
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefc1b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefc1b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6YNlE", function(module, exports) {
module.exports = "<svg height=\"24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.843 2.7C19.063 2.7 23 6.366 23 11.228c0 3.754-2.862 6.584-6.658 6.584-3.287 0-5.007-2.318-5.007-4.609 0-2.395 1.923-4.344 4.287-4.344.566 0 1.023.12 1.309.223a.212.212 0 0 1 .137.229l-.016.058-.514 1.18a.223.223 0 0 1-.245.13 2.965 2.965 0 0 0-.506-.046c-1.245 0-2.258 1.027-2.258 2.288 0 1.33 1.165 2.373 2.651 2.373 2.195 0 3.913-1.777 3.913-4.046 0-3.024-2.294-5.135-5.58-5.135-4.076 0-7.393 3.36-7.393 7.491a7.519 7.519 0 0 0 2.871 5.924l-4.96 3.18A12.042 12.042 0 0 1 2 14.7c0-6.617 5.313-12 11.843-12z\" fill-rule=\"evenodd\"/></svg>";

});

parcelRegister("9wlV6", function(module, exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-arrow-down-circle\"><circle cx=\"12\" cy=\"12\" r=\"10\"/><path d=\"m8 12 4 4 4-4M12 8v8\"/></svg>";

});

parcelRegister("4Q7KU", function(module, exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-arrow-down-left\"><path d=\"M17 7 7 17M17 17H7V7\"/></svg>";

});

parcelRegister("iUsTz", function(module, exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-arrow-down-right\"><path d=\"m7 7 10 10M17 7v10H7\"/></svg>";

});

parcelRegister("kfWEV", function(module, exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-arrow-down\"><path d=\"M12 5v14M19 12l-7 7-7-7\"/></svg>";

});

parcelRegister("hpAtq", function(module, exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-arrow-left-circle\"><circle cx=\"12\" cy=\"12\" r=\"10\"/><path d=\"m12 8-4 4 4 4M16 12H8\"/></svg>";

});

parcelRegister("flW3m", function(module, exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-arrow-left\"><path d=\"M19 12H5M12 19l-7-7 7-7\"/></svg>";

});

parcelRegister("fUjto", function(module, exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-arrow-right\"><path d=\"M5 12h14M12 5l7 7-7 7\"/></svg>";

});

parcelRegister("JWxI4", function(module, exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-arrow-right-circle\"><circle cx=\"12\" cy=\"12\" r=\"10\"/><path d=\"m12 16 4-4-4-4M8 12h8\"/></svg>";

});

parcelRegister("dHcR4", function(module, exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-arrow-up-circle\"><circle cx=\"12\" cy=\"12\" r=\"10\"/><path d=\"m16 12-4-4-4 4M12 16V8\"/></svg>";

});

parcelRegister("hF4Sv", function(module, exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-arrow-up-left\"><path d=\"M17 17 7 7M7 17V7h10\"/></svg>";

});

parcelRegister("5QY7o", function(module, exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-arrow-up-right\"><path d=\"M7 17 17 7M7 7h10v10\"/></svg>";

});

parcelRegister("6byik", function(module, exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-arrow-up\"><path d=\"M12 19V5M5 12l7-7 7 7\"/></svg>";

});

parcelRegister("8ePs4", function(module, exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-check-circle\"><path d=\"M22 11.08V12a10 10 0 1 1-5.93-9.14\"/><path d=\"M22 4 12 14.01l-3-3\"/></svg>";

});

parcelRegister("cGfez", function(module, exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-check\"><path d=\"M20 6 9 17l-5-5\"/></svg>";

});

parcelRegister("2Ul1b", function(module, exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-chevron-down\"><path d=\"m6 9 6 6 6-6\"/></svg>";

});

parcelRegister("gwP6O", function(module, exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-chevron-left\"><path d=\"m15 18-6-6 6-6\"/></svg>";

});

parcelRegister("8eE1Q", function(module, exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-chevron-right\"><path d=\"m9 18 6-6-6-6\"/></svg>";

});

parcelRegister("c7jAY", function(module, exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-chevron-up\"><path d=\"m18 15-6-6-6 6\"/></svg>";

});

parcelRegister("9jlg3", function(module, exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-copy\"><rect x=\"9\" y=\"9\" width=\"13\" height=\"13\" rx=\"2\" ry=\"2\"/><path d=\"M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1\"/></svg>";

});

parcelRegister("eYX6R", function(module, exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-eye-off\"><path d=\"M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24M1 1l22 22\"/></svg>";

});

parcelRegister("bd5y4", function(module, exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-eye\"><path d=\"M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z\"/><circle cx=\"12\" cy=\"12\" r=\"3\"/></svg>";

});

parcelRegister("gg799", function(module, exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-info\"><circle cx=\"12\" cy=\"12\" r=\"10\"/><path d=\"M12 16v-4M12 8h.01\"/></svg>";

});

parcelRegister("5bM1A", function(module, exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-minus\"><path d=\"M5 12h14\"/></svg>";

});

parcelRegister("acnwK", function(module, exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-sun\"><circle cx=\"12\" cy=\"12\" r=\"5\"/><path d=\"M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42\"/></svg>";

});

parcelRegister("2Rz49", function(module, exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-moon\"><path d=\"M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z\"/></svg>";

});

parcelRegister("jgr4j", function(module, exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-more-horizontal\"><circle cx=\"12\" cy=\"12\" r=\"1\"/><circle cx=\"19\" cy=\"12\" r=\"1\"/><circle cx=\"5\" cy=\"12\" r=\"1\"/></svg>";

});

parcelRegister("fi6wH", function(module, exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-more-vertical\"><circle cx=\"12\" cy=\"12\" r=\"1\"/><circle cx=\"12\" cy=\"5\" r=\"1\"/><circle cx=\"12\" cy=\"19\" r=\"1\"/></svg>";

});

parcelRegister("i1d6Y", function(module, exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-send\"><path d=\"M22 2 11 13M22 2l-7 20-4-9-9-4 20-7z\"/></svg>";

});

parcelRegister("XMQx2", function(module, exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-smile\"><circle cx=\"12\" cy=\"12\" r=\"10\"/><path d=\"M8 14s1.5 2 4 2 4-2 4-2M9 9h.01M15 9h.01\"/></svg>";

});

parcelRegister("rdEtP", function(module, exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-search\"><circle cx=\"11\" cy=\"11\" r=\"8\"/><path d=\"m21 21-4.35-4.35\"/></svg>";

});

parcelRegister("dKKdP", function(module, exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-upload\"><path d=\"M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12\"/></svg>";

});

parcelRegister("hrriy", function(module, exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-video\"><path d=\"m23 7-7 5 7 5V7z\"/><rect x=\"1\" y=\"5\" width=\"15\" height=\"14\" rx=\"2\" ry=\"2\"/></svg>";

});

parcelRegister("9gXuv", function(module, exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-x\"><path d=\"M18 6 6 18M6 6l12 12\"/></svg>";

});

parcelRegister("8lEKy", function(module, exports) {
module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-plus\"><path d=\"M12 5v14M5 12h14\"/></svg>";

});

parcelRegister("cVSYW", function(module, exports) {

$parcel$export(module.exports, "connect", () => connect);
$parcel$export(module.exports, "send", () => send);

var $cBUNY = parcelRequire("cBUNY");

var $aOJ2H = parcelRequire("aOJ2H");

var $73MNt = parcelRequire("73MNt");
"use strict";
const { isFunction, isArray } = $cBUNY.default || $cBUNY;
const { window } = $aOJ2H.default || $aOJ2H;
const ENV = "production";
const defautlOpts = {};
let CONNECT_ATTEPT = 0;
const CONNECT_ATTEPT_MAX_ALLOWED = 1;
const connect = (key, options = {})=>{
    const isDev = options.development || window && window.location && window.location.host.includes("local") || ENV === "test" || ENV === "development";
    const SOCKET_BACKEND_URL = isDev ? "http://localhost:13336/" : "https://socket.symbols.app/";
    const socketUrls = isArray(options.socketUrl) ? options.socketUrl : [
        options.socketUrl || SOCKET_BACKEND_URL
    ];
    const primaryUrl = socketUrls[0];
    const secondaryUrl = socketUrls[1] || "socket.symbols.app";
    const socket = (0, $73MNt.default)(primaryUrl || SOCKET_BACKEND_URL, {
    });
    socket.on("connect", ()=>{
        if (isDev) console.log(`Connected to %c${primaryUrl || SOCKET_BACKEND_URL} %c${key} %c${socket.id}`, "font-weight: bold; color: green;", "font-weight: bold;", "");
        socket.emit("initConnect", {
            key: key,
            ...options
        });
        try {
            if (isFunction(options.onConnect)) options.onConnect(socket.id, socket);
        } catch (e) {
            console.error(e);
        }
    });
    socket.on("connect_error", (err)=>{
        console.log(`event: connect_error | reason: ${err.message}`);
        try {
            if (isFunction(options.onError)) options.onError(err, socket);
            if (CONNECT_ATTEPT < CONNECT_ATTEPT_MAX_ALLOWED) {
                CONNECT_ATTEPT++;
                socket.disconnect();
                if (ENV === "test" || ENV === "development") console.log("Could not connect to %c" + primaryUrl + "%c, reconnecting to %c" + secondaryUrl, "font-weight: bold; color: red;", "", "font-weight: bold; color: green;");
                connect(key, {
                    ...options,
                    socketUrl: secondaryUrl
                });
            }
        } catch (e) {
            console.error(e);
        }
    });
    socket.on("disconnect", (reason)=>{
        console.log(`event: disconnect | reason: ${reason}`);
        try {
            if (isFunction(options.onDisconnect)) options.onDisconnect(reason, socket);
        } catch (e) {
            console.error(e);
        }
    });
    socket.onAny((event, ...args)=>{
        if (event === "connect") return;
        try {
            if (isFunction(options.onChange)) options.onChange(event, args[0], socket);
        } catch (e) {
            console.error(e);
        }
    });
    return socket;
};
function send(event = "change", changes, options) {
    this.emit(event, changes, {
        ...options,
        ...defautlOpts
    });
}
function disconnect() {
    this.disconnect();
}

});
parcelRegister("cBUNY", function(module, exports) {

var $NWrSd = parcelRequire("NWrSd");

var $jOLBF = parcelRequire("jOLBF");

var $EqHTq = parcelRequire("EqHTq");

var $8wu6n = parcelRequire("8wu6n");

var $fMhOg = parcelRequire("fMhOg");

var $hSU9O = parcelRequire("hSU9O");

var $cPMIO = parcelRequire("cPMIO");

var $cQ6eY = parcelRequire("cQ6eY");

var $5WrxC = parcelRequire("5WrxC");

var $jvD5p = parcelRequire("jvD5p");

var $57Gb5 = parcelRequire("57Gb5");

var $glQML = parcelRequire("glQML");
"use strict";
$parcel$exportWildcard(module.exports, $NWrSd);
$parcel$exportWildcard(module.exports, $jOLBF);
$parcel$exportWildcard(module.exports, $EqHTq);
$parcel$exportWildcard(module.exports, $8wu6n);
$parcel$exportWildcard(module.exports, $fMhOg);
$parcel$exportWildcard(module.exports, $hSU9O);
$parcel$exportWildcard(module.exports, $cPMIO);
$parcel$exportWildcard(module.exports, $cQ6eY);
$parcel$exportWildcard(module.exports, $5WrxC);
$parcel$exportWildcard(module.exports, $jvD5p);
$parcel$exportWildcard(module.exports, $57Gb5);
$parcel$exportWildcard(module.exports, $glQML);

});
parcelRegister("NWrSd", function(module, exports) {

$parcel$export(module.exports, "generateKey", () => $0961ea6318004278$export$3a7728e868aa3ebd);
$parcel$export(module.exports, "createSnapshotId", () => $0961ea6318004278$export$6f8fb29fbb5b5b63);
"use strict";
const $0961ea6318004278$export$3a7728e868aa3ebd = function() {
    let index = 0;
    function newId() {
        index++;
        return index;
    }
    return newId;
}();
const $0961ea6318004278$export$6f8fb29fbb5b5b63 = $0961ea6318004278$export$3a7728e868aa3ebd;

});

parcelRegister("jOLBF", function(module, exports) {

$parcel$export(module.exports, "NODE_ENV", () => $e6d79d7b0d7b5fe1$export$dd8826725fa2a3d4);
$parcel$export(module.exports, "isProduction", () => $e6d79d7b0d7b5fe1$export$f15d00aa73aafac4);
$parcel$export(module.exports, "isTest", () => $e6d79d7b0d7b5fe1$export$410cbc2864fa25b5);
$parcel$export(module.exports, "isDevelopment", () => $e6d79d7b0d7b5fe1$export$df77466336fe5355);
$parcel$export(module.exports, "getNev", () => $e6d79d7b0d7b5fe1$export$d84272657cb7c466);
"use strict";
const $e6d79d7b0d7b5fe1$export$dd8826725fa2a3d4 = "production";
const $e6d79d7b0d7b5fe1$export$f15d00aa73aafac4 = (env = $e6d79d7b0d7b5fe1$export$dd8826725fa2a3d4)=>env === "production" || env === "prod" || env !== "development" && env !== "dev" && env !== "test";
const $e6d79d7b0d7b5fe1$export$410cbc2864fa25b5 = (env = $e6d79d7b0d7b5fe1$export$dd8826725fa2a3d4)=>env === "test";
const $e6d79d7b0d7b5fe1$export$df77466336fe5355 = (env = $e6d79d7b0d7b5fe1$export$dd8826725fa2a3d4)=>env === "development" || env === "dev";
const $e6d79d7b0d7b5fe1$export$d84272657cb7c466 = (key, env = $e6d79d7b0d7b5fe1$export$dd8826725fa2a3d4)=>env[key];

});

parcelRegister("EqHTq", function(module, exports) {

$parcel$export(module.exports, "isObject", () => $079873fc3f2b5f81$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isString", () => $079873fc3f2b5f81$export$844ec244b1367d54);
$parcel$export(module.exports, "isNumber", () => $079873fc3f2b5f81$export$7e4aa119212bc614);
$parcel$export(module.exports, "isFunction", () => $079873fc3f2b5f81$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isBoolean", () => $079873fc3f2b5f81$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "isNull", () => $079873fc3f2b5f81$export$630801d484da15df);
$parcel$export(module.exports, "isArray", () => $079873fc3f2b5f81$export$43bee75e5e14138e);
$parcel$export(module.exports, "isDate", () => $079873fc3f2b5f81$export$871608497c498473);
$parcel$export(module.exports, "isObjectLike", () => $079873fc3f2b5f81$export$c10d0b04eaa80a43);
$parcel$export(module.exports, "isDefined", () => $079873fc3f2b5f81$export$4e62c701997796c1);
$parcel$export(module.exports, "isUndefined", () => $079873fc3f2b5f81$export$fce6876652108ab);
$parcel$export(module.exports, "TYPES", () => $079873fc3f2b5f81$export$426db7a6155b7a80);
$parcel$export(module.exports, "is", () => $079873fc3f2b5f81$export$226b3eccf92c9ed9);
$parcel$export(module.exports, "isNot", () => $079873fc3f2b5f81$export$612ae635ef713eeb);

var $cPMIO = parcelRequire("cPMIO");
"use strict";
const $079873fc3f2b5f81$export$a6cdc56e425d0d0a = (arg)=>{
    if (arg === null) return false;
    return typeof arg === "object" && arg.constructor === Object;
};
const $079873fc3f2b5f81$export$844ec244b1367d54 = (arg)=>typeof arg === "string";
const $079873fc3f2b5f81$export$7e4aa119212bc614 = (arg)=>typeof arg === "number";
const $079873fc3f2b5f81$export$f6e2535fb5126e54 = (arg)=>typeof arg === "function";
const $079873fc3f2b5f81$export$f9ce7b637dfbe238 = (arg)=>arg === true || arg === false;
const $079873fc3f2b5f81$export$630801d484da15df = (arg)=>arg === null;
const $079873fc3f2b5f81$export$43bee75e5e14138e = (arg)=>Array.isArray(arg);
const $079873fc3f2b5f81$export$871608497c498473 = (d)=>d instanceof Date;
const $079873fc3f2b5f81$export$c10d0b04eaa80a43 = (arg)=>{
    if (arg === null) return false;
    // if (isArray(arg)) return false
    return typeof arg === "object";
};
const $079873fc3f2b5f81$export$4e62c701997796c1 = (arg)=>{
    return $079873fc3f2b5f81$export$a6cdc56e425d0d0a(arg) || $079873fc3f2b5f81$export$c10d0b04eaa80a43(arg) || $079873fc3f2b5f81$export$844ec244b1367d54(arg) || $079873fc3f2b5f81$export$7e4aa119212bc614(arg) || $079873fc3f2b5f81$export$f6e2535fb5126e54(arg) || $079873fc3f2b5f81$export$43bee75e5e14138e(arg) || $079873fc3f2b5f81$export$c10d0b04eaa80a43(arg) || $079873fc3f2b5f81$export$f9ce7b637dfbe238(arg) || $079873fc3f2b5f81$export$871608497c498473(arg) || $079873fc3f2b5f81$export$630801d484da15df(arg);
};
const $079873fc3f2b5f81$export$fce6876652108ab = (arg)=>{
    return arg === undefined;
};
const $079873fc3f2b5f81$export$426db7a6155b7a80 = {
    boolean: $079873fc3f2b5f81$export$f9ce7b637dfbe238,
    array: $079873fc3f2b5f81$export$43bee75e5e14138e,
    object: $079873fc3f2b5f81$export$a6cdc56e425d0d0a,
    string: $079873fc3f2b5f81$export$844ec244b1367d54,
    date: $079873fc3f2b5f81$export$871608497c498473,
    number: $079873fc3f2b5f81$export$7e4aa119212bc614,
    null: $079873fc3f2b5f81$export$630801d484da15df,
    function: $079873fc3f2b5f81$export$f6e2535fb5126e54,
    objectLike: $079873fc3f2b5f81$export$c10d0b04eaa80a43,
    node: (0, $cPMIO.isNode),
    htmlElement: (0, $cPMIO.isHtmlElement),
    defined: $079873fc3f2b5f81$export$4e62c701997796c1
};
const $079873fc3f2b5f81$export$226b3eccf92c9ed9 = (arg)=>{
    return (...args)=>{
        return args.map((val)=>$079873fc3f2b5f81$export$426db7a6155b7a80[val](arg)).filter((v)=>v).length > 0;
    };
};
const $079873fc3f2b5f81$export$612ae635ef713eeb = (arg)=>{
    return (...args)=>{
        return args.map((val)=>$079873fc3f2b5f81$export$426db7a6155b7a80[val](arg)).filter((v)=>v).length === 0;
    };
};

});
parcelRegister("cPMIO", function(module, exports) {

$parcel$export(module.exports, "isNode", () => $95800a96be489797$export$8ee0fc9ee280b4ee);
$parcel$export(module.exports, "isHtmlElement", () => $95800a96be489797$export$211442cb55fb93);

var $jvD5p = parcelRequire("jvD5p");
"use strict";
const $95800a96be489797$export$8ee0fc9ee280b4ee = (obj)=>{
    return (typeof Node === "object" ? obj instanceof (0, $jvD5p.window).Node : obj && typeof obj === "object" && typeof obj.nodeType === "number" && typeof obj.nodeName === "string") || false;
};
const $95800a96be489797$export$211442cb55fb93 = (obj)=>{
    return (typeof HTMLElement === "object" ? obj instanceof (0, $jvD5p.window).HTMLElement // DOM2
     : obj && typeof obj === "object" && obj !== null && obj.nodeType === 1 && typeof obj.nodeName === "string") || false;
};

});
parcelRegister("jvD5p", function(module, exports) {

$parcel$export(module.exports, "global", () => $e33f3b456b841cc9$export$90b4d2ff6acb88af);
$parcel$export(module.exports, "self", () => $e33f3b456b841cc9$export$82c2e460fb230c2a);
$parcel$export(module.exports, "window", () => $e33f3b456b841cc9$export$8291e5b88f90ce4);
$parcel$export(module.exports, "document", () => $e33f3b456b841cc9$export$5a7bfc01df82fcd1);
"use strict";
const $e33f3b456b841cc9$export$90b4d2ff6acb88af = globalThis;
const $e33f3b456b841cc9$export$82c2e460fb230c2a = globalThis;
const $e33f3b456b841cc9$export$8291e5b88f90ce4 = globalThis;
const $e33f3b456b841cc9$export$5a7bfc01df82fcd1 = $e33f3b456b841cc9$export$8291e5b88f90ce4.document // eslint-disable-line
;

});



parcelRegister("8wu6n", function(module, exports) {

$parcel$export(module.exports, "exec", () => $6348a97baa20d8d9$export$78e3044358792147);
$parcel$export(module.exports, "map", () => $6348a97baa20d8d9$export$871de8747c9eaa88);
$parcel$export(module.exports, "merge", () => $6348a97baa20d8d9$export$4950aa0f605343fb);
$parcel$export(module.exports, "deepMerge", () => $6348a97baa20d8d9$export$6969335ea1e4e77c);
$parcel$export(module.exports, "clone", () => $6348a97baa20d8d9$export$9cd59f9826255e47);
$parcel$export(module.exports, "deepCloneExclude", () => $6348a97baa20d8d9$export$99e9e507e655127d);
$parcel$export(module.exports, "mergeArrayExclude", () => $6348a97baa20d8d9$export$1c8d6f44648a0c27);
$parcel$export(module.exports, "deepClone", () => $6348a97baa20d8d9$export$b7d58db314e0ac27);
$parcel$export(module.exports, "deepCloneWithExtnd", () => $6348a97baa20d8d9$export$e249d5701977b61b);
$parcel$export(module.exports, "deepStringify", () => $6348a97baa20d8d9$export$7885cbf849c4488d);
$parcel$export(module.exports, "objectToString", () => $6348a97baa20d8d9$export$830c053460e5ddf6);
$parcel$export(module.exports, "detachFunctionsFromObject", () => $6348a97baa20d8d9$export$43ffbb9d42fee1c4);
$parcel$export(module.exports, "deepDestringify", () => $6348a97baa20d8d9$export$87659e1dc59ed8a3);
$parcel$export(module.exports, "stringToObject", () => $6348a97baa20d8d9$export$a6c9a3ccba61521e);
$parcel$export(module.exports, "diffObjects", () => $6348a97baa20d8d9$export$fcd7b39b3d1c2c1);
$parcel$export(module.exports, "diff", () => $6348a97baa20d8d9$export$a37e3c603d7117e5);
$parcel$export(module.exports, "diffArrays", () => $6348a97baa20d8d9$export$f1c08b3bfc8443c4);
$parcel$export(module.exports, "hasOwnProperty", () => $6348a97baa20d8d9$export$5a15a386532a5ea4);
$parcel$export(module.exports, "isEmpty", () => $6348a97baa20d8d9$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "isEmptyObject", () => $6348a97baa20d8d9$export$83b788b1a3698c03);
$parcel$export(module.exports, "makeObjectWithoutPrototype", () => $6348a97baa20d8d9$export$d6d64087a1bd2d);
$parcel$export(module.exports, "deepDiff", () => $6348a97baa20d8d9$export$f00d38dfe38936c3);
$parcel$export(module.exports, "overwrite", () => $6348a97baa20d8d9$export$d3305692eb3e9a81);
$parcel$export(module.exports, "overwriteShallow", () => $6348a97baa20d8d9$export$1c07155dfdd98f41);
$parcel$export(module.exports, "overwriteDeep", () => $6348a97baa20d8d9$export$f0b277b530b4fffd);
$parcel$export(module.exports, "mergeIfExisted", () => $6348a97baa20d8d9$export$7bde6dffa6d2dd59);
$parcel$export(module.exports, "flattenRecursive", () => $6348a97baa20d8d9$export$d53c2c5b09d0676f);
$parcel$export(module.exports, "isEqualDeep", () => $6348a97baa20d8d9$export$683c7d6569f339f4);
$parcel$export(module.exports, "deepContains", () => $6348a97baa20d8d9$export$273cb3019e2f952c);
$parcel$export(module.exports, "removeFromObject", () => $6348a97baa20d8d9$export$bdd7fc6cf95d63b);

var $jvD5p = parcelRequire("jvD5p");

var $EqHTq = parcelRequire("EqHTq");

var $hSU9O = parcelRequire("hSU9O");

var $5WrxC = parcelRequire("5WrxC");
"use strict";
const $6348a97baa20d8d9$export$78e3044358792147 = (param, element, state, context)=>{
    if ((0, $EqHTq.isFunction)(param)) return param(element, state || element.state, context || element.context);
    return param;
};
const $6348a97baa20d8d9$export$871de8747c9eaa88 = (obj, extention, element)=>{
    for(const e in extention)obj[e] = $6348a97baa20d8d9$export$78e3044358792147(extention[e], element);
};
const $6348a97baa20d8d9$export$4950aa0f605343fb = (element, obj, excludeFrom = [])=>{
    for(const e in obj){
        const hasOwnProperty = Object.prototype.hasOwnProperty.call(obj, e);
        if (!hasOwnProperty || excludeFrom.includes(e) || e.startsWith("__")) continue;
        const elementProp = element[e];
        const objProp = obj[e];
        if (elementProp === undefined) element[e] = objProp;
    }
    return element;
};
const $6348a97baa20d8d9$export$6969335ea1e4e77c = (element, extend, excludeFrom = [])=>{
    for(const e in extend){
        const hasOwnProperty = Object.prototype.hasOwnProperty.call(extend, e);
        if (!hasOwnProperty || excludeFrom.includes(e) || e.startsWith("__")) continue;
        const elementProp = element[e];
        const extendProp = extend[e];
        if ((0, $EqHTq.isObjectLike)(elementProp) && (0, $EqHTq.isObjectLike)(extendProp)) $6348a97baa20d8d9$export$6969335ea1e4e77c(elementProp, extendProp, excludeFrom);
        else if (elementProp === undefined) element[e] = extendProp;
    }
    return element;
};
const $6348a97baa20d8d9$export$9cd59f9826255e47 = (obj, excludeFrom = [])=>{
    const o = {};
    for(const prop in obj){
        const hasOwnProperty = Object.prototype.hasOwnProperty.call(obj, prop);
        if (!hasOwnProperty || excludeFrom.includes(prop) || prop.startsWith("__")) continue;
        o[prop] = obj[prop];
    }
    return o;
};
const $6348a97baa20d8d9$export$99e9e507e655127d = (obj, excludeFrom = [])=>{
    if ((0, $EqHTq.isArray)(obj)) return obj.map((x)=>$6348a97baa20d8d9$export$99e9e507e655127d(x, excludeFrom));
    const o = {};
    for(const k in obj){
        const hasOwnProperty = Object.prototype.hasOwnProperty.call(obj, k);
        if (!hasOwnProperty || excludeFrom.includes(k) || k.startsWith("__")) continue;
        let v = obj[k];
        if (k === "extend" && (0, $EqHTq.isArray)(v)) v = $6348a97baa20d8d9$export$1c8d6f44648a0c27(v, excludeFrom);
        if ((0, $EqHTq.isArray)(v)) o[k] = v.map((x)=>$6348a97baa20d8d9$export$99e9e507e655127d(x, excludeFrom));
        else if ((0, $EqHTq.isObject)(v)) o[k] = $6348a97baa20d8d9$export$99e9e507e655127d(v, excludeFrom);
        else o[k] = v;
    }
    return o;
};
const $6348a97baa20d8d9$export$1c8d6f44648a0c27 = (arr, excl = [])=>{
    return arr.reduce((acc, curr)=>$6348a97baa20d8d9$export$6969335ea1e4e77c(acc, $6348a97baa20d8d9$export$99e9e507e655127d(curr, excl)), {});
};
const $6348a97baa20d8d9$export$b7d58db314e0ac27 = (obj, excludeFrom = [], cleanUndefined = false)=>{
    const o = (0, $EqHTq.isArray)(obj) ? [] : {};
    for(const prop in obj){
        if (prop === "__proto__") continue;
        if (excludeFrom.includes(prop) || prop.startsWith("__")) continue;
        let objProp = obj[prop];
        if (cleanUndefined && (0, $EqHTq.isUndefined)(objProp)) continue;
        if (prop === "extend" && (0, $EqHTq.isArray)(objProp)) objProp = (0, $hSU9O.mergeArray)(objProp);
        if ((0, $EqHTq.isObjectLike)(objProp)) o[prop] = $6348a97baa20d8d9$export$b7d58db314e0ac27(objProp, excludeFrom, cleanUndefined);
        else o[prop] = objProp;
    }
    return o;
};
const $6348a97baa20d8d9$export$e249d5701977b61b = (obj, excludeFrom = [], cleanUndefined = false)=>{
    const o = (0, $EqHTq.isArray)(obj) ? [] : {};
    for(const prop in obj){
        if (prop === "__proto__") continue;
        if (excludeFrom.includes(prop) || prop.startsWith("__")) continue;
        const objProp = obj[prop];
        if (cleanUndefined && (0, $EqHTq.isUndefined)(objProp)) continue;
        if ((0, $EqHTq.isObjectLike)(objProp)) o[prop] = $6348a97baa20d8d9$export$e249d5701977b61b(objProp, excludeFrom, cleanUndefined);
        else o[prop] = objProp;
    }
    return o;
};
const $6348a97baa20d8d9$export$7885cbf849c4488d = (obj, stringified = {})=>{
    for(const prop in obj){
        const objProp = obj[prop];
        if ((0, $EqHTq.isFunction)(objProp)) stringified[prop] = objProp.toString();
        else if ((0, $EqHTq.isObject)(objProp)) {
            stringified[prop] = {};
            $6348a97baa20d8d9$export$7885cbf849c4488d(objProp, stringified[prop]);
        } else if ((0, $EqHTq.isArray)(objProp)) {
            stringified[prop] = [];
            objProp.forEach((v, i)=>{
                if ((0, $EqHTq.isObject)(v)) {
                    stringified[prop][i] = {};
                    $6348a97baa20d8d9$export$7885cbf849c4488d(v, stringified[prop][i]);
                } else if ((0, $EqHTq.isFunction)(v)) stringified[prop][i] = v.toString();
                else stringified[prop][i] = v;
            });
        } else stringified[prop] = objProp;
    }
    return stringified;
};
const $6348a97baa20d8d9$export$830c053460e5ddf6 = (obj, indent = 0)=>{
    const spaces = "  ".repeat(indent);
    let str = "{\n";
    for (const [key, value] of Object.entries(obj)){
        const keyNotAllowdChars = (0, $5WrxC.stringIncludesAny)(key, [
            "&",
            "*",
            "-",
            ":",
            "%",
            "{",
            "}",
            ">",
            "<",
            "@",
            ".",
            "/",
            "!",
            " "
        ]);
        const stringedKey = keyNotAllowdChars ? `'${key}'` : key;
        str += `${spaces}  ${stringedKey}: `;
        if ((0, $EqHTq.isArray)(value)) {
            str += "[\n";
            for (const element of value){
                if ((0, $EqHTq.isObject)(element) && element !== null) str += `${spaces}    ${$6348a97baa20d8d9$export$830c053460e5ddf6(element, indent + 2)},\n`;
                else if ((0, $EqHTq.isString)(element)) str += `${spaces}    '${element}',\n`;
                else str += `${spaces}    ${element},\n`;
            }
            str += `${spaces}  ]`;
        } else if ((0, $EqHTq.isObjectLike)(value)) str += $6348a97baa20d8d9$export$830c053460e5ddf6(value, indent + 1);
        else if ((0, $EqHTq.isString)(value)) str += (0, $5WrxC.stringIncludesAny)(value, [
            "\n",
            "'"
        ]) ? `\`${value}\`` : `'${value}'`;
        else str += value;
        str += ",\n";
    }
    str += `${spaces}}`;
    return str;
};
const $6348a97baa20d8d9$export$43ffbb9d42fee1c4 = (obj, detached = {})=>{
    for(const prop in obj){
        const objProp = obj[prop];
        if ((0, $EqHTq.isFunction)(objProp)) continue;
        else if ((0, $EqHTq.isObject)(objProp)) {
            detached[prop] = {};
            $6348a97baa20d8d9$export$7885cbf849c4488d(objProp, detached[prop]);
        } else if ((0, $EqHTq.isArray)(objProp)) {
            detached[prop] = [];
            objProp.forEach((v, i)=>{
                if ((0, $EqHTq.isFunction)(v)) return;
                if ((0, $EqHTq.isObject)(v)) {
                    detached[prop][i] = {};
                    $6348a97baa20d8d9$export$43ffbb9d42fee1c4(v, detached[prop][i]);
                } else detached[prop][i] = v;
            });
        } else detached[prop] = objProp;
    }
    return detached;
};
const $6348a97baa20d8d9$export$87659e1dc59ed8a3 = (obj, destringified = {})=>{
    for(const prop in obj){
        const hasOwnProperty = Object.prototype.hasOwnProperty.call(obj, prop);
        if (!hasOwnProperty) continue;
        const objProp = obj[prop];
        if ((0, $EqHTq.isString)(objProp)) {
            if (objProp.includes("=>") || objProp.includes("function") || objProp.startsWith("(")) try {
                const evalProp = (0, $jvD5p.window).eval(`(${objProp})`) // use parentheses to convert string to function expression
                ;
                destringified[prop] = evalProp;
            } catch (e) {
                if (e) destringified[prop] = objProp;
            }
            else destringified[prop] = objProp;
        } else if ((0, $EqHTq.isArray)(objProp)) {
            destringified[prop] = [];
            objProp.forEach((arrProp)=>{
                if ((0, $EqHTq.isString)(arrProp)) {
                    if (arrProp.includes("=>") || arrProp.includes("function") || arrProp.startsWith("(")) try {
                        const evalProp = (0, $jvD5p.window).eval(`(${arrProp})`) // use parentheses to convert string to function expression
                        ;
                        destringified[prop].push(evalProp);
                    } catch (e) {
                        if (e) destringified[prop].push(arrProp);
                    }
                    else destringified[prop].push(arrProp);
                } else if ((0, $EqHTq.isObject)(arrProp)) destringified[prop].push($6348a97baa20d8d9$export$87659e1dc59ed8a3(arrProp));
                else destringified[prop].push(arrProp);
            });
        } else if ((0, $EqHTq.isObject)(objProp)) destringified[prop] = $6348a97baa20d8d9$export$87659e1dc59ed8a3(objProp, destringified[prop]) // recursively call deepDestringify for nested objects
        ;
        else destringified[prop] = objProp;
    }
    return destringified;
};
const $6348a97baa20d8d9$export$a6c9a3ccba61521e = (str, verbose)=>{
    try {
        return (0, $jvD5p.window).eval("(" + str + ")") // eslint-disable-line
        ;
    } catch (e) {
        if (verbose) console.warn(e);
    }
};
const $6348a97baa20d8d9$export$fcd7b39b3d1c2c1 = (original, objToDiff, cache)=>{
    for(const e in objToDiff){
        if (e === "ref") continue;
        const originalProp = original[e];
        const objToDiffProp = objToDiff[e];
        if ((0, $EqHTq.isObject)(originalProp) && (0, $EqHTq.isObject)(objToDiffProp)) {
            cache[e] = {};
            $6348a97baa20d8d9$export$a37e3c603d7117e5(originalProp, objToDiffProp, cache[e]);
        } else if (objToDiffProp !== undefined) cache[e] = objToDiffProp;
    }
    return cache;
};
const $6348a97baa20d8d9$export$f1c08b3bfc8443c4 = (original, objToDiff, cache)=>{
    if (original.length !== objToDiff.length) cache = objToDiff;
    else {
        const diffArr = [];
        for(let i = 0; i < original.length; i++){
            const diffObj = $6348a97baa20d8d9$export$a37e3c603d7117e5(original[i], objToDiff[i]);
            if (Object.keys(diffObj).length > 0) diffArr.push(diffObj);
        }
        if (diffArr.length > 0) cache = diffArr;
    }
    return cache;
};
const $6348a97baa20d8d9$export$a37e3c603d7117e5 = (original, objToDiff, cache = {})=>{
    if ((0, $EqHTq.isArray)(original) && (0, $EqHTq.isArray)(objToDiff)) {
        cache = [];
        $6348a97baa20d8d9$export$f1c08b3bfc8443c4(original, objToDiff, cache);
    } else $6348a97baa20d8d9$export$fcd7b39b3d1c2c1(original, objToDiff, cache);
    return cache;
};
const $6348a97baa20d8d9$export$5a15a386532a5ea4 = (o, ...args)=>Object.prototype.hasOwnProperty.call(o, ...args);
const $6348a97baa20d8d9$export$dd1bc94b04021eeb = (o)=>Object.keys(o).length === 0;
const $6348a97baa20d8d9$export$83b788b1a3698c03 = (o)=>(0, $EqHTq.isObject)(o) && $6348a97baa20d8d9$export$dd1bc94b04021eeb(o);
const $6348a97baa20d8d9$export$d6d64087a1bd2d = ()=>Object.create(null);
const $6348a97baa20d8d9$export$f00d38dfe38936c3 = (lhs, rhs)=>{
    if (lhs === rhs) return {};
    if (!(0, $EqHTq.isObjectLike)(lhs) || !(0, $EqHTq.isObjectLike)(rhs)) return rhs;
    const deletedValues = Object.keys(lhs).reduce((acc, key)=>{
        if (!$6348a97baa20d8d9$export$5a15a386532a5ea4(rhs, key)) acc[key] = undefined;
        return acc;
    }, $6348a97baa20d8d9$export$d6d64087a1bd2d());
    if ((0, $EqHTq.isDate)(lhs) || (0, $EqHTq.isDate)(rhs)) {
        if (lhs.valueOf() === rhs.valueOf()) return {};
        return rhs;
    }
    return Object.keys(rhs).reduce((acc, key)=>{
        if (!$6348a97baa20d8d9$export$5a15a386532a5ea4(lhs, key)) {
            acc[key] = rhs[key];
            return acc;
        }
        const difference = $6348a97baa20d8d9$export$a37e3c603d7117e5(lhs[key], rhs[key]);
        if ($6348a97baa20d8d9$export$83b788b1a3698c03(difference) && !(0, $EqHTq.isDate)(difference) && ($6348a97baa20d8d9$export$83b788b1a3698c03(lhs[key]) || !$6348a97baa20d8d9$export$83b788b1a3698c03(rhs[key]))) return acc;
        acc[key] = difference;
        return acc;
    }, deletedValues);
};
const $6348a97baa20d8d9$export$d3305692eb3e9a81 = (element, params, excludeFrom = [])=>{
    const { ref: ref } = element;
    const changes = {};
    for(const e in params){
        if (excludeFrom.includes(e) || e.startsWith("__")) continue;
        const elementProp = element[e];
        const paramsProp = params[e];
        if (paramsProp) {
            ref.__cache[e] = changes[e] = elementProp;
            ref[e] = paramsProp;
        }
    }
    return changes;
};
const $6348a97baa20d8d9$export$1c07155dfdd98f41 = (obj, params, excludeFrom = [])=>{
    for(const e in params){
        if (excludeFrom.includes(e) || e.startsWith("__")) continue;
        obj[e] = params[e];
    }
    return obj;
};
const $6348a97baa20d8d9$export$f0b277b530b4fffd = (obj, params, excludeFrom = [])=>{
    for(const e in params){
        if (e === "__proto__") continue;
        if (excludeFrom.includes(e) || e.startsWith("__")) continue;
        const objProp = obj[e];
        const paramsProp = params[e];
        if ((0, $EqHTq.isObjectLike)(objProp) && (0, $EqHTq.isObjectLike)(paramsProp)) $6348a97baa20d8d9$export$f0b277b530b4fffd(objProp, paramsProp);
        else if (paramsProp !== undefined) obj[e] = paramsProp;
    }
    return obj;
};
const $6348a97baa20d8d9$export$7bde6dffa6d2dd59 = (a, b)=>{
    if ((0, $EqHTq.isObjectLike)(a) && (0, $EqHTq.isObjectLike)(b)) return $6348a97baa20d8d9$export$6969335ea1e4e77c(a, b);
    return a || b;
};
const $6348a97baa20d8d9$export$d53c2c5b09d0676f = (param, prop, stack = [])=>{
    const objectized = (0, $hSU9O.mergeAndCloneIfArray)(param);
    stack.push(objectized);
    const extendOfExtend = objectized[prop];
    if (extendOfExtend) $6348a97baa20d8d9$export$d53c2c5b09d0676f(extendOfExtend, prop, stack);
    delete objectized[prop];
    return stack;
};
const $6348a97baa20d8d9$export$683c7d6569f339f4 = (param, element, visited = new Set())=>{
    // Check if both values are non-null objects
    if (typeof param !== "object" || typeof element !== "object" || param === null || element === null) return param === element // Compare non-object values directly
    ;
    // Check for circular references
    if (visited.has(param) || visited.has(element)) return true // Assume equality to break the circular reference
    ;
    visited.add(param);
    visited.add(element);
    const keysParam = Object.keys(param);
    const keysElement = Object.keys(element);
    // Check if both objects have the same number of properties
    if (keysParam.length !== keysElement.length) return false;
    // Check if all properties in param also exist in element
    for (const key of keysParam){
        if (!keysElement.includes(key)) return false;
        const paramProp = param[key];
        const elementProp = element[key];
        // Recursively check property values
        if (!$6348a97baa20d8d9$export$683c7d6569f339f4(paramProp, elementProp, visited)) return false;
    }
    return true;
};
const $6348a97baa20d8d9$export$273cb3019e2f952c = (obj1, obj2)=>{
    if (typeof obj1 !== typeof obj2) return false;
    if ((0, $EqHTq.isObjectLike)(obj1)) {
        if (Array.isArray(obj1) && Array.isArray(obj2)) {
            if (obj1.length !== obj2.length) return false;
            for(let i = 0; i < obj1.length; i++){
                if (!$6348a97baa20d8d9$export$273cb3019e2f952c(obj1[i], obj2[i])) return false;
            }
        } else if ((0, $EqHTq.isObjectLike)(obj1) && obj2 !== null) for(const key in obj1){
            const hasOwnProperty = Object.prototype.hasOwnProperty.call(obj2, key);
            if (!hasOwnProperty || !$6348a97baa20d8d9$export$273cb3019e2f952c(obj1[key], obj2[key])) return false;
        }
    } else return obj2 === obj1;
    return true;
};
const $6348a97baa20d8d9$export$bdd7fc6cf95d63b = (obj, props)=>{
    if (props === undefined || props === null) return obj;
    if ((0, $EqHTq.is)(props)("string", "number")) delete obj[props];
    else if ((0, $EqHTq.isArray)(props)) props.forEach((prop)=>delete obj[prop]);
    else throw new Error("Invalid input: props must be a string or an array of strings");
    return obj;
};

});
parcelRegister("hSU9O", function(module, exports) {

$parcel$export(module.exports, "arrayContainsOtherArray", () => $d0530a7c3063b815$export$de875babef361e5d);
$parcel$export(module.exports, "removeFromArray", () => $d0530a7c3063b815$export$8af121ae7401c4);
$parcel$export(module.exports, "swapItemsInArray", () => $d0530a7c3063b815$export$7e6517ca043a4c76);
$parcel$export(module.exports, "joinArrays", () => $d0530a7c3063b815$export$fc359ae9633f7296);
$parcel$export(module.exports, "mergeArray", () => $d0530a7c3063b815$export$fd2fbaf2367ef824);
$parcel$export(module.exports, "mergeAndCloneIfArray", () => $d0530a7c3063b815$export$803a4c6bdde5cd1d);
$parcel$export(module.exports, "cutArrayBeforeValue", () => $d0530a7c3063b815$export$e1c90dd42d36d8f4);
$parcel$export(module.exports, "cutArrayAfterValue", () => $d0530a7c3063b815$export$e9b4b966d876219d);
$parcel$export(module.exports, "createNestedObject", () => $d0530a7c3063b815$export$a9706fb8026b394a);
$parcel$export(module.exports, "removeValueFromArray", () => $d0530a7c3063b815$export$7268a0a9258a5297);
$parcel$export(module.exports, "removeValueFromArrayAll", () => $d0530a7c3063b815$export$91b305d65813a3f8);

var $8wu6n = parcelRequire("8wu6n");

var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $d0530a7c3063b815$export$de875babef361e5d = (arr1, arr2)=>{
    return arr2.every((val)=>arr1.includes(val));
};
const $d0530a7c3063b815$export$8af121ae7401c4 = (arr, index)=>{
    if ((0, $EqHTq.isString)(index)) index = parseInt(index);
    if ((0, $EqHTq.isNumber)(index)) {
        if (index < 0 || index >= arr.length || isNaN(index)) throw new Error("Invalid index");
        arr.splice(index, 1);
    } else if ((0, $EqHTq.isArray)(index)) index.forEach((idx)=>$d0530a7c3063b815$export$8af121ae7401c4(arr, idx));
    else throw new Error("Invalid index");
    return arr;
};
const $d0530a7c3063b815$export$7e6517ca043a4c76 = (arr, i, j)=>{
    [arr[i], arr[j]] = [
        arr[j],
        arr[i]
    ];
};
const $d0530a7c3063b815$export$fc359ae9633f7296 = (...arrays)=>{
    return [].concat(...arrays);
};
const $d0530a7c3063b815$export$fd2fbaf2367ef824 = (arr, excludeFrom = [])=>{
    return arr.reduce((a, c)=>(0, $8wu6n.deepMerge)(a, (0, $8wu6n.deepClone)(c, excludeFrom), excludeFrom), {});
};
const $d0530a7c3063b815$export$803a4c6bdde5cd1d = (obj)=>{
    return (0, $EqHTq.isArray)(obj) ? $d0530a7c3063b815$export$fd2fbaf2367ef824(obj) : (0, $8wu6n.deepClone)(obj);
};
const $d0530a7c3063b815$export$e1c90dd42d36d8f4 = (arr, value)=>{
    const index = arr.indexOf(value);
    if (index !== -1) return arr.slice(0, index);
    return arr;
};
const $d0530a7c3063b815$export$e9b4b966d876219d = (arr, value)=>{
    const index = arr.indexOf(value);
    if (index !== -1) return arr.slice(index + 1);
    return arr;
};
const $d0530a7c3063b815$export$a9706fb8026b394a = (arr, lastValue)=>{
    const nestedObject = {};
    if (arr.length === 0) return lastValue;
    arr.reduce((obj, value, index)=>{
        if (!obj[value]) obj[value] = {};
        if (index === arr.length - 1 && lastValue) obj[value] = lastValue;
        return obj[value];
    }, nestedObject);
    return nestedObject;
};
const $d0530a7c3063b815$export$7268a0a9258a5297 = (arr, value)=>{
    const index = arr.indexOf(value);
    if (index > -1) {
        const newArray = [
            ...arr
        ];
        newArray.splice(index, 1);
        return newArray;
    }
    return arr.slice();
};
const $d0530a7c3063b815$export$91b305d65813a3f8 = (arr, value)=>{
    return arr.filter((item)=>item !== value);
};

});

parcelRegister("5WrxC", function(module, exports) {

$parcel$export(module.exports, "stringIncludesAny", () => $4537bba2bd33729a$export$5e62532c096c05e0);
$parcel$export(module.exports, "trimStringFromSymbols", () => $4537bba2bd33729a$export$4cb168a4c77839cc);
$parcel$export(module.exports, "replaceLiteralsWithObjectFields", () => $4537bba2bd33729a$export$7cb52b7decbd2220);
$parcel$export(module.exports, "lowercaseFirstLetter", () => $4537bba2bd33729a$export$f08459d87829d2ee);
"use strict";
const $4537bba2bd33729a$export$5e62532c096c05e0 = (str, characters)=>{
    for (const char of characters){
        if (str.includes(char)) return true;
    }
    return false;
};
const $4537bba2bd33729a$export$4cb168a4c77839cc = (str, characters)=>{
    // Create a regular expression pattern to match the specified symbols
    const pattern = new RegExp(`[${characters.join("\\")}]`, "g");
    // Replace matched symbols with an empty string
    return str.replace(pattern, "");
};
/**
 * Replaces placeholders in a string with corresponding {{ }} values from an object.
 *
 * @param {string} str - The string containing placeholders to replace.
 * @param {object} state - The object containing the values to substitute.
 * @returns {string} The modified string with placeholders replaced by values from the object.
 */ const $4537bba2bd33729a$var$brackRegex = /\{\{\s*((?:\.\.\/)+)?([^}\s]+)\s*\}\}/g;
const $4537bba2bd33729a$export$7cb52b7decbd2220 = (str, state)=>{
    if (!str.includes("{{")) return str;
    return str.replace($4537bba2bd33729a$var$brackRegex, (_, parentPath, variable)=>{
        if (parentPath) {
            const parentLevels = parentPath.match(/\.\.\//g).length;
            let parentState = state;
            for(let i = 0; i < parentLevels; i++){
                parentState = parentState.parent;
                if (!parentState) return "" // Return an empty string if the parent level doesn't exist
                ;
            }
            const value = parentState[variable.trim()];
            return value !== undefined ? `${value}` : "";
        } else {
            const value = state[variable.trim()];
            return value !== undefined ? `${value}` : "";
        }
    });
};
const $4537bba2bd33729a$export$f08459d87829d2ee = (inputString)=>{
    return `${inputString.charAt(0).toLowerCase()}${inputString.slice(1)}`;
};

});


parcelRegister("fMhOg", function(module, exports) {

$parcel$export(module.exports, "debounce", () => $b7c9275e9e0262d0$export$61fc7d43ac8f84b0);
$parcel$export(module.exports, "debounceOnContext", () => $b7c9275e9e0262d0$export$d3757b91c00af798);
$parcel$export(module.exports, "memoize", () => $b7c9275e9e0262d0$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "isStringFunction", () => $b7c9275e9e0262d0$export$6f017d9966fe4675);
"use strict";
function $b7c9275e9e0262d0$export$61fc7d43ac8f84b0(func, wait, immediate) {
    let timeout;
    return function() {
        const context = this;
        const args = arguments;
        const later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}
const $b7c9275e9e0262d0$export$d3757b91c00af798 = (element, func, timeout = 300)=>{
    let timer;
    return (...args)=>{
        clearTimeout(timer);
        timer = setTimeout(()=>{
            func.apply(element, args);
        }, timeout);
    };
};
const $b7c9275e9e0262d0$export$fc10aeed3a532e2a = (fn)=>{
    const cache = {};
    return (...args)=>{
        const n = args[0];
        if (n in cache) return cache[n];
        else {
            const result = fn(n);
            cache[n] = result;
            return result;
        }
    };
};
const $b7c9275e9e0262d0$export$6f017d9966fe4675 = (inputString)=>{
    // Regular expression to match both regular and arrow function declarations
    const functionRegex = /^((function\s*\([^)]*\)\s*\{[^}]*\})|(\([^)]*\)\s*=>))/;
    // Use the regex to test if the inputString matches the function pattern
    return functionRegex.test(inputString);
};

});

parcelRegister("cQ6eY", function(module, exports) {

$parcel$export(module.exports, "logIf", () => $958f2e9ae228360b$export$f3730dd3d285b7c6);
$parcel$export(module.exports, "logGroupIf", () => $958f2e9ae228360b$export$7cea94b68a0c230b);
"use strict";
const $958f2e9ae228360b$export$f3730dd3d285b7c6 = (bool, ...arg)=>{
    if (bool) arg.map((v)=>console.log(v));
};
const $958f2e9ae228360b$export$7cea94b68a0c230b = (bool, key, ...arg)=>{
    if (bool) {
        console.group(key);
        arg.map((v)=>console.log(v));
        console.groupEnd(key);
    }
};

});

parcelRegister("57Gb5", function(module, exports) {

$parcel$export(module.exports, "isMobile", () => $3bae52d896fdaae9$export$d0a8044dce8ff2fc);
$parcel$export(module.exports, "setCookie", () => $3bae52d896fdaae9$export$110700823644f4a6);
$parcel$export(module.exports, "getCookie", () => $3bae52d896fdaae9$export$4be65e66cfa2648a);

var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $3bae52d896fdaae9$export$d0a8044dce8ff2fc = (()=>typeof navigator === "undefined" ? false : /Mobi/.test(navigator.userAgent))();
const $3bae52d896fdaae9$export$110700823644f4a6 = (cname, cvalue, exdays = 365)=>{
    if ((0, $EqHTq.isUndefined)(document) || (0, $EqHTq.isUndefined)(document.cookie)) return;
    const d = new Date();
    d.setTime(d.getTime() + exdays * 86400000);
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${cname}=${cvalue};${expires};path=/`;
};
const $3bae52d896fdaae9$export$4be65e66cfa2648a = (cname)=>{
    if ((0, $EqHTq.isUndefined)(document) || (0, $EqHTq.isUndefined)(document.cookie)) return;
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(";");
    for(let i = 0; i < ca.length; i++){
        let c = ca[i];
        while(c.charAt(0) === " ")c = c.substring(1);
        if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
    }
    return "";
};

});

parcelRegister("glQML", function(module, exports) {

$parcel$export(module.exports, "HTML_TAGS", () => $be778da0f6744ca3$export$4c3fa92ca590c71f);
$parcel$export(module.exports, "isValidHtmlTag", () => $be778da0f6744ca3$export$52675ca41d41c093);
"use strict";
const $be778da0f6744ca3$export$4c3fa92ca590c71f = {
    root: [
        "body",
        "html"
    ],
    head: [
        "title",
        "base",
        "meta",
        "style"
    ],
    body: [
        "string",
        "fragment",
        "a",
        "abbr",
        "acronym",
        "address",
        "applet",
        "area",
        "article",
        "aside",
        "audio",
        "b",
        "basefont",
        "bdi",
        "bdo",
        "big",
        "blockquote",
        "br",
        "button",
        "canvas",
        "caption",
        "center",
        "cite",
        "code",
        "search",
        "col",
        "colgroup",
        "data",
        "datalist",
        "dd",
        "del",
        "details",
        "dfn",
        "dialog",
        "dir",
        "div",
        "dl",
        "dt",
        "em",
        "embed",
        "fieldset",
        "figcaption",
        "figure",
        "font",
        "footer",
        "form",
        "frame",
        "frameset",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hr",
        "i",
        "iframe",
        "img",
        "input",
        "ins",
        "kbd",
        "label",
        "legend",
        "li",
        "link",
        "main",
        "map",
        "mark",
        "meter",
        "nav",
        "noframes",
        "noscript",
        "object",
        "ol",
        "optgroup",
        "option",
        "output",
        "p",
        "param",
        "picture",
        "pre",
        "progress",
        "hgroup",
        "q",
        "rp",
        "rt",
        "ruby",
        "s",
        "samp",
        "script",
        "section",
        "select",
        "small",
        "source",
        "span",
        "strike",
        "strong",
        "sub",
        "summary",
        "sup",
        "table",
        "tbody",
        "td",
        "template",
        "hgroup",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "time",
        "tr",
        "track",
        "tt",
        "u",
        "ul",
        "var",
        "video",
        "wbr",
        // SVG
        "svg",
        "path"
    ]
};
const $be778da0f6744ca3$export$52675ca41d41c093 = (arg)=>$be778da0f6744ca3$export$4c3fa92ca590c71f.body.includes(arg);

});


parcelRegister("aOJ2H", function(module, exports) {

$parcel$export(module.exports, "global", () => $7e0183656ac8db45$export$90b4d2ff6acb88af);
$parcel$export(module.exports, "self", () => $7e0183656ac8db45$export$82c2e460fb230c2a);
$parcel$export(module.exports, "window", () => $7e0183656ac8db45$export$8291e5b88f90ce4);
$parcel$export(module.exports, "document", () => $7e0183656ac8db45$export$5a7bfc01df82fcd1);
"use strict";
const $7e0183656ac8db45$export$90b4d2ff6acb88af = globalThis;
const $7e0183656ac8db45$export$82c2e460fb230c2a = globalThis;
const $7e0183656ac8db45$export$8291e5b88f90ce4 = globalThis;
const $7e0183656ac8db45$export$5a7bfc01df82fcd1 = $7e0183656ac8db45$export$8291e5b88f90ce4.document // eslint-disable-line
;

});

parcelRegister("73MNt", function(module, exports) {

$parcel$export(module.exports, "default", () => $523eaa49d3f99bf8$export$841407ceb083bd74);

var $kATNo = parcelRequire("kATNo");

var $fL4YY = parcelRequire("fL4YY");

var $lGX0c = parcelRequire("lGX0c");

var $2BjQv = parcelRequire("2BjQv");
/**
 * Managers cache.
 */ const $523eaa49d3f99bf8$var$cache = {};
function $523eaa49d3f99bf8$export$841407ceb083bd74(uri, opts) {
    if (typeof uri === "object") {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    const parsed = (0, $kATNo.url)(uri, opts.path || "/socket.io");
    const source = parsed.source;
    const id = parsed.id;
    const path = parsed.path;
    const sameNamespace = $523eaa49d3f99bf8$var$cache[id] && path in $523eaa49d3f99bf8$var$cache[id]["nsps"];
    const newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
    let io;
    if (newConnection) io = new (0, $fL4YY.Manager)(source, opts);
    else {
        if (!$523eaa49d3f99bf8$var$cache[id]) $523eaa49d3f99bf8$var$cache[id] = new (0, $fL4YY.Manager)(source, opts);
        io = $523eaa49d3f99bf8$var$cache[id];
    }
    if (parsed.query && !opts.query) opts.query = parsed.queryKey;
    return io.socket(parsed.path, opts);
}
// so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
// namespace (e.g. `io.connect(...)`), for backward compatibility
Object.assign($523eaa49d3f99bf8$export$841407ceb083bd74, {
    Manager: $fL4YY.Manager,
    Socket: $lGX0c.Socket,
    io: $523eaa49d3f99bf8$export$841407ceb083bd74,
    connect: $523eaa49d3f99bf8$export$841407ceb083bd74
});

});
parcelRegister("kATNo", function(module, exports) {

$parcel$export(module.exports, "url", () => $efe27346e00da8a8$export$128fa18b7194ef);
parcelRequire("1XKMK");
var $l7wSz = parcelRequire("l7wSz");
function $efe27346e00da8a8$export$128fa18b7194ef(uri, path = "", loc) {
    let obj = uri;
    // default to window.location
    loc = loc || typeof location !== "undefined" && location;
    if (null == uri) uri = loc.protocol + "//" + loc.host;
    // relative path support
    if (typeof uri === "string") {
        if ("/" === uri.charAt(0)) {
            if ("/" === uri.charAt(1)) uri = loc.protocol + uri;
            else uri = loc.host + uri;
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            if ("undefined" !== typeof loc) uri = loc.protocol + "//" + uri;
            else uri = "https://" + uri;
        }
        // parse
        obj = (0, $l7wSz.parse)(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) obj.port = "80";
        else if (/^(http|ws)s$/.test(obj.protocol)) obj.port = "443";
    }
    obj.path = obj.path || "/";
    const ipv6 = obj.host.indexOf(":") !== -1;
    const host = ipv6 ? "[" + obj.host + "]" : obj.host;
    // define unique id
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    // define href
    obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
}

});
parcelRegister("1XKMK", function(module, exports) {

$parcel$export(module.exports, "Socket", () => (parcelRequire("al9N3")).Socket);
$parcel$export(module.exports, "installTimerFunctions", () => (parcelRequire("5vwdc")).installTimerFunctions);
$parcel$export(module.exports, "parse", () => (parcelRequire("l7wSz")).parse);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("cFgwF")).nextTick);

var $al9N3 = parcelRequire("al9N3");

var $6opKi = parcelRequire("6opKi");

var $gEtm1 = parcelRequire("gEtm1");

var $5vwdc = parcelRequire("5vwdc");

var $l7wSz = parcelRequire("l7wSz");

var $cFgwF = parcelRequire("cFgwF");
const $16df97babd1aadf1$export$a51d6b395ff4c65a = (0, $al9N3.Socket).protocol;

});
parcelRegister("al9N3", function(module, exports) {

$parcel$export(module.exports, "Socket", () => $787375aed2c43820$export$4798917dbf149b79);

var $gEtm1 = parcelRequire("gEtm1");

var $5vwdc = parcelRequire("5vwdc");

var $2buxl = parcelRequire("2buxl");

var $l7wSz = parcelRequire("l7wSz");

var $687to = parcelRequire("687to");

var $CnWUo = parcelRequire("CnWUo");

var $cFgwF = parcelRequire("cFgwF");
class $787375aed2c43820$export$4798917dbf149b79 extends (0, $687to.Emitter) {
    /**
     * Socket constructor.
     *
     * @param {String|Object} uri - uri or options
     * @param {Object} opts - options
     */ constructor(uri, opts = {}){
        super();
        this.binaryType = (0, $cFgwF.defaultBinaryType);
        this.writeBuffer = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = null;
        }
        if (uri) {
            uri = (0, $l7wSz.parse)(uri);
            opts.hostname = uri.host;
            opts.secure = uri.protocol === "https" || uri.protocol === "wss";
            opts.port = uri.port;
            if (uri.query) opts.query = uri.query;
        } else if (opts.host) opts.hostname = (0, $l7wSz.parse)(opts.host).host;
        (0, $5vwdc.installTimerFunctions)(this, opts);
        this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
        if (opts.hostname && !opts.port) // if no port is specified manually, use the protocol default
        opts.port = this.secure ? "443" : "80";
        this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
        this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? "443" : "80");
        this.transports = opts.transports || [
            "polling",
            "websocket",
            "webtransport"
        ];
        this.writeBuffer = [];
        this.prevBufferLen = 0;
        this.opts = Object.assign({
            path: "/engine.io",
            agent: false,
            withCredentials: false,
            upgrade: true,
            timestampParam: "t",
            rememberUpgrade: false,
            addTrailingSlash: true,
            rejectUnauthorized: true,
            perMessageDeflate: {
                threshold: 1024
            },
            transportOptions: {},
            closeOnBeforeunload: false
        }, opts);
        this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : "");
        if (typeof this.opts.query === "string") this.opts.query = (0, $2buxl.decode)(this.opts.query);
        // set on handshake
        this.id = null;
        this.upgrades = null;
        this.pingInterval = null;
        this.pingTimeout = null;
        // set on heartbeat
        this.pingTimeoutTimer = null;
        if (typeof addEventListener === "function") {
            if (this.opts.closeOnBeforeunload) {
                // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
                // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
                // closed/reloaded)
                this.beforeunloadEventListener = ()=>{
                    if (this.transport) {
                        // silently close the transport
                        this.transport.removeAllListeners();
                        this.transport.close();
                    }
                };
                addEventListener("beforeunload", this.beforeunloadEventListener, false);
            }
            if (this.hostname !== "localhost") {
                this.offlineEventListener = ()=>{
                    this.onClose("transport close", {
                        description: "network connection lost"
                    });
                };
                addEventListener("offline", this.offlineEventListener, false);
            }
        }
        this.open();
    }
    /**
     * Creates transport of the given type.
     *
     * @param {String} name - transport name
     * @return {Transport}
     * @private
     */ createTransport(name) {
        const query = Object.assign({}, this.opts.query);
        // append engine.io protocol identifier
        query.EIO = (0, $CnWUo.protocol);
        // transport name
        query.transport = name;
        // session id if we already have one
        if (this.id) query.sid = this.id;
        const opts = Object.assign({}, this.opts, {
            query: query,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port
        }, this.opts.transportOptions[name]);
        return new (0, $gEtm1.transports)[name](opts);
    }
    /**
     * Initializes transport to use and starts probe.
     *
     * @private
     */ open() {
        let transport;
        if (this.opts.rememberUpgrade && $787375aed2c43820$export$4798917dbf149b79.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1) transport = "websocket";
        else if (0 === this.transports.length) {
            // Emit error on next tick so it can be listened to
            this.setTimeoutFn(()=>{
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        } else transport = this.transports[0];
        this.readyState = "opening";
        // Retry with the next transport if the transport is disabled (jsonp: false)
        try {
            transport = this.createTransport(transport);
        } catch (e) {
            this.transports.shift();
            this.open();
            return;
        }
        transport.open();
        this.setTransport(transport);
    }
    /**
     * Sets the current transport. Disables the existing one (if any).
     *
     * @private
     */ setTransport(transport) {
        if (this.transport) this.transport.removeAllListeners();
        // set up transport
        this.transport = transport;
        // set up transport listeners
        transport.on("drain", this.onDrain.bind(this)).on("packet", this.onPacket.bind(this)).on("error", this.onError.bind(this)).on("close", (reason)=>this.onClose("transport close", reason));
    }
    /**
     * Probes a transport.
     *
     * @param {String} name - transport name
     * @private
     */ probe(name) {
        let transport = this.createTransport(name);
        let failed = false;
        $787375aed2c43820$export$4798917dbf149b79.priorWebsocketSuccess = false;
        const onTransportOpen = ()=>{
            if (failed) return;
            transport.send([
                {
                    type: "ping",
                    data: "probe"
                }
            ]);
            transport.once("packet", (msg)=>{
                if (failed) return;
                if ("pong" === msg.type && "probe" === msg.data) {
                    this.upgrading = true;
                    this.emitReserved("upgrading", transport);
                    if (!transport) return;
                    $787375aed2c43820$export$4798917dbf149b79.priorWebsocketSuccess = "websocket" === transport.name;
                    this.transport.pause(()=>{
                        if (failed) return;
                        if ("closed" === this.readyState) return;
                        cleanup();
                        this.setTransport(transport);
                        transport.send([
                            {
                                type: "upgrade"
                            }
                        ]);
                        this.emitReserved("upgrade", transport);
                        transport = null;
                        this.upgrading = false;
                        this.flush();
                    });
                } else {
                    const err = new Error("probe error");
                    // @ts-ignore
                    err.transport = transport.name;
                    this.emitReserved("upgradeError", err);
                }
            });
        };
        function freezeTransport() {
            if (failed) return;
            // Any callback called by transport should be ignored since now
            failed = true;
            cleanup();
            transport.close();
            transport = null;
        }
        // Handle any error that happens while probing
        const onerror = (err)=>{
            const error = new Error("probe error: " + err);
            // @ts-ignore
            error.transport = transport.name;
            freezeTransport();
            this.emitReserved("upgradeError", error);
        };
        function onTransportClose() {
            onerror("transport closed");
        }
        // When the socket is closed while we're probing
        function onclose() {
            onerror("socket closed");
        }
        // When the socket is upgraded while we're probing
        function onupgrade(to) {
            if (transport && to.name !== transport.name) freezeTransport();
        }
        // Remove all listeners on the transport and on self
        const cleanup = ()=>{
            transport.removeListener("open", onTransportOpen);
            transport.removeListener("error", onerror);
            transport.removeListener("close", onTransportClose);
            this.off("close", onclose);
            this.off("upgrading", onupgrade);
        };
        transport.once("open", onTransportOpen);
        transport.once("error", onerror);
        transport.once("close", onTransportClose);
        this.once("close", onclose);
        this.once("upgrading", onupgrade);
        if (this.upgrades.indexOf("webtransport") !== -1 && name !== "webtransport") // favor WebTransport
        this.setTimeoutFn(()=>{
            if (!failed) transport.open();
        }, 200);
        else transport.open();
    }
    /**
     * Called when connection is deemed open.
     *
     * @private
     */ onOpen() {
        this.readyState = "open";
        $787375aed2c43820$export$4798917dbf149b79.priorWebsocketSuccess = "websocket" === this.transport.name;
        this.emitReserved("open");
        this.flush();
        // we check for `readyState` in case an `open`
        // listener already closed the socket
        if ("open" === this.readyState && this.opts.upgrade) {
            let i = 0;
            const l = this.upgrades.length;
            for(; i < l; i++)this.probe(this.upgrades[i]);
        }
    }
    /**
     * Handles a packet.
     *
     * @private
     */ onPacket(packet) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            this.emitReserved("packet", packet);
            // Socket is live - any packet counts
            this.emitReserved("heartbeat");
            this.resetPingTimeout();
            switch(packet.type){
                case "open":
                    this.onHandshake(JSON.parse(packet.data));
                    break;
                case "ping":
                    this.sendPacket("pong");
                    this.emitReserved("ping");
                    this.emitReserved("pong");
                    break;
                case "error":
                    const err = new Error("server error");
                    // @ts-ignore
                    err.code = packet.data;
                    this.onError(err);
                    break;
                case "message":
                    this.emitReserved("data", packet.data);
                    this.emitReserved("message", packet.data);
                    break;
            }
        }
    }
    /**
     * Called upon handshake completion.
     *
     * @param {Object} data - handshake obj
     * @private
     */ onHandshake(data) {
        this.emitReserved("handshake", data);
        this.id = data.sid;
        this.transport.query.sid = data.sid;
        this.upgrades = this.filterUpgrades(data.upgrades);
        this.pingInterval = data.pingInterval;
        this.pingTimeout = data.pingTimeout;
        this.maxPayload = data.maxPayload;
        this.onOpen();
        // In case open handler closes socket
        if ("closed" === this.readyState) return;
        this.resetPingTimeout();
    }
    /**
     * Sets and resets ping timeout timer based on server pings.
     *
     * @private
     */ resetPingTimeout() {
        this.clearTimeoutFn(this.pingTimeoutTimer);
        this.pingTimeoutTimer = this.setTimeoutFn(()=>{
            this.onClose("ping timeout");
        }, this.pingInterval + this.pingTimeout);
        if (this.opts.autoUnref) this.pingTimeoutTimer.unref();
    }
    /**
     * Called on `drain` event
     *
     * @private
     */ onDrain() {
        this.writeBuffer.splice(0, this.prevBufferLen);
        // setting prevBufferLen = 0 is very important
        // for example, when upgrading, upgrade packet is sent over,
        // and a nonzero prevBufferLen could cause problems on `drain`
        this.prevBufferLen = 0;
        if (0 === this.writeBuffer.length) this.emitReserved("drain");
        else this.flush();
    }
    /**
     * Flush write buffers.
     *
     * @private
     */ flush() {
        if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
            const packets = this.getWritablePackets();
            this.transport.send(packets);
            // keep track of current length of writeBuffer
            // splice writeBuffer and callbackBuffer on `drain`
            this.prevBufferLen = packets.length;
            this.emitReserved("flush");
        }
    }
    /**
     * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
     * long-polling)
     *
     * @private
     */ getWritablePackets() {
        const shouldCheckPayloadSize = this.maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
        if (!shouldCheckPayloadSize) return this.writeBuffer;
        let payloadSize = 1; // first packet type
        for(let i = 0; i < this.writeBuffer.length; i++){
            const data = this.writeBuffer[i].data;
            if (data) payloadSize += (0, $5vwdc.byteLength)(data);
            if (i > 0 && payloadSize > this.maxPayload) return this.writeBuffer.slice(0, i);
            payloadSize += 2; // separator + packet type
        }
        return this.writeBuffer;
    }
    /**
     * Sends a message.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} callback function.
     * @return {Socket} for chaining.
     */ write(msg, options, fn) {
        this.sendPacket("message", msg, options, fn);
        return this;
    }
    send(msg, options, fn) {
        this.sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a packet.
     *
     * @param {String} type: packet type.
     * @param {String} data.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @private
     */ sendPacket(type, data, options, fn) {
        if ("function" === typeof data) {
            fn = data;
            data = undefined;
        }
        if ("function" === typeof options) {
            fn = options;
            options = null;
        }
        if ("closing" === this.readyState || "closed" === this.readyState) return;
        options = options || {};
        options.compress = false !== options.compress;
        const packet = {
            type: type,
            data: data,
            options: options
        };
        this.emitReserved("packetCreate", packet);
        this.writeBuffer.push(packet);
        if (fn) this.once("flush", fn);
        this.flush();
    }
    /**
     * Closes the connection.
     */ close() {
        const close = ()=>{
            this.onClose("forced close");
            this.transport.close();
        };
        const cleanupAndClose = ()=>{
            this.off("upgrade", cleanupAndClose);
            this.off("upgradeError", cleanupAndClose);
            close();
        };
        const waitForUpgrade = ()=>{
            // wait for upgrade to finish since we can't send packets while pausing a transport
            this.once("upgrade", cleanupAndClose);
            this.once("upgradeError", cleanupAndClose);
        };
        if ("opening" === this.readyState || "open" === this.readyState) {
            this.readyState = "closing";
            if (this.writeBuffer.length) this.once("drain", ()=>{
                if (this.upgrading) waitForUpgrade();
                else close();
            });
            else if (this.upgrading) waitForUpgrade();
            else close();
        }
        return this;
    }
    /**
     * Called upon transport error
     *
     * @private
     */ onError(err) {
        $787375aed2c43820$export$4798917dbf149b79.priorWebsocketSuccess = false;
        this.emitReserved("error", err);
        this.onClose("transport error", err);
    }
    /**
     * Called upon transport close.
     *
     * @private
     */ onClose(reason, description) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            // clear timers
            this.clearTimeoutFn(this.pingTimeoutTimer);
            // stop event from firing again for transport
            this.transport.removeAllListeners("close");
            // ensure transport won't stay open
            this.transport.close();
            // ignore further transport communication
            this.transport.removeAllListeners();
            if (typeof removeEventListener === "function") {
                removeEventListener("beforeunload", this.beforeunloadEventListener, false);
                removeEventListener("offline", this.offlineEventListener, false);
            }
            // set ready state
            this.readyState = "closed";
            // clear session id
            this.id = null;
            // emit close event
            this.emitReserved("close", reason, description);
            // clean buffers after, so users can still
            // grab the buffers on `close` event
            this.writeBuffer = [];
            this.prevBufferLen = 0;
        }
    }
    /**
     * Filters upgrades, returning only those matching client transports.
     *
     * @param {Array} upgrades - server upgrades
     * @private
     */ filterUpgrades(upgrades) {
        const filteredUpgrades = [];
        let i = 0;
        const j = upgrades.length;
        for(; i < j; i++)if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
        return filteredUpgrades;
    }
}
$787375aed2c43820$export$4798917dbf149b79.protocol = (0, $CnWUo.protocol);

});
parcelRegister("gEtm1", function(module, exports) {

$parcel$export(module.exports, "transports", () => $c1f726e793763466$export$46dec00755c1153b);

var $7pvuz = parcelRequire("7pvuz");

var $dhyBt = parcelRequire("dhyBt");

var $hJTtX = parcelRequire("hJTtX");
const $c1f726e793763466$export$46dec00755c1153b = {
    websocket: (0, $dhyBt.WS),
    webtransport: (0, $hJTtX.WT),
    polling: (0, $7pvuz.Polling)
};

});
parcelRegister("7pvuz", function(module, exports) {

$parcel$export(module.exports, "Polling", () => $56534be56e5aa809$export$265ee5eefd4c309b);

var $6opKi = parcelRequire("6opKi");

var $e3yjg = parcelRequire("e3yjg");

var $CnWUo = parcelRequire("CnWUo");

var $lB1J3 = parcelRequire("lB1J3");

var $687to = parcelRequire("687to");

var $5vwdc = parcelRequire("5vwdc");

var $3kfWP = parcelRequire("3kfWP");
function $56534be56e5aa809$var$empty() {}
const $56534be56e5aa809$var$hasXHR2 = function() {
    const xhr = new (0, $lB1J3.XHR)({
        xdomain: false
    });
    return null != xhr.responseType;
}();
class $56534be56e5aa809$export$265ee5eefd4c309b extends (0, $6opKi.Transport) {
    /**
     * XHR Polling constructor.
     *
     * @param {Object} opts
     * @package
     */ constructor(opts){
        super(opts);
        this.polling = false;
        if (typeof location !== "undefined") {
            const isSSL = "https:" === location.protocol;
            let port = location.port;
            // some user agents have empty `location.port`
            if (!port) port = isSSL ? "443" : "80";
            this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
        }
        /**
         * XHR supports binary
         */ const forceBase64 = opts && opts.forceBase64;
        this.supportsBinary = $56534be56e5aa809$var$hasXHR2 && !forceBase64;
        if (this.opts.withCredentials) this.cookieJar = (0, $lB1J3.createCookieJar)();
    }
    get name() {
        return "polling";
    }
    /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @protected
     */ doOpen() {
        this.poll();
    }
    /**
     * Pauses polling.
     *
     * @param {Function} onPause - callback upon buffers are flushed and transport is paused
     * @package
     */ pause(onPause) {
        this.readyState = "pausing";
        const pause = ()=>{
            this.readyState = "paused";
            onPause();
        };
        if (this.polling || !this.writable) {
            let total = 0;
            if (this.polling) {
                total++;
                this.once("pollComplete", function() {
                    --total || pause();
                });
            }
            if (!this.writable) {
                total++;
                this.once("drain", function() {
                    --total || pause();
                });
            }
        } else pause();
    }
    /**
     * Starts polling cycle.
     *
     * @private
     */ poll() {
        this.polling = true;
        this.doPoll();
        this.emitReserved("poll");
    }
    /**
     * Overloads onData to detect payloads.
     *
     * @protected
     */ onData(data) {
        const callback = (packet)=>{
            // if its the first message we consider the transport open
            if ("opening" === this.readyState && packet.type === "open") this.onOpen();
            // if its a close packet, we close the ongoing requests
            if ("close" === packet.type) {
                this.onClose({
                    description: "transport closed by the server"
                });
                return false;
            }
            // otherwise bypass onData and handle the message
            this.onPacket(packet);
        };
        // decode payload
        (0, $CnWUo.decodePayload)(data, this.socket.binaryType).forEach(callback);
        // if an event did not trigger closing
        if ("closed" !== this.readyState) {
            // if we got data we're not polling
            this.polling = false;
            this.emitReserved("pollComplete");
            if ("open" === this.readyState) this.poll();
        }
    }
    /**
     * For polling, send a close packet.
     *
     * @protected
     */ doClose() {
        const close = ()=>{
            this.write([
                {
                    type: "close"
                }
            ]);
        };
        if ("open" === this.readyState) close();
        else // in case we're trying to close while
        // handshaking is in progress (GH-164)
        this.once("open", close);
    }
    /**
     * Writes a packets payload.
     *
     * @param {Array} packets - data packets
     * @protected
     */ write(packets) {
        this.writable = false;
        (0, $CnWUo.encodePayload)(packets, (data)=>{
            this.doWrite(data, ()=>{
                this.writable = true;
                this.emitReserved("drain");
            });
        });
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "https" : "http";
        const query = this.query || {};
        // cache busting is forced
        if (false !== this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $e3yjg.yeast)();
        if (!this.supportsBinary && !query.sid) query.b64 = 1;
        return this.createUri(schema, query);
    }
    /**
     * Creates a request.
     *
     * @param {String} method
     * @private
     */ request(opts = {}) {
        Object.assign(opts, {
            xd: this.xd,
            cookieJar: this.cookieJar
        }, this.opts);
        return new $56534be56e5aa809$export$7fa6c5b6f8193917(this.uri(), opts);
    }
    /**
     * Sends data.
     *
     * @param {String} data to send.
     * @param {Function} called upon flush.
     * @private
     */ doWrite(data, fn) {
        const req = this.request({
            method: "POST",
            data: data
        });
        req.on("success", fn);
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr post error", xhrStatus, context);
        });
    }
    /**
     * Starts a poll cycle.
     *
     * @private
     */ doPoll() {
        const req = this.request();
        req.on("data", this.onData.bind(this));
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr poll error", xhrStatus, context);
        });
        this.pollXhr = req;
    }
}
class $56534be56e5aa809$export$7fa6c5b6f8193917 extends (0, $687to.Emitter) {
    /**
     * Request constructor
     *
     * @param {Object} options
     * @package
     */ constructor(uri, opts){
        super();
        (0, $5vwdc.installTimerFunctions)(this, opts);
        this.opts = opts;
        this.method = opts.method || "GET";
        this.uri = uri;
        this.data = undefined !== opts.data ? opts.data : null;
        this.create();
    }
    /**
     * Creates the XHR object and sends the request.
     *
     * @private
     */ create() {
        var _a;
        const opts = (0, $5vwdc.pick)(this.opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        opts.xdomain = !!this.opts.xd;
        const xhr = this.xhr = new (0, $lB1J3.XHR)(opts);
        try {
            xhr.open(this.method, this.uri, true);
            try {
                if (this.opts.extraHeaders) {
                    xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                    for(let i in this.opts.extraHeaders)if (this.opts.extraHeaders.hasOwnProperty(i)) xhr.setRequestHeader(i, this.opts.extraHeaders[i]);
                }
            } catch (e) {}
            if ("POST" === this.method) try {
                xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch (e) {}
            try {
                xhr.setRequestHeader("Accept", "*/*");
            } catch (e) {}
            (_a = this.opts.cookieJar) === null || _a === void 0 || _a.addCookies(xhr);
            // ie6 check
            if ("withCredentials" in xhr) xhr.withCredentials = this.opts.withCredentials;
            if (this.opts.requestTimeout) xhr.timeout = this.opts.requestTimeout;
            xhr.onreadystatechange = ()=>{
                var _a;
                if (xhr.readyState === 3) (_a = this.opts.cookieJar) === null || _a === void 0 || _a.parseCookies(xhr);
                if (4 !== xhr.readyState) return;
                if (200 === xhr.status || 1223 === xhr.status) this.onLoad();
                else // make sure the `error` event handler that's user-set
                // does not throw in the same tick and gets caught here
                this.setTimeoutFn(()=>{
                    this.onError(typeof xhr.status === "number" ? xhr.status : 0);
                }, 0);
            };
            xhr.send(this.data);
        } catch (e) {
            // Need to defer since .create() is called directly from the constructor
            // and thus the 'error' event can only be only bound *after* this exception
            // occurs.  Therefore, also, we cannot throw here at all.
            this.setTimeoutFn(()=>{
                this.onError(e);
            }, 0);
            return;
        }
        if (typeof document !== "undefined") {
            this.index = $56534be56e5aa809$export$7fa6c5b6f8193917.requestsCount++;
            $56534be56e5aa809$export$7fa6c5b6f8193917.requests[this.index] = this;
        }
    }
    /**
     * Called upon error.
     *
     * @private
     */ onError(err) {
        this.emitReserved("error", err, this.xhr);
        this.cleanup(true);
    }
    /**
     * Cleans up house.
     *
     * @private
     */ cleanup(fromError) {
        if ("undefined" === typeof this.xhr || null === this.xhr) return;
        this.xhr.onreadystatechange = $56534be56e5aa809$var$empty;
        if (fromError) try {
            this.xhr.abort();
        } catch (e) {}
        if (typeof document !== "undefined") delete $56534be56e5aa809$export$7fa6c5b6f8193917.requests[this.index];
        this.xhr = null;
    }
    /**
     * Called upon load.
     *
     * @private
     */ onLoad() {
        const data = this.xhr.responseText;
        if (data !== null) {
            this.emitReserved("data", data);
            this.emitReserved("success");
            this.cleanup();
        }
    }
    /**
     * Aborts the request.
     *
     * @package
     */ abort() {
        this.cleanup();
    }
}
$56534be56e5aa809$export$7fa6c5b6f8193917.requestsCount = 0;
$56534be56e5aa809$export$7fa6c5b6f8193917.requests = {};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */ if (typeof document !== "undefined") {
    // @ts-ignore
    if (typeof attachEvent === "function") // @ts-ignore
    attachEvent("onunload", $56534be56e5aa809$var$unloadHandler);
    else if (typeof addEventListener === "function") {
        const terminationEvent = "onpagehide" in (0, $3kfWP.globalThisShim) ? "pagehide" : "unload";
        addEventListener(terminationEvent, $56534be56e5aa809$var$unloadHandler, false);
    }
}
function $56534be56e5aa809$var$unloadHandler() {
    for(let i in $56534be56e5aa809$export$7fa6c5b6f8193917.requests)if ($56534be56e5aa809$export$7fa6c5b6f8193917.requests.hasOwnProperty(i)) $56534be56e5aa809$export$7fa6c5b6f8193917.requests[i].abort();
}

});
parcelRegister("6opKi", function(module, exports) {

$parcel$export(module.exports, "Transport", () => $4a78f487f5bb98d8$export$86495b081fef8e52);
parcelRequire("CnWUo");
var $ezyGD = parcelRequire("ezyGD");

var $687to = parcelRequire("687to");

var $5vwdc = parcelRequire("5vwdc");

var $2buxl = parcelRequire("2buxl");
class $4a78f487f5bb98d8$export$8e68de6fb26f2236 extends Error {
    constructor(reason, description, context){
        super(reason);
        this.description = description;
        this.context = context;
        this.type = "TransportError";
    }
}
class $4a78f487f5bb98d8$export$86495b081fef8e52 extends (0, $687to.Emitter) {
    /**
     * Transport abstract constructor.
     *
     * @param {Object} opts - options
     * @protected
     */ constructor(opts){
        super();
        this.writable = false;
        (0, $5vwdc.installTimerFunctions)(this, opts);
        this.opts = opts;
        this.query = opts.query;
        this.socket = opts.socket;
    }
    /**
     * Emits an error.
     *
     * @param {String} reason
     * @param description
     * @param context - the error context
     * @return {Transport} for chaining
     * @protected
     */ onError(reason, description, context) {
        super.emitReserved("error", new $4a78f487f5bb98d8$export$8e68de6fb26f2236(reason, description, context));
        return this;
    }
    /**
     * Opens the transport.
     */ open() {
        this.readyState = "opening";
        this.doOpen();
        return this;
    }
    /**
     * Closes the transport.
     */ close() {
        if (this.readyState === "opening" || this.readyState === "open") {
            this.doClose();
            this.onClose();
        }
        return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     */ send(packets) {
        if (this.readyState === "open") this.write(packets);
    }
    /**
     * Called upon open
     *
     * @protected
     */ onOpen() {
        this.readyState = "open";
        this.writable = true;
        super.emitReserved("open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @protected
     */ onData(data) {
        const packet = (0, $ezyGD.decodePacket)(data, this.socket.binaryType);
        this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     *
     * @protected
     */ onPacket(packet) {
        super.emitReserved("packet", packet);
    }
    /**
     * Called upon close.
     *
     * @protected
     */ onClose(details) {
        this.readyState = "closed";
        super.emitReserved("close", details);
    }
    /**
     * Pauses the transport, in order not to lose packets during an upgrade.
     *
     * @param onPause
     */ pause(onPause) {}
    createUri(schema, query = {}) {
        return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
    }
    _hostname() {
        const hostname = this.opts.hostname;
        return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
    }
    _port() {
        if (this.opts.port && (this.opts.secure && Number(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80)) return ":" + this.opts.port;
        else return "";
    }
    _query(query) {
        const encodedQuery = (0, $2buxl.encode)(query);
        return encodedQuery.length ? "?" + encodedQuery : "";
    }
}

});
parcelRegister("CnWUo", function(module, exports) {

$parcel$export(module.exports, "encodePayload", () => $0736208648dc8bae$export$144d64fe58dad441);
$parcel$export(module.exports, "decodePayload", () => $0736208648dc8bae$export$d10cc2e7f7566a2d);
$parcel$export(module.exports, "createPacketEncoderStream", () => $0736208648dc8bae$export$a525fb718e9c623a);
$parcel$export(module.exports, "createPacketDecoderStream", () => $0736208648dc8bae$export$552d20aac7500f47);
$parcel$export(module.exports, "protocol", () => $0736208648dc8bae$export$a51d6b395ff4c65a);
$parcel$export(module.exports, "encodePacket", () => (parcelRequire("bRHuL")).encodePacket);
$parcel$export(module.exports, "decodePacket", () => (parcelRequire("ezyGD")).decodePacket);

var $bRHuL = parcelRequire("bRHuL");

var $ezyGD = parcelRequire("ezyGD");

var $fsDlh = parcelRequire("fsDlh");
const $0736208648dc8bae$var$SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
const $0736208648dc8bae$export$144d64fe58dad441 = (packets, callback)=>{
    // some packets may be added to the array while encoding, so the initial length must be saved
    const length = packets.length;
    const encodedPackets = new Array(length);
    let count = 0;
    packets.forEach((packet, i)=>{
        // force base64 encoding for binary packets
        (0, $bRHuL.encodePacket)(packet, false, (encodedPacket)=>{
            encodedPackets[i] = encodedPacket;
            if (++count === length) callback(encodedPackets.join($0736208648dc8bae$var$SEPARATOR));
        });
    });
};
const $0736208648dc8bae$export$d10cc2e7f7566a2d = (encodedPayload, binaryType)=>{
    const encodedPackets = encodedPayload.split($0736208648dc8bae$var$SEPARATOR);
    const packets = [];
    for(let i = 0; i < encodedPackets.length; i++){
        const decodedPacket = (0, $ezyGD.decodePacket)(encodedPackets[i], binaryType);
        packets.push(decodedPacket);
        if (decodedPacket.type === "error") break;
    }
    return packets;
};
function $0736208648dc8bae$export$a525fb718e9c623a() {
    // @ts-expect-error
    return new TransformStream({
        transform (packet, controller) {
            (0, $bRHuL.encodePacketToBinary)(packet, (encodedPacket)=>{
                const payloadLength = encodedPacket.length;
                let header;
                // inspired by the WebSocket format: https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API/Writing_WebSocket_servers#decoding_payload_length
                if (payloadLength < 126) {
                    header = new Uint8Array(1);
                    new DataView(header.buffer).setUint8(0, payloadLength);
                } else if (payloadLength < 65536) {
                    header = new Uint8Array(3);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 126);
                    view.setUint16(1, payloadLength);
                } else {
                    header = new Uint8Array(9);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 127);
                    view.setBigUint64(1, BigInt(payloadLength));
                }
                // first bit indicates whether the payload is plain text (0) or binary (1)
                if (packet.data && typeof packet.data !== "string") header[0] |= 0x80;
                controller.enqueue(header);
                controller.enqueue(encodedPacket);
            });
        }
    });
}
let $0736208648dc8bae$var$TEXT_DECODER;
function $0736208648dc8bae$var$totalLength(chunks) {
    return chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
}
function $0736208648dc8bae$var$concatChunks(chunks, size) {
    if (chunks[0].length === size) return chunks.shift();
    const buffer = new Uint8Array(size);
    let j = 0;
    for(let i = 0; i < size; i++){
        buffer[i] = chunks[0][j++];
        if (j === chunks[0].length) {
            chunks.shift();
            j = 0;
        }
    }
    if (chunks.length && j < chunks[0].length) chunks[0] = chunks[0].slice(j);
    return buffer;
}
function $0736208648dc8bae$export$552d20aac7500f47(maxPayload, binaryType) {
    if (!$0736208648dc8bae$var$TEXT_DECODER) $0736208648dc8bae$var$TEXT_DECODER = new TextDecoder();
    const chunks = [];
    let state = 0 /* READ_HEADER */ ;
    let expectedLength = -1;
    let isBinary = false;
    // @ts-expect-error
    return new TransformStream({
        transform (chunk, controller) {
            chunks.push(chunk);
            while(true){
                if (state === 0 /* READ_HEADER */ ) {
                    if ($0736208648dc8bae$var$totalLength(chunks) < 1) break;
                    const header = $0736208648dc8bae$var$concatChunks(chunks, 1);
                    isBinary = (header[0] & 0x80) === 0x80;
                    expectedLength = header[0] & 0x7f;
                    if (expectedLength < 126) state = 3 /* READ_PAYLOAD */ ;
                    else if (expectedLength === 126) state = 1 /* READ_EXTENDED_LENGTH_16 */ ;
                    else state = 2 /* READ_EXTENDED_LENGTH_64 */ ;
                } else if (state === 1 /* READ_EXTENDED_LENGTH_16 */ ) {
                    if ($0736208648dc8bae$var$totalLength(chunks) < 2) break;
                    const headerArray = $0736208648dc8bae$var$concatChunks(chunks, 2);
                    expectedLength = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length).getUint16(0);
                    state = 3 /* READ_PAYLOAD */ ;
                } else if (state === 2 /* READ_EXTENDED_LENGTH_64 */ ) {
                    if ($0736208648dc8bae$var$totalLength(chunks) < 8) break;
                    const headerArray = $0736208648dc8bae$var$concatChunks(chunks, 8);
                    const view = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length);
                    const n = view.getUint32(0);
                    if (n > Math.pow(2, 21) - 1) {
                        // the maximum safe integer in JavaScript is 2^53 - 1
                        controller.enqueue((0, $fsDlh.ERROR_PACKET));
                        break;
                    }
                    expectedLength = n * Math.pow(2, 32) + view.getUint32(4);
                    state = 3 /* READ_PAYLOAD */ ;
                } else {
                    if ($0736208648dc8bae$var$totalLength(chunks) < expectedLength) break;
                    const data = $0736208648dc8bae$var$concatChunks(chunks, expectedLength);
                    controller.enqueue((0, $ezyGD.decodePacket)(isBinary ? data : $0736208648dc8bae$var$TEXT_DECODER.decode(data), binaryType));
                    state = 0 /* READ_HEADER */ ;
                }
                if (expectedLength === 0 || expectedLength > maxPayload) {
                    controller.enqueue((0, $fsDlh.ERROR_PACKET));
                    break;
                }
            }
        }
    });
}
const $0736208648dc8bae$export$a51d6b395ff4c65a = 4;

});
parcelRegister("bRHuL", function(module, exports) {

$parcel$export(module.exports, "encodePacket", () => $8a3662315a48cdbd$export$57852049361a8e62);
$parcel$export(module.exports, "encodePacketToBinary", () => $8a3662315a48cdbd$export$ec0c9b9013ee0ef5);

var $fsDlh = parcelRequire("fsDlh");
const $8a3662315a48cdbd$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
const $8a3662315a48cdbd$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
// ArrayBuffer.isView method is not defined in IE10
const $8a3662315a48cdbd$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
};
const $8a3662315a48cdbd$export$57852049361a8e62 = ({ type: type, data: data }, supportsBinary, callback)=>{
    if ($8a3662315a48cdbd$var$withNativeBlob && data instanceof Blob) {
        if (supportsBinary) return callback(data);
        else return $8a3662315a48cdbd$var$encodeBlobAsBase64(data, callback);
    } else if ($8a3662315a48cdbd$var$withNativeArrayBuffer && (data instanceof ArrayBuffer || $8a3662315a48cdbd$var$isView(data))) {
        if (supportsBinary) return callback(data);
        else return $8a3662315a48cdbd$var$encodeBlobAsBase64(new Blob([
            data
        ]), callback);
    }
    // plain string
    return callback((0, $fsDlh.PACKET_TYPES)[type] + (data || ""));
};
const $8a3662315a48cdbd$var$encodeBlobAsBase64 = (data, callback)=>{
    const fileReader = new FileReader();
    fileReader.onload = function() {
        const content = fileReader.result.split(",")[1];
        callback("b" + (content || ""));
    };
    return fileReader.readAsDataURL(data);
};
function $8a3662315a48cdbd$var$toArray(data) {
    if (data instanceof Uint8Array) return data;
    else if (data instanceof ArrayBuffer) return new Uint8Array(data);
    else return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
}
let $8a3662315a48cdbd$var$TEXT_ENCODER;
function $8a3662315a48cdbd$export$ec0c9b9013ee0ef5(packet, callback) {
    if ($8a3662315a48cdbd$var$withNativeBlob && packet.data instanceof Blob) return packet.data.arrayBuffer().then($8a3662315a48cdbd$var$toArray).then(callback);
    else if ($8a3662315a48cdbd$var$withNativeArrayBuffer && (packet.data instanceof ArrayBuffer || $8a3662315a48cdbd$var$isView(packet.data))) return callback($8a3662315a48cdbd$var$toArray(packet.data));
    $8a3662315a48cdbd$export$57852049361a8e62(packet, false, (encoded)=>{
        if (!$8a3662315a48cdbd$var$TEXT_ENCODER) $8a3662315a48cdbd$var$TEXT_ENCODER = new TextEncoder();
        callback($8a3662315a48cdbd$var$TEXT_ENCODER.encode(encoded));
    });
}

});
parcelRegister("fsDlh", function(module, exports) {

$parcel$export(module.exports, "PACKET_TYPES", () => $b417fd17fc84e4e3$export$c169aefb7330cccb);
$parcel$export(module.exports, "PACKET_TYPES_REVERSE", () => $b417fd17fc84e4e3$export$47791e8004edd485);
$parcel$export(module.exports, "ERROR_PACKET", () => $b417fd17fc84e4e3$export$c718b5840781f8a7);
const $b417fd17fc84e4e3$export$c169aefb7330cccb = Object.create(null); // no Map = no polyfill
$b417fd17fc84e4e3$export$c169aefb7330cccb["open"] = "0";
$b417fd17fc84e4e3$export$c169aefb7330cccb["close"] = "1";
$b417fd17fc84e4e3$export$c169aefb7330cccb["ping"] = "2";
$b417fd17fc84e4e3$export$c169aefb7330cccb["pong"] = "3";
$b417fd17fc84e4e3$export$c169aefb7330cccb["message"] = "4";
$b417fd17fc84e4e3$export$c169aefb7330cccb["upgrade"] = "5";
$b417fd17fc84e4e3$export$c169aefb7330cccb["noop"] = "6";
const $b417fd17fc84e4e3$export$47791e8004edd485 = Object.create(null);
Object.keys($b417fd17fc84e4e3$export$c169aefb7330cccb).forEach((key)=>{
    $b417fd17fc84e4e3$export$47791e8004edd485[$b417fd17fc84e4e3$export$c169aefb7330cccb[key]] = key;
});
const $b417fd17fc84e4e3$export$c718b5840781f8a7 = {
    type: "error",
    data: "parser error"
};

});


parcelRegister("ezyGD", function(module, exports) {

$parcel$export(module.exports, "decodePacket", () => $a9bf3da28855a34f$export$4647901878f33f31);

var $fsDlh = parcelRequire("fsDlh");

var $aVEkU = parcelRequire("aVEkU");
const $a9bf3da28855a34f$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $a9bf3da28855a34f$export$4647901878f33f31 = (encodedPacket, binaryType)=>{
    if (typeof encodedPacket !== "string") return {
        type: "message",
        data: $a9bf3da28855a34f$var$mapBinary(encodedPacket, binaryType)
    };
    const type = encodedPacket.charAt(0);
    if (type === "b") return {
        type: "message",
        data: $a9bf3da28855a34f$var$decodeBase64Packet(encodedPacket.substring(1), binaryType)
    };
    const packetType = (0, $fsDlh.PACKET_TYPES_REVERSE)[type];
    if (!packetType) return 0, $fsDlh.ERROR_PACKET;
    return encodedPacket.length > 1 ? {
        type: (0, $fsDlh.PACKET_TYPES_REVERSE)[type],
        data: encodedPacket.substring(1)
    } : {
        type: (0, $fsDlh.PACKET_TYPES_REVERSE)[type]
    };
};
const $a9bf3da28855a34f$var$decodeBase64Packet = (data, binaryType)=>{
    if ($a9bf3da28855a34f$var$withNativeArrayBuffer) {
        const decoded = (0, $aVEkU.decode)(data);
        return $a9bf3da28855a34f$var$mapBinary(decoded, binaryType);
    } else return {
        base64: true,
        data: data
    }; // fallback for old browsers
};
const $a9bf3da28855a34f$var$mapBinary = (data, binaryType)=>{
    switch(binaryType){
        case "blob":
            if (data instanceof Blob) // from WebSocket + binaryType "blob"
            return data;
            else // from HTTP long-polling or WebTransport
            return new Blob([
                data
            ]);
        case "arraybuffer":
        default:
            if (data instanceof ArrayBuffer) // from HTTP long-polling (base64) or WebSocket + binaryType "arraybuffer"
            return data;
            else // from WebTransport (Uint8Array)
            return data.buffer;
    }
};

});
parcelRegister("aVEkU", function(module, exports) {

$parcel$export(module.exports, "decode", () => $7f4e842ae29bcbc5$export$2f872c0f2117be69);
// imported from https://github.com/socketio/base64-arraybuffer
const $7f4e842ae29bcbc5$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
// Use a lookup table to find the index.
const $7f4e842ae29bcbc5$var$lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(let i = 0; i < $7f4e842ae29bcbc5$var$chars.length; i++)$7f4e842ae29bcbc5$var$lookup[$7f4e842ae29bcbc5$var$chars.charCodeAt(i)] = i;
const $7f4e842ae29bcbc5$export$c564cdbbe6da493 = (arraybuffer)=>{
    let bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = "";
    for(i = 0; i < len; i += 3){
        base64 += $7f4e842ae29bcbc5$var$chars[bytes[i] >> 2];
        base64 += $7f4e842ae29bcbc5$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $7f4e842ae29bcbc5$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $7f4e842ae29bcbc5$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
    return base64;
};
const $7f4e842ae29bcbc5$export$2f872c0f2117be69 = (base64)=>{
    let bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === "=") {
        bufferLength--;
        if (base64[base64.length - 2] === "=") bufferLength--;
    }
    const arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i = 0; i < len; i += 4){
        encoded1 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i)];
        encoded2 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};

});



parcelRegister("687to", function(module, exports) {

$parcel$export(module.exports, "Emitter", () => $8ff0082eecb39b62$export$4293555f241ae35a);
/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $8ff0082eecb39b62$export$4293555f241ae35a(obj) {
    if (obj) return $8ff0082eecb39b62$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $8ff0082eecb39b62$var$mixin(obj) {
    for(var key in $8ff0082eecb39b62$export$4293555f241ae35a.prototype)obj[key] = $8ff0082eecb39b62$export$4293555f241ae35a.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $8ff0082eecb39b62$export$4293555f241ae35a.prototype.on = $8ff0082eecb39b62$export$4293555f241ae35a.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks["$" + event] = this._callbacks["$" + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $8ff0082eecb39b62$export$4293555f241ae35a.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $8ff0082eecb39b62$export$4293555f241ae35a.prototype.off = $8ff0082eecb39b62$export$4293555f241ae35a.prototype.removeListener = $8ff0082eecb39b62$export$4293555f241ae35a.prototype.removeAllListeners = $8ff0082eecb39b62$export$4293555f241ae35a.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks["$" + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks["$" + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks["$" + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $8ff0082eecb39b62$export$4293555f241ae35a.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks["$" + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
// alias used for reserved events (protected method)
$8ff0082eecb39b62$export$4293555f241ae35a.prototype.emitReserved = $8ff0082eecb39b62$export$4293555f241ae35a.prototype.emit;
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $8ff0082eecb39b62$export$4293555f241ae35a.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks["$" + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $8ff0082eecb39b62$export$4293555f241ae35a.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};

});

parcelRegister("5vwdc", function(module, exports) {

$parcel$export(module.exports, "pick", () => $4028d5a20a4526d1$export$357523c63a2253b9);
$parcel$export(module.exports, "installTimerFunctions", () => $4028d5a20a4526d1$export$2f67576668b97183);
$parcel$export(module.exports, "byteLength", () => $4028d5a20a4526d1$export$a48f0734ac7c2329);

var $3kfWP = parcelRequire("3kfWP");
function $4028d5a20a4526d1$export$357523c63a2253b9(obj, ...attr) {
    return attr.reduce((acc, k)=>{
        if (obj.hasOwnProperty(k)) acc[k] = obj[k];
        return acc;
    }, {});
}
// Keep a reference to the real timeout functions so they can be used when overridden
const $4028d5a20a4526d1$var$NATIVE_SET_TIMEOUT = (0, $3kfWP.globalThisShim).setTimeout;
const $4028d5a20a4526d1$var$NATIVE_CLEAR_TIMEOUT = (0, $3kfWP.globalThisShim).clearTimeout;
function $4028d5a20a4526d1$export$2f67576668b97183(obj, opts) {
    if (opts.useNativeTimers) {
        obj.setTimeoutFn = $4028d5a20a4526d1$var$NATIVE_SET_TIMEOUT.bind((0, $3kfWP.globalThisShim));
        obj.clearTimeoutFn = $4028d5a20a4526d1$var$NATIVE_CLEAR_TIMEOUT.bind((0, $3kfWP.globalThisShim));
    } else {
        obj.setTimeoutFn = (0, $3kfWP.globalThisShim).setTimeout.bind((0, $3kfWP.globalThisShim));
        obj.clearTimeoutFn = (0, $3kfWP.globalThisShim).clearTimeout.bind((0, $3kfWP.globalThisShim));
    }
}
// base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
const $4028d5a20a4526d1$var$BASE64_OVERHEAD = 1.33;
function $4028d5a20a4526d1$export$a48f0734ac7c2329(obj) {
    if (typeof obj === "string") return $4028d5a20a4526d1$var$utf8Length(obj);
    // arraybuffer or blob
    return Math.ceil((obj.byteLength || obj.size) * $4028d5a20a4526d1$var$BASE64_OVERHEAD);
}
function $4028d5a20a4526d1$var$utf8Length(str) {
    let c = 0, length = 0;
    for(let i = 0, l = str.length; i < l; i++){
        c = str.charCodeAt(i);
        if (c < 0x80) length += 1;
        else if (c < 0x800) length += 2;
        else if (c < 0xd800 || c >= 0xe000) length += 3;
        else {
            i++;
            length += 4;
        }
    }
    return length;
}

});
parcelRegister("3kfWP", function(module, exports) {

$parcel$export(module.exports, "globalThisShim", () => $26bf9c4279db2ef0$export$394f9358f6231289);
const $26bf9c4279db2ef0$export$394f9358f6231289 = (()=>{
    if (typeof self !== "undefined") return self;
    else if (typeof window !== "undefined") return window;
    else return Function("return this")();
})();

});


parcelRegister("2buxl", function(module, exports) {

$parcel$export(module.exports, "encode", () => $19744bce3c183d10$export$c564cdbbe6da493);
$parcel$export(module.exports, "decode", () => $19744bce3c183d10$export$2f872c0f2117be69);
// imported from https://github.com/galkn/querystring
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */ function $19744bce3c183d10$export$c564cdbbe6da493(obj) {
    let str = "";
    for(let i in obj)if (obj.hasOwnProperty(i)) {
        if (str.length) str += "&";
        str += encodeURIComponent(i) + "=" + encodeURIComponent(obj[i]);
    }
    return str;
}
function $19744bce3c183d10$export$2f872c0f2117be69(qs) {
    let qry = {};
    let pairs = qs.split("&");
    for(let i = 0, l = pairs.length; i < l; i++){
        let pair = pairs[i].split("=");
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
}

});


parcelRegister("e3yjg", function(module, exports) {

$parcel$export(module.exports, "yeast", () => $a3bbf5b17719daf1$export$5bb64b92cb4135a);
// imported from https://github.com/unshiftio/yeast
"use strict";
const $a3bbf5b17719daf1$var$alphabet = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_".split(""), $a3bbf5b17719daf1$var$length = 64, $a3bbf5b17719daf1$var$map = {};
let $a3bbf5b17719daf1$var$seed = 0, $a3bbf5b17719daf1$var$i = 0, $a3bbf5b17719daf1$var$prev;
function $a3bbf5b17719daf1$export$c564cdbbe6da493(num) {
    let encoded = "";
    do {
        encoded = $a3bbf5b17719daf1$var$alphabet[num % $a3bbf5b17719daf1$var$length] + encoded;
        num = Math.floor(num / $a3bbf5b17719daf1$var$length);
    }while (num > 0);
    return encoded;
}
function $a3bbf5b17719daf1$export$2f872c0f2117be69(str) {
    let decoded = 0;
    for($a3bbf5b17719daf1$var$i = 0; $a3bbf5b17719daf1$var$i < str.length; $a3bbf5b17719daf1$var$i++)decoded = decoded * $a3bbf5b17719daf1$var$length + $a3bbf5b17719daf1$var$map[str.charAt($a3bbf5b17719daf1$var$i)];
    return decoded;
}
function $a3bbf5b17719daf1$export$5bb64b92cb4135a() {
    const now = $a3bbf5b17719daf1$export$c564cdbbe6da493(+new Date());
    if (now !== $a3bbf5b17719daf1$var$prev) return $a3bbf5b17719daf1$var$seed = 0, $a3bbf5b17719daf1$var$prev = now;
    return now + "." + $a3bbf5b17719daf1$export$c564cdbbe6da493($a3bbf5b17719daf1$var$seed++);
}
//
// Map each character to its index.
//
for(; $a3bbf5b17719daf1$var$i < $a3bbf5b17719daf1$var$length; $a3bbf5b17719daf1$var$i++)$a3bbf5b17719daf1$var$map[$a3bbf5b17719daf1$var$alphabet[$a3bbf5b17719daf1$var$i]] = $a3bbf5b17719daf1$var$i;

});

parcelRegister("lB1J3", function(module, exports) {

$parcel$export(module.exports, "XHR", () => $fb8e645f3bad3d56$export$a2d42eb087c10497);
$parcel$export(module.exports, "createCookieJar", () => $fb8e645f3bad3d56$export$19413efcf2fac759);
// browser shim for xmlhttprequest module

var $kxvpX = parcelRequire("kxvpX");

var $3kfWP = parcelRequire("3kfWP");
function $fb8e645f3bad3d56$export$a2d42eb087c10497(opts) {
    const xdomain = opts.xdomain;
    // XMLHttpRequest can be disabled on IE
    try {
        if ("undefined" !== typeof XMLHttpRequest && (!xdomain || (0, $kxvpX.hasCORS))) return new XMLHttpRequest();
    } catch (e) {}
    if (!xdomain) try {
        return new (0, $3kfWP.globalThisShim)[[
            "Active"
        ].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {}
}
function $fb8e645f3bad3d56$export$19413efcf2fac759() {}

});
parcelRegister("kxvpX", function(module, exports) {

$parcel$export(module.exports, "hasCORS", () => $ef3f42a25dd224af$export$5235bbd4a1ef06e);
// imported from https://github.com/component/has-cors
let $ef3f42a25dd224af$var$value = false;
try {
    $ef3f42a25dd224af$var$value = typeof XMLHttpRequest !== "undefined" && "withCredentials" in new XMLHttpRequest();
} catch (err) {
// if XMLHttp support is disabled in IE then it will throw
// when trying to create
}
const $ef3f42a25dd224af$export$5235bbd4a1ef06e = $ef3f42a25dd224af$var$value;

});



parcelRegister("dhyBt", function(module, exports) {

$parcel$export(module.exports, "WS", () => $9ab7b46a38551fa4$export$911baa0677ac404c);

var $6opKi = parcelRequire("6opKi");

var $e3yjg = parcelRequire("e3yjg");

var $5vwdc = parcelRequire("5vwdc");

var $cFgwF = parcelRequire("cFgwF");
parcelRequire("CnWUo");
var $bRHuL = parcelRequire("bRHuL");

var $6ZWSX = parcelRequire("6ZWSX");
var $9ab7b46a38551fa4$require$Buffer = $6ZWSX.Buffer;
// detect ReactNative environment
const $9ab7b46a38551fa4$var$isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
class $9ab7b46a38551fa4$export$911baa0677ac404c extends (0, $6opKi.Transport) {
    /**
     * WebSocket transport constructor.
     *
     * @param {Object} opts - connection options
     * @protected
     */ constructor(opts){
        super(opts);
        this.supportsBinary = !opts.forceBase64;
    }
    get name() {
        return "websocket";
    }
    doOpen() {
        if (!this.check()) // let probe timeout
        return;
        const uri = this.uri();
        const protocols = this.opts.protocols;
        // React Native only supports the 'headers' option, and will print a warning if anything else is passed
        const opts = $9ab7b46a38551fa4$var$isReactNative ? {} : (0, $5vwdc.pick)(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        if (this.opts.extraHeaders) opts.headers = this.opts.extraHeaders;
        try {
            this.ws = (0, $cFgwF.usingBrowserWebSocket) && !$9ab7b46a38551fa4$var$isReactNative ? protocols ? new (0, $cFgwF.WebSocket)(uri, protocols) : new (0, $cFgwF.WebSocket)(uri) : new (0, $cFgwF.WebSocket)(uri, protocols, opts);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this.ws.binaryType = this.socket.binaryType;
        this.addEventListeners();
    }
    /**
     * Adds event listeners to the socket
     *
     * @private
     */ addEventListeners() {
        this.ws.onopen = ()=>{
            if (this.opts.autoUnref) this.ws._socket.unref();
            this.onOpen();
        };
        this.ws.onclose = (closeEvent)=>this.onClose({
                description: "websocket connection closed",
                context: closeEvent
            });
        this.ws.onmessage = (ev)=>this.onData(ev.data);
        this.ws.onerror = (e)=>this.onError("websocket error", e);
    }
    write(packets) {
        this.writable = false;
        // encodePacket efficient as it uses WS framing
        // no need for encodePayload
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            (0, $bRHuL.encodePacket)(packet, this.supportsBinary, (data)=>{
                // always create a new object (GH-437)
                const opts = {};
                if (!(0, $cFgwF.usingBrowserWebSocket)) {
                    if (packet.options) opts.compress = packet.options.compress;
                    if (this.opts.perMessageDeflate) {
                        const len = // @ts-ignore
                        "string" === typeof data ? $9ab7b46a38551fa4$require$Buffer.byteLength(data) : data.length;
                        if (len < this.opts.perMessageDeflate.threshold) opts.compress = false;
                    }
                }
                // Sometimes the websocket has already been closed but the browser didn't
                // have a chance of informing us about it yet, in that case send will
                // throw an error
                try {
                    if (0, $cFgwF.usingBrowserWebSocket) // TypeError is thrown when passing the second argument on Safari
                    this.ws.send(data);
                    else this.ws.send(data, opts);
                } catch (e) {}
                if (lastPacket) // fake drain
                // defer to next tick to allow Socket to clear writeBuffer
                (0, $cFgwF.nextTick)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        if (typeof this.ws !== "undefined") {
            this.ws.close();
            this.ws = null;
        }
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "wss" : "ws";
        const query = this.query || {};
        // append timestamp to URI
        if (this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $e3yjg.yeast)();
        // communicate binary support capabilities
        if (!this.supportsBinary) query.b64 = 1;
        return this.createUri(schema, query);
    }
    /**
     * Feature detection for WebSocket.
     *
     * @return {Boolean} whether this transport is available.
     * @private
     */ check() {
        return !!(0, $cFgwF.WebSocket);
    }
}

});
parcelRegister("cFgwF", function(module, exports) {

$parcel$export(module.exports, "nextTick", () => $93862213c34af1ff$export$bdd553fddd433dcb);
$parcel$export(module.exports, "WebSocket", () => $93862213c34af1ff$export$3909fb301d3dc8c9);
$parcel$export(module.exports, "usingBrowserWebSocket", () => $93862213c34af1ff$export$3407ba5dfb7a683d);
$parcel$export(module.exports, "defaultBinaryType", () => $93862213c34af1ff$export$790dcbc41e2d75d5);

var $3kfWP = parcelRequire("3kfWP");
const $93862213c34af1ff$export$bdd553fddd433dcb = (()=>{
    const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) return (cb)=>Promise.resolve().then(cb);
    else return (cb, setTimeoutFn)=>setTimeoutFn(cb, 0);
})();
const $93862213c34af1ff$export$3909fb301d3dc8c9 = (0, $3kfWP.globalThisShim).WebSocket || (0, $3kfWP.globalThisShim).MozWebSocket;
const $93862213c34af1ff$export$3407ba5dfb7a683d = true;
const $93862213c34af1ff$export$790dcbc41e2d75d5 = "arraybuffer";

});

parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("hJTtX", function(module, exports) {

$parcel$export(module.exports, "WT", () => $cea1ad415a07b478$export$961c930859384407);

var $6opKi = parcelRequire("6opKi");

var $cFgwF = parcelRequire("cFgwF");

var $CnWUo = parcelRequire("CnWUo");
class $cea1ad415a07b478$export$961c930859384407 extends (0, $6opKi.Transport) {
    get name() {
        return "webtransport";
    }
    doOpen() {
        // @ts-ignore
        if (typeof WebTransport !== "function") return;
        // @ts-ignore
        this.transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
        this.transport.closed.then(()=>{
            this.onClose();
        }).catch((err)=>{
            this.onError("webtransport error", err);
        });
        // note: we could have used async/await, but that would require some additional polyfills
        this.transport.ready.then(()=>{
            this.transport.createBidirectionalStream().then((stream)=>{
                const decoderStream = (0, $CnWUo.createPacketDecoderStream)(Number.MAX_SAFE_INTEGER, this.socket.binaryType);
                const reader = stream.readable.pipeThrough(decoderStream).getReader();
                const encoderStream = (0, $CnWUo.createPacketEncoderStream)();
                encoderStream.readable.pipeTo(stream.writable);
                this.writer = encoderStream.writable.getWriter();
                const read = ()=>{
                    reader.read().then(({ done: done, value: value })=>{
                        if (done) return;
                        this.onPacket(value);
                        read();
                    }).catch((err)=>{});
                };
                read();
                const packet = {
                    type: "open"
                };
                if (this.query.sid) packet.data = `{"sid":"${this.query.sid}"}`;
                this.writer.write(packet).then(()=>this.onOpen());
            });
        });
    }
    write(packets) {
        this.writable = false;
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            this.writer.write(packet).then(()=>{
                if (lastPacket) (0, $cFgwF.nextTick)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        var _a;
        (_a = this.transport) === null || _a === void 0 || _a.close();
    }
}

});


parcelRegister("l7wSz", function(module, exports) {

$parcel$export(module.exports, "parse", () => $f603c1892ffe9e8b$export$98e6a39c04603d36);
// imported from https://github.com/galkn/parseuri
/**
 * Parses a URI
 *
 * Note: we could also have used the built-in URL object, but it isn't supported on all platforms.
 *
 * See:
 * - https://developer.mozilla.org/en-US/docs/Web/API/URL
 * - https://caniuse.com/url
 * - https://www.rfc-editor.org/rfc/rfc3986#appendix-B
 *
 * History of the parse() method:
 * - first commit: https://github.com/socketio/socket.io-client/commit/4ee1d5d94b3906a9c052b459f1a818b15f38f91c
 * - export into its own module: https://github.com/socketio/engine.io-client/commit/de2c561e4564efeb78f1bdb1ba39ef81b2822cb3
 * - reimport: https://github.com/socketio/engine.io-client/commit/df32277c3f6d622eec5ed09f493cae3f3391d242
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */ const $f603c1892ffe9e8b$var$re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
const $f603c1892ffe9e8b$var$parts = [
    "source",
    "protocol",
    "authority",
    "userInfo",
    "user",
    "password",
    "host",
    "port",
    "relative",
    "path",
    "directory",
    "file",
    "query",
    "anchor"
];
function $f603c1892ffe9e8b$export$98e6a39c04603d36(str) {
    if (str.length > 2000) throw "URI too long";
    const src = str, b = str.indexOf("["), e = str.indexOf("]");
    if (b != -1 && e != -1) str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ";") + str.substring(e, str.length);
    let m = $f603c1892ffe9e8b$var$re.exec(str || ""), uri = {}, i = 14;
    while(i--)uri[$f603c1892ffe9e8b$var$parts[i]] = m[i] || "";
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ":");
        uri.authority = uri.authority.replace("[", "").replace("]", "").replace(/;/g, ":");
        uri.ipv6uri = true;
    }
    uri.pathNames = $f603c1892ffe9e8b$var$pathNames(uri, uri["path"]);
    uri.queryKey = $f603c1892ffe9e8b$var$queryKey(uri, uri["query"]);
    return uri;
}
function $f603c1892ffe9e8b$var$pathNames(obj, path) {
    const regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.slice(0, 1) == "/" || path.length === 0) names.splice(0, 1);
    if (path.slice(-1) == "/") names.splice(names.length - 1, 1);
    return names;
}
function $f603c1892ffe9e8b$var$queryKey(uri, query) {
    const data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
        if ($1) data[$1] = $2;
    });
    return data;
}

});




parcelRegister("fL4YY", function(module, exports) {

$parcel$export(module.exports, "Manager", () => $b78f1c3cb524f77d$export$d0d38e7dec7a1a61);
parcelRequire("1XKMK");
var $5vwdc = parcelRequire("5vwdc");
var $cFgwF = parcelRequire("cFgwF");
var $al9N3 = parcelRequire("al9N3");

var $lGX0c = parcelRequire("lGX0c");

var $2BjQv = parcelRequire("2BjQv");

var $vPX8d = parcelRequire("vPX8d");

var $5pEXn = parcelRequire("5pEXn");

var $687to = parcelRequire("687to");
class $b78f1c3cb524f77d$export$d0d38e7dec7a1a61 extends (0, $687to.Emitter) {
    constructor(uri, opts){
        var _a;
        super();
        this.nsps = {};
        this.subs = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = undefined;
        }
        opts = opts || {};
        opts.path = opts.path || "/socket.io";
        this.opts = opts;
        (0, $5vwdc.installTimerFunctions)(this, opts);
        this.reconnection(opts.reconnection !== false);
        this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
        this.reconnectionDelay(opts.reconnectionDelay || 1000);
        this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
        this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
        this.backoff = new (0, $5pEXn.Backoff)({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor()
        });
        this.timeout(null == opts.timeout ? 20000 : opts.timeout);
        this._readyState = "closed";
        this.uri = uri;
        const _parser = opts.parser || $2BjQv;
        this.encoder = new _parser.Encoder();
        this.decoder = new _parser.Decoder();
        this._autoConnect = opts.autoConnect !== false;
        if (this._autoConnect) this.open();
    }
    reconnection(v) {
        if (!arguments.length) return this._reconnection;
        this._reconnection = !!v;
        return this;
    }
    reconnectionAttempts(v) {
        if (v === undefined) return this._reconnectionAttempts;
        this._reconnectionAttempts = v;
        return this;
    }
    reconnectionDelay(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelay;
        this._reconnectionDelay = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMin(v);
        return this;
    }
    randomizationFactor(v) {
        var _a;
        if (v === undefined) return this._randomizationFactor;
        this._randomizationFactor = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setJitter(v);
        return this;
    }
    reconnectionDelayMax(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelayMax;
        this._reconnectionDelayMax = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMax(v);
        return this;
    }
    timeout(v) {
        if (!arguments.length) return this._timeout;
        this._timeout = v;
        return this;
    }
    /**
     * Starts trying to reconnect if reconnection is enabled and we have not
     * started reconnecting yet
     *
     * @private
     */ maybeReconnectOnOpen() {
        // Only try to reconnect if it's the first time we're connecting
        if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) // keeps reconnection from firing twice for the same reconnection loop
        this.reconnect();
    }
    /**
     * Sets the current transport `socket`.
     *
     * @param {Function} fn - optional, callback
     * @return self
     * @public
     */ open(fn) {
        if (~this._readyState.indexOf("open")) return this;
        this.engine = new (0, $al9N3.Socket)(this.uri, this.opts);
        const socket = this.engine;
        const self = this;
        this._readyState = "opening";
        this.skipReconnect = false;
        // emit `open`
        const openSubDestroy = (0, $vPX8d.on)(socket, "open", function() {
            self.onopen();
            fn && fn();
        });
        const onError = (err)=>{
            this.cleanup();
            this._readyState = "closed";
            this.emitReserved("error", err);
            if (fn) fn(err);
            else // Only do this if there is no fn to handle the error
            this.maybeReconnectOnOpen();
        };
        // emit `error`
        const errorSub = (0, $vPX8d.on)(socket, "error", onError);
        if (false !== this._timeout) {
            const timeout = this._timeout;
            // set timer
            const timer = this.setTimeoutFn(()=>{
                openSubDestroy();
                onError(new Error("timeout"));
                socket.close();
            }, timeout);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
        this.subs.push(openSubDestroy);
        this.subs.push(errorSub);
        return this;
    }
    /**
     * Alias for open()
     *
     * @return self
     * @public
     */ connect(fn) {
        return this.open(fn);
    }
    /**
     * Called upon transport open.
     *
     * @private
     */ onopen() {
        // clear old subs
        this.cleanup();
        // mark as open
        this._readyState = "open";
        this.emitReserved("open");
        // add new subs
        const socket = this.engine;
        this.subs.push((0, $vPX8d.on)(socket, "ping", this.onping.bind(this)), (0, $vPX8d.on)(socket, "data", this.ondata.bind(this)), (0, $vPX8d.on)(socket, "error", this.onerror.bind(this)), (0, $vPX8d.on)(socket, "close", this.onclose.bind(this)), (0, $vPX8d.on)(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
     * Called upon a ping.
     *
     * @private
     */ onping() {
        this.emitReserved("ping");
    }
    /**
     * Called with data.
     *
     * @private
     */ ondata(data) {
        try {
            this.decoder.add(data);
        } catch (e) {
            this.onclose("parse error", e);
        }
    }
    /**
     * Called when parser fully decodes a packet.
     *
     * @private
     */ ondecoded(packet) {
        // the nextTick call prevents an exception in a user-provided event listener from triggering a disconnection due to a "parse error"
        (0, $cFgwF.nextTick)(()=>{
            this.emitReserved("packet", packet);
        }, this.setTimeoutFn);
    }
    /**
     * Called upon socket error.
     *
     * @private
     */ onerror(err) {
        this.emitReserved("error", err);
    }
    /**
     * Creates a new socket for the given `nsp`.
     *
     * @return {Socket}
     * @public
     */ socket(nsp, opts) {
        let socket = this.nsps[nsp];
        if (!socket) {
            socket = new (0, $lGX0c.Socket)(this, nsp, opts);
            this.nsps[nsp] = socket;
        } else if (this._autoConnect && !socket.active) socket.connect();
        return socket;
    }
    /**
     * Called upon a socket close.
     *
     * @param socket
     * @private
     */ _destroy(socket) {
        const nsps = Object.keys(this.nsps);
        for (const nsp of nsps){
            const socket = this.nsps[nsp];
            if (socket.active) return;
        }
        this._close();
    }
    /**
     * Writes a packet.
     *
     * @param packet
     * @private
     */ _packet(packet) {
        const encodedPackets = this.encoder.encode(packet);
        for(let i = 0; i < encodedPackets.length; i++)this.engine.write(encodedPackets[i], packet.options);
    }
    /**
     * Clean up transport subscriptions and packet buffer.
     *
     * @private
     */ cleanup() {
        this.subs.forEach((subDestroy)=>subDestroy());
        this.subs.length = 0;
        this.decoder.destroy();
    }
    /**
     * Close the current socket.
     *
     * @private
     */ _close() {
        this.skipReconnect = true;
        this._reconnecting = false;
        this.onclose("forced close");
        if (this.engine) this.engine.close();
    }
    /**
     * Alias for close()
     *
     * @private
     */ disconnect() {
        return this._close();
    }
    /**
     * Called upon engine close.
     *
     * @private
     */ onclose(reason, description) {
        this.cleanup();
        this.backoff.reset();
        this._readyState = "closed";
        this.emitReserved("close", reason, description);
        if (this._reconnection && !this.skipReconnect) this.reconnect();
    }
    /**
     * Attempt a reconnection.
     *
     * @private
     */ reconnect() {
        if (this._reconnecting || this.skipReconnect) return this;
        const self = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) {
            this.backoff.reset();
            this.emitReserved("reconnect_failed");
            this._reconnecting = false;
        } else {
            const delay = this.backoff.duration();
            this._reconnecting = true;
            const timer = this.setTimeoutFn(()=>{
                if (self.skipReconnect) return;
                this.emitReserved("reconnect_attempt", self.backoff.attempts);
                // check again for the case socket closed in above events
                if (self.skipReconnect) return;
                self.open((err)=>{
                    if (err) {
                        self._reconnecting = false;
                        self.reconnect();
                        this.emitReserved("reconnect_error", err);
                    } else self.onreconnect();
                });
            }, delay);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
    }
    /**
     * Called upon successful reconnect.
     *
     * @private
     */ onreconnect() {
        const attempt = this.backoff.attempts;
        this._reconnecting = false;
        this.backoff.reset();
        this.emitReserved("reconnect", attempt);
    }
}

});
parcelRegister("lGX0c", function(module, exports) {

$parcel$export(module.exports, "Socket", () => $fcab49da21a6222a$export$4798917dbf149b79);

var $2BjQv = parcelRequire("2BjQv");

var $vPX8d = parcelRequire("vPX8d");

var $687to = parcelRequire("687to");
/**
 * Internal events.
 * These events can't be emitted by the user.
 */ const $fcab49da21a6222a$var$RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1
});
class $fcab49da21a6222a$export$4798917dbf149b79 extends (0, $687to.Emitter) {
    /**
     * `Socket` constructor.
     */ constructor(io, nsp, opts){
        super();
        /**
         * Whether the socket is currently connected to the server.
         *
         * @example
         * const socket = io();
         *
         * socket.on("connect", () => {
         *   console.log(socket.connected); // true
         * });
         *
         * socket.on("disconnect", () => {
         *   console.log(socket.connected); // false
         * });
         */ this.connected = false;
        /**
         * Whether the connection state was recovered after a temporary disconnection. In that case, any missed packets will
         * be transmitted by the server.
         */ this.recovered = false;
        /**
         * Buffer for packets received before the CONNECT packet
         */ this.receiveBuffer = [];
        /**
         * Buffer for packets that will be sent once the socket is connected
         */ this.sendBuffer = [];
        /**
         * The queue of packets to be sent with retry in case of failure.
         *
         * Packets are sent one by one, each waiting for the server acknowledgement, in order to guarantee the delivery order.
         * @private
         */ this._queue = [];
        /**
         * A sequence to generate the ID of the {@link QueuedPacket}.
         * @private
         */ this._queueSeq = 0;
        this.ids = 0;
        this.acks = {};
        this.flags = {};
        this.io = io;
        this.nsp = nsp;
        if (opts && opts.auth) this.auth = opts.auth;
        this._opts = Object.assign({}, opts);
        if (this.io._autoConnect) this.open();
    }
    /**
     * Whether the socket is currently disconnected
     *
     * @example
     * const socket = io();
     *
     * socket.on("connect", () => {
     *   console.log(socket.disconnected); // false
     * });
     *
     * socket.on("disconnect", () => {
     *   console.log(socket.disconnected); // true
     * });
     */ get disconnected() {
        return !this.connected;
    }
    /**
     * Subscribe to open, close and packet events
     *
     * @private
     */ subEvents() {
        if (this.subs) return;
        const io = this.io;
        this.subs = [
            (0, $vPX8d.on)(io, "open", this.onopen.bind(this)),
            (0, $vPX8d.on)(io, "packet", this.onpacket.bind(this)),
            (0, $vPX8d.on)(io, "error", this.onerror.bind(this)),
            (0, $vPX8d.on)(io, "close", this.onclose.bind(this))
        ];
    }
    /**
     * Whether the Socket will try to reconnect when its Manager connects or reconnects.
     *
     * @example
     * const socket = io();
     *
     * console.log(socket.active); // true
     *
     * socket.on("disconnect", (reason) => {
     *   if (reason === "io server disconnect") {
     *     // the disconnection was initiated by the server, you need to manually reconnect
     *     console.log(socket.active); // false
     *   }
     *   // else the socket will automatically try to reconnect
     *   console.log(socket.active); // true
     * });
     */ get active() {
        return !!this.subs;
    }
    /**
     * "Opens" the socket.
     *
     * @example
     * const socket = io({
     *   autoConnect: false
     * });
     *
     * socket.connect();
     */ connect() {
        if (this.connected) return this;
        this.subEvents();
        if (!this.io["_reconnecting"]) this.io.open(); // ensure open
        if ("open" === this.io._readyState) this.onopen();
        return this;
    }
    /**
     * Alias for {@link connect()}.
     */ open() {
        return this.connect();
    }
    /**
     * Sends a `message` event.
     *
     * This method mimics the WebSocket.send() method.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
     *
     * @example
     * socket.send("hello");
     *
     * // this is equivalent to
     * socket.emit("message", "hello");
     *
     * @return self
     */ send(...args) {
        args.unshift("message");
        this.emit.apply(this, args);
        return this;
    }
    /**
     * Override `emit`.
     * If the event is in `events`, it's emitted normally.
     *
     * @example
     * socket.emit("hello", "world");
     *
     * // all serializable datastructures are supported (no need to call JSON.stringify)
     * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
     *
     * // with an acknowledgement from the server
     * socket.emit("hello", "world", (val) => {
     *   // ...
     * });
     *
     * @return self
     */ emit(ev, ...args) {
        if ($fcab49da21a6222a$var$RESERVED_EVENTS.hasOwnProperty(ev)) throw new Error('"' + ev.toString() + '" is a reserved event name');
        args.unshift(ev);
        if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
            this._addToQueue(args);
            return this;
        }
        const packet = {
            type: (0, $2BjQv.PacketType).EVENT,
            data: args
        };
        packet.options = {};
        packet.options.compress = this.flags.compress !== false;
        // event ack callback
        if ("function" === typeof args[args.length - 1]) {
            const id = this.ids++;
            const ack = args.pop();
            this._registerAckCallback(id, ack);
            packet.id = id;
        }
        const isTransportWritable = this.io.engine && this.io.engine.transport && this.io.engine.transport.writable;
        const discardPacket = this.flags.volatile && (!isTransportWritable || !this.connected);
        if (discardPacket) ;
        else if (this.connected) {
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        } else this.sendBuffer.push(packet);
        this.flags = {};
        return this;
    }
    /**
     * @private
     */ _registerAckCallback(id, ack) {
        var _a;
        const timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
        if (timeout === undefined) {
            this.acks[id] = ack;
            return;
        }
        // @ts-ignore
        const timer = this.io.setTimeoutFn(()=>{
            delete this.acks[id];
            for(let i = 0; i < this.sendBuffer.length; i++)if (this.sendBuffer[i].id === id) this.sendBuffer.splice(i, 1);
            ack.call(this, new Error("operation has timed out"));
        }, timeout);
        this.acks[id] = (...args)=>{
            // @ts-ignore
            this.io.clearTimeoutFn(timer);
            ack.apply(this, [
                null,
                ...args
            ]);
        };
    }
    /**
     * Emits an event and waits for an acknowledgement
     *
     * @example
     * // without timeout
     * const response = await socket.emitWithAck("hello", "world");
     *
     * // with a specific timeout
     * try {
     *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
     * } catch (err) {
     *   // the server did not acknowledge the event in the given delay
     * }
     *
     * @return a Promise that will be fulfilled when the server acknowledges the event
     */ emitWithAck(ev, ...args) {
        // the timeout flag is optional
        const withErr = this.flags.timeout !== undefined || this._opts.ackTimeout !== undefined;
        return new Promise((resolve, reject)=>{
            args.push((arg1, arg2)=>{
                if (withErr) return arg1 ? reject(arg1) : resolve(arg2);
                else return resolve(arg1);
            });
            this.emit(ev, ...args);
        });
    }
    /**
     * Add the packet to the queue.
     * @param args
     * @private
     */ _addToQueue(args) {
        let ack;
        if (typeof args[args.length - 1] === "function") ack = args.pop();
        const packet = {
            id: this._queueSeq++,
            tryCount: 0,
            pending: false,
            args: args,
            flags: Object.assign({
                fromQueue: true
            }, this.flags)
        };
        args.push((err, ...responseArgs)=>{
            if (packet !== this._queue[0]) // the packet has already been acknowledged
            return;
            const hasError = err !== null;
            if (hasError) {
                if (packet.tryCount > this._opts.retries) {
                    this._queue.shift();
                    if (ack) ack(err);
                }
            } else {
                this._queue.shift();
                if (ack) ack(null, ...responseArgs);
            }
            packet.pending = false;
            return this._drainQueue();
        });
        this._queue.push(packet);
        this._drainQueue();
    }
    /**
     * Send the first packet of the queue, and wait for an acknowledgement from the server.
     * @param force - whether to resend a packet that has not been acknowledged yet
     *
     * @private
     */ _drainQueue(force = false) {
        if (!this.connected || this._queue.length === 0) return;
        const packet = this._queue[0];
        if (packet.pending && !force) return;
        packet.pending = true;
        packet.tryCount++;
        this.flags = packet.flags;
        this.emit.apply(this, packet.args);
    }
    /**
     * Sends a packet.
     *
     * @param packet
     * @private
     */ packet(packet) {
        packet.nsp = this.nsp;
        this.io._packet(packet);
    }
    /**
     * Called upon engine `open`.
     *
     * @private
     */ onopen() {
        if (typeof this.auth == "function") this.auth((data)=>{
            this._sendConnectPacket(data);
        });
        else this._sendConnectPacket(this.auth);
    }
    /**
     * Sends a CONNECT packet to initiate the Socket.IO session.
     *
     * @param data
     * @private
     */ _sendConnectPacket(data) {
        this.packet({
            type: (0, $2BjQv.PacketType).CONNECT,
            data: this._pid ? Object.assign({
                pid: this._pid,
                offset: this._lastOffset
            }, data) : data
        });
    }
    /**
     * Called upon engine or manager `error`.
     *
     * @param err
     * @private
     */ onerror(err) {
        if (!this.connected) this.emitReserved("connect_error", err);
    }
    /**
     * Called upon engine `close`.
     *
     * @param reason
     * @param description
     * @private
     */ onclose(reason, description) {
        this.connected = false;
        delete this.id;
        this.emitReserved("disconnect", reason, description);
    }
    /**
     * Called with socket packet.
     *
     * @param packet
     * @private
     */ onpacket(packet) {
        const sameNamespace = packet.nsp === this.nsp;
        if (!sameNamespace) return;
        switch(packet.type){
            case (0, $2BjQv.PacketType).CONNECT:
                if (packet.data && packet.data.sid) this.onconnect(packet.data.sid, packet.data.pid);
                else this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                break;
            case (0, $2BjQv.PacketType).EVENT:
            case (0, $2BjQv.PacketType).BINARY_EVENT:
                this.onevent(packet);
                break;
            case (0, $2BjQv.PacketType).ACK:
            case (0, $2BjQv.PacketType).BINARY_ACK:
                this.onack(packet);
                break;
            case (0, $2BjQv.PacketType).DISCONNECT:
                this.ondisconnect();
                break;
            case (0, $2BjQv.PacketType).CONNECT_ERROR:
                this.destroy();
                const err = new Error(packet.data.message);
                // @ts-ignore
                err.data = packet.data.data;
                this.emitReserved("connect_error", err);
                break;
        }
    }
    /**
     * Called upon a server event.
     *
     * @param packet
     * @private
     */ onevent(packet) {
        const args = packet.data || [];
        if (null != packet.id) args.push(this.ack(packet.id));
        if (this.connected) this.emitEvent(args);
        else this.receiveBuffer.push(Object.freeze(args));
    }
    emitEvent(args) {
        if (this._anyListeners && this._anyListeners.length) {
            const listeners = this._anyListeners.slice();
            for (const listener of listeners)listener.apply(this, args);
        }
        super.emit.apply(this, args);
        if (this._pid && args.length && typeof args[args.length - 1] === "string") this._lastOffset = args[args.length - 1];
    }
    /**
     * Produces an ack callback to emit with an event.
     *
     * @private
     */ ack(id) {
        const self = this;
        let sent = false;
        return function(...args) {
            // prevent double callbacks
            if (sent) return;
            sent = true;
            self.packet({
                type: (0, $2BjQv.PacketType).ACK,
                id: id,
                data: args
            });
        };
    }
    /**
     * Called upon a server acknowlegement.
     *
     * @param packet
     * @private
     */ onack(packet) {
        const ack = this.acks[packet.id];
        if ("function" === typeof ack) {
            ack.apply(this, packet.data);
            delete this.acks[packet.id];
        }
    }
    /**
     * Called upon server connect.
     *
     * @private
     */ onconnect(id, pid) {
        this.id = id;
        this.recovered = pid && this._pid === pid;
        this._pid = pid; // defined only if connection state recovery is enabled
        this.connected = true;
        this.emitBuffered();
        this.emitReserved("connect");
        this._drainQueue(true);
    }
    /**
     * Emit buffered events (received and emitted).
     *
     * @private
     */ emitBuffered() {
        this.receiveBuffer.forEach((args)=>this.emitEvent(args));
        this.receiveBuffer = [];
        this.sendBuffer.forEach((packet)=>{
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        });
        this.sendBuffer = [];
    }
    /**
     * Called upon server disconnect.
     *
     * @private
     */ ondisconnect() {
        this.destroy();
        this.onclose("io server disconnect");
    }
    /**
     * Called upon forced client/server side disconnections,
     * this method ensures the manager stops tracking us and
     * that reconnections don't get triggered for this.
     *
     * @private
     */ destroy() {
        if (this.subs) {
            // clean subscriptions to avoid reconnections
            this.subs.forEach((subDestroy)=>subDestroy());
            this.subs = undefined;
        }
        this.io["_destroy"](this);
    }
    /**
     * Disconnects the socket manually. In that case, the socket will not try to reconnect.
     *
     * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
     *
     * @example
     * const socket = io();
     *
     * socket.on("disconnect", (reason) => {
     *   // console.log(reason); prints "io client disconnect"
     * });
     *
     * socket.disconnect();
     *
     * @return self
     */ disconnect() {
        if (this.connected) this.packet({
            type: (0, $2BjQv.PacketType).DISCONNECT
        });
        // remove socket from pool
        this.destroy();
        if (this.connected) // fire events
        this.onclose("io client disconnect");
        return this;
    }
    /**
     * Alias for {@link disconnect()}.
     *
     * @return self
     */ close() {
        return this.disconnect();
    }
    /**
     * Sets the compress flag.
     *
     * @example
     * socket.compress(false).emit("hello");
     *
     * @param compress - if `true`, compresses the sending data
     * @return self
     */ compress(compress) {
        this.flags.compress = compress;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
     * ready to send messages.
     *
     * @example
     * socket.volatile.emit("hello"); // the server may or may not receive it
     *
     * @returns self
     */ get volatile() {
        this.flags.volatile = true;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
     * given number of milliseconds have elapsed without an acknowledgement from the server:
     *
     * @example
     * socket.timeout(5000).emit("my-event", (err) => {
     *   if (err) {
     *     // the server did not acknowledge the event in the given delay
     *   }
     * });
     *
     * @returns self
     */ timeout(timeout) {
        this.flags.timeout = timeout;
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * @example
     * socket.onAny((event, ...args) => {
     *   console.log(`got ${event}`);
     * });
     *
     * @param listener
     */ onAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * @example
     * socket.prependAny((event, ...args) => {
     *   console.log(`got event ${event}`);
     * });
     *
     * @param listener
     */ prependAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`got event ${event}`);
     * }
     *
     * socket.onAny(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAny(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAny();
     *
     * @param listener
     */ offAny(listener) {
        if (!this._anyListeners) return this;
        if (listener) {
            const listeners = this._anyListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAny() {
        return this._anyListeners || [];
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.onAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ onAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.prependAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ prependAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`sent event ${event}`);
     * }
     *
     * socket.onAnyOutgoing(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAnyOutgoing(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAnyOutgoing();
     *
     * @param [listener] - the catch-all listener (optional)
     */ offAnyOutgoing(listener) {
        if (!this._anyOutgoingListeners) return this;
        if (listener) {
            const listeners = this._anyOutgoingListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyOutgoingListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAnyOutgoing() {
        return this._anyOutgoingListeners || [];
    }
    /**
     * Notify the listeners for each packet sent
     *
     * @param packet
     *
     * @private
     */ notifyOutgoingListeners(packet) {
        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            const listeners = this._anyOutgoingListeners.slice();
            for (const listener of listeners)listener.apply(this, packet.data);
        }
    }
}

});
parcelRegister("2BjQv", function(module, exports) {

$parcel$export(module.exports, "protocol", () => $1e4e6e6cc3958162$export$a51d6b395ff4c65a);
$parcel$export(module.exports, "PacketType", () => $1e4e6e6cc3958162$export$84d4095e16c6fc19);
$parcel$export(module.exports, "Encoder", () => $1e4e6e6cc3958162$export$a50aceb0e02a00aa);
$parcel$export(module.exports, "Decoder", () => $1e4e6e6cc3958162$export$f9de6ca0bc043724);

var $687to = parcelRequire("687to");

var $8URBv = parcelRequire("8URBv");

var $eGKCF = parcelRequire("eGKCF");
/**
 * These strings must not be used as event names, as they have a special meaning.
 */ const $1e4e6e6cc3958162$var$RESERVED_EVENTS = [
    "connect",
    "connect_error",
    "disconnect",
    "disconnecting",
    "newListener",
    "removeListener"
];
const $1e4e6e6cc3958162$export$a51d6b395ff4c65a = 5;
var $1e4e6e6cc3958162$export$84d4095e16c6fc19;
(function(PacketType) {
    PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
    PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
    PacketType[PacketType["EVENT"] = 2] = "EVENT";
    PacketType[PacketType["ACK"] = 3] = "ACK";
    PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
    PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
    PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
})($1e4e6e6cc3958162$export$84d4095e16c6fc19 || ($1e4e6e6cc3958162$export$84d4095e16c6fc19 = {}));
class $1e4e6e6cc3958162$export$a50aceb0e02a00aa {
    /**
     * Encoder constructor
     *
     * @param {function} replacer - custom replacer to pass down to JSON.parse
     */ constructor(replacer){
        this.replacer = replacer;
    }
    /**
     * Encode a packet as a single string if non-binary, or as a
     * buffer sequence, depending on packet type.
     *
     * @param {Object} obj - packet object
     */ encode(obj) {
        if (obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT || obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.ACK) {
            if ((0, $eGKCF.hasBinary)(obj)) return this.encodeAsBinary({
                type: obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT ? $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT : $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK,
                nsp: obj.nsp,
                data: obj.data,
                id: obj.id
            });
        }
        return [
            this.encodeAsString(obj)
        ];
    }
    /**
     * Encode packet as string.
     */ encodeAsString(obj) {
        // first is type
        let str = "" + obj.type;
        // attachments if we have them
        if (obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT || obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK) str += obj.attachments + "-";
        // if we have a namespace other than `/`
        // we append it followed by a comma `,`
        if (obj.nsp && "/" !== obj.nsp) str += obj.nsp + ",";
        // immediately followed by the id
        if (null != obj.id) str += obj.id;
        // json data
        if (null != obj.data) str += JSON.stringify(obj.data, this.replacer);
        return str;
    }
    /**
     * Encode packet as 'buffer sequence' by removing blobs, and
     * deconstructing packet into object with placeholders and
     * a list of buffers.
     */ encodeAsBinary(obj) {
        const deconstruction = (0, $8URBv.deconstructPacket)(obj);
        const pack = this.encodeAsString(deconstruction.packet);
        const buffers = deconstruction.buffers;
        buffers.unshift(pack); // add packet info to beginning of data list
        return buffers; // write all the buffers
    }
}
// see https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
function $1e4e6e6cc3958162$var$isObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}
class $1e4e6e6cc3958162$export$f9de6ca0bc043724 extends (0, $687to.Emitter) {
    /**
     * Decoder constructor
     *
     * @param {function} reviver - custom reviver to pass down to JSON.stringify
     */ constructor(reviver){
        super();
        this.reviver = reviver;
    }
    /**
     * Decodes an encoded packet string into packet JSON.
     *
     * @param {String} obj - encoded packet
     */ add(obj) {
        let packet;
        if (typeof obj === "string") {
            if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
            packet = this.decodeString(obj);
            const isBinaryEvent = packet.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT;
            if (isBinaryEvent || packet.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK) {
                packet.type = isBinaryEvent ? $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT : $1e4e6e6cc3958162$export$84d4095e16c6fc19.ACK;
                // binary packet's json
                this.reconstructor = new $1e4e6e6cc3958162$var$BinaryReconstructor(packet);
                // no attachments, labeled binary but no binary data to follow
                if (packet.attachments === 0) super.emitReserved("decoded", packet);
            } else // non-binary full packet
            super.emitReserved("decoded", packet);
        } else if ((0, $eGKCF.isBinary)(obj) || obj.base64) {
            // raw binary data
            if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
            else {
                packet = this.reconstructor.takeBinaryData(obj);
                if (packet) {
                    // received final buffer
                    this.reconstructor = null;
                    super.emitReserved("decoded", packet);
                }
            }
        } else throw new Error("Unknown type: " + obj);
    }
    /**
     * Decode a packet String (JSON data)
     *
     * @param {String} str
     * @return {Object} packet
     */ decodeString(str) {
        let i = 0;
        // look up type
        const p = {
            type: Number(str.charAt(0))
        };
        if ($1e4e6e6cc3958162$export$84d4095e16c6fc19[p.type] === undefined) throw new Error("unknown packet type " + p.type);
        // look up attachments if type binary
        if (p.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT || p.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK) {
            const start = i + 1;
            while(str.charAt(++i) !== "-" && i != str.length);
            const buf = str.substring(start, i);
            if (buf != Number(buf) || str.charAt(i) !== "-") throw new Error("Illegal attachments");
            p.attachments = Number(buf);
        }
        // look up namespace (if any)
        if ("/" === str.charAt(i + 1)) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if ("," === c) break;
                if (i === str.length) break;
            }
            p.nsp = str.substring(start, i);
        } else p.nsp = "/";
        // look up id
        const next = str.charAt(i + 1);
        if ("" !== next && Number(next) == next) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if (null == c || Number(c) != c) {
                    --i;
                    break;
                }
                if (i === str.length) break;
            }
            p.id = Number(str.substring(start, i + 1));
        }
        // look up json data
        if (str.charAt(++i)) {
            const payload = this.tryParse(str.substr(i));
            if ($1e4e6e6cc3958162$export$f9de6ca0bc043724.isPayloadValid(p.type, payload)) p.data = payload;
            else throw new Error("invalid payload");
        }
        return p;
    }
    tryParse(str) {
        try {
            return JSON.parse(str, this.reviver);
        } catch (e) {
            return false;
        }
    }
    static isPayloadValid(type, payload) {
        switch(type){
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.CONNECT:
                return $1e4e6e6cc3958162$var$isObject(payload);
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.DISCONNECT:
                return payload === undefined;
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.CONNECT_ERROR:
                return typeof payload === "string" || $1e4e6e6cc3958162$var$isObject(payload);
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT:
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT:
                return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $1e4e6e6cc3958162$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.ACK:
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK:
                return Array.isArray(payload);
        }
    }
    /**
     * Deallocates a parser's resources
     */ destroy() {
        if (this.reconstructor) {
            this.reconstructor.finishedReconstruction();
            this.reconstructor = null;
        }
    }
}
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 */ class $1e4e6e6cc3958162$var$BinaryReconstructor {
    constructor(packet){
        this.packet = packet;
        this.buffers = [];
        this.reconPack = packet;
    }
    /**
     * Method to be called when binary data received from connection
     * after a BINARY_EVENT packet.
     *
     * @param {Buffer | ArrayBuffer} binData - the raw binary data received
     * @return {null | Object} returns null if more binary data is expected or
     *   a reconstructed packet object if all buffers have been received.
     */ takeBinaryData(binData) {
        this.buffers.push(binData);
        if (this.buffers.length === this.reconPack.attachments) {
            // done with buffer list
            const packet = (0, $8URBv.reconstructPacket)(this.reconPack, this.buffers);
            this.finishedReconstruction();
            return packet;
        }
        return null;
    }
    /**
     * Cleans up binary packet reconstruction variables.
     */ finishedReconstruction() {
        this.reconPack = null;
        this.buffers = [];
    }
}

});
parcelRegister("8URBv", function(module, exports) {

$parcel$export(module.exports, "deconstructPacket", () => $67dd224d5a131c9e$export$ac2edb9eb7af56f6);
$parcel$export(module.exports, "reconstructPacket", () => $67dd224d5a131c9e$export$a00da3b1ec037a04);

var $eGKCF = parcelRequire("eGKCF");
function $67dd224d5a131c9e$export$ac2edb9eb7af56f6(packet) {
    const buffers = [];
    const packetData = packet.data;
    const pack = packet;
    pack.data = $67dd224d5a131c9e$var$_deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return {
        packet: pack,
        buffers: buffers
    };
}
function $67dd224d5a131c9e$var$_deconstructPacket(data, buffers) {
    if (!data) return data;
    if ((0, $eGKCF.isBinary)(data)) {
        const placeholder = {
            _placeholder: true,
            num: buffers.length
        };
        buffers.push(data);
        return placeholder;
    } else if (Array.isArray(data)) {
        const newData = new Array(data.length);
        for(let i = 0; i < data.length; i++)newData[i] = $67dd224d5a131c9e$var$_deconstructPacket(data[i], buffers);
        return newData;
    } else if (typeof data === "object" && !(data instanceof Date)) {
        const newData = {};
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) newData[key] = $67dd224d5a131c9e$var$_deconstructPacket(data[key], buffers);
        return newData;
    }
    return data;
}
function $67dd224d5a131c9e$export$a00da3b1ec037a04(packet, buffers) {
    packet.data = $67dd224d5a131c9e$var$_reconstructPacket(packet.data, buffers);
    delete packet.attachments; // no longer useful
    return packet;
}
function $67dd224d5a131c9e$var$_reconstructPacket(data, buffers) {
    if (!data) return data;
    if (data && data._placeholder === true) {
        const isIndexValid = typeof data.num === "number" && data.num >= 0 && data.num < buffers.length;
        if (isIndexValid) return buffers[data.num]; // appropriate buffer (should be natural order anyway)
        else throw new Error("illegal attachments");
    } else if (Array.isArray(data)) for(let i = 0; i < data.length; i++)data[i] = $67dd224d5a131c9e$var$_reconstructPacket(data[i], buffers);
    else if (typeof data === "object") {
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) data[key] = $67dd224d5a131c9e$var$_reconstructPacket(data[key], buffers);
    }
    return data;
}

});
parcelRegister("eGKCF", function(module, exports) {

$parcel$export(module.exports, "isBinary", () => $ab192732c3780e48$export$37488ff1135b1696);
$parcel$export(module.exports, "hasBinary", () => $ab192732c3780e48$export$5234c529abdb5610);
const $ab192732c3780e48$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $ab192732c3780e48$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
const $ab192732c3780e48$var$toString = Object.prototype.toString;
const $ab192732c3780e48$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && $ab192732c3780e48$var$toString.call(Blob) === "[object BlobConstructor]";
const $ab192732c3780e48$var$withNativeFile = typeof File === "function" || typeof File !== "undefined" && $ab192732c3780e48$var$toString.call(File) === "[object FileConstructor]";
function $ab192732c3780e48$export$37488ff1135b1696(obj) {
    return $ab192732c3780e48$var$withNativeArrayBuffer && (obj instanceof ArrayBuffer || $ab192732c3780e48$var$isView(obj)) || $ab192732c3780e48$var$withNativeBlob && obj instanceof Blob || $ab192732c3780e48$var$withNativeFile && obj instanceof File;
}
function $ab192732c3780e48$export$5234c529abdb5610(obj, toJSON) {
    if (!obj || typeof obj !== "object") return false;
    if (Array.isArray(obj)) {
        for(let i = 0, l = obj.length; i < l; i++){
            if ($ab192732c3780e48$export$5234c529abdb5610(obj[i])) return true;
        }
        return false;
    }
    if ($ab192732c3780e48$export$37488ff1135b1696(obj)) return true;
    if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) return $ab192732c3780e48$export$5234c529abdb5610(obj.toJSON(), true);
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key) && $ab192732c3780e48$export$5234c529abdb5610(obj[key])) return true;
    }
    return false;
}

});



parcelRegister("vPX8d", function(module, exports) {

$parcel$export(module.exports, "on", () => $05fb321879039179$export$af631764ddc44097);
function $05fb321879039179$export$af631764ddc44097(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}

});


parcelRegister("5pEXn", function(module, exports) {

$parcel$export(module.exports, "Backoff", () => $3f0f0eae169725b6$export$2d38012449449c89);
/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $3f0f0eae169725b6$export$2d38012449449c89(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};

});




parcelRegister("Vqjah", function(module, exports) {
/**
 * EvEmitter v2.1.1
 * Lil' event emitter
 * MIT License
 */ (function(global, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS - Browserify, Webpack
    module.exports = factory();
    else // Browser globals
    global.EvEmitter = factory();
})(typeof window != "undefined" ? window : module.exports, function() {
    function EvEmitter() {}
    let proto = EvEmitter.prototype;
    proto.on = function(eventName, listener) {
        if (!eventName || !listener) return this;
        // set events hash
        let events = this._events = this._events || {};
        // set listeners array
        let listeners = events[eventName] = events[eventName] || [];
        // only add once
        if (!listeners.includes(listener)) listeners.push(listener);
        return this;
    };
    proto.once = function(eventName, listener) {
        if (!eventName || !listener) return this;
        // add event
        this.on(eventName, listener);
        // set once flag
        // set onceEvents hash
        let onceEvents = this._onceEvents = this._onceEvents || {};
        // set onceListeners object
        let onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
        // set flag
        onceListeners[listener] = true;
        return this;
    };
    proto.off = function(eventName, listener) {
        let listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return this;
        let index = listeners.indexOf(listener);
        if (index != -1) listeners.splice(index, 1);
        return this;
    };
    proto.emitEvent = function(eventName, args) {
        let listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return this;
        // copy over to avoid interference if .off() in listener
        listeners = listeners.slice(0);
        args = args || [];
        // once stuff
        let onceListeners = this._onceEvents && this._onceEvents[eventName];
        for (let listener of listeners){
            let isOnce = onceListeners && onceListeners[listener];
            if (isOnce) {
                // remove listener
                // remove before trigger to prevent recursion
                this.off(eventName, listener);
                // unset once flag
                delete onceListeners[listener];
            }
            // trigger listener
            listener.apply(this, args);
        }
        return this;
    };
    proto.allOff = function() {
        delete this._events;
        delete this._onceEvents;
        return this;
    };
    return EvEmitter;
});

});

parcelRequire("cBUNY");
"use strict";



































var $7c0747b58b41b25c$export$2e2bcd8739ae039 = {
    logo: (parcelRequire("6YNlE")),
    arrowDownCircle: (parcelRequire("9wlV6")),
    arrowDownLeft: (parcelRequire("4Q7KU")),
    arrowDownRight: (parcelRequire("iUsTz")),
    arrowDown: (parcelRequire("kfWEV")),
    arrowLeftCircle: (parcelRequire("hpAtq")),
    arrowLeft: (parcelRequire("flW3m")),
    arrowRight: (parcelRequire("fUjto")),
    arrowRightCircle: (parcelRequire("JWxI4")),
    arrowUpCircle: (parcelRequire("dHcR4")),
    arrowUpLeft: (parcelRequire("hF4Sv")),
    arrowUpRight: (parcelRequire("5QY7o")),
    arrowUp: (parcelRequire("6byik")),
    checkCircle: (parcelRequire("8ePs4")),
    check: (parcelRequire("cGfez")),
    chevronDown: (parcelRequire("2Ul1b")),
    chevronLeft: (parcelRequire("gwP6O")),
    chevronRight: (parcelRequire("8eE1Q")),
    chevronUp: (parcelRequire("c7jAY")),
    copy: (parcelRequire("9jlg3")),
    eyeOff: (parcelRequire("eYX6R")),
    eye: (parcelRequire("bd5y4")),
    info: (parcelRequire("gg799")),
    minus: (parcelRequire("5bM1A")),
    sun: (parcelRequire("acnwK")),
    moon: (parcelRequire("2Rz49")),
    moreHorizontal: (parcelRequire("jgr4j")),
    moreVertical: (parcelRequire("fi6wH")),
    send: (parcelRequire("i1d6Y")),
    smile: (parcelRequire("XMQx2")),
    search: (parcelRequire("rdEtP")),
    upload: (parcelRequire("dKKdP")),
    video: (parcelRequire("hrriy")),
    x: (parcelRequire("9gXuv")),
    plus: (parcelRequire("8lEKy"))
};


"use strict";
const $68c1235a721b25ba$export$9b982809044276a6 = {
    transparent: "rgba(0, 0, 0, 0)",
    black: "black",
    gray: "#4e4e50",
    blue: "#0e80fd",
    indigo: "#50E1FF",
    green: "#59AC56",
    red: "#FE5B47",
    yellow: "#EDCB38",
    orange: "#E2862F",
    brown: "#7D6755",
    pink: "#FD8ABF",
    purple: "#7345AF",
    white: "white",
    green2: "#04F214",
    blue2: "#0474F2",
    gray2: "#A3A3A8",
    gray3: "#1C1C1F",
    gray4: "#BDBDC1",
    title: [
        "--black 1",
        "--white 1"
    ],
    caption: [
        "--gray 1 +16",
        "--gray4 1"
    ],
    paragraph: [
        "--gray 1",
        "--gray 1 +65"
    ]
};
const $68c1235a721b25ba$export$3d856cf049c09ba8 = {
    "gradient-blue-light": `linear-gradient(to right,
    rgba(4, 116, 242, 1),
    rgba(0, 48, 103, 1)
  )`,
    "gradient-blue-dark": `linear-gradient(to right,
    #0474F2,
    #003067
  )`,
    "gradient-dark": `linear-gradient(0deg,
    rgba(0,0,0,0.06) 0%,
    rgba(0,0,0,0.07) 100%
  )`,
    "gradient-dark-active": `linear-gradient(0deg,
    rgba(0,0,0,0.09) 0%,
    rgba(0,0,0,0.1) 100%
  )`,
    "gradient-light": `linear-gradient(
    0deg,
    rgba(255,255,255,0.05) 0%,
    rgba(255,255,255,0.06) 100%
  )`,
    "gradient-light-active": `linear-gradient(
    0deg,
    rgba(255,255,255,0.09) 0%,
    rgba(255,255,255,0.10) 100%
  )`,
    "gradient-colorful": `linear-gradient(60deg,
    #00A2E7 0%,
    #185DF3 31%,
    #1E54F0 36%,
    #8B4CCA 69%,
    #C66894 100%
  )`
};


"use strict";
const $ff633047a5e6ba5f$var$PRIORITIES = {
    primary: {
        "@dark": {
            color: "white",
            background: "blue",
            ".color-only": {
                color: "blue"
            },
            ".inactive": {
                background: "gray 1 +16"
            },
            ".gradient": {
                color: "white",
                background: "gradient-blue"
            }
        },
        "@light": {
            color: "white",
            background: "gradient-blue",
            ".color-only": {
                color: "blue"
            },
            ".gradient": {
                color: "white",
                background: "gradient-colorful"
            }
        }
    },
    secondary: {
        "@dark": {
            color: "white",
            background: "green",
            ".color-only": {
                color: "green"
            }
        },
        "@light": {
            color: "white",
            background: "green",
            ".color-only": {
                color: "green"
            }
        },
        ".child": "--primary"
    },
    tertiary: {
        "@dark": {
            color: "white",
            background: "gray .92 +8"
        },
        "@light": {
            background: "gray .1"
        }
    },
    quaternary: {
        "@light": {
            color: "white",
            background: "gradient-light"
        },
        "@dark": {
            color: "white",
            background: "gradient-dark-active"
        }
    },
    quinary: {
        "@dark": {
            color: "gray 1 90",
            background: "gradient-light",
            ":hover": {
                color: "gray 1 95",
                background: "gradient-light-active"
            },
            ":focus": {
                color: "gray 1 120",
                background: "gradient-light-active"
            },
            ":active": {
                color: "gray 1 120",
                background: "gradient-light-active"
            },
            ".active": {
                color: "gray 1 120",
                background: "gradient-light-active"
            }
        },
        "@light": {
            color: "gray3",
            background: "gradient-dark",
            ":hover": {
                color: "gray1",
                background: "gradient-dark-active"
            },
            ":active": {
                color: "gray1",
                background: "gradient-dark-active"
            },
            ".active": {
                color: "gray1",
                background: "gradient-dark-active"
            }
        }
    }
};
const $ff633047a5e6ba5f$var$STATES = {
    alert: {
        "@dark": {
            color: "white",
            background: "red"
        }
    },
    warning: {
        "@dark": {
            color: "black",
            background: "yellow"
        }
    },
    success: {
        "@dark": {
            color: "black",
            background: "green"
        }
    }
};
const $ff633047a5e6ba5f$var$UI = {
    field: {
        "@light": {
            color: "black",
            background: "gray .975 +144",
            borderColor: "gray .975 +144",
            "::placeholder": {
                color: "gray 1 -68"
            }
        },
        "@dark": {
            color: "white",
            background: "gray .975 -52",
            borderColor: "gray .975 -52",
            "::placeholder": {
                color: "gray 1 +68"
            }
        }
    },
    label: {
        "@dark": {
            color: "white",
            background: "gray .92 +8"
        },
        "@light": {
            background: "gray .1"
        },
        ".light": {
            color: "white",
            background: "gray3"
        },
        ".dark": {
            color: "white",
            background: "black .35"
        }
    },
    card: {
        "@light": {
            background: "gray .975 +150"
        },
        "@dark": {
            color: "white",
            background: "gray .975 -56"
        },
        ".child": {
            color: "white",
            background: "gray3"
        },
        ".secondary": {
            color: "white",
            background: "gradient-blue-dark",
            ".child": {
                color: "white",
                background: "black .35"
            }
        }
    },
    dialog: {
        "@dark": {
            color: "white",
            background: "gray .92",
            ".helper": {
                color: "white",
                background: "black"
            }
        },
        "@light": {
            color: "currentColor",
            background: "gray .1"
        }
    }
};
const $ff633047a5e6ba5f$export$5714e40777c1bcc2 = {
    document: {
        "@light": {
            color: "black",
            background: "white"
        },
        "@dark": {
            color: "white",
            background: "black"
        }
    },
    ...$ff633047a5e6ba5f$var$PRIORITIES,
    ...$ff633047a5e6ba5f$var$STATES,
    ...$ff633047a5e6ba5f$var$UI,
    none: {
        color: "none",
        background: "none"
    },
    transparent: {
        color: "currentColor",
        background: "transparent"
    }
};


"use strict";
const $5f8d538af304c7c6$export$d36796ab73e728d9 = {
    base: 16,
    ratio: 1.25,
    subSequence: true,
    templates: {}
};


"use strict";
const $79ffe4ae2b30fe08$export$82ea42e772d49e5b = {
    ratio: 1.618,
    subSequence: true
};


"use strict";
const $dbb948e0eaf3d49a$export$75d3998385cc196f = {
    SourceSans: [
        {
            url: ""
        }
    ]
};
const $dbb948e0eaf3d49a$export$530097e879f93363 = {
    system: {
        value: [
            '"Helvetica Neue"',
            "Helvetica",
            "Arial"
        ],
        type: "sans-serif"
    }
};


"use strict";
const $99bfc4205b1fbca6$export$500415a86c544f73 = {
    tv: "(min-width: 2780px)",
    screenL: "(max-width: 1920px)",
    "screenL<": "(min-width: 1920px)",
    screenM: "(max-width: 1680px)",
    "screenM<": "(min-width: 1680px)",
    screenS: "(max-width: 1440px)",
    "screenS<": "(min-width: 1440px)",
    tabletL: "(max-width: 1366px)",
    "tabletL<": "(min-width: 1366px)",
    tabletM: "(max-width: 1280px)",
    "tabletM<": "(min-width: 1280px)",
    tabletS: "(max-width: 1024px)",
    "tabletS<": "(min-width: 1024px)",
    mobileL: "(max-width: 768px)",
    "mobileL<": "(min-width: 768px)",
    mobileM: "(max-width: 560px)",
    "mobileM<": "(min-width: 560px)",
    mobileS: "(max-width: 480px)",
    "mobileS<": "(min-width: 480px)",
    mobileXS: "(max-width: 375px)",
    "mobileXS<": "(min-width: 375px)",
    light: "(prefers-color-scheme: light)",
    dark: "(prefers-color-scheme: dark)",
    print: "print"
};


"use strict";
const $ab3d361449dd62cb$export$3c9e9dc0cdfaa753 = {
    base: 150,
    ratio: 1.333,
    unit: "ms",
    subSequence: true
};


"use strict";
const $812d27f1e77a76ab$export$c2f8e0cc249a8d8f = {
    version: "0.0.1",
    COLOR: $68c1235a721b25ba$export$9b982809044276a6,
    GRADIENT: $68c1235a721b25ba$export$3d856cf049c09ba8,
    THEME: $ff633047a5e6ba5f$export$5714e40777c1bcc2,
    TYPOGRAPHY: $5f8d538af304c7c6$export$d36796ab73e728d9,
    SPACING: $79ffe4ae2b30fe08$export$82ea42e772d49e5b,
    FONT: $dbb948e0eaf3d49a$export$75d3998385cc196f,
    FONT_FAMILY: $dbb948e0eaf3d49a$export$530097e879f93363,
    TIMING: $ab3d361449dd62cb$export$3c9e9dc0cdfaa753,
    ICONS: $7c0747b58b41b25c$export$2e2bcd8739ae039,
    MEDIA: $99bfc4205b1fbca6$export$500415a86c544f73,
    DEVICES: {},
    CASES: {},
    SVG: {} // TODO: Check with @nikoloza on this
};
var $812d27f1e77a76ab$export$2e2bcd8739ae039 = $812d27f1e77a76ab$export$c2f8e0cc249a8d8f;


var $75f36cb383311abc$exports = {};
var $18dbdacc7a38df0d$exports = {};

$parcel$export($18dbdacc7a38df0d$exports, "isScalingUnit", () => $18dbdacc7a38df0d$export$6a836bb704f10b75);
"use strict";
const $18dbdacc7a38df0d$export$6a836bb704f10b75 = (unit)=>{
    return unit === "em" || unit === "rem" || unit === "vw" || unit === "vh" || unit === "vmax" || unit === "vmin";
};


var $1ef99b0b26632769$exports = {};

$parcel$export($1ef99b0b26632769$exports, "colorStringToRgbaArray", () => $1ef99b0b26632769$export$fa32e9c99a43479e);
$parcel$export($1ef99b0b26632769$exports, "mixTwoColors", () => $1ef99b0b26632769$export$fc81362b978df912);
$parcel$export($1ef99b0b26632769$exports, "mixTwoRgba", () => $1ef99b0b26632769$export$7aaa71d8fa03e6fa);
$parcel$export($1ef99b0b26632769$exports, "hexToRgb", () => $1ef99b0b26632769$export$5a544e13ad4e1fa5);
$parcel$export($1ef99b0b26632769$exports, "hexToRgbArray", () => $1ef99b0b26632769$export$fc66327a54d8eee6);
$parcel$export($1ef99b0b26632769$exports, "rgbToHex", () => $1ef99b0b26632769$export$34d09c4a771c46ef);
$parcel$export($1ef99b0b26632769$exports, "rgbArrayToHex", () => $1ef99b0b26632769$export$becee3e8de1b8d23);
$parcel$export($1ef99b0b26632769$exports, "hexToRgba", () => $1ef99b0b26632769$export$9665a07d9187b414);
$parcel$export($1ef99b0b26632769$exports, "mixTwoRgb", () => $1ef99b0b26632769$export$7d1bd62512294b2f);
$parcel$export($1ef99b0b26632769$exports, "changeLightness", () => $1ef99b0b26632769$export$784aaa753604ca97);
$parcel$export($1ef99b0b26632769$exports, "rgbToHSL", () => $1ef99b0b26632769$export$ac60e367bcb68b);
$parcel$export($1ef99b0b26632769$exports, "hslToRgb", () => $1ef99b0b26632769$export$29fb7152bd3f781a);
$parcel$export($1ef99b0b26632769$exports, "getColorShade", () => $1ef99b0b26632769$export$e1d0a0f5f1f4ce36);
$parcel$export($1ef99b0b26632769$exports, "opacify", () => $1ef99b0b26632769$export$f4f50e3877dd0530);
$parcel$export($1ef99b0b26632769$exports, "getRgbTone", () => $1ef99b0b26632769$export$2d78fefdcfb7f222);

var $aOJ2H = parcelRequire("aOJ2H");
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $1ef99b0b26632769$var$ENV = "production";
const $1ef99b0b26632769$export$fa32e9c99a43479e = (color)=>{
    if (color === "") return;
    if (color.toLowerCase() === "transparent") return [
        0,
        0,
        0,
        0
    ];
    // convert #RGB and #RGBA to #RRGGBB and #RRGGBBAA
    if (color[0] === "#") {
        if (color.length < 7) color = "#" + color[1] + color[1] + color[2] + color[2] + color[3] + color[3] + (color.length > 4 ? color[4] + color[4] : "");
        return [
            parseInt(color.substr(1, 2), 16),
            parseInt(color.substr(3, 2), 16),
            parseInt(color.substr(5, 2), 16),
            color.length > 7 ? parseInt(color.substr(7, 2), 16) / 255 : 1
        ];
    }
    // convert named colors
    if (color.indexOf("rgb") === -1) {
        if ((0, $aOJ2H.document) && (0, $aOJ2H.window)) {
            // intentionally use unknown tag to lower chances of css rule override with !important
            const elem = (0, $aOJ2H.document).body.appendChild((0, $aOJ2H.document).createElement("fictum"));
            // this flag tested on chrome 59, ff 53, ie9, ie10, ie11, edge 14
            const flag = "rgb(1, 2, 3)";
            elem.style.color = flag;
            // color set failed - some monstrous css rule is probably taking over the color of our object
            if (elem.style.color !== flag) return;
            elem.style.color = color;
            if (elem.style.color === flag || elem.style.color === "") return; // color parse failed
            color = (0, $aOJ2H.window).getComputedStyle(elem).color;
            (0, $aOJ2H.document).body.removeChild(elem);
        }
    }
    // convert 'rgb(R,G,B)' to 'rgb(R,G,B,A)' which looks awful but will pass the regxep below
    if (color.indexOf("rgb") === 0) {
        if (color.indexOf("rgba") === -1) color = `${color}, 1`;
        return color.match(/[\.\d]+/g).map((a)=>+a) // eslint-disable-line
        ;
    }
    // TODO: fix this
    return [];
};
const $1ef99b0b26632769$export$fc81362b978df912 = (colorA, colorB, range = 0.5)=>{
    colorA = $1ef99b0b26632769$export$fa32e9c99a43479e(colorA);
    colorB = $1ef99b0b26632769$export$fa32e9c99a43479e(colorB);
    return $1ef99b0b26632769$export$7aaa71d8fa03e6fa(colorA, colorB, range);
};
const $1ef99b0b26632769$export$5a544e13ad4e1fa5 = (hex, alpha = 1)=>{
    const [r, g, b] = hex.match(/\w\w/g).map((x)=>parseInt(x, 16));
    return `rgb(${r},${g},${b})`;
};
const $1ef99b0b26632769$export$fc66327a54d8eee6 = (hex, alpha = 1)=>{
    const [r, g, b] = hex.match(/\w\w/g).map((x)=>parseInt(x, 16));
    return [
        r,
        g,
        b
    ];
};
const $1ef99b0b26632769$export$34d09c4a771c46ef = (r, g, b)=>{
    return "#" + (16777216 | r << 16 | g << 8 | b).toString(16).slice(1);
};
const $1ef99b0b26632769$export$becee3e8de1b8d23 = ([r, g, b])=>{
    return (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
};
const $1ef99b0b26632769$export$9665a07d9187b414 = (hex, alpha = 1)=>{
    const [r, g, b] = hex.match(/\w\w/g).map((x)=>parseInt(x, 16));
    return `rgba(${r},${g},${b},${alpha})`;
};
const $1ef99b0b26632769$export$7d1bd62512294b2f = (colorA, colorB, range = 0.5)=>{
    const arr = [];
    for(let i = 0; i < 3; i++)arr[i] = ~~(colorA[i] + (colorB[i] - colorA[i]) * range);
    return `rgb(${arr})`;
};
const $1ef99b0b26632769$export$784aaa753604ca97 = (delta, hsl)=>{
    const [hue, saturation, lightness] = hsl;
    const newLightness = Math.max(0, Math.min(100, lightness + parseFloat(delta)));
    return [
        hue,
        saturation,
        newLightness
    ];
};
const $1ef99b0b26632769$export$ac60e367bcb68b = (r, g, b)=>{
    const a = Math.max(r, g, b);
    const n = a - Math.min(r, g, b);
    const f = 1 - Math.abs(a + a - n - 1);
    const h = n && (a == r ? (g - b) / n : a == g ? 2 + (b - r) / n : 4 + (r - g) / n //eslint-disable-line
    );
    return [
        60 * (h < 0 ? h + 6 : h),
        f ? n / f : 0,
        (a + a - n) / 2
    ];
};
const $1ef99b0b26632769$export$29fb7152bd3f781a = (h, s, l, a = s * Math.min(l, 1 - l), f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1))=>[
        f(0),
        f(8),
        f(4)
    ];
const $1ef99b0b26632769$export$e1d0a0f5f1f4ce36 = (col, amt)=>{
    const num = parseInt(col, 16);
    let r = (num >> 16) + amt;
    if (r > 255) r = 255;
    else if (r < 0) r = 0;
    let b = (num >> 8 & 0x00FF) + amt;
    if (b > 255) b = 255;
    else if (b < 0) b = 0;
    let g = (num & 0x0000FF) + amt;
    if (g > 255) g = 255;
    else if (g < 0) g = 0;
    return ((g | b << 8 | r << 16) + 0x1000000).toString(16).slice(1);
};
const $1ef99b0b26632769$export$7aaa71d8fa03e6fa = (colorA, colorB, range = 0.5)=>{
    const arr = [];
    for(let i = 0; i < 4; i++){
        const round = i === 3 ? (x)=>x : Math.round;
        arr[i] = round(colorA[i] + (colorB[i] - colorA[i]) * range);
    }
    return `rgba(${arr})`;
};
const $1ef99b0b26632769$export$f4f50e3877dd0530 = (color, opacity)=>{
    const arr = $1ef99b0b26632769$export$fa32e9c99a43479e(color);
    if (!arr) {
        if ($1ef99b0b26632769$var$ENV === "test" || $1ef99b0b26632769$var$ENV === "development") console.warn(color + " color is not rgba");
        return;
    }
    arr[3] = opacity;
    return `rgba(${arr})`;
};
const $1ef99b0b26632769$export$2d78fefdcfb7f222 = (rgb, tone)=>{
    if ((0, $EqHTq.isString)(rgb) && rgb.includes("rgb")) rgb = $1ef99b0b26632769$export$fa32e9c99a43479e(rgb).join(", ");
    if ((0, $EqHTq.isString)(rgb)) rgb = rgb.split(",").map((v)=>parseFloat(v.trim()));
    if ((0, $EqHTq.isNumber)(tone)) tone += "";
    const toHex = $1ef99b0b26632769$export$becee3e8de1b8d23(rgb);
    const abs = tone.slice(0, 1);
    if (abs === "-" || abs === "+") {
        const colorShade = $1ef99b0b26632769$export$e1d0a0f5f1f4ce36(toHex, parseFloat(tone));
        return $1ef99b0b26632769$export$fc66327a54d8eee6(colorShade).join(", ");
    } else {
        const [r, g, b] = rgb;
        const hsl = $1ef99b0b26632769$export$ac60e367bcb68b(r, g, b);
        const [h, s, l] = hsl // eslint-disable-line
        ;
        const newRgb = $1ef99b0b26632769$export$29fb7152bd3f781a(h, s, parseFloat(tone) / 100 * 255);
        return newRgb;
    }
};


var $08f037a4512e32ac$exports = {};

$parcel$export($08f037a4512e32ac$exports, "returnSubThemeOrDefault", () => $08f037a4512e32ac$export$b653d4648867fe18);
"use strict";
const $08f037a4512e32ac$export$b653d4648867fe18 = (orig, theme)=>{
    if (!orig) return;
    if (orig.themes && orig.themes[theme]) return orig.themes[theme];
    if (orig[theme]) return [
        orig,
        orig[theme]
    ];
    return orig;
};


var $acb660e77bec9cb5$exports = {};

$parcel$export($acb660e77bec9cb5$exports, "getDefaultOrFirstKey", () => $acb660e77bec9cb5$export$73aa7d12a2d2fb83);
$parcel$export($acb660e77bec9cb5$exports, "getFontFormat", () => $acb660e77bec9cb5$export$6c7bbed5530e9474);
$parcel$export($acb660e77bec9cb5$exports, "setInCustomFontMedia", () => $acb660e77bec9cb5$export$e84fe2812840a337);
$parcel$export($acb660e77bec9cb5$exports, "setCustomFont", () => $acb660e77bec9cb5$export$27bb82ae7d3ac02b);
$parcel$export($acb660e77bec9cb5$exports, "setCustomFontMedia", () => $acb660e77bec9cb5$export$2593ac3417be5ed7);
$parcel$export($acb660e77bec9cb5$exports, "getFontFaceEach", () => $acb660e77bec9cb5$export$198e04e3616f042a);
$parcel$export($acb660e77bec9cb5$exports, "getFontFace", () => $acb660e77bec9cb5$export$e9d70cd3a9044b8e);
$parcel$export($acb660e77bec9cb5$exports, "getFontFaceEachString", () => $acb660e77bec9cb5$export$c26ef91aac8931ec);
$parcel$export($acb660e77bec9cb5$exports, "getFontFaceString", () => $acb660e77bec9cb5$export$8b73d71a1d936bc);
"use strict";
const $acb660e77bec9cb5$export$73aa7d12a2d2fb83 = (LIBRARY, key)=>{
    if (LIBRARY[key]) return LIBRARY[key].value;
    if (LIBRARY.default) return LIBRARY[LIBRARY.default].value;
    const hasValue = Object.keys(LIBRARY)[0];
    return hasValue && LIBRARY[hasValue] && LIBRARY[hasValue].value;
};
const $acb660e77bec9cb5$export$6c7bbed5530e9474 = (url)=>url.split(/[#?]/)[0].split(".").pop().trim();
const $acb660e77bec9cb5$export$e84fe2812840a337 = (str)=>`@font-face { ${str} }`;
const $acb660e77bec9cb5$export$27bb82ae7d3ac02b = (name, url, weight)=>`
  font-family: '${name}';
  font-style: normal;
  ${weight && `font-weight: ${weight};`}
  src: url('${url}') format('${$acb660e77bec9cb5$export$6c7bbed5530e9474(url)}');`;
const $acb660e77bec9cb5$export$2593ac3417be5ed7 = (name, url, weight)=>`@font-face {
  ${$acb660e77bec9cb5$export$27bb82ae7d3ac02b(name, url, weight)}
}`;
const $acb660e77bec9cb5$export$198e04e3616f042a = (name, weights)=>{
    const keys = Object.keys(weights);
    return keys.map((key)=>{
        const { url: url, fontWeight: fontWeight } = weights[key];
        return $acb660e77bec9cb5$export$27bb82ae7d3ac02b(name, url, fontWeight);
    });
};
const $acb660e77bec9cb5$export$e9d70cd3a9044b8e = (LIBRARY)=>{
    const keys = Object.keys(LIBRARY);
    return keys.map((key)=>$acb660e77bec9cb5$export$198e04e3616f042a(key, LIBRARY[key].value));
};
const $acb660e77bec9cb5$export$c26ef91aac8931ec = (name, weights)=>{
    const isArr = weights[0];
    if (isArr) return $acb660e77bec9cb5$export$198e04e3616f042a(name, weights).map($acb660e77bec9cb5$export$e84fe2812840a337);
    return $acb660e77bec9cb5$export$2593ac3417be5ed7(name, weights.url);
};
const $acb660e77bec9cb5$export$8b73d71a1d936bc = (LIBRARY)=>{
    const keys = Object.keys(LIBRARY);
    return keys.map((key)=>$acb660e77bec9cb5$export$c26ef91aac8931ec(key, LIBRARY[key].value));
};


var $366218d35fdab076$exports = {};

$parcel$export($366218d35fdab076$exports, "numToLetterMap", () => $366218d35fdab076$export$81ab9dc24d52c4ba);
$parcel$export($366218d35fdab076$exports, "setScalingVar", () => $366218d35fdab076$export$68dfa61d698afbde);
$parcel$export($366218d35fdab076$exports, "setSubScalingVar", () => $366218d35fdab076$export$c9d5ef57eeb83fa);
$parcel$export($366218d35fdab076$exports, "getSubratioDifference", () => $366218d35fdab076$export$12adf55fdaa50348);
$parcel$export($366218d35fdab076$exports, "getSubratio", () => $366218d35fdab076$export$50db87b17b1557b4);
$parcel$export($366218d35fdab076$exports, "generateSubSequence", () => $366218d35fdab076$export$622ae6209895c34e);
$parcel$export($366218d35fdab076$exports, "generateSequence", () => $366218d35fdab076$export$29708af739d9b0fc);
$parcel$export($366218d35fdab076$exports, "getSequenceValue", () => $366218d35fdab076$export$efde09b5692f9bd0);
$parcel$export($366218d35fdab076$exports, "getSequenceValuePropertyPair", () => $366218d35fdab076$export$86c0052f25dacc45);
$parcel$export($366218d35fdab076$exports, "findHeadingLetter", () => $366218d35fdab076$export$14c834a042d41297);
$parcel$export($366218d35fdab076$exports, "findHeadings", () => $366218d35fdab076$export$8dc77c00fe04c40a);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
var $8319f99b46b296c9$exports = {};

$parcel$export($8319f99b46b296c9$exports, "copyStringToClipboard", () => $8319f99b46b296c9$export$4cdfed7d7fed21b8);
$parcel$export($8319f99b46b296c9$exports, "toCamelCase", () => $8319f99b46b296c9$export$86f54f62aa7a7514);
$parcel$export($8319f99b46b296c9$exports, "toTitleCase", () => $8319f99b46b296c9$export$f06f8b3003f18927);
$parcel$export($8319f99b46b296c9$exports, "toDashCase", () => $8319f99b46b296c9$export$6401d9e8afa09755);
$parcel$export($8319f99b46b296c9$exports, "toDescriptionCase", () => $8319f99b46b296c9$export$c82070d8669cc24e);
$parcel$export($8319f99b46b296c9$exports, "arrayzeValue", () => $8319f99b46b296c9$export$d1ef4b1a340dec10);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
var $6d2b41257afed6ac$exports = {};

$parcel$export($6d2b41257afed6ac$exports, "findClosestNumber", () => $6d2b41257afed6ac$export$97a41db892f2d4c);
$parcel$export($6d2b41257afed6ac$exports, "findClosestNumberInFactory", () => $6d2b41257afed6ac$export$63c606e1170dd201);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $6d2b41257afed6ac$export$97a41db892f2d4c = (number, arr)=>{
    return ((0, $EqHTq.isArray)(arr) ? arr : Object.values(arr)).reduce((prev, curr)=>{
        return Math.abs(curr - number) < Math.abs(prev - number) ? curr : prev;
    });
};
const $6d2b41257afed6ac$export$63c606e1170dd201 = (val, factory)=>{
    val = parseFloat(val);
    if ((0, $EqHTq.isObject)(factory)) factory = Object.values(factory);
    return $6d2b41257afed6ac$export$97a41db892f2d4c(val, factory);
};


var $6990ad4ace0aad0d$exports = {};

$parcel$export($6990ad4ace0aad0d$exports, "formatDate", () => $6990ad4ace0aad0d$export$3ae94a2503e890a1);
"use strict";
const $6990ad4ace0aad0d$export$3ae94a2503e890a1 = (timestamp)=>{
    if (!timestamp) return "";
    const d = new Date(timestamp);
    const ye = new Intl.DateTimeFormat("en", {
        year: "numeric"
    }).format(d);
    const mo = new Intl.DateTimeFormat("en", {
        month: "short"
    }).format(d);
    const da = new Intl.DateTimeFormat("en", {
        day: "2-digit"
    }).format(d);
    return `${da} ${mo}, ${ye}`;
};


"use strict";
const $8319f99b46b296c9$export$4cdfed7d7fed21b8 = (str)=>{
    const el = document.createElement("textarea");
    el.value = str;
    el.setAttribute("readonly", "");
    el.style = {
        position: "absolute",
        left: "-9999px"
    };
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
};
const $8319f99b46b296c9$export$86f54f62aa7a7514 = (str)=>{
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replaceAll(/\s+/g, "");
};
const $8319f99b46b296c9$export$f06f8b3003f18927 = (str)=>str && str.replace(/\w\S*/g, (txt)=>{
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
const $8319f99b46b296c9$export$6401d9e8afa09755 = (val)=>val.replace(/[^a-zA-Z0-9]/g, " ") // Replace non-alphanumeric characters with spaces
    .trim() // Remove leading and trailing spaces
    .toLowerCase() // Convert to lowercase
    .replace(/\s+/g, "-") // Replace spaces with dashes
    .replace(/-+/g, "-") // Replace consecutive dashes with a single dash
    .replace(/^-|-$/g, "") // Remove leading and trailing dashes
;
const $8319f99b46b296c9$export$c82070d8669cc24e = (str)=>{
    const result = str.replace(/([A-Z])/g, " $1");
    return result.charAt(0).toUpperCase() + result.slice(1);
};
const $8319f99b46b296c9$export$d1ef4b1a340dec10 = (val)=>{
    if ((0, $EqHTq.isArray)(val)) return val;
    if ((0, $EqHTq.isString)(val)) return val.split(" ");
    if ((0, $EqHTq.isObject)(val)) return Object.values(val);
    if ((0, $EqHTq.isNumber)(val)) return [
        val
    ];
};
$parcel$exportWildcard($8319f99b46b296c9$exports, $6d2b41257afed6ac$exports);
$parcel$exportWildcard($8319f99b46b296c9$exports, $6990ad4ace0aad0d$exports);


parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
var $9da0db98e0c07b6d$exports = {};

$parcel$export($9da0db98e0c07b6d$exports, "RESET", () => $9da0db98e0c07b6d$export$4a991c87e640ef77);
var $d2de3d327c0c6201$exports = {};

$parcel$export($d2de3d327c0c6201$exports, "SEQUENCE", () => $d2de3d327c0c6201$export$34694f8d8b23ee2a);
"use strict";
const $d2de3d327c0c6201$export$34694f8d8b23ee2a = {
    "minor-second": 1.067,
    "major-second": 1.125,
    "minor-third": 1.2,
    "major-third": 1.25,
    "perfect-fourth": 1.333,
    "augmented-fourth": 1.414,
    "perfect-fifth": 1.5,
    "minor-sixth": 1.6,
    phi: 1.618,
    "major-sixth": 1.667,
    "square-root-3": 1.732,
    "minor-seventh": 1.778,
    "major-seventh": 1.875,
    octave: 2,
    "square-root-5": 2.23,
    "major-tenth": 2.5,
    "major-eleventh": 2.667,
    "major-twelfth": 3,
    pi: 3.14,
    "double-octave": 4
};


var $9ac3be22fd3c73fc$exports = {};

$parcel$export($9ac3be22fd3c73fc$exports, "UNIT", () => $9ac3be22fd3c73fc$export$97361b7a0c542045);
"use strict";
const $9ac3be22fd3c73fc$export$97361b7a0c542045 = {
    default: "em"
};


var $cc16a6638a049274$exports = {};

$parcel$export($cc16a6638a049274$exports, "TYPOGRAPHY", () => $cc16a6638a049274$export$d36796ab73e728d9);

"use strict";
const $cc16a6638a049274$var$defaultProps = {
    browserDefault: 16,
    base: 16,
    type: "font-size",
    ratio: (0, $d2de3d327c0c6201$export$34694f8d8b23ee2a)["minor-third"],
    range: [
        -3,
        12
    ],
    h1Matches: 6,
    lineHeight: 1.5,
    subSequence: true,
    mediaRegenerate: false,
    unit: "em",
    templates: {},
    sequence: {},
    scales: {},
    vars: {}
};
const $cc16a6638a049274$export$d36796ab73e728d9 = $cc16a6638a049274$var$defaultProps;


var $2015873c4c2cfb72$exports = {};

$parcel$export($2015873c4c2cfb72$exports, "FONT", () => $2015873c4c2cfb72$export$75d3998385cc196f);
"use strict";
var $2015873c4c2cfb72$var$defFont = {
    name: "",
    url: "",
    fontStyle: "",
    fontWeight: 500,
    fontStretch: "normal",
    fontOpticalSizing: "auto"
};
const $2015873c4c2cfb72$export$75d3998385cc196f = {};


var $814e605b31851b50$exports = {};

$parcel$export($814e605b31851b50$exports, "FONT_FAMILY", () => $814e605b31851b50$export$530097e879f93363);
$parcel$export($814e605b31851b50$exports, "FONT_FAMILY_TYPES", () => $814e605b31851b50$export$756e583a6734f96e);
$parcel$export($814e605b31851b50$exports, "FONT_FACE", () => $814e605b31851b50$export$2c16de31893252e6);
"use strict";
var $814e605b31851b50$var$defaultFont = {
    name: "",
    family: "",
    type: ""
};
const $814e605b31851b50$export$530097e879f93363 = {};
const $814e605b31851b50$export$756e583a6734f96e = {
    "sans-serif": "Helvetica, Arial, sans-serif, --system-default",
    serif: "Times New Roman, Georgia, serif, --system-default",
    monospace: "Courier New, monospace, --system-default"
};
const $814e605b31851b50$export$2c16de31893252e6 = {};


var $1dbcec70a81fc9be$exports = {};

$parcel$export($1dbcec70a81fc9be$exports, "MEDIA", () => $1dbcec70a81fc9be$export$500415a86c544f73);
"use strict";
const $1dbcec70a81fc9be$export$500415a86c544f73 = {
    tv: "(min-width: 2780px)",
    light: "(prefers-color-scheme: light)",
    dark: "(prefers-color-scheme: dark)",
    print: "print"
};


var $950c64c959f06041$exports = {};

$parcel$export($950c64c959f06041$exports, "SPACING", () => $950c64c959f06041$export$82ea42e772d49e5b);


"use strict";
const $950c64c959f06041$var$defaultProps = {
    base: (0, $cc16a6638a049274$export$d36796ab73e728d9).base,
    type: "spacing",
    ratio: (0, $d2de3d327c0c6201$export$34694f8d8b23ee2a).phi,
    range: [
        -5,
        15
    ],
    subSequence: true,
    mediaRegenerate: false,
    unit: "em",
    sequence: {},
    scales: {},
    vars: {}
};
const $950c64c959f06041$export$82ea42e772d49e5b = $950c64c959f06041$var$defaultProps;


var $891220fdda3d21a2$exports = {};

$parcel$export($891220fdda3d21a2$exports, "COLOR", () => $891220fdda3d21a2$export$9b982809044276a6);
$parcel$export($891220fdda3d21a2$exports, "GRADIENT", () => $891220fdda3d21a2$export$3d856cf049c09ba8);
"use strict";
var $891220fdda3d21a2$var$proto = {
    name: "",
    value: ""
};
const $891220fdda3d21a2$export$9b982809044276a6 = {};
const $891220fdda3d21a2$export$3d856cf049c09ba8 = {};


var $d3a916a1fb7d8435$exports = {};

$parcel$export($d3a916a1fb7d8435$exports, "THEME", () => $d3a916a1fb7d8435$export$5714e40777c1bcc2);
"use strict";
const $d3a916a1fb7d8435$var$themeA = {
    text: "blue",
    background: "white",
    border: "black",
    active: {},
    helpers: [],
    themes: {},
    inverse: {} // schemeAInverse
};
const $d3a916a1fb7d8435$export$5714e40777c1bcc2 = {};


var $8bcf1bed1aa8dad9$exports = {};

$parcel$export($8bcf1bed1aa8dad9$exports, "SHADOW", () => $8bcf1bed1aa8dad9$export$98b6069deb71e13e);
"use strict";
const $8bcf1bed1aa8dad9$var$shadow = {
    name: "primaryShadow",
    boxShadow: "gray12, 0 0px 50px 50px"
};
const $8bcf1bed1aa8dad9$export$98b6069deb71e13e = {};


var $60fc9d3d8a249143$exports = {};

$parcel$export($60fc9d3d8a249143$exports, "ICONS", () => $60fc9d3d8a249143$export$fde44257752a9f60);
"use strict";
const $60fc9d3d8a249143$export$fde44257752a9f60 = {};


var $0cc3469566cd77c9$exports = {};

$parcel$export($0cc3469566cd77c9$exports, "TIMING", () => $0cc3469566cd77c9$export$3c9e9dc0cdfaa753);

"use strict";
const $0cc3469566cd77c9$var$defaultProps = {
    default: 150,
    base: 150,
    type: "timing",
    ratio: (0, $d2de3d327c0c6201$export$34694f8d8b23ee2a)["perfect-fourth"],
    range: [
        -3,
        12
    ],
    mediaRegenerate: false,
    unit: "ms",
    sequence: {},
    scales: {},
    vars: {}
};
const $0cc3469566cd77c9$export$3c9e9dc0cdfaa753 = $0cc3469566cd77c9$var$defaultProps;


var $438de410da63932f$exports = {};

$parcel$export($438de410da63932f$exports, "DOCUMENT", () => $438de410da63932f$export$ef011b4e114b1fba);
"use strict";
const $438de410da63932f$export$ef011b4e114b1fba = {};


var $567db250b885dfb6$exports = {};

$parcel$export($567db250b885dfb6$exports, "BREAKPOINTS", () => $567db250b885dfb6$export$426e07cd0772984d);
$parcel$export($567db250b885dfb6$exports, "DEVICES", () => $567db250b885dfb6$export$7e1b78538df536d8);
"use strict";
const $567db250b885dfb6$export$426e07cd0772984d = {
    screenL: 1920,
    screenM: 1680,
    screenS: 1440,
    tabletL: 1366,
    tabletM: 1280,
    tabletS: 1024,
    mobileL: 768,
    mobileM: 560,
    mobileS: 480,
    mobileXS: 375
};
const $567db250b885dfb6$export$7e1b78538df536d8 = {
    screenL: [
        1920,
        1024
    ],
    screenM: [
        1680,
        1024
    ],
    screenS: [
        1440,
        978
    ],
    tabletL: [
        1366,
        926
    ],
    tabletM: [
        1280,
        768
    ],
    tabletS: [
        1024,
        768
    ],
    mobileL: [
        768,
        375
    ],
    mobileM: [
        560,
        768
    ],
    mobileS: [
        480,
        768
    ],
    mobileXS: [
        375,
        768
    ]
};


var $49f0f03e163f2585$exports = {};

$parcel$export($49f0f03e163f2585$exports, "CASES", () => $49f0f03e163f2585$export$ddbef7dfaa374d2d);
"use strict";
const $49f0f03e163f2585$export$ddbef7dfaa374d2d = {};


var $fc04128916812e44$exports = {};

$parcel$export($fc04128916812e44$exports, "ANIMATION", () => $fc04128916812e44$export$a8fef325e42f6db3);
"use strict";
const $fc04128916812e44$export$a8fef325e42f6db3 = {};


var $f4fd3215e1191093$exports = {};

$parcel$export($f4fd3215e1191093$exports, "SVG", () => $f4fd3215e1191093$export$13f4b12aafeba5d6);
$parcel$export($f4fd3215e1191093$exports, "SVG_DATA", () => $f4fd3215e1191093$export$9738e40199601663);
"use strict";
const $f4fd3215e1191093$export$13f4b12aafeba5d6 = {};
const $f4fd3215e1191093$export$9738e40199601663 = {};


var $a13c32e8633d5002$exports = {};

$parcel$export($a13c32e8633d5002$exports, "TEMPLATES", () => $a13c32e8633d5002$export$b8020e85ad90bfe5);
"use strict";
const $a13c32e8633d5002$export$b8020e85ad90bfe5 = {};


"use strict";
const $9da0db98e0c07b6d$export$4a991c87e640ef77 = {};
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $d2de3d327c0c6201$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $9ac3be22fd3c73fc$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $cc16a6638a049274$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $2015873c4c2cfb72$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $814e605b31851b50$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $1dbcec70a81fc9be$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $950c64c959f06041$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $891220fdda3d21a2$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $d3a916a1fb7d8435$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $8bcf1bed1aa8dad9$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $60fc9d3d8a249143$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $0cc3469566cd77c9$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $438de410da63932f$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $567db250b885dfb6$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $49f0f03e163f2585$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $fc04128916812e44$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $f4fd3215e1191093$exports);
$parcel$exportWildcard($9da0db98e0c07b6d$exports, $a13c32e8633d5002$exports);


"use strict";
const $5a3b725cdb25b0eb$export$220f2e5d84ced4cb = {};
const $5a3b725cdb25b0eb$export$1630b5343357e8b5 = {
    verbose: false,
    useVariable: true,
    useReset: true,
    CSS_VARS: $5a3b725cdb25b0eb$export$220f2e5d84ced4cb,
    ...$9da0db98e0c07b6d$exports
};
const $5a3b725cdb25b0eb$var$cachedConfig = (0, $8wu6n.deepClone)($5a3b725cdb25b0eb$export$1630b5343357e8b5);
const $5a3b725cdb25b0eb$export$ee513c29aad6cc62 = {
    active: "0",
    0: $5a3b725cdb25b0eb$export$1630b5343357e8b5
};
const $5a3b725cdb25b0eb$export$8a278b801d0668ff = (def)=>{
    if ((0, $EqHTq.isDefined)(def)) $5a3b725cdb25b0eb$export$ee513c29aad6cc62.active = def;
    return $5a3b725cdb25b0eb$export$ee513c29aad6cc62[def || $5a3b725cdb25b0eb$export$ee513c29aad6cc62.active];
};
const $5a3b725cdb25b0eb$export$e23c3d522afb24cd = (def)=>{
    return $5a3b725cdb25b0eb$export$ee513c29aad6cc62[def || $5a3b725cdb25b0eb$export$ee513c29aad6cc62.active];
};
const $5a3b725cdb25b0eb$export$5e61d1b6fff0c794 = (newConfig)=>{
    if (!(0, $EqHTq.isObject)(newConfig)) return;
    $5a3b725cdb25b0eb$export$ee513c29aad6cc62.active = "1";
    $5a3b725cdb25b0eb$export$ee513c29aad6cc62["1"] = (0, $8wu6n.deepMerge)(newConfig, (0, $8wu6n.deepClone)($5a3b725cdb25b0eb$var$cachedConfig));
    return newConfig;
};



"use strict";
const $366218d35fdab076$export$81ab9dc24d52c4ba = {
    "-6": "U",
    "-5": "V",
    "-4": "W",
    "-3": "X",
    "-2": "Y",
    "-1": "Z",
    0: "A",
    1: "B",
    2: "C",
    3: "D",
    4: "E",
    5: "F",
    6: "G",
    7: "H",
    8: "I",
    9: "J",
    10: "K",
    11: "L",
    12: "M",
    13: "N",
    14: "O",
    15: "P",
    16: "Q",
    17: "R",
    18: "S",
    19: "T"
};
const $366218d35fdab076$var$setSequenceValue = (props, sequenceProps)=>{
    const { key: key, variable: variable, value: value, scaling: scaling, index: index, scalingVariable: scalingVariable } = props;
    sequenceProps.sequence[key] = {
        key: key,
        decimal: ~~(value * 100) / 100,
        val: ~~value,
        scaling: scaling,
        index: index,
        scalingVariable: scalingVariable,
        variable: variable
    };
    sequenceProps.scales[key] = scaling;
    sequenceProps.vars[variable] = scaling + sequenceProps.unit;
};
const $366218d35fdab076$export$68dfa61d698afbde = (key, sequenceProps)=>{
    const { base: base, type: type, unit: unit } = sequenceProps;
    const defaultVal = ((0, $18dbdacc7a38df0d$export$6a836bb704f10b75)(unit) ? 1 : base) + unit;
    if (key === 0) return defaultVal;
    const prefix = "--" + (type && type.replace(".", "-"));
    const ratioVar = `${prefix}-ratio`;
    if (key > 0) {
        const prevLetterKey = $366218d35fdab076$export$81ab9dc24d52c4ba[key - 1];
        return `calc(var(${prefix}-${prevLetterKey}) * var(${ratioVar}))`;
    }
    if (key < 0) {
        const nextLetterKey = $366218d35fdab076$export$81ab9dc24d52c4ba[key + 1];
        return `calc(var(${prefix}-${nextLetterKey}) / var(${ratioVar}))`;
    }
};
const $366218d35fdab076$export$c9d5ef57eeb83fa = (index, arr, variable, sequenceProps)=>{
    const { type: type } = sequenceProps;
    const skipMiddle = index === 2 && arr.length === 2;
    const indexMapWithLength = skipMiddle ? index + 1 : index;
    const prefix = "--" + (type && type.replace(".", "-"));
    const subRatioVarPrefix = `${prefix}-sub-ratio-`;
    return `calc(var(${variable}) * var(${subRatioVarPrefix + indexMapWithLength}))`;
};
const $366218d35fdab076$export$12adf55fdaa50348 = (base, ratio)=>{
    const diff = base * ratio - base;
    const subRatio = diff / 1.618;
    const first = base * ratio - subRatio;
    const second = base + subRatio;
    const middle = (first + second) / 2;
    return [
        first,
        middle,
        second
    ];
};
const $366218d35fdab076$export$50db87b17b1557b4 = (base, ratio)=>{
    return $366218d35fdab076$export$12adf55fdaa50348(base, ratio).map((v)=>v / base);
};
const $366218d35fdab076$export$622ae6209895c34e = (props, sequenceProps)=>{
    const { key: key, base: base, value: value, ratio: ratio, variable: variable, index: index } = props;
    const next = value * ratio;
    const diffRounded = ~~next - ~~value;
    let arr;
    const [first, middle, second] = $366218d35fdab076$export$12adf55fdaa50348(value, ratio);
    if (diffRounded > 16) arr = [
        first,
        middle,
        second
    ];
    else arr = [
        first,
        second
    ];
    arr.forEach((v, k)=>{
        const scaling = ~~(v / base * 1000) / 1000;
        const newVar = variable + (k + 1);
        const newIndex = index + (k + 1) / 10;
        const scalingVariable = $366218d35fdab076$export$c9d5ef57eeb83fa(k + 1, arr, variable, sequenceProps);
        const props = {
            key: key + (k + 1),
            variable: newVar,
            value: v,
            scaling: scaling,
            scalingVariable: scalingVariable,
            index: newIndex
        };
        $366218d35fdab076$var$setSequenceValue(props, sequenceProps);
    });
};
const $366218d35fdab076$var$switchSequenceOnNegative = (key, base, ratio)=>{
    // const values = Object.values(SEQUENCE)
    // const index = values.indexOf(ratio)
    // const diffRatio = ratio / SPACING.ratio
    // const total = values[values.length - 1] - values[0]
    // const avg = total / 2
    // const diff = avg - ratio
    // const scale = total / ratio
    // const finalDiff = avg + avg / diffRatio
    // if (key < 0) return base * Math.pow(avg, key)
    return base * Math.pow(ratio, key);
};
const $366218d35fdab076$export$29708af739d9b0fc = (sequenceProps)=>{
    const { type: type, base: base, ratio: ratio, range: range, subSequence: subSequence } = sequenceProps;
    const n = Math.abs(range[0]) + Math.abs(range[1]);
    const prefix = "--" + (type && type.replace(".", "-")) + "-";
    for(let i = 0; i <= n; i++){
        const key = range[1] - i;
        const letterKey = $366218d35fdab076$export$81ab9dc24d52c4ba[key];
        const value = $366218d35fdab076$var$switchSequenceOnNegative(key, base, ratio);
        const scaling = ~~(value / base * 100) / 100;
        const variable = prefix + letterKey;
        const scalingVariable = $366218d35fdab076$export$68dfa61d698afbde(key, sequenceProps);
        const props = {
            key: letterKey,
            variable: variable,
            value: value,
            base: base,
            scaling: scaling,
            scalingVariable: scalingVariable,
            ratio: ratio,
            index: key
        };
        $366218d35fdab076$var$setSequenceValue(props, sequenceProps);
        if (subSequence) $366218d35fdab076$export$622ae6209895c34e(props, sequenceProps);
    }
    return sequenceProps;
};
const $366218d35fdab076$export$efde09b5692f9bd0 = (value = "A", sequenceProps)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { UNIT: UNIT } = CONFIG;
    const { sequence: sequence, unit: unit = UNIT.default, useVariable: useVariable } = sequenceProps;
    if ((0, $EqHTq.isString)(value) && value.slice(0, 2) === "--") return `var(${value})`;
    const prefix = `--${(0, $8319f99b46b296c9$export$6401d9e8afa09755)(sequenceProps.type.replace(".", "-"))}-`;
    const startsWithDashOrLetterRegex = /^-?[a-zA-Z]/i;
    const startsWithDashOrLetter = startsWithDashOrLetterRegex.test(value);
    if (value === "none" || value === "auto" || value === "unset" || value === "inherit" || value === "fit-content" || value === "min-content" || value === "max-content" || value.includes("calc") || value.includes("var") || !startsWithDashOrLetter) return value;
    const letterVal = value.toUpperCase();
    const isNegative = letterVal.slice(0, 1) === "-" ? "-" : "";
    let absValue = isNegative ? letterVal.slice(1) : letterVal;
    let mediaName = "";
    if (absValue.includes("_")) {
        mediaName = "_" + absValue.split("_")[1].toLowerCase();
        absValue = absValue.split("_")[0];
    }
    const varValue = (v)=>startsWithDashOrLetterRegex.test(v) ? `var(${prefix}${v}${mediaName})` : v;
    if (absValue.includes("+")) {
        const [first, second] = absValue.split("+");
        const joint = `${varValue(first)} + ${varValue(second)}`;
        return isNegative ? `calc((${joint}) * -1)` : `calc(${joint})`;
    } else if (absValue.includes("*")) {
        const [first, second] = absValue.split("*");
        const joint = `${varValue(first)} * ${varValue(second)}`;
        return isNegative ? `calc((${joint}) * -1)` : `calc(${joint})`;
    } else if (absValue.includes("-")) {
        // TODO: check this
        // check for the first char
        const [first, second] = absValue.split("-");
        const joint = `${varValue(first)} - ${varValue(second)}`;
        return isNegative ? `calc((${joint}) * -1)` : `calc(${joint})`;
    }
    // if subsequence is not set but value is applied
    if (!sequence[absValue] && absValue.length === 2) {
        if (CONFIG.verbose) console.warn(absValue, "- value is not found because `subSequence` is set to false");
        absValue = absValue.slice(0, 1);
    }
    if (useVariable || CONFIG.useVariable) {
        const varValue = `var(${prefix}${absValue}${mediaName})`;
        return isNegative ? `calc(${varValue} * -1)` : varValue;
    }
    const sequenceItem = sequence ? sequence[absValue] : null;
    if (!sequenceItem) return console.warn("can't find", sequence, absValue);
    if (unit === "ms" || unit === "s") return isNegative + sequenceItem.val + unit;
    return isNegative + sequenceItem.scaling + unit;
};
const $366218d35fdab076$export$86c0052f25dacc45 = (value, propertyName, sequenceProps)=>{
    if (typeof value !== "string") {
        console.warn(propertyName, value, "is not a string");
        return {
            [propertyName]: value
        };
    }
    if (value === "-" || value === "") return {};
    return {
        [propertyName]: $366218d35fdab076$export$efde09b5692f9bd0(value, sequenceProps)
    };
};
const $366218d35fdab076$export$14c834a042d41297 = (h1Matches, index)=>$366218d35fdab076$export$81ab9dc24d52c4ba[h1Matches - index];
const $366218d35fdab076$export$8dc77c00fe04c40a = (propertyNames)=>{
    const { h1Matches: h1Matches, sequence: sequence } = propertyNames;
    return new Array(6).fill(null).map((_, i)=>{
        const findLetter = $366218d35fdab076$export$14c834a042d41297(h1Matches, i);
        return sequence[findLetter];
    });
};


var $313f46bb97bb8cbe$exports = {};

$parcel$export($313f46bb97bb8cbe$exports, "setVariables", () => $313f46bb97bb8cbe$export$7c38483ff47439d8);
$parcel$export($313f46bb97bb8cbe$exports, "applySequenceGlobalVars", () => $313f46bb97bb8cbe$export$eba6b21fdce78bcd);
$parcel$export($313f46bb97bb8cbe$exports, "applySequenceVars", () => $313f46bb97bb8cbe$export$97ab4e7d8ade5018);
$parcel$export($313f46bb97bb8cbe$exports, "applyMediaSequenceVars", () => $313f46bb97bb8cbe$export$768e417cbfe71417);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");



"use strict";
const $313f46bb97bb8cbe$export$7c38483ff47439d8 = (result, key)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { CSS_VARS: CSS_VARS } = CONFIG;
    if ((0, $EqHTq.isObjectLike)(result.value)) ;
    else CSS_VARS[result.var] = result.value;
};
const $313f46bb97bb8cbe$export$eba6b21fdce78bcd = (vars, obj, options)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { UNIT: UNIT } = CONFIG;
    const unit = obj.unit || UNIT.default;
    const { base: base, ratio: ratio, type: type } = obj;
    const prefix = "--" + (type && type.replace(".", "-"));
    vars[`${prefix}-base`] = base;
    vars[`${prefix}-unit`] = unit;
    const ratioVar = `${prefix}-ratio`;
    vars[ratioVar] = ratio;
    const [first, middle, second] = (0, $366218d35fdab076$export$50db87b17b1557b4)(base, ratio);
    vars[`${prefix}-sub-ratio-1`] = `calc(var(${prefix}-ratio) * ${first / ratio})`;
    vars[`${prefix}-sub-ratio-2`] = `calc(var(${prefix}-ratio) * ${middle / ratio})`;
    vars[`${prefix}-sub-ratio-3`] = `calc(var(${prefix}-ratio) * ${second / ratio})`;
// vars[`${prefix}-sub-ratio-1`] = first
// vars[`${prefix}-sub-ratio-2`] = middle
// vars[`${prefix}-sub-ratio-3`] = second
};
const $313f46bb97bb8cbe$export$97ab4e7d8ade5018 = (FACTORY, options = {})=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { UNIT: UNIT, TIMING: TIMING, CSS_VARS: CSS_VARS } = CONFIG;
    const unit = FACTORY.unit || UNIT.default;
    const { mediaRegenerate: mediaRegenerate, sequence: sequence, scales: scales } = FACTORY;
    if (!mediaRegenerate) $313f46bb97bb8cbe$export$eba6b21fdce78bcd(CSS_VARS, FACTORY, options);
    for(const key in sequence){
        const item = sequence[key];
        const value = (FACTORY.type === TIMING.type ? sequence[key].val : scales[key]) + unit;
        if (!mediaRegenerate) {
            CSS_VARS[item.variable + "_default"] = value;
            CSS_VARS[item.variable] = item.scalingVariable;
            continue;
        }
        if (options.useDefault === false) CSS_VARS[item.variable] = value;
        else {
            CSS_VARS[item.variable + "_default"] = value;
            CSS_VARS[item.variable] = `var(${item.variable + "_default"})`;
        }
    }
};
const $313f46bb97bb8cbe$export$768e417cbfe71417 = (FACTORY, media, options = {})=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { UNIT: UNIT, MEDIA: MEDIA, CSS_VARS: CSS_VARS } = CONFIG;
    const mediaName = media.slice(1);
    const unit = FACTORY.unit || UNIT.default;
    const { mediaRegenerate: mediaRegenerate } = FACTORY;
    const { sequence: sequence, scales: scales } = FACTORY[media];
    const query = MEDIA[mediaName];
    if (!query && CONFIG.verbose) console.warn("Can't find media query ", query);
    // if mediaRegenerate is not applied ratio and and sequence sizes
    // will be applied using CSS vars
    if (!mediaRegenerate) {
        let underMediaQuery = CSS_VARS[`@media ${query}`];
        if (!underMediaQuery) underMediaQuery = CSS_VARS[`@media ${query}`] = {};
        $313f46bb97bb8cbe$export$eba6b21fdce78bcd(underMediaQuery, FACTORY[media], options);
        return;
    }
    for(const key in sequence){
        const item = sequence[key];
        const value = ((0, $18dbdacc7a38df0d$export$6a836bb704f10b75)(unit) ? scales[key] : sequence[key].val) + unit;
        if (!query && CONFIG.verbose) console.warn("Can't find query ", query);
        let underMediaQuery = CSS_VARS[`@media ${query}`];
        if (!underMediaQuery) underMediaQuery = CSS_VARS[`@media ${query}`] = {};
        underMediaQuery[item.variable] = `var(${item.variable + "_" + mediaName})`;
        CSS_VARS[item.variable + "_" + mediaName] = value;
    }
};


var $da07070d258f49a5$exports = {};

$parcel$export($da07070d258f49a5$exports, "generateSprite", () => $da07070d258f49a5$export$121b8d85aca89bf6);
$parcel$export($da07070d258f49a5$exports, "convertSvgToSymbol", () => $da07070d258f49a5$export$510fb280711ea968);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");

"use strict";
const $da07070d258f49a5$export$121b8d85aca89bf6 = (icons)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    let sprite = "";
    for(const key in icons){
        if (CONFIG.__svg_cache[key]) continue;
        else CONFIG.__svg_cache[key] = true;
        sprite += icons[key];
    }
    return sprite;
};
const $da07070d258f49a5$var$parseRootAttributes = (htmlString)=>{
    if (!(0, $EqHTq.isString)(htmlString)) return console.warn(`parseRootAttributes: ${htmlString} is not a string`);
    const match = htmlString.match(/<svg\s+(.*?)>/);
    if (!match || !match[1]) return {};
    const attrString = match[1];
    const attrs = attrString.match(/(\S+)=["']?((?:.(?!["']?\s+(?:\S+)=|\s*\/?[>"']))+.)["']?/gm);
    return attrs.reduce((acc, attr)=>{
        const [key, value] = attr.split("=");
        acc[key] = value.replace(/['"]/g, "");
        return acc;
    }, {});
};
const $da07070d258f49a5$var$replaceIdsAndUrls = (code, key)=>{
    const idRegex = /id="([^"]*)"/;
    const urlRegex = /url\(#([^)]*)\)/g;
    const matches = code.match(/id="([^"]*)"/g);
    let replacedCode = code;
    if ((0, $EqHTq.isArray)(matches)) matches.forEach(()=>{
        const randomKey = Math.floor(Math.random() * 100000);
        replacedCode = code.replace(idRegex, `id="${key}-${randomKey}"`).replace(urlRegex, `url(#${key}-${randomKey})`);
    });
    return replacedCode;
};
const $da07070d258f49a5$export$510fb280711ea968 = (key, code)=>{
    const extractAttrs = $da07070d258f49a5$var$parseRootAttributes(code);
    const { width: width, height: height } = extractAttrs;
    const viewBox = extractAttrs.viewBox || `0 0 ${width || 24} ${height || 24}`;
    const xmlns = "http://www.w3.org/2000/svg";
    const replacedCode = $da07070d258f49a5$var$replaceIdsAndUrls(code, key);
    let symbol = replacedCode.replace("<svg", `<symbol id="${key}" xmlns="${xmlns}" viewBox="${viewBox}"`);
    symbol = symbol.replace(/width="[^"]*"/, "");
    symbol = symbol.replace(/height="[^"]*"/, "");
    symbol = symbol.replace("</svg", "</symbol");
    return symbol;
};


"use strict";
$parcel$exportWildcard($75f36cb383311abc$exports, $18dbdacc7a38df0d$exports);
$parcel$exportWildcard($75f36cb383311abc$exports, $1ef99b0b26632769$exports);
$parcel$exportWildcard($75f36cb383311abc$exports, $08f037a4512e32ac$exports);
$parcel$exportWildcard($75f36cb383311abc$exports, $acb660e77bec9cb5$exports);
$parcel$exportWildcard($75f36cb383311abc$exports, $366218d35fdab076$exports);
$parcel$exportWildcard($75f36cb383311abc$exports, $313f46bb97bb8cbe$exports);
$parcel$exportWildcard($75f36cb383311abc$exports, $da07070d258f49a5$exports);


var $30c1eb8bbbe7b5d7$exports = {};
var $c6753c52b98cd54e$exports = {};

$parcel$export($c6753c52b98cd54e$exports, "getColor", () => $c6753c52b98cd54e$export$5551a2d24ff40153);
$parcel$export($c6753c52b98cd54e$exports, "getMediaColor", () => $c6753c52b98cd54e$export$dd72f6d9deea7207);
$parcel$export($c6753c52b98cd54e$exports, "setColor", () => $c6753c52b98cd54e$export$130a5dc1bc9cd8e1);
$parcel$export($c6753c52b98cd54e$exports, "setGradient", () => $c6753c52b98cd54e$export$afaa8352c6a43a44);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");


"use strict";
const $c6753c52b98cd54e$export$5551a2d24ff40153 = (value, key, config)=>{
    const CONFIG = config || (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    if (!(0, $EqHTq.isString)(value)) {
        if (CONFIG.verbose) console.warn(value, "- type for color is not valid");
        return;
    }
    if (value.slice(0, 2) === "--") return `var(${value})`;
    if (key && value[key]) value = value[key];
    const [name, alpha, tone] = (0, $EqHTq.isArray)(value) ? value : value.split(" ");
    const { COLOR: COLOR, GRADIENT: GRADIENT } = CONFIG;
    let val = COLOR[name] || GRADIENT[name];
    if (!val) {
        if (CONFIG.verbose) console.warn("Can't find color ", name);
        return value;
    }
    if (key) {
        if (val[key]) val = val[key];
        else if (CONFIG.verbose) console.warn(value, " - does not have ", key);
    }
    // TODO: support variables
    // if (alpha) return `rgba(var(${val[shade || ''].var}), ${modifier})`
    let rgb = val.rgb;
    if (!rgb) return CONFIG.useVariable ? `var(${val.var})` : val.value;
    if (tone && !val[tone]) {
        rgb = (0, $1ef99b0b26632769$export$2d78fefdcfb7f222)(rgb, tone);
        val[tone] = {
            rgb: rgb,
            var: `${val.var}-${tone}`
        };
    }
    if (val[tone]) rgb = val[tone].rgb;
    if (alpha) return `rgba(${rgb}, ${alpha})`;
    return CONFIG.useVariable ? `var(${val.var})` : `rgb(${rgb})`;
};
const $c6753c52b98cd54e$export$dd72f6d9deea7207 = (value, globalTheme, config)=>{
    const CONFIG = config || (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    if (!globalTheme) globalTheme = CONFIG.globalTheme;
    if (!(0, $EqHTq.isString)(value)) {
        if (CONFIG.verbose) console.warn(value, "- type for color is not valid");
        return;
    }
    if (value.slice(0, 2) === "--") return `var(${value})`;
    const [name] = (0, $EqHTq.isArray)(value) ? value : value.split(" ");
    const { COLOR: COLOR, GRADIENT: GRADIENT } = CONFIG;
    const val = COLOR[name] || GRADIENT[name];
    const isObj = (0, $EqHTq.isObject)(val);
    if (isObj && val.value) return $c6753c52b98cd54e$export$5551a2d24ff40153(value, `@${globalTheme}`, config);
    else if (isObj) {
        if (globalTheme) return $c6753c52b98cd54e$export$5551a2d24ff40153(value, `@${globalTheme}`, config);
        else {
            const obj = {};
            for(const mediaName in val){
                const query = CONFIG.MEDIA[mediaName.slice(1)];
                const media = `@media screen and ${query}`;
                obj[media] = $c6753c52b98cd54e$export$5551a2d24ff40153(value, mediaName, config);
            }
            return obj;
        }
    } else {
        if (CONFIG.verbose) console.warn("Can't find color", value);
        return value;
    }
};
const $c6753c52b98cd54e$export$130a5dc1bc9cd8e1 = (val, key, suffix)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    if ((0, $EqHTq.isString)(val) && val.slice(0, 2) === "--") val = $c6753c52b98cd54e$export$5551a2d24ff40153(val.slice(2));
    if ((0, $EqHTq.isArray)(val)) return {
        "@light": $c6753c52b98cd54e$export$130a5dc1bc9cd8e1(val[0], key, "light"),
        "@dark": $c6753c52b98cd54e$export$130a5dc1bc9cd8e1(val[1], key, "dark")
    };
    if ((0, $EqHTq.isObject)(val)) {
        const obj = {};
        for(const variant in val)obj[variant] = $c6753c52b98cd54e$export$130a5dc1bc9cd8e1(val[variant], key, variant.slice(0, 1) === "@" ? variant.slice(1) : variant);
        return obj;
    }
    const CSSVar = `--color-${key}` + (suffix ? `-${suffix}` : "");
    const [r, g, b, a = 1] = (0, $1ef99b0b26632769$export$fa32e9c99a43479e)(val.value || val);
    const alpha = parseFloat(a.toFixed(2));
    const rgb = `${r}, ${g}, ${b}`;
    const value = `rgba(${rgb}, ${alpha})`;
    if (CONFIG.useVariable) CONFIG.CSS_VARS[CSSVar] = value;
    return {
        var: CSSVar,
        rgb: rgb,
        alpha: alpha,
        value: value
    };
};
const $c6753c52b98cd54e$export$afaa8352c6a43a44 = (val, key, suffix)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    if ((0, $EqHTq.isString)(val) && val.slice(0, 2) === "--") val = $c6753c52b98cd54e$export$5551a2d24ff40153(val.slice(2));
    if ((0, $EqHTq.isArray)(val)) return {
        "@light": $c6753c52b98cd54e$export$afaa8352c6a43a44(val[0], key, "light"),
        "@dark": $c6753c52b98cd54e$export$afaa8352c6a43a44(val[0], key, "dark")
    };
    if ((0, $EqHTq.isObject)(val)) {
        const obj = {};
        for(const variant in val)obj[variant] = $c6753c52b98cd54e$export$afaa8352c6a43a44(val[variant], key, variant.slice(0, 1) === "@" ? variant.slice(1) : variant);
        return obj;
    }
    const CSSVar = `--gradient-${key}` + (suffix ? `-${suffix}` : "");
    if (CONFIG.useVariable) CONFIG.CSS_VARS[CSSVar] = val.value || val;
    return {
        var: CSSVar,
        value: val.value || val
    };
};


var $50bcf74814855f89$exports = {};

$parcel$export($50bcf74814855f89$exports, "getTheme", () => $50bcf74814855f89$export$89cbf1a0881c8b9c);
$parcel$export($50bcf74814855f89$exports, "getMediaTheme", () => $50bcf74814855f89$export$b3cf7317de2f2233);
$parcel$export($50bcf74814855f89$exports, "setTheme", () => $50bcf74814855f89$export$2e49b867b7a0847c);
$parcel$export($50bcf74814855f89$exports, "setMediaTheme", () => $50bcf74814855f89$export$c57b11cd015ce162);


parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $50bcf74814855f89$var$setThemeValue = (theme)=>{
    const value = {};
    const { state: state, media: media, helpers: helpers, ...rest } = theme;
    const keys = Object.keys(rest);
    keys.map((key)=>{
        const conditions = [
            "color",
            "Color",
            "background",
            "border"
        ];
        const isColor = conditions.some((k)=>key.includes(k));
        return value[key] = isColor ? (0, $c6753c52b98cd54e$export$5551a2d24ff40153)(theme[key]) : theme[key];
    });
    return value;
};
const $50bcf74814855f89$var$getThemeValue = (theme)=>{
    if (theme.value) return theme.value;
    theme.value = $50bcf74814855f89$var$setThemeValue(theme);
    return theme.value;
};
const $50bcf74814855f89$export$89cbf1a0881c8b9c = (value, modifier)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    if (CONFIG.useVariable) return $50bcf74814855f89$export$b3cf7317de2f2233(value, modifier);
    const { THEME: THEME } = CONFIG;
    if ((0, $EqHTq.isString)(value)) {
        const [theme, subtheme] = value.split(" ");
        const isOurTheme = THEME[theme];
        if (isOurTheme) {
            if (!subtheme && !modifier) return $50bcf74814855f89$var$getThemeValue(isOurTheme);
            value = [
                theme,
                subtheme || modifier
            ];
        }
    }
    if ((0, $EqHTq.isObjectLike)(value) && value[1]) {
        const themeName = value[0];
        const subThemeName = value[1];
        const { helpers: helpers, media: media, state: state } = THEME[themeName];
        if (media && media[subThemeName]) return $50bcf74814855f89$var$getThemeValue(media[subThemeName]);
        if (helpers && helpers[subThemeName]) return $50bcf74814855f89$var$getThemeValue(helpers[subThemeName]);
        if (state && state[subThemeName]) return $50bcf74814855f89$var$getThemeValue(state[subThemeName]);
    } else if ((0, $EqHTq.isObject)(value)) return $50bcf74814855f89$var$setThemeValue(value);
};
const $50bcf74814855f89$var$setInverseTheme = (theme, variant, value)=>{
    if ((0, $EqHTq.isObject)(variant)) theme.variants.inverse.value = $50bcf74814855f89$var$setThemeValue(variant);
    else if (variant === true) {
        const { color: color, background: background } = value;
        theme.variants.inverse = {
            value: {
                color: background,
                background: color
            }
        };
    }
};
const $50bcf74814855f89$var$setPseudo = (theme, key, variant, themeValue)=>{
    const result = $50bcf74814855f89$export$89cbf1a0881c8b9c(variant);
    themeValue[`&:${key}`] = result;
    if ((0, $EqHTq.isObject)(variant) && !variant.value) variant.value = result;
};
const $50bcf74814855f89$var$setSelectors = (theme, value)=>{
    const { state: state } = theme;
    if (!state) return;
    const keys = Object.keys(state);
    keys.map((key)=>{
        const variant = state[key];
        $50bcf74814855f89$var$setPseudo(theme, key, variant, value);
        return theme;
    });
    return theme;
};
const $50bcf74814855f89$var$setPrefersScheme = (theme, key, variant, themeValue)=>{
    const result = $50bcf74814855f89$export$89cbf1a0881c8b9c(variant);
    themeValue[`@media (prefers-color-scheme: ${key})`] = result;
    if ((0, $EqHTq.isObject)(variant) && !variant.value) variant.value = result;
};
const $50bcf74814855f89$var$setMedia = (theme, value)=>{
    const { media: media } = theme;
    if (!media) return;
    const keys = Object.keys(media);
    keys.map((key)=>{
        const variant = media[key];
        if (key === "dark" || key === "light") $50bcf74814855f89$var$setPrefersScheme(theme, key, variant, value);
        if (key === "inverse") $50bcf74814855f89$var$setInverseTheme(theme, variant, value);
        return theme;
    });
    return theme;
};
const $50bcf74814855f89$var$setHelpers = (theme, value)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { helpers: helpers } = theme;
    if (!helpers) return;
    const keys = Object.keys(helpers);
    keys.map((key)=>{
        const helper = helpers[key];
        if ((0, $EqHTq.isString)(helper)) helpers[key] = CONFIG.THEME[helper];
        else $50bcf74814855f89$var$getThemeValue(helpers[key]);
        return theme;
    });
    return theme;
};
const $50bcf74814855f89$export$2e49b867b7a0847c = (val, key)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    if (CONFIG.useVariable) return $50bcf74814855f89$export$c57b11cd015ce162(val, key);
    const { state: state, media: media, helpers: helpers } = val;
    const value = $50bcf74814855f89$var$setThemeValue(val, key);
    const CSSvar = `--theme-${key}`;
    $50bcf74814855f89$var$setSelectors(val, value);
    $50bcf74814855f89$var$setMedia(val, value);
    $50bcf74814855f89$var$setHelpers(val, value);
    return {
        var: CSSvar,
        value: value,
        state: state,
        media: media,
        helpers: helpers
    };
};
const $50bcf74814855f89$var$keySetters = {
    "@": (theme, value)=>$50bcf74814855f89$var$setMedia(theme, value),
    ":": (theme, value)=>$50bcf74814855f89$var$setSelectors(theme, value),
    ".": (theme, value)=>$50bcf74814855f89$var$setHelpers(theme, value)
};
const $50bcf74814855f89$export$c57b11cd015ce162 = (val, key, suffix, prefers)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { CSS_VARS: CSS_VARS } = CONFIG;
    const theme = {
        value: val
    };
    if ((0, $EqHTq.isObjectLike)(val)) {
        for(const param in val){
            const symb = param.slice(0, 1);
            const value = val[param];
            if (symb === "@" || symb === ":" || symb === ".") {
                const hasPrefers = symb === "@" && param;
                theme[param] = $50bcf74814855f89$export$c57b11cd015ce162(value, key, param, prefers || hasPrefers);
            } else {
                const color = (0, $c6753c52b98cd54e$export$5551a2d24ff40153)(value, prefers);
                const metaSuffixes = [
                    ...new Set([
                        prefers,
                        suffix
                    ].filter((v)=>v).map((v)=>v.slice(1)))
                ];
                const varmetaSuffixName = metaSuffixes.length ? "-" + metaSuffixes.join("-") : "";
                const CSSVar = `--theme-${key}${varmetaSuffixName}-${param}`;
                if (CONFIG.useVariable) {
                    CSS_VARS[CSSVar] = color;
                    theme[param] = `var(${CSSVar})`;
                } else theme[param] = color;
                theme[`.${param}`] = {
                    [param]: theme[param]
                };
            }
        }
        if (theme.background || theme.color || theme.backgroundColor) theme[".inversed"] = {
            color: theme.background || theme.backgroundColor,
            background: theme.color
        };
    }
    if ((0, $EqHTq.isString)(val) && val.slice(0, 2) === "--") {
        const { THEME: THEME } = CONFIG;
        const value = THEME[val.slice(2)];
        const getReferenced = $50bcf74814855f89$export$b3cf7317de2f2233(value, prefers);
        return getReferenced;
    }
    return theme;
};
const $50bcf74814855f89$var$recursiveTheme = (val)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const obj = {};
    for(const param in val){
        const symb = param.slice(0, 1);
        if ((0, $EqHTq.isObjectLike)(val[param])) {
            if (symb === "@") {
                const query = CONFIG.MEDIA[param.slice(1)];
                const media = `@media screen and ${query}`;
                obj[media] = $50bcf74814855f89$var$recursiveTheme(val[param]);
            } else if (symb === ":") obj[`&${param}`] = $50bcf74814855f89$var$recursiveTheme(val[param]);
        } else obj[param] = val[param];
    }
    return obj;
};
const $50bcf74814855f89$var$findModifierFromArray = (val, modifierArray)=>{
    const currentMod = modifierArray.shift();
    if (val[currentMod]) return $50bcf74814855f89$var$findModifierFromArray(val[currentMod], modifierArray);
    return val;
};
const $50bcf74814855f89$var$findModifier = (val, modifier)=>{
    if ((0, $EqHTq.isArray)(modifier)) return $50bcf74814855f89$var$findModifierFromArray(val, modifier);
    else if ((0, $EqHTq.isString)(modifier) && val[modifier]) return val[modifier];
    else return val;
};
const $50bcf74814855f89$var$checkForReference = (val, callback)=>{
    if ((0, $EqHTq.isString)(val) && val.slice(0, 2) === "--") return $50bcf74814855f89$export$b3cf7317de2f2233(val.slice(2));
    return val;
};
const $50bcf74814855f89$var$checkThemeReference = (val)=>$50bcf74814855f89$var$checkForReference(val, $50bcf74814855f89$var$checkThemeReference) // eslint-disable-line
;
const $50bcf74814855f89$export$b3cf7317de2f2233 = (value, modifier)=>{
    const activeConfig = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    if ((0, $EqHTq.isString)(value) && value.slice(0, 2) === "--") value = $50bcf74814855f89$export$b3cf7317de2f2233(value.slice(2));
    if (!value || !(0, $EqHTq.isString)(value)) {
        if (activeConfig.verbose) console.warn(`${value} - Theme is not a string`);
        return;
    }
    const [themeName, ...themeModifiers] = (0, $EqHTq.isArray)(value) ? value : value.split(" ");
    let themeValue = activeConfig.THEME[themeName];
    if (themeValue && (themeModifiers || modifier)) themeValue = $50bcf74814855f89$var$findModifier(themeValue, themeModifiers.length ? themeModifiers : modifier);
    const resolvedTheme = $50bcf74814855f89$var$recursiveTheme(themeValue);
    return resolvedTheme;
};


var $ed362cf167c3740b$exports = {};

$parcel$export($ed362cf167c3740b$exports, "setFont", () => $ed362cf167c3740b$export$69e9bdef456a9c46);
$parcel$export($ed362cf167c3740b$exports, "getFontFamily", () => $ed362cf167c3740b$export$c4930fc256cef44f);
$parcel$export($ed362cf167c3740b$exports, "setFontFamily", () => $ed362cf167c3740b$export$5fae120d779aafec);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");



"use strict";
const $ed362cf167c3740b$export$69e9bdef456a9c46 = (val, key)=>{
    const CSSvar = `--font-${key}`;
    if (!val || (0, $EqHTq.isArray)(val) && !val[0]) return;
    const fontFace = val[0] ? (0, $acb660e77bec9cb5$export$198e04e3616f042a)(key, val) : (0, $acb660e77bec9cb5$export$2593ac3417be5ed7)(key, val.url);
    return {
        var: CSSvar,
        value: val,
        fontFace: fontFace
    };
};
const $ed362cf167c3740b$export$c4930fc256cef44f = (key, factory)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { FONT_FAMILY: FONT_FAMILY } = CONFIG;
    return (0, $acb660e77bec9cb5$export$73aa7d12a2d2fb83)(factory || FONT_FAMILY, key);
};
const $ed362cf167c3740b$export$5fae120d779aafec = (val, key)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { FONT_FAMILY: FONT_FAMILY, FONT_FAMILY_TYPES: FONT_FAMILY_TYPES } = CONFIG;
    let { value: value, type: type } = val;
    if (val.isDefault) FONT_FAMILY.default = key;
    if ((0, $EqHTq.isObject)(value)) value = (0, $8319f99b46b296c9$export$d1ef4b1a340dec10)(value);
    const CSSvar = `--font-family-${key}`;
    const str = `${value.join(", ")}, ${FONT_FAMILY_TYPES[type]}`;
    return {
        var: CSSvar,
        value: str,
        arr: value,
        type: type
    };
};


var $277afaefb2791215$exports = {};

$parcel$export($277afaefb2791215$exports, "runThroughMedia", () => $277afaefb2791215$export$ee622839cb6e2b5d);
$parcel$export($277afaefb2791215$exports, "applyHeadings", () => $277afaefb2791215$export$7fc39a69c6299a60);
$parcel$export($277afaefb2791215$exports, "applyTypographySequence", () => $277afaefb2791215$export$7c7d7b0d076fe8b5);
$parcel$export($277afaefb2791215$exports, "getFontSizeByKey", () => $277afaefb2791215$export$ea9b2cd64205746b);
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");


"use strict";
const $277afaefb2791215$export$ee622839cb6e2b5d = (FACTORY)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { TYPOGRAPHY: TYPOGRAPHY, MEDIA: MEDIA } = CONFIG;
    for(const prop in FACTORY){
        const isPropMedia = prop.slice(0, 1) === "@";
        const mediaValue = FACTORY[prop];
        if (!isPropMedia) continue;
        const { mediaRegenerate: mediaRegenerate } = FACTORY;
        const mediaName = prop.slice(1);
        const { type: type, base: base, ratio: ratio, range: range, subSequence: subSequence, h1Matches: h1Matches, unit: unit } = FACTORY;
        (0, $8wu6n.merge)(mediaValue, {
            type: type,
            base: base,
            ratio: ratio,
            range: range,
            subSequence: subSequence,
            h1Matches: h1Matches,
            unit: unit
        });
        const query = MEDIA[mediaName];
        TYPOGRAPHY.templates[`@media screen and ${query}`] = {
            fontSize: mediaValue.base / TYPOGRAPHY.browserDefault + unit
        };
        if (!mediaRegenerate) {
            (0, $313f46bb97bb8cbe$export$768e417cbfe71417)(FACTORY, prop);
            continue;
        }
        (0, $8wu6n.merge)(mediaValue, {
            sequence: {},
            scales: {},
            templates: {},
            vars: {}
        });
        (0, $366218d35fdab076$export$29708af739d9b0fc)(mediaValue);
        (0, $313f46bb97bb8cbe$export$768e417cbfe71417)(FACTORY, prop);
    }
};
const $277afaefb2791215$export$7fc39a69c6299a60 = (props)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    if (props.h1Matches) {
        const unit = props.unit;
        const HEADINGS = (0, $366218d35fdab076$export$8dc77c00fe04c40a)(props);
        const { templates: templates } = props;
        for(const k in HEADINGS){
            const headerName = `h${parseInt(k) + 1}`;
            const headerStyle = templates[headerName];
            templates[headerName] = {
                fontSize: CONFIG.useVariable ? `var(${HEADINGS[k].variable})` : `${HEADINGS[k].scaling}${unit}`,
                margin: headerStyle ? headerStyle.margin : 0,
                lineHeight: headerStyle ? headerStyle.lineHeight : props.lineHeight,
                letterSpacing: headerStyle ? headerStyle.letterSpacing : props.letterSpacing,
                fontWeight: headerStyle ? headerStyle.fontWeight : 900 - k * 100
            };
        }
    }
};
const $277afaefb2791215$export$7c7d7b0d076fe8b5 = ()=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { TYPOGRAPHY: TYPOGRAPHY } = CONFIG;
    (0, $366218d35fdab076$export$29708af739d9b0fc)(TYPOGRAPHY);
    $277afaefb2791215$export$7fc39a69c6299a60(TYPOGRAPHY);
    (0, $313f46bb97bb8cbe$export$97ab4e7d8ade5018)(TYPOGRAPHY);
    $277afaefb2791215$export$ee622839cb6e2b5d(TYPOGRAPHY);
};
const $277afaefb2791215$export$ea9b2cd64205746b = (value)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { TYPOGRAPHY: TYPOGRAPHY } = CONFIG;
    return (0, $366218d35fdab076$export$86c0052f25dacc45)(value, "fontSize", TYPOGRAPHY);
};


var $7a9f91e2b97567cc$exports = {};

$parcel$export($7a9f91e2b97567cc$exports, "applySpacingSequence", () => $7a9f91e2b97567cc$export$9bfe8384addafa7c);
$parcel$export($7a9f91e2b97567cc$exports, "getSpacingByKey", () => $7a9f91e2b97567cc$export$4f949d23b5dbefe6);
$parcel$export($7a9f91e2b97567cc$exports, "getSpacingBasedOnRatio", () => $7a9f91e2b97567cc$export$94679ba49f16fc2e);

parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
var $8wu6n = parcelRequire("8wu6n");


"use strict";
const $7a9f91e2b97567cc$var$runThroughMedia = (FACTORY)=>{
    for(const prop in FACTORY){
        const mediaProps = FACTORY[prop];
        const isMediaName = prop.slice(0, 1) === "@";
        if (!isMediaName) continue;
        const { type: type, base: base, ratio: ratio, range: range, subSequence: subSequence, h1Matches: h1Matches, unit: unit } = FACTORY;
        (0, $8wu6n.merge)(mediaProps, {
            type: type,
            base: base,
            ratio: ratio,
            range: range,
            subSequence: subSequence,
            h1Matches: h1Matches,
            unit: unit,
            sequence: {},
            scales: {},
            templates: {},
            vars: {}
        });
        (0, $366218d35fdab076$export$29708af739d9b0fc)(mediaProps);
        (0, $313f46bb97bb8cbe$export$768e417cbfe71417)(FACTORY, prop);
    }
};
const $7a9f91e2b97567cc$export$9bfe8384addafa7c = ()=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { SPACING: SPACING } = CONFIG;
    (0, $366218d35fdab076$export$29708af739d9b0fc)(SPACING);
    (0, $313f46bb97bb8cbe$export$97ab4e7d8ade5018)(SPACING);
    $7a9f91e2b97567cc$var$runThroughMedia(SPACING);
};
const $7a9f91e2b97567cc$var$getSequence = (sequenceProps)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { SPACING: SPACING } = CONFIG;
    if (!sequenceProps) return SPACING;
    const hasGenerated = Object.keys(sequenceProps.sequence).length > 0;
    return hasGenerated ? sequenceProps : (0, $366218d35fdab076$export$29708af739d9b0fc)(sequenceProps);
};
const $7a9f91e2b97567cc$export$4f949d23b5dbefe6 = (value, propertyName = "padding", sequenceProps)=>{
    const sequence = $7a9f91e2b97567cc$var$getSequence(sequenceProps);
    if ((0, $EqHTq.isString)(value) && (value.includes("calc") || value.includes("var"))) return {
        [propertyName]: value
    };
    const stack = (0, $8319f99b46b296c9$export$d1ef4b1a340dec10)(value);
    if (!(0, $EqHTq.isArray)(stack)) return;
    if (stack.length > 1) {
        let suffix = "";
        if (propertyName === "borderWidth") {
            propertyName = "border";
            suffix = "Width";
        }
        const directions = {
            2: [
                "Block",
                "Inline"
            ],
            3: [
                "BlockStart",
                "Inline",
                "BlockEnd"
            ],
            4: [
                "BlockStart",
                "InlineEnd",
                "BlockEnd",
                "InlineStart"
            ]
        };
        const wrapSequenceValueByDirection = (direction, i)=>(0, $366218d35fdab076$export$86c0052f25dacc45)(stack[i], propertyName + direction + suffix, sequence);
        return directions[stack.length].map((dir, key)=>wrapSequenceValueByDirection(dir, key));
    }
    return (0, $366218d35fdab076$export$86c0052f25dacc45)(value, propertyName, sequence);
};
const $7a9f91e2b97567cc$export$94679ba49f16fc2e = (props, propertyName, val)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { SPACING: SPACING } = CONFIG;
    const { spacingRatio: spacingRatio, unit: unit } = props;
    const value = val || props[propertyName];
    if (spacingRatio) {
        let sequenceProps = SPACING[spacingRatio];
        if (!sequenceProps) {
            const { type: type, base: base, range: range, subSequence: subSequence } = SPACING;
            sequenceProps = SPACING[spacingRatio] = (0, $8wu6n.merge)({
                ratio: spacingRatio,
                type: type + "-" + spacingRatio,
                unit: unit,
                sequence: {},
                scales: {},
                templates: {},
                vars: {}
            }, {
                base: base,
                range: range,
                subSequence: subSequence,
                ratio: SPACING.ratio,
                unit: SPACING.unit
            });
        }
        (0, $313f46bb97bb8cbe$export$97ab4e7d8ade5018)(sequenceProps, {
            useDefault: false
        });
        return $7a9f91e2b97567cc$export$4f949d23b5dbefe6(value, propertyName, sequenceProps);
    }
    return $7a9f91e2b97567cc$export$4f949d23b5dbefe6(value, propertyName);
};


var $4a7f8e4f20ce09e5$exports = {};

$parcel$export($4a7f8e4f20ce09e5$exports, "setShadow", () => $4a7f8e4f20ce09e5$export$9cd3672191b5a46f);
$parcel$export($4a7f8e4f20ce09e5$exports, "getShadow", () => $4a7f8e4f20ce09e5$export$db93b77dbb14f011);



parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $4a7f8e4f20ce09e5$export$9cd3672191b5a46f = (value, key, suffix, prefers)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    // const { CSS_VARS } = CONFIG
    // const theme = { valueue: value }
    if ((0, $EqHTq.isArray)(value)) return {
        "@light": $4a7f8e4f20ce09e5$export$9cd3672191b5a46f(value[0], key, "light"),
        "@dark": $4a7f8e4f20ce09e5$export$9cd3672191b5a46f(value[1], key, "dark")
    };
    if ((0, $EqHTq.isObject)(value)) {
        const obj = {};
        for(const variant in value)obj[variant] = $4a7f8e4f20ce09e5$export$9cd3672191b5a46f(value[variant], key, variant.startsWith("@") ? variant.slice(1) : variant);
        return obj;
    }
    if ((0, $EqHTq.isString)(value) && value.includes(",")) value = value.split(",").map((v)=>{
        v = v.trim();
        if (v.startsWith("--")) return `var(${v})`;
        if ((0, $c6753c52b98cd54e$export$5551a2d24ff40153)(v).length > 2) return (0, $c6753c52b98cd54e$export$5551a2d24ff40153)(v);
        if (v.includes("px") || v.slice(-2) === "em") return v;
        const arr = v.split(" ");
        if (!arr.length) return v;
        return arr.map((v)=>(0, $7a9f91e2b97567cc$export$4f949d23b5dbefe6)(v, "shadow").shadow).join(" ");
    }).join(" ");
    const CSSVar = `--shadow-${key}` + (suffix ? `-${suffix}` : "");
    if (CONFIG.useVariable) CONFIG.CSS_VARS[CSSVar] = value;
    return {
        var: CSSVar,
        value: value
    };
};
const $4a7f8e4f20ce09e5$export$db93b77dbb14f011 = (value, globalTheme)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    if (!globalTheme) globalTheme = CONFIG.globalTheme;
    if (!(0, $EqHTq.isString)(value)) {
        if (CONFIG.verbose) console.warn(value, "- type for color is not valid");
        return;
    }
    if (value.slice(0, 2) === "--") return `var(${value})`;
    const [name] = (0, $EqHTq.isArray)(value) ? value : value.split(" ");
    const { SHADOW: SHADOW } = CONFIG;
    const val = SHADOW[name];
    const isObj = (0, $EqHTq.isObject)(val);
    if (!val) {
        if (CONFIG.verbose) console.warn("Can't find color ", name);
        return value;
    }
    if (globalTheme) {
        if (val[globalTheme]) return val[globalTheme].value;
        else if (CONFIG.verbose) console.warn(value, " - does not have ", globalTheme);
    }
    if (isObj && val.value) return val.value;
    if (isObj) {
        const obj = {};
        for(const mediaName in val){
            const query = CONFIG.MEDIA[mediaName.slice(1)];
            const media = `@media screen and ${query}`;
            obj[media] = val.value;
        }
        return obj;
    }
    if (CONFIG.verbose) console.warn("Can't find color", value);
    return value;
};


var $200bfc3872a6d81d$exports = {};

$parcel$export($200bfc3872a6d81d$exports, "applyTimingSequence", () => $200bfc3872a6d81d$export$a5be618f63a441ac);
$parcel$export($200bfc3872a6d81d$exports, "getTimingFunction", () => $200bfc3872a6d81d$export$23ba66c7c3e2e613);
$parcel$export($200bfc3872a6d81d$exports, "getTimingByKey", () => $200bfc3872a6d81d$export$3fa311edc5edd22f);



"use strict";
const $200bfc3872a6d81d$export$a5be618f63a441ac = ()=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { TIMING: TIMING } = CONFIG;
    (0, $366218d35fdab076$export$29708af739d9b0fc)(TIMING);
    (0, $313f46bb97bb8cbe$export$97ab4e7d8ade5018)(TIMING);
};
const $200bfc3872a6d81d$export$23ba66c7c3e2e613 = (value)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { TIMING: TIMING } = CONFIG;
    return TIMING[value] || TIMING[(0, $8319f99b46b296c9$export$86f54f62aa7a7514)(value)] || value;
};
const $200bfc3872a6d81d$export$3fa311edc5edd22f = (value, property = "timing")=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { TIMING: TIMING } = CONFIG;
    return (0, $366218d35fdab076$export$86c0052f25dacc45)(value, property, TIMING);
};


var $ffaa6eb4db8ddc52$exports = {};

$parcel$export($ffaa6eb4db8ddc52$exports, "applyDocument", () => $ffaa6eb4db8ddc52$export$25b333cdc54cc186);
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");


"use strict";
const $ffaa6eb4db8ddc52$export$25b333cdc54cc186 = ()=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { DOCUMENT: DOCUMENT, FONT_FAMILY: FONT_FAMILY, THEME: THEME, TYPOGRAPHY: TYPOGRAPHY } = CONFIG;
    return (0, $8wu6n.merge)(DOCUMENT, {
        theme: THEME.document,
        fontFamily: (0, $acb660e77bec9cb5$export$73aa7d12a2d2fb83)(FONT_FAMILY),
        fontSize: TYPOGRAPHY.base,
        lineHeight: TYPOGRAPHY.lineHeight
    });
};


var $0475f9d7e694cab2$exports = {};

$parcel$export($0475f9d7e694cab2$exports, "setSVG", () => $0475f9d7e694cab2$export$694c6c574069ebf2);
$parcel$export($0475f9d7e694cab2$exports, "appendSVGSprite", () => $0475f9d7e694cab2$export$2c4662f4a995c568);
$parcel$export($0475f9d7e694cab2$exports, "setIcon", () => $0475f9d7e694cab2$export$33914de34c28be6c);
$parcel$export($0475f9d7e694cab2$exports, "appendIconsSprite", () => $0475f9d7e694cab2$export$6831f47ca12f6d69);

var $aOJ2H = parcelRequire("aOJ2H");


"use strict";
const $0475f9d7e694cab2$var$DEF_OPTIONS = {
    document: $aOJ2H.document
};
const $0475f9d7e694cab2$export$694c6c574069ebf2 = (val, key)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    if (!val) {
        if (CONFIG.verbose) console.warn("setSVG: val is not defined", key);
        return;
    }
    if (CONFIG.useSvgSprite) return (0, $da07070d258f49a5$export$510fb280711ea968)(key, val);
    return val;
};
const $0475f9d7e694cab2$export$2c4662f4a995c568 = (LIBRARY, options = $0475f9d7e694cab2$var$DEF_OPTIONS)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const lib = Object.keys(LIBRARY).length ? {} : CONFIG.SVG;
    for(const key in LIBRARY)lib[key] = CONFIG.SVG[key];
    $0475f9d7e694cab2$var$appendSVG(lib, options);
};
const $0475f9d7e694cab2$export$33914de34c28be6c = (val, key)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    if (CONFIG.useIconSprite) return $0475f9d7e694cab2$export$694c6c574069ebf2(val, key);
    return val;
};
const $0475f9d7e694cab2$export$6831f47ca12f6d69 = (LIBRARY, options = $0475f9d7e694cab2$var$DEF_OPTIONS)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const lib = Object.keys(LIBRARY).length ? {} : CONFIG.ICONS;
    for(const key in LIBRARY)lib[key] = CONFIG.ICONS[key];
    $0475f9d7e694cab2$var$appendSVG(lib, options);
};
const $0475f9d7e694cab2$var$createSVGSpriteElement = (options = {
    isRoot: true
})=>{
    if (!(0, $aOJ2H.document) || !(0, $aOJ2H.document).createElementNS) return;
    const svgElem = (0, $aOJ2H.document).createElementNS("http://www.w3.org/2000/svg", "svg");
    if (options.isRoot) {
        svgElem.setAttribute("aria-hidden", "true");
        svgElem.setAttribute("width", "0");
        svgElem.setAttribute("height", "0");
        svgElem.setAttribute("style", "position:absolute");
        svgElem.setAttribute("id", "svgSprite");
    }
    return svgElem;
};
const $0475f9d7e694cab2$var$appendSVG = (lib, options = $0475f9d7e694cab2$var$DEF_OPTIONS)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const doc = options.document || (0, $aOJ2H.document);
    if (!doc || !doc.documentElement) {
        if (CONFIG.verbose) console.warn("To append SVG sprites it should be run in browser environment");
        return (0, $da07070d258f49a5$export$121b8d85aca89bf6)(lib);
    }
    const exists = doc.querySelector("#svgSprite");
    const SVGsprite = (0, $da07070d258f49a5$export$121b8d85aca89bf6)(lib);
    if (exists) {
        const tempSVG = $0475f9d7e694cab2$var$createSVGSpriteElement({
            isRoot: false
        });
        // const svgSpriteWithoutRoot = doc.createElement('template')
        tempSVG.innerHTML = SVGsprite;
        exists.append(...tempSVG.children);
    } else {
        const svgSpriteDOM = $0475f9d7e694cab2$var$createSVGSpriteElement();
        if (svgSpriteDOM && svgSpriteDOM.nodeType) {
            svgSpriteDOM.innerHTML = SVGsprite;
            doc.body.prepend(svgSpriteDOM);
        }
    }
};


var $da693abe5a891559$exports = {};

$parcel$export($da693abe5a891559$exports, "applyReset", () => $da693abe5a891559$export$984fb5f73961424e);
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");


"use strict";
const $da693abe5a891559$export$984fb5f73961424e = (reset = {})=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { RESET: RESET, TYPOGRAPHY: TYPOGRAPHY, DOCUMENT: DOCUMENT } = CONFIG;
    if (RESET) {
        if (RESET[":root"]) {
            const configReset = RESET;
            const configTemplates = TYPOGRAPHY.templates;
            configReset.body = {
                ...CONFIG.useDocumentTheme ? (0, $50bcf74814855f89$export$b3cf7317de2f2233)("document", `@${CONFIG.globalTheme}`) : {},
                ...configTemplates.body
            };
            configReset.h1 = configTemplates.h1;
            configReset.h2 = configTemplates.h2;
            configReset.h3 = configTemplates.h3;
            configReset.h4 = configTemplates.h4;
            configReset.h5 = configTemplates.h5;
            configReset.h6 = configTemplates.h6;
        }
        const { body: body, ...templates } = TYPOGRAPHY.templates;
        const globalTheme = CONFIG.useDocumentTheme ? (0, $50bcf74814855f89$export$b3cf7317de2f2233)("document", `@${CONFIG.globalTheme}`) : {};
        if (RESET.html) (0, $8wu6n.overwriteDeep)(RESET.html, globalTheme);
        return (0, $8wu6n.deepMerge)((0, $8wu6n.merge)(RESET, reset), {
            html: {
                position: "absolute",
                // overflow: 'hidden',
                width: "100%",
                height: "100%",
                top: "0",
                left: "0",
                margin: "0",
                WebkitFontSmoothing: "subpixel-antialiased",
                scrollBehavior: "smooth",
                ...globalTheme,
                fontSize: TYPOGRAPHY.browserDefault + "px",
                fontFamily: DOCUMENT.fontFamily,
                lineHeight: DOCUMENT.lineHeight
            },
            body: {
                boxSizing: "border-box",
                height: "100%",
                margin: 0,
                fontFamily: DOCUMENT.fontFamily,
                fontSize: TYPOGRAPHY.base / TYPOGRAPHY.browserDefault + CONFIG.UNIT.default,
                ...templates,
                ...body
            },
            // form elements
            fieldset: {
                border: 0,
                padding: 0,
                margin: 0
            },
            "select, input": {
                fontFamily: DOCUMENT.fontFamily
            }
        });
    }
};


"use strict";
$parcel$exportWildcard($30c1eb8bbbe7b5d7$exports, $c6753c52b98cd54e$exports);
$parcel$exportWildcard($30c1eb8bbbe7b5d7$exports, $50bcf74814855f89$exports);
$parcel$exportWildcard($30c1eb8bbbe7b5d7$exports, $ed362cf167c3740b$exports);
$parcel$exportWildcard($30c1eb8bbbe7b5d7$exports, $277afaefb2791215$exports);
$parcel$exportWildcard($30c1eb8bbbe7b5d7$exports, $7a9f91e2b97567cc$exports);
$parcel$exportWildcard($30c1eb8bbbe7b5d7$exports, $4a7f8e4f20ce09e5$exports);
$parcel$exportWildcard($30c1eb8bbbe7b5d7$exports, $200bfc3872a6d81d$exports);
$parcel$exportWildcard($30c1eb8bbbe7b5d7$exports, $ffaa6eb4db8ddc52$exports);
$parcel$exportWildcard($30c1eb8bbbe7b5d7$exports, $0475f9d7e694cab2$exports);
$parcel$exportWildcard($30c1eb8bbbe7b5d7$exports, $da693abe5a891559$exports);






parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");


"use strict";
const $33055954907944f0$var$isBorderStyle = (str)=>[
        "none",
        "hidden",
        "dotted",
        "dashed",
        "solid",
        "double",
        "groove",
        "ridge",
        "inset",
        "outset",
        "initial"
    ].some((v)=>str.includes(v));
const $33055954907944f0$export$ca4ef6ca6dc743f2 = (border)=>{
    const arr = border.split(", ");
    return arr.map((v)=>{
        v = v.trim();
        if (v.slice(0, 2) === "--") return `var(${v})`;
        else if ($33055954907944f0$var$isBorderStyle(v)) return v || "solid";
        else if (v.slice(-2) === "px" || v.slice(-2) === "em") return v // TODO: add map spacing
        ;
        else if ((0, $c6753c52b98cd54e$export$5551a2d24ff40153)(v).length > 2) return (0, $c6753c52b98cd54e$export$5551a2d24ff40153)(v);
        return (0, $7a9f91e2b97567cc$export$4f949d23b5dbefe6)(v, "border").border;
    }).join(" ");
};
const $33055954907944f0$export$8bcd50b221b13db = (stroke)=>{
    return stroke.split(", ").map((v)=>{
        if (v.slice(0, 2) === "--") return `var(${v})`;
        if (v.includes("px")) return v;
        else if ((0, $c6753c52b98cd54e$export$5551a2d24ff40153)(v)) return (0, $c6753c52b98cd54e$export$5551a2d24ff40153)(v);
        return v;
    }).join(" ");
};
const $33055954907944f0$export$837e4beeff9ff924 = (sh, globalTheme)=>(0, $4a7f8e4f20ce09e5$export$db93b77dbb14f011)(sh, globalTheme);
const $33055954907944f0$export$9c296746f296a70 = (shadows)=>shadows.split("|").map((shadow)=>{
        return shadow.split(", ").map((v)=>{
            v = v.trim();
            if (v.slice(0, 2) === "--") return `var(${v})`;
            if ((0, $c6753c52b98cd54e$export$5551a2d24ff40153)(v).length > 2) return (0, $c6753c52b98cd54e$export$5551a2d24ff40153)(v);
            if (v.includes("px") || v.slice(-2) === "em") return v;
            const arr = v.split(" ");
            if (!arr.length) return v;
            return arr.map((v)=>(0, $7a9f91e2b97567cc$export$4f949d23b5dbefe6)(v, "shadow").shadow).join(" ");
        }).join(" ");
    }).join(",");
const $33055954907944f0$export$15f2b9b64835b137 = (backgroundImage, globalTheme)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    return backgroundImage.split(", ").map((v)=>{
        if (v.slice(0, 2) === "--") return `var(${v})`;
        if (v.includes("url") || v.includes("gradient")) return v;
        else if (CONFIG.GRADIENT[backgroundImage]) return {
            backgroundImage: (0, $c6753c52b98cd54e$export$dd72f6d9deea7207)(backgroundImage, globalTheme || CONFIG.globalTheme)
        };
        else if (v.includes("/") || v.includes("http")) return `url(${v})`;
        return v;
    }).join(" ");
};
const $33055954907944f0$export$1e420ad2d0d06436 = (gap)=>(0, $EqHTq.isString)(gap) && gap.split(" ").map((v)=>(0, $7a9f91e2b97567cc$export$4f949d23b5dbefe6)(v, "gap").gap).join(" ");
const $33055954907944f0$export$df2b736a06860be7 = (transition)=>{
    const arr = transition.split(" ");
    if (!arr.length) return transition;
    return arr.map((v)=>{
        if (v.slice(0, 2) === "--") return `var(${v})`;
        if (v.length < 3 || v.includes("ms")) {
            const mapWithSequence = (0, $200bfc3872a6d81d$export$3fa311edc5edd22f)(v);
            return mapWithSequence.timing || v;
        }
        if ((0, $200bfc3872a6d81d$export$23ba66c7c3e2e613)(v)) return (0, $200bfc3872a6d81d$export$23ba66c7c3e2e613)(v);
        return v;
    }).join(" ");
};
const $33055954907944f0$export$d87c1c5f4a8ec3d9 = (duration, props, propertyName)=>{
    if (!(0, $EqHTq.isString)(duration)) return;
    return duration.split(",").map((v)=>(0, $200bfc3872a6d81d$export$3fa311edc5edd22f)(v).timing || v).join(",");
};
const $33055954907944f0$export$d9f7ff0c2b32d4b5 = (transition)=>{
    const arr = transition.split(",");
    if (!arr.length) return;
    return arr.map($33055954907944f0$export$df2b736a06860be7).join(",");
};
const $33055954907944f0$export$80eafc63c0bb6c49 = (propertyName)=>{
    const prop = propertyName.toLowerCase();
    return (prop.includes("width") || prop.includes("height")) && !prop.includes("border");
};
const $33055954907944f0$export$f09d9444954afeda = (propertyName, val, props = {}, opts = {})=>{
    let value = val || props[propertyName];
    if ((0, $EqHTq.isUndefined)(value) && (0, $EqHTq.isNull)(value)) return;
    const shouldScaleBoxSize = props.scaleBoxSize;
    const isBoxSize = $33055954907944f0$export$80eafc63c0bb6c49(propertyName);
    if (!shouldScaleBoxSize && isBoxSize && (0, $EqHTq.isString)(value)) value = value.split(" ").map((v)=>{
        const isSingleLetter = v.length < 3 && /[A-Z]/.test(v);
        const hasUnits = [
            "%",
            "vw",
            "vh",
            "ch"
        ].some((unit)=>value.includes(unit));
        if (isSingleLetter && !hasUnits) return v + "_default";
        return v;
    }).join(" ");
    if (opts.ratio) return (0, $7a9f91e2b97567cc$export$94679ba49f16fc2e)(props, propertyName, value);
    else return (0, $7a9f91e2b97567cc$export$4f949d23b5dbefe6)(value, propertyName);
};
const $33055954907944f0$export$b6e34d20a288a08c = (propertyName, props)=>{
    return $33055954907944f0$export$f09d9444954afeda(propertyName, null, props, {
        ratio: true
    });
};




parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $baa590feaf6cb6da$var$setCases = (val, key)=>{
    if ((0, $EqHTq.isFunction)(val)) return val();
    return val;
};
const $baa590feaf6cb6da$var$setSameValue = (val, key)=>val;
const $baa590feaf6cb6da$export$9ae1d0dd64d4a382 = {
    color: (0, $c6753c52b98cd54e$export$130a5dc1bc9cd8e1),
    gradient: (0, $c6753c52b98cd54e$export$afaa8352c6a43a44),
    font: (0, $ed362cf167c3740b$export$69e9bdef456a9c46),
    font_family: (0, $ed362cf167c3740b$export$5fae120d779aafec),
    theme: (0, $50bcf74814855f89$export$2e49b867b7a0847c),
    icons: (0, $0475f9d7e694cab2$export$33914de34c28be6c),
    svg: (0, $0475f9d7e694cab2$export$694c6c574069ebf2),
    svg_data: $baa590feaf6cb6da$var$setSameValue,
    typography: $baa590feaf6cb6da$var$setSameValue,
    cases: $baa590feaf6cb6da$var$setCases,
    shadow: (0, $4a7f8e4f20ce09e5$export$9cd3672191b5a46f),
    spacing: $baa590feaf6cb6da$var$setSameValue,
    media: $baa590feaf6cb6da$var$setSameValue,
    timing: $baa590feaf6cb6da$var$setSameValue,
    reset: $baa590feaf6cb6da$var$setSameValue,
    unit: $baa590feaf6cb6da$var$setSameValue,
    animation: $baa590feaf6cb6da$var$setSameValue
};
const $baa590feaf6cb6da$export$80746c6bc6142fc8 = (FACTORY_NAME, value, key)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const factoryName = FACTORY_NAME.toLowerCase();
    const FACTORY = CONFIG[FACTORY_NAME];
    if ($baa590feaf6cb6da$export$9ae1d0dd64d4a382[factoryName]) {
        const result = $baa590feaf6cb6da$export$9ae1d0dd64d4a382[factoryName](value, key);
        FACTORY[key] = result;
        return FACTORY;
    }
    if (CONFIG.verbose) console.warn("Can not find", factoryName, "method in scratch");
};
const $baa590feaf6cb6da$export$943920cf7e6d5f23 = (factoryName, props)=>{
    const CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const FACTORY_NAME = factoryName.toUpperCase();
    const keys = Object.keys(props);
    keys.map((key)=>$baa590feaf6cb6da$export$80746c6bc6142fc8(FACTORY_NAME, props[key], key));
    return CONFIG[FACTORY_NAME];
};
const $baa590feaf6cb6da$var$SET_OPTIONS = {};
const $baa590feaf6cb6da$export$adaa4cf7ef1b65be = (recivedConfig, options = $baa590feaf6cb6da$var$SET_OPTIONS)=>{
    let CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
    const { version: version, verbose: verbose, useVariable: useVariable, useReset: useReset, useSvgSprite: useSvgSprite, useFontImport: useFontImport, useIconSprite: useIconSprite, globalTheme: globalTheme, useDocumentTheme: useDocumentTheme, useDefaultConfig: useDefaultConfig, ...config } = recivedConfig;
    if (options.newConfig) CONFIG = (0, $5a3b725cdb25b0eb$export$5e61d1b6fff0c794)(options.newConfig);
    if (verbose !== undefined) CONFIG.verbose = verbose;
    if (useVariable !== undefined) CONFIG.useVariable = useVariable;
    if (useReset !== undefined) CONFIG.useReset = useReset;
    if (useFontImport !== undefined) CONFIG.useFontImport = useFontImport;
    if (useSvgSprite !== undefined) CONFIG.useSvgSprite = useSvgSprite;
    if (useIconSprite !== undefined) CONFIG.useIconSprite = useIconSprite;
    if (useDocumentTheme !== undefined) CONFIG.useDocumentTheme = useDocumentTheme;
    if (globalTheme !== undefined) CONFIG.globalTheme = globalTheme;
    if (useDefaultConfig !== undefined) CONFIG.useDefaultConfig = useDefaultConfig;
    if (CONFIG.verbose) console.log(CONFIG);
    if (!CONFIG.__svg_cache) CONFIG.__svg_cache = {};
    const keys = Object.keys(config);
    keys.map((key)=>$baa590feaf6cb6da$export$943920cf7e6d5f23(key, config[key]));
    // apply generic configs
    (0, $277afaefb2791215$export$7c7d7b0d076fe8b5)();
    (0, $7a9f91e2b97567cc$export$9bfe8384addafa7c)();
    (0, $200bfc3872a6d81d$export$a5be618f63a441ac)();
    (0, $ffaa6eb4db8ddc52$export$25b333cdc54cc186)();
    (0, $da693abe5a891559$export$984fb5f73961424e)();
    return CONFIG;
};


"use strict";


/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $e18645ac1956fbe6$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $e18645ac1956fbe6$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $e18645ac1956fbe6$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e18645ac1956fbe6$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $e18645ac1956fbe6$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(j += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(j) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $298fb931ed4fbf8b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(g = j += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $d68ffb0773f38e18$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $fc182b1f84212d3f$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $298fb931ed4fbf8b$export$9e1725a4cfeada27)(character)) break;
        (0, $298fb931ed4fbf8b$export$48cfd1e771a65c4f)();
    }
    return (0, $298fb931ed4fbf8b$export$58adb3bec8346d0f)(begin, (0, $298fb931ed4fbf8b$export$5880b8b5730aff45));
};
var $fc182b1f84212d3f$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $298fb931ed4fbf8b$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $fc182b1f84212d3f$var$identifierWithPointTracking((0, $298fb931ed4fbf8b$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $298fb931ed4fbf8b$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $298fb931ed4fbf8b$export$4d3fb11e950abb9e)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $298fb931ed4fbf8b$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $298fb931ed4fbf8b$export$48cfd1e771a65c4f)());
    return parsed;
};
var $fc182b1f84212d3f$var$getRules = function getRules(value, points) {
    return (0, $298fb931ed4fbf8b$export$45918ac1574455b1)($fc182b1f84212d3f$var$toRules((0, $298fb931ed4fbf8b$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $fc182b1f84212d3f$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $fc182b1f84212d3f$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$fc182b1f84212d3f$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $fc182b1f84212d3f$var$fixedElements.set(element, true);
    var points = [];
    var rules = $fc182b1f84212d3f$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $fc182b1f84212d3f$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $fc182b1f84212d3f$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $fc182b1f84212d3f$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($fc182b1f84212d3f$var$ignoreFlag) > -1;
};
var $fc182b1f84212d3f$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($fc182b1f84212d3f$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $fc182b1f84212d3f$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $fc182b1f84212d3f$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$fc182b1f84212d3f$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $fc182b1f84212d3f$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $fc182b1f84212d3f$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$fc182b1f84212d3f$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $fc182b1f84212d3f$var$nullifyElement(element);
    } else if ($fc182b1f84212d3f$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $fc182b1f84212d3f$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $fc182b1f84212d3f$var$prefix(value, length) {
    switch((0, $298fb931ed4fbf8b$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "box-$1$2" + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-item-" + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-line-pack" + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "box-" + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "-grow", "") + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$2") + value;
        // cursor
        case 6187:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1"), /(image-set)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "box-pack:$3" + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $298fb931ed4fbf8b$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$2-$3" + "$1" + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $298fb931ed4fbf8b$export$f8e21b1e77979a08)(value, "stretch") ? $fc182b1f84212d3f$var$prefix((0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, (0, $298fb931ed4fbf8b$export$36776f635604f274)(value) - 3 - (~(0, $298fb931ed4fbf8b$export$f8e21b1e77979a08)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, ":", ":" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + ((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "$2$3" + "$1" + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $298fb931ed4fbf8b$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + value + (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $fc182b1f84212d3f$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $298fb931ed4fbf8b$export$527d108ccf083c2b:
                element["return"] = $fc182b1f84212d3f$var$prefix(element.value, element.length);
                break;
            case 0, $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                    (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                        value: (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(element.value, "@", "@" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (element.length) return (0, $298fb931ed4fbf8b$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $298fb931ed4fbf8b$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ":" + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)([
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + "input-$1")
                                    ]
                                }),
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ":" + (0, $298fb931ed4fbf8b$export$2c0f367103c8d01c) + "$1")
                                    ]
                                }),
                                (0, $298fb931ed4fbf8b$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $fc182b1f84212d3f$var$defaultStylisPlugins = [
    $fc182b1f84212d3f$var$prefixer
];
var $fc182b1f84212d3f$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $fc182b1f84212d3f$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $fc182b1f84212d3f$var$compat,
        $fc182b1f84212d3f$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $298fb931ed4fbf8b$export$fac44ee5b035f737),
        (0, $298fb931ed4fbf8b$export$38bcb760f1d4871c)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $298fb931ed4fbf8b$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)((0, $298fb931ed4fbf8b$export$ef7acd7185315e22)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $e18645ac1956fbe6$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $90ba2da1f62e5f1b$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $90ba2da1f62e5f1b$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $90ba2da1f62e5f1b$var$hyphenateRegex = /[A-Z]|^ms/g;
var $90ba2da1f62e5f1b$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $90ba2da1f62e5f1b$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $90ba2da1f62e5f1b$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $90ba2da1f62e5f1b$var$processStyleName = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(styleName) {
    return $90ba2da1f62e5f1b$var$isCustomProperty(styleName) ? styleName : styleName.replace($90ba2da1f62e5f1b$var$hyphenateRegex, "-$&").toLowerCase();
});
var $90ba2da1f62e5f1b$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($90ba2da1f62e5f1b$var$animationRegex, function(match, p1, p2) {
                $90ba2da1f62e5f1b$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $90ba2da1f62e5f1b$var$cursor
                };
                return p1;
            });
    }
    if ((0, $936be3b045ab836e$export$2e2bcd8739ae039)[key] !== 1 && !$90ba2da1f62e5f1b$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $90ba2da1f62e5f1b$var$contentValuePattern, $90ba2da1f62e5f1b$var$contentValues, $90ba2da1f62e5f1b$var$oldProcessStyleValue, $90ba2da1f62e5f1b$var$msPattern, $90ba2da1f62e5f1b$var$hyphenPattern, $90ba2da1f62e5f1b$var$hyphenatedCache;
var $90ba2da1f62e5f1b$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $90ba2da1f62e5f1b$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $90ba2da1f62e5f1b$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $90ba2da1f62e5f1b$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $90ba2da1f62e5f1b$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $90ba2da1f62e5f1b$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $90ba2da1f62e5f1b$var$cursor;
                var result = interpolation(mergedProps);
                $90ba2da1f62e5f1b$var$cursor = previousCursor;
                return $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $90ba2da1f62e5f1b$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($90ba2da1f62e5f1b$var$isProcessableValue(value)) string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + $90ba2da1f62e5f1b$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($90ba2da1f62e5f1b$var$isProcessableValue(value[_i])) string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + $90ba2da1f62e5f1b$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $90ba2da1f62e5f1b$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $90ba2da1f62e5f1b$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $90ba2da1f62e5f1b$var$cursor;
var $90ba2da1f62e5f1b$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $90ba2da1f62e5f1b$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $90ba2da1f62e5f1b$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $90ba2da1f62e5f1b$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $3629985b3ecf741f$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $90ba2da1f62e5f1b$var$cursor
    };
};


var $1f6791d0a193b918$var$isBrowser = true;
function $1f6791d0a193b918$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $1f6791d0a193b918$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $1f6791d0a193b918$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $1f6791d0a193b918$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $1f6791d0a193b918$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


function $f80ae5e019588f18$var$insertWithoutScoping(cache, serialized) {
    if (cache.inserted[serialized.name] === undefined) return cache.insert("", serialized, cache.sheet, true);
}
function $f80ae5e019588f18$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $1f6791d0a193b918$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $f80ae5e019588f18$export$2e2bcd8739ae039 = function createEmotion(options) {
    var cache = (0, $fc182b1f84212d3f$export$2e2bcd8739ae039)(options); // $FlowFixMe
    cache.sheet.speedy = function(value) {
        this.isSpeedy = value;
    };
    cache.compat = true;
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)(args, cache.registered, undefined);
        (0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var keyframes = function keyframes() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var serialized = (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)(args, cache.registered);
        var animation = "animation-" + serialized.name;
        $f80ae5e019588f18$var$insertWithoutScoping(cache, {
            name: serialized.name,
            styles: "@keyframes " + animation + "{" + serialized.styles + "}"
        });
        return animation;
    };
    var injectGlobal = function injectGlobal() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        var serialized = (0, $90ba2da1f62e5f1b$export$6321afa313b251b5)(args, cache.registered);
        $f80ae5e019588f18$var$insertWithoutScoping(cache, serialized);
    };
    var cx = function cx() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return $f80ae5e019588f18$var$merge(cache.registered, css, $f80ae5e019588f18$var$classnames(args));
    };
    return {
        css: css,
        cx: cx,
        injectGlobal: injectGlobal,
        keyframes: keyframes,
        hydrate: function hydrate(ids) {
            ids.forEach(function(key) {
                cache.inserted[key] = true;
            });
        },
        flush: function flush() {
            cache.registered = {};
            cache.inserted = {};
            cache.sheet.flush();
        },
        // $FlowFixMe
        sheet: cache.sheet,
        cache: cache,
        getRegisteredStyles: (0, $1f6791d0a193b918$export$95d99596f328fd52).bind(null, cache.registered),
        merge: $f80ae5e019588f18$var$merge.bind(null, cache.registered, css)
    };
};
var $f80ae5e019588f18$var$classnames = function classnames(args) {
    var cls = "";
    for(var i = 0; i < args.length; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};


"use strict";
const $b3468425a35a59c8$export$100c3af055d141e0 = (key = "smbls", container)=>{
    const cleanKey = key.replaceAll(/\./g, "-");
    return (0, $f80ae5e019588f18$export$2e2bcd8739ae039)({
        key: cleanKey,
        container: container
    });
};
const $b3468425a35a59c8$export$51d693b3d243fd90 = $b3468425a35a59c8$export$100c3af055d141e0();



parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");

var $0e6c01aab9a4ae9b$exports = {};
$0e6c01aab9a4ae9b$exports = JSON.parse("{}");


"use strict";
const $31242768b5023c84$var$CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
const $31242768b5023c84$var$mergeWithLocalFile = (config = $31242768b5023c84$var$CONFIG, RC_FILE)=>{
    const rcfile = (0, $EqHTq.isObject)(RC_FILE) ? RC_FILE : (0, (/*@__PURE__*/$parcel$interopDefault($0e6c01aab9a4ae9b$exports))) || {};
    const clonedFile = (0, $8wu6n.deepClone)(rcfile.designSystem || {});
    return (0, $8wu6n.deepMerge)(config, clonedFile);
};
const $31242768b5023c84$var$SET_OPTIONS = {
    emotion: (0, $b3468425a35a59c8$export$51d693b3d243fd90),
    useVariable: true,
    useReset: true,
    useFontImport: true,
    useIconSprite: true,
    useDocumentTheme: true,
    useSvgSprite: true
};
const $31242768b5023c84$export$2cd8252107eb640b = (config, options = $31242768b5023c84$var$SET_OPTIONS)=>{
    const emotion = options.emotion || (0, $b3468425a35a59c8$export$51d693b3d243fd90);
    const resultConfig = $31242768b5023c84$var$mergeWithLocalFile(config || {});
    const conf = (0, $baa590feaf6cb6da$export$adaa4cf7ef1b65be)({
        verbose: options.verbose,
        useReset: options.useReset,
        useFontImport: options.useFontImport,
        useVariable: options.useVariable,
        useSvgSprite: options.useSvgSprite,
        useDocumentTheme: options.useDocumentTheme,
        useIconSprite: options.useIconSprite,
        useDefaultConfig: options.useDefaultConfig,
        ...resultConfig
    }, {
        newConfig: options.newConfig
    });
    const FontFace = (0, $acb660e77bec9cb5$export$8b73d71a1d936bc)(conf.FONT);
    const useReset = conf.useReset;
    const useVariable = conf.useVariable;
    const useFontImport = conf.useFontImport;
    const useSvgSprite = conf.useSvgSprite;
    const hasSvgs = config.svg || config.SVG;
    const useIconSprite = conf.useIconSprite;
    const hasIcons = config.icons || config.ICONS;
    if (useFontImport) emotion.injectGlobal(FontFace);
    if (useVariable) emotion.injectGlobal({
        ":root": conf.CSS_VARS
    });
    if (useReset) emotion.injectGlobal(conf.RESET);
    if (hasSvgs) (0, $0475f9d7e694cab2$export$2c4662f4a995c568)(hasSvgs, {
        document: options.document
    });
    else if (useSvgSprite) (0, $0475f9d7e694cab2$export$2c4662f4a995c568)(conf.SVG, {
        document: options.document
    });
    if (hasIcons) (0, $0475f9d7e694cab2$export$6831f47ca12f6d69)(hasIcons, {
        document: options.document
    });
    else if (useIconSprite) (0, $0475f9d7e694cab2$export$6831f47ca12f6d69)(conf.ICONS, {
        document: options.document
    });
    return conf;
};
const $31242768b5023c84$var$UPDATE_OPTIONS = {
    emotion: (0, $b3468425a35a59c8$export$51d693b3d243fd90)
};
const $31242768b5023c84$export$4f395a2c8fcf6959 = (config, RC_FILE, options = $31242768b5023c84$var$UPDATE_OPTIONS)=>{
    const emotion = options.emotion || (0, $b3468425a35a59c8$export$51d693b3d243fd90);
    const resultConfig = $31242768b5023c84$var$mergeWithLocalFile(config || {}, RC_FILE);
    const conf = (0, $baa590feaf6cb6da$export$adaa4cf7ef1b65be)({
        verbose: false,
        ...resultConfig
    });
    emotion.injectGlobal({
        ":root": conf.CSS_VARS
    });
    emotion.injectGlobal(conf.RESET);
};
const $31242768b5023c84$export$3a26aa64e59aeaff = (styles, options = $31242768b5023c84$var$UPDATE_OPTIONS)=>{
    const emotion = options.emotion || (0, $b3468425a35a59c8$export$51d693b3d243fd90);
    emotion.injectGlobal(styles);
};
const $31242768b5023c84$export$ed2c61d2d8a098be = (config, options = $31242768b5023c84$var$UPDATE_OPTIONS)=>{
    const emotion = options.emotion || (0, $b3468425a35a59c8$export$51d693b3d243fd90);
    emotion.injectGlobal({
        ":root": config.CSS_VARS
    });
};
const $31242768b5023c84$export$2796c4ce44e61efa = (props, options = $31242768b5023c84$var$UPDATE_OPTIONS)=>{} // setClassname(props, options.emotion.css)
;


var $be006f1a0fabd945$exports = {};
var $73d59c6c3fce378b$exports = {};
var $40d382f435ee1fdb$exports = {};

$parcel$export($40d382f435ee1fdb$exports, "Block", () => $40d382f435ee1fdb$export$d96a8827a60d6b69);
$parcel$export($40d382f435ee1fdb$exports, "Hr", () => $40d382f435ee1fdb$export$c65504044f62f430);
$parcel$export($40d382f435ee1fdb$exports, "Br", () => $40d382f435ee1fdb$export$9130f216d904f5ea);
$parcel$export($40d382f435ee1fdb$exports, "Div", () => $40d382f435ee1fdb$export$5bfb0bc6cd684584);
$parcel$export($40d382f435ee1fdb$exports, "Span", () => $40d382f435ee1fdb$export$5f1714a13ed34c01);
$parcel$export($40d382f435ee1fdb$exports, "Ul", () => $40d382f435ee1fdb$export$d4f99c77eeffeaea);
$parcel$export($40d382f435ee1fdb$exports, "Gutter", () => $40d382f435ee1fdb$export$b710539649c46ff);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");

"use strict";
const $40d382f435ee1fdb$export$d96a8827a60d6b69 = {
    deps: {
        getSpacingBasedOnRatio: $7a9f91e2b97567cc$export$94679ba49f16fc2e,
        getSpacingByKey: $7a9f91e2b97567cc$export$4f949d23b5dbefe6,
        transfromGap: $33055954907944f0$export$1e420ad2d0d06436,
        transformSizeRatio: $33055954907944f0$export$b6e34d20a288a08c,
        transformSize: $33055954907944f0$export$f09d9444954afeda
    },
    class: {
        boxSizing: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.boxSizing) ? {
                boxSizing: props.boxSizing
            } : {
                boxSizing: "border-box"
            },
        display: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.display) && {
                display: props.display
            },
        hide: ({ props: props })=>props.hide && {
                display: "none !important"
            },
        width: ({ props: props, deps: deps })=>deps.transformSizeRatio("width", props),
        height: ({ props: props, deps: deps })=>deps.transformSizeRatio("height", props),
        boxSize: ({ props: props, deps: deps })=>{
            if (typeof props.boxSize !== "string") return;
            const [height, width] = props.boxSize.split(" ");
            return {
                ...deps.transformSize("height", height),
                ...deps.transformSize("width", width || height)
            };
        },
        minWidth: ({ props: props, deps: deps })=>deps.transformSizeRatio("minWidth", props),
        maxWidth: ({ props: props, deps: deps })=>deps.transformSizeRatio("maxWidth", props),
        widthRange: ({ props: props, deps: deps })=>{
            if (typeof props.widthRange !== "string") return;
            const [minWidth, maxWidth] = props.widthRange.split(" ");
            return {
                ...deps.transformSize("minWidth", minWidth),
                ...deps.transformSize("maxWidth", maxWidth || minWidth)
            };
        },
        minHeight: ({ props: props, deps: deps })=>deps.transformSizeRatio("minHeight", props),
        maxHeight: ({ props: props, deps: deps })=>deps.transformSizeRatio("maxHeight", props),
        heightRange: ({ props: props, deps: deps })=>{
            if (typeof props.heightRange !== "string") return;
            const [minHeight, maxHeight] = props.heightRange.split(" ");
            return {
                ...deps.transformSize("minHeight", minHeight),
                ...deps.transformSize("maxHeight", maxHeight || minHeight)
            };
        },
        direction: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.direction) && {
                direction: props.direction
            },
        aspectRatio: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.aspectRatio) && {
                aspectRatio: props.aspectRatio
            },
        borderWidth: ({ props: props, deps: deps })=>deps.transformSizeRatio("borderWidth", props),
        padding: ({ props: props, deps: deps })=>deps.transformSizeRatio("padding", props),
        paddingInline: ({ props: props, deps: deps })=>{
            if (typeof props.paddingInline !== "string") return;
            const [paddingInlineStart, paddingInlineEnd] = props.paddingInline.split(" ");
            return {
                ...deps.transformSize("paddingInlineStart", paddingInlineStart),
                ...deps.transformSize("paddingInlineEnd", paddingInlineEnd || paddingInlineStart)
            };
        },
        paddingBlock: ({ props: props, deps: deps })=>{
            if (typeof props.paddingBlock !== "string") return;
            const [paddingBlockStart, paddingBlockEnd] = props.paddingBlock.split(" ");
            return {
                ...deps.transformSize("paddingBlockStart", paddingBlockStart),
                ...deps.transformSize("paddingBlockEnd", paddingBlockEnd || paddingBlockStart)
            };
        },
        paddingInlineStart: ({ props: props, deps: deps })=>deps.transformSizeRatio("paddingInlineStart", props),
        paddingInlineEnd: ({ props: props, deps: deps })=>deps.transformSizeRatio("paddingInlineEnd", props),
        paddingBlockStart: ({ props: props, deps: deps })=>deps.transformSizeRatio("paddingBlockStart", props),
        paddingBlockEnd: ({ props: props, deps: deps })=>deps.transformSizeRatio("paddingBlockEnd", props),
        margin: ({ props: props, deps: deps })=>deps.transformSizeRatio("margin", props),
        marginInline: ({ props: props, deps: deps })=>{
            if (typeof props.marginInline !== "string") return;
            const [marginInlineStart, marginInlineEnd] = props.marginInline.split(" ");
            return {
                ...deps.transformSize("marginInlineStart", marginInlineStart),
                ...deps.transformSize("marginInlineEnd", marginInlineEnd || marginInlineStart)
            };
        },
        marginBlock: ({ props: props, deps: deps })=>{
            if (typeof props.marginBlock !== "string") return;
            const [marginBlockStart, marginBlockEnd] = props.marginBlock.split(" ");
            return {
                ...deps.transformSize("marginBlockStart", marginBlockStart),
                ...deps.transformSize("marginBlockEnd", marginBlockEnd || marginBlockStart)
            };
        },
        marginInlineStart: ({ props: props, deps: deps })=>deps.transformSizeRatio("marginInlineStart", props),
        marginInlineEnd: ({ props: props, deps: deps })=>deps.transformSizeRatio("marginInlineEnd", props),
        marginBlockStart: ({ props: props, deps: deps })=>deps.transformSizeRatio("marginBlockStart", props),
        marginBlockEnd: ({ props: props, deps: deps })=>deps.transformSizeRatio("marginBlockEnd", props),
        gap: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.gap) && {
                gap: (0, $33055954907944f0$export$1e420ad2d0d06436)(props.gap)
            },
        gridArea: ({ props: props, deps: deps })=>props.gridArea && {
                gridArea: props.gridArea
            },
        flex: ({ props: props })=>props.flex && {
                flex: props.flex
            },
        flexDirection: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.flexDirection) && {
                flexDirection: props.flexDirection
            },
        alignItems: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.alignItems) && {
                alignItems: props.alignItems
            },
        alignContent: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.alignContent) && {
                alignContent: props.alignContent
            },
        justifyContent: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.justifyContent) && {
                justifyContent: props.justifyContent
            },
        justifyItems: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.justifyItems) && {
                justifyItems: props.justifyItems
            },
        alignSelf: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.alignSelf) && {
                alignSelf: props.alignSelf
            },
        order: ({ props: props })=>props.order && {
                order: props.order
            },
        flexWrap: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.flexWrap) && {
                display: "flex",
                flexFlow: props.flexWrap
            },
        flexFlow: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.flexFlow) && {
                display: "flex",
                flexFlow: props.flexFlow + (props.reverse ? "-reverse" : "")
            },
        flexAlign: ({ props: props })=>{
            if (typeof props.flexAlign !== "string") return;
            const [alignItems, justifyContent] = props.flexAlign.split(" ");
            return {
                display: "flex",
                alignItems: alignItems,
                justifyContent: justifyContent
            };
        },
        gridColumn: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.gridColumn) && {
                gridColumn: props.gridColumn
            },
        gridColumnStart: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.gridColumnStart) && {
                gridColumnStart: props.gridColumnStart
            },
        gridRow: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.gridRow) && {
                gridRow: props.gridRow
            },
        gridRowStart: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.gridRowStart) && {
                gridRowStart: props.gridRowStart
            },
        size: ({ props: props, deps: deps })=>{
            if (typeof props.heightRange !== "string") return;
            const [minHeight, maxHeight] = props.heightRange.split(" ");
            return {
                ...deps.transformSizeRatio("minHeight", minHeight),
                ...deps.transformSizeRatio("maxHeight", maxHeight || minHeight)
            };
        },
        columns: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.columns) && {
                columns: props.columns
            },
        columnRule: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.columnRule) && {
                columnRule: props.columnRule
            },
        columnWidth: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.columnWidth) && {
                columnWidth: props.columnWidth
            },
        columnGap: ({ props: props, deps: deps })=>deps.transformSizeRatio("columnGap", props),
        columnSpan: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.columnSpan) && {
                columnSpan: props.columnSpan
            },
        columnFill: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.columnFill) && {
                columnFill: props.columnFill
            },
        columnCount: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.columnCount) && {
                columnCount: props.columnCount
            }
    }
};
const $40d382f435ee1fdb$export$c65504044f62f430 = {
    tag: "hr",
    props: {
        margin: "C1 0"
    }
};
const $40d382f435ee1fdb$export$9130f216d904f5ea = {
    tag: "br"
};
const $40d382f435ee1fdb$export$5bfb0bc6cd684584 = {
    tag: "div"
};
const $40d382f435ee1fdb$export$5f1714a13ed34c01 = {
    tag: "span"
};
const $40d382f435ee1fdb$export$d4f99c77eeffeaea = {
    tag: "ul",
    childExtend: {
        tag: "li"
    }
};
const $40d382f435ee1fdb$export$b710539649c46ff = {
    deps: {
        getSpacingByKey: $7a9f91e2b97567cc$export$4f949d23b5dbefe6
    },
    props: {
        size: "C1"
    },
    class: {
        size: ({ props: props, deps: deps })=>{
            if (typeof props.size !== "string") return;
            const [height, width] = props.size.split(" ");
            return {
                ...deps.getSpacingByKey("height", height),
                ...deps.getSpacingByKey("width", width || height)
            };
        }
    }
};


var $b908145e0b91dcdb$exports = {};

$parcel$export($b908145e0b91dcdb$exports, "Direction", () => $b908145e0b91dcdb$export$cacd6541cfeeb6c1);
"use strict";
const $b908145e0b91dcdb$export$cacd6541cfeeb6c1 = {
    props: {
        direction: "ltr"
    },
    class: {
        direction: ({ props: props })=>({
                direction: props.direction
            })
    }
};


var $8184389c03ed1792$exports = {};

$parcel$export($8184389c03ed1792$exports, "Flex", () => $8184389c03ed1792$export$f51f4c4ede09e011);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $8184389c03ed1792$export$f51f4c4ede09e011 = {
    props: {
        display: "flex"
    },
    class: {
        flow: ({ props: props })=>{
            const { flow: flow, reverse: reverse } = props;
            if (!(0, $EqHTq.isString)(flow)) return;
            let [direction, wrap] = (flow || "row").split(" ");
            if (flow.startsWith("x") || flow.startsWith("row")) direction = "row";
            if (flow.startsWith("y") || flow.startsWith("column")) direction = "column";
            return {
                flexFlow: (direction || "") + (reverse ? "-reverse" : "") + " " + (wrap || "")
            };
        },
        wrap: ({ props: props })=>props.wrap && {
                flexWrap: props.wrap
            },
        align: ({ props: props })=>{
            if (!(0, $EqHTq.isString)(props.align)) return;
            const [alignItems, justifyContent] = props.align.split(" ");
            return {
                alignItems: alignItems,
                justifyContent: justifyContent
            };
        }
    }
};


var $afd03220988cb716$exports = {};

$parcel$export($afd03220988cb716$exports, "Grid", () => $afd03220988cb716$export$ef2184bd89960b14);

"use strict";
const $afd03220988cb716$export$ef2184bd89960b14 = {
    deps: {
        getSpacingBasedOnRatio: $7a9f91e2b97567cc$export$94679ba49f16fc2e
    },
    props: {
        display: "grid"
    },
    class: {
        area: ({ props: props })=>props.area ? {
                gridArea: props.area
            } : null,
        template: ({ props: props })=>props.template ? {
                gridTemplate: props.template
            } : null,
        templateAreas: ({ props: props })=>props.templateAreas ? {
                gridTemplateAreas: props.templateAreas
            } : null,
        column: ({ props: props })=>props.column ? {
                gridColumn: props.column
            } : null,
        columns: ({ props: props })=>props.columns ? {
                gridTemplateColumns: props.columns
            } : null,
        templateColumns: ({ props: props })=>props.templateColumns ? {
                gridTemplateColumns: props.templateColumns
            } : null,
        autoColumns: ({ props: props })=>props.autoColumns ? {
                gridAutoColumns: props.autoColumns
            } : null,
        columnStart: ({ props: props })=>props.columnStart ? {
                gridColumnStart: props.columnStart
            } : null,
        row: ({ props: props })=>props.row ? {
                gridRow: props.row
            } : null,
        rows: ({ props: props })=>props.rows ? {
                gridTemplateRows: props.rows
            } : null,
        templateRows: ({ props: props })=>props.templateRows ? {
                gridTemplateRows: props.templateRows
            } : null,
        autoRows: ({ props: props })=>props.autoRows ? {
                gridAutoRows: props.autoRows
            } : null,
        rowStart: ({ props: props })=>props.rowStart ? {
                gridRowStart: props.rowStart
            } : null,
        autoFlow: ({ props: props })=>props.autoFlow ? {
                gridAutoFlow: props.autoFlow
            } : null,
        columnGap: ({ props: props, deps: deps })=>props.columnGap ? deps.getSpacingBasedOnRatio(props, "columnGap") : null,
        rowGap: ({ props: props, deps: deps })=>props.rowGap ? deps.getSpacingBasedOnRatio(props, "rowGap") : null
    }
};


var $c95002999fe11fd8$exports = {};

$parcel$export($c95002999fe11fd8$exports, "Img", () => $c95002999fe11fd8$export$cc7b5f925acc71d3);
"use strict";
const $c95002999fe11fd8$export$cc7b5f925acc71d3 = {
    tag: "img",
    attr: {
        src: ({ props: props })=>props.src,
        alt: ({ props: props })=>props.alt,
        title: ({ props: props })=>props.title || props.alt
    }
};


var $f085155ee8a416c4$exports = {};

$parcel$export($f085155ee8a416c4$exports, "Form", () => $f085155ee8a416c4$export$a7fed597f4b8afd8);
"use strict";
const $f085155ee8a416c4$export$a7fed597f4b8afd8 = {
    tag: "form",
    attr: {
        action: ({ props: props })=>props.action,
        method: ({ props: props })=>props.method,
        enctype: ({ props: props })=>props.enctype
    }
};


var $bc85e892389de1ab$exports = {};

$parcel$export($bc85e892389de1ab$exports, "keySetters", () => $bc85e892389de1ab$export$5c168558fab3755c);
$parcel$export($bc85e892389de1ab$exports, "Media", () => $bc85e892389de1ab$export$7fc53215244aec38);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
var $8wu6n = parcelRequire("8wu6n");
var $2ae1edf582b77174$exports = {};

$parcel$export($2ae1edf582b77174$exports, "getSystemTheme", () => $2ae1edf582b77174$export$fe979c3403443f94);
$parcel$export($2ae1edf582b77174$exports, "Theme", () => $2ae1edf582b77174$export$14faa19a0f3bbeb2);


var $3e7681929891ee4e$exports = {};

$parcel$export($3e7681929891ee4e$exports, "Timing", () => $3e7681929891ee4e$export$ef1e5872612852d1);


var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $3e7681929891ee4e$export$ef1e5872612852d1 = {
    deps: {
        getTimingFunction: $200bfc3872a6d81d$export$23ba66c7c3e2e613,
        splitTransition: $33055954907944f0$export$d9f7ff0c2b32d4b5,
        transformDuration: $33055954907944f0$export$d87c1c5f4a8ec3d9
    },
    class: {
        transition: ({ props: props, deps: deps })=>!(0, $EqHTq.isUndefined)(props.transition) && {
                transition: deps.splitTransition(props.transition)
            },
        willChange: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.willChange) && {
                willChange: props.willChange
            },
        transitionDuration: ({ props: props, deps: deps })=>!(0, $EqHTq.isUndefined)(props.transitionDuration) && {
                transitionDuration: deps.transformDuration(props.transitionDuration)
            },
        transitionDelay: ({ props: props, deps: deps })=>!(0, $EqHTq.isUndefined)(props.transitionDelay) && {
                transitionDelay: deps.transformDuration(props.transitionDelay)
            },
        transitionTimingFunction: ({ props: props, deps: deps })=>!(0, $EqHTq.isUndefined)(props.transitionTimingFunction) && {
                transitionTimingFunction: deps.getTimingFunction(props.transitionTimingFunction)
            },
        transitionProperty: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.transitionProperty) && {
                transitionProperty: props.transitionProperty,
                willChange: props.transitionProperty
            }
    }
};


"use strict";
const $1364b7b7ead3f203$var$CONFIG = (0, $5a3b725cdb25b0eb$export$e23c3d522afb24cd)();
const $1364b7b7ead3f203$export$b202ba015b5882cd = {
    4: {
        boxShadow: `rgba(0,0,0,.10) 0 2${$1364b7b7ead3f203$var$CONFIG.UNIT.default} 4${$1364b7b7ead3f203$var$CONFIG.UNIT.default}`
    },
    6: {
        boxShadow: `rgba(0,0,0,.10) 0 3${$1364b7b7ead3f203$var$CONFIG.UNIT.default} 6${$1364b7b7ead3f203$var$CONFIG.UNIT.default}`
    },
    10: {
        boxShadow: `rgba(0,0,0,.10) 0 4${$1364b7b7ead3f203$var$CONFIG.UNIT.default} 10${$1364b7b7ead3f203$var$CONFIG.UNIT.default}`
    },
    16: {
        boxShadow: `rgba(0,0,0,.10) 0 8${$1364b7b7ead3f203$var$CONFIG.UNIT.default} 16${$1364b7b7ead3f203$var$CONFIG.UNIT.default}`
    },
    26: {
        boxShadow: `rgba(0,0,0,.10) 0 14${$1364b7b7ead3f203$var$CONFIG.UNIT.default} 26${$1364b7b7ead3f203$var$CONFIG.UNIT.default}`
    },
    42: {
        boxShadow: `rgba(0,0,0,.10) 0 20${$1364b7b7ead3f203$var$CONFIG.UNIT.default} 42${$1364b7b7ead3f203$var$CONFIG.UNIT.default}`
    }
};
const $1364b7b7ead3f203$var$getComputedBackgroundColor = ({ props: props })=>{
    return (0, $c6753c52b98cd54e$export$5551a2d24ff40153)(props.shapeDirectionColor) || (0, $c6753c52b98cd54e$export$5551a2d24ff40153)(props.borderColor) || (0, $c6753c52b98cd54e$export$5551a2d24ff40153)(props.backgroundColor) || (0, $c6753c52b98cd54e$export$5551a2d24ff40153)(props.background);
};
const $1364b7b7ead3f203$var$inheritTransition = ({ props: props, deps: deps })=>{
    const exec = (0, $3e7681929891ee4e$export$ef1e5872612852d1).class.transition({
        props: props,
        deps: deps
    });
    return exec && exec.transition;
};
const $1364b7b7ead3f203$export$511e1d54a4a8684e = {
    rectangle: {},
    circle: {
        borderRadius: "100%"
    },
    bubble: {},
    tv: {
        borderRadius: "1.15em/2.5em"
    },
    tooltip: ({ props: props, deps: deps })=>({
            position: props.position || "relative",
            "&:before": {
                content: '""',
                display: "block",
                width: "0px",
                height: "0px",
                border: ".35em solid",
                borderColor: $1364b7b7ead3f203$var$getComputedBackgroundColor({
                    props: props,
                    deps: deps
                }),
                transition: $1364b7b7ead3f203$var$inheritTransition({
                    props: props,
                    deps: deps
                }),
                transitionProperty: "border-color",
                position: "absolute",
                borderRadius: ".15em"
            }
        }),
    tooltipDirection: {
        top: {
            "&:before": {
                top: "0",
                left: "50%",
                transform: "translate(-50%, -50%) rotate(45deg)"
            }
        },
        right: {
            "&:before": {
                top: "50%",
                right: "0",
                transform: "translate(50%, -50%) rotate(45deg)"
            }
        },
        bottom: {
            "&:before": {
                bottom: "0",
                left: "50%",
                transform: "translate(-50%, 50%) rotate(45deg)"
            }
        },
        left: {
            "&:before": {
                top: "50%",
                left: "0",
                transform: "translate(-50%, -50%) rotate(45deg)"
            }
        }
    },
    tag: ({ props: props, deps: deps })=>({
            position: "relative",
            "&:before": {
                content: '""',
                display: "block",
                background: $1364b7b7ead3f203$var$getComputedBackgroundColor({
                    props: props,
                    deps: deps
                }),
                transition: $1364b7b7ead3f203$var$inheritTransition({
                    props: props,
                    deps: deps
                }),
                transitionProperty: "background",
                borderRadius: ".25em",
                position: "absolute",
                zIndex: "-1",
                aspectRatio: "1/1",
                top: "50%",
                transformOrigin: "50% 50%",
                height: "73%"
            }
        }),
    tagDirection: {
        top: {
            "&:before": {
                bottom: "100%",
                left: "50%",
                transform: "translate(-50%, 50%) rotate(45deg)"
            }
        },
        right: {
            "&:before": {
                top: "50%",
                left: "100%",
                transform: "translate(-50%, -50%) rotate(45deg)"
            }
        },
        bottom: {
            "&:before": {
                top: "100%",
                left: "50%",
                transform: "translate(-50%, -50%) rotate(45deg)"
            }
        },
        left: {
            "&:before": {
                top: "50%",
                right: "100%",
                transform: "translate(50%, -50%) rotate(45deg)"
            }
        }
    },
    hexagon: ({ props: props, deps: deps })=>({
            position: "relative",
            "&:before, &:after": {
                content: '""',
                display: "block",
                position: "absolute",
                zIndex: "-1",
                borderRadius: ".25em",
                aspectRatio: "1/1",
                top: "50%",
                transformOrigin: "50% 50%",
                height: "73%",
                background: $1364b7b7ead3f203$var$getComputedBackgroundColor({
                    props: props,
                    deps: deps
                }),
                transition: $1364b7b7ead3f203$var$inheritTransition({
                    props: props,
                    deps: deps
                }),
                transitionProperty: "background"
            },
            "&:before": {
                left: "0",
                transform: "translate3d(-50%, -50%, 1px) rotate(45deg)"
            },
            "&:after": {
                left: "100%",
                transform: "translate3d(-50%, -50%, 1px) rotate(45deg)"
            }
        }),
    chevron: ({ props: props, deps: deps })=>({
            position: "relative",
            "&:before, &:after": {
                content: '""',
                display: "block",
                position: "absolute",
                zIndex: "-1",
                aspectRatio: "1/1",
                top: "50%",
                transformOrigin: "50% 50%",
                transition: $1364b7b7ead3f203$var$inheritTransition({
                    props: props,
                    deps: deps
                }),
                transitionProperty: "background"
            },
            "&:before": {
                background: `linear-gradient(225deg, ${$1364b7b7ead3f203$var$getComputedBackgroundColor({
                    props: props,
                    deps: deps
                })} 25%, transparent 25%), linear-gradient(315deg, ${$1364b7b7ead3f203$var$getComputedBackgroundColor({
                    props: props,
                    deps: deps
                })} 25%, transparent 25%)`
            },
            "&:after": {
                background: $1364b7b7ead3f203$var$getComputedBackgroundColor({
                    props: props,
                    deps: deps
                }),
                borderRadius: ".25em"
            }
        }),
    chevronDirection: {
        left: {
            "&:before": {
                height: "100%",
                left: "100%",
                transform: "translate3d(-1%, -50%, 1px) scale(-1, 1)"
            },
            "&:after": {
                height: "73%",
                left: "0",
                transform: "translate3d(-50%, -50%, 1px) rotate(45deg)"
            }
        },
        right: {
            "&:before": {
                height: "100%",
                left: "0",
                transform: "translate3d(-99%, -50%, 1px)"
            },
            "&:after": {
                height: "73%",
                left: "100%",
                transform: "translate3d(-50%, -50%, 1px) rotate(45deg)"
            }
        }
    }
};


parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $2ae1edf582b77174$export$fe979c3403443f94 = ({ context: context, state: state })=>{
    const rootState = state && state.__root;
    return rootState && rootState.globalTheme ? rootState.globalTheme : context.designSystem && context.designSystem.globalTheme;
};
const $2ae1edf582b77174$export$14faa19a0f3bbeb2 = {
    deps: {
        depth: $1364b7b7ead3f203$export$b202ba015b5882cd,
        getSystemTheme: $2ae1edf582b77174$export$fe979c3403443f94,
        getMediaTheme: $50bcf74814855f89$export$b3cf7317de2f2233,
        getMediaColor: $c6753c52b98cd54e$export$dd72f6d9deea7207,
        transformTextStroke: $33055954907944f0$export$8bcd50b221b13db,
        transformShadow: $33055954907944f0$export$837e4beeff9ff924,
        transformBoxShadow: $33055954907944f0$export$9c296746f296a70,
        transformBorder: $33055954907944f0$export$ca4ef6ca6dc743f2,
        transformBackgroundImage: $33055954907944f0$export$15f2b9b64835b137
    },
    class: {
        depth: ({ props: props, deps: deps })=>!(0, $EqHTq.isUndefined)(props.depth) && deps.depth[props.depth],
        theme: (element)=>{
            const { props: props, deps: deps } = element;
            const globalTheme = deps.getSystemTheme(element);
            if (!props.theme) return;
            const hasSubtheme = props.theme.includes(" ") && !props.theme.includes("@");
            const globalThemeForced = `@${props.themeModifier || globalTheme}`;
            if (hasSubtheme) {
                const themeAppliedInVal = props.theme.split(" ");
                themeAppliedInVal.splice(1, 0, globalThemeForced);
                return deps.getMediaTheme(themeAppliedInVal);
            } else if (props.theme.includes("@{globalTheme}")) props.theme.replace("@{globalTheme}", globalThemeForced);
            return deps.getMediaTheme(props.theme, `@${props.themeModifier || globalTheme}`);
        },
        color: (element)=>{
            const { props: props, deps: deps } = element;
            const globalTheme = deps.getSystemTheme(element);
            if (!props.color) return;
            return {
                color: deps.getMediaColor(props.color, globalTheme)
            };
        },
        background: (element)=>{
            const { props: props, deps: deps } = element;
            const globalTheme = deps.getSystemTheme(element);
            if (!props.background) return;
            return {
                background: deps.getMediaColor(props.background, globalTheme)
            };
        },
        backgroundColor: (element)=>{
            const { props: props, deps: deps } = element;
            const globalTheme = deps.getSystemTheme(element);
            if (!props.backgroundColor) return;
            return {
                backgroundColor: deps.getMediaColor(props.backgroundColor, globalTheme)
            };
        },
        backgroundImage: (element)=>{
            const { props: props, deps: deps } = element;
            const globalTheme = deps.getSystemTheme(element);
            if (!props.backgroundImage) return;
            return {
                backgroundImage: deps.transformBackgroundImage(props.backgroundImage, globalTheme)
            };
        },
        backgroundSize: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.backgroundSize) ? {
                backgroundSize: props.backgroundSize
            } : null,
        backgroundPosition: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.backgroundPosition) ? {
                backgroundPosition: props.backgroundPosition
            } : null,
        backgroundRepeat: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.backgroundRepeat) ? {
                backgroundRepeat: props.backgroundRepeat
            } : null,
        textStroke: ({ props: props, deps: deps })=>!(0, $EqHTq.isUndefined)(props.textStroke) ? {
                WebkitTextStroke: deps.transformTextStroke(props.textStroke)
            } : null,
        outline: ({ props: props, deps: deps })=>!(0, $EqHTq.isUndefined)(props.outline) && {
                outline: deps.transformBorder(props.outline)
            },
        border: ({ props: props, deps: deps })=>!(0, $EqHTq.isUndefined)(props.border) && {
                border: deps.transformBorder(props.border)
            },
        borderColor: (element)=>{
            const { props: props, deps: deps } = element;
            const globalTheme = deps.getSystemTheme(element);
            if (!props.borderColor) return;
            return {
                borderColor: deps.getMediaColor(props.borderColor, globalTheme)
            };
        },
        borderStyle: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.borderStyle) && {
                borderStyle: props.borderStyle
            },
        borderLeft: ({ props: props, deps: deps })=>!(0, $EqHTq.isUndefined)(props.borderLeft) && {
                borderLeft: deps.transformBorder(props.borderLeft)
            },
        borderTop: ({ props: props, deps: deps })=>!(0, $EqHTq.isUndefined)(props.borderTop) && {
                borderTop: deps.transformBorder(props.borderTop)
            },
        borderRight: ({ props: props, deps: deps })=>!(0, $EqHTq.isUndefined)(props.borderRight) && {
                borderRight: deps.transformBorder(props.borderRight)
            },
        borderBottom: ({ props: props, deps: deps })=>!(0, $EqHTq.isUndefined)(props.borderBottom) && {
                borderBottom: deps.transformBorder(props.borderBottom)
            },
        shadow: (element)=>{
            const { props: props, deps: deps } = element;
            const globalTheme = deps.getSystemTheme(element);
            if (!props.backgroundImage) return;
            return {
                boxShadow: deps.transformShadow(props.backgroundImage, globalTheme)
            };
        },
        boxShadow: ({ props: props, deps: deps })=>(0, $EqHTq.isString)(props.boxShadow) && {
                boxShadow: deps.transformBoxShadow(props.boxShadow)
            },
        textShadow: ({ props: props, deps: deps })=>!(0, $EqHTq.isUndefined)(props.textShadow) && {
                textShadow: deps.transformBoxShadow(props.textShadow)
            },
        backdropFilter: ({ props: props, deps: deps })=>!(0, $EqHTq.isUndefined)(props.backdropFilter) && {
                backdropFilter: props.backdropFilter
            },
        opacity: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.opacity) && {
                opacity: props.opacity
            },
        visibility: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.visibility) && {
                visibility: props.visibility
            },
        columnRule: ({ props: props, deps: deps })=>!(0, $EqHTq.isUndefined)(props.columnRule) && {
                columnRule: deps.transformBorder(props.columnRule)
            },
        filter: ({ props: props, deps: deps })=>!(0, $EqHTq.isUndefined)(props.filter) && {
                filter: props.filter
            },
        mixBlendMode: ({ props: props, deps: deps })=>!(0, $EqHTq.isUndefined)(props.mixBlendMode) && {
                mixBlendMode: props.mixBlendMode
            },
        appearance: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.appearance) && {
                appearance: props.appearance
            }
    }
};


"use strict";
const $bc85e892389de1ab$export$5c168558fab3755c = {
    "@": (key, props, result, element, isSubtree)=>$bc85e892389de1ab$var$applyMediaProps(key, props, isSubtree ? result : result && result.media, element),
    ":": (key, props, result, element, isSubtree)=>$bc85e892389de1ab$var$applySelectorProps(key, props, isSubtree ? result : result && result.selector, element),
    "[": (key, props, result, element, isSubtree)=>$bc85e892389de1ab$var$applySelectorProps(key, props, isSubtree ? result : result && result.selector, element),
    "*": (key, props, result, element, isSubtree)=>$bc85e892389de1ab$var$applySelectorProps(key, props, isSubtree ? result : result && result.selector, element),
    "+": (key, props, result, element, isSubtree)=>$bc85e892389de1ab$var$applySelectorProps(key, props, isSubtree ? result : result && result.selector, element),
    "~": (key, props, result, element, isSubtree)=>$bc85e892389de1ab$var$applySelectorProps(key, props, isSubtree ? result : result && result.selector, element),
    "&": (key, props, result, element, isSubtree)=>$bc85e892389de1ab$var$applyAndProps(key, props, isSubtree ? result : result && result.selector, element),
    ">": (key, props, result, element, isSubtree)=>$bc85e892389de1ab$var$applyAndProps(key, props, isSubtree ? result : result && result.selector, element),
    $: (key, props, result, element, isSubtree)=>$bc85e892389de1ab$var$applyCaseProps(key, props, isSubtree ? result : result && result.case, element),
    "-": (key, props, result, element, isSubtree)=>$bc85e892389de1ab$var$applyVariableProps(key, props, isSubtree ? result : result && result.variable, element),
    ".": (key, props, result, element, isSubtree)=>$bc85e892389de1ab$var$applyConditionalCaseProps(key, props, isSubtree ? result : result && result.case, element),
    "!": (key, props, result, element, isSubtree)=>$bc85e892389de1ab$var$applyConditionalFalsyProps(key, props, isSubtree ? result : result && result.case, element)
};
const $bc85e892389de1ab$var$execClass = (key, props, result, element)=>{
    const { class: className } = element;
    const classnameExec = className[key];
    if (typeof classnameExec !== "function") return;
    let classExec = classnameExec({
        props: props,
        context: element.context,
        state: element.state,
        deps: element.deps
    });
    if ((0, $EqHTq.isArray)(classExec)) classExec = classExec.reduce((a, c)=>(0, $8wu6n.merge)(a, c), {});
    for(const finalProp in classExec)result[finalProp] = classExec[finalProp];
    return classExec;
};
const $bc85e892389de1ab$var$convertPropsToClass = (props, result, element)=>{
    const propsClassObj = {};
    for(const key in props){
        const setter = $bc85e892389de1ab$export$5c168558fab3755c[key.slice(0, 1)];
        if (setter) {
            setter(key, props[key], propsClassObj, element, true);
            continue;
        } else $bc85e892389de1ab$var$execClass(key, props, propsClassObj, element);
    }
    return propsClassObj;
};
const $bc85e892389de1ab$var$applyMediaProps = (key, props, result, element)=>{
    const { context: context } = element;
    if (!context.designSystem || !context.designSystem.MEDIA) return;
    const globalTheme = (0, $2ae1edf582b77174$export$fe979c3403443f94)(element);
    const { MEDIA: MEDIA } = context.designSystem;
    const mediaName = MEDIA[key.slice(1)];
    const generatedClass = $bc85e892389de1ab$var$convertPropsToClass(props, result, element);
    const name = key.slice(1);
    const isTheme = [
        "dark",
        "light"
    ].includes(name);
    const matchesGlobal = name === globalTheme;
    if (globalTheme && isTheme) {
        if (matchesGlobal) return (0, $8wu6n.merge)(result, generatedClass);
        return;
    }
    const mediaKey = mediaName ? `@media screen and ${mediaName}` : key;
    result[mediaKey] = generatedClass;
    return result[mediaKey];
};
const $bc85e892389de1ab$var$applyAndProps = (key, props, result, element)=>{
    result[key] = $bc85e892389de1ab$var$convertPropsToClass(props, result, element);
    return result[key];
};
const $bc85e892389de1ab$var$applySelectorProps = (key, props, result, element)=>{
    const selectorKey = `&${key}`;
    result[selectorKey] = $bc85e892389de1ab$var$convertPropsToClass(props, result, element);
    return result[selectorKey];
};
const $bc85e892389de1ab$var$applyCaseProps = (key, props, result, element)=>{
    const { CASES: CASES } = element.context && element.context.designSystem;
    const caseKey = key.slice(1);
    const isPropTrue = element.props[caseKey];
    if (!CASES[caseKey] && !isPropTrue) return;
    return (0, $8wu6n.merge)(result, $bc85e892389de1ab$var$convertPropsToClass(props, result, element));
};
const $bc85e892389de1ab$var$applyVariableProps = (key, props, result, element)=>{
    result[key] = props;
    return result;
};
const $bc85e892389de1ab$var$applyConditionalCaseProps = (key, props, result, element)=>{
    const caseKey = key.slice(1);
    const isPropTrue = element.props[caseKey] || element.state[caseKey];
    if (!isPropTrue) return; // remove classname if not here
    return (0, $8wu6n.merge)(result, $bc85e892389de1ab$var$convertPropsToClass(props, result, element));
};
const $bc85e892389de1ab$var$applyConditionalFalsyProps = (key, props, result, element)=>{
    const caseKey = key.slice(1);
    const isPropTrue = element.props[caseKey] || element.state[caseKey] === true;
    if (!isPropTrue) return (0, $8wu6n.merge)(result, $bc85e892389de1ab$var$convertPropsToClass(props, result, element));
};
const $bc85e892389de1ab$var$applyTrueProps = (props, result, element)=>(0, $8wu6n.merge)(result, $bc85e892389de1ab$var$convertPropsToClass(props, result, element));
const $bc85e892389de1ab$var$beforeClassAssign = (element, s)=>{
    const { props: props, class: className, context: context } = element;
    const CLASS_NAMES = {
        media: {},
        selector: {},
        case: {},
        variable: {}
    };
    if (!context) return;
    const globalTheme = context.designSystem.globalTheme;
    for(const key in props){
        const setter = $bc85e892389de1ab$export$5c168558fab3755c[key.slice(0, 1)];
        if (globalTheme) {
            if (key === "theme") props.update({
                themeModifier: globalTheme
            }, {
                preventListeners: true,
                preventRecursive: true,
                isForced: true,
                preventDefineUpdate: true
            });
            else if (key === "true") $bc85e892389de1ab$var$applyTrueProps(props[key], CLASS_NAMES, element);
        }
        if (setter) setter(key, props[key], CLASS_NAMES, element);
    }
    // override props
    if (props["^"]) for(const key in props["^"])$bc85e892389de1ab$var$execClass(key, props, CLASS_NAMES, element);
    const parentProps = element.parent && element.parent.props;
    if (parentProps && parentProps.spacingRatio && parentProps.inheritSpacingRatio) element.setProps({
        spacingRatio: parentProps.spacingRatio,
        inheritSpacingRatio: true
    }, {
        preventListeners: true,
        preventRecursive: true,
        isForced: true,
        preventDefineUpdate: true
    });
    (0, $8wu6n.overwriteShallow)(className, CLASS_NAMES);
};
const $bc85e892389de1ab$export$7fc53215244aec38 = {
    class: {
        case: (el, s)=>{
            return {
            };
        }
    },
    on: {
        beforeClassAssign: $bc85e892389de1ab$var$beforeClassAssign
    }
};


var $0b0e26e2a21aab54$exports = {};

$parcel$export($0b0e26e2a21aab54$exports, "Iframe", () => $0b0e26e2a21aab54$export$5137ec99f248330b);
"use strict";
const $0b0e26e2a21aab54$export$5137ec99f248330b = {
    tag: "iframe",
    props: {
        position: "relative",
        minWidth: "H",
        minHeight: "H"
    },
    attr: {
        src: ({ props: props })=>props.src,
        loading: ({ props: props })=>props.loading,
        allowfullscreen: ({ props: props })=>props.allowfullscreen,
        frameborder: ({ props: props })=>props.frameborder,
        allow: ({ props: props })=>props.allow,
        referrerpolicy: ({ props: props })=>props.referrerpolicy
    }
};


var $2d62e11bc2f194bd$exports = {};

$parcel$export($2d62e11bc2f194bd$exports, "Interaction", () => $2d62e11bc2f194bd$export$a13296960cae0384);
"use strict";
const $2d62e11bc2f194bd$export$a13296960cae0384 = {
    class: {
        userSelect: ({ props: props })=>props.userSelect && {
                userSelect: props.userSelect
            },
        pointerEvents: ({ props: props })=>props.pointerEvents && {
                pointerEvents: props.pointerEvents
            },
        cursor: ({ props: props })=>props.cursor && {
                cursor: props.cursor
            }
    }
};


var $c3656ade3a6fd1e0$exports = {};

$parcel$export($c3656ade3a6fd1e0$exports, "Hoverable", () => $c3656ade3a6fd1e0$export$8cf654b375a16d2d);
$parcel$export($c3656ade3a6fd1e0$exports, "Clickable", () => $c3656ade3a6fd1e0$export$2f51d37476d4c437);
$parcel$export($c3656ade3a6fd1e0$exports, "Focusable", () => $c3656ade3a6fd1e0$export$35a3bebf7ef2d934);
$parcel$export($c3656ade3a6fd1e0$exports, "FocusableComponent", () => $c3656ade3a6fd1e0$export$b177f82f5511f000);
"use strict";
const $c3656ade3a6fd1e0$var$style = {
    appearance: "none",
    border: "none",
    cursor: "pointer",
    fontFamily: "inherit"
};
const $c3656ade3a6fd1e0$export$8cf654b375a16d2d = {
    props: {
        transition: "C defaultBezier",
        transitionProperty: "opacity, transform",
        opacity: 0.85,
        ":hover": {
            opacity: 0.9,
            transform: "scale(1.015)"
        },
        ":active": {
            opacity: 1,
            transform: "scale(1.015)"
        },
        ".active": {
            opacity: 1,
            transform: "scale(1.015)",
            ":hover": {
                opacity: 1
            }
        }
    }
};
const $c3656ade3a6fd1e0$export$2f51d37476d4c437 = {
    extend: $c3656ade3a6fd1e0$export$8cf654b375a16d2d,
    props: {
        ":active": {
            opacity: 1,
            transform: "scale(1.015)"
        },
        ".active": {
            opacity: 1
        }
    }
};
const $c3656ade3a6fd1e0$export$35a3bebf7ef2d934 = {
    props: {
        border: "none",
        outline: "solid, 0, blue .3",
        ":focus-visible": {
            opacity: 1,
            outline: "solid, X, blue .3"
        }
    },
    attr: {
        placeholder: ({ props: props })=>props.placeholder,
        tabIndex: ({ props: props })=>props.tabIndex
    }
};
const $c3656ade3a6fd1e0$export$b177f82f5511f000 = {
    extend: $c3656ade3a6fd1e0$export$35a3bebf7ef2d934,
    tag: "button",
    props: {
        fontSize: "A",
        type: "button",
        border: "none",
        textDecoration: "none",
        lineHeight: "1",
        whiteSpace: "nowrap",
        fontFamily: "inherit",
        style: $c3656ade3a6fd1e0$var$style
    },
    attr: {
        type: ({ props: props })=>props.type
    }
};


var $1cd063474a590068$exports = {};

$parcel$export($1cd063474a590068$exports, "Overflow", () => $1cd063474a590068$export$25d20c189d4a23b8);
"use strict";
const $1cd063474a590068$export$25d20c189d4a23b8 = {
    class: {
        overflow: ({ props: props })=>props.overflow && {
                overflow: props.overflow
            },
        overflowX: ({ props: props })=>props.overflowX && {
                overflowX: props.overflowX
            },
        overflowY: ({ props: props })=>props.overflowY && {
                overflowY: props.overflowY
            }
    }
};


var $c17872c3358c86eb$exports = {};

$parcel$export($c17872c3358c86eb$exports, "Collection", () => $c17872c3358c86eb$export$fb8073518f34e6ec);
"use strict";
const $bfb47641e396194b$export$5100524046ce8de6 = [
    "update",
    "parse",
    "clean",
    "create",
    "destroy",
    "add",
    "toggle",
    "remove",
    "apply",
    "set",
    "reset",
    "rootUpdate",
    "parentUpdate",
    "parent",
    "__element",
    "__depends",
    "__ref",
    "__children",
    "__root"
];


parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $33936e69aa63c9cd$export$27ca81ea148fa005 = (param, element, state, context, options)=>{
    return param(element, state || element.state, context || element.context, options);
};
const $33936e69aa63c9cd$export$1bc010482b845252 = (param, element, options)=>{
    if (element.on && (0, $EqHTq.isFunction)(element.on[param])) {
        const { state: state, context: context } = element;
        return $33936e69aa63c9cd$export$27ca81ea148fa005(element.on[param], element, state, context, options);
    }
};
const $33936e69aa63c9cd$export$906113ec468a9c43 = (param, updatedObj, element, state, context, options)=>{
    return param(updatedObj, element, state || element.state, context || element.context, options);
};
const $33936e69aa63c9cd$export$8fe90418b8a0fc1e = (param, updatedObj, element, options)=>{
    if (element.on && (0, $EqHTq.isFunction)(element.on[param])) {
        const { state: state, context: context } = element;
        return $33936e69aa63c9cd$export$906113ec468a9c43(element.on[param], updatedObj, element, state, context, options);
    }
};
const $33936e69aa63c9cd$export$1f7cb486ba1f8a10 = (element, options)=>{
    const { node: node, on: on } = element;
    for(const param in on){
        if (param === "init" || param === "beforeClassAssign" || param === "render" || param === "renderRouter" || param === "attachNode" || param === "stateInit" || param === "stateCreated" || param === "initStateUpdate" || param === "stateUpdate" || param === "initUpdate" || param === "update") continue;
        const appliedFunction = element.on[param];
        if ((0, $EqHTq.isFunction)(appliedFunction)) node.addEventListener(param, (event)=>{
            const { state: state, context: context } = element;
            appliedFunction(event, element, state, context, options);
        });
    }
};


var $06908963bda72849$exports = {};

$parcel$export($06908963bda72849$exports, "ERRORS_REGISTRY", () => $06908963bda72849$export$fc4da02de2c0bd43);
$parcel$export($06908963bda72849$exports, "report", () => $06908963bda72849$export$f18d5b0af29128b7);
"use strict";
const $06908963bda72849$export$fc4da02de2c0bd43 = {
    en: {
        DocumentNotDefined: {
            title: "Document is undefined",
            description: "To tweak with DOM, you should use browser."
        },
        OverwriteToBuiltin: {
            title: "Overwriting to builtin method",
            description: "Overwriting a builtin method in the window define is not possible, please choose different name"
        },
        BrowserNotDefined: {
            title: "Can't recognize environment",
            description: "Environment should be browser application, that can run Javascript"
        },
        SetQuickPreferancesIsNotObject: {
            title: "Quick preferances object is required",
            description: 'Please pass a plain object with "lang", "culture" and "area" properties'
        },
        InvalidParams: {
            title: "Params are invalid",
            description: 'Please pass a plain object with "lang", "culture" and "area" properties'
        },
        CantCreateWithoutNode: {
            title: "You must provide node",
            description: "Can't create DOM element without setting node or text"
        },
        HTMLInvalidTag: {
            title: "Element tag name (or DOM nodeName) is invalid",
            description: "To create element, you must provide valid DOM node. See full list of them at here: http://www.w3schools.com/tags/"
        },
        HTMLInvalidAttr: {
            title: "Attibutes object is invalid",
            description: "Please pass a valid plain object to apply as an attributes for a DOM node"
        },
        HTMLInvalidData: {
            title: "Data object is invalid",
            description: "Please pass a valid plain object to apply as an dataset for a DOM node"
        },
        HTMLInvalidStyles: {
            title: "Styles object is invalid",
            description: "Please pass a valid plain object to apply as an style for a DOM node"
        },
        HTMLInvalidText: {
            title: "Text string is invalid",
            description: "Please pass a valid string to apply text to DOM node"
        },
        ElementOnStateIsNotDefined: {
            title: "Element on state is not defined",
            description: "Please check the element object"
        }
    }
};
const $06908963bda72849$export$f18d5b0af29128b7 = (err, arg, element)=>{
    const currentLang = "en";
    let errObj;
    if (err && typeof err === "string") errObj = $06908963bda72849$export$fc4da02de2c0bd43[currentLang][err];
    return new Error(`"${err}", "${arg}"\n\n`, `${errObj.description}`, element ? `\n\n${element}` : "");
};


parcelRequire("cBUNY");
var $glQML = parcelRequire("glQML");
"use strict";
const $a7c2803c7e7b293f$export$342a7615681b7118 = (tag)=>{
    return (0, $glQML.isValidHtmlTag)(tag || "div") || (0, $06908963bda72849$export$f18d5b0af29128b7)("HTMLInvalidTag");
};


"use strict";


parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");

parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
var $hSU9O = parcelRequire("hSU9O");

"use strict";
const $7c314a91da5c12c3$export$98e6a39c04603d36 = function() {
    const state = this;
    if ((0, $EqHTq.isObject)(state)) {
        const obj = {};
        for(const param in state)if (!(0, $bfb47641e396194b$export$5100524046ce8de6).includes(param)) obj[param] = state[param];
        return obj;
    } else if ((0, $EqHTq.isArray)(state)) return state.filter((item)=>!(0, $bfb47641e396194b$export$5100524046ce8de6).includes(item));
};
const $7c314a91da5c12c3$export$cf0b2a6c63f9e656 = function(options = {}) {
    const state = this;
    for(const param in state)if (!(0, $bfb47641e396194b$export$5100524046ce8de6).includes(param)) delete state[param];
    if (!options.preventStateUpdate) state.update(state, {
        replace: true,
        ...options
    });
    return state;
};
const $7c314a91da5c12c3$export$b1fb4cac938035f7 = function(options = {}) {
    const state = this;
    const element = state.__element;
    const stateKey = element.__ref.__state;
    if ((0, $EqHTq.isString)(stateKey)) {
        element.parent.state.remove(stateKey, {
            isHoisted: true,
            ...options
        });
        return element.state;
    }
    delete element.state;
    element.state = state.parent;
    if (state.parent) delete state.parent.__children[element.key];
    if (state.__children) for(const key in state.__children){
        const child = state.__children[key];
        if (child.state) {
            if ((0, $EqHTq.isArray)(child.state)) Object.defineProperty(child.state, "parent", {
                value: state.parent,
                enumerable: false,
                configurable: true,
                writable: true // Set this to true if you want to allow changing the function later
            });
            else Object.setPrototypeOf(child, {
                parent: state.parent
            });
        }
    }
    element.state.update({}, {
        isHoisted: true,
        ...options
    });
    return element.state;
};
const $7c314a91da5c12c3$export$e45af8832c6abf26 = function(obj, options = {}) {
    const state = this;
    if (!state || !state.parent) return;
    return state.parent.update(obj, {
        isHoisted: true,
        ...options
    });
};
const $7c314a91da5c12c3$export$c2f300c8c094e900 = function(obj, options = {}) {
    const state = this;
    if (!state) return;
    const rootState = state.__element.__ref.__root.state;
    return rootState.update(obj, {
        isHoisted: false,
        ...options
    });
};
const $7c314a91da5c12c3$export$e16d8520af44a096 = function(value, options = {}) {
    const state = this;
    if ((0, $EqHTq.isArray)(state)) {
        state.push(value);
        state.update(state.parse(), {
            overwrite: true,
            ...options
        });
    } else if ((0, $EqHTq.isObject)(state)) {
        const key = Object.keys(state).length;
        state.update({
            [key]: value
        }, options);
    }
};
const $7c314a91da5c12c3$export$e03c1c3201ee8bb7 = function(key, options = {}) {
    const state = this;
    state.update({
        [key]: !state[key]
    }, options);
};
const $7c314a91da5c12c3$export$cd7f480d6b8286c3 = function(key, options = {}) {
    const state = this;
    if ((0, $EqHTq.isArray)(state)) (0, $hSU9O.removeFromArray)(state, key);
    if ((0, $EqHTq.isObject)(state)) (0, $8wu6n.removeFromObject)(state, key);
    return state.set(state.parse(), {
        replace: true,
        ...options
    });
};
const $7c314a91da5c12c3$export$adaa4cf7ef1b65be = function(val, options = {}) {
    const state = this;
    const value = (0, $8wu6n.deepCloneWithExtnd)(val);
    return state.clean({
        preventStateUpdate: true,
        ...options
    }).update(value, {
        replace: true,
        ...options
    });
};
const $7c314a91da5c12c3$export$aad8462122ac592b = function(options = {}) {
    const state = this;
    const value = (0, $8wu6n.deepCloneWithExtnd)(state.parse());
    return state.set(value, {
        replace: true,
        ...options
    });
};
const $7c314a91da5c12c3$export$5635d7ef4b8fee1c = function(func, options = {}) {
    const state = this;
    if ((0, $EqHTq.isFunction)(func)) {
        func(state);
        return state.update(state.parse(), {
            replace: true,
            ...options
        });
    }
};





parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");

"use strict";
const $5fcb062e9eb35754$export$c138e045c9d99c0 = (stateKey, parentState)=>{
    if (!stateKey.includes("~/")) return;
    const arr = stateKey.split("~/");
    if (arr.length > 1) return parentState.__root;
};
const $5fcb062e9eb35754$export$f7dd4f6f6830b29d = (stateKey, parentState)=>{
    if (!stateKey.includes("../")) return;
    const arr = stateKey.split("../");
    const arrLength = arr.length - 1;
    for(let i = 0; i < arrLength; i++){
        if (!parentState.parent) return null;
        parentState = parentState.parent;
    }
    return parentState;
};
const $5fcb062e9eb35754$export$e6d108f71cc7e736 = (stateKey, parentState, options = {})=>{
    const arr = stateKey.split("/");
    const arrLength = arr.length - 1;
    for(let i = 0; i < arrLength; i++){
        const childKey = arr[i];
        const grandChildKey = arr[i + 1];
        if (childKey === "__proto__" || grandChildKey === "__proto__") return;
        let childInParent = parentState[childKey];
        if (!childInParent) childInParent = parentState[childKey] = {} // check for array
        ;
        if (!childInParent[grandChildKey]) childInParent[grandChildKey] = {} // check for array
        ;
        stateKey = grandChildKey;
        parentState = childInParent;
    }
    if (options.returnParent) return parentState;
    return parentState[stateKey];
};
const $5fcb062e9eb35754$export$487549069bb5d2a9 = (element, parent, options = {})=>{
    const ref = element.__ref;
    let stateKey = ref.__state;
    if (!$5fcb062e9eb35754$export$e187d7e20e9fd8fa(element)) return;
    const rootState = $5fcb062e9eb35754$export$c138e045c9d99c0(stateKey, parent.state);
    let parentState = parent.state;
    if (rootState) {
        parentState = rootState;
        stateKey = stateKey.replaceAll("~/", "");
    } else {
        const findGrandParentState = $5fcb062e9eb35754$export$f7dd4f6f6830b29d(stateKey, parent.state);
        if (findGrandParentState) {
            parentState = findGrandParentState;
            stateKey = stateKey.replaceAll("../", "");
        }
    }
    if (!parentState) return;
    return $5fcb062e9eb35754$export$e6d108f71cc7e736(stateKey, parentState, options);
};
const $5fcb062e9eb35754$export$c546cc738d4564ba = (element, parent)=>{
    const ref = element.__ref;
    const inheritedState = $5fcb062e9eb35754$export$487549069bb5d2a9(element, parent);
    if ((0, $EqHTq.isUndefined)(inheritedState)) return element.state;
    if ((0, $EqHTq.is)(inheritedState)("object", "array")) return (0, $8wu6n.deepCloneWithExtnd)(inheritedState, (0, $bfb47641e396194b$export$5100524046ce8de6));
    else if ((0, $EqHTq.is)(inheritedState)("string", "number", "boolean")) {
        ref.__stateType = typeof inheritedState;
        return {
            value: inheritedState
        };
    }
    console.warn(ref.__state, "is not present. Replacing with", {});
};
const $5fcb062e9eb35754$export$e187d7e20e9fd8fa = (element)=>{
    const ref = element.__ref;
    const stateKey = ref.__state;
    if (stateKey && (0, $EqHTq.is)(stateKey)("number", "string", "boolean")) return true;
    return false;
};
const $5fcb062e9eb35754$export$e5d60a6bbabd36f = function(state) {
    if (!(0, $EqHTq.isObjectLike)(state)) return false;
    return state.update && state.parse && state.clean && state.create && state.parent && state.destroy && state.rootUpdate && state.parentUpdate && state.toggle && state.add && state.apply && state.__element && state.__children;
// return arrayContainsOtherArray(keys, ['update', 'parse', 'clean', 'create', 'parent', 'rootUpdate'])
};
const $5fcb062e9eb35754$export$a1831dd7b6191ba4 = (path, value)=>{
    if (!path) return value || {};
    const keys = path.split("/");
    const obj = {};
    let ref = obj;
    keys.forEach((key, index)=>{
        ref[key] = index === keys.length - 1 ? value || {} : {};
        ref = ref[key];
    });
    return obj;
};


"use strict";
const $8b576c5d9c1d0c84$var$STATE_UPDATE_OPTIONS = {
    overwrite: true,
    preventHoistElementUpdate: false,
    updateByState: true,
    isHoisted: true,
    execStateFunction: true
};
const $8b576c5d9c1d0c84$export$4971331372cec95a = function(obj, options = $8b576c5d9c1d0c84$var$STATE_UPDATE_OPTIONS) {
    const state = this;
    const element = state.__element;
    if (!options.updateByState) (0, $8wu6n.merge)(options, $8b576c5d9c1d0c84$var$STATE_UPDATE_OPTIONS);
    if (!state.__element) (0, $06908963bda72849$export$f18d5b0af29128b7)("ElementOnStateIsNotDefined");
    if (options.preventInheritAtCurrentState === true) options.preventInheritAtCurrentState = state;
    else if (options.preventInheritAtCurrentState) return;
    if (!options.preventInitStateUpdateListener) {
        const initStateUpdateReturns = (0, $33936e69aa63c9cd$export$8fe90418b8a0fc1e)("initStateUpdate", obj, element, options);
        if (initStateUpdateReturns === false) return element;
    }
    $8b576c5d9c1d0c84$var$applyOverwrite(state, obj, options);
    const updateIsHoisted = $8b576c5d9c1d0c84$var$hoistStateUpdate(state, obj, options);
    if (updateIsHoisted) return state;
    $8b576c5d9c1d0c84$var$updateDependentState(state, obj, options);
    $8b576c5d9c1d0c84$var$applyElementUpdate(state, obj, options);
    if (!options.preventStateUpdateListener) (0, $33936e69aa63c9cd$export$8fe90418b8a0fc1e)("stateUpdate", obj, element, options);
    return state;
};
const $8b576c5d9c1d0c84$var$applyOverwrite = (state, obj, options)=>{
    const { overwrite: overwrite } = options;
    if (!overwrite) return;
    const shallow = overwrite === "shallow" || overwrite === "shallow-once";
    const merge = overwrite === "merge";
    if (merge) {
        (0, $8wu6n.deepMerge)(state, obj, (0, $bfb47641e396194b$export$5100524046ce8de6));
        return;
    }
    const overwriteFunc = shallow ? (0, $8wu6n.overwriteShallow) : (0, $8wu6n.overwriteDeep);
    if (options.overwrite === "shallow-once") options.overwrite = true;
    overwriteFunc(state, obj, (0, $bfb47641e396194b$export$5100524046ce8de6));
};
const $8b576c5d9c1d0c84$var$hoistStateUpdate = (state, obj, options)=>{
    const element = state.__element;
    const { parent: parent, __ref: ref } = element;
    const stateKey = ref.__state;
    const stateType = ref.__stateType;
    if (!stateKey) return;
    const asksForInherit = (0, $5fcb062e9eb35754$export$e187d7e20e9fd8fa)(element);
    const inheritedState = (0, $5fcb062e9eb35754$export$487549069bb5d2a9)(element, parent, {
        returnParent: true
    });
    const shouldPropagateState = asksForInherit && inheritedState && !options.stopStatePropagation;
    if (!shouldPropagateState) return;
    const isStringState = stateType === "string" || stateType === "number" || stateType === "boolean";
    const value = isStringState ? state.value : state.parse();
    const passedValue = isStringState ? state.value : obj;
    const findRootState = (0, $5fcb062e9eb35754$export$c138e045c9d99c0)(stateKey, parent.state);
    const findGrandParentState = (0, $5fcb062e9eb35754$export$f7dd4f6f6830b29d)(stateKey, parent.state);
    const changesValue = (0, $5fcb062e9eb35754$export$a1831dd7b6191ba4)(stateKey, passedValue);
    const targetParent = findRootState || findGrandParentState || parent.state;
    if (options.replace) (0, $8wu6n.overwriteDeep)(targetParent, changesValue || value) // check with createNestedObjectByKeyPath
    ;
    targetParent.update(changesValue, {
        execStateFunction: false,
        isHoisted: true,
        preventUpdate: options.preventHoistElementUpdate,
        overwrite: !options.replace,
        ...options
    });
    const hasNotUpdated = options.preventUpdate !== true || !options.preventHoistElementUpdate;
    if (!options.preventStateUpdateListener && hasNotUpdated) (0, $33936e69aa63c9cd$export$8fe90418b8a0fc1e)("stateUpdate", obj, element, options);
    return true;
};
const $8b576c5d9c1d0c84$var$updateDependentState = (state, obj, options)=>{
    if (!state.__depends) return;
    for(const el in state.__depends){
        const dependentState = state.__depends[el];
        dependentState.clean().update(state.parse(), options);
    }
};
const $8b576c5d9c1d0c84$var$applyElementUpdate = (state, obj, options)=>{
    const element = state.__element;
    if (options.preventUpdate !== true) element.update({}, {
        ...options,
        updateByState: true
    });
    else if (options.preventUpdate === "recursive") element.update({}, {
        ...options,
        isHoisted: false,
        updateByState: true,
        preventUpdate: true
    });
};



"use strict";
const $774f1a3b2fe82710$export$e6a0daad8304de = function(element, parent, options) {
    element.state = $774f1a3b2fe82710$export$6e8a0938c76079c7(element, parent, options);
    return element.state;
};
const $774f1a3b2fe82710$export$6e8a0938c76079c7 = function(element, parent, options) {
    const objectizeState = $774f1a3b2fe82710$var$checkForTypes(element);
    if (objectizeState === false) return parent.state || {};
    else element.state = (0, $8wu6n.deepCloneWithExtnd)(objectizeState, (0, $bfb47641e396194b$export$5100524046ce8de6));
    const whatInitReturns = (0, $33936e69aa63c9cd$export$1bc010482b845252)("stateInit", element, options);
    if (whatInitReturns === false) return element.state;
    if ((0, $5fcb062e9eb35754$export$e187d7e20e9fd8fa)(element)) {
        const inheritedState = (0, $5fcb062e9eb35754$export$c546cc738d4564ba)(element, parent);
        element.state = (0, $EqHTq.isUndefined)(inheritedState) ? {} : inheritedState;
    }
    const dependentState = $774f1a3b2fe82710$var$applyDependentState(element, element.state);
    if (dependentState) element.state = dependentState;
    $774f1a3b2fe82710$var$applyMethods(element);
    // trigger `on.stateCreated`
    (0, $33936e69aa63c9cd$export$1bc010482b845252)("stateCreated", element);
    return element.state;
};
const $774f1a3b2fe82710$var$applyDependentState = (element, state)=>{
    const { __ref: ref } = state;
    if (!ref) return;
    const dependentState = (0, $8wu6n.deepCloneWithExtnd)(ref, (0, $bfb47641e396194b$export$5100524046ce8de6));
    const newDepends = {
        [element.key]: dependentState
    };
    ref.__depends = (0, $EqHTq.isObject)(ref.__depends) ? {
        ...ref.__depends,
        ...newDepends
    } : newDepends;
    return dependentState;
};
const $774f1a3b2fe82710$var$checkForTypes = (element)=>{
    const { state: state, __ref: ref } = element;
    if ((0, $EqHTq.isFunction)(state)) {
        ref.__state = state;
        return (0, $8wu6n.exec)(state, element);
    } else if ((0, $EqHTq.is)(state)("string", "number")) {
        ref.__state = state;
        return {};
    } else if (state === true) {
        ref.__state = element.key;
        return {};
    } else if (state) {
        ref.__hasRootState = true;
        return state;
    } else return false;
};
const $774f1a3b2fe82710$var$addProtoToArray = (state, proto)=>{
    for(const key in proto)Object.defineProperty(state, key, {
        value: proto[key],
        enumerable: false,
        configurable: true,
        writable: true // Set this to true if you want to allow changing the function later
    });
};
const $774f1a3b2fe82710$var$applyMethods = (element)=>{
    const state = element.state;
    const ref = element.__ref;
    const proto = {
        clean: (0, $7c314a91da5c12c3$export$cf0b2a6c63f9e656).bind(state),
        parse: (0, $7c314a91da5c12c3$export$98e6a39c04603d36).bind(state),
        destroy: (0, $7c314a91da5c12c3$export$b1fb4cac938035f7).bind(state),
        update: (0, $8b576c5d9c1d0c84$export$4971331372cec95a).bind(state),
        rootUpdate: (0, $7c314a91da5c12c3$export$c2f300c8c094e900).bind(state),
        parentUpdate: (0, $7c314a91da5c12c3$export$e45af8832c6abf26).bind(state),
        create: $774f1a3b2fe82710$export$e6a0daad8304de.bind(state),
        add: (0, $7c314a91da5c12c3$export$e16d8520af44a096).bind(state),
        toggle: (0, $7c314a91da5c12c3$export$e03c1c3201ee8bb7).bind(state),
        remove: (0, $7c314a91da5c12c3$export$cd7f480d6b8286c3).bind(state),
        apply: (0, $7c314a91da5c12c3$export$5635d7ef4b8fee1c).bind(state),
        set: (0, $7c314a91da5c12c3$export$adaa4cf7ef1b65be).bind(state),
        reset: (0, $7c314a91da5c12c3$export$aad8462122ac592b).bind(state),
        parent: element.parent.state,
        __element: element,
        __children: {},
        __root: ref.__root ? ref.__root.state : state
    };
    if ((0, $EqHTq.isArray)(state)) $774f1a3b2fe82710$var$addProtoToArray(state, proto);
    else Object.setPrototypeOf(state, proto);
    if (state.parent && state.parent.__children) state.parent.__children[element.key] = state;
};





"use strict";


parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $c17872c3358c86eb$export$fb8073518f34e6ec = {
    define: {
        $collection: (param, el, state)=>{
            if (!param) return;
            if ((0, $EqHTq.isString)(param)) {
                if (param === "state") param = state.parse();
                else param = (0, $5fcb062e9eb35754$export$e6d108f71cc7e736)(param, state);
            }
            if ((0, $5fcb062e9eb35754$export$e5d60a6bbabd36f)(param)) param = param.parse();
            if ((0, $EqHTq.isNot)(param)("array", "object")) return;
            const { __ref: ref } = el;
            if ((0, $EqHTq.isObjectLike)(param)) param = (0, $8wu6n.deepClone)(param);
            if (ref.__collectionCache) {
                const equals = JSON.stringify(param) === JSON.stringify(ref.__collectionCache);
                if (equals) {
                    ref.__noCollectionDifference = true;
                    return;
                } else {
                    ref.__collectionCache = param;
                    delete ref.__noCollectionDifference;
                }
            } else ref.__collectionCache = param;
            const obj = {
                tag: "fragment",
                props: {
                    childProps: el.props && el.props.childProps
                }
            };
            for(const key in param){
                const value = param[key];
                obj[key] = (0, $EqHTq.isObjectLike)(value) ? value : {
                    value: value
                };
            }
            el.removeContent();
            el.content = obj;
            return obj;
        },
        $setCollection: (param, el, state)=>{
            if (!param) return;
            if ((0, $EqHTq.isString)(param)) {
                if (param === "state") param = state.parse();
                else param = (0, $5fcb062e9eb35754$export$e6d108f71cc7e736)(param, state);
            }
            const data = ((0, $EqHTq.isArray)(param) ? param : (0, $EqHTq.isObject)(param) ? Object.values(param) : []).map((item)=>!(0, $EqHTq.isObjectLike)(item) ? {
                    props: {
                        value: item
                    }
                } : item);
            if (data.length) {
                const t = setTimeout(()=>{
                    el.set({
                        tag: "fragment",
                        ...data
                    }, {
                        preventDefineUpdate: "$setCollection"
                    });
                    clearTimeout(t);
                });
            }
            return data;
        },
        $stateCollection: (param, el, state)=>{
            if (!param) return;
            if ((0, $EqHTq.isString)(param)) {
                if (param === "state") param = state.parse();
                else param = (0, $5fcb062e9eb35754$export$e6d108f71cc7e736)(param, state);
            }
            if ((0, $5fcb062e9eb35754$export$e5d60a6bbabd36f)(param)) param = param.parse();
            if ((0, $EqHTq.isNot)(param)("array", "object")) return;
            const { __ref: ref } = el;
            if (ref.__stateCollectionCache) {
                const equals = JSON.stringify(param) === JSON.stringify(ref.__stateCollectionCache);
                if (equals) {
                    ref.__noCollectionDifference = true;
                    return;
                } else {
                    ref.__stateCollectionCache = (0, $8wu6n.deepClone)(param);
                    delete ref.__noCollectionDifference;
                }
            } else ref.__stateCollectionCache = (0, $8wu6n.deepClone)(param);
            const obj = {
                tag: "fragment",
                props: {
                    childProps: el.props && el.props.childProps
                }
            };
            for(const key in param){
                const value = param[key];
                obj[key] = {
                    state: (0, $EqHTq.isObjectLike)(value) ? value : {
                        value: value
                    }
                };
            }
            el.removeContent();
            el.content = obj;
            return obj;
        },
        $propsCollection: (param, el, state)=>{
            if (!param) return;
            if ((0, $EqHTq.isString)(param)) {
                if (param === "state") param = state.parse();
                else param = (0, $5fcb062e9eb35754$export$e6d108f71cc7e736)(param, state);
            }
            if ((0, $5fcb062e9eb35754$export$e5d60a6bbabd36f)(param)) param = param.parse();
            if ((0, $EqHTq.isNot)(param)("array", "object")) return;
            const { __ref: ref } = el;
            if (ref.__propsCollectionCache) {
                const equals = JSON.stringify(param) === JSON.stringify(ref.__propsCollectionCache) // eslint-disable-line
                ;
                if (equals) {
                    ref.__noCollectionDifference = true;
                    return;
                } else {
                    ref.__propsCollectionCache = (0, $8wu6n.deepClone)(param);
                    delete ref.__noCollectionDifference;
                }
            } else ref.__propsCollectionCache = (0, $8wu6n.deepClone)(param);
            const obj = {
                tag: "fragment",
                props: {
                    childProps: el.props && el.props.childProps
                }
            };
            for(const key in param){
                const value = param[key];
                obj[key] = {
                    props: (0, $EqHTq.isObjectLike)(value) ? value : {
                        value: value
                    }
                };
            }
            el.removeContent();
            el.content = obj;
            // const set = () => {
            //   el.set(obj, { preventDefineUpdate: '$propsCollection' })
            // }
            // if (el.props && el.props.lazyLoad) {
            //   window.requestAnimationFrame(set)
            // } else set()
            return obj;
        }
    }
};


var $b974d8cead94d416$exports = {};

$parcel$export($b974d8cead94d416$exports, "Position", () => $b974d8cead94d416$export$13807d9ee5a34a42);

"use strict";
const $b974d8cead94d416$export$13807d9ee5a34a42 = {
    deps: {
        getSpacingByKey: $7a9f91e2b97567cc$export$4f949d23b5dbefe6
    },
    class: {
        position: ({ props: props })=>props.position && {
                position: props.position
            },
        inset: ({ props: props, deps: deps })=>{
            const { inset: inset } = props;
            if (typeof inset !== "string") return;
            return {
                inset: inset.split(" ").map((v)=>deps.getSpacingByKey(v, "k").k).join(" ")
            };
        },
        left: ({ props: props, deps: deps })=>deps.getSpacingByKey(props.left, "left"),
        top: ({ props: props, deps: deps })=>deps.getSpacingByKey(props.top, "top"),
        right: ({ props: props, deps: deps })=>deps.getSpacingByKey(props.right, "right"),
        bottom: ({ props: props, deps: deps })=>deps.getSpacingByKey(props.bottom, "bottom"),
        verticalInset: ({ props: props, deps: deps })=>{
            const { verticalInset: verticalInset } = props;
            if (typeof verticalInset !== "string") return;
            const vi = verticalInset.split(" ").map((v)=>deps.getSpacingByKey(v, "k").k);
            return {
                top: vi[0],
                bottom: vi[1] || vi[0]
            };
        },
        horizontalInset: ({ props: props, deps: deps })=>{
            const { horizontalInset: horizontalInset } = props;
            if (typeof horizontalInset !== "string") return;
            const vi = horizontalInset.split(" ").map((v)=>deps.getSpacingByKey(v, "k").k);
            return {
                left: vi[0],
                right: vi[1] || vi[0]
            };
        }
    }
};


var $80736e04e60e3fa1$exports = {};

$parcel$export($80736e04e60e3fa1$exports, "Picture", () => $80736e04e60e3fa1$export$f0d5dc2ce3e4cb5f);

"use strict";
const $80736e04e60e3fa1$export$f0d5dc2ce3e4cb5f = {
    deps: {
        getSystemTheme: $2ae1edf582b77174$export$fe979c3403443f94
    },
    tag: "picture",
    childExtend: {
        tag: "source",
        attr: {
            media: (element)=>{
                const { props: props, key: key, context: context, deps: deps } = element;
                const { MEDIA: MEDIA } = context.designSystem;
                const globalTheme = deps.getSystemTheme(element);
                const mediaName = (props.media || key).slice(1);
                if (mediaName === globalTheme) return "(min-width: 0px)";
                else if (mediaName === "dark" || mediaName === "light") return "(max-width: 0px)";
                return MEDIA[mediaName];
            },
            srcset: ({ props: props })=>props.srcset
        }
    },
    Img: ({ props: props })=>({
            width: "inherit",
            ignoreChildExtend: true,
            height: "inherit",
            src: props.src
        })
};


var $2fb1843bd4d59ef3$exports = {};

$parcel$export($2fb1843bd4d59ef3$exports, "Pseudo", () => $2fb1843bd4d59ef3$export$36c664c5efe2f59c);
"use strict";
const $2fb1843bd4d59ef3$export$36c664c5efe2f59c = {
    class: {
        content: ({ props: props })=>props.content && {
                content: props.content
            }
    }
};


var $7d36ad90912ad279$exports = {};

$parcel$export($7d36ad90912ad279$exports, "Svg", () => $7d36ad90912ad279$export$e17b9c1182212c96);
"use strict";
const $7d36ad90912ad279$export$e17b9c1182212c96 = {
    tag: "svg",
    props: {
        style: {
            "*": {
                fill: "currentColor"
            }
        }
    },
    attr: {
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
    },
    html: ({ key: key, props: props, context: context, ...el })=>{
        const { designSystem: designSystem, utils: utils } = context;
        const SVG = designSystem && designSystem.SVG;
        const useSvgSprite = props.spriteId || context.designSystem && context.designSystem.useSvgSprite;
        if (!useSvgSprite && props.src) return props.src;
        const useSVGSymbol = (icon)=>`<use xlink:href="#${icon}" />`;
        const spriteId = props.spriteId;
        if (spriteId) return useSVGSymbol(spriteId);
        const symbolId = Symbol.for(props.src);
        let SVGKey = SVG[symbolId];
        if (SVGKey && SVG[SVGKey]) return useSVGSymbol(SVGKey);
        SVGKey = SVG[symbolId] = Math.random();
        if (props.src) utils.init({
            svg: {
                [SVGKey]: props.src
            }
        }, {
            document: context.document,
            emotion: context.emotion
        });
        return useSVGSymbol(SVGKey);
    }
};


var $f93c5e7c35cc4205$exports = {};

$parcel$defineInteropFlag($f93c5e7c35cc4205$exports);

$parcel$export($f93c5e7c35cc4205$exports, "Shape", () => $f93c5e7c35cc4205$export$6428a7f2611ef1fa);
$parcel$export($f93c5e7c35cc4205$exports, "default", () => $f93c5e7c35cc4205$export$2e2bcd8739ae039);
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");



"use strict";
const $f93c5e7c35cc4205$var$transformBorderRadius = (radius, props, propertyName)=>{
    if (!(0, $EqHTq.isString)(radius)) return;
    return {
        borderRadius: radius.split(" ").map((v, k)=>(0, $7a9f91e2b97567cc$export$94679ba49f16fc2e)(props, propertyName, v)[propertyName]).join(" ")
    };
};
const $f93c5e7c35cc4205$export$6428a7f2611ef1fa = {
    extend: (0, $2fb1843bd4d59ef3$export$36c664c5efe2f59c),
    deps: {
        exec: $8wu6n.exec,
        getSpacingBasedOnRatio: $7a9f91e2b97567cc$export$94679ba49f16fc2e,
        getMediaColor: $c6753c52b98cd54e$export$dd72f6d9deea7207,
        transformBorderRadius: $f93c5e7c35cc4205$var$transformBorderRadius
    },
    class: {
        shape: ({ props: props, deps: deps })=>{
            const { shape: shape } = props;
            return deps.exec((0, $1364b7b7ead3f203$export$511e1d54a4a8684e)[shape], {
                props: props,
                deps: deps
            });
        },
        shapeDirection: ({ props: props })=>{
            const { shape: shape, shapeDirection: shapeDirection } = props;
            if (!shape || !shapeDirection) return;
            const shapeDir = (0, $1364b7b7ead3f203$export$511e1d54a4a8684e)[shape + "Direction"];
            return shape && shapeDir ? shapeDir[shapeDirection || "left"] : null;
        },
        shapeDirectionColor: ({ props: props, deps: deps })=>{
            const { background: background, backgroundColor: backgroundColor } = props;
            const borderColor = {
                borderColor: deps.getMediaColor(background || backgroundColor)
            };
            return props.shapeDirection ? borderColor : null;
        },
        round: ({ props: props, key: key, deps: deps, ...el })=>deps.transformBorderRadius(props.round || props.borderRadius, props, "round"),
        borderRadius: ({ props: props, key: key, deps: deps, ...el })=>deps.transformBorderRadius(props.borderRadius || props.round, props, "borderRadius")
    }
};
var $f93c5e7c35cc4205$export$2e2bcd8739ae039 = $f93c5e7c35cc4205$export$6428a7f2611ef1fa;



var $b448a4a1f1311a88$exports = {};

$parcel$export($b448a4a1f1311a88$exports, "Text", () => $b448a4a1f1311a88$export$5f1af8db9871e1d6);
$parcel$export($b448a4a1f1311a88$exports, "H1", () => $b448a4a1f1311a88$export$5523b16adee8048);
$parcel$export($b448a4a1f1311a88$exports, "H2", () => $b448a4a1f1311a88$export$cb94397127ac9363);
$parcel$export($b448a4a1f1311a88$exports, "H3", () => $b448a4a1f1311a88$export$746be9e3a3dfff1f);
$parcel$export($b448a4a1f1311a88$exports, "H4", () => $b448a4a1f1311a88$export$cc5e069d64fda823);
$parcel$export($b448a4a1f1311a88$exports, "H5", () => $b448a4a1f1311a88$export$88ef9fdaf11f7a1f);
$parcel$export($b448a4a1f1311a88$exports, "H6", () => $b448a4a1f1311a88$export$a559fb8039b06400);
$parcel$export($b448a4a1f1311a88$exports, "P", () => $b448a4a1f1311a88$export$56c0d5a1e737357d);
$parcel$export($b448a4a1f1311a88$exports, "Caption", () => $b448a4a1f1311a88$export$32fbfacc5d962e0c);
$parcel$export($b448a4a1f1311a88$exports, "Strong", () => $b448a4a1f1311a88$export$f301627d437cff88);
$parcel$export($b448a4a1f1311a88$exports, "Underline", () => $b448a4a1f1311a88$export$741ee5bff4f2bc22);
$parcel$export($b448a4a1f1311a88$exports, "Italic", () => $b448a4a1f1311a88$export$1cfcf4275506b1c6);
$parcel$export($b448a4a1f1311a88$exports, "Title", () => $b448a4a1f1311a88$export$f99233281efd08a0);
$parcel$export($b448a4a1f1311a88$exports, "Headline", () => $b448a4a1f1311a88$export$e1faab0803786bcf);
$parcel$export($b448a4a1f1311a88$exports, "Subhead", () => $b448a4a1f1311a88$export$17e07beff4cf82a6);
$parcel$export($b448a4a1f1311a88$exports, "Footnote", () => $b448a4a1f1311a88$export$54539b446c9863da);
$parcel$export($b448a4a1f1311a88$exports, "B", () => $b448a4a1f1311a88$export$ef35774e6d314e91);
$parcel$export($b448a4a1f1311a88$exports, "I", () => $b448a4a1f1311a88$export$9bb611d729802a56);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");

"use strict";
const $b448a4a1f1311a88$export$5f1af8db9871e1d6 = {
    deps: {
        getFontSizeByKey: $277afaefb2791215$export$ea9b2cd64205746b,
        getFontFamily: $ed362cf167c3740b$export$c4930fc256cef44f
    },
    text: ({ key: key, props: props, state: state, deps: deps })=>{
        if (props.text === true) return state && state[key] || props && props[key];
        return props.text;
    },
    class: {
        fontSize: (el)=>{
            const { props: props, deps: deps } = el;
            return props.fontSize ? deps.getFontSizeByKey(props.fontSize) : null;
        },
        font: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.font) && {
                font: props.font
            },
        fontFamily: ({ props: props, deps: deps })=>!(0, $EqHTq.isUndefined)(props.fontFamily) && {
                fontFamily: deps.getFontFamily(props.fontFamily) || props.fontFamily
            },
        lineHeight: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.lineHeight) && {
                lineHeight: props.lineHeight
            },
        // lineHeight: ({ props }) => !isUndefined(props.lineHeight) && getSpacingBasedOnRatio(props, 'lineHeight', null, ''),
        textDecoration: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.textDecoration) && {
                textDecoration: props.textDecoration
            },
        textTransform: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.textTransform) && {
                textTransform: props.textTransform
            },
        wordBreak: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.wordBreak) && {
                wordBreak: props.wordBreak
            },
        whiteSpace: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.whiteSpace) && {
                whiteSpace: props.whiteSpace
            },
        wordWrap: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.wordWrap) && {
                wordWrap: props.wordWrap
            },
        letterSpacing: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.letterSpacing) && {
                letterSpacing: props.letterSpacing
            },
        textOverflow: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.textOverflow) && {
                textOverflow: props.textOverflow
            },
        textAlign: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.textAlign) && {
                textAlign: props.textAlign
            },
        writingMode: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.writingMode) && {
                writingMode: props.writingMode
            },
        textOrientation: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.textOrientation) && {
                textOrientation: props.textOrientation
            },
        fontWeight: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.fontWeight) && {
                fontWeight: props.fontWeight,
                fontVariationSettings: '"wght" ' + props.fontWeight
            }
    }
};
const $b448a4a1f1311a88$export$5523b16adee8048 = {
    tag: "h1"
};
const $b448a4a1f1311a88$export$cb94397127ac9363 = {
    tag: "h2"
};
const $b448a4a1f1311a88$export$746be9e3a3dfff1f = {
    tag: "h3"
};
const $b448a4a1f1311a88$export$cc5e069d64fda823 = {
    tag: "h4"
};
const $b448a4a1f1311a88$export$88ef9fdaf11f7a1f = {
    tag: "h5"
};
const $b448a4a1f1311a88$export$a559fb8039b06400 = {
    tag: "h6"
};
const $b448a4a1f1311a88$export$56c0d5a1e737357d = {
    tag: "p"
};
const $b448a4a1f1311a88$export$32fbfacc5d962e0c = {
    tag: "caption"
};
const $b448a4a1f1311a88$export$f301627d437cff88 = {
    tag: "strong",
    props: {
        fontWeight: "700"
    }
};
const $b448a4a1f1311a88$export$741ee5bff4f2bc22 = {
    tag: "u"
};
const $b448a4a1f1311a88$export$1cfcf4275506b1c6 = {
    tag: "i"
};
const $b448a4a1f1311a88$export$f99233281efd08a0 = {};
const $b448a4a1f1311a88$export$e1faab0803786bcf = {
    tag: "h6",
    props: {
        fontSize: "B",
        fontWeight: 500
    }
};
const $b448a4a1f1311a88$export$17e07beff4cf82a6 = {
    tag: "span",
    props: {
        fontSize: "Z1"
    }
};
const $b448a4a1f1311a88$export$54539b446c9863da = {
    tag: "span",
    props: {
        fontSize: "Z"
    }
};
const $b448a4a1f1311a88$export$ef35774e6d314e91 = {
    tag: "b"
};
const $b448a4a1f1311a88$export$9bb611d729802a56 = {
    tag: "i"
};



var $d40f17327c4275d4$exports = {};

$parcel$export($d40f17327c4275d4$exports, "Transform", () => $d40f17327c4275d4$export$563a914cafbdc389);

var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $d40f17327c4275d4$export$563a914cafbdc389 = {
    class: {
        zoom: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.zoom) && {
                zoom: props.zoom
            },
        transform: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.transform) && {
                transform: props.transform
            },
        transformOrigin: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.transformOrigin) && {
                transformOrigin: props.transformOrigin
            }
    }
};


var $6a19813fd6d21e30$exports = {};

$parcel$export($6a19813fd6d21e30$exports, "XYZ", () => $6a19813fd6d21e30$export$36b810b8b2e73231);

var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $6a19813fd6d21e30$export$36b810b8b2e73231 = {
    class: {
        zIndex: ({ props: props })=>!(0, $EqHTq.isUndefined)(props.zIndex) && {
                zIndex: props.zIndex
            }
    }
};


var $d23f9a85003e63d3$exports = {};

$parcel$export($d23f9a85003e63d3$exports, "Animation", () => $d23f9a85003e63d3$export$c35d437ae5945fcd);

parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");

"use strict";
const $d23f9a85003e63d3$var$applyAnimationProps = (animation, element)=>{
    const { emotion: ctxEmotion } = element.context;
    const { keyframes: keyframes } = ctxEmotion || (0, $b3468425a35a59c8$export$51d693b3d243fd90);
    if ((0, $EqHTq.isObject)(animation)) return {
        animationName: keyframes(animation)
    };
    const { ANIMATION: ANIMATION } = element.context && element.context.designSystem;
    const record = ANIMATION[animation];
    return keyframes(record);
};
const $d23f9a85003e63d3$export$c35d437ae5945fcd = {
    deps: {
        isObject: $EqHTq.isObject,
        getTimingByKey: $200bfc3872a6d81d$export$3fa311edc5edd22f,
        getTimingFunction: $200bfc3872a6d81d$export$23ba66c7c3e2e613,
        applyAnimationProps: $d23f9a85003e63d3$var$applyAnimationProps
    },
    class: {
        animation: (el)=>el.props.animation && {
                animationName: el.deps.applyAnimationProps(el.props.animation, el),
                animationDuration: el.deps.getTimingByKey(el.props.animationDuration || "A").timing,
                animationDelay: el.deps.getTimingByKey(el.props.animationDelay || "0s").timing,
                animationTimingFunction: el.deps.getTimingFunction(el.props.animationTimingFunction || "ease"),
                animationFillMode: el.props.animationFillMode || "both",
                animationPlayState: el.props.animationPlayState,
                animationDirection: el.props.animationDirection
            },
        animationName: (el)=>el.props.animationName && {
                animationName: el.deps.applyAnimationProps(el.props.animationName, el)
            },
        animationDuration: ({ props: props, deps: deps })=>props.animationDuration && {
                animationDuration: deps.getTimingByKey(props.animationDuration).timing
            },
        animationDelay: ({ props: props, deps: deps })=>props.animationDelay && {
                animationDelay: deps.getTimingByKey(props.animationDelay).timing
            },
        animationTimingFunction: ({ props: props, deps: deps })=>props.animationTimingFunction && {
                animationTimingFunction: deps.getTimingFunction(props.animationTimingFunction)
            },
        animationFillMode: ({ props: props })=>props.animationFillMode && {
                animationFillMode: props.animationFillMode
            },
        animationPlayState: ({ props: props })=>props.animationPlayState && {
                animationPlayState: props.animationPlayState
            },
        animationIterationCount: ({ props: props })=>props.animationIterationCount && {
                animationIterationCount: props.animationIterationCount || 1
            },
        animationDirection: ({ props: props })=>props.animationDirection && {
                animationDirection: props.animationDirection
            }
    }
};


"use strict";
$parcel$exportWildcard($73d59c6c3fce378b$exports, $40d382f435ee1fdb$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $b908145e0b91dcdb$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $8184389c03ed1792$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $afd03220988cb716$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $c95002999fe11fd8$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $f085155ee8a416c4$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $bc85e892389de1ab$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $0b0e26e2a21aab54$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $2d62e11bc2f194bd$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $c3656ade3a6fd1e0$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $1cd063474a590068$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $c17872c3358c86eb$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $b974d8cead94d416$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $80736e04e60e3fa1$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $2fb1843bd4d59ef3$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $7d36ad90912ad279$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $f93c5e7c35cc4205$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $2ae1edf582b77174$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $b448a4a1f1311a88$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $3e7681929891ee4e$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $d40f17327c4275d4$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $6a19813fd6d21e30$exports);
$parcel$exportWildcard($73d59c6c3fce378b$exports, $d23f9a85003e63d3$exports);


var $c95c6861d219ec8a$exports = {};

$parcel$export($c95c6861d219ec8a$exports, "Box", () => $c95c6861d219ec8a$export$e71c4d32a2263218);
$parcel$export($c95c6861d219ec8a$exports, "Circle", () => $c95c6861d219ec8a$export$c89a927ffc67e6fa);

parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $c95c6861d219ec8a$var$PropsCSS = {
    class: {
        style: ({ props: props })=>props && props.style
    }
};
const $c95c6861d219ec8a$export$e71c4d32a2263218 = {
    extend: [
        $c95c6861d219ec8a$var$PropsCSS,
        (0, $f93c5e7c35cc4205$export$6428a7f2611ef1fa),
        (0, $b974d8cead94d416$export$13807d9ee5a34a42),
        (0, $2ae1edf582b77174$export$14faa19a0f3bbeb2),
        (0, $40d382f435ee1fdb$export$d96a8827a60d6b69),
        (0, $b448a4a1f1311a88$export$5f1af8db9871e1d6),
        (0, $1cd063474a590068$export$25d20c189d4a23b8),
        (0, $3e7681929891ee4e$export$ef1e5872612852d1),
        (0, $d40f17327c4275d4$export$563a914cafbdc389),
        (0, $bc85e892389de1ab$export$7fc53215244aec38),
        (0, $2d62e11bc2f194bd$export$a13296960cae0384),
        (0, $6a19813fd6d21e30$export$36b810b8b2e73231),
        (0, $d23f9a85003e63d3$export$c35d437ae5945fcd)
    ],
    deps: {
        isString: $EqHTq.isString
    },
    attr: {
        id: ({ props: props, deps: deps })=>deps.isString(props.id) && props.id,
        title: ({ props: props, deps: deps })=>deps.isString(props.title) && props.title,
        contentEditable: ({ props: props })=>props.contentEditable || props.contenteditable,
        dir: ({ props: props })=>props.dir,
        draggable: ({ props: props })=>props.draggable,
        hidden: ({ props: props })=>props.hidden,
        lang: ({ props: props })=>props.lang,
        spellcheck: ({ props: props })=>props.spellcheck,
        tabindex: ({ props: props })=>props.tabindex,
        translate: ({ props: props })=>props.translate
    }
};
const $c95c6861d219ec8a$export$c89a927ffc67e6fa = {
    props: {
        round: "100%"
    }
};


var $f8a17223267b0208$exports = {};

$parcel$export($f8a17223267b0208$exports, "Icon", () => $f8a17223267b0208$export$f04a61298a47a40f);
$parcel$export($f8a17223267b0208$exports, "IconText", () => $f8a17223267b0208$export$fe7c634bfc18e397);
$parcel$export($f8a17223267b0208$exports, "FileIcon", () => $f8a17223267b0208$export$8c1a3d13e85d78b7);

parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $f8a17223267b0208$export$f04a61298a47a40f = {
    extend: (0, $7d36ad90912ad279$export$e17b9c1182212c96),
    deps: {
        isString: $EqHTq.isString
    },
    props: ({ key: key, props: props, parent: parent, context: context, deps: deps })=>{
        const { ICONS: ICONS, useIconSprite: useIconSprite, verbose: verbose } = context && context.designSystem;
        const { toCamelCase: toCamelCase } = context && context.utils;
        const iconName = props.name || props.icon || key;
        const camelCase = toCamelCase(deps.isString(iconName) ? iconName : key);
        const isArray = camelCase.split(/([a-z])([A-Z])/g);
        let activeIconName;
        if (props.active) activeIconName = props[".active"].name || props[".active"].icon;
        if (parent && parent.props && parent.props.active && parent.props[".active"] && parent.props[".active"].icon) activeIconName = parent.props[".active"].icon.name || parent.props[".active"].icon.icon || parent.props[".active"].icon;
        let validIconName;
        if (ICONS[activeIconName]) validIconName = activeIconName;
        if (ICONS[camelCase]) validIconName = camelCase;
        else if (ICONS[isArray[0] + isArray[1]]) validIconName = isArray[0] + isArray[1];
        else if (ICONS[isArray[0]]) validIconName = isArray[0];
        else if (verbose) console.warn("Can't find icon:", iconName, validIconName);
        const iconFromLibrary = ICONS[validIconName];
        const directSrc = parent && parent.props && parent.props.src || props.src;
        return {
            width: "A",
            height: "A",
            display: "inline-block",
            spriteId: useIconSprite && validIconName,
            src: iconFromLibrary || directSrc || ICONS.noIcon,
            style: {
                fill: "currentColor"
            }
        };
    },
    attr: {
        viewBox: "0 0 24 24"
    }
};
const $f8a17223267b0208$export$fe7c634bfc18e397 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        align: "center center",
        lineHeight: 1
    },
    Icon: {
        props: ({ parent: parent, props: props })=>({
                icon: parent.props.icon
            }),
        if: ({ parent: parent, props: props })=>{
            const doesExist = parent.props.icon || parent.props.Icon || props.name || props.icon;
            return doesExist;
        }
    },
    text: ({ props: props })=>props.text,
    ".reversed": {
        props: {
            flow: "row-reverse"
        }
    },
    ".vertical": {
        props: {
            flow: "column"
        }
    }
};
const $f8a17223267b0208$export$8c1a3d13e85d78b7 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        theme: "tertiary",
        boxSize: "C1",
        align: "center center",
        round: "Z"
    },
    Icon: {
        fontSize: "B",
        margin: "auto",
        icon: "file"
    }
};


var $5d0d06667ca93e89$exports = {};
var $c740580a6e69a0e6$exports = {};

$parcel$export($c740580a6e69a0e6$exports, "StatusIndicator", () => $c740580a6e69a0e6$export$b4f88f0ca5784eef);
"use strict";
const $c740580a6e69a0e6$export$b4f88f0ca5784eef = {
    props: {
        widthRange: "Z+V",
        theme: "primary",
        round: "100%",
        aspectRatio: "1/1",
        border: "solid, gray",
        borderWidth: "2px"
    }
};


var $0c6dd160b1fcaf0f$exports = {};

$parcel$export($0c6dd160b1fcaf0f$exports, "CheckIndicator", () => $0c6dd160b1fcaf0f$export$1b5af9b9e924baca);
$parcel$export($0c6dd160b1fcaf0f$exports, "CheckIndicatorWithLabel", () => $0c6dd160b1fcaf0f$export$1c148d89e9c73bd2);

"use strict";
const $0c6dd160b1fcaf0f$export$1b5af9b9e924baca = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        padding: "Y1",
        round: "100%",
        theme: "success"
    },
    Icon: {
        name: "check",
        fontSize: "A"
    }
};
const $0c6dd160b1fcaf0f$export$1c148d89e9c73bd2 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        align: "center flex-start",
        gap: "Z"
    },
    CheckIndicator: {},
    Caption: {
        text: "Step",
        fontWeight: "400"
    }
};


var $ec3d83c516121c79$exports = {};

$parcel$export($ec3d83c516121c79$exports, "CountIndicator", () => $ec3d83c516121c79$export$484b8642c0073407);

"use strict";
const $ec3d83c516121c79$export$484b8642c0073407 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        text: "2",
        theme: "primary",
        widthRange: "A1",
        boxSizing: "content-box",
        lineHeight: "1em",
        padding: "X",
        round: "100%",
        align: "center center",
        aspectRatio: "1 / 1"
    }
};


var $0734a9a0d8a64818$exports = {};

$parcel$export($0734a9a0d8a64818$exports, "RadioIndicator", () => $0734a9a0d8a64818$export$d35a9ffa9a04f9e7);
$parcel$export($0734a9a0d8a64818$exports, "RadioIndicatorWithLabel", () => $0734a9a0d8a64818$export$d488d51e59555914);

"use strict";
const $0734a9a0d8a64818$export$d35a9ffa9a04f9e7 = {
    props: {
        padding: "Z+V",
        theme: "tertiary",
        boxSize: "fit-content",
        round: "100%",
        ":after": {
            content: '""',
            boxSize: "Z",
            background: "white",
            display: "block",
            round: "100%"
        }
    }
};
const $0734a9a0d8a64818$export$d488d51e59555914 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        align: "center flex-start",
        gap: "Z"
    },
    RadioIndicator: {},
    Caption: {
        text: "Step",
        fontWeight: "500",
        fontSize: "Z2"
    }
};


var $96edeac257cf83d5$exports = {};

$parcel$export($96edeac257cf83d5$exports, "SuccessIndicator", () => $96edeac257cf83d5$export$93b3b8f45e6ad816);

"use strict";
const $96edeac257cf83d5$export$93b3b8f45e6ad816 = {
    extend: (0, $0c6dd160b1fcaf0f$export$1b5af9b9e924baca),
    props: {
        theme: "success",
        padding: "X+V2",
        fontSize: "F"
    }
};


"use strict";
$parcel$exportWildcard($5d0d06667ca93e89$exports, $c740580a6e69a0e6$exports);
$parcel$exportWildcard($5d0d06667ca93e89$exports, $0c6dd160b1fcaf0f$exports);
$parcel$exportWildcard($5d0d06667ca93e89$exports, $ec3d83c516121c79$exports);
$parcel$exportWildcard($5d0d06667ca93e89$exports, $0734a9a0d8a64818$exports);
$parcel$exportWildcard($5d0d06667ca93e89$exports, $96edeac257cf83d5$exports);


var $32625a13d757d0d6$exports = {};

$parcel$export($32625a13d757d0d6$exports, "Hgroup", () => $32625a13d757d0d6$export$bd5b3f7ef3b94a4a);
$parcel$export($32625a13d757d0d6$exports, "HgroupRows", () => $32625a13d757d0d6$export$4c6ac4526c395f50);
$parcel$export($32625a13d757d0d6$exports, "HgroupButton", () => $32625a13d757d0d6$export$7fa5389f12735f1f);
"use strict";
const $32625a13d757d0d6$export$bd5b3f7ef3b94a4a = {
    extend: "Flex",
    tag: "hgroup",
    props: {
        flow: "column",
        gap: "Y",
        Title: {
            fontWeight: "700",
            alignItems: "center"
        },
        Paragraph: {
            margin: "0",
            color: "caption",
            "> p": {
                margin: "0"
            }
        }
    },
    Title: {
        extend: "Flex",
        props: ({ parent: parent })=>({
                text: parent.props.title,
                lineHeight: "1em"
            })
    },
    Paragraph: {
        extend: "Flex",
        props: ({ parent: parent })=>({
                text: parent.props.paragraph,
                margin: "0"
            })
    }
};
const $32625a13d757d0d6$export$4c6ac4526c395f50 = {
    extend: $32625a13d757d0d6$export$bd5b3f7ef3b94a4a,
    Title: {
        extend: "Flex",
        props: {
            color: "title",
            align: "center space-between"
        }
    },
    Paragraph: {
        extend: "Flex",
        props: {
            color: "paragraph",
            align: "center space-between"
        }
    }
};
const $32625a13d757d0d6$export$7fa5389f12735f1f = {
    extend: $32625a13d757d0d6$export$4c6ac4526c395f50,
    Title: {
        props: {
            justifyContent: "space-between"
        },
        Span: {},
        Button: {
            props: {
                background: "transparent",
                color: "currentColor",
                padding: "0",
                Icon: {
                    name: "x",
                    fontSize: "C"
                }
            }
        }
    },
    Paragraph: {}
};


var $f887848157c82147$exports = {};

$parcel$export($f887848157c82147$exports, "UnitValue", () => $f887848157c82147$export$d703b7d35511419c);
$parcel$export($f887848157c82147$exports, "DoubleUnitValue", () => $f887848157c82147$export$19636468023d76f);
$parcel$export($f887848157c82147$exports, "UnitValueWithLabel", () => $f887848157c82147$export$2315678a8bc727a7);
$parcel$export($f887848157c82147$exports, "UnitValueWithTitle", () => $f887848157c82147$export$8efdae2c595fd1);

"use strict";
const $f887848157c82147$export$d703b7d35511419c = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        color: "title",
        align: "center flex-start",
        gap: "V",
        fontWeight: "400",
        "> *": {
            lineHeight: "1em"
        }
    },
    Value: {
        props: {
            text: "72"
        }
    },
    Unit: {
        props: {
            text: "%"
        }
    }
};
const $f887848157c82147$export$19636468023d76f = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        align: "center flex-start",
        color: "caption",
        gap: "Y"
    },
    UnitValue: {
        Value: {
            text: "72"
        },
        Unit: {
            text: "%"
        }
    },
    dot: {
        props: {
            boxSize: "W W",
            round: "100%",
            background: "currentColor"
        }
    },
    UnitValue_2: {
        props: {
            gap: "X+W"
        },
        Value: {
            text: "2"
        },
        Unit: {
            text: "Second left"
        }
    }
};
const $f887848157c82147$export$2315678a8bc727a7 = {
    extend: $f887848157c82147$export$19636468023d76f,
    props: {
        gap: "Y2"
    },
    UnitValue: {
        flow: "row-reverse",
        fontWeight: "700",
        Value: {
            text: "12,759"
        },
        Unit: {
            text: "$"
        }
    },
    dot: null,
    UnitValue_2: {
        props: {
            theme: "field",
            padding: "Z",
            round: "Y1",
            gap: "0"
        },
        Value: {
            text: "+8.8"
        },
        Unit: {
            text: "%"
        }
    }
};
const $f887848157c82147$export$8efdae2c595fd1 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        align: "center flex-start",
        gap: "Y",
        fontSize: "Z1"
    },
    Title: {
        tag: "caption",
        props: {
            text: "balance :",
            textTransform: "capitalize"
        }
    },
    UnitValue: {
        textTransform: "uppercase",
        gap: "Y",
        color: "currentColor",
        Value: {
            text: "0"
        },
        Unit: {
            text: "bnb"
        }
    }
};


var $59e9b7f5a8955db9$exports = {};

$parcel$export($59e9b7f5a8955db9$exports, "Link", () => $59e9b7f5a8955db9$export$a6c7ac8248d6e38a);
$parcel$export($59e9b7f5a8955db9$exports, "RouterLink", () => $59e9b7f5a8955db9$export$fce709ebdac448ed);
$parcel$export($59e9b7f5a8955db9$exports, "RouteLink", () => $59e9b7f5a8955db9$export$9a6dc2d0fce7da79);
var $90351548418b68d1$exports = {};

$parcel$defineInteropFlag($90351548418b68d1$exports);

$parcel$export($90351548418b68d1$exports, "getActiveRoute", () => $90351548418b68d1$export$e7a685f330e7752);
$parcel$export($90351548418b68d1$exports, "lastPathname", () => $90351548418b68d1$export$7a9e7a91cdf4fce1);
$parcel$export($90351548418b68d1$exports, "lastLevel", () => $90351548418b68d1$export$ed098f724085d263);
$parcel$export($90351548418b68d1$exports, "router", () => $90351548418b68d1$export$5375cda95f0b0eb4);
$parcel$export($90351548418b68d1$exports, "default", () => $90351548418b68d1$export$2e2bcd8739ae039);

parcelRequire("cBUNY");
var $jvD5p = parcelRequire("jvD5p");
"use strict";
const $90351548418b68d1$export$e7a685f330e7752 = (level = 0, route = (0, $jvD5p.window).location.pathname)=>{
    const routeArray = route.split("/");
    const activeRoute = routeArray[level + 1];
    if (activeRoute) return `/${activeRoute}`;
};
let $90351548418b68d1$export$7a9e7a91cdf4fce1;
let $90351548418b68d1$export$ed098f724085d263 = 0;
const $90351548418b68d1$var$defaultOptions = {
    level: $90351548418b68d1$export$ed098f724085d263,
    pushState: true,
    initialRender: false,
    scrollToTop: true,
    scrollToNode: false,
    scrollNode: (0, $jvD5p.document) && (0, $jvD5p.document).documentElement,
    scrollBody: false,
    useFragment: false,
    updateState: true,
    scrollToOffset: 0,
    scrollToOptions: {
        behavior: "smooth"
    }
};
const $90351548418b68d1$export$5375cda95f0b0eb4 = (path, element, state = {}, passedOptions = {})=>{
    const options = {
        ...$90351548418b68d1$var$defaultOptions,
        ...element.context.routerOptions,
        ...passedOptions
    };
    $90351548418b68d1$export$ed098f724085d263 = options.lastLevel;
    const newElementKey = options.newElementKey;
    const [pathname, hash] = path.split("#");
    const rootNode = element.node;
    const route = $90351548418b68d1$export$e7a685f330e7752(options.level, pathname);
    const content = element.routes[route || "/"] || element.routes["/*"];
    const scrollNode = options.scrollToNode ? rootNode : options.scrollNode;
    const hashChanged = hash && hash !== (0, $jvD5p.window).location.hash.slice(1);
    const pathChanged = pathname !== $90351548418b68d1$export$7a9e7a91cdf4fce1;
    $90351548418b68d1$export$7a9e7a91cdf4fce1 = pathname;
    if (!content) return;
    if (options.pushState) (0, $jvD5p.window).history.pushState(state, null, pathname + (hash ? `#${hash}` : ""));
    if (pathChanged || !hashChanged) {
        if (options.updateState) element.state.update({
            route: route,
            hash: hash
        }, {
            preventContentUpdate: true
        });
        if (newElementKey && options.removeOldElement) element[newElementKey].remove();
        element.set({
            tag: options.useFragment && "fragment",
            extend: content
        }, {
            newElementKey: newElementKey
        });
    }
    if (options.scrollToTop) scrollNode.scrollTo({
        ...options.scrollToOptions || {},
        top: 0,
        left: 0
    });
    if (options.scrollToNode) content.content.node.scrollTo({
        ...options.scrollToOptions || {},
        top: 0,
        left: 0
    });
    if (hash) {
        const activeNode = (0, $jvD5p.document).getElementById(hash);
        if (activeNode) {
            const top = activeNode.getBoundingClientRect().top + rootNode.scrollTop - options.scrollToOffset || 0;
            scrollNode.scrollTo({
                ...options.scrollToOptions || {},
                top: top,
                left: 0
            });
        }
    }
    // trigger `on.routeChanged`
    (0, $33936e69aa63c9cd$export$1bc010482b845252)("routeChanged", element, options);
};
var $90351548418b68d1$export$2e2bcd8739ae039 = $90351548418b68d1$export$5375cda95f0b0eb4;


parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");

"use strict";
const $59e9b7f5a8955db9$export$a6c7ac8248d6e38a = {
    extend: (0, $c3656ade3a6fd1e0$export$35a3bebf7ef2d934),
    tag: "a",
    props: {
        aria: {},
        fontWeight: "bold",
        textDecoration: "none",
        color: "currentColor",
        draggable: false
    },
    attr: {
        href: (el)=>{
            const { context: ctx } = el;
            const { exec: exec } = ctx.utils;
            return exec(el.props.href, el) || exec(el.props, el).href;
        },
        target: ({ props: props })=>props.target,
        "aria-label": ({ props: props })=>props.aria ? props.aria.label : props.text,
        draggable: ({ props: props })=>props.draggable
    }
};
const $59e9b7f5a8955db9$export$fce709ebdac448ed = {
    on: {
        click: (event, el)=>{
            const { props: props, context: ctx } = el;
            const { href: href, scrollToTop: scrollToTop, stopPropagation: stopPropagation } = props;
            if (stopPropagation) event.stopPropagation();
            if (!href) return;
            const { utils: utils, snippets: snippets, routerOptions: routerOptions } = ctx;
            const root = el.__ref.__root;
            const linkIsExternal = href.includes("http://") || href.includes("https://") || href.includes("mailto:") || href.includes("tel:");
            if (href && !linkIsExternal) {
                (snippets.router || utils.router || (0, $90351548418b68d1$export$5375cda95f0b0eb4))(href, root, {}, {
                    scrollToOptions: {
                        behaviour: "instant"
                    },
                    scrollToTop: (0, $EqHTq.isDefined)(scrollToTop) ? scrollToTop : true,
                    ...routerOptions,
                    ...props.routerOptions
                });
                event.preventDefault();
            }
        }
    }
};
const $59e9b7f5a8955db9$export$9a6dc2d0fce7da79 = {
    extend: [
        $59e9b7f5a8955db9$export$a6c7ac8248d6e38a,
        $59e9b7f5a8955db9$export$fce709ebdac448ed
    ]
};


var $eb21f9c2ced2890e$exports = {};

$parcel$export($eb21f9c2ced2890e$exports, "Video", () => $eb21f9c2ced2890e$export$ae01dedf5c052bb);
"use strict";
const $eb21f9c2ced2890e$export$ae01dedf5c052bb = {
    tag: "video",
    childExtend: {
        tag: "source",
        attr: {
            src: ({ props: props })=>props.src,
            controls: ({ props: props })=>props.controls
        }
    },
    props: {
        controls: true
    },
    attr: {
        src: ({ props: props })=>props.src,
        autoplay: ({ props: props })=>props.autoplay,
        loop: ({ props: props })=>props.loop,
        poster: ({ props: props })=>props.poster,
        muted: ({ props: props })=>props.muted,
        preload: ({ props: props })=>props.preload,
        controls: ({ props: props })=>props.controls
    }
};


var $8a688fbb24f94be4$exports = {};

$parcel$export($8a688fbb24f94be4$exports, "DoubleHr", () => $8a688fbb24f94be4$export$c4a0252366c774e);

"use strict";
const $8a688fbb24f94be4$export$c4a0252366c774e = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        gap: "B",
        fontSize: "Z1",
        fontWeight: "500",
        alignItems: "center",
        ":before": {
            content: '""',
            height: "V",
            flex: "1",
            background: "gray3"
        },
        text: "Or",
        ":after": {
            content: '""',
            height: "V",
            flex: "1",
            background: "gray3"
        }
    }
};


var $7f02b9e3018c9249$exports = {};
var $d4fa7f19f335d32f$exports = {};

$parcel$export($d4fa7f19f335d32f$exports, "Input", () => $d4fa7f19f335d32f$export$f5b8910cec6cf069);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
var $5WrxC = parcelRequire("5WrxC");
"use strict";
const $d4fa7f19f335d32f$export$f5b8910cec6cf069 = {
    extend: [
        "Focusable"
    ],
    tag: "input",
    deps: {
        isString: $EqHTq.isString,
        replaceLiteralsWithObjectFields: $5WrxC.replaceLiteralsWithObjectFields
    },
    props: {
        border: "none",
        type: "input",
        theme: "field",
        fontSize: "A",
        round: "C",
        lineHeight: "1",
        padding: "Z2 B"
    },
    attr: {
        pattern: ({ props: props })=>props.pattern,
        minLength: ({ props: props })=>props.minlength,
        maxLength: ({ props: props })=>props.maxlength,
        name: ({ props: props })=>props.name,
        autocomplete: ({ props: props })=>props.autocomplete,
        placeholder: ({ props: props })=>props.placeholder,
        value: ({ props: props, state: state, deps: deps })=>{
            const { isString: isString, replaceLiteralsWithObjectFields: replaceLiteralsWithObjectFields } = deps;
            if (isString(props.value) && props.value.includes("{{")) return replaceLiteralsWithObjectFields(props.value, state);
            return props.value;
        },
        disabled: ({ props: props })=>props.disabled || null,
        readonly: ({ props: props })=>props.readonly,
        required: ({ props: props })=>props.required,
        type: ({ props: props })=>props.type
    }
};


var $213c0d90580abffb$exports = {};

$parcel$export($213c0d90580abffb$exports, "NumberInput", () => $213c0d90580abffb$export$6bf0cd3a219bbade);

"use strict";
const $213c0d90580abffb$export$6bf0cd3a219bbade = {
    extend: [
        "Flex",
        (0, $d4fa7f19f335d32f$export$f5b8910cec6cf069)
    ],
    props: {
        type: "number",
        boxSize: "C+X",
        align: "center center",
        textAlign: "center",
        round: "Y1",
        theme: "transparent",
        border: "solid, gray3",
        borderWidth: "1px",
        placeholder: "0",
        fontWeight: "400",
        "::-webkit-inner-spin-button": {
            appearance: "none"
        }
    },
    attr: {
        step: ({ props: props })=>props.step,
        min: ({ props: props })=>props.min,
        max: ({ props: props })=>props.max
    }
};


var $59b438ee4e9b846d$exports = {};

$parcel$export($59b438ee4e9b846d$exports, "Checkbox", () => $59b438ee4e9b846d$export$48513f6b9f8ce62d);
$parcel$export($59b438ee4e9b846d$exports, "CheckboxHgroup", () => $59b438ee4e9b846d$export$8d7a3c6c6de62e1f);
"use strict";
const $59b438ee4e9b846d$export$48513f6b9f8ce62d = {
    extend: "Focusable",
    tag: "label",
    props: {
        boxSize: "fit-content fit-content",
        cursor: "pointer",
        round: "Y"
    },
    Input: {
        props: {
            type: "checkbox",
            display: "none",
            ":checked + div": {
                theme: "primary"
            },
            ":checked + div > svg": {
                transform: "none",
                opacity: "1"
            }
        },
        attr: {
            checked: ({ parent: parent })=>parent.props.checked
        }
    },
    Flex: {
        props: {
            align: "center center",
            fontSize: "B1",
            padding: "V",
            theme: "field",
            round: "X2",
            transition: "background A defaultBezier"
        },
        Icon: {
            props: {
                icon: "check",
                opacity: "0",
                transform: "scale(0.9) rotate(-15deg)",
                transition: "opacity B defaultBezier"
            }
        }
    }
};
const $59b438ee4e9b846d$export$8d7a3c6c6de62e1f = {
    extend: "Flex",
    tag: "label",
    props: {
        boxSize: "fit-content",
        align: "flex-start flex-start",
        gap: "A"
    },
    Checkbox: {
        tag: "div"
    },
    HgroupRows: {
        gap: "Z1",
        margin: "Y - - -"
    }
};


var $36ec4dd7c97e9ba6$exports = {};

$parcel$export($36ec4dd7c97e9ba6$exports, "Radio", () => $36ec4dd7c97e9ba6$export$d7b12c4107be0d61);
$parcel$export($36ec4dd7c97e9ba6$exports, "RadioHgroup", () => $36ec4dd7c97e9ba6$export$4a51391209c6c8b9);

"use strict";
const $36ec4dd7c97e9ba6$export$d7b12c4107be0d61 = {
    extend: (0, $59b438ee4e9b846d$export$48513f6b9f8ce62d),
    Input: {
        type: "radio",
        ":checked + div:after": {
            opacity: "1"
        }
    },
    Flex: {
        extend: "Pseudo",
        props: {
            round: "100%",
            padding: "Y",
            ":after": {
                content: '""',
                display: "block",
                boxSize: "X+W1",
                round: "100%",
                background: "white",
                opacity: "0",
                transition: "opacity .15s ease-in-out"
            }
        },
        Icon: null
    }
};
const $36ec4dd7c97e9ba6$export$4a51391209c6c8b9 = {
    extend: (0, $59b438ee4e9b846d$export$8d7a3c6c6de62e1f),
    Checkbox: null,
    Radio: {}
};


var $d0c993a5e2b7f197$exports = {};

$parcel$export($d0c993a5e2b7f197$exports, "Toggle", () => $d0c993a5e2b7f197$export$bea8ebba691c5813);
$parcel$export($d0c993a5e2b7f197$exports, "ToggleHgroup", () => $d0c993a5e2b7f197$export$9c397544fb27ca65);

"use strict";
const $d0c993a5e2b7f197$export$bea8ebba691c5813 = {
    extend: (0, $59b438ee4e9b846d$export$48513f6b9f8ce62d),
    Input: {
        props: {
            ":checked + div": {
                background: "green2 +8",
                justifyContent: "flex-end"
            }
        }
    },
    Flex: {
        props: {
            boxSize: "A1 B1",
            padding: "- W_default",
            round: "D",
            align: "center flex-start",
            theme: "field",
            border: "none",
            transition: "opacity .15s ease",
            ":after": {
                content: '""',
                boxSize: "A A",
                round: "100%",
                background: "white",
                boxShadow: "1px, 1px, Z, gray .2"
            }
        },
        Icon: null
    }
};
const $d0c993a5e2b7f197$export$9c397544fb27ca65 = {
    extend: (0, $59b438ee4e9b846d$export$8d7a3c6c6de62e1f),
    Checkbox: null,
    Toggle: {}
};


var $20f1327918487e94$exports = {};

$parcel$export($20f1327918487e94$exports, "Textarea", () => $20f1327918487e94$export$379139ebc1c2b235);
$parcel$export($20f1327918487e94$exports, "TextareaWithButton", () => $20f1327918487e94$export$b70f05b5c6092f02);


"use strict";
const $20f1327918487e94$export$379139ebc1c2b235 = {
    tag: "textarea",
    extend: [
        (0, $d4fa7f19f335d32f$export$f5b8910cec6cf069),
        (0, $8184389c03ed1792$export$f51f4c4ede09e011)
    ],
    props: {
        variant: "outlined",
        fontfamily: "Avenir",
        round: "Z1",
        placeholder: "Leave us a message...",
        padding: "A",
        theme: "field",
        border: "none",
        maxWidth: "G1_default",
        minHeight: "E_default",
        width: "100%",
        height: "E1_default",
        fontFamily: "inherit",
        style: {
            resize: "none"
        }
    },
    ".simple": {
        props: {
            theme: "field",
            round: "Z2",
            lineHeight: 1.4
        }
    },
    ".outlined": {
        props: {
            theme: "field",
            borderWidth: "1px",
            borderStyle: "solid",
            lineHeight: 1.4,
            placeholder: "Leave us a message...",
            resize: "none"
        }
    }
};
const $20f1327918487e94$export$b70f05b5c6092f02 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        gap: "Y2"
    },
    Textarea: {
        height: "C2+W",
        minWidth: "H",
        padding: "A",
        fontSize: "Z1",
        round: "Z2",
        minHeight: "fit-content"
    },
    SquareButton: {
        props: {
            background: "blue",
            Icon: {
                name: "send"
            }
        }
    }
};


"use strict";
$parcel$exportWildcard($7f02b9e3018c9249$exports, $d4fa7f19f335d32f$exports);
$parcel$exportWildcard($7f02b9e3018c9249$exports, $213c0d90580abffb$exports);
$parcel$exportWildcard($7f02b9e3018c9249$exports, $59b438ee4e9b846d$exports);
$parcel$exportWildcard($7f02b9e3018c9249$exports, $36ec4dd7c97e9ba6$exports);
$parcel$exportWildcard($7f02b9e3018c9249$exports, $d0c993a5e2b7f197$exports);
$parcel$exportWildcard($7f02b9e3018c9249$exports, $20f1327918487e94$exports);


var $c038997f2687863c$exports = {};

$parcel$export($c038997f2687863c$exports, "Select", () => $c038997f2687863c$export$ef9b1a59e592288f);

"use strict";
const $c038997f2687863c$export$ef9b1a59e592288f = {
    extend: (0, $c3656ade3a6fd1e0$export$35a3bebf7ef2d934),
    tag: "select",
    props: {
        fontSize: "A",
        border: "none",
        boxSizing: "border-box",
        theme: "field",
        cursor: "pointer"
    },
    childExtend: {
        tag: "option",
        props: {
            value: "",
            selected: "",
            disabled: ""
        },
        attr: {
            value: ({ props: props })=>props.value,
            selected: ({ props: props })=>props.selected,
            disabled: ({ props: props })=>props.disabled
        }
    },
    attr: {
        name: ({ props: props })=>props.name,
        disabled: ({ props: props })=>props.disabled
    }
};


var $408dff139db483ea$exports = {};
var $846f9615e5dff418$exports = {};

$parcel$export($846f9615e5dff418$exports, "CommonField", () => $846f9615e5dff418$export$5fe3d428dda5a48e);
$parcel$export($846f9615e5dff418$exports, "CommonFieldTemplate", () => $846f9615e5dff418$export$baa29b825dfa9c0a);


"use strict";
const $846f9615e5dff418$export$5fe3d428dda5a48e = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    tag: "label",
    props: {
        flow: "column",
        boxSize: "fit-content fit-content",
        gap: "Z"
    },
    Title: {
        props: {
            text: "Label",
            lineHeight: "1em",
            padding: "- - - V2",
            color: "caption"
        }
    },
    Field: {
        tag: "div"
    },
    Hint: {
        extend: (0, $f8a17223267b0208$export$fe7c634bfc18e397),
        props: {
            color: "caption",
            align: "center flex-start",
            text: "",
            fontSize: "Z1",
            gap: "Y",
            padding: "W - - W"
        }
    }
};
const $846f9615e5dff418$export$baa29b825dfa9c0a = {
    extend: $846f9615e5dff418$export$5fe3d428dda5a48e,
    Title: {},
    Field: {
        Icon: {
            props: {
                name: "info"
            }
        },
        Input: {},
        Button: {
            icon: "eye"
        }
    },
    Hint: {
        Icon: {
            props: {
                name: "info"
            }
        },
        text: "Description"
    }
};


var $86fa541a35e509bb$exports = {};

$parcel$export($86fa541a35e509bb$exports, "Field", () => $86fa541a35e509bb$export$a455218a85c89869);
$parcel$export($86fa541a35e509bb$exports, "FieldTemplate", () => $86fa541a35e509bb$export$5eb2102ba34ef9b2);
$parcel$export($86fa541a35e509bb$exports, "FieldWithTitle", () => $86fa541a35e509bb$export$257a13be48b6f047);
$parcel$export($86fa541a35e509bb$exports, "FieldWithTitleTemplate", () => $86fa541a35e509bb$export$a9dd5a869d4dc0cb);


"use strict";
const $86fa541a35e509bb$export$a455218a85c89869 = {
    extend: "Flex",
    tag: "label",
    props: {
        minWidth: "F2+Z2",
        maxWidth: "F2+Z2",
        minHeight: "C+V",
        align: "center flex-start",
        gap: "Y",
        boxSizing: "border-box",
        position: "relative",
        Input: {
            padding: "Z2 B2 Z2 B",
            flex: "1"
        },
        Button: {
            padding: "0",
            background: "transparent",
            margin: "- - - auto",
            fontSize: "Z2"
        }
    },
    Input: {
        placeholder: "Placeholder"
    },
    Icon: {
        props: ({ parent: parent })=>({
                name: parent.props.icon,
                minWidth: "A",
                margin: "- Z1 - -C",
                position: "relative"
            })
    }
};
const $86fa541a35e509bb$export$5eb2102ba34ef9b2 = {
    extend: $86fa541a35e509bb$export$a455218a85c89869,
    Icon: {
        props: {
            name: "info"
        }
    },
    Input: {},
    Button: {
        Icon: {
            name: "eye"
        }
    }
};
const $86fa541a35e509bb$export$257a13be48b6f047 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        flow: "column",
        boxSize: "fit-content fit-content",
        gap: "Y1",
        // border: '.05px solid red',
        Hint: {
            color: "gray 1 +64",
            align: "center flex-start",
            fontSize: "Z2",
            gap: "Y",
            padding: "W Y2 - Y2"
        }
    },
    Title: {
        props: {
            text: "Label",
            lineHeight: "1em",
            color: "title",
            fontWeight: "400",
            padding: "- Y1"
        }
    },
    Field: {
        extend: $86fa541a35e509bb$export$a455218a85c89869
    }
};
const $86fa541a35e509bb$export$a9dd5a869d4dc0cb = {
    extend: $86fa541a35e509bb$export$257a13be48b6f047,
    Title: {},
    Field: {
        Icon: {
            props: {
                name: "info"
            }
        },
        Input: {},
        Button: {
            icon: "eye"
        }
    },
    Hint: {
        extend: (0, $f8a17223267b0208$export$fe7c634bfc18e397),
        props: {
            icon: "info",
            text: "Description"
        }
    }
};


var $d5f256e68f92ff3f$exports = {};

$parcel$export($d5f256e68f92ff3f$exports, "Search", () => $d5f256e68f92ff3f$export$4b85d3515bd863a5);
$parcel$export($d5f256e68f92ff3f$exports, "SearchWithButton", () => $d5f256e68f92ff3f$export$19f2462a4dbfed8);
$parcel$export($d5f256e68f92ff3f$exports, "SearchWithDropDownButton", () => $d5f256e68f92ff3f$export$b28ff139ed930e2d);
"use strict";
const $d5f256e68f92ff3f$export$4b85d3515bd863a5 = {
    tag: "search",
    props: {
        maxWidth: "G3",
        gap: "Z",
        onSubmit: (ev, el, s)=>{}
    },
    Form: {
        extend: "Field",
        props: {
            flow: "row-reverse",
            Input: {
                padding: "Z2 B Z2 C"
            },
            Icon: {
                margin: "- -C - Z1",
                name: "search"
            }
        },
        Input: {
            props: {
                type: "search",
                placeholder: "Search",
                "::placeholder": {
                    color: "paragraph"
                }
            }
        },
        Icon: {},
        on: {
            submit: (ev, el, s)=>el.parent.props.onSubmit(ev, el, s)
        }
    }
};
const $d5f256e68f92ff3f$export$19f2462a4dbfed8 = {
    extend: $d5f256e68f92ff3f$export$4b85d3515bd863a5,
    props: {
        Button: {
            fontSize: "B"
        }
    },
    Form: {
        Icon: {},
        Input: {
            props: {
                ":focus ~ button": {
                    opacity: "1"
                }
            }
        },
        Button: {
            props: {
                opacity: "0",
                icon: "x"
            },
            Icon: {
                on: {
                    click: (e, el)=>{
                        el.parent.parent.Input.node.value = "";
                    }
                }
            }
        }
    }
};
const $d5f256e68f92ff3f$export$b28ff139ed930e2d = {
    extend: $d5f256e68f92ff3f$export$19f2462a4dbfed8,
    props: {
        theme: "tertiary",
        maxWidth: "G3+C",
        padding: "0 A 0 0",
        gap: "Z"
    },
    DropDownButton: {},
    Input: {
        props: {
            padding: "- - - X"
        }
    },
    Button: {},
    Icon: {}
};


var $dd0910b23638afad$exports = {};

$parcel$export($dd0910b23638afad$exports, "TextAreaField", () => $dd0910b23638afad$export$301bf6213f61d17f);

"use strict";
const $dd0910b23638afad$export$301bf6213f61d17f = {
    tag: "label",
    extend: (0, $c3656ade3a6fd1e0$export$35a3bebf7ef2d934),
    props: {
        boxSize: "fit-content",
        border: "solid, gray .45 +80",
        borderWidth: ".8px",
        overflow: "hidden",
        round: "Z1",
        ":focus-within": {
            outline: "1px solid #0474F2"
        }
    },
    TextArea: {
        tag: "textarea",
        attr: {
            placeholder: "Leave us a message..."
        },
        props: {
            minWidth: "H",
            minHeight: "D2+Y1",
            padding: "A",
            fontFamily: "avenir",
            theme: "transparent",
            border: "none",
            outline: "none",
            style: {
                resize: "none"
            },
            "::placeholder": {
                color: "gray 1 +64"
            }
        }
    }
};


"use strict";
$parcel$exportWildcard($408dff139db483ea$exports, $846f9615e5dff418$exports);
$parcel$exportWildcard($408dff139db483ea$exports, $86fa541a35e509bb$exports);
$parcel$exportWildcard($408dff139db483ea$exports, $d5f256e68f92ff3f$exports);
$parcel$exportWildcard($408dff139db483ea$exports, $dd0910b23638afad$exports);


var $ca26469f43255c37$exports = {};

$parcel$export($ca26469f43255c37$exports, "Button", () => $ca26469f43255c37$export$353f5b6fc5456de1);
$parcel$export($ca26469f43255c37$exports, "SquareButton", () => $ca26469f43255c37$export$51cd5c72b5e560c6);
$parcel$export($ca26469f43255c37$exports, "CircleButton", () => $ca26469f43255c37$export$235c11ae4b685dbd);
$parcel$export($ca26469f43255c37$exports, "KangorooButton", () => $ca26469f43255c37$export$6fbe98cd572b6a70);
$parcel$export($ca26469f43255c37$exports, "FlexButton", () => $ca26469f43255c37$export$c48f2f65343acffb);
$parcel$export($ca26469f43255c37$exports, "ButtonSet", () => $ca26469f43255c37$export$87e672a75327e04b);
$parcel$export($ca26469f43255c37$exports, "CancelConfirmButtons", () => $ca26469f43255c37$export$68fd62726e540676);
$parcel$export($ca26469f43255c37$exports, "IcontextButton", () => $ca26469f43255c37$export$61af5426caa380d5);
$parcel$export($ca26469f43255c37$exports, "DropDownButton", () => $ca26469f43255c37$export$e200d4ca2624495d);
$parcel$export($ca26469f43255c37$exports, "DropDownButtonWithAvatar", () => $ca26469f43255c37$export$4ded3f507897701b);
$parcel$export($ca26469f43255c37$exports, "PlusMinusButtons", () => $ca26469f43255c37$export$f3d9ff5714153fda);


"use strict";
const $ca26469f43255c37$export$353f5b6fc5456de1 = {
    extend: [
        (0, $f8a17223267b0208$export$fe7c634bfc18e397),
        (0, $c3656ade3a6fd1e0$export$b177f82f5511f000)
    ],
    tag: "button",
    props: {
        fontSize: "A",
        type: "button",
        border: "none",
        display: "inline-flex",
        align: "center center",
        textDecoration: "none",
        lineHeight: "1",
        whiteSpace: "nowrap",
        padding: "Z B2",
        fontWeight: "500",
        fontFamily: "inherit",
        round: "C2"
    },
    attr: {
        type: ({ props: props })=>props.type
    }
};
const $ca26469f43255c37$export$51cd5c72b5e560c6 = {
    extend: $ca26469f43255c37$export$353f5b6fc5456de1,
    props: {
        fontSize: "A",
        width: "A",
        padding: "Z",
        aspectRatio: "1 / 1",
        icon: "smile",
        boxSize: "fit-content fit-content",
        justifyContent: "center",
        round: "Z",
        boxSizing: "content-box"
    }
};
const $ca26469f43255c37$export$235c11ae4b685dbd = {
    extend: $ca26469f43255c37$export$51cd5c72b5e560c6,
    props: {
        round: "C"
    }
};
const $ca26469f43255c37$export$6fbe98cd572b6a70 = {
    extend: $ca26469f43255c37$export$353f5b6fc5456de1,
    childExtend: (0, $f8a17223267b0208$export$fe7c634bfc18e397)
};
const $ca26469f43255c37$export$c48f2f65343acffb = {
    extend: $ca26469f43255c37$export$353f5b6fc5456de1,
    props: {
        boxSize: "fit-content",
        padding: "Z2 A2",
        round: "Z1",
        gap: "Z",
        position: "relative",
        Icon: {
            fontSize: "B1"
        }
    },
    Icon: {},
    Text: {
        text: "Button"
    }
};
const $ca26469f43255c37$export$87e672a75327e04b = {
    tag: "nav",
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    childExtend: $ca26469f43255c37$export$51cd5c72b5e560c6
};
const $ca26469f43255c37$export$68fd62726e540676 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        gap: "Z2",
        maxWidth: "fit-content"
    },
    childExtend: {
        extend: $ca26469f43255c37$export$c48f2f65343acffb,
        props: {
            ":first-child": {
                theme: "transparent",
                padding: "- Y1"
            }
        }
    },
    ...[
        {
            Text: "No"
        },
        {
            Text: "Yes"
        }
    ]
};
const $ca26469f43255c37$export$61af5426caa380d5 = {
    extend: $ca26469f43255c37$export$c48f2f65343acffb,
    props: {
        position: "relative",
        theme: "tertiary",
        padding: "Z2 A",
        icon: "smile"
    }
};
const $ca26469f43255c37$export$e200d4ca2624495d = {
    extend: $ca26469f43255c37$export$c48f2f65343acffb,
    props: {
        gap: "X2",
        boxSize: "fit-content fit-content",
        padding: "Z1 A1 Z Z1",
        theme: "dialog",
        icon: "chevronDown",
        Icon: {
            fontSize: "D"
        },
        Text: {
            text: "All"
        }
    }
};
const $ca26469f43255c37$export$4ded3f507897701b = {
    extend: $ca26469f43255c37$export$e200d4ca2624495d,
    props: {
        gap: "Y",
        padding: "Y",
        round: "Z1",
        theme: "dialog",
        Icon: {
            fontSize: "B1"
        }
    },
    Avatar: {
        boxSize: "A2+V1"
    },
    caption: {
        text: "ETH",
        props: {
            fontSize: "Y1",
            fontWeight: "400"
        }
    }
};
const $ca26469f43255c37$export$f3d9ff5714153fda = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        alignItems: "center",
        gap: "A"
    },
    Minus: {
        extend: $ca26469f43255c37$export$51cd5c72b5e560c6,
        props: {
            icon: "minus"
        }
    },
    Value: {
        props: {
            text: "1"
        }
    },
    Plus: {
        extend: $ca26469f43255c37$export$51cd5c72b5e560c6,
        props: {
            icon: "plus"
        }
    }
};


var $aad64e0c8b152d2b$exports = {};
var $dffb8c7028cd6201$exports = {};

$parcel$export($dffb8c7028cd6201$exports, "ProgressLine", () => $dffb8c7028cd6201$export$e5c0f55a2ee94410);
$parcel$export($dffb8c7028cd6201$exports, "ProgressLineWithUnitValue", () => $dffb8c7028cd6201$export$4ae3d31aafc39023);

"use strict";
const $dffb8c7028cd6201$export$e5c0f55a2ee94410 = {
    tag: "progress",
    props: {
        value: 0.7,
        height: "X1",
        minWidth: "F2+B1",
        round: "2px",
        overflow: "hidden",
        theme: "primary @dark .inactive",
        "::-webkit-progress-bar": {
            theme: "primary @dark .inactive"
        },
        "::-webkit-progress-value": {
            theme: "primary",
            borderRadius: "2px"
        }
    },
    attr: {
        max: ({ props: props })=>props.max,
        progress: ({ props: props })=>props.progress,
        value: ({ props: props })=>props.value
    }
};
const $dffb8c7028cd6201$export$4ae3d31aafc39023 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        align: "center flex-start",
        gap: "Z1"
    },
    ProgressLine: {
        minWidth: "F2+B1"
    },
    UnitValue: {}
};


var $48668b60617de765$exports = {};

$parcel$export($48668b60617de765$exports, "ProgressCircle", () => $48668b60617de765$export$c79b9d6b4cc92af7);
$parcel$export($48668b60617de765$exports, "ProgressCircleWithIcon", () => $48668b60617de765$export$f3fa27e27f68075d);
$parcel$export($48668b60617de765$exports, "ProgressCircleWithUnitValue", () => $48668b60617de765$export$cf4b72ceff71fe7f);
$parcel$export($48668b60617de765$exports, "ProgressCircleWithSideUnitValue", () => $48668b60617de765$export$ee33a859843d9344);

"use strict";
const $48668b60617de765$export$c79b9d6b4cc92af7 = {
    props: {
        widthRange: "D",
        aspectRatio: "1 / 1",
        position: "relative",
        ":after": {
            content: '""',
            position: "absolute",
            width: "calc(100% - 5px)",
            height: "calc(100% - 5px)",
            background: "black",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            round: "100%"
        }
    },
    Progress: {
        tag: "progress",
        props: {
            boxSize: "100% 100%",
            value: 0.7,
            round: "100%",
            overflow: "hidden",
            style: {
                "&::-webkit-progress-bar": {
                    background: "#0474F2"
                },
                "&::-webkit-progress-value": {
                    background: "#252527"
                }
            }
        },
        attr: {
            max: ({ props: props })=>props.max,
            progress: ({ props: props })=>props.progress,
            value: ({ props: props })=>props.value
        }
    }
};
const $48668b60617de765$export$f3fa27e27f68075d = {
    extend: $48668b60617de765$export$c79b9d6b4cc92af7,
    Icon: {
        name: "arrowUp",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: "3",
        fontSize: "E"
    }
};
const $48668b60617de765$export$cf4b72ceff71fe7f = {
    extend: $48668b60617de765$export$c79b9d6b4cc92af7,
    Progress: {},
    UnitValue: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: "3",
        fontSize: "Z"
    }
};
const $48668b60617de765$export$ee33a859843d9344 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        align: "center flex-start",
        boxSize: "fit-content",
        gap: "Y"
    },
    ProgressCircle: {
        boxSize: "A",
        ":after": {
            width: "calc(100% - 5px)",
            height: "calc(100% - 5px)"
        }
    },
    UnitValue: {}
};


"use strict";
$parcel$exportWildcard($aad64e0c8b152d2b$exports, $dffb8c7028cd6201$exports);
$parcel$exportWildcard($aad64e0c8b152d2b$exports, $48668b60617de765$exports);


var $781e0e9576e3e707$exports = {};

$parcel$export($781e0e9576e3e707$exports, "Range", () => $781e0e9576e3e707$export$9a58ef0d7ad3278c);
$parcel$export($781e0e9576e3e707$exports, "RangeWithButtons", () => $781e0e9576e3e707$export$94c40b3709c521a9);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");


"use strict";
const $781e0e9576e3e707$var$props = {
    appearance: "none",
    width: "100%",
    height: "2px",
    outline: "none",
    flex: 1,
    onInput: (ev, el, s)=>s.update({
            value: el.node.value
        }),
    onChange: (ev, el, s)=>s.update({
            value: el.node.value
        }),
    style: {
        appearance: "none"
    },
    "::-webkit-slider-thumb": {
        boxSizing: "content-box",
        width: "8px",
        height: "8px",
        borderWidth: "2px",
        borderStyle: "solid",
        borderRadius: "100%",
        opacity: ".8",
        style: {
            appearance: "none"
        }
    },
    "::-webkit-slider-runnable-track": {},
    "@dark": {
        background: "white 0.2",
        "::-webkit-slider-thumb": {
            background: "#232526",
            borderColor: (0, $1ef99b0b26632769$export$f4f50e3877dd0530)("#454646", 0.75)
        },
        ":hover": {
            "::-webkit-slider-thumb": {
                borderColor: (0, $1ef99b0b26632769$export$f4f50e3877dd0530)("#fff", 0.35)
            }
        },
        ":focus": {
            "::-webkit-slider-thumb": {
                borderColor: "#3C6AC0"
            }
        }
    },
    "@light": {
        background: "gray9",
        "::-webkit-slider-thumb": {
            background: "white",
            borderColor: "gray9"
        },
        ":hover": {
            "::-webkit-slider-thumb": {
                borderColor: "gray7"
            }
        },
        ":focus": {
            "::-webkit-slider-thumb": {
                borderColor: "blue"
            }
        }
    }
};
const $781e0e9576e3e707$var$returnPropertyValue = (el, property, def)=>{
    const val = el.props && el.props[property];
    const r = (0, $EqHTq.isFunction)(val) ? val(el, el.state) : val !== undefined ? val : def !== undefined ? def : 0;
    return r + "";
};
const $781e0e9576e3e707$export$9a58ef0d7ad3278c = {
    props: $781e0e9576e3e707$var$props,
    tag: "input",
    attr: {
        type: "range",
        value: (el, s)=>parseFloat(el.state.value || el.props.value || el.props.defaultValue),
        min: (el, s)=>$781e0e9576e3e707$var$returnPropertyValue(el, "min", 0),
        max: (el, s)=>$781e0e9576e3e707$var$returnPropertyValue(el, "max", 100),
        step: (el, s)=>$781e0e9576e3e707$var$returnPropertyValue(el, "step", 1)
    },
    on: {
        input: (ev, el, s)=>{
            const props = el.props;
            if ((0, $EqHTq.isFunction)(props.onInput)) props.onInput(ev, el, s);
            else s.update({
                value: parseFloat(el.node.value)
            });
        },
        change: (ev, el, s)=>{
            const props = el.props;
            if ((0, $EqHTq.isFunction)(props.onChange)) props.onChange(ev, el, s);
            else s.update({
                value: parseFloat(el.node.value)
            });
        }
    }
};
const $781e0e9576e3e707$export$94c40b3709c521a9 = {
    minus: {
        extend: (0, $ca26469f43255c37$export$51cd5c72b5e560c6),
        props: {
            theme: "field",
            icon: "minus"
        },
        on: {
            click: (ev, el, s)=>{
                const parentProps = el.parent.props;
                if ((0, $EqHTq.isFunction)(parentProps.onDecrease)) parentProps.onDecrease(ev, el.parent, s);
                else {
                    const value = parseFloat(s.value);
                    const min = $781e0e9576e3e707$var$returnPropertyValue(el.parent, "min", 1);
                    const step = $781e0e9576e3e707$var$returnPropertyValue(el.parent, "step", 1);
                    if (value > min) s.update({
                        value: value - step
                    });
                }
            }
        }
    },
    value: {
        props: {
            width: "4ch"
        },
        tag: "span",
        text: ({ state: state, parent: parent })=>{
            const unit = $781e0e9576e3e707$var$returnPropertyValue(parent, "unit", "");
            return "" + (state.value || state.defaultValue || 0) + unit;
        }
    },
    input: {
        extend: $781e0e9576e3e707$export$9a58ef0d7ad3278c,
        attr: {
            value: (el, s)=>parseFloat(s.value || s.defaultValue),
            min: (el, s)=>$781e0e9576e3e707$var$returnPropertyValue(el.parent, "min", 0),
            max: (el, s)=>$781e0e9576e3e707$var$returnPropertyValue(el.parent, "max", 100),
            step: (el, s)=>$781e0e9576e3e707$var$returnPropertyValue(el.parent, "step", 1)
        },
        on: {
            input: (ev, el, s)=>{
                const parentProps = el.parent.props;
                if ((0, $EqHTq.isFunction)(parentProps.onInput)) parentProps.onInput(ev, el, s);
                else s.update({
                    value: parseFloat(el.node.value)
                });
            },
            change: (ev, el, s)=>{
                const parentProps = el.parent.props;
                if ((0, $EqHTq.isFunction)(parentProps.onChange)) parentProps.onChange(ev, el, s);
                else s.update({
                    value: parseFloat(el.node.value)
                });
            }
        }
    },
    plus: {
        extend: (0, $ca26469f43255c37$export$51cd5c72b5e560c6),
        props: {
            theme: "field",
            icon: "plus"
        },
        on: {
            click: (ev, el, s)=>{
                const parentProps = el.parent.props;
                if ((0, $EqHTq.isFunction)(parentProps.onIncrease)) parentProps.onIncrease(ev, el.parent, s);
                else {
                    const value = parseFloat(s.value);
                    const max = $781e0e9576e3e707$var$returnPropertyValue(el.parent, "max", 1);
                    const step = $781e0e9576e3e707$var$returnPropertyValue(el.parent, "step", 1);
                    if (value < max) s.update({
                        value: value + step
                    });
                }
            }
        }
    }
};


var $c658bc99cb4f11e8$exports = {};

$parcel$export($c658bc99cb4f11e8$exports, "RangeSlider", () => $c658bc99cb4f11e8$export$826424dabc3dd705);
$parcel$export($c658bc99cb4f11e8$exports, "Slider", () => $c658bc99cb4f11e8$export$472062a354075cee);
"use strict";
var $a2410c4a861c3532$export$2e2bcd8739ae039 = {
    appearance: "none",
    width: "100%",
    height: "2px",
    outline: "none",
    flex: 1,
    "::-webkit-slider-thumb": {
        boxSizing: "content-box",
        appearance: "none",
        width: "8px",
        height: "8px",
        borderWidth: "2px",
        borderStyle: "solid",
        borderRadius: "100%",
        opacity: ".8"
    }
};


parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");

"use strict";
const $c658bc99cb4f11e8$export$826424dabc3dd705 = {
    props: {
        ...(0, $a2410c4a861c3532$export$2e2bcd8739ae039),
        theme: "sliderThumb"
    },
    tag: "input",
    attr: {
        type: "range"
    }
};
const $c658bc99cb4f11e8$var$listenProp = (el, prop, def)=>{
    const val = el && el.props && el.props[prop];
    const r = ((0, $EqHTq.isFunction)(val) ? val() : val) || (def !== undefined ? def : 50);
    return r;
};
const $c658bc99cb4f11e8$export$472062a354075cee = {
    button0: {
        extend: [
            (0, $ca26469f43255c37$export$51cd5c72b5e560c6)
        ],
        props: {
            icon: "minus"
        },
        on: {
            click: (ev, el, s)=>{
                el.props && (0, $EqHTq.isFunction)(el.props.click) && el.props.click(ev, el, s);
                const input = el.parent.input;
                const props = input.props;
                const value = (0, $EqHTq.isFunction)(props.value) ? props.value() : props.value;
                input.node.value = value;
            }
        }
    },
    value: {
        style: {
            width: "4ch"
        },
        tag: "span",
        text: (el, s)=>{
            const value = $c658bc99cb4f11e8$var$listenProp(el.parent.input, "value");
            const unit = $c658bc99cb4f11e8$var$listenProp(el.parent.input, "unit", "");
            return "" + value + unit;
        }
    },
    range: {
        extend: $c658bc99cb4f11e8$export$826424dabc3dd705,
        attr: {
            value: (el, s)=>$c658bc99cb4f11e8$var$listenProp(el, "value", 50),
            min: (el, s)=>$c658bc99cb4f11e8$var$listenProp(el, "min", 0),
            max: (el, s)=>$c658bc99cb4f11e8$var$listenProp(el, "max", 100),
            step: (el, s)=>$c658bc99cb4f11e8$var$listenProp(el, "step", 1)
        },
        on: {
            input: (ev, el, s)=>el.props && (0, $EqHTq.isFunction)(el.props.input) && el.props.input(ev, el, s),
            change: (ev, el, s)=>el.props && (0, $EqHTq.isFunction)(el.props.change) && el.props.change(ev, el, s)
        }
    },
    button1: {
        extend: [
            (0, $ca26469f43255c37$export$51cd5c72b5e560c6)
        ],
        props: {
            icon: "plus"
        },
        on: {
            click: (ev, el, s)=>{
                el.props && (0, $EqHTq.isFunction)(el.props.click) && el.props.click(ev, el, s);
                const input = el.parent.input;
                const props = input.props;
                const value = (0, $EqHTq.isFunction)(props.value) ? props.value() : props.value;
                input.node.value = value;
            }
        }
    }
};


var $7bd759d9ddd96987$exports = {};

$parcel$export($7bd759d9ddd96987$exports, "Label", () => $7bd759d9ddd96987$export$b04be29aa201d4f5);
$parcel$export($7bd759d9ddd96987$exports, "LabelButton", () => $7bd759d9ddd96987$export$239fbcd864262455);
$parcel$export($7bd759d9ddd96987$exports, "CardLabel", () => $7bd759d9ddd96987$export$e13aaac4037b0914);


"use strict";
const $7bd759d9ddd96987$export$b04be29aa201d4f5 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        text: "-2.902x",
        fontSize: "Z",
        theme: "tertiary",
        boxSize: "fit-content fit-content",
        padding: "W2 Y2",
        lineHeight: "1",
        round: "Y1",
        fontWeight: "400"
    }
};
const $7bd759d9ddd96987$export$239fbcd864262455 = {
    extend: (0, $ca26469f43255c37$export$353f5b6fc5456de1),
    props: {
        theme: "tertiary",
        fontSize: "Z2",
        emoji: "\uD83D\uDC4D",
        text: "3",
        padding: "X2 Z",
        round: "C",
        lineHeight: 1,
        gap: "X2",
        fontWeight: "500"
    },
    emoji: {
        props: ({ parent: parent })=>({
                text: parent.props.emoji
            })
    }
};
const $7bd759d9ddd96987$export$e13aaac4037b0914 = {
    props: {
        text: "-2.902x",
        fontSize: "Z",
        background: "#F4454E",
        boxSize: "fit-content fit-content",
        padding: "W Y",
        round: "Y"
    }
};


var $d0fd1386e51a3c49$exports = {};
var $de415e64d965a551$exports = {};

$parcel$export($de415e64d965a551$exports, "Avatar", () => $de415e64d965a551$export$e2255cf6045e8d47);

"use strict";
const $de415e64d965a551$export$e2255cf6045e8d47 = {
    extend: (0, $c95002999fe11fd8$export$cc7b5f925acc71d3),
    props: ({ key: key, props: props })=>({
            display: "block",
            avatarType: "adventurer-neutral",
            borderRadius: "100%",
            boxSize: "C+X C+X",
            src: `https://api.dicebear.com/7.x/${props.avatarType || "initials"}/svg?seed=${props.key || key || "no-avatar"}`
        })
};


var $6ee5e234b1e3ae1a$exports = {};

$parcel$export($6ee5e234b1e3ae1a$exports, "AvatarIndicator", () => $6ee5e234b1e3ae1a$export$2fb355f3907c18fc);
"use strict";
const $6ee5e234b1e3ae1a$export$2fb355f3907c18fc = {
    props: {
        boxSize: "fit-content",
        position: "relative",
        round: "100%"
    },
    Avatar: {},
    StatusIndicator: {
        theme: "success",
        position: "absolute",
        bottom: "0",
        right: "0"
    }
};


var $8f77a64ae10a2cb0$exports = {};

$parcel$export($8f77a64ae10a2cb0$exports, "AvatarBundle", () => $8f77a64ae10a2cb0$export$5822eaed382932db);


"use strict";
const $8f77a64ae10a2cb0$export$5822eaed382932db = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        childProps: {
            "@light": {
                border: "2px, var(--theme-document-light-background), solid"
            },
            "@dark": {
                border: "2px, var(--theme-document-dark-background), solid"
            },
            ":not(:last-child)": {
                margin: "0 -Y2 0 0"
            }
        }
    },
    childExtend: (0, $de415e64d965a551$export$e2255cf6045e8d47),
    $propsCollection: ({ props: props })=>props.options
};


var $715033dbecabb105$exports = {};

$parcel$export($715033dbecabb105$exports, "AvatarChooser", () => $715033dbecabb105$export$666bea062326062a);

"use strict";
const $715033dbecabb105$export$666bea062326062a = {
    extend: (0, $ca26469f43255c37$export$353f5b6fc5456de1),
    tag: "label",
    state: {
        key: "am"
    },
    props: {
        round: "A2",
        width: "fit-content",
        padding: "X2 Y2+V X2 X2",
        theme: "tertiary",
        position: "relative",
        cursor: "pointer"
    },
    Avatar: {
        props: ({ state: state })=>({
                key: state.key,
                boxSize: "B1",
                pointerEvents: "none"
            })
    },
    Select: {
        props: {
            outline: "none",
            pointerEvents: "All",
            appearance: "none",
            height: "100%",
            background: "none",
            color: "currentColor",
            lineHeight: 1,
            padding: "- B - Y1",
            zIndex: "2",
            flex: "1",
            fontWeight: "500",
            ":focus-visible": {
                outline: "none"
            }
        },
        childExtend: {
            tag: "option"
        },
        $propsCollection: ({ parent: parent, state: state })=>{
            if (!parent.props.options) return [];
            return parent.props.options.map((v)=>{
                if (v.text === state.key) return {
                    ...v,
                    selected: true
                };
                return v;
            });
        },
        on: {
            change: (ev, { state: state })=>{
                state.update({
                    key: ev.target.value
                });
            }
        }
    },
    Icon: {
        props: {
            icon: "chevronDown",
            fontSize: "C",
            margin: "V - - -",
            position: "absolute",
            right: "Y1",
            pointerEvents: "none"
        }
    }
};


"use strict";
$parcel$exportWildcard($d0fd1386e51a3c49$exports, $de415e64d965a551$exports);
$parcel$exportWildcard($d0fd1386e51a3c49$exports, $6ee5e234b1e3ae1a$exports);
$parcel$exportWildcard($d0fd1386e51a3c49$exports, $8f77a64ae10a2cb0$exports);
$parcel$exportWildcard($d0fd1386e51a3c49$exports, $715033dbecabb105$exports);


var $e39e4f558cd2a095$exports = {};

$parcel$export($e39e4f558cd2a095$exports, "Notification", () => $e39e4f558cd2a095$export$14834abbfce3b8cd);
$parcel$export($e39e4f558cd2a095$exports, "NotificationIndicator", () => $e39e4f558cd2a095$export$208fd20af21dc523);

"use strict";
const $e39e4f558cd2a095$export$14834abbfce3b8cd = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        theme: "alert",
        padding: "Z1 B Z A",
        round: "A A A Y2",
        gap: "X2",
        cursor: "pointer",
        align: "flex-start center"
    },
    IconText: {
        props: {
            icon: "info outline"
        }
    },
    Flex: {
        props: {
            flow: "column",
            align: "flex-start",
            gap: "X2"
        },
        Title: {
            tag: "h6",
            props: {
                margin: "0",
                fontWeight: "600",
                lineHeight: "1em",
                text: "Notification"
            }
        },
        P: {
            props: {
                fontSize: "Z",
                margin: "0",
                text: "is not always a distraction"
            }
        }
    }
};
const $e39e4f558cd2a095$export$208fd20af21dc523 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        text: "2",
        fontSize: "Z",
        lineHeight: "1em",
        background: "#0474F2",
        boxSize: "fit-content fit-content",
        padding: "X+W",
        round: "Y+X"
    }
};


var $5789735af6bd85de$exports = {};

$parcel$export($5789735af6bd85de$exports, "Tooltip", () => $5789735af6bd85de$export$28c660c63b792dea);
$parcel$export($5789735af6bd85de$exports, "TooltipHidden", () => $5789735af6bd85de$export$92ba62bde414cbb2);
$parcel$export($5789735af6bd85de$exports, "TooltipParent", () => $5789735af6bd85de$export$1d54d90a050b9c15);
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");

"use strict";
const $5789735af6bd85de$export$28c660c63b792dea = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        theme: "dialog",
        background: "black",
        flow: "column",
        shape: "tooltip",
        shapeDirection: "left",
        padding: "Z1 A",
        round: "Y2",
        width: "fit-content",
        minWidth: "D2",
        maxWidth: "F2",
        gap: "X",
        textAlign: "center"
    },
    attr: {
        tooltip: true
    },
    Title: {
        if: ({ parent: parent, props: props })=>(0, $EqHTq.isDefined)(parent.props.title) || props.text,
        props: ({ parent: parent })=>({
                width: "fit-content",
                fontWeight: 500,
                color: "gray12",
                text: parent.props.title
            })
    },
    P: {
        if: ({ parent: parent, props: props })=>(0, $EqHTq.isDefined)(parent.props.description) || props.text,
        props: ({ parent: parent })=>({
                width: "fit-content",
                fontSize: "Z2",
                margin: "0",
                color: "gray6",
                fontWeight: "400",
                text: parent.props.description
            })
    }
};
const $5789735af6bd85de$export$92ba62bde414cbb2 = {
    extend: $5789735af6bd85de$export$28c660c63b792dea,
    props: ({ props: props })=>({
            position: "absolute",
            pointerEvents: "none",
            opacity: "0",
            visibility: "hidden",
            transition: "C defaultBezier opacity, C defaultBezier visibility, B defaultBezier transform",
            ...props.shapeDirection === "top" ? {
                top: "112%",
                left: "50%",
                transform: "translate3d(-50%,10%,0)",
                ".active": {
                    transform: "translate3d(-50%,0,0)",
                    opacity: 1,
                    visibility: "visible"
                }
            } : props.shapeDirection === "right" ? {
                transform: "translate3d(10%,-50%,0)",
                right: "112%",
                top: "50%",
                ".active": {
                    transform: "translate3d(0%,-50%,0)",
                    opacity: 1,
                    visibility: "visible"
                }
            } : props.shapeDirection === "bottom" ? {
                transform: "translate3d(-50%,-10%,0)",
                bottom: "112%",
                left: "50%",
                ".active": {
                    transform: "translate3d(-50%,0,0)",
                    opacity: 1,
                    visibility: "visible"
                }
            } : {
                transform: "translate3d(10%,-50%,0)",
                left: "112%",
                top: "50%",
                ".active": {
                    transform: "translate3d(0%,-50%,0)",
                    opacity: 1,
                    visibility: "visible"
                }
            }
        })
};
const $5789735af6bd85de$export$1d54d90a050b9c15 = {
    props: (el)=>{
        const { Tooltip: Tooltip, TooltipHidden: TooltipHidden } = el;
        const TooltipElem = Tooltip || TooltipHidden;
        if (!TooltipElem || TooltipElem) return console.warn("Tooltip was not found in", el.__ref.path);
        const TooltipActive = TooltipElem.props && TooltipElem.props[".active"];
        return {
            position: "relative",
            zIndex: 999,
            style: {
                "&:hover, &:focus-visible": {
                    zIndex: 1000,
                    "& [tooltip]": TooltipActive || {
                        transform: "translate3d(-50%,0,0)",
                        opacity: 1,
                        visibility: "visible"
                    }
                }
            }
        };
    }
};


var $f935884925ad4fcf$exports = {};

$parcel$export($f935884925ad4fcf$exports, "Pills", () => $f935884925ad4fcf$export$93f0733b9cd7cb26);

"use strict";
const $f935884925ad4fcf$export$93f0733b9cd7cb26 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        gap: "Y2"
    },
    childExtend: {
        extend: {
            props: ({ key: key, state: state, parent: parent })=>({
                    boxSize: "Y2",
                    round: "A",
                    background: "currentColor",
                    active: parseInt(key) === parseInt(state.active || parent.props.active),
                    "!active": {
                        opacity: 0.35
                    }
                })
        },
        on: {
            click: (e, el)=>{
                el.state.update({
                    active: parseInt(el.key)
                });
            }
        }
    },
    $propsCollection: ({ props: props, state: state })=>new Array(props.qty).fill({})
};


var $d6afc2003bbecb7e$exports = {};

$parcel$export($d6afc2003bbecb7e$exports, "Tab", () => $d6afc2003bbecb7e$export$3e41faf802a29e71);
$parcel$export($d6afc2003bbecb7e$exports, "IconTab", () => $d6afc2003bbecb7e$export$5fd6e91639893354);

"use strict";
const $d6afc2003bbecb7e$export$3e41faf802a29e71 = {
    extend: (0, $ca26469f43255c37$export$c48f2f65343acffb),
    props: {
        boxSize: "fit-content fit-content",
        align: "center flex-start",
        position: "relative",
        padding: "Z Z1",
        theme: "field",
        borderRadius: "A A X2 X2",
        icon: "smile"
    },
    Icon: {},
    Text: {
        text: "Caption"
    },
    CountIndicator: {
        fontSize: "Z1",
        text: "19",
        margin: "- - - X1"
    }
};
const $d6afc2003bbecb7e$export$5fd6e91639893354 = {
    extend: (0, $ca26469f43255c37$export$51cd5c72b5e560c6),
    Span: null,
    CountIndicator: {
        fontSize: "Z",
        position: "absolute",
        top: "-Y2",
        right: "-Y2",
        text: "19"
    }
};


var $0845c3d41e8b035e$exports = {};
var $e82f0792b13ea87f$exports = {};

$parcel$export($e82f0792b13ea87f$exports, "CheckStep", () => $e82f0792b13ea87f$export$63e9616f085c25f5);
$parcel$export($e82f0792b13ea87f$exports, "CheckSteps", () => $e82f0792b13ea87f$export$f6472a2e5cf4be95);

"use strict";
const $e82f0792b13ea87f$export$63e9616f085c25f5 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        boxSize: "fit-content",
        align: "center flex-start",
        gap: "Z1"
    },
    CheckIndicatorWithLabel: {
        CheckIndicator: {
            theme: "transparent",
            border: "1.5px solid #1C1C1F",
            ".isActive": {
                theme: "primary",
                border: "none"
            }
        }
    },
    ProgressLine: {
        value: 0,
        height: "V2",
        minWidth: "E",
        maxWidth: "E",
        round: "D",
        ".isActive": {
            value: 1
        }
    }
};
const $e82f0792b13ea87f$export$f6472a2e5cf4be95 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        boxSize: "fit-content fit-content",
        align: "center flex-start",
        gap: "Z1",
        childProps: {
            ":last-child > progress": {
                display: "none"
            }
        }
    },
    childExtend: $e82f0792b13ea87f$export$63e9616f085c25f5,
    ...[
        {
            CheckIndicatorWithLabel: {
                CheckIndicator: {
                    isActive: true
                }
            },
            ProgressLine: {
                value: 1
            }
        },
        {
            CheckIndicatorWithLabel: {
                CheckIndicator: {
                    isActive: true
                }
            },
            ProgressLine: {
                value: 1
            }
        },
        {
            CheckIndicatorWithLabel: {
                CheckIndicator: {
                    isActive: true
                }
            },
            ProgressLine: {
                value: 1
            }
        },
        {},
        {}
    ]
};


var $35d1430a0e07c2dc$exports = {};

$parcel$export($35d1430a0e07c2dc$exports, "RadioStep", () => $35d1430a0e07c2dc$export$ed72fcde61061f29);
$parcel$export($35d1430a0e07c2dc$exports, "RadioSteps", () => $35d1430a0e07c2dc$export$c1b1d6357b678bd5);


"use strict";
const $35d1430a0e07c2dc$export$ed72fcde61061f29 = {
    extend: (0, $e82f0792b13ea87f$export$63e9616f085c25f5),
    CheckIndicatorWithLabel: null,
    RadioIndicatorWithLabel: {
        RadioIndicator: {
            theme: "dialog",
            ":after": {},
            ".isActive": {
                theme: "dialog",
                border: "none",
                ":after": {
                    theme: "primary"
                }
            }
        }
    },
    ProgressLine: {}
};
const $35d1430a0e07c2dc$export$c1b1d6357b678bd5 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        boxSize: "fit-content fit-content",
        align: "center flex-start",
        gap: "Z",
        childProps: {
            ":last-child > progress": {
                display: "none"
            }
        }
    },
    childExtend: $35d1430a0e07c2dc$export$ed72fcde61061f29,
    ...[
        {
            RadioIndicatorWithLabel: {
                RadioIndicator: {
                    isActive: true
                }
            },
            ProgressLine: {
                value: 1
            }
        },
        {
            RadioIndicatorWithLabel: {
                RadioIndicator: {
                    isActive: true
                }
            },
            ProgressLine: {
                value: 1
            }
        },
        {
            RadioIndicatorWithLabel: {
                RadioIndicator: {
                    isActive: true
                }
            },
            ProgressLine: {
                value: 1
            }
        },
        {},
        {}
    ]
};


var $55a7a8d2fb1cfa5b$exports = {};

$parcel$export($55a7a8d2fb1cfa5b$exports, "LineSteps", () => $55a7a8d2fb1cfa5b$export$ca8e53c01c00bf00);
$parcel$export($55a7a8d2fb1cfa5b$exports, "LineStepsWithHgroup", () => $55a7a8d2fb1cfa5b$export$4ae04c55091daa94);


"use strict";
const $55a7a8d2fb1cfa5b$export$ca8e53c01c00bf00 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        boxSize: "fit-content",
        gap: "Y1"
    },
    childExtend: {
        extend: (0, $dffb8c7028cd6201$export$e5c0f55a2ee94410),
        props: {
            value: 1,
            height: "X2",
            minWidth: "F",
            round: "X"
        }
    },
    ...[
        {},
        {},
        {
            props: {
                value: 0
            }
        }
    ]
};
const $55a7a8d2fb1cfa5b$export$4ae04c55091daa94 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        flow: "column",
        padding: "A A1",
        theme: "dialog",
        round: "A1",
        boxSize: "fit-content",
        gap: "A1"
    },
    Hgroup: {
        gap: "Y1",
        Title: {
            text: "Symbols",
            fontSize: "D1"
        },
        Paragraph: {
            text: "The easiest way to build your own website.",
            fontSize: "Z1",
            color: "caption"
        }
    },
    LineSteps: {
        childProps: {
            minWidth: "E+A",
            maxWidth: "E+A"
        }
    }
};


"use strict";
$parcel$exportWildcard($0845c3d41e8b035e$exports, $e82f0792b13ea87f$exports);
$parcel$exportWildcard($0845c3d41e8b035e$exports, $35d1430a0e07c2dc$exports);
$parcel$exportWildcard($0845c3d41e8b035e$exports, $55a7a8d2fb1cfa5b$exports);


var $ffecead860a69fb6$exports = {};

$parcel$export($ffecead860a69fb6$exports, "ParagraphButton", () => $ffecead860a69fb6$export$67f2745a7819a23e);
$parcel$export($ffecead860a69fb6$exports, "ParagraphButtonWithCheckbox", () => $ffecead860a69fb6$export$e49a0306ba5b7ef2);

"use strict";
const $ffecead860a69fb6$export$67f2745a7819a23e = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        alignItems: "center",
        gap: "Y2"
    },
    P: {
        props: {
            text: "Didn't get the code?",
            color: "caption",
            margin: "0"
        }
    },
    Button: {
        text: "Click to resend",
        padding: "0",
        background: "transparent",
        textDecoration: "underline",
        fontWeight: "500",
        Icon: {
            display: "none"
        }
    }
};
const $ffecead860a69fb6$export$e49a0306ba5b7ef2 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    tag: "label",
    props: {
        gap: "1ch",
        alignItems: "center"
    },
    Checkbox: {
        tag: "div",
        props: {
            Input: {},
            Flex: {
                fontSize: "A"
            }
        }
    },
    ParagraphButton: {
        P: {
            text: "You agree to"
        },
        Button: {
            text: "privacy policy"
        }
    }
};


var $b0b428f1a022b7ac$exports = {};

$parcel$export($b0b428f1a022b7ac$exports, "SocialLink", () => $b0b428f1a022b7ac$export$cc8afd413c65875b);


"use strict";
const $b0b428f1a022b7ac$export$cc8afd413c65875b = {
    extend: [
        (0, $59e9b7f5a8955db9$export$a6c7ac8248d6e38a),
        (0, $f8a17223267b0208$export$fe7c634bfc18e397)
    ],
    props: {
        fontWeight: "500",
        text: "Continue with Twitch",
        fontSize: "Z1",
        gap: "Z",
        boxSize: "fit-content",
        padding: "A A2",
        background: "gray3",
        round: "Z1",
        maxHeight: `${3}em`,
        cursor: "pointer",
        Icon: {
            name: "twitch",
            boxSize: "A2"
        }
    }
};


var $14b0ee601310f298$exports = {};

$parcel$export($14b0ee601310f298$exports, "Dialog", () => $14b0ee601310f298$export$3ddf2d174ce01153);
$parcel$export($14b0ee601310f298$exports, "DialogHeader", () => $14b0ee601310f298$export$742513523b177e3b);
$parcel$export($14b0ee601310f298$exports, "DialogFooter", () => $14b0ee601310f298$export$7bbfb2d443473050);
"use strict";
const $14b0ee601310f298$export$3ddf2d174ce01153 = {
    extend: "Flex",
    tag: "dialog",
    props: {
        flow: "column",
        border: "0",
        theme: "dialog",
        round: "Z2"
    }
};
const $14b0ee601310f298$export$742513523b177e3b = {
    extend: "Hgroup",
    props: {
        minWidth: "100%",
        gap: "A"
    },
    Title: {
        props: {
            align: "center space-between"
        },
        Text: {
            text: "Title"
        },
        SquareButton: {
            icon: "x",
            theme: "transparent"
        }
    },
    Paragraph: {
        props: {
            color: "caption"
        }
    }
};
const $14b0ee601310f298$export$7bbfb2d443473050 = {
    extend: "Flex",
    props: {
        align: "center flex-end",
        gap: "X2",
        margin: "auto - -",
        padding: "Y2 X2"
    },
    childExtend: {
        extend: "Button",
        props: {
            textTransform: "uppercase",
            background: "transparent",
            "@dark": {
                theme: "primary @dark .color-only"
            },
            "@light": {
                theme: "primary @light .color-only"
            },
            "&": {
                padding: "Z A"
            },
            ":hover": {
                theme: "tertiary"
            },
            ":active": {
                background: "white .1"
            }
        }
    },
    cancel: {
        text: "cancel"
    },
    ok: {
        text: "ok"
    }
};


var $423902791a5aa103$exports = {};
var $1c7c00bc6cd309dd$exports = {};

$parcel$export($1c7c00bc6cd309dd$exports, "Modal", () => $1c7c00bc6cd309dd$export$2b77a92f1a5ad772);

"use strict";
const $1c7c00bc6cd309dd$export$2b77a92f1a5ad772 = {
    extend: (0, $14b0ee601310f298$export$3ddf2d174ce01153),
    props: {
        boxSize: "fit-content",
        align: "stretch flex-start",
        minWidth: "G3",
        position: "relative",
        padding: "Z2 A2",
        round: "A1"
    },
    ModalHeader: {
        extend: "DialogHeader"
    }
};


var $b1364ff4d85ad896$exports = {};

$parcel$export($b1364ff4d85ad896$exports, "CompleteProcess", () => $b1364ff4d85ad896$export$8bf7a5ad1edc323e);

"use strict";
const $b1364ff4d85ad896$export$8bf7a5ad1edc323e = {
    extend: (0, $1c7c00bc6cd309dd$export$2b77a92f1a5ad772),
    props: {
        align: "center",
        gap: "B"
    },
    ModalHeader: {
        Title: {
            Text: null,
            SquareButton_x: {
                margin: "- - - auto"
            }
        },
        Paragraph: null
    },
    SuccessIndicator: {
        fontSize: "D"
    },
    Hgroup: {
        alignItems: "center",
        gap: "Y",
        Title: {
            text: "Reset complete!"
        },
        Paragraph: {
            text: "Your request has been approved!"
        }
    },
    FlexButton: {
        minWidth: "100%",
        margin: "Y - - -",
        fontWeight: "500",
        Text: {
            text: "Done"
        }
    }
};


var $6376e85cc840acfd$exports = {};

$parcel$export($6376e85cc840acfd$exports, "Message", () => $6376e85cc840acfd$export$f69c19e57285b83a);

"use strict";
const $6376e85cc840acfd$export$f69c19e57285b83a = {
    extend: (0, $1c7c00bc6cd309dd$export$2b77a92f1a5ad772),
    props: {
        maxWidth: "G3"
    },
    ModalHeader: {
        Title: {
            Text: {
                text: "Message"
            },
            SquareButton: {
                padding: "V2"
            }
        },
        Paragraph: {
            props: {
                text: "Yes. If you change your mind and no longer wish to keep your iPhone, you have the option to return it to us. The returned iPhone must be in good condition and in the original packaging, which contains all accessories, manuals and instructions. Returns are subject to Apple\u2019s Sales and Refunds Policy."
            }
        }
    }
};


var $3345613b86ec130c$exports = {};

$parcel$export($3345613b86ec130c$exports, "Pricing", () => $3345613b86ec130c$export$bc75f5ddb26aac73);


"use strict";
const $3345613b86ec130c$export$bc75f5ddb26aac73 = {
    extend: (0, $1c7c00bc6cd309dd$export$2b77a92f1a5ad772),
    props: {
        background: "gray3",
        gap: "B",
        minWidth: "G+B",
        maxWidth: "G+B",
        padding: "A1"
    },
    ModalHeader: null,
    Content: {
        props: {
            flow: "column",
            gap: "A1"
        },
        childExtend: {
            extend: (0, $f887848157c82147$export$d703b7d35511419c),
            props: {
                justifyContent: "space-between",
                textTransform: "capitalize"
            }
        },
        ...[
            {
                Unit: {
                    props: {
                        text: "subtotal"
                    }
                },
                Value: {
                    props: {
                        text: "$5,499.00"
                    }
                }
            },
            {
                Unit: {
                    props: {
                        text: "Shipping"
                    }
                },
                Value: {
                    props: {
                        text: "Free"
                    }
                }
            },
            {
                Unit: {
                    props: {
                        text: "Savings"
                    }
                },
                Value: {
                    props: {
                        text: "$1,600.00"
                    }
                }
            }
        ]
    },
    ModalFooter: {
        props: {
            margin: "- -X -X"
        },
        FlexButton: {
            flex: "1",
            padding: "Z2 -",
            round: "Y2",
            theme: "field",
            margin: "- -X -X",
            text: "Add promo code",
            fontWeight: "500"
        }
    }
};


"use strict";
$parcel$exportWildcard($423902791a5aa103$exports, $1c7c00bc6cd309dd$exports);
$parcel$exportWildcard($423902791a5aa103$exports, $b1364ff4d85ad896$exports);
$parcel$exportWildcard($423902791a5aa103$exports, $6376e85cc840acfd$exports);
$parcel$exportWildcard($423902791a5aa103$exports, $3345613b86ec130c$exports);


var $bfe4bf8a850bff5d$exports = {};
var $6129fe7cbc1a3e27$exports = {};

$parcel$export($6129fe7cbc1a3e27$exports, "List", () => $6129fe7cbc1a3e27$export$54c2e3dc7acea9f5);
$parcel$export($6129fe7cbc1a3e27$exports, "ListTemplate", () => $6129fe7cbc1a3e27$export$92d9ebaedf6ba994);
$parcel$export($6129fe7cbc1a3e27$exports, "DotList", () => $6129fe7cbc1a3e27$export$4f8543c05544ab60);

"use strict";
const $6129fe7cbc1a3e27$export$54c2e3dc7acea9f5 = {
    props: {
        position: "relative",
        overflow: "hidden",
        round: "A",
        minWidth: "F1",
        theme: "dialog",
        ":before, &:after": {
            content: '""',
            position: "absolute",
            boxSize: "A2 100%",
            zIndex: "2",
            left: "0",
            pointerEvents: "none"
        },
        ":before": {
            top: "0",
            background: "linear-gradient(to bottom, var(--theme-dialog-dark-background) 0%, transparent 100%)"
        },
        ":after": {
            bottom: "0",
            background: "linear-gradient(to top, var(--theme-dialog-dark-background) 0%, transparent 100%)"
        }
    },
    Flex: {
        props: {
            flow: "column",
            maxHeight: "F+C",
            overflow: "auto",
            "::-webkit-scrollbar": {
                display: "none"
            }
        },
        childExtend: {
            props: {
                padding: "Z1 A1",
                position: "relative",
                cursor: "pointer",
                color: "caption",
                ":hover": {
                    background: "gray .92 +4"
                },
                childProps: {
                    position: "relative"
                }
            }
        }
    }
};
const $6129fe7cbc1a3e27$export$92d9ebaedf6ba994 = {
    extend: $6129fe7cbc1a3e27$export$54c2e3dc7acea9f5,
    props: {
        maxWidth: "F"
    },
    Flex: {
        ...[
            {
                span: {
                    text: "Item"
                }
            },
            {
                span: {
                    text: "Item"
                }
            },
            {
                span: {
                    text: "Item"
                }
            },
            {
                span: {
                    text: "Item"
                }
            },
            {
                span: {
                    text: "Item"
                }
            },
            {
                span: {
                    text: "Item"
                }
            },
            {
                span: {
                    text: "Item"
                }
            },
            {
                span: {
                    text: "Item"
                }
            },
            {
                span: {
                    text: "Item"
                }
            },
            {
                span: {
                    text: "Item"
                }
            },
            {
                span: {
                    text: "Item"
                }
            },
            {
                span: {
                    text: "Item"
                }
            },
            {
                span: {
                    text: "Item"
                }
            }
        ]
    }
};
const $6129fe7cbc1a3e27$export$4f8543c05544ab60 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        flow: "column",
        gap: "Z2"
    },
    childExtend: {
        tag: "caption",
        extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
        props: {
            align: "center flex-start",
            lineHeight: "1em",
            fontWeight: "700",
            fontSize: "B",
            gap: "Z",
            ":before": {
                content: '""',
                boxSize: "W_default",
                background: "currentColor",
                zIndex: "20"
            }
        }
    },
    ...[
        {
            props: {
                text: "brand font"
            }
        }
    ]
};


var $c7bf60df080a0235$exports = {};

$parcel$export($c7bf60df080a0235$exports, "ListWithTitle", () => $c7bf60df080a0235$export$4ff37d595c9ddd65);
$parcel$export($c7bf60df080a0235$exports, "ListWithTitleTemplate", () => $c7bf60df080a0235$export$40693a637a08ac1c);


"use strict";
const $c7bf60df080a0235$export$4ff37d595c9ddd65 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        flow: "column",
        overflow: "hidden",
        round: "A",
        maxWidth: "F1"
    },
    Title: {
        tag: "h5",
        props: {
            position: "sticky",
            top: "0",
            zIndex: "3",
            text: "Group name",
            color: "gray .92 +68",
            fontWeight: "400",
            theme: "dialog",
            padding: "A"
        }
    },
    List: {
        extend: (0, $6129fe7cbc1a3e27$export$54c2e3dc7acea9f5),
        props: {
            round: "0",
            minWidth: "100%"
        }
    }
};
const $c7bf60df080a0235$export$40693a637a08ac1c = {
    extend: $c7bf60df080a0235$export$4ff37d595c9ddd65,
    Title: {},
    List: {
        Flex: {
            ...[
                {
                    span: {
                        text: "Item"
                    }
                },
                {
                    span: {
                        text: "Item"
                    }
                },
                {
                    span: {
                        text: "Item"
                    }
                },
                {
                    span: {
                        text: "Item"
                    }
                },
                {
                    span: {
                        text: "Item"
                    }
                }
            ]
        }
    }
};


var $4579617f0fa8bf9e$exports = {};

$parcel$export($4579617f0fa8bf9e$exports, "GroupList", () => $4579617f0fa8bf9e$export$fbb84e1f3ad193aa);
$parcel$export($4579617f0fa8bf9e$exports, "GroupListTemplate", () => $4579617f0fa8bf9e$export$68db3b1dce1e4bec);


"use strict";
const $4579617f0fa8bf9e$export$fbb84e1f3ad193aa = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        flow: "column",
        overflow: "hidden",
        theme: "dialog",
        maxHeight: "H",
        round: "A",
        maxWidth: "G"
    },
    Header: {
        extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
        props: {
            text: "Header",
            padding: "Z2 A",
            fontSize: "A2",
            fontWeight: "500"
        }
    },
    Groups: {
        props: {
            position: "relative",
            ":before, &:after": {
                content: '""',
                position: "absolute",
                boxSize: "A2 100%",
                zIndex: "2",
                left: "0",
                pointerEvents: "none"
            },
            ":before": {
                top: "0",
                background: "linear-gradient(to bottom, var(--theme-dialog-dark-background) 0%, transparent 100%)"
            },
            ":after": {
                bottom: "0",
                background: "linear-gradient(to top, var(--theme-dialog-dark-background) 0%, transparent 100%)"
            }
        },
        Flex: {
            extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
            props: {
                flow: "column",
                maxHeight: "G2",
                overflow: "auto",
                "::-webkit-scrollbar": {
                    display: "none"
                }
            },
            childExtend: {
                extend: (0, $c7bf60df080a0235$export$4ff37d595c9ddd65),
                props: {
                    round: "0",
                    minWidth: "100%",
                    overflow: "visible",
                    background: "transparent"
                },
                Title: {
                    props: {
                        theme: "transparent"
                    }
                },
                List: {
                    props: {
                        overflow: "visible",
                        theme: "transparent",
                        ":before": {
                            display: "none"
                        },
                        ":after": {
                            display: "none"
                        }
                    },
                    Flex: {
                        props: {
                            style: {
                                overflowY: "visible"
                            },
                            minHeight: "fit-content",
                            maxHeight: "fit-content",
                            childProps: {
                                ":after": {
                                    background: "gray"
                                }
                            }
                        }
                    }
                }
            }
        }
    }
};
const $4579617f0fa8bf9e$export$68db3b1dce1e4bec = {
    extend: $4579617f0fa8bf9e$export$fbb84e1f3ad193aa,
    Header: {},
    Groups: {
        props: {},
        Flex: {
            props: {},
            ...[
                {
                    Title: null,
                    List: {
                        props: {},
                        Flex: {
                            props: {},
                            ...[
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                }
                            ]
                        }
                    }
                },
                {
                    Title: {},
                    List: {
                        props: {},
                        Flex: {
                            props: {},
                            ...[
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                }
                            ]
                        }
                    }
                },
                {
                    Title: {},
                    List: {
                        props: {},
                        Flex: {
                            props: {},
                            ...[
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                }
                            ]
                        }
                    }
                }
            ]
        }
    }
};


var $1c06718eab5142ba$exports = {};

$parcel$export($1c06718eab5142ba$exports, "GroupListWithSearch", () => $1c06718eab5142ba$export$8fd62ef8d907c0bc);
$parcel$export($1c06718eab5142ba$exports, "GroupListWithSearchTemplate", () => $1c06718eab5142ba$export$acc754292a9a26ee);



"use strict";
const $1c06718eab5142ba$export$8fd62ef8d907c0bc = {
    extend: (0, $4579617f0fa8bf9e$export$fbb84e1f3ad193aa),
    props: {
        maxWidth: "G1_default"
    },
    Header: {},
    SearchContainer: {
        extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
        props: {
            padding: "0 Z1 Y2 Z1",
            background: "transparent"
        },
        Search: {
            extend: (0, $d5f256e68f92ff3f$export$4b85d3515bd863a5),
            props: {
                maxWidth: "100%",
                minWidth: "100%",
                minHeight: "C",
                theme: "transparent",
                round: "Z1"
            },
            Icon: {
                props: {
                    fontSize: "C",
                    color: "title"
                }
            },
            Input: {
                fontSize: "Z"
            }
        }
    },
    Groups: {
        Flex: {
            childExtend: {
                Title: {},
                List: {
                    Flex: {
                        childExtend: {
                            props: {}
                        }
                    }
                }
            }
        }
    }
};
const $1c06718eab5142ba$export$acc754292a9a26ee = {
    extend: $1c06718eab5142ba$export$8fd62ef8d907c0bc,
    Header: {},
    SearchContainer: {},
    Groups: {
        Flex: {
            ...[
                {
                    Title: null,
                    List: {
                        Flex: {
                            ...[
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                }
                            ]
                        }
                    }
                },
                {
                    Title: {},
                    List: {
                        Flex: {
                            ...[
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                }
                            ]
                        }
                    }
                },
                {
                    Title: {},
                    List: {
                        Flex: {
                            ...[
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                },
                                {
                                    span: {
                                        text: "Item"
                                    }
                                }
                            ]
                        }
                    }
                }
            ]
        }
    }
};


"use strict";
$parcel$exportWildcard($bfe4bf8a850bff5d$exports, $6129fe7cbc1a3e27$exports);
$parcel$exportWildcard($bfe4bf8a850bff5d$exports, $c7bf60df080a0235$exports);
$parcel$exportWildcard($bfe4bf8a850bff5d$exports, $4579617f0fa8bf9e$exports);
$parcel$exportWildcard($bfe4bf8a850bff5d$exports, $1c06718eab5142ba$exports);


var $d93ddbd64d83a6b9$exports = {};

$parcel$export($d93ddbd64d83a6b9$exports, "TimePicker", () => $d93ddbd64d83a6b9$export$5f876910ea565cd3);


var $dcb83043ba4dd622$exports = {};

$parcel$export($dcb83043ba4dd622$exports, "TimePickerItem", () => $dcb83043ba4dd622$export$c15bac1813c10cfa);

"use strict";
const $dcb83043ba4dd622$var$props = {
    align: "center center",
    flow: "column",
    gap: "X",
    "> button": {
        padding: "0",
        background: "transparent",
        fontSize: "Z",
        display: "none"
    }
};
const $dcb83043ba4dd622$export$c15bac1813c10cfa = {
    tag: "label",
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: $dcb83043ba4dd622$var$props,
    Button_plus: {
        icon: "plus"
    },
    NumberInput: {
        boxSize: "C C",
        round: "Z",
        padding: "0",
        align: "center center",
        textAlign: "center",
        min: 0,
        max: 24,
        placeholder: "00",
        appearance: "textfield",
        theme: "field",
        "::-webkit-inner-spin-button": {
            style: {
                appearance: "none"
            },
            margin: 0
        },
        "::-webkit-outer-spin-button": {
            style: {
                appearance: "none"
            },
            margin: 0
        }
    },
    Button_minus: {
        icon: "minus"
    }
};


var $c217819d479da9d8$exports = {};

$parcel$export($c217819d479da9d8$exports, "TimeSwitcher", () => $c217819d479da9d8$export$d4eea2dc8b6aadbd);


"use strict";
const $c217819d479da9d8$var$props = {
    boxSize: "C B2",
    flow: "column",
    overflow: "hidden",
    round: "Z",
    theme: "field"
};
const $c217819d479da9d8$export$d4eea2dc8b6aadbd = {
    props: $c217819d479da9d8$var$props,
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    childExtend: {
        extend: (0, $ca26469f43255c37$export$353f5b6fc5456de1),
        props: ({ state: state, key: key })=>({
                active: state.activeShift === key,
                padding: "0",
                flex: "1",
                width: "100%",
                fontSize: "Y",
                textTransform: "uppercase",
                round: "0",
                background: "transparent",
                color: "currentColor",
                lineHeight: "1",
                ".active": {
                    theme: "primary"
                }
            }),
        on: {
            click: (ev, { key: key, state: state })=>{
                state.update({
                    activeShift: key
                });
            }
        }
    },
    am: {
        text: "am"
    },
    pm: {
        text: "pm"
    }
};


"use strict";
const $d93ddbd64d83a6b9$export$5f876910ea565cd3 = {
    extend: [
        (0, $14b0ee601310f298$export$3ddf2d174ce01153),
        (0, $8184389c03ed1792$export$f51f4c4ede09e011)
    ],
    state: {
        activeShift: "am"
    },
    props: {
        flow: "column",
        width: "fit-content",
        padding: "Z2 A"
    },
    Title: {
        fontSize: "Z1",
        textTransform: "capitalize",
        padding: "- - A -",
        text: "enter time"
    },
    Flex: {
        props: {
            align: "center center",
            gap: "A"
        },
        Flex: {
            tag: "label",
            props: {
                align: "center center",
                gap: "Y2"
            },
            TimePickerItem_hh: {
                NumberInput: {
                    placeholder: "HH",
                    min: "0",
                    max: "11"
                }
            },
            Span: {
                text: ":"
            },
            TimePickerItem_mm: {
                NumberInput: {
                    placeholder: "MM",
                    min: "0",
                    max: "59"
                }
            },
            Span_2: {
                text: ":"
            },
            TimePickerItem_ss: {
                NumberInput: {
                    placeholder: "SS",
                    min: "0",
                    max: "59"
                }
            }
        },
        TimeSwitcher: {}
    },
    DialogFooter: {
        align: "center flex-end",
        gap: "X",
        margin: "Z2 -Z2 -Z",
        childProps: {
            background: "transparent",
            padding: "0",
            color: "#0079FD"
        }
    }
};
$parcel$exportWildcard($d93ddbd64d83a6b9$exports, $dcb83043ba4dd622$exports);
$parcel$exportWildcard($d93ddbd64d83a6b9$exports, $c217819d479da9d8$exports);


var $954e4cb4adbc0299$exports = {};

$parcel$export($954e4cb4adbc0299$exports, "DropdownList", () => $954e4cb4adbc0299$export$e40cc1c58d22b809);
$parcel$export($954e4cb4adbc0299$exports, "DropdownParent", () => $954e4cb4adbc0299$export$b162207c9836937);


"use strict";
const $954e4cb4adbc0299$export$e40cc1c58d22b809 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        padding: "0 Y",
        maxHeight: "G",
        flow: "column",
        theme: "quaternary",
        overflow: "hidden auto",
        style: {
            listStyleType: "none"
        }
    },
    childExtend: {
        extend: (0, $ca26469f43255c37$export$353f5b6fc5456de1),
        state: {},
        props: ({ key: key, state: state })=>({
                active: state.active === key,
                position: "relative",
                round: "0",
                align: "center flex-end",
                flow: "row-reverse",
                padding: "Z2 C Z2 Y2",
                margin: "0",
                gap: "Y2",
                theme: "quaternary .child",
                ":hover": {
                    style: {
                        svg: {
                            opacity: "0.5"
                        }
                    }
                },
                Icon: {
                    active: state.active === key,
                    name: "checkmark",
                    opacity: "0.1",
                    ".active": {
                        opacity: "1"
                    }
                },
                ":not(:first-child)": {
                    "@dark": {
                        border: "gray4 .65, solid"
                    },
                    "@light": {
                        border: "gray11, solid"
                    },
                    borderWidth: "1px 0 0"
                }
            })
    },
    $propsCollection: ({ props: props })=>props.options
};
const $954e4cb4adbc0299$export$b162207c9836937 = {
    props: {
        position: "relative",
        zIndex: 999,
        style: {
            "&:hover": {
                zIndex: 1000,
                "& [dropdown]": {
                    transform: "translate3d(0,0,0)",
                    opacity: 1,
                    visibility: "visible"
                }
            }
        }
    }
};


var $9f1f1f2471e307cd$exports = {};
var $372c98013349edc9$exports = {};

$parcel$export($372c98013349edc9$exports, "CommonForm", () => $372c98013349edc9$export$4452190d80a7d3c4);



"use strict";
const $372c98013349edc9$export$4452190d80a7d3c4 = {
    extend: (0, $1c7c00bc6cd309dd$export$2b77a92f1a5ad772),
    props: {
        gap: "B",
        boxSizing: "border-box",
        padding: "A+V A"
    },
    ModalHeader: {
        props: {
            gap: "Z"
        },
        Title: {
            Text: {},
            SquareButton_x: {
                margin: "-Y+V - - -",
                fontSize: "C"
            }
        }
    },
    Form: {
        extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
        props: {
            flow: "column",
            "> div ~ button": {
                padding: "Z2+V1 -"
            },
            "> div ~ div:last-child > button": {
                padding: "Z2+V1 B"
            },
            "> div ~ div:last-child > button:first-child": {
                padding: "Z2+V Z"
            }
        },
        Fields: {
            extend: (0, $afd03220988cb716$export$ef2184bd89960b14),
            props: {
                columnGap: "A",
                rowGap: "A1"
            },
            childExtend: {
                extend: (0, $86fa541a35e509bb$export$257a13be48b6f047),
                props: {
                    width: "100%",
                    Field: {
                        minWidth: "100%"
                    }
                }
            }
        },
        Submit: {
            props: {
                minWidth: "100%",
                margin: "C - - -"
            }
        }
    }
};


var $1d4fe7f0128f8c5f$exports = {};

$parcel$export($1d4fe7f0128f8c5f$exports, "VerificationCode", () => $1d4fe7f0128f8c5f$export$2927e323c8fd0351);



"use strict";
const $1d4fe7f0128f8c5f$export$2927e323c8fd0351 = {
    extend: (0, $372c98013349edc9$export$4452190d80a7d3c4),
    // state: { value: NUMBERS },
    Header: {
        props: {
            gap: "A"
        },
        Title: {
            caption: {
                props: {
                    text: "Verify your email"
                }
            }
        },
        Paragraph: {
            props: {
                text: "Verification code has been sent to you. Enter the code below.",
                maxWidth: "G1_default"
            }
        }
    },
    Form: {
        props: {
            "> div ~ div:last-child > button": {
                padding: "Z1+V1 B+V"
            },
            "> div ~ div:last-child > button:first-child": {
                padding: "Z1+V1 Y1"
            }
        },
        Fields: {
            props: {
                display: "flex",
                columnGap: "A",
                childProps: {
                    flex: "1",
                    fontSize: "E"
                }
            },
            childExtend: (0, $213c0d90580abffb$export$6bf0cd3a219bbade),
            ...[
                {},
                {},
                {},
                {}
            ]
        },
        ParagraphButton: {
            padding: "Z1 Z2 - Z2"
        },
        Submit: {
            extend: (0, $ca26469f43255c37$export$68fd62726e540676),
            props: {
                justifyContent: "flex-end"
            },
            ...[
                {
                    caption: {
                        props: {
                            text: "Cancel"
                        }
                    }
                },
                {
                    caption: {
                        props: {
                            text: "Verify"
                        }
                    }
                }
            ]
        }
    }
};


var $19adbe66832a7db4$exports = {};

$parcel$export($19adbe66832a7db4$exports, "ResetPassword", () => $19adbe66832a7db4$export$a4c3d56613a57187);



"use strict";
const $19adbe66832a7db4$export$a4c3d56613a57187 = {
    extend: (0, $372c98013349edc9$export$4452190d80a7d3c4),
    props: {
        minWidth: "G3+D"
    },
    ModalHeader: {
        Title: {
            caption: {
                props: {
                    text: "Choose new password"
                }
            }
        },
        Paragraph: {
            props: {
                text: "Almost done. Enter your new password and you\u2019re all set"
            }
        }
    },
    Form: {
        Fields: {
            ...[
                {
                    Title: {
                        props: {
                            text: "Old password"
                        }
                    },
                    Field: {}
                },
                {
                    Title: {
                        props: {
                            text: "New password"
                        }
                    },
                    Field: {},
                    Hint: {
                        extend: (0, $f8a17223267b0208$export$fe7c634bfc18e397),
                        props: {
                            icon: "info",
                            text: "8 character minimum"
                        }
                    }
                },
                {
                    Title: {
                        props: {
                            text: "Confirm new password"
                        }
                    },
                    Field: {},
                    Hint: {
                        extend: (0, $f8a17223267b0208$export$fe7c634bfc18e397),
                        props: {
                            icon: "info",
                            text: "8 character minimum"
                        }
                    }
                }
            ]
        },
        Submit: {
            extend: (0, $ca26469f43255c37$export$68fd62726e540676),
            props: {
                justifyContent: "flex-end"
            },
            ...[
                {
                    Text: "Cancel"
                },
                {
                    Text: "Reset password"
                }
            ]
        }
    }
};


var $98f1138c763dad2c$exports = {};

$parcel$export($98f1138c763dad2c$exports, "ContactForm", () => $98f1138c763dad2c$export$d5d8fc50aded1148);



"use strict";
const $98f1138c763dad2c$export$d5d8fc50aded1148 = {
    extend: (0, $372c98013349edc9$export$4452190d80a7d3c4),
    ModalHeader: {
        Title: {
            Text: {
                text: "We\u2019d love to help"
            }
        },
        Paragraph: {
            props: {
                text: "Reach out and we\u2019ll get in touch within 24 hours."
            }
        }
    },
    Form: {
        Fields: {
            props: {
                columns: "repeat(2, 1fr)"
            },
            ...[
                {
                    props: {
                        gridColumn: "1"
                    },
                    Title: {
                        props: {
                            text: "First name"
                        }
                    },
                    Field: {
                        Input: {
                            props: {
                                placeholder: "First name"
                            }
                        }
                    }
                },
                {
                    props: {
                        gridColumn: "2"
                    },
                    Title: {
                        props: {
                            text: "Last name"
                        }
                    },
                    Field: {
                        Input: {
                            props: {
                                placeholder: "Last name"
                            }
                        }
                    }
                },
                {
                    props: {
                        gridColumn: "1 / span 2"
                    },
                    Title: {
                        props: {
                            text: "Email"
                        }
                    },
                    Field: {
                        Input: {
                            props: {
                                placeholder: "example@email.com"
                            }
                        }
                    }
                },
                {
                    props: {
                        gridColumn: "1 / span 2"
                    },
                    Title: {
                        props: {
                            text: "Message"
                        }
                    },
                    Field: {
                        extend: (0, $dd0910b23638afad$export$301bf6213f61d17f)
                    }
                }
            ]
        },
        ParagraphButtonWithCheckbox: {
            padding: "Z1 Z - Z"
        },
        Submit: {
            extend: (0, $ca26469f43255c37$export$c48f2f65343acffb),
            text: "Send message"
        }
    }
};


var $1ba06bf2d1a50fb3$exports = {};

$parcel$export($1ba06bf2d1a50fb3$exports, "SignUp", () => $1ba06bf2d1a50fb3$export$4ee457d816cea81a);



"use strict";
const $1ba06bf2d1a50fb3$export$4ee457d816cea81a = {
    extend: (0, $372c98013349edc9$export$4452190d80a7d3c4),
    props: {
        minWidth: "H"
    },
    ModalHeader: {
        Title: {
            caption: {
                props: {
                    text: "Create your account"
                }
            }
        },
        Paragraph: {
            props: {
                text: "Let\u2019s get started with your 30 days free trial"
            }
        }
    },
    Form: {
        Fields: {
            ...[
                {
                    Title: {
                        props: {
                            text: "Full name"
                        }
                    },
                    Field: {
                        Input: {
                            props: {
                                placeholder: "Enter your full name"
                            }
                        }
                    }
                },
                {
                    Title: {
                        props: {
                            text: "Email"
                        }
                    },
                    Field: {
                        Input: {
                            props: {
                                placeholder: "Email address"
                            }
                        }
                    }
                },
                {
                    Title: {
                        props: {
                            text: "Password"
                        }
                    },
                    Field: {
                        Input: {
                            props: {
                                placeholder: "Create a password"
                            }
                        }
                    },
                    Hint: {
                        extend: (0, $f8a17223267b0208$export$fe7c634bfc18e397),
                        props: {
                            icon: "info",
                            text: "8 character minimum"
                        }
                    }
                },
                {
                    Title: {
                        props: {
                            text: "Confirm password"
                        }
                    },
                    Field: {
                        Input: {
                            props: {
                                placeholder: "Repeat password"
                            }
                        }
                    },
                    Hint: {
                        extend: (0, $f8a17223267b0208$export$fe7c634bfc18e397),
                        props: {
                            icon: "info",
                            text: "8 character minimum"
                        }
                    }
                }
            ]
        },
        ParagraphButtonWithCheckbox: {
            padding: "Z2 Z1 - Z1",
            justifyContent: "flex-end"
        },
        Submit: {
            extend: (0, $ca26469f43255c37$export$c48f2f65343acffb),
            text: "Create an account"
        }
    }
};


var $1470454842f104bb$exports = {};

$parcel$export($1470454842f104bb$exports, "LogIn", () => $1470454842f104bb$export$88195aaac9f90319);




"use strict";
const $1470454842f104bb$export$88195aaac9f90319 = {
    extend: (0, $372c98013349edc9$export$4452190d80a7d3c4),
    props: {
        minWidth: "G3+C1"
    },
    ModalHeader: {
        Title: {
            caption: {
                props: {
                    text: "Log in to your account"
                }
            }
        },
        Paragraph: {
            props: {
                text: "Enter your email address and password to log in."
            }
        }
    },
    Form: {
        props: {
            ParagraphButtonWithCheckbox: {
                margin: "A -"
            }
        },
        Fields: {
            ...[
                {
                    Title: {
                        props: {
                            text: "Email"
                        }
                    },
                    Field: {
                        Input: {
                            props: {
                                placeholder: "Enter your email"
                            }
                        }
                    }
                },
                {
                    Title: {
                        props: {
                            text: "Password"
                        }
                    },
                    Field: {
                        Icon: null,
                        Input: {
                            props: {
                                placeholder: "Enter your password"
                            }
                        },
                        Button: {
                            props: {
                                icon: "eye"
                            }
                        }
                    }
                }
            ]
        },
        ParagraphButtonWithCheckbox: {
            padding: "- Y1",
            Checkbox: {},
            ParagraphButton: {
                flex: "1",
                justifyContent: "space-between",
                P: {
                    text: "Keep me logged in"
                },
                Button: {
                    text: "Forgot your password?",
                    fontWeight: "400",
                    textDecoration: "none"
                }
            }
        },
        Submit: {
            extend: (0, $ca26469f43255c37$export$c48f2f65343acffb),
            props: {
                margin: "A - - -"
            },
            text: "Sign in"
        }
    },
    DoubleHr: {},
    ModalFooter: {
        extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
        props: {
            flow: "column",
            gap: "Z2"
        },
        childExtend: {
            extend: (0, $b0b428f1a022b7ac$export$cc8afd413c65875b),
            props: {
                minWidth: "100%",
                color: "caption"
            }
        },
        ...[
            {},
            {}
        ]
    }
};


"use strict";
$parcel$exportWildcard($9f1f1f2471e307cd$exports, $372c98013349edc9$exports);
$parcel$exportWildcard($9f1f1f2471e307cd$exports, $1d4fe7f0128f8c5f$exports);
$parcel$exportWildcard($9f1f1f2471e307cd$exports, $19adbe66832a7db4$exports);
$parcel$exportWildcard($9f1f1f2471e307cd$exports, $98f1138c763dad2c$exports);
$parcel$exportWildcard($9f1f1f2471e307cd$exports, $1ba06bf2d1a50fb3$exports);
$parcel$exportWildcard($9f1f1f2471e307cd$exports, $1470454842f104bb$exports);


var $6e069cc18a82edfb$exports = {};
var $061ed3737020da80$exports = {};

$parcel$export($061ed3737020da80$exports, "UploadImage", () => $061ed3737020da80$export$eaa555e7f7268368);
$parcel$export($061ed3737020da80$exports, "UploadIcon", () => $061ed3737020da80$export$8df90684a752ef81);

"use strict";
const $061ed3737020da80$export$eaa555e7f7268368 = {
    props: {
        padding: "A+V",
        theme: "tertiary",
        boxSize: "fit-content",
        round: "Z2"
    },
    Icon: {
        name: "upload"
    }
};
const $061ed3737020da80$export$8df90684a752ef81 = {
    extend: [
        (0, $c3656ade3a6fd1e0$export$35a3bebf7ef2d934),
        (0, $8184389c03ed1792$export$f51f4c4ede09e011)
    ],
    tag: "label",
    props: {
        position: "relative",
        theme: "tertiary",
        flow: "column",
        align: "center center",
        round: "A",
        cursor: "pointer",
        border: "1.6px, dashed, white 0.1",
        padding: "B B2"
    },
    Input: {
        props: {
            type: "file",
            position: "absolute",
            inset: "0 0 0 0",
            opacity: "0",
            visibility: "hidden"
        }
    },
    Icon: {
        props: {
            name: "upload",
            fontSize: "B",
            opacity: ".2"
        }
    },
    P: {
        props: {
            text: " or click and upload from your computer",
            flexFlow: "column",
            flexAlign: "center center",
            opacity: ".22",
            margin: "0"
        },
        Span: {
            text: "Drag and drop your font file",
            display: "block"
        }
    }
};


var $37c84bf058717c9e$exports = {};

$parcel$export($37c84bf058717c9e$exports, "UploadButton", () => $37c84bf058717c9e$export$b3fd96a52c80b3af);
$parcel$export($37c84bf058717c9e$exports, "UploadButtonWithBackground", () => $37c84bf058717c9e$export$d93e13215bb24752);

"use strict";
const $37c84bf058717c9e$export$b3fd96a52c80b3af = {
    extend: (0, $ca26469f43255c37$export$c48f2f65343acffb),
    props: {
        position: "relative",
        padding: "0",
        theme: "field @{globalTheme} .color-only",
        boxSize: "fit-content fit-content",
        cursor: "pointer"
    },
    Input: {
        type: "file",
        inset: "0 0 0 0",
        position: "absolute",
        boxSize: "100% 100%",
        top: "0",
        left: "0",
        opacity: "0",
        cursor: "pointer"
    },
    Text: "Browse files"
};
const $37c84bf058717c9e$export$d93e13215bb24752 = {
    extend: $37c84bf058717c9e$export$b3fd96a52c80b3af,
    props: {
        theme: "field",
        padding: "Z2 A1"
    },
    Text: "Browse files"
};


var $b73fb42cd78333e5$exports = {};

$parcel$export($b73fb42cd78333e5$exports, "UploadLabel", () => $b73fb42cd78333e5$export$505072ee04aa5991);
$parcel$export($b73fb42cd78333e5$exports, "UploadLabel2", () => $b73fb42cd78333e5$export$a0e211032c21de58);

"use strict";
const $b73fb42cd78333e5$export$505072ee04aa5991 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        flow: "column",
        align: "center flex-start",
        boxSize: "fit-content fit-content",
        gap: "B2",
        padding: "C D1",
        round: "A",
        border: "solid, gray2 .05",
        borderWidth: "1px",
        theme: "dialog"
    },
    Icon: {
        name: "file",
        fontSize: "D",
        theme: "field .color-only"
    },
    Hgroup: {
        props: {
            align: "center flex-start",
            gap: "Z",
            fontWeight: "400"
        },
        Title: {
            props: {
                text: "Drag & drop your files here or",
                flow: "row-reverse",
                fontWeight: "400",
                gap: "Y2",
                align: "center flex-start",
                color: "title"
            },
            UploadButton: {
                caption: {
                    fontWeight: "500"
                }
            }
        },
        Paragraph: {
            props: {
                text: "50 MB max file size",
                fontSize: "Z"
            }
        }
    }
};
const $b73fb42cd78333e5$export$a0e211032c21de58 = {
    extend: $b73fb42cd78333e5$export$505072ee04aa5991,
    props: {
        padding: "B2 E1",
        gap: "B"
    },
    Icon: {},
    Hgroup: {
        Title: {
            UploadButton: null
        }
    },
    UploadButtonWithBackground: {
        padding: "A C",
        margin: "Z - - -",
        caption: {
            fontWeight: "500"
        }
    }
};


var $ecaa8d2defd13b14$exports = {};

$parcel$export($ecaa8d2defd13b14$exports, "UploadFooter", () => $ecaa8d2defd13b14$export$f7dfe53dbb716bc9);
$parcel$export($ecaa8d2defd13b14$exports, "UploadModal", () => $ecaa8d2defd13b14$export$46267e49b219a0a9);
$parcel$export($ecaa8d2defd13b14$exports, "UploadModal2", () => $ecaa8d2defd13b14$export$b65842c4956b58f0);
$parcel$export($ecaa8d2defd13b14$exports, "UploadModal3", () => $ecaa8d2defd13b14$export$c900fbf3ee85d573);
$parcel$export($ecaa8d2defd13b14$exports, "UploadModal4", () => $ecaa8d2defd13b14$export$3a5e73785f9123f5);





"use strict";
const $ecaa8d2defd13b14$export$f7dfe53dbb716bc9 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        gap: "E",
        align: "center space-between",
        boxSize: "fit-content"
    },
    IconText: {
        extend: (0, $f8a17223267b0208$export$fe7c634bfc18e397),
        props: {
            icon: "info",
            text: "Support",
            gap: "Y",
            fontWeight: "400"
        }
    },
    Buttons: {
        extend: (0, $ca26469f43255c37$export$68fd62726e540676),
        props: {
            childProps: {
                padding: "Z2 A1",
                ":first-child": {
                    theme: "tertiary",
                    padding: "- A1"
                }
            }
        },
        ...[
            {
                Text: "Cancel"
            },
            {
                extend: (0, $37c84bf058717c9e$export$d93e13215bb24752),
                Text: "Attach file"
            }
        ]
    }
};
const $ecaa8d2defd13b14$export$46267e49b219a0a9 = {
    extend: (0, $1c7c00bc6cd309dd$export$2b77a92f1a5ad772),
    props: {
        gap: "A",
        round: "A1",
        padding: "A"
    },
    ModalHeader: {
        Title: {
            Text: {
                text: "File Upload"
            },
            SquareButton_x: {
                margin: "-V2 - - -"
            }
        },
        Paragraph: null
    },
    UploadLabel: {},
    UploadFooter: {
        props: {
            minWidth: "100%",
            margin: "-W - - -"
        },
        IconText: {
            props: {
                padding: "- Z"
            }
        },
        Buttons: {
            props: {
                gap: "Z2"
            }
        }
    }
};
const $ecaa8d2defd13b14$export$b65842c4956b58f0 = {
    extend: $ecaa8d2defd13b14$export$46267e49b219a0a9,
    ModalHeader: {},
    UploadLabel: null,
    UploadLabel2: {
        width: "100%",
        Icon: {},
        Hgroup: {},
        UploadButtonWithBackground: {
            theme: "tertiary"
        }
    }
};
const $ecaa8d2defd13b14$export$c900fbf3ee85d573 = {
    extend: $ecaa8d2defd13b14$export$b65842c4956b58f0,
    ModalHeader: {},
    UploadLabel2: {},
    UploadFooter: {
        props: {
            padding: "0"
        },
        IconText: null,
        Buttons: {
            props: {
                minWidth: "100%",
                childProps: {
                    flex: "1"
                }
            }
        }
    }
};
const $ecaa8d2defd13b14$export$3a5e73785f9123f5 = {
    extend: $ecaa8d2defd13b14$export$c900fbf3ee85d573,
    ModalHeader: {},
    UploadLabel2: {},
    UploadingProcess4: {
        minWidth: "100%"
    },
    UploadFooter: {}
};


var $436e06560fe36808$exports = {};

$parcel$export($436e06560fe36808$exports, "UploadingProcess", () => $436e06560fe36808$export$d3bde94e2efb9035);
$parcel$export($436e06560fe36808$exports, "UploadedProcess", () => $436e06560fe36808$export$d49bf085c21e643f);
$parcel$export($436e06560fe36808$exports, "UploadingProcess2", () => $436e06560fe36808$export$cec7e46fa1c18b50);
$parcel$export($436e06560fe36808$exports, "UploadedProcess2", () => $436e06560fe36808$export$e5b51bef77ac41e4);
$parcel$export($436e06560fe36808$exports, "UploadingProcess3", () => $436e06560fe36808$export$cb8aa0cad0ef2fbe);
$parcel$export($436e06560fe36808$exports, "UploadedProcess3", () => $436e06560fe36808$export$a68cdcc6f5f09a7);
$parcel$export($436e06560fe36808$exports, "UploadingProcess4", () => $436e06560fe36808$export$ee74b8d4b46a24c5);
$parcel$export($436e06560fe36808$exports, "UploadedProcess4", () => $436e06560fe36808$export$822735be3c4db181);



"use strict";
const $436e06560fe36808$export$d3bde94e2efb9035 = {
    extend: (0, $14b0ee601310f298$export$3ddf2d174ce01153),
    props: {
        boxSize: "fit-content",
        padding: "Y2 Z2 Y2 Y2",
        round: "A",
        gap: "Y2",
        position: "relative"
    },
    Image: {
        extend: (0, $061ed3737020da80$export$eaa555e7f7268368)
    },
    Flex: {
        extend: (0, $32625a13d757d0d6$export$bd5b3f7ef3b94a4a),
        props: {
            justifyContent: "space-between",
            padding: "W2 -"
        },
        Title: {
            props: {
                justifyContent: "space-between"
            },
            Text: {
                text: "Image.jpg",
                fontSize: "Z2"
            },
            SquareButton_x: {
                icon: "x",
                fontSize: "B",
                boxSize: "fit-content",
                padding: "0",
                theme: "transparent",
                margin: "- -V1 - -"
            }
        },
        Paragraph: {
            props: {
                flow: "column",
                gap: "Y2"
            },
            DoubleUnitValue: {
                fontSize: "Z2"
            },
            ProgressLine: {}
        }
    }
};
const $436e06560fe36808$export$d49bf085c21e643f = {
    extend: $436e06560fe36808$export$d3bde94e2efb9035,
    Image: {},
    Flex: {
        Title: {},
        Paragraph: {
            DoubleUnitValue: null,
            span: {
                props: {
                    text: "Done",
                    lineHeight: "1em",
                    color: "title",
                    display: "block"
                }
            },
            ProgressLine: {
                value: "1",
                style: {
                    "&::-webkit-progress-value": {
                        background: "#04F214"
                    }
                }
            }
        }
    }
};
const $436e06560fe36808$export$cec7e46fa1c18b50 = {
    extend: $436e06560fe36808$export$d3bde94e2efb9035,
    props: {
        border: "solid, gray3",
        borderWidth: "1px"
    },
    Image: {
        props: {
            padding: "Z2"
        },
        Icon: {
            fontSize: "D"
        }
    },
    Flex: {
        Title: {
            caption: {
                props: {
                    fontSize: "A1"
                }
            }
        },
        Paragraph: {
            ProgressLineWithUnitValue: {
                ProgressLine: {},
                UnitValue: {
                    fontSize: "Z1"
                }
            },
            DoubleUnitValue: null,
            ProgressLine: null
        }
    }
};
const $436e06560fe36808$export$e5b51bef77ac41e4 = {
    extend: $436e06560fe36808$export$cec7e46fa1c18b50,
    Image: {},
    Flex: {
        props: {
            margin: "- - -V2 -"
        },
        Title: {},
        Paragraph: {
            ProgressLineWithUnitValue: {
                ProgressLine: {
                    value: 1,
                    style: {
                        "&::-webkit-progress-value": {
                            background: "#04F214"
                        }
                    }
                },
                UnitValue: {
                    Value: {
                        text: "100"
                    }
                }
            }
        }
    }
};
const $436e06560fe36808$export$cb8aa0cad0ef2fbe = {
    extend: $436e06560fe36808$export$cec7e46fa1c18b50,
    props: {
        minWidth: "G+C2",
        gap: "Z"
    },
    Image: {},
    Flex: {
        props: {
            padding: "0",
            justifyContent: "center",
            gap: "Z"
        },
        Title: {
            Text: {
                fontSize: "Z2"
            },
            SquareButton_x: {
                position: "absolute",
                top: "50%",
                right: "B+W1",
                transform: "translate(50%, -50%)",
                padding: "Y",
                fontSize: "A1",
                theme: "tertiary"
            }
        },
        Paragraph: {
            ProgressLineWithUnitValue: null,
            ProgressCircleWithSideUnitValue: {}
        }
    }
};
const $436e06560fe36808$export$a68cdcc6f5f09a7 = {
    extend: $436e06560fe36808$export$cb8aa0cad0ef2fbe,
    Image: {},
    Flex: {
        Title: {},
        Paragraph: {
            ProgressCircleWithSideUnitValue: {
                ProgressCircle: {
                    Progress: {
                        value: 1,
                        style: {
                            "&::-webkit-progress-value": {
                                background: "#04F214"
                            }
                        }
                    }
                },
                UnitValue: {
                    Value: {
                        text: "Done"
                    },
                    Unit: {
                        display: "none"
                    }
                }
            }
        }
    }
};
const $436e06560fe36808$export$ee74b8d4b46a24c5 = {
    extend: $436e06560fe36808$export$cb8aa0cad0ef2fbe,
    props: {
        alignItems: "center",
        padding: "Y2 Y2 Y2 Z",
        gap: "Z1"
    },
    Image: null,
    ProgressCircleWithIcon: {
        boxSize: "C+X1",
        Icon: {
            fontSize: "C"
        }
    },
    Flex: {
        props: {
            gap: "Y1",
            padding: "W2 - - -"
        },
        Title: {},
        Paragraph: {
            tag: "p",
            props: {
                text: "Uploading . . .",
                margin: "0",
                padding: "0",
                color: "title"
            },
            ProgressCircleWithSideUnitValue: null
        }
    }
};
const $436e06560fe36808$export$822735be3c4db181 = {
    extend: $436e06560fe36808$export$ee74b8d4b46a24c5,
    ProgressCircleWithIcon: {
        ":after": {
            width: "calc(100% - 3px)",
            height: "calc(100% - 3px)"
        },
        Icon: {
            name: "check",
            color: "#04F214",
            fontSize: "E1"
        },
        Progress: {
            value: 1,
            style: {
                "&::-webkit-progress-value": {
                    background: "#04F214"
                }
            }
        }
    },
    Flex: {
        Title: {},
        Paragraph: {
            text: "Uploaded"
        }
    }
};


"use strict";
$parcel$exportWildcard($6e069cc18a82edfb$exports, $061ed3737020da80$exports);
$parcel$exportWildcard($6e069cc18a82edfb$exports, $37c84bf058717c9e$exports);
$parcel$exportWildcard($6e069cc18a82edfb$exports, $b73fb42cd78333e5$exports);
$parcel$exportWildcard($6e069cc18a82edfb$exports, $ecaa8d2defd13b14$exports);
$parcel$exportWildcard($6e069cc18a82edfb$exports, $436e06560fe36808$exports);


var $bdfe1d5bd3b47067$exports = {};
var $7c01b64d6fe504fd$exports = {};

$parcel$export($7c01b64d6fe504fd$exports, "User", () => $7c01b64d6fe504fd$export$1f44aaf2ec115b54);

"use strict";
const $7c01b64d6fe504fd$export$1f44aaf2ec115b54 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        boxSize: "fit-content",
        theme: "dialog",
        padding: "Z A Z Z",
        round: "A",
        gap: "Y1",
        align: "center flex-start"
    },
    AvatarIndicator: {
        Avatar: {
            boxSize: "C+V"
        }
    },
    Hgroup: {
        props: {
            justifyContent: "center",
            gap: "W2",
            margin: "X2 - - -"
        },
        Title: {
            props: {
                fontWeight: "500"
            }
        },
        Paragraph: {
            props: {
                fontSize: "Z1",
                alignItems: "center"
            }
        }
    }
};


var $f1342b36a388e88f$exports = {};

$parcel$export($f1342b36a388e88f$exports, "ChatUser", () => $f1342b36a388e88f$export$742dee7e484b86e3);



"use strict";
const $f1342b36a388e88f$export$742dee7e484b86e3 = {
    extend: (0, $7c01b64d6fe504fd$export$1f44aaf2ec115b54),
    props: {
        gap: "Y2"
    },
    Avatar: {},
    Notes: {
        props: {
            gap: "X1"
        },
        Title: {
            props: {
                align: "center space-between"
            },
            caption: {
                props: {
                    text: "Maria Kenter"
                }
            },
            time: {
                extend: (0, $f887848157c82147$export$d703b7d35511419c),
                props: {
                    fontSize: "Z1",
                    color: "paragraph",
                    gap: "X2"
                },
                Unit: {
                    props: {
                        text: "2:22"
                    }
                },
                Value: {
                    props: {
                        text: "AM"
                    }
                }
            }
        },
        Paragraph: {
            props: {
                gap: "C1"
            },
            p: {
                extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
                props: {
                    text: "Hey team, I\u2019ve finished the requirements document",
                    maxWidth: "F1",
                    overflow: "hidden",
                    whiteSpace: "nowrap"
                }
            },
            CountIndicator: {}
        }
    }
};


var $b9343a89d12ca1bd$exports = {};

$parcel$export($b9343a89d12ca1bd$exports, "UserButtonSet", () => $b9343a89d12ca1bd$export$2f974c3ae0bad759);
$parcel$export($b9343a89d12ca1bd$exports, "UserButtonSetCircle", () => $b9343a89d12ca1bd$export$c41b1e39f58ef596);

"use strict";
const $b9343a89d12ca1bd$export$2f974c3ae0bad759 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        boxSize: "fit-content",
        theme: "dialog",
        padding: "Z1 Z1 Z Z",
        round: "A",
        alignItems: "center",
        gap: "E"
    },
    User: {
        padding: "0",
        gap: "Y2",
        Avatar: {
            fontSize: "A"
        },
        Notes: {
            margin: "W - - -",
            gap: "X2",
            Title: {
                text: "Group"
            },
            Paragraph: {
                text: "Active now"
            }
        }
    },
    ButtonSet: {
        props: {
            gap: "Y2"
        },
        ...[
            {
                props: {
                    icon: "phone"
                }
            },
            {
                props: {
                    icon: "video"
                }
            },
            {
                props: {
                    icon: "moreHorizontal"
                }
            }
        ]
    }
};
const $b9343a89d12ca1bd$export$c41b1e39f58ef596 = {
    extend: $b9343a89d12ca1bd$export$2f974c3ae0bad759,
    User: {},
    ButtonSet: {
        childExtend: {
            props: {
                round: "100%"
            }
        }
    }
};


var $1ee0560b3704dbc9$exports = {};

$parcel$export($1ee0560b3704dbc9$exports, "UserMessage", () => $1ee0560b3704dbc9$export$46bbf1c329ce020);

"use strict";
const $1ee0560b3704dbc9$export$46bbf1c329ce020 = {
    extend: (0, $7c01b64d6fe504fd$export$1f44aaf2ec115b54),
    props: {
        gap: "Z",
        theme: "transparent"
    },
    AvatarIndicator: {},
    Hgroup: {
        props: {
            margin: "0"
        },
        Title: null,
        Paragraph: {
            props: {
                text: "Can you please review the latest design?",
                padding: "Z1 Z2",
                round: "Z2",
                theme: "dialog"
            }
        }
    }
};


var $a3d32edcf109e612$exports = {};

$parcel$export($a3d32edcf109e612$exports, "UserWithLabel", () => $a3d32edcf109e612$export$4817664f18cc7faa);


"use strict";
const $a3d32edcf109e612$export$4817664f18cc7faa = {
    extend: (0, $7c01b64d6fe504fd$export$1f44aaf2ec115b54),
    props: {
        gap: "Y2"
    },
    Avatar: {
        StatusIndicator: null,
        Avatar: {
            props: {
                boxSize: "B2+W"
            }
        }
    },
    Notes: {
        props: {
            margin: "V2 - - -"
        },
        Title: {
            props: {
                gap: "Y1",
                fontSize: "Z2"
            },
            caption: {
                props: {
                    text: "ETHDOWN"
                }
            },
            label: {
                extend: (0, $7bd759d9ddd96987$export$b04be29aa201d4f5)
            }
        },
        Paragraph: {
            tag: "p",
            props: {
                text: "Short ETH with up to 4x Leverage",
                fontSize: "Z1"
            }
        }
    }
};


var $f6d27188afd1d14c$exports = {};

$parcel$export($f6d27188afd1d14c$exports, "UserWithButton", () => $f6d27188afd1d14c$export$d467f8a0cb59b203);


"use strict";
const $f6d27188afd1d14c$export$d467f8a0cb59b203 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        boxSize: "fit-content",
        theme: "dialog",
        border: "1px, solid, gray3",
        padding: "Y Z2 Y Y",
        alignItems: "center",
        gap: "B",
        round: "A"
    },
    User: {
        extend: (0, $7c01b64d6fe504fd$export$1f44aaf2ec115b54),
        props: {
            padding: "0"
        },
        Avatar: {
            Avatar: {
                props: {
                    fontSize: "Z2",
                    round: "Z1"
                }
            },
            StatusIndicator: null
        },
        Notes: {
            props: {
                gap: "X"
            },
            Title: {
                props: {
                    text: "Wallet ID"
                }
            },
            Paragraph: {
                props: {
                    text: "0xfb59...d862"
                }
            }
        }
    },
    SquareButton: {
        background: "transparent",
        theme: null,
        color: "currentColor",
        opacity: "0.5",
        transition: "A defaultBezier",
        transitionProperty: "opacity, background",
        padding: "0",
        Icon: {
            name: "copy",
            fontSize: "C"
        }
    }
};


"use strict";
$parcel$exportWildcard($bdfe1d5bd3b47067$exports, $7c01b64d6fe504fd$exports);
$parcel$exportWildcard($bdfe1d5bd3b47067$exports, $f1342b36a388e88f$exports);
$parcel$exportWildcard($bdfe1d5bd3b47067$exports, $b9343a89d12ca1bd$exports);
$parcel$exportWildcard($bdfe1d5bd3b47067$exports, $1ee0560b3704dbc9$exports);
$parcel$exportWildcard($bdfe1d5bd3b47067$exports, $a3d32edcf109e612$exports);
$parcel$exportWildcard($bdfe1d5bd3b47067$exports, $f6d27188afd1d14c$exports);


var $f70d2005bd02a5dc$exports = {};

$parcel$export($f70d2005bd02a5dc$exports, "Banner", () => $f70d2005bd02a5dc$export$3b4e64e77073e307);

"use strict";
const $f70d2005bd02a5dc$export$3b4e64e77073e307 = {
    extend: "Hgroup",
    props: {
        height: "fit-content",
        padding: "D2+Z D+Y2 D D",
        width: "100%",
        theme: "dialog",
        align: "flex-start",
        gap: "B",
        "@mobileL": {
            padding: "C1 C"
        },
        "@mobileS": {
            padding: "C1 B"
        }
    },
    Title: {
        tag: "h1",
        props: {
            textTransform: "capitalize",
            fontSize: "L",
            fontWeight: "900",
            letterSpacing: "-0.035em",
            lineHeight: ".8em",
            gap: "0",
            "@mobileL": {
                fontSize: "J2"
            },
            "@mobileM": {
                fontSize: "J"
            },
            "@mobileS": {
                fontSize: "I"
            },
            maxWidth: "fit-content"
        }
    },
    Paragraph: {
        props: {
            flow: "column",
            justifyContent: "space-between",
            flex: "1",
            minWidth: "100%",
            position: "relative",
            gap: "A",
            "@mobileL": {
                display: "none"
            },
            // '@tabletS': { display: 'none' },
            ":before": {
                content: '""',
                position: "absolute",
                boxSize: "0.3px 100%",
                theme: "dialog",
                top: "0",
                round: "C",
                background: "white 0"
            }
        },
        P: {
            props: {
                text: "Our typography system ranges from impactful brand type used in marketing applications to functional type used in product.",
                // maxWidth: 'G2_default',
                maxWidth: "G1_default",
                lineHeight: "1.6em",
                color: "grey",
                padding: "- Z",
                "@mobileL": {
                    display: "none"
                }
            }
        },
        Flex: {
            extend: "Hgroup",
            props: {
                gap: "A2",
                alignSelf: "flex-end",
                "@mobileL": {
                    alignSelf: "flex-start",
                    padding: "- A2"
                }
            },
            Title: {
                tag: "h6",
                props: {
                    text: "What you\u2019ll find",
                    fontWeight: "400",
                    color: "grey",
                    fontSize: "Z2"
                }
            },
            Paragraph: {
                ...(0, $6129fe7cbc1a3e27$export$4f8543c05544ab60),
                ...[
                    {}
                ]
            }
        }
    }
};


var $87ee317037997b79$exports = {};

$parcel$export($87ee317037997b79$exports, "Table", () => $87ee317037997b79$export$54ec01a60f47d33d);
"use strict";
const $87ee317037997b79$export$54ec01a60f47d33d = {};


var $98c6b405bb42d461$exports = {};
var $98eb44ecb3737867$exports = {};

$parcel$export($98eb44ecb3737867$exports, "Card", () => $98eb44ecb3737867$export$60332b2344f7fe41);

"use strict";
const $98eb44ecb3737867$export$60332b2344f7fe41 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        boxSize: "fit-content",
        padding: "Z2 A",
        gap: "Z1",
        round: "Z2",
        theme: "card"
    }
};


var $33039b825a2544f7$exports = {};

$parcel$export($33039b825a2544f7$exports, "BalanceCard", () => $33039b825a2544f7$export$d2076e5299ace0ec);



"use strict";
const $33039b825a2544f7$export$d2076e5299ace0ec = {
    extend: [
        (0, $98eb44ecb3737867$export$60332b2344f7fe41),
        (0, $32625a13d757d0d6$export$bd5b3f7ef3b94a4a)
    ],
    props: {
        theme: "card .secondary",
        gap: "Z2",
        padding: "A A"
    },
    Title: {
        props: {
            justifyContent: "space-between",
            gap: "E"
        },
        caption: {
            props: {
                text: "Total crypto assets",
                fontSize: "Z2",
                fontWeight: "500"
            }
        },
        arrowBtn: {
            extend: (0, $ca26469f43255c37$export$353f5b6fc5456de1),
            props: {
                padding: "0",
                theme: "transparent",
                fontSize: "D",
                color: "caption",
                margin: "-X -W2 - -",
                Icon: {
                    name: "arrowUpRight"
                }
            }
        }
    },
    Paragraph: {
        props: {
            flow: "column",
            align: "flex-start flex-start",
            gap: "A"
        },
        UnitValueWithLabel: {
            UnitValue: {},
            UnitValue2: {
                theme: "card .secondary .child"
            }
        },
        UnitValue: {
            flow: "row-reverse",
            color: "paragraph",
            fontWeight: "400",
            fontSize: "Z",
            gap: "Y",
            Value: {
                text: "an hour ago"
            },
            Unit: {
                text: "Last update:"
            }
        }
    }
};


var $74fcd0d805acd80b$exports = {};

$parcel$export($74fcd0d805acd80b$exports, "StepCard", () => $74fcd0d805acd80b$export$25f0557f767cf1c9);

"use strict";
const $74fcd0d805acd80b$export$25f0557f767cf1c9 = {
    props: {
        boxSize: "fit-content",
        padding: "F E2+A2 G E2+A2",
        position: "relative",
        overflow: "hidden",
        round: "A2",
        backgroundColor: "#FF3CAC",
        background: "linear-gradient(225deg, #FF3CAC 0%, #784BA0 50%, #2B86C5 100%)"
    },
    Icon: {
        extend: (0, $f8a17223267b0208$export$f04a61298a47a40f),
        props: {
            icon: "dribbble",
            boxSize: "E"
        }
    },
    LineStepsWithHgroup: {
        position: "absolute",
        left: "0",
        bottom: "0",
        width: "100%",
        round: "0",
        background: "black .2"
    }
};


var $3bbc74ee3952d628$exports = {};

$parcel$export($3bbc74ee3952d628$exports, "ConvertCard", () => $3bbc74ee3952d628$export$de7984f25c7cb2b1);


"use strict";
const $3bbc74ee3952d628$export$de7984f25c7cb2b1 = {
    extend: [
        (0, $98eb44ecb3737867$export$60332b2344f7fe41),
        (0, $32625a13d757d0d6$export$bd5b3f7ef3b94a4a)
    ],
    props: {
        minWidth: "G1_default",
        theme: "dialog",
        round: "Z2",
        padding: "A Z2+V Y1 Z2+V",
        gap: "A1"
    },
    Title: {
        props: {
            justifyContent: "space-between",
            fontWeight: "400",
            color: "caption"
        },
        caption: {
            props: {
                text: "From"
            }
        },
        UnitValueWithTitle: {}
    },
    Paragraph: {
        props: {
            align: "center space-between",
            margin: "0",
            padding: "0"
        },
        value: {
            props: {
                text: "0.00",
                fontSize: "C1"
            }
        },
        DropDownButtonWithAvatar: {
            theme: "tertiary",
            margin: "- -V"
        }
    }
};


var $386272c7763df5dc$exports = {};

$parcel$export($386272c7763df5dc$exports, "CurrencyConvert", () => $386272c7763df5dc$export$ad6bf4752205be04);


"use strict";
const $386272c7763df5dc$export$ad6bf4752205be04 = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        boxSize: "fit-content",
        gap: "Z",
        padding: "Z A A A",
        flow: "column",
        theme: "dialog",
        round: "A1"
    },
    Title: {
        props: {
            text: "convert",
            textTransform: "capitalize",
            fontSize: "A2",
            padding: "- W",
            fontWeight: "500"
        }
    },
    Cards: {
        extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
        props: {
            flow: "column",
            gap: "A"
        },
        childExtend: {
            extend: (0, $3bbc74ee3952d628$export$de7984f25c7cb2b1),
            props: {
                theme: "tertiary",
                Paragraph: {
                    dropDownButton: {
                        theme: "field"
                    }
                }
            }
        },
        ...[
            {},
            {}
        ]
    },
    FlexButton: {
        minWidth: "100%",
        margin: "Z - - -",
        text: "convert",
        textTransform: "capitalize"
    }
};


"use strict";
$parcel$exportWildcard($98c6b405bb42d461$exports, $98eb44ecb3737867$exports);
$parcel$exportWildcard($98c6b405bb42d461$exports, $33039b825a2544f7$exports);
$parcel$exportWildcard($98c6b405bb42d461$exports, $74fcd0d805acd80b$exports);
$parcel$exportWildcard($98c6b405bb42d461$exports, $3bbc74ee3952d628$exports);
$parcel$exportWildcard($98c6b405bb42d461$exports, $386272c7763df5dc$exports);


"use strict";
$parcel$exportWildcard($be006f1a0fabd945$exports, $73d59c6c3fce378b$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $c95c6861d219ec8a$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $f8a17223267b0208$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $5d0d06667ca93e89$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $32625a13d757d0d6$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $f887848157c82147$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $59e9b7f5a8955db9$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $eb21f9c2ced2890e$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $8a688fbb24f94be4$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $7f02b9e3018c9249$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $c038997f2687863c$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $408dff139db483ea$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $ca26469f43255c37$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $aad64e0c8b152d2b$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $781e0e9576e3e707$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $c658bc99cb4f11e8$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $7bd759d9ddd96987$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $d0fd1386e51a3c49$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $e39e4f558cd2a095$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $5789735af6bd85de$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $f935884925ad4fcf$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $d6afc2003bbecb7e$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $0845c3d41e8b035e$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $ffecead860a69fb6$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $b0b428f1a022b7ac$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $14b0ee601310f298$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $423902791a5aa103$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $bfe4bf8a850bff5d$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $d93ddbd64d83a6b9$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $954e4cb4adbc0299$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $9f1f1f2471e307cd$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $6e069cc18a82edfb$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $bdfe1d5bd3b47067$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $f70d2005bd02a5dc$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $87ee317037997b79$exports);
$parcel$exportWildcard($be006f1a0fabd945$exports, $98c6b405bb42d461$exports);


parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
var $2a60ce89a661a6b2$exports = {};

$parcel$export($2a60ce89a661a6b2$exports, "scratchUtils", () => $75f36cb383311abc$exports);
$parcel$export($2a60ce89a661a6b2$exports, "scratchSystem", () => $30c1eb8bbbe7b5d7$exports);
$parcel$export($2a60ce89a661a6b2$exports, "set", () => $baa590feaf6cb6da$export$adaa4cf7ef1b65be);
$parcel$export($2a60ce89a661a6b2$exports, "init", () => $31242768b5023c84$export$2cd8252107eb640b);
$parcel$export($2a60ce89a661a6b2$exports, "reInit", () => $31242768b5023c84$export$4f395a2c8fcf6959);
$parcel$export($2a60ce89a661a6b2$exports, "applyCSS", () => $31242768b5023c84$export$3a26aa64e59aeaff);


var $cBUNY = parcelRequire("cBUNY");




"use strict";
$parcel$exportWildcard($2a60ce89a661a6b2$exports, $cBUNY);
$parcel$exportWildcard($2a60ce89a661a6b2$exports, $8319f99b46b296c9$exports);
$parcel$exportWildcard($2a60ce89a661a6b2$exports, $06908963bda72849$exports);
$parcel$exportWildcard($2a60ce89a661a6b2$exports, $90351548418b68d1$exports);



parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
var $jvD5p = parcelRequire("jvD5p");

"use strict";
const $4747ce2ab72764ea$var$DEFAULT_ROUTING_OPTIONS = {
    initRouter: true,
    injectRouterInLinkComponent: true,
    popState: true
};
const $4747ce2ab72764ea$export$cf7ee87ede64229c = (element, options)=>{
    if (options.router === false) return;
    else if (options.router === true) options.router = $4747ce2ab72764ea$var$DEFAULT_ROUTING_OPTIONS;
    else (0, $8wu6n.merge)(options.router || {}, $4747ce2ab72764ea$var$DEFAULT_ROUTING_OPTIONS);
    const routerOptions = options.router;
    const router = options.snippets && options.snippets.router ? options.snippets.router : (0, $90351548418b68d1$export$5375cda95f0b0eb4);
    const onRouterRenderDefault = (el, s)=>{
        const { pathname: pathname, hash: hash } = (0, $jvD5p.window).location;
        const url = pathname + hash;
        if (el.routes) router(url, el, {}, {
            initialRender: true
        });
    };
    const hasRenderRouter = element.on && !(0, $EqHTq.isUndefined)(element.on.renderRouter);
    if (routerOptions && routerOptions.initRouter && !hasRenderRouter) {
        if (element.on) element.on.renderRouter = onRouterRenderDefault;
        else element.on = {
            renderRouter: onRouterRenderDefault
        };
    }
    $4747ce2ab72764ea$export$54b760094ac80b64(routerOptions);
    return routerOptions;
};
let $4747ce2ab72764ea$var$popStateFired;
const $4747ce2ab72764ea$export$423945072aa2156 = (element, options)=>{
    if ($4747ce2ab72764ea$var$popStateFired) return;
    $4747ce2ab72764ea$var$popStateFired = true;
    const routerOptions = options.router || $4747ce2ab72764ea$var$DEFAULT_ROUTING_OPTIONS;
    if (!routerOptions.popState) return;
    const router = options.snippets && options.snippets.router ? options.snippets.router : (0, $90351548418b68d1$export$5375cda95f0b0eb4);
    (0, $jvD5p.window).onpopstate = (e)=>{
        const { pathname: pathname, hash: hash } = (0, $jvD5p.window).location;
        const url = pathname + hash;
        router(url, element, {}, {
            pushState: false,
            scrollToTop: false,
            level: 0
        });
    };
};
const $4747ce2ab72764ea$export$54b760094ac80b64 = (routerOptions)=>{
    if (routerOptions && routerOptions.injectRouterInLinkComponent) return (0, $8wu6n.deepMerge)((0, $59e9b7f5a8955db9$export$a6c7ac8248d6e38a), (0, $59e9b7f5a8955db9$export$fce709ebdac448ed));
};


parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");

var $cBUNY = parcelRequire("cBUNY");

var $aOJ2H = parcelRequire("aOJ2H");
"use strict";
const { overwriteDeep: $b7a07a87e1dff17d$var$overwriteDeep, deepDestringify: $b7a07a87e1dff17d$var$deepDestringify } = $cBUNY;
const { window: $b7a07a87e1dff17d$var$window } = $aOJ2H;
const $b7a07a87e1dff17d$var$IS_DEVELOPMENT = $b7a07a87e1dff17d$var$window && $b7a07a87e1dff17d$var$window.location ? $b7a07a87e1dff17d$var$window.location.host.includes("dev.") || $b7a07a87e1dff17d$var$window.location.host.includes("symbo.ls") : false;
const $b7a07a87e1dff17d$var$SERVER_URL = $b7a07a87e1dff17d$var$IS_DEVELOPMENT ? "http://localhost:13335/get/" : "https://api.symbols.app/get/";
const $b7a07a87e1dff17d$var$defaultOptions = {
    endpoint: $b7a07a87e1dff17d$var$SERVER_URL
};
const $b7a07a87e1dff17d$export$e7aa7bc5c1b3cfb3 = globalThis.fetch;
const $b7a07a87e1dff17d$export$db36d2f1649120da = async (key, options = $b7a07a87e1dff17d$var$defaultOptions)=>{
    const baseUrl = options.endpoint || $b7a07a87e1dff17d$var$SERVER_URL;
    const route = options.serviceRoute ? $cBUNY.isArray(options.serviceRoute) ? options.serviceRoute.map((v)=>v.toLowerCase()).join(",") : options.serviceRoute : "";
    let response;
    try {
        response = await $b7a07a87e1dff17d$export$e7aa7bc5c1b3cfb3(baseUrl + route, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "X-AppKey": key
            }
        });
        return await response.json();
    } catch (e) {
        if ($cBUNY.isFunction(options.onError)) return options.onError(e);
        else console.error(e);
    }
};
const $b7a07a87e1dff17d$export$525bc467aeb111d5 = async (key, options)=>{
    const { editor: editor } = options;
    if (editor && editor.remote) {
        const data = await $b7a07a87e1dff17d$export$db36d2f1649120da(key, editor);
        const evalData = $b7a07a87e1dff17d$var$IS_DEVELOPMENT ? $b7a07a87e1dff17d$var$deepDestringify(data) : $b7a07a87e1dff17d$var$deepDestringify(data.releases[0]);
        if (editor.serviceRoute) {
            if ($cBUNY.isArray(editor.serviceRoute)) editor.serviceRoute.forEach((route)=>{
                $b7a07a87e1dff17d$var$overwriteDeep(options[route], evalData[route.toLowerCase()]);
            });
            else $b7a07a87e1dff17d$var$overwriteDeep(options[editor.serviceRoute], evalData);
        } else [
            "state",
            "designSystem",
            "components",
            "snippets",
            "pages",
            "utils",
            "functions"
        ].forEach((key)=>{
            $b7a07a87e1dff17d$var$overwriteDeep(options[key], evalData[key.toLowerCase()]);
        });
    }
    return options;
};
const $b7a07a87e1dff17d$export$571411efd7718583 = async (key, options, callback)=>{
    const { editor: editor } = options;
    if (editor && editor.remote) {
        const data = await $b7a07a87e1dff17d$export$db36d2f1649120da(key, editor);
        const evalData = $b7a07a87e1dff17d$var$IS_DEVELOPMENT ? $b7a07a87e1dff17d$var$deepDestringify(data) : $b7a07a87e1dff17d$var$deepDestringify(data.releases[0]);
        callback(evalData);
    }
};


"use strict";
const $5e586daec44b56de$export$8946d631417d8ced = async (key, options)=>{
    if (key && options.editor) try {
        if (!options.editor.async) await (0, $b7a07a87e1dff17d$export$525bc467aeb111d5)(key, options);
    } catch (e) {
        console.error(e);
    }
};
const $5e586daec44b56de$export$beca342e15b450be = (app, key, options, callback)=>{
    if (key && options.editor) try {
        const defaultCallback = (data)=>{
            if ((0, $EqHTq.isObject)(data.designsystem)) options.utils.init(data.designsystem);
            if ((0, $EqHTq.isObject)(data.state)) app.state.set(data.state);
        };
        if (options.editor.async) (0, $b7a07a87e1dff17d$export$571411efd7718583)(key, options, callback || defaultCallback);
    } catch (e) {
        console.error(e);
    }
};






var $cVSYW = parcelRequire("cVSYW");


var $aOJ2H = parcelRequire("aOJ2H");
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");

parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");

var $cVSYW = parcelRequire("cVSYW");
"use strict";
const $7b205a167d538434$export$bf8485336ba6654d = {
    props: {
        ".preventSelect": {
            userSelect: "none"
        }
    },
    focus: {
        state: {},
        props: (el, s)=>({
                position: "fixed",
                hide: !s.area || !s.parent.debugging
            }),
        class: {
            inset: (el, state)=>{
                const { area: area } = state;
                if (!area) return;
                const { x: x, y: y, width: width, height: height } = area;
                return {
                    top: y - 6 + "px",
                    left: x - 6 + "px",
                    width: width + 12 + "px",
                    height: height + 12 + "px"
                };
            }
        },
        style: {
            boxShadow: "0 0 10px #3686F733, 0 0 0 3px #3686F766, 0 0 100vmax 100vmax #000A",
            zIndex: "9999999",
            borderRadius: "10px",
            pointerEvents: "none"
        },
        span: {
            props: {
                position: "absolute",
                margin: "A2 0",
                fontSize: "Z",
                color: "text",
                // color: 'blue',
                zIndex: "99999999",
                textDecoration: "underline",
                fontWeight: "500",
                top: "100%"
            },
            style: {
                boxShadow: "0 25px 10px 35px black",
                textShadow: "0 0 10px black"
            },
            text: (el, s)=>s.focusKey
        },
        on: {
            init: ({ context: context })=>{
                const { components: components } = context;
                if ((0, $EqHTq.isObject)(components)) {
                    const { Content: Content, ...rest } = components;
                    for(const key in rest){
                        if ($be006f1a0fabd945$exports[key]) continue;
                        if (!rest[key].__ref) rest[key].__ref = {};
                        if (!rest[key].__ref.__componentKey) rest[key].__ref.__componentKey = key;
                    }
                }
            }
        }
    },
    on: {
        mousemove: (ev, e, state)=>{
            const el = ev.target.ref;
            const component = $7b205a167d538434$var$findComponent(el);
            if (!component || !state.debugging || !component.__ref) return;
            const focusState = e.focus.state;
            const updateValue = (area)=>{
                focusState.update({
                    area: area,
                    focusKey: component.__ref.__componentKey
                });
            };
            const update = ()=>{
                if (ev.altKey && ev.shiftKey) {
                    const { x: x, y: y, width: width, height: height } = component.node.getBoundingClientRect();
                    const area = {
                        x: x,
                        y: y,
                        width: width,
                        height: height
                    };
                    if (!focusState.area) return updateValue(area);
                    if (focusState.area.x !== area.x) updateValue(area);
                } else if (focusState.area) focusState.update({
                    area: false
                });
            };
            window.requestAnimationFrame(()=>{
                update();
                window.requestAnimationFrame(update);
            });
        },
        click: (ev, elem, state)=>{
            const el = ev.target.ref;
            const component = $7b205a167d538434$var$findComponent(el);
            if (!component || !component.__ref.__componentKey || !state.debugging) return;
            (0, $cVSYW.send)("route", `/export/${component.__ref.__componentKey}`);
            return false;
        }
    }
};
function $7b205a167d538434$var$findComponent(el) {
    if (!el || !el.__ref) return;
    if (el.__ref.__componentKey) return el;
    return $7b205a167d538434$var$findComponent(el.parent);
}
const $7b205a167d538434$export$db4eced57a06882d = (app)=>{
    window.onkeydown = (ev)=>{
        if (ev.altKey && ev.shiftKey) app.state.update({
            debugging: true,
            preventSelect: true
        }, {
            preventContentUpdate: true,
            preventRecursive: true
        });
    };
    window.onkeyup = (ev)=>{
        if ((!ev.altKey || !ev.shiftKey) && app.state.debugging) {
            app.focus.state.update({
                area: false
            });
            app.state.update({
                debugging: false,
                preventSelect: false
            }, {
                preventContentUpdate: true,
                preventRecursive: true,
                preventPropsUpdate: true
            });
        }
    };
};


"use strict";
const $18c650c6b9aa2424$var$isLocalhost = (0, $aOJ2H.window) && (0, $aOJ2H.window).location && (0, $aOJ2H.window).location.host.includes("local");
const $18c650c6b9aa2424$var$ANIMATION = {
    fadeInUp: {
        from: {
            transform: "translate3d(0, 12.5%, 1px)",
            opacity: 0
        },
        to: {
            transform: "translate3d(0, 0, 1px)",
            opacity: 1
        }
    },
    fadeOutDown: {
        from: {
            transform: "translate3d(0, 0, 1px)",
            opacity: 1
        },
        to: {
            transform: "translate3d(0, 12.5%, 1px)",
            opacity: 0
        }
    }
};
const $18c650c6b9aa2424$var$COLOR = {
    black: "#000000",
    blue: "#3686F7"
};
// set({
//   COLOR,
//   ANIMATION
// })
const $18c650c6b9aa2424$var$connectedToSymbols = (clients, element, state)=>{
    if (clients.symbols) {
        if (!state.connected) {
            state.notifications.connected = {
                title: "Connected",
                message: "to the Symbols live server"
            };
            state.update({
                connected: true
            });
            const t = setTimeout(()=>{
                delete state.notifications.connected;
                element.notifications.content.connected.setProps({
                    animation: "fadeOutDown"
                });
                state.update({
                    connected: true
                });
                clearTimeout(t);
            }, 3000);
        }
    } else if (state.connected) {
        state.notifications.connected = {
            title: "Disconnected",
            message: "from the Symbols live server",
            type: "error"
        };
        state.update({
            connected: false
        });
        const t = setTimeout(()=>{
            delete state.notifications.connected;
            element.notifications.content.connected.setProps({
                animation: "fadeOutDown"
            });
            state.update({
                connected: true
            });
            clearTimeout(t);
        }, 3000);
    }
};
const $18c650c6b9aa2424$var$onConnect = (element, state)=>{
    return (socketId, socket)=>{
    // send('components', { COMPONENTS: a(COMPONENTS) })
    };
};
const $18c650c6b9aa2424$var$onDisconnect = (element, state)=>{
    return ()=>{};
};
const $18c650c6b9aa2424$var$onChange = (el, s, ctx)=>{
    return (event, data)=>{
        if (event === "change") {
            const obj = JSON.parse(data);
            const { state: state, designSystem: designSystem, pages: pages, components: components, snippets: snippets } = obj.DATA;
            const { utils: utils } = ctx;
            if (pages) // overwriteShallow(ctx.pages, pages)
            (0, $8wu6n.overwriteDeep)(ctx.pages, pages);
            if (components) (0, $8wu6n.overwriteDeep)(ctx.components, components);
            if (snippets) (0, $8wu6n.overwriteDeep)(ctx.snippets, snippets);
            if (state) {
                const route = state.route;
                if (route) (utils.router || (0, $90351548418b68d1$export$5375cda95f0b0eb4))(route.replace("/state", "") || "/", el, {});
                else if (!(snippets && components && pages)) s.update(state);
            }
            if (snippets || components || pages) (utils.router || (0, $90351548418b68d1$export$5375cda95f0b0eb4))((0, $aOJ2H.window).location.pathname, el, {});
            if (designSystem) (0, $31242768b5023c84$export$2cd8252107eb640b)(designSystem);
        }
        if (event === "clients") $18c650c6b9aa2424$var$connectedToSymbols(data, el, s);
    };
};
const $18c650c6b9aa2424$var$NOTIF_COLORS = {
    success: "green",
    error: "red",
    warning: "yellow"
};
const $18c650c6b9aa2424$var$Notifications = {
    props: {
        position: "fixed",
        left: "A2",
        bottom: "Z2",
        zIndex: "999"
    },
    childExtend: {
        extend: [
            (0, $e39e4f558cd2a095$export$14834abbfce3b8cd)
        ],
        props: ({ state: state })=>({
                animation: "fadeInUp",
                animationDuration: "C",
                background: $18c650c6b9aa2424$var$NOTIF_COLORS[state.type || "success"],
                icon: null,
                article: {
                    Flex: {
                        Title: {
                            text: state.title
                        },
                        P: {
                            text: state.message
                        }
                    }
                }
            }),
        on: {
            click: (e, el)=>el.setProps({
                    animation: "fadeOutDown"
                })
        }
    },
    $stateCollection: ({ state: state })=>state.notifications
};
const $18c650c6b9aa2424$export$2ae15352e0a80063 = {
    notifications: $18c650c6b9aa2424$var$Notifications,
    state: {
        notifications: {}
    },
    on: {
        render: (el, s, ctx)=>{
            (0, $cVSYW.connect)(ctx.key, {
                source: $18c650c6b9aa2424$var$isLocalhost ? "localhost" : "client",
                socketUrl: $18c650c6b9aa2424$var$isLocalhost ? "localhost:13336" : "socket.symbols.app",
                location: (0, $aOJ2H.window).location.host,
                onConnect: $18c650c6b9aa2424$var$onConnect(el, s, ctx),
                onDisconnect: $18c650c6b9aa2424$var$onDisconnect(el, s, ctx),
                onChange: $18c650c6b9aa2424$var$onChange(el, s, ctx)
            });
        }
    }
};


parcelRequire("cBUNY");
var $jOLBF = parcelRequire("jOLBF");
var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $5b6a3972014f3e94$export$ca717cfcb724fd64 = (extend, options)=>{
    const { editor: editor } = options;
    if (!editor) return extend;
    const inspect = (0, $EqHTq.isUndefined)(editor.inspect) ? (0, $jOLBF.isDevelopment)() : editor.inspect;
    if (inspect) extend.push((0, $7b205a167d538434$export$bf8485336ba6654d));
    const liveSync = (0, $EqHTq.isUndefined)(editor.liveSync) ? (0, $jOLBF.isDevelopment)() : editor.liveSync;
    if (liveSync) extend.push((0, $18c650c6b9aa2424$export$2ae15352e0a80063));
    return extend;
};
const $5b6a3972014f3e94$export$a0eecf521ca4df6c = (root, options)=>{
    const { editor: editor } = options;
    if (!editor) return;
    const inspect = (0, $EqHTq.isUndefined)(editor.inspect) ? (0, $jOLBF.isDevelopment)() : editor.inspect;
    if (inspect) (0, $7b205a167d538434$export$db4eced57a06882d)(root);
};



"use strict";
const $596256ead72518a6$export$6588fc50c67b09a2 = {
    routes: (param)=>param,
    // deps: (param, el) => param || el.parent.deps,
    $router: (param, el)=>{
        if (!param) return;
        const obj = {
            tag: "fragment",
            ...param
        };
        const set = ()=>{
            el.set(obj, {
                preventDefineUpdate: "$router"
            });
        };
        if (el.props && el.props.lazyLoad) window.requestAnimationFrame(set);
        else set();
        return obj;
    },
    $collection: (0, $c17872c3358c86eb$export$fb8073518f34e6ec).define.$collection,
    $setCollection: (0, $c17872c3358c86eb$export$fb8073518f34e6ec).define.$setCollection,
    $stateCollection: (0, $c17872c3358c86eb$export$fb8073518f34e6ec).define.$stateCollection,
    $propsCollection: (0, $c17872c3358c86eb$export$fb8073518f34e6ec).define.$propsCollection
};


"use strict";
const $d5fc17b4ecb94b3e$export$882cd4124a942c79 = {
    useReset: true,
    useVariable: true,
    useIconSprite: true,
    useSvgSprite: true,
    useDocumentTheme: true,
    useFontImport: true,
    useDefaultConfig: true
};
const $d5fc17b4ecb94b3e$export$7f202753e6a32b2b = {
    defaultConfig: true,
    state: {},
    pages: {},
    components: {},
    router: {
        initRouter: true,
        popState: true,
        injectRouterInLinkComponent: true
    },
    define: (0, $596256ead72518a6$export$6588fc50c67b09a2)
};
var $d5fc17b4ecb94b3e$export$2e2bcd8739ae039 = $d5fc17b4ecb94b3e$export$7f202753e6a32b2b;



parcelRequire("cBUNY");
var $jvD5p = parcelRequire("jvD5p");

"use strict";
const $80563b8eaf6ba844$export$fbea82a1c0574ef4 = {
    key: ":root",
    node: (0, $jvD5p.document) ? (0, $jvD5p.document).body : (0, $06908963bda72849$export$f18d5b0af29128b7)("DocumentNotDefined", (0, $jvD5p.document))
};
const $80563b8eaf6ba844$export$33ecaa422889cd80 = $80563b8eaf6ba844$export$fbea82a1c0574ef4;


parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");

"use strict";
const $8af08dc9e7559b54$export$270e7ba5936d3c48 = (element)=>{};




parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
var $glQML = parcelRequire("glQML");
"use strict";
const $01ef634a92434650$var$cache = {};
const $01ef634a92434650$export$39fdcd81e0c5d80b = (element)=>{
    const { tag: tag } = element;
    if (tag) {
        if (tag === "string") return document.createTextNode(element.text);
        else if (tag === "fragment") return document.createDocumentFragment();
        else if (tag === "svg" || tag === "path") return document.createElementNS("http://www.w3.org/2000/svg", tag);
        else return document.createElement(tag) // TODO: allow strict mode to check validity
        ;
    } else return document.createElement("div");
};
const $01ef634a92434650$export$5075bd4eae016d2c = (element)=>{
    let { tag: tag, key: key, props: props } = element;
    tag = (0, $8wu6n.exec)(tag, element);
    if (tag === true) tag = key;
    if ((0, $EqHTq.isObject)(props) && (0, $EqHTq.isString)(props.tag)) {
        const tagExists = (0, $glQML.isValidHtmlTag)(props.tag);
        if (tagExists) return props.tag;
    }
    if ((0, $EqHTq.isString)(tag)) {
        if ((0, $glQML.isValidHtmlTag)(tag)) return tag;
    } else {
        let keyAsTag = key.toLowerCase();
        if (keyAsTag.includes(".")) keyAsTag = keyAsTag.split(".")[0];
        if (keyAsTag.includes("_")) keyAsTag = keyAsTag.split("_")[0];
        if ((0, $glQML.isValidHtmlTag)(keyAsTag)) return keyAsTag;
    }
    return "div";
};
const $01ef634a92434650$export$257247f9c0329159 = (element)=>{
    const tag = element.tag = $01ef634a92434650$export$5075bd4eae016d2c(element);
    if (!(0, $a7c2803c7e7b293f$export$342a7615681b7118)(tag)) return (0, $06908963bda72849$export$f18d5b0af29128b7)("HTMLInvalidTag", element.tag, element);
    let cachedTag = $01ef634a92434650$var$cache[tag];
    if (!cachedTag) cachedTag = $01ef634a92434650$var$cache[tag] = $01ef634a92434650$export$39fdcd81e0c5d80b(element);
    const clonedNode = cachedTag.cloneNode(true);
    if (tag === "string") clonedNode.nodeValue = element.text;
    return clonedNode;
};


"use strict";
const $98807bf18bc93fb3$export$13970129ca912f06 = (node, parentNode)=>{
    parentNode.appendChild(node);
    return node;
};
const $98807bf18bc93fb3$export$9c63b8d16fa708c5 = (node, siblingNode, parentNode)=>{
    const parent = parentNode || siblingNode.parentNode;
    if (siblingNode.nextSibling) parent && parent.insertBefore(node, siblingNode.nextSibling);
    else siblingNode && siblingNode.insertAdjacentElement("afterend", node);
};
const $98807bf18bc93fb3$export$3a727f1d0007fe49 = (node, siblingNode, parentNode)=>{
    const parent = parentNode || siblingNode.parentNode;
    parent && parent.insertBefore(node, siblingNode);
};
const $98807bf18bc93fb3$export$4f2a718cb234b42f = (element, parent, key, attachOptions)=>{
    parent[key || element.key] = element;
    if (element.tag !== "shadow") {
        if (attachOptions && attachOptions.position) (attachOptions.position === "before" ? $98807bf18bc93fb3$export$3a727f1d0007fe49 : $98807bf18bc93fb3$export$9c63b8d16fa708c5)(element.node, attachOptions.node || parent.node);
        else $98807bf18bc93fb3$export$13970129ca912f06(element.node, parent.node);
    }
    return element;
};


"use strict";


parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
var $jOLBF = parcelRequire("jOLBF");

parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");

"use strict";
var /**
 * Recursively add attributes to a DOM node
 */ $781ba30c522cf3e7$export$2e2bcd8739ae039 = (params, element, node)=>{
    const { __ref: __ref } = element;
    const { __attr: __attr } = __ref;
    if ((0, $EqHTq.isNot)("object")) (0, $06908963bda72849$export$f18d5b0af29128b7)("HTMLInvalidAttr", params);
    if (params) for(const attr in params){
        const val = (0, $8wu6n.exec)(params[attr], element);
        // if (__attr[attr] === val) return
        if (val && node.setAttribute) node.setAttribute(attr, val);
        else if (node.removeAttribute) node.removeAttribute(attr);
        __attr[attr] = val;
    }
    console.groupEnd(params, __attr);
};


parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $6a43953e96d89b45$export$d559e9a3b71405f6 = (element)=>{
    const { key: key } = element;
    if (element.class === true) element.class = key;
    else if (!element.class && typeof key === "string" && key.charAt(0) === "_" && key.charAt(1) !== "_") element.class = key.slice(1);
};
const $6a43953e96d89b45$export$b04d9b8d414ba5e8 = (obj, element)=>{
    let className = "";
    for(const item in obj){
        const param = obj[item];
        if (typeof param === "boolean" && param) className += ` ${item}`;
        else if (typeof param === "string") className += ` ${param}`;
        else if (typeof param === "function") className += ` ${(0, $8wu6n.exec)(param, element)}`;
    }
    return className;
};
const $6a43953e96d89b45$export$11c615ce16f87241 = (params, element)=>{
    if (!params) return;
    const { key: key } = element;
    if (params === true) params = element.class = {
        key: key
    };
    if ((0, $EqHTq.isString)(params)) params = element.class = {
        default: params
    };
    if ((0, $EqHTq.isObject)(params)) params = $6a43953e96d89b45$export$b04d9b8d414ba5e8(params, element);
    // TODO: fails on string
    const className = params.replace(/\s+/g, " ").trim();
    if (element.ref) element.ref.class = className // TODO: this check is NOT needed in new DOMQL
    ;
    return className;
};
const $6a43953e96d89b45$export$e8f750c9f10c0a7b = (params, element, node)=>{
    const className = $6a43953e96d89b45$export$11c615ce16f87241(params, element);
    node.classList = className;
    return className;
};
var $6a43953e96d89b45$export$2e2bcd8739ae039 = (params, element, node)=>{
    $6a43953e96d89b45$export$e8f750c9f10c0a7b(params, element, node);
};


parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");

"use strict";
var $ad3d3b247d47f3a2$export$2e2bcd8739ae039 = {};




"use strict";
const $bf937aebc888d68f$var$set = function(params, options = {}, el) {
    const element = el || this;
    const { __ref: ref, content: content } = element;
    const __contentRef = content && content.__ref;
    const lazyLoad = element.props && element.props.lazyLoad;
    const hasCollection = element.$collection || element.$stateCollection || element.$propsCollection;
    if (options.preventContentUpdate === true && !hasCollection) return;
    if (ref.__noCollectionDifference || __contentRef && __contentRef.__cached && (0, $8wu6n.deepContains)(params, content)) return content.update();
    const setAsync = ()=>{
        (0, $0a7669919424e35c$export$6e1d9b0d0e1e1def)(element);
        (0, $947d5c063e68e91c$export$2e2bcd8739ae039)(params, element, options.newElementKey || "content", {
            ignoreChildExtend: true,
            ...(0, $782cf63e523d0885$export$2e2bcd8739ae039).defaultOptions,
            ...(0, $ad3d3b247d47f3a2$export$2e2bcd8739ae039).create,
            ...options
        });
    };
    if (params) {
        const { childExtend: childExtend } = params;
        if (!childExtend && element.childExtend) params.childExtend = element.childExtend;
        if (lazyLoad) window.requestAnimationFrame(setAsync);
        else setAsync();
    }
    return element;
};
var $bf937aebc888d68f$export$2e2bcd8739ae039 = $bf937aebc888d68f$var$set;


"use strict";
const $0a7669919424e35c$export$5143cc956eb9d8f6 = function(params, options) {
    const element = this;
    if (!element.content) return;
    if (element.content.update) element.content.update(params, options);
};
const $0a7669919424e35c$export$6e1d9b0d0e1e1def = function(el) {
    const element = el || this;
    const { __ref: __ref } = element;
    if (element.content) {
        if (element.content.node) {
            if (element.content.tag === "fragment") element.node.innerHTML = "";
            else element.node.removeChild(element.content.node);
        }
        const { __cached: __cached } = __ref;
        if (__cached && __cached.content) {
            if (__cached.content.tag === "fragment") __cached.content.parent.node.innerHTML = "";
            else if (__cached.content && (0, $EqHTq.isFunction)(__cached.content.remove)) __cached.content.remove();
        }
        delete element.content;
    }
};
const $0a7669919424e35c$export$431313f2afd011e2 = (param, element, node, options)=>{
    if (param && element) {
        if (element.content.update) element.content.update({}, options);
        else (0, $bf937aebc888d68f$export$2e2bcd8739ae039).call(element, param, options);
    }
};
var $0a7669919424e35c$export$2e2bcd8739ae039 = $0a7669919424e35c$export$431313f2afd011e2;


parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");

"use strict";
var /**
 * Apply data parameters on the DOM nodes
 * this should only work if `showOnNode: true` is passed
 */ $e4aeb17327021212$export$2e2bcd8739ae039 = (params, element, node)=>{
    if (params && params.showOnNode) {
        if (!(0, $EqHTq.isObject)(params)) (0, $06908963bda72849$export$f18d5b0af29128b7)("HTMLInvalidData", params);
        // Apply data params on node
        for(const dataset in params)if (dataset !== "showOnNode") node.dataset[dataset] = (0, $8wu6n.exec)(params[dataset], element);
    }
};


parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
"use strict";
var /**
 * Appends raw HTML as content
 * an original one as a child
 */ $1591488d379f80a7$export$2e2bcd8739ae039 = (param, element, node)=>{
    const prop = (0, $8wu6n.exec)(param, element);
    const { __ref: __ref } = element;
    if (prop !== __ref.__html) {
        // const parser = new window.DOMParser()
        // param = parser.parseFromString(param, 'text/html')
        if (node.nodeName === "SVG") node.textContent = prop;
        else node.innerHTML = prop;
        __ref.__html = prop;
    }
};


parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
var $8wu6n = parcelRequire("8wu6n");

"use strict";
var /**
 * Recursively add styles to a DOM node
 */ $479abf9e8c0e6739$export$2e2bcd8739ae039 = (params, element, node)=>{
    if (params) {
        if ((0, $EqHTq.isObject)(params)) (0, $8wu6n.map)(node.style, params, element);
        else (0, $06908963bda72849$export$f18d5b0af29128b7)("HTMLInvalidStyles", params);
    }
};



parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
var $5WrxC = parcelRequire("5WrxC");
"use strict";
var /**
 * Creates a text node and appends into
 * an original one as a child
 */ $19f4b3c5f241581d$export$2e2bcd8739ae039 = (param, element, node)=>{
    let prop = (0, $8wu6n.exec)(param, element);
    if ((0, $EqHTq.isString)(prop) && prop.includes("{{")) prop = (0, $5WrxC.replaceLiteralsWithObjectFields)(prop, element.state);
    if (element.tag === "string") node.nodeValue = prop;
    else if (param !== undefined || param !== null) {
        if (element.__text) {
            if (element.__text.text === prop) return;
            element.__text.text = prop;
            if (element.__text.node) element.__text.node.nodeValue = prop;
        } else (0, $947d5c063e68e91c$export$2e2bcd8739ae039)({
            tag: "string",
            text: prop
        }, element, "__text");
    }
};



parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $4a610b4ab9f6f506$export$ca000e230c0caa3e = (params, element, node)=>{
    const state = (0, $8wu6n.exec)(params, element);
    if ((0, $EqHTq.isObject)(state)) for(const param in state){
        if ((0, $bfb47641e396194b$export$5100524046ce8de6).includes(param)) continue;
        if (!Object.hasOwnProperty.call(state, param)) continue;
    // element.state[param] = exec(state[param], element)
    }
    return element;
};
var $4a610b4ab9f6f506$export$2e2bcd8739ae039 = $4a610b4ab9f6f506$export$ca000e230c0caa3e;


parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
"use strict";
var /**
 * Apply data parameters on the DOM nodes
 * this should only work if `showOnNode: true` is passed
 */ $d1bc0a58271a837c$export$2e2bcd8739ae039 = (params, element, node)=>{
    if (!(0, $EqHTq.isObject)(params)) return;
    // Apply data params on node
    for(const scopeItem in params){
        const value = params[scopeItem];
        if ((0, $EqHTq.isFunction)(value)) element.scope[scopeItem] = value.bind(element);
        else element.scope[scopeItem] = value;
    }
};



"use strict";
var $782cf63e523d0885$export$2e2bcd8739ae039 = {
    attr: $781ba30c522cf3e7$export$2e2bcd8739ae039,
    style: $479abf9e8c0e6739$export$2e2bcd8739ae039,
    text: $19f4b3c5f241581d$export$2e2bcd8739ae039,
    html: $1591488d379f80a7$export$2e2bcd8739ae039,
    content: $0a7669919424e35c$export$2e2bcd8739ae039,
    data: $e4aeb17327021212$export$2e2bcd8739ae039,
    class: (0, $6a43953e96d89b45$export$2e2bcd8739ae039),
    state: $4a610b4ab9f6f506$export$2e2bcd8739ae039,
    scope: $d1bc0a58271a837c$export$2e2bcd8739ae039,
    deps: (param, el)=>param || el.parent.deps,
    extend: {},
    childExtend: {},
    childExtendRecursive: {},
    props: {},
    path: {},
    if: {},
    define: {},
    transform: {},
    __name: {},
    __ref: {},
    __hash: {},
    __text: {},
    nextElement: {},
    previousElement: {},
    key: {},
    tag: {},
    query: {},
    parent: {},
    node: {},
    set: {},
    update: {},
    setProps: {},
    remove: {},
    updateContent: {},
    removeContent: {},
    lookup: {},
    spotByPath: {},
    keys: {},
    log: {},
    parse: {},
    parseDeep: {},
    on: {},
    component: {},
    context: {},
    $collection: {},
    $stateCollection: {},
    $propsCollection: {},
    $setCollection: {},
    $setStateCollection: {},
    $setPropsCollection: {}
};
const $782cf63e523d0885$export$2f387f690230eab4 = {
    elementKeys: [
        "tag",
        "text",
        "style",
        "attr",
        "class",
        "state",
        "props",
        "data",
        "content",
        "html",
        "on",
        "key"
    ],
    propsKeys: [
        "__element",
        "update"
    ],
    stateKeys: []
};


"use strict";


"use strict";
const $d61abc47c39ce5ac$export$cec27f102c074405 = function(path) {
    const element = this;
    const arr = [].concat(path);
    let active = (0, $80563b8eaf6ba844$export$33ecaa422889cd80)[arr[0]];
    if (!arr || !arr.length) return console.log(arr, "on", element.key, "is undefined");
    while(active.key === arr[0]){
        arr.shift();
        if (!arr.length) break;
        active = active[arr[0]];
        if (!active) return;
    }
    return active;
};
const $d61abc47c39ce5ac$export$dfc7155ac0343b8 = function(key) {
    const element = this;
    let { parent: parent } = element;
    while(parent.key !== key){
        if (parent[key]) return parent[key];
        parent = parent.parent;
        if (!parent) return;
    }
    return parent;
};
const $d61abc47c39ce5ac$export$cd7f480d6b8286c3 = function(params) {
    const element = this;
    if ((0, $EqHTq.isFunction)(element.node.remove)) element.node.remove();
    else if (!(0, $jOLBF.isProduction)()) {
        console.warn("This item cant be removed");
        element.log();
    }
    delete element.parent[element.key];
};
const $d61abc47c39ce5ac$export$3988ae62b71be9a3 = function(param) {
    const element = this;
    return element[param];
};
const $d61abc47c39ce5ac$export$938ca3893886de06 = function(param, options) {
    const element = this;
    if (!param || !element.props) return;
    element.update({
        props: param
    }, options);
    return element;
};
const $d61abc47c39ce5ac$export$a98d858bb785d7b9 = (element, key, get, set)=>Object.defineProperty(element, key, {
        get: get,
        set: set
    });
const $d61abc47c39ce5ac$export$ed97f33186d4b816 = function() {
    const element = this;
    const keys = [];
    for(const param in element){
        if ((0, $782cf63e523d0885$export$2e2bcd8739ae039)[param] && !(0, $782cf63e523d0885$export$2f387f690230eab4).elementKeys.includes(param)) continue;
        keys.push(param);
    }
    return keys;
};
const $d61abc47c39ce5ac$export$98e6a39c04603d36 = function(excl = []) {
    const element = this;
    const obj = {};
    const keyList = $d61abc47c39ce5ac$export$ed97f33186d4b816.call(element);
    keyList.forEach((v)=>{
        if (excl.includes(v)) return;
        let val = element[v];
        if (v === "state") {
            if (element.__ref && element.__ref.__hasRootState) return;
            if ((0, $EqHTq.isFunction)(val && val.parse)) val = val.parse();
        } else if (v === "props") {
            const { __element: __element, update: update, ...props } = element[v];
            obj[v] = props;
        } else if ((0, $EqHTq.isDefined)(val)) obj[v] = val;
    });
    return obj;
};
const $d61abc47c39ce5ac$export$3ed0fe0c6a5387e2 = function(excl = []) {
    const element = this;
    const obj = $d61abc47c39ce5ac$export$98e6a39c04603d36.call(element, excl);
    for(const v in obj){
        if (excl.includes(v)) return;
        if ((0, $EqHTq.isObjectLike)(obj[v])) obj[v] = $d61abc47c39ce5ac$export$3ed0fe0c6a5387e2.call(obj[v], excl);
    }
    return obj;
};
const $d61abc47c39ce5ac$export$bef1f36f5486a6a3 = function(...args) {
    const element = this;
    const { __ref: __ref } = element;
    console.group(element.key);
    if (args.length) args.forEach((v)=>console.log(`%c${v}:\n`, "font-weight: bold", element[v]));
    else {
        console.log(__ref.path);
        const keys = element.keys();
        keys.forEach((v)=>console.log(`%c${v}:\n`, "font-weight: bold", element[v]));
    }
    console.groupEnd(element.key);
    return element;
};
const $d61abc47c39ce5ac$export$e87a5caa96444a37 = function() {
    const element = this;
    const { key: key, parent: parent } = element;
    const { __children: __children } = parent.__ref;
    const currentIndex = __children.indexOf(key);
    const nextChild = __children[currentIndex + 1];
    return parent[nextChild];
};
const $d61abc47c39ce5ac$export$1facc1d780a4d839 = function(el) {
    const element = el || this;
    const { key: key, parent: parent } = element;
    const { __children: __children } = parent.__ref;
    if (!__children) return;
    const currentIndex = __children.indexOf(key);
    return parent[__children[currentIndex - 1]];
};
const $d61abc47c39ce5ac$export$f0748ddc99f937c7 = [
    "set",
    "update",
    "remove",
    "updateContent",
    "removeContent",
    "lookup",
    "spotByPath",
    "keys",
    "parse",
    "setProps",
    "parseDeep",
    "if",
    "log",
    "nextElement",
    "previousElement"
];
const $d61abc47c39ce5ac$export$ed2133acb96eb5aa = function(param) {
    return $d61abc47c39ce5ac$export$f0748ddc99f937c7.includes(param);
};



parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
var $hSU9O = parcelRequire("hSU9O");

"use strict";
const $c6321d44fd66ade0$export$431871e52735632b = [
    "update",
    "__element"
];


parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");

parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $045c563bb4b0b2eb$var$objectizeStringProperty = (propValue)=>{
    if ((0, $EqHTq.is)(propValue)("string", "number")) return {
        inheritedString: propValue
    };
    return propValue;
};
const $045c563bb4b0b2eb$export$d25057a75c14aff7 = (element, parent)=>{
    let propsStack = [];
    const parentProps = (0, $8wu6n.exec)(parent, parent.state).props;
    const matchParent = parent.props && parentProps[element.key];
    const matchParentIsString = (0, $EqHTq.isString)(matchParent);
    const matchParentChildProps = parentProps && parentProps.childProps;
    if (matchParent) {
        if (matchParentIsString) {
            const inheritedStringExists = propsStack.filter((v)=>v.inheritedString)[0];
            if (inheritedStringExists) inheritedStringExists.inheritedString = matchParent;
            else propsStack = [].concat($045c563bb4b0b2eb$var$objectizeStringProperty(matchParent), propsStack);
        } else propsStack.push($045c563bb4b0b2eb$var$objectizeStringProperty(matchParent));
    }
    if (matchParentChildProps) propsStack.push(matchParentChildProps);
    return propsStack;
};


"use strict";
const $e818f1ed291a38e8$var$createPropsStack = (element, parent)=>{
    const { props: props, __ref: __ref } = element;
    const propsStack = __ref.__props = (0, $045c563bb4b0b2eb$export$d25057a75c14aff7)(element, parent);
    if ((0, $EqHTq.isObject)(props)) propsStack.push(props);
    else if (props === "inherit" && parent.props) propsStack.push(parent.props);
    else if (props) propsStack.push(props);
    if ((0, $EqHTq.isArray)(__ref.__extend)) __ref.__extend.forEach((extend)=>{
        if (extend.props && extend.props !== props) propsStack.push(extend.props);
    });
    __ref.__props = propsStack;
    return propsStack;
};
const $e818f1ed291a38e8$export$b23ca50362483f82 = (props, element)=>{
    element.props = {};
    const mergedProps = {};
    props.forEach((v)=>{
        if ((0, $c6321d44fd66ade0$export$431871e52735632b).includes(v)) return;
        const execProps = (0, $8wu6n.exec)(v, element);
        // TODO: check if this failing the function props merge
        // if (isObject(execProps) && execProps.__element) return
        // it was causing infinite loop at early days
        element.props = (0, $8wu6n.deepMerge)(mergedProps, (0, $8wu6n.deepClone)(execProps, (0, $c6321d44fd66ade0$export$431871e52735632b)), (0, $c6321d44fd66ade0$export$431871e52735632b));
    });
    element.props = mergedProps;
    const methods = {
        update: $e818f1ed291a38e8$var$update.bind(element.props),
        __element: element
    };
    Object.setPrototypeOf(element.props, methods);
    return element.props;
};
const $e818f1ed291a38e8$export$c94ea207b45fef3a = function(element, parent, cached) {
    const { __ref: ref } = element;
    // if (element.parent.key === '0' && element.key === 'editor') {
    //   debugger
    // }
    const applyProps = ()=>{
        const propsStack = cached || $e818f1ed291a38e8$var$createPropsStack(element, parent);
        if (propsStack.length) {
            ref.__props = propsStack;
            $e818f1ed291a38e8$export$b23ca50362483f82(propsStack, element);
        } else {
            ref.__props = cached || [];
            element.props = {};
        }
    };
    if (ref.__if) applyProps();
    else try {
        applyProps();
    } catch  {
        element.props = {};
        ref.__props = cached || [];
    }
    const methods = {
        update: $e818f1ed291a38e8$var$update.bind(element.props),
        __element: element
    };
    Object.setPrototypeOf(element.props, methods);
    return element;
};
function $e818f1ed291a38e8$var$update(props, options) {
    const element = this.__element;
    element.update({
        props: props
    }, options);
}





"use strict";
const $902e7fcbfa0a2596$export$c8dce3c08436e91e = (newProps, element, parent)=>{
    const { __ref: __ref } = element;
    let propsStack = __ref.__props;
    const parentProps = (0, $045c563bb4b0b2eb$export$d25057a75c14aff7)(element, parent);
    if (parentProps.length) propsStack = __ref.__props = [].concat(parentProps, propsStack);
    if (newProps) propsStack = __ref.__props = [].concat(newProps, propsStack);
    if (propsStack) (0, $e818f1ed291a38e8$export$b23ca50362483f82)(propsStack, element);
    return element;
};


"use strict";



"use strict";
const $9dbe2fe74e93fc61$export$7f0c3d30e5984c9d = (0, $hSU9O.joinArrays)([
    "node",
    "state",
    "context",
    "extend"
], (0, $d61abc47c39ce5ac$export$f0748ddc99f937c7), (0, $bfb47641e396194b$export$5100524046ce8de6), (0, $c6321d44fd66ade0$export$431871e52735632b));
const $9dbe2fe74e93fc61$export$6969335ea1e4e77c = (element, extend, exclude = $9dbe2fe74e93fc61$export$7f0c3d30e5984c9d)=>{
    for(const e in extend){
        if (exclude.includes(e)) continue;
        const elementProp = element[e];
        const extendProp = extend[e];
        if (elementProp === undefined) element[e] = extendProp;
        else if ((0, $EqHTq.isObjectLike)(elementProp) && (0, $EqHTq.isObject)(extendProp)) $9dbe2fe74e93fc61$export$6969335ea1e4e77c(elementProp, extendProp);
    }
    return element;
};
const $9dbe2fe74e93fc61$export$9cd59f9826255e47 = (obj, exclude = $9dbe2fe74e93fc61$export$7f0c3d30e5984c9d)=>{
    const o = {};
    for(const e in obj){
        if (exclude.includes(e)) continue;
        o[e] = obj[e];
    }
    return o;
};
const $9dbe2fe74e93fc61$export$b7d58db314e0ac27 = (obj, exclude = $9dbe2fe74e93fc61$export$7f0c3d30e5984c9d)=>{
    const o = (0, $EqHTq.isArray)(obj) ? [] : {};
    for(const e in obj){
        if (exclude.includes(e)) continue;
        let objProp = obj[e];
        if (e === "extend" && (0, $EqHTq.isArray)(objProp)) objProp = $9dbe2fe74e93fc61$export$fd2fbaf2367ef824(objProp, exclude);
        if ((0, $EqHTq.isObjectLike)(objProp)) o[e] = $9dbe2fe74e93fc61$export$b7d58db314e0ac27(objProp, exclude);
        else o[e] = objProp;
    }
    return o;
};
const $9dbe2fe74e93fc61$export$d3305692eb3e9a81 = (element, params, options)=>{
    const changes = {};
    const { __ref: __ref } = element;
    const { __exec: __exec, __cached: __cached } = __ref;
    for(const e in params){
        if (e === "props" || e === "state" || e === "__ref") continue;
        const elementProp = element[e];
        const paramsProp = params[e];
        if (paramsProp !== undefined) {
            __cached[e] = changes[e] = elementProp;
            element[e] = paramsProp;
        }
        if (options.cleanExec) delete __exec[e];
    }
    return changes;
};
const $9dbe2fe74e93fc61$export$1c07155dfdd98f41 = (obj, params, exclude = $9dbe2fe74e93fc61$export$7f0c3d30e5984c9d)=>{
    for(const e in params){
        if (exclude.includes(e)) continue;
        obj[e] = params[e];
    }
    return obj;
};
const $9dbe2fe74e93fc61$export$f0b277b530b4fffd = (obj, params, exclude = $9dbe2fe74e93fc61$export$7f0c3d30e5984c9d)=>{
    for(const e in params){
        if (exclude.includes(e)) continue;
        const objProp = obj[e];
        const paramsProp = params[e];
        if ((0, $EqHTq.isObjectLike)(objProp) && (0, $EqHTq.isObjectLike)(paramsProp)) $9dbe2fe74e93fc61$export$f0b277b530b4fffd(objProp, paramsProp);
        else if (paramsProp !== undefined) obj[e] = paramsProp;
    }
    return obj;
};
const $9dbe2fe74e93fc61$export$7bde6dffa6d2dd59 = (a, b)=>{
    if ((0, $EqHTq.isObjectLike)(a) && (0, $EqHTq.isObjectLike)(b)) return $9dbe2fe74e93fc61$export$6969335ea1e4e77c(a, b);
    return a || b;
};
const $9dbe2fe74e93fc61$export$fd2fbaf2367ef824 = (arr, exclude = [
    "parent",
    "node",
    "__element",
    "state",
    "context",
    "__ref"
])=>{
    return arr.reduce((a, c)=>$9dbe2fe74e93fc61$export$6969335ea1e4e77c(a, $9dbe2fe74e93fc61$export$b7d58db314e0ac27(c, exclude)), {});
};
const $9dbe2fe74e93fc61$export$803a4c6bdde5cd1d = (obj)=>{
    return (0, $EqHTq.isArray)(obj) ? $9dbe2fe74e93fc61$export$fd2fbaf2367ef824(obj) : $9dbe2fe74e93fc61$export$b7d58db314e0ac27(obj);
};
const $9dbe2fe74e93fc61$export$d53c2c5b09d0676f = (param, prop, stack = [])=>{
    const objectized = $9dbe2fe74e93fc61$export$803a4c6bdde5cd1d(param);
    stack.push(objectized);
    const extendOfExtend = objectized[prop];
    if (extendOfExtend) $9dbe2fe74e93fc61$export$d53c2c5b09d0676f(extendOfExtend, prop, stack);
    delete objectized[prop];
    return stack;
};


parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $ce326eb5cdcc3ce9$var$ENV = "production";
const $ce326eb5cdcc3ce9$export$daf4c137c5f56404 = ()=>Math.random().toString(36).substring(2);
const $ce326eb5cdcc3ce9$export$476cb8ab9adcdb0d = {};
const $ce326eb5cdcc3ce9$export$bc442b6cc8c83971 = {};
const $ce326eb5cdcc3ce9$export$46ce3405574370c6 = (extend)=>{
    return $ce326eb5cdcc3ce9$export$476cb8ab9adcdb0d[extend.__hash];
};
const $ce326eb5cdcc3ce9$export$8c8f2806a2edf07f = (extend, stack)=>{
    const hash = $ce326eb5cdcc3ce9$export$daf4c137c5f56404();
    if (!(0, $EqHTq.isString)(extend)) extend.__hash = hash;
    $ce326eb5cdcc3ce9$export$476cb8ab9adcdb0d[hash] = stack;
    return stack;
};
const $ce326eb5cdcc3ce9$export$6ef9dd655b57622a = (extend, stack)=>{
    if (extend.__hash) return stack.concat($ce326eb5cdcc3ce9$export$46ce3405574370c6(extend));
    return $ce326eb5cdcc3ce9$export$8c8f2806a2edf07f(extend, stack) // stack .concat(hashedExtend)
    ;
};
const $ce326eb5cdcc3ce9$export$2c118161a655606a = (extend, stack, context)=>{
    extend.forEach((each)=>$ce326eb5cdcc3ce9$export$802e3e1ed5ecb3f2(each, stack, context));
    return stack;
};
const $ce326eb5cdcc3ce9$export$54e9fb29908872fa = (extend, stack, context)=>{
    const extendOflattenExtend = extend.extend;
    if (extendOflattenExtend) $ce326eb5cdcc3ce9$export$802e3e1ed5ecb3f2(extendOflattenExtend, stack, context);
    return stack;
};
const $ce326eb5cdcc3ce9$export$802e3e1ed5ecb3f2 = (extend, stack, context)=>{
    if (!extend) return stack;
    if ((0, $EqHTq.isArray)(extend)) return $ce326eb5cdcc3ce9$export$2c118161a655606a(extend, stack, context);
    if ((0, $EqHTq.isString)(extend)) extend = $ce326eb5cdcc3ce9$export$ade1aefc7d5ec315(extend, context);
    stack.push(extend);
    if (extend.extend) $ce326eb5cdcc3ce9$export$54e9fb29908872fa(extend, stack, context);
    return stack;
};
const $ce326eb5cdcc3ce9$export$16fb354ab895483c = (obj)=>{
    const o = {};
    for(const prop in obj){
        if ([
            "parent",
            "node",
            "__element"
        ].indexOf(prop) > -1) continue;
        const objProp = obj[prop];
        if ((0, $EqHTq.isObject)(objProp)) o[prop] = $ce326eb5cdcc3ce9$export$16fb354ab895483c(objProp);
        else if ((0, $EqHTq.isArray)(objProp)) o[prop] = objProp.map((x)=>x);
        else o[prop] = objProp;
    }
    return o;
};
const $ce326eb5cdcc3ce9$export$d20ceec222df68ed = (element, extend)=>{
    for(const e in extend){
        if ([
            "parent",
            "node",
            "__element"
        ].indexOf(e) > -1) continue;
        const elementProp = element[e];
        const extendProp = extend[e];
        if (elementProp === undefined) element[e] = extendProp;
        else if ((0, $EqHTq.isObject)(elementProp) && (0, $EqHTq.isObject)(extendProp)) $ce326eb5cdcc3ce9$export$d20ceec222df68ed(elementProp, extendProp);
        else if ((0, $EqHTq.isArray)(elementProp) && (0, $EqHTq.isArray)(extendProp)) element[e] = elementProp.concat(extendProp);
        else if ((0, $EqHTq.isArray)(elementProp) && (0, $EqHTq.isObject)(extendProp)) {
            const obj = $ce326eb5cdcc3ce9$export$d20ceec222df68ed({}, elementProp);
            element[e] = $ce326eb5cdcc3ce9$export$d20ceec222df68ed(obj, extendProp);
        } else if (elementProp === undefined && (0, $EqHTq.isFunction)(extendProp)) element[e] = extendProp;
    }
    return element;
};
const $ce326eb5cdcc3ce9$export$e2e460d82983fb19 = (stack)=>{
    return stack.reduce((a, c)=>{
        return $ce326eb5cdcc3ce9$export$d20ceec222df68ed(a, $ce326eb5cdcc3ce9$export$16fb354ab895483c(c));
    }, {});
};
const $ce326eb5cdcc3ce9$export$ade1aefc7d5ec315 = (extend, context, options = {})=>{
    const COMPONENTS = context && context.components || options.components;
    if ((0, $EqHTq.isString)(extend)) {
        const componentExists = COMPONENTS[extend] || COMPONENTS["smbls." + extend];
        if (COMPONENTS && componentExists) return componentExists;
        else {
            if (options.verbose && ($ce326eb5cdcc3ce9$var$ENV === "test" || $ce326eb5cdcc3ce9$var$ENV === "development")) console.warn("Extend is string but component was not found:", extend);
            return {};
        }
    }
    return extend;
};
const $ce326eb5cdcc3ce9$export$f9f936cf352c3af2 = (extendStack, childExtendStack)=>{
    return [].concat(extendStack.slice(0, 1)).concat(childExtendStack.slice(0, 1)).concat(extendStack.slice(1)).concat(childExtendStack.slice(1));
};
const $ce326eb5cdcc3ce9$export$a0203ee23029af7e = (extend, context)=>{
    if (!extend) return [];
    if (extend.__hash) return $ce326eb5cdcc3ce9$export$46ce3405574370c6(extend) || [];
    const stack = $ce326eb5cdcc3ce9$export$802e3e1ed5ecb3f2(extend, [], context);
    return $ce326eb5cdcc3ce9$export$6ef9dd655b57622a(extend, stack);
};
const $ce326eb5cdcc3ce9$export$52f1fe7126b651a = (extend)=>{
    const stack = $ce326eb5cdcc3ce9$export$a0203ee23029af7e(extend);
    return $ce326eb5cdcc3ce9$export$e2e460d82983fb19(stack);
} // export const replaceStringsWithComponents = (stack, context, options) => {
 //   const COMPONENTS = (context && context.components) || options.components
 //   return stack.map(v => {
 //     if (isString(v)) {
 //       const component = COMPONENTS[v]
 //       return component
 //     }
 //     if (isString(v.extend)) {
 //       v.extend = getExtendMerged(COMPONENTS[v.extend])
 //     }
 //     return v
 //   })
 // }
;


parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
var $hSU9O = parcelRequire("hSU9O");
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");

"use strict";
const $3bff1c984b824aeb$var$ENV = "production";
let $3bff1c984b824aeb$var$mainExtend;
const $3bff1c984b824aeb$export$f20941eae6723bcc = (element, parent, options = {})=>{
    if ((0, $EqHTq.isFunction)(element)) element = (0, $8wu6n.exec)(element, parent);
    let { extend: extend, props: props, context: context, __ref: __ref } = element;
    extend = (0, $ce326eb5cdcc3ce9$export$ade1aefc7d5ec315)(extend, context, options);
    const extendStack = (0, $ce326eb5cdcc3ce9$export$a0203ee23029af7e)(extend, context);
    if ($3bff1c984b824aeb$var$ENV !== "test" || $3bff1c984b824aeb$var$ENV !== "development") delete element.extend;
    let childExtendStack = [];
    if (parent) {
        element.parent = parent;
        // Assign parent attr to the element
        if (!options.ignoreChildExtend && !(props && props.ignoreChildExtend)) {
            childExtendStack = (0, $ce326eb5cdcc3ce9$export$a0203ee23029af7e)(parent.childExtend, context);
            const ignoreChildExtendRecursive = props && props.ignoreChildExtendRecursive;
            if (parent.childExtendRecursive && !ignoreChildExtendRecursive) {
                const canExtendRecursive = element.key !== "__text";
                if (canExtendRecursive) {
                    const childExtendRecursiveStack = (0, $ce326eb5cdcc3ce9$export$a0203ee23029af7e)(parent.childExtendRecursive, context);
                    // add error if childExtendRecursive contains element which goes to infinite loop
                    childExtendStack = childExtendStack.concat(childExtendRecursiveStack);
                    element.childExtendRecursive = parent.childExtendRecursive;
                }
            }
        }
    }
    const extendLength = extendStack.length;
    const childExtendLength = childExtendStack.length;
    let stack = [];
    if (extendLength && childExtendLength) stack = (0, $ce326eb5cdcc3ce9$export$f9f936cf352c3af2)(extendStack, childExtendStack);
    else if (extendLength) stack = extendStack;
    else if (childExtendLength) stack = childExtendStack;
    else if (!options.extend) return element;
    if (options.extend) {
        if (!$3bff1c984b824aeb$var$mainExtend) {
            const defaultOptionsExtend = (0, $ce326eb5cdcc3ce9$export$a0203ee23029af7e)(options.extend, context);
            $3bff1c984b824aeb$var$mainExtend = (0, $ce326eb5cdcc3ce9$export$e2e460d82983fb19)(defaultOptionsExtend);
            delete $3bff1c984b824aeb$var$mainExtend.extend;
        }
        stack = [].concat(stack, $3bff1c984b824aeb$var$mainExtend);
    }
    // check if array contains string extends
    if (__ref) __ref.__extend = stack;
    let mergedExtend = (0, $ce326eb5cdcc3ce9$export$e2e460d82983fb19)(stack);
    // apply `component:` property
    const COMPONENTS = context && context.components || options.components;
    const component = (0, $8wu6n.exec)(element.component || mergedExtend.component, element);
    if (component && COMPONENTS && COMPONENTS[component]) {
        const componentExtend = (0, $ce326eb5cdcc3ce9$export$e2e460d82983fb19)((0, $ce326eb5cdcc3ce9$export$a0203ee23029af7e)(COMPONENTS[component]));
        mergedExtend = (0, $ce326eb5cdcc3ce9$export$d20ceec222df68ed)(componentExtend, mergedExtend);
    }
    const merged = (0, $ce326eb5cdcc3ce9$export$d20ceec222df68ed)(element, mergedExtend);
    return merged;
};


"use strict";
const $a6bfc6202982ac85$var$ENV = "production";
const $a6bfc6202982ac85$var$DOMQL_BUILTINS = [
    "extend",
    "childExtend",
    "childExtendRecursive",
    "define",
    "props",
    "state",
    "on",
    "if",
    "attr",
    "key",
    "tag"
];
const $a6bfc6202982ac85$export$b791484194c5fc38 = (key)=>{
    const isFirstKeyString = (0, $EqHTq.isString)(key);
    if (!isFirstKeyString) return;
    const firstCharKey = key.slice(0, 1);
    return /^[A-Z]*$/.test(firstCharKey);
};
const $a6bfc6202982ac85$export$69dfe88127d1d0de = (key)=>{
    const isFirstKeyString = (0, $EqHTq.isString)(key);
    if (!isFirstKeyString) return;
    const firstCharKey = key.slice(0, 1);
    return /^[a-z]*$/.test(firstCharKey);
};
const $a6bfc6202982ac85$export$356ecc5e07374be5 = (newExtend, element)=>{
    const { extend: elementExtend } = element;
    const originalArray = (0, $EqHTq.isArray)(elementExtend) ? elementExtend : [
        elementExtend
    ];
    const receivedArray = (0, $EqHTq.isArray)(newExtend) ? newExtend : [
        newExtend
    ];
    const extend = (0, $hSU9O.joinArrays)(receivedArray, originalArray);
    return {
        ...element,
        extend: extend
    };
};
const $a6bfc6202982ac85$var$replaceOnKeys = (key)=>key.replace(/on\w+/g, (match)=>match.substring(2));
const $a6bfc6202982ac85$export$2cbc234431a4ef8 = (el, parent, key, options)=>{
    const newElem = {
        props: {},
        on: {}
    };
    for(const k in el){
        const prop = el[k];
        const isEvent = prop.startsWith("on");
        const isMethod = prop.startsWith("$");
        if (isEvent) {
            const onKey = $a6bfc6202982ac85$var$replaceOnKeys(prop);
            newElem.on[onKey] = prop;
        } else if (!isMethod && $a6bfc6202982ac85$export$69dfe88127d1d0de(k)) {
            if (!$a6bfc6202982ac85$var$DOMQL_BUILTINS.includes(k)) newElem.props[k] = prop;
        } else if ($a6bfc6202982ac85$export$b791484194c5fc38(k)) newElem[k] = prop;
        else newElem[k] = prop;
    }
    return newElem;
};
const $a6bfc6202982ac85$export$c786485ace8eb69b = (element, parent, key)=>{
    const { context: context, tag: tag, extend: extend, props: props, attr: attr, state: state, childExtend: childExtend, childProps: childProps, on: on, if: condition } = element;
    const hasComponentAttrs = extend || childExtend || props || state || on || condition || attr;
    const extendFromKey = key.includes("+") ? key.split("+") // get array of componentKeys
     : key.includes("_") ? key.split("_")[0] // get component key split _
     : key.includes(".") ? key.split(".")[0] // get component key split .
     : [
        key
    ];
    const isExtendKeyComponent = context && context.components[extendFromKey];
    if (element === isExtendKeyComponent) return element;
    else if (!hasComponentAttrs || childProps) return {
        extend: extendFromKey,
        tag: tag,
        props: {
            ...element
        }
    };
    else if (!extend || extend === true) return {
        ...element,
        tag: tag,
        extend: extendFromKey
    };
    else if (extend) return $a6bfc6202982ac85$export$356ecc5e07374be5(extendFromKey, element);
    else if ((0, $EqHTq.isFunction)(element)) return {
        extend: extendFromKey,
        tag: tag,
        props: {
            ...(0, $8wu6n.exec)(element, parent)
        }
    };
};
const $a6bfc6202982ac85$export$2279e5e6b0817ddc = (element, parent, key)=>{
    return $a6bfc6202982ac85$export$c786485ace8eb69b(element, parent, key) || element;
};
const $a6bfc6202982ac85$export$fd6b2f481ffc7974 = (element, parent, options)=>{
    const { context: context } = element;
    if (!context || !context.components) return;
    const { components: components } = context;
    const { extend: extend } = element;
    const execExtend = (0, $8wu6n.exec)(extend, element);
    if ((0, $EqHTq.isString)(execExtend)) {
        const componentExists = components[execExtend] || components["smbls." + execExtend];
        if (componentExists) element.extend = componentExists;
        else {
            if (($a6bfc6202982ac85$var$ENV === "test" || $a6bfc6202982ac85$var$ENV === "development") && options.verbose) {
                console.warn(execExtend, "is not in library", components, element);
                console.warn("replacing with ", {});
            }
            element.extend = {};
        }
    }
};
const $a6bfc6202982ac85$export$53cd1a145c393044 = (param)=>{
    if (!(0, $EqHTq.isString)(param)) return;
    const firstCharKey = param.slice(0, 1);
    // return (firstCharKey === '.' || firstCharKey === '$')
    return firstCharKey === ".";
};
const $a6bfc6202982ac85$export$c66af1c05bf7bb06 = (element)=>{
    const { props: props } = element;
    if ((0, $EqHTq.isObject)(props) && (0, $EqHTq.isString)(props.variant)) return true;
};
const $a6bfc6202982ac85$export$a9aa73f3ae416cbd = (element, variant, variantProps)=>{
    let variantElement = element[variant];
    if (!variantElement) return;
    const props = (0, $EqHTq.isObject)(variantProps) ? variantProps : {};
    if ((0, $EqHTq.isString)(variantElement)) variantElement = {
        extend: [
            {
                props: props
            },
            variantElement
        ]
    };
    else if (variantElement.extend) variantElement = $a6bfc6202982ac85$export$356ecc5e07374be5({
        props: props
    }, variantElement);
    return (0, $8wu6n.overwriteDeep)(element, (0, $3bff1c984b824aeb$export$f20941eae6723bcc)(variantElement)) // TODO: check why string is not working
    ;
};
const $a6bfc6202982ac85$export$f1439fc936ef702f = (element)=>{
    const { props: props } = element;
    if (!$a6bfc6202982ac85$export$c66af1c05bf7bb06(element)) return element;
    const { variant: variant } = props;
    $a6bfc6202982ac85$export$a9aa73f3ae416cbd(element, `.${variant}`);
    const elKeys = Object.keys(element).filter((key)=>$a6bfc6202982ac85$export$53cd1a145c393044(key));
    elKeys.forEach((variant)=>{
        const slicedVariantElementKey = variant.slice(1);
        const variantElementProps = props[slicedVariantElementKey];
        if (variantElementProps) $a6bfc6202982ac85$export$a9aa73f3ae416cbd(element, variant, variantElementProps);
    });
    return element;
};


"use strict";



"use strict";
const $0513b3ed7d5404ec$export$3223a9877c540db8 = (element, exclude = {})=>{
    const { __ref: ref } = element;
    for(const param in element){
        if (exclude[param]) continue;
        const prop = element[param];
        if ((0, $EqHTq.isFunction)(prop) && !(0, $d61abc47c39ce5ac$export$ed2133acb96eb5aa)(param) && !(0, $a6bfc6202982ac85$export$53cd1a145c393044)(param)) {
            ref.__exec[param] = prop;
            element[param] = prop(element, element.state);
        // if (isComponent)
        }
    }
};
const $0513b3ed7d5404ec$export$2ad800d85590910f = (element, options = {
    excludes: (0, $9dbe2fe74e93fc61$export$7f0c3d30e5984c9d)
})=>{
    const { __ref: ref } = element;
    const changes = {};
    for(const param in ref.__exec){
        const prop = element[param];
        const isDefinedParam = ref.__defineCache[param];
        if (isDefinedParam) continue;
        const newExec = ref.__exec[param](element, element.state, element.context);
        const execReturnsString = (0, $EqHTq.isString)(newExec) || (0, $EqHTq.isNumber)(newExec);
        // if (prop && prop.node && execReturnsString) {
        if (prop && prop.node && execReturnsString) (0, $9dbe2fe74e93fc61$export$d3305692eb3e9a81)(prop, {
            text: newExec
        }, options);
        else if (newExec !== prop) {
            if ((0, $a6bfc6202982ac85$export$b791484194c5fc38)(param)) {
                const { extend: extend, ...newElem } = (0, $a6bfc6202982ac85$export$c786485ace8eb69b)(newExec, element, param);
                (0, $9dbe2fe74e93fc61$export$d3305692eb3e9a81)(prop, newElem, options);
            // } else {
            //   overwrite(prop, newExec, options)
            } else {
                ref.__cached[param] = changes[param] = prop;
                element[param] = newExec;
            }
        }
    }
    return changes;
};
const $0513b3ed7d5404ec$export$b4c781127351659b = (element)=>{
    const { define: define, context: context, __ref: ref } = element;
    let defineObj = {};
    const hasGlobalDefine = context && (0, $EqHTq.isObject)(context.define);
    if ((0, $EqHTq.isObject)(define)) defineObj = {
        ...define
    };
    if (hasGlobalDefine) defineObj = {
        ...defineObj,
        ...context.define
    };
    for(const param in defineObj){
        let elementProp = element[param];
        if ((0, $EqHTq.isFunction)(elementProp) && !(0, $d61abc47c39ce5ac$export$ed2133acb96eb5aa)(param) && !(0, $a6bfc6202982ac85$export$53cd1a145c393044)(param)) {
            ref.__exec[param] = elementProp;
            const execParam = elementProp = (0, $8wu6n.exec)(elementProp, element);
            if (execParam) {
                elementProp = element[param] = execParam.parse ? execParam.parse() : execParam;
                ref.__defineCache[param] = elementProp;
            }
        }
        const execParam = defineObj[param](elementProp, element, element.state, element.context);
        if (execParam) element[param] = execParam;
    }
    return element;
};
const $0513b3ed7d5404ec$export$88eda8a7eb5c5eff = (element)=>{
    const { context: context, define: define, __ref: ref } = element;
    const changes = {};
    let obj = {};
    if ((0, $EqHTq.isObject)(define)) obj = {
        ...define
    };
    if ((0, $EqHTq.isObject)(context && context.define)) obj = {
        ...obj,
        ...context.define
    };
    for(const param in obj){
        const execParam = ref.__exec[param];
        if (execParam) ref.__defineCache[param] = execParam(element, element.state, element.context);
        const cached = (0, $8wu6n.exec)(ref.__defineCache[param], element);
        const newExecParam = obj[param](cached, element, element.state, element.context);
        if (newExecParam) element[param] = newExecParam;
    }
    return changes;
};



parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");

"use strict";
const $88e1be01eff6bc07$export$535107f3c159da5d = (param, element, options)=>{
    const { node: node, context: context, __ref: ref } = element;
    const prop = element[param];
    const DOMQLProperty = (0, $782cf63e523d0885$export$2e2bcd8739ae039)[param];
    const DOMQLPropertyFromContext = context && context.registry && context.registry[param];
    const isGlobalTransformer = DOMQLPropertyFromContext || DOMQLProperty;
    const hasDefine = element.define && element.define[param];
    const hasContextDefine = context && context.define && context.define[param];
    if (!ref.__if) return;
    if (isGlobalTransformer && !hasContextDefine) {
        if ((0, $EqHTq.isFunction)(isGlobalTransformer)) {
            isGlobalTransformer(prop, element, node, options);
            return;
        }
    }
    return {
        hasDefine: hasDefine,
        hasContextDefine: hasContextDefine
    };
};



parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");
var $5WrxC = parcelRequire("5WrxC");
"use strict";
const $11a8b378b730acc1$export$e43138af17da316d = (element)=>{
    const { props: props, on: on } = element;
    const eventKeysFromProps = Object.keys(props).filter((key)=>key.startsWith("on"));
    eventKeysFromProps.forEach((v)=>{
        const eventName = (0, $5WrxC.lowercaseFirstLetter)(v.split("on")[1]);
        const origEvent = on[eventName];
        if ((0, $EqHTq.isFunction)(origEvent)) on[eventName] = (...args)=>{
            const originalEventRetunrs = origEvent(...args);
            if (originalEventRetunrs !== false) props[v](...args);
        };
        else on[eventName] = props[v];
    });
};


"use strict";
// import { defineSetter } from './methods'
const $4e214d02be0ddce7$var$ENV = "production";
const $4e214d02be0ddce7$export$270e7ba5936d3c48 = (element, options)=>{
    // create and assign a node
    let { node: node, tag: tag, __ref: ref } = element;
    let isNewNode;
    if (!node) {
        isNewNode = true;
        if (!ref.__if) return element;
        if (tag === "shadow") node = element.node = element.parent.node.attachShadow({
            mode: "open"
        });
        else node = element.node = (0, $01ef634a92434650$export$257247f9c0329159)(element);
        // trigger `on.attachNode`
        (0, $33936e69aa63c9cd$export$1bc010482b845252)("attachNode", element, options);
    }
    // node.dataset // .key = element.key
    if ($4e214d02be0ddce7$var$ENV === "test" || $4e214d02be0ddce7$var$ENV === "development" || options.alowRefReference) {
        node.ref = element;
        if ((0, $EqHTq.isFunction)(node.setAttribute)) node.setAttribute("key", element.key);
    }
    // iterate through define
    (0, $0513b3ed7d5404ec$export$b4c781127351659b)(element);
    // iterate through exec
    (0, $0513b3ed7d5404ec$export$3223a9877c540db8)(element);
    if (element.tag !== "string" && element.tag !== "fragment") {
        (0, $11a8b378b730acc1$export$e43138af17da316d)(element);
        // apply events
        if (isNewNode && (0, $EqHTq.isObject)(element.on)) (0, $33936e69aa63c9cd$export$1f7cb486ba1f8a10)(element, options);
    }
    for(const param in element){
        const value = element[param];
        if ((0, $EqHTq.isUndefined)(value) || (0, $d61abc47c39ce5ac$export$ed2133acb96eb5aa)(param) || (0, $a6bfc6202982ac85$export$53cd1a145c393044)(param) || (0, $EqHTq.isObject)((0, $782cf63e523d0885$export$2e2bcd8739ae039)[param])) continue;
        const isElement = (0, $88e1be01eff6bc07$export$535107f3c159da5d)(param, element, options);
        if (isElement) {
            const { hasDefine: hasDefine, hasContextDefine: hasContextDefine } = isElement;
            if (element[param] && !hasDefine && !hasContextDefine) {
                const createAsync = ()=>(0, $947d5c063e68e91c$export$2e2bcd8739ae039)((0, $8wu6n.exec)(value, element), element, param, options);
                if (element.props && element.props.lazyLoad || options.lazyLoad) window.requestAnimationFrame(()=>createAsync());
                else createAsync();
            }
        }
    }
    // node.dataset.key = key
    return element;
};
var $4e214d02be0ddce7$export$2e2bcd8739ae039 = $4e214d02be0ddce7$export$270e7ba5936d3c48;



parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
"use strict";
const $5fc178d8c3a9e6de$export$5c3eb765ea0f1dc2 = {
    key: {},
    tag: {},
    if: {},
    define: {},
    attr: {},
    style: {},
    content: {},
    class: {},
    props: {},
    state: {},
    method: {},
    transform: {},
    on: {},
    ref: {},
    extend: {},
    childExtend: {},
    text: (element, state)=>{
        element.ref.text = {
            tag: "text",
            text: (0, $8wu6n.exec)(element.text, element, state)
        };
    },
    innerHTML: {},
    set: {},
    update: {},
    remove: {}
} // log: {}
 // value: {},
 // text: {},
 // html: {},
 // path: {},
 // data: {},
 // if: {},
 // __hash: {},
 // __cache: {},
 // __defined: {},
 // __exec: {},
 // __changes: {},
 // __trash: {},
 // __root: {},
 // __props: {},
 // __extend: {},
 // __ifFragment: {},
 // __ifFalsy: {},
 // parent: {},
 // node: {},
 // lookup: {},
 // keys: {},
 // parse: {},
 // parseDeep: {},
;


"use strict";
const $89442055fcdd5e8d$export$de435b1ae0c975f3 = {
    root: [
        "body",
        "html"
    ],
    head: [
        "title",
        "base",
        "meta",
        "style"
    ],
    body: [
        "html",
        "body",
        "string",
        "fragment",
        "a",
        "abbr",
        "acronym",
        "address",
        "applet",
        "area",
        "article",
        "aside",
        "audio",
        "b",
        "basefont",
        "bdi",
        "bdo",
        "big",
        "blockquote",
        "br",
        "button",
        "canvas",
        "caption",
        "center",
        "cite",
        "code",
        "col",
        "colgroup",
        "data",
        "datalist",
        "dd",
        "del",
        "details",
        "dfn",
        "dialog",
        "dir",
        "div",
        "dl",
        "dt",
        "em",
        "embed",
        "fieldset",
        "figcaption",
        "figure",
        "font",
        "footer",
        "form",
        "frame",
        "frameset",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hr",
        "i",
        "iframe",
        "img",
        "input",
        "ins",
        "kbd",
        "label",
        "legend",
        "li",
        "link",
        "main",
        "map",
        "mark",
        "meter",
        "nav",
        "noframes",
        "noscript",
        "object",
        "ol",
        "optgroup",
        "option",
        "output",
        "p",
        "param",
        "picture",
        "pre",
        "progress",
        "q",
        "rp",
        "rt",
        "ruby",
        "s",
        "samp",
        "script",
        "section",
        "select",
        "small",
        "source",
        "span",
        "strike",
        "strong",
        "sub",
        "summary",
        "sup",
        "table",
        "tbody",
        "td",
        "template",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "time",
        "tr",
        "track",
        "tt",
        "u",
        "ul",
        "var",
        "video",
        "wbr",
        // SVG
        "svg",
        "path"
    ]
};


"use strict";









parcelRequire("cBUNY");
var $jOLBF = parcelRequire("jOLBF");

parcelRequire("cBUNY");
var $NWrSd = parcelRequire("NWrSd");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
var $jvD5p = parcelRequire("jvD5p");










"use strict";
const $196ad7400dcaf39e$var$snapshot = {
    snapshotId: (0, $NWrSd.createSnapshotId)
};
const $196ad7400dcaf39e$var$UPDATE_DEFAULT_OPTIONS = {
    stackChanges: false,
    cleanExec: true,
    preventRecursive: false,
    currentSnapshot: false,
    calleeElement: false,
    excludes: (0, $9dbe2fe74e93fc61$export$7f0c3d30e5984c9d)
};
const $196ad7400dcaf39e$var$update = function(params = {}, options = $196ad7400dcaf39e$var$UPDATE_DEFAULT_OPTIONS) {
    const element = this;
    const { parent: parent, node: node, key: key } = element;
    const { excludes: excludes, preventInheritAtCurrentState: preventInheritAtCurrentState } = options;
    if (!options.preventListeners) (0, $33936e69aa63c9cd$export$8fe90418b8a0fc1e)("startUpdate", params, element, options);
    if (preventInheritAtCurrentState && preventInheritAtCurrentState.__element === element) return;
    if (!excludes) (0, $8wu6n.merge)(options, $196ad7400dcaf39e$var$UPDATE_DEFAULT_OPTIONS);
    let ref = element.__ref;
    if (!ref) ref = element.__ref = {};
    const [snapshotOnCallee, calleeElement, snapshotHasUpdated] = $196ad7400dcaf39e$var$captureSnapshot(element, options);
    if (snapshotHasUpdated) return;
    if ((0, $EqHTq.isString)(params) || (0, $EqHTq.isNumber)(params)) params = {
        text: params
    };
    const inheritState = $196ad7400dcaf39e$var$inheritStateUpdates(element, options);
    if (inheritState === false) return;
    const ifFails = $196ad7400dcaf39e$var$checkIfOnUpdate(element, parent, options);
    if (ifFails) return;
    if (ref.__if && !options.preventPropsUpdate) {
        const hasParentProps = parent.props && (parent.props[key] || parent.props.childProps);
        const hasFunctionInProps = ref.__props.filter((v)=>(0, $EqHTq.isFunction)(v));
        const props = params.props || hasParentProps || hasFunctionInProps.length;
        if (props) (0, $902e7fcbfa0a2596$export$c8dce3c08436e91e)(props, element, parent);
    }
    if (!options.preventInitUpdateListener && !options.preventListeners) {
        const initUpdateReturns = (0, $33936e69aa63c9cd$export$8fe90418b8a0fc1e)("initUpdate", params, element, options);
        if (initUpdateReturns === false) return element;
    }
    const overwriteChanges = (0, $8wu6n.overwriteDeep)(element, params, (0, $9dbe2fe74e93fc61$export$7f0c3d30e5984c9d));
    const execChanges = (0, $0513b3ed7d5404ec$export$2ad800d85590910f)(element, {
        ignore: $196ad7400dcaf39e$var$UPDATE_DEFAULT_OPTIONS
    });
    // if (element.key === 'Navigation') debugger
    const definedChanges = (0, $0513b3ed7d5404ec$export$88eda8a7eb5c5eff)(element);
    if (!options.isForced && !options.preventListeners) (0, $33936e69aa63c9cd$export$1bc010482b845252)("beforeClassAssign", element, options);
    if (options.stackChanges && element.__stackChanges) {
        const stackChanges = (0, $8wu6n.merge)(definedChanges, (0, $8wu6n.merge)(execChanges, overwriteChanges));
        element.__stackChanges.push(stackChanges);
    }
    if (!ref.__if) return false;
    if (!node) // return createNode(element, options)
    return;
    for(const param in element){
        const prop = element[param];
        const hasOnlyUpdateFalsy = options.onlyUpdate && (options.onlyUpdate !== param || !element.lookup(options.onlyUpdate));
        const isInPreventUpdate = (0, $EqHTq.isArray)(options.preventUpdate) && options.preventUpdate.includes(param);
        const isInPreventDefineUpdate = (0, $EqHTq.isArray)(options.preventDefineUpdate) && options.preventDefineUpdate.includes(param);
        const hasCollection = element.$collection || element.$stateCollection || element.$propsCollection;
        if ((0, $EqHTq.isUndefined)(prop) || hasOnlyUpdateFalsy || isInPreventUpdate || isInPreventDefineUpdate || options.preventDefineUpdate === true || options.preventDefineUpdate === param || options.preventContentUpdate && param === "content" && !hasCollection || (options.preventStateUpdate && param) === "state" || (0, $d61abc47c39ce5ac$export$ed2133acb96eb5aa)(param) || (0, $EqHTq.isObject)((0, $782cf63e523d0885$export$2e2bcd8739ae039)[param]) || (0, $a6bfc6202982ac85$export$53cd1a145c393044)(param)) continue;
        if (options.preventStateUpdate === "once") options.preventStateUpdate = false;
        const isElement = (0, $88e1be01eff6bc07$export$535107f3c159da5d)(param, element, options);
        if (isElement) {
            const { hasDefine: hasDefine, hasContextDefine: hasContextDefine } = isElement;
            const canUpdate = (0, $EqHTq.isObject)(prop) && !hasDefine && !hasContextDefine && !options.preventRecursive;
            if (!canUpdate) continue;
            const lazyLoad = element.props.lazyLoad || options.lazyLoad;
            const childUpdateCall = ()=>$196ad7400dcaf39e$var$update.call(prop, params[prop], {
                    ...options,
                    currentSnapshot: snapshotOnCallee,
                    calleeElement: calleeElement
                });
            lazyLoad ? (0, $jvD5p.window).requestAnimationFrame(()=>childUpdateCall()) : childUpdateCall();
        }
    }
    if (!options.preventUpdateListener) (0, $33936e69aa63c9cd$export$1bc010482b845252)("update", element, options);
};
const $196ad7400dcaf39e$var$captureSnapshot = (element, options)=>{
    const ref = element.__ref;
    const { currentSnapshot: currentSnapshot, calleeElement: calleeElement } = options;
    const isCallee = calleeElement === element;
    if (!calleeElement || isCallee) {
        const createdStanpshot = $196ad7400dcaf39e$var$snapshot.snapshotId();
        ref.__currentSnapshot = createdStanpshot;
        return [
            createdStanpshot,
            element
        ];
    }
    const snapshotOnCallee = ref.__currentSnapshot;
    if (currentSnapshot < snapshotOnCallee) return [
        snapshotOnCallee,
        calleeElement,
        true
    ];
    return [
        snapshotOnCallee,
        calleeElement
    ];
};
const $196ad7400dcaf39e$var$checkIfOnUpdate = (element, parent, options)=>{
    if (!(0, $EqHTq.isFunction)(element.if) || !parent) return;
    const ref = element.__ref;
    const ifPassed = element.if(element, element.state, element.context, options);
    const itWasFalse = ref.__if !== true;
    if (ifPassed) {
        ref.__if = true;
        if (itWasFalse) {
            delete element.__hash;
            delete element.extend;
            if (!ref.__hasRootState) delete element.state;
            if (ref.__state) element.state = ref.__state;
            else if (!ref.__hasRootState) delete element.state;
            element.node && element.node.remove();
            const previousElement = element.previousElement();
            const nextElement = element.nextElement();
            const hasPrevious = previousElement && previousElement.node;
            const hasNext = nextElement && nextElement.node;
            const attachOptions = (hasPrevious && hasPrevious.parentNode || hasNext && hasNext.parentNode) && {
                position: hasPrevious ? "after" : hasNext ? "before" : null,
                node: hasPrevious || hasNext
            };
            const created = (0, $947d5c063e68e91c$export$2e2bcd8739ae039)(element, parent, element.key, (0, $ad3d3b247d47f3a2$export$2e2bcd8739ae039).create, attachOptions);
            // check preventUpdate for an array (Line: 87)
            if (options.preventUpdate !== true && element.on && (0, $EqHTq.isFunction)(element.on.update)) (0, $33936e69aa63c9cd$export$27ca81ea148fa005)(element.on.update, created, created.state);
            return created;
        }
    } else if (element.node && !ifPassed) {
        element.node.remove();
        delete ref.__if;
    }
};
/**
 * Inherit state updates for a given element based on the specified options.
 *
 * @param {Object} element - The element to inherit state updates for.
 * @param {Object} options - Configuration options for state update inheritance.
 * @param {boolean} [options.preventUpdateTriggerStateUpdate] - If true, prevent triggering state updates.
 * @param {boolean} [options.isHoisted] - Whether the state is hoisted.
 * @param {boolean} [options.execStateFunction] - Execute the state functions.
 * @param {boolean} [options.stateFunctionOverwrite] - If true, overwrite (not merge) current state with what function returns.
 * @param {boolean} [options.preventInheritedStateUpdate] - If true, prevent inheriting state updates.
 * @param {boolean} [options.preventInitStateUpdateListener] - If true, prevent the 'initStateUpdate' event listener.
 * @param {boolean} [options.preventStateUpdateListener] - If true, prevent the 'stateUpdate' event listener.
 * @returns {boolean} - If returns false, it breaks the update function
 */ const $196ad7400dcaf39e$var$inheritStateUpdates = (element, options)=>{
    const { __ref: ref } = element;
    const stateKey = ref.__state;
    const { parent: parent, state: state } = element;
    const { preventUpdateTriggerStateUpdate: preventUpdateTriggerStateUpdate, isHoisted: isHoisted, execStateFunction: execStateFunction } = options;
    if (preventUpdateTriggerStateUpdate) return;
    // If does not have own state inherit from parent
    if (!stateKey && !ref.__hasRootState) {
        element.state = parent && parent.state || {};
        return;
    }
    // If state is function, decide execution and apply setting a current state
    const shouldForceFunctionState = (0, $EqHTq.isFunction)(stateKey) && !isHoisted && execStateFunction;
    if (shouldForceFunctionState) {
        const execState = (0, $8wu6n.exec)(stateKey, element);
        state.set(execState, {
            ...options,
            preventUpdate: true,
            preventStateUpdateListener: false,
            updatedByStateFunction: true
        });
        return;
    }
    // If state is string, find its value in the state tree
    const keyInParentState = (0, $5fcb062e9eb35754$export$487549069bb5d2a9)(element, element.parent);
    if (!keyInParentState || options.preventInheritedStateUpdate) return;
    // Trigger on.initStateUpdate event
    if (!options.preventInitStateUpdateListener && !options.preventListeners) {
        const initStateReturns = (0, $33936e69aa63c9cd$export$8fe90418b8a0fc1e)("initStateUpdate", keyInParentState, element, options);
        if (initStateReturns === false) return element;
    }
    // Recreate the state again
    const newState = $196ad7400dcaf39e$var$createStateUpdate(element, parent, options);
    // Trigger on.stateUpdate event
    if (!options.preventStateUpdateListener && !options.preventListeners) (0, $33936e69aa63c9cd$export$8fe90418b8a0fc1e)("stateUpdate", newState.parse(), element, options);
};
const $196ad7400dcaf39e$var$createStateUpdate = (element, parent, options)=>{
    const __stateChildren = element.state.__children;
    const newState = (0, $774f1a3b2fe82710$export$e6a0daad8304de)(element, parent);
    element.state = newState;
    for(const child in __stateChildren){
        // check this for inherited states
        if (newState[child]) newState.__children[child] = __stateChildren[child];
        __stateChildren[child].parent = newState;
    }
    return newState;
};
var $196ad7400dcaf39e$export$2e2bcd8739ae039 = $196ad7400dcaf39e$var$update;




"use strict";
const $6587d89a5cc3b917$export$626ce79af72fc3d3 = (element, parent)=>{
    const proto = {
        set: (0, $bf937aebc888d68f$export$2e2bcd8739ae039).bind(element),
        update: (0, $196ad7400dcaf39e$export$2e2bcd8739ae039).bind(element),
        remove: (0, $d61abc47c39ce5ac$export$cd7f480d6b8286c3).bind(element),
        updateContent: (0, $0a7669919424e35c$export$5143cc956eb9d8f6).bind(element),
        removeContent: (0, $0a7669919424e35c$export$6e1d9b0d0e1e1def).bind(element),
        setProps: (0, $d61abc47c39ce5ac$export$938ca3893886de06).bind(element),
        lookup: (0, $d61abc47c39ce5ac$export$dfc7155ac0343b8).bind(element),
        spotByPath: (0, $d61abc47c39ce5ac$export$cec27f102c074405).bind(element),
        parse: (0, $d61abc47c39ce5ac$export$98e6a39c04603d36).bind(element),
        parseDeep: (0, $d61abc47c39ce5ac$export$3ed0fe0c6a5387e2).bind(element),
        keys: (0, $d61abc47c39ce5ac$export$ed97f33186d4b816).bind(element),
        nextElement: (0, $d61abc47c39ce5ac$export$e87a5caa96444a37).bind(element),
        previousElement: (0, $d61abc47c39ce5ac$export$1facc1d780a4d839).bind(element)
    };
    if ((0, $jOLBF.isDevelopment)()) proto.log = (0, $d61abc47c39ce5ac$export$bef1f36f5486a6a3).bind(element);
    Object.setPrototypeOf(element, proto);
};




parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $NWrSd = parcelRequire("NWrSd");
var $EqHTq = parcelRequire("EqHTq");
var $cPMIO = parcelRequire("cPMIO");


"use strict";
const $947d5c063e68e91c$var$ENV = "production";
/**
 * Creating a domQL element using passed parameters
 */ const $947d5c063e68e91c$var$create = (element, parent, key, options = (0, $ad3d3b247d47f3a2$export$2e2bcd8739ae039).create || {}, attachOptions)=>{
    $947d5c063e68e91c$var$cacheOptions(element, options);
    // if (key === 'Title') debugger
    // if element is STRING
    if ($947d5c063e68e91c$var$checkIfPrimitive(element)) element = $947d5c063e68e91c$var$applyValueAsText(element, parent, key);
    element = $947d5c063e68e91c$var$redefineElement(element, parent, key, options);
    parent = $947d5c063e68e91c$var$redefineParent(element, parent, key);
    key = $947d5c063e68e91c$var$createKey(element, parent, key);
    const ref = $947d5c063e68e91c$var$addRef(element, parent, key);
    // assign initial props
    ref.__initialProps = (0, $8wu6n.deepClone)(element.props, []);
    // assign context
    $947d5c063e68e91c$var$applyContext(element, parent, options);
    (0, $a6bfc6202982ac85$export$fd6b2f481ffc7974)(element, parent, options);
    if (!ref.__skipCreate) // create EXTEND inheritance
    (0, $3bff1c984b824aeb$export$f20941eae6723bcc)(element, parent, options);
    // create and assign a KEY
    element.key = key;
    // Only resolve extends, skip everything else
    if (options.onlyResolveExtends) return $947d5c063e68e91c$var$onlyResolveExtends(element, parent, key, options);
    $947d5c063e68e91c$var$switchDefaultOptions(element, parent, options);
    $947d5c063e68e91c$var$addCaching(element, parent);
    (0, $6587d89a5cc3b917$export$626ce79af72fc3d3)(element, parent);
    $947d5c063e68e91c$var$createScope(element, parent);
    (0, $774f1a3b2fe82710$export$e6a0daad8304de)(element, parent);
    if (element.scope === "state") element.scope = element.state;
    $947d5c063e68e91c$var$createIfConditionFlag(element, parent);
    // apply props settings
    (0, $e818f1ed291a38e8$export$c94ea207b45fef3a)(element, parent);
    if (element.scope === "props" || element.scope === true) element.scope = element.props;
    // recatch if it passess props again
    $947d5c063e68e91c$var$createIfConditionFlag(element, parent);
    // if it already HAS a NODE
    if (element.node && ref.__if) return (0, $98807bf18bc93fb3$export$4f2a718cb234b42f)(element, parent, key, attachOptions);
    // apply variants
    (0, $a6bfc6202982ac85$export$f1439fc936ef702f)(element, parent);
    const onInit = (0, $33936e69aa63c9cd$export$1bc010482b845252)("init", element, options);
    if (onInit === false) return element;
    (0, $33936e69aa63c9cd$export$1bc010482b845252)("beforeClassAssign", element, options);
    // generate a CLASS name
    (0, $6a43953e96d89b45$export$d559e9a3b71405f6)(element);
    $947d5c063e68e91c$var$renderElement(element, parent, options, attachOptions);
    $947d5c063e68e91c$var$addElementIntoParentChildren(element, parent);
    (0, $33936e69aa63c9cd$export$1bc010482b845252)("complete", element, options);
    return element;
};
const $947d5c063e68e91c$var$createBasedOnType = (element, parent, key, options)=>{
    // if ELEMENT is not given
    if (element === undefined) {
        if ($947d5c063e68e91c$var$ENV === "test" || $947d5c063e68e91c$var$ENV === "development") console.warn(key, "element is undefined in", parent && parent.__ref && parent.__ref.path);
        return {};
    }
    if ((0, $EqHTq.isString)(key) && key.slice(0, false)) {
        if ($947d5c063e68e91c$var$ENV === "test" || $947d5c063e68e91c$var$ENV === "development") console.warn(key, "seems like to be in __ref");
    }
    if (element === null) return;
    if (element === true) return {
        text: true
    };
    // if element is extend
    if (element.__hash) return {
        extend: element
    };
    return element;
};
const $947d5c063e68e91c$var$redefineElement = (element, parent, key, options)=>{
    const elementWrapper = $947d5c063e68e91c$var$createBasedOnType(element, parent, key, options);
    if (options.syntaxv3 || element.props?.syntaxv3 || parent.props?.syntaxv3) {
        element.props.syntaxv3 = true;
        return (0, $a6bfc6202982ac85$export$2cbc234431a4ef8)(element, parent, key, options);
    } else if ((0, $a6bfc6202982ac85$export$b791484194c5fc38)(key)) return (0, $a6bfc6202982ac85$export$2279e5e6b0817ddc)(elementWrapper, parent, key);
    // TODO: move as define plugins
    // Responsive rendering
    if ($947d5c063e68e91c$var$checkIfMedia(key)) return $947d5c063e68e91c$var$applyMediaProps(elementWrapper, parent, key);
    return elementWrapper;
};
const $947d5c063e68e91c$var$redefineParent = (element, parent, key, options)=>{
    if (!parent) return 0, $80563b8eaf6ba844$export$fbea82a1c0574ef4;
    if ((0, $cPMIO.isNode)(parent)) {
        const parentNodeWrapper = {
            key: ":root",
            node: parent
        };
        (0, $80563b8eaf6ba844$export$fbea82a1c0574ef4)[`${key}_parent`] = parentNodeWrapper;
        return parentNodeWrapper;
    }
    return parent;
};
const $947d5c063e68e91c$var$cacheOptions = (element, options)=>{
    if (options && !(0, $ad3d3b247d47f3a2$export$2e2bcd8739ae039).create) {
        (0, $ad3d3b247d47f3a2$export$2e2bcd8739ae039).create = options;
        (0, $ad3d3b247d47f3a2$export$2e2bcd8739ae039).create.context = element.context || options.context;
    }
};
const $947d5c063e68e91c$var$createKey = (element, parent, key)=>{
    return ((0, $8wu6n.exec)(key, element) || key || element.key || (0, $NWrSd.generateKey)()).toString();
};
const $947d5c063e68e91c$var$addRef = (element, parent)=>{
    if (element.__ref) element.__ref.origin = element;
    else element.__ref = {
        origin: element
    };
    return element.__ref;
};
const $947d5c063e68e91c$var$switchDefaultOptions = (element, parent, options)=>{
    if (Object.keys(options).length) {
        (0, $782cf63e523d0885$export$2e2bcd8739ae039).defaultOptions = options;
        if (options.ignoreChildExtend) delete options.ignoreChildExtend;
    }
};
const $947d5c063e68e91c$var$addElementIntoParentChildren = (element, parent)=>{
    if (parent.__ref && parent.__ref.__children) parent.__ref.__children.push(element.key);
};
const $947d5c063e68e91c$var$renderElement = (element, parent, options, attachOptions)=>{
    const { __ref: ref, key: key } = element;
    // CREATE a real NODE
    (0, $4e214d02be0ddce7$export$2e2bcd8739ae039)(element, options);
    if (!ref.__if) {
        parent[key || element.key] = element;
        return element;
    }
    // assign NODE
    (0, $98807bf18bc93fb3$export$4f2a718cb234b42f)(element, parent, key, attachOptions);
    // run `on.renderRouter`
    (0, $33936e69aa63c9cd$export$1bc010482b845252)("renderRouter", element, options);
    // run `on.render`
    (0, $33936e69aa63c9cd$export$1bc010482b845252)("render", element, options);
};
const $947d5c063e68e91c$var$checkIfPrimitive = (element)=>(0, $EqHTq.is)(element)("string", "number");
const $947d5c063e68e91c$var$applyValueAsText = (element, parent, key)=>{
    const extendTag = element.extend && element.extend.tag;
    const childExtendTag = parent.childExtend && parent.childExtend.tag;
    const isKeyValidHTMLTag = (0, $89442055fcdd5e8d$export$de435b1ae0c975f3).body.indexOf(key) > -1 && key;
    return {
        text: element,
        tag: extendTag || childExtendTag || isKeyValidHTMLTag || "string"
    };
};
const $947d5c063e68e91c$var$applyContext = (element, parent, options)=>{
    const forcedOptionsContext = options.context && !(0, $80563b8eaf6ba844$export$fbea82a1c0574ef4).context && !element.context;
    if (forcedOptionsContext) (0, $80563b8eaf6ba844$export$fbea82a1c0574ef4).context = options.context;
    // inherit from parent or root
    if (!element.context) element.context = parent.context || options.context || (0, $80563b8eaf6ba844$export$fbea82a1c0574ef4).context;
};
// Create scope - shared object across the elements to the own or the nearest parent
const $947d5c063e68e91c$var$createScope = (element, parent)=>{
    const { __ref: ref } = element;
    // If the element doesn't have a scope, initialize it using the parent's scope or the root's scope.
    if (!element.scope) element.scope = parent.scope || ref.__root.scope || {};
};
const $947d5c063e68e91c$var$createIfConditionFlag = (element, parent)=>{
    const { __ref: ref } = element;
    if ((0, $EqHTq.isFunction)(element.if) && !element.if(element, element.state)) delete ref.__if;
    else ref.__if = true;
};
const $947d5c063e68e91c$var$addCaching = (element, parent)=>{
    const { __ref: ref } = element;
    let { __ref: parentRef } = parent;
    // enable TRANSFORM in data
    if (!element.transform) element.transform = {};
    // enable CACHING
    if (!ref.__cached) ref.__cached = {};
    if (!ref.__defineCache) ref.__defineCache = {};
    // enable EXEC
    if (!ref.__exec) ref.__exec = {};
    // enable CLASS CACHING
    if (!ref.__class) ref.__class = {};
    if (!ref.__classNames) ref.__classNames = {};
    // enable CLASS CACHING
    if (!ref.__attr) ref.__attr = {};
    // enable CHANGES storing
    if (!ref.__changes) ref.__changes = [];
    // enable CHANGES storing
    if (!ref.__children) ref.__children = [];
    // Add _root element property
    const hasRoot = parent && parent.key === ":root";
    if (!ref.__root) ref.__root = hasRoot ? element : parentRef.__root;
    // set the PATH array
    if ($947d5c063e68e91c$var$ENV === "test" || $947d5c063e68e91c$var$ENV === "development") {
        if (!parentRef) parentRef = parent.ref = {};
        if (!parentRef.__path) parentRef.__path = [];
        ref.__path = parentRef.__path.concat(element.key);
    }
};
const $947d5c063e68e91c$var$onlyResolveExtends = (element, parent, key, options)=>{
    const { __ref: ref } = element;
    if (!ref.__skipCreate) {
        element.tag = (0, $01ef634a92434650$export$5075bd4eae016d2c)(element);
        // if (!element.props) element.props = {}
        // Copy-paste of addCaching()
        // enable CACHING
        if (!ref.__cached) ref.__cached = {};
        if (!ref.__defineCache) ref.__defineCache = {};
        // enable EXEC
        if (!ref.__exec) ref.__exec = {};
        // enable CLASS CACHING
        if (!ref.__class) ref.__class = {};
        if (!ref.__classNames) ref.__classNames = {};
        // enable CLASS CACHING
        if (!ref.__attr) ref.__attr = {};
        // enable CHANGES storing
        if (!ref.__changes) ref.__changes = [];
        // enable CHANGES storing
        if (!ref.__children) ref.__children = [];
        // Add __root element property
        // const hasRoot = parent && parent.key === ':root'
        // if (!ref.__root) ref.__root = hasRoot ? element : parentRef.__root
        (0, $6587d89a5cc3b917$export$626ce79af72fc3d3)(element, parent);
        (0, $774f1a3b2fe82710$export$e6a0daad8304de)(element, parent);
        // Borrowed from createIfConditionFlag()
        if ((0, $EqHTq.isFunction)(element.if)) {
            const ifPassed = element.if(element, element.state);
            if (!ifPassed) // const ifFragment = cacheNode({ tag: 'fragment' })
            // ref.__ifFragment = appendNode(ifFragment, parent.node)
            delete ref.__if;
            else ref.__if = true;
        } else ref.__if = true;
        /// ///
        if (element.node && ref.__if) parent[key || element.key] = element;
         // Borrowed from assignNode()
        (0, $e818f1ed291a38e8$export$c94ea207b45fef3a)(element, parent);
        if (!element.props) element.props = {};
        (0, $a6bfc6202982ac85$export$f1439fc936ef702f)(element, parent);
    }
    if (element.tag !== "string" && element.tag !== "fragment") {
        (0, $0513b3ed7d5404ec$export$b4c781127351659b)(element);
        (0, $0513b3ed7d5404ec$export$3223a9877c540db8)(element);
        for(const k in element){
            if ((0, $EqHTq.isUndefined)(element[k]) || (0, $d61abc47c39ce5ac$export$ed2133acb96eb5aa)(k) || (0, $EqHTq.isObject)((0, $782cf63e523d0885$export$2e2bcd8739ae039)[k]) || (0, $a6bfc6202982ac85$export$53cd1a145c393044)(k)) continue;
            const hasDefine = element.define && element.define[k];
            const contextHasDefine = element.context && element.context.define && element.context.define[k];
            const optionsHasDefine = options.define && options.define[k];
            if (!ref.__skipCreate && (0, $782cf63e523d0885$export$2e2bcd8739ae039)[k] && !optionsHasDefine) continue;
            else if (element[k] && !hasDefine && !optionsHasDefine && !contextHasDefine) $947d5c063e68e91c$var$create((0, $8wu6n.exec)(element[k], element), element, k, options);
        }
    }
    parent[key || element.key] = element // Borrowed from assignNode()
    ;
    delete element.update;
    delete element.__element;
    // added by createProps
    if (element.props) {
        delete element.props.update;
        delete element.props.__element;
    }
    return element;
};
const $947d5c063e68e91c$var$checkIfMedia = (key)=>key.slice(0, 1) === "@";
const $947d5c063e68e91c$var$applyMediaProps = (element, parent, key)=>{
    const { props: props } = element;
    if (props) {
        props.display = "none";
        if (props[key]) props[key].display = props.display;
        else props[key] = {
            display: props.display || "block"
        };
        return element;
    } else return {
        ...element,
        props: {
            display: "none",
            [key]: {
                display: "block"
            }
        }
    };
};
var $947d5c063e68e91c$export$2e2bcd8739ae039 = $947d5c063e68e91c$var$create;





"use strict";
var $dd5b413a87318846$export$2e2bcd8739ae039 = (params, options = {})=>{
    const { overwrite: overwrite } = options;
    for(const param in params)if ((0, $782cf63e523d0885$export$2e2bcd8739ae039)[param] && !overwrite) (0, $06908963bda72849$export$f18d5b0af29128b7)("OverwriteToBuiltin", param);
    else (0, $782cf63e523d0885$export$2e2bcd8739ae039)[param] = params[param];
};




"use strict";


"use strict";
const $07fce7224ceb45c2$var$create = (element, parent, key, options)=>{
    // createState
    // createNode
    return (0, $947d5c063e68e91c$export$2e2bcd8739ae039)(element, parent, key, options);
};
var $07fce7224ceb45c2$export$2e2bcd8739ae039 = {
    TREE: $80563b8eaf6ba844$export$33ecaa422889cd80,
    create: $07fce7224ceb45c2$var$create
};


parcelRequire("cBUNY");
var $EqHTq = parcelRequire("EqHTq");




parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
var $jOLBF = parcelRequire("jOLBF");
parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");
var $EqHTq = parcelRequire("EqHTq");
"use strict";
const $ef00d6a2421ef52f$export$990fa93f2c5a3271 = (element)=>{
    const { key: key } = element;
    if (element.class === true) element.class = key;
    else if (!element.class && typeof key === "string" && key.charAt(0) === "_" && key.charAt(1) !== "_") element.class = key.slice(1);
};
const $ef00d6a2421ef52f$export$b04d9b8d414ba5e8 = (obj, element)=>{
    let className = "";
    for(const item in obj){
        const param = obj[item];
        if (typeof param === "boolean" && param) className += ` ${item}`;
        else if (typeof param === "string") className += ` ${param}`;
        else if (typeof param === "function") className += ` ${(0, $8wu6n.exec)(param, element)}`;
    }
    return className;
};
const $ef00d6a2421ef52f$export$11c615ce16f87241 = (params, element)=>{
    if (!params) return;
    const { key: key } = element;
    if (params === true) params = element.class = {
        key: key
    };
    if ((0, $EqHTq.isString)(params)) params = element.class = {
        default: params
    };
    if ((0, $EqHTq.isObject)(params)) params = $ef00d6a2421ef52f$export$b04d9b8d414ba5e8(params, element);
    // TODO: fails on string
    const className = params.replace(/\s+/g, " ").trim();
    if (element.ref) element.ref.class = className // TODO: this check is NOT needed in new DOMQL
    ;
    return className;
};
const $ef00d6a2421ef52f$export$e8f750c9f10c0a7b = (params, element, node)=>{
    const className = $ef00d6a2421ef52f$export$11c615ce16f87241(params, element);
    node.classList = className;
    return className;
};



"use strict";
const $a03ad4de26254f62$export$c79b0dc85ccca679 = (emotion)=>{
    return (params, element, state)=>{
        const execParams = (0, $8wu6n.exec)(params, element);
        if (params) {
            if ((0, $EqHTq.isObjectLike)(element.class)) element.class.elementStyle = execParams;
            else element.class = {
                elementStyle: execParams
            };
        }
        $a03ad4de26254f62$export$62b33bcc98e42249(emotion)(element.class, element, element.state, true);
    };
};
const $a03ad4de26254f62$export$62b33bcc98e42249 = (emotion)=>{
    return (params, element, state, flag)=>{
        if (element.style && !flag) return;
        const { __ref: __ref } = element;
        const { __class: __class, __classNames: __classNames } = __ref;
        if (!(0, $EqHTq.isObjectLike)(params)) return;
        if (element.props.class) __classNames.classProps = element.props.class;
        if (element.attr.class) __classNames.class = element.attr.class;
        for(const key in params){
            const prop = (0, $8wu6n.exec)(params[key], element);
            if (!prop) {
                delete __class[key];
                delete __classNames[key];
                continue;
            }
            const isEqual = (0, $8wu6n.isEqualDeep)(__class[key], prop);
            if (!isEqual) {
                if (!(0, $jOLBF.isProduction)() && (0, $EqHTq.isObject)(prop)) prop.label = key || element.key;
                const CSSed = emotion.css(prop);
                __class[key] = prop;
                __classNames[key] = CSSed;
            }
        }
        (0, $ef00d6a2421ef52f$export$e8f750c9f10c0a7b)(__classNames, element, element.node);
    // return element.class
    };
};
const $a03ad4de26254f62$export$23627aa597d6e60c = (emotion, options)=>{
    if (!emotion) emotion = (0, $f80ae5e019588f18$export$2e2bcd8739ae039)(options || {
        key: "smbls"
    });
    return {
        style: $a03ad4de26254f62$export$c79b0dc85ccca679(emotion),
        class: $a03ad4de26254f62$export$62b33bcc98e42249(emotion)
    };
};




parcelRequire("cBUNY");
var $8wu6n = parcelRequire("8wu6n");


"use strict";
const $0cb0e0c91cc6836f$export$e567b959eb9cc2cc = (key, options = {})=>{
    const doc = options.parent || options.document || document;
    const initOptions = options.initOptions || {};
    const emotion = initOptions.emotion;
    if (!initOptions.emotion) initOptions.emotion = (0, $b3468425a35a59c8$export$51d693b3d243fd90);
    const registry = options.registry || (0, $a03ad4de26254f62$export$23627aa597d6e60c)(initOptions.emotion, options);
    const defaultDesignSystem = (0, $8wu6n.deepClone)((0, $812d27f1e77a76ab$export$2e2bcd8739ae039));
    const designSystem = initOptions.useDefaultConfig ? (0, $8wu6n.deepMerge)(options.designSystem, defaultDesignSystem) : options.designSystem || defaultDesignSystem;
    const scratchSystem = (0, $31242768b5023c84$export$2cd8252107eb640b)(designSystem, {
        key: key,
        emotion: emotion,
        verbose: options.verbose,
        document: doc,
        ...(0, $d5fc17b4ecb94b3e$export$882cd4124a942c79),
        ...initOptions
    });
    return [
        scratchSystem,
        emotion,
        registry
    ];
};




"use strict";
const $f46ec85bc7cd1647$var$checkIfKeyIsComponent = (key)=>{
    const isFirstKeyString = (0, $EqHTq.isString)(key);
    if (!isFirstKeyString) return;
    const firstCharKey = key.slice(0, 1);
    return /^[A-Z]*$/.test(firstCharKey);
};
const $f46ec85bc7cd1647$export$17aa062053a6ac51 = ()=>{
    const newObj = {};
    for(const key in $be006f1a0fabd945$exports)if (Object.prototype.hasOwnProperty.call($be006f1a0fabd945$exports, key)) {
        if ($f46ec85bc7cd1647$var$checkIfKeyIsComponent(key)) newObj[`smbls.${key}`] = $be006f1a0fabd945$exports[key];
        else newObj[key] = $be006f1a0fabd945$exports[key];
    }
    return newObj;
};
const $f46ec85bc7cd1647$export$4f2633f1ff10978c = (options)=>{
    return options.components ? {
        ...$f46ec85bc7cd1647$export$17aa062053a6ac51(),
        ...options.components
    } : $f46ec85bc7cd1647$export$17aa062053a6ac51();
};
const $f46ec85bc7cd1647$export$348dc3ccba7d17b1 = (options)=>{
    return {
        ...$2a60ce89a661a6b2$exports,
        ...$2a60ce89a661a6b2$exports.scratchUtils,
        ...options.snippets || options.utils || {}
    };
};
const $f46ec85bc7cd1647$export$d54de307475be07a = (options, key)=>{
    const [scratcDesignhSystem, emotion, registry] = (0, $0cb0e0c91cc6836f$export$e567b959eb9cc2cc)(key, options);
    return [
        scratcDesignhSystem,
        emotion,
        registry
    ];
};
const $f46ec85bc7cd1647$export$beb986ec1c64324 = (options, App)=>{
    const state = {};
    if (options.state) $2a60ce89a661a6b2$exports.deepMerge(state, options.state);
    if (App && App.state) (0, $8wu6n.deepMerge)(state, App.state);
    return (0, $8wu6n.deepCloneWithExtnd)(state);
};
const $f46ec85bc7cd1647$export$b2f7e94520d001d1 = (options)=>{
    const pages = options.pages;
    Object.keys(options.pages).filter((v)=>!v.startsWith("/")).forEach((v)=>{
        if (v === "main") pages["/"] = options.pages.main;
        else pages["/" + v] = options.pages[v];
    });
    options.pages = pages;
    return pages;
};
const $f46ec85bc7cd1647$export$b2b7a41b0a3bae42 = (options)=>{
    if (typeof document === "undefined") {
        if (typeof window === "undefined") window = {} // eslint-disable-line
        ;
        if (!window.document) window.document = {
            body: {}
        };
        document = window.document // eslint-disable-line
        ;
    }
    return options.parent || options.document || document;
};


"use strict";
const $a04f9f910a252074$var$SYMBOLS_KEY = undefined;
const $a04f9f910a252074$export$b5b313bfdabf2fb4 = (App, options)=>{
    const key = options.key || $a04f9f910a252074$var$SYMBOLS_KEY || ((0, $EqHTq.isString)(App) ? App : "");
    const [scratcDesignSystem, emotion, registry] = (0, $f46ec85bc7cd1647$export$d54de307475be07a)(options, key);
    if ((0, $EqHTq.isString)(App)) App = {};
    const doc = (0, $f46ec85bc7cd1647$export$b2b7a41b0a3bae42)(options);
    const state = (0, $f46ec85bc7cd1647$export$beb986ec1c64324)(options, App);
    const pages = (0, $f46ec85bc7cd1647$export$b2f7e94520d001d1)(options);
    const components = (0, $f46ec85bc7cd1647$export$4f2633f1ff10978c)(options);
    const designSystem = scratcDesignSystem;
    const snippets = (0, $f46ec85bc7cd1647$export$348dc3ccba7d17b1)(options);
    const define = options.define || (0, $596256ead72518a6$export$6588fc50c67b09a2);
    const routerOptions = (0, $4747ce2ab72764ea$export$cf7ee87ede64229c)(App, options) // eslint-disable-line
    ;
    const extend = (0, $5b6a3972014f3e94$export$ca717cfcb724fd64)([
        App
    ], options);
    return ((0, $07fce7224ceb45c2$export$2e2bcd8739ae039).default && (0, $07fce7224ceb45c2$export$2e2bcd8739ae039).default.create || (0, $07fce7224ceb45c2$export$2e2bcd8739ae039).create)({
        extend: extend,
        routes: options.pages,
        state: state,
        context: {
            key: key,
            components: components,
            state: state,
            pages: pages,
            designSystem: designSystem,
            snippets: snippets,
            functions: options.functions,
            files: options.files,
            utils: snippets,
            define: define,
            registry: registry,
            emotion: emotion,
            routerOptions: routerOptions,
            document: doc
        }
    }, doc.body, key, {
        extend: [
            $c95c6861d219ec8a$export$e71c4d32a2263218
        ],
        verbose: options.verbose,
        ...options.domqlOptions
    });
};


"use strict";
const $22cae8e82746fd5e$var$SYMBOLS_KEY = undefined;
const $22cae8e82746fd5e$var$mergeWithLocalFile = (options, optionsExternalFile)=>(0, $8wu6n.deepMerge)(options, (0, $EqHTq.isObject)(optionsExternalFile) ? optionsExternalFile : (0, (/*@__PURE__*/$parcel$interopDefault($0e6c01aab9a4ae9b$exports))) || {});
const $22cae8e82746fd5e$export$185802fd694ee1f5 = (App, options = (0, $d5fc17b4ecb94b3e$export$2e2bcd8739ae039), optionsExternalFile)=>{
    const redefinedOptions = {
        ...(0, $d5fc17b4ecb94b3e$export$2e2bcd8739ae039),
        ...$22cae8e82746fd5e$var$mergeWithLocalFile(options, optionsExternalFile)
    };
    const domqlApp = (0, $a04f9f910a252074$export$b5b313bfdabf2fb4)(App, redefinedOptions);
    (0, $5b6a3972014f3e94$export$a0eecf521ca4df6c)(domqlApp, redefinedOptions);
    (0, $4747ce2ab72764ea$export$423945072aa2156)(domqlApp, redefinedOptions);
    if (redefinedOptions.on && redefinedOptions.on.create) redefinedOptions.on.create(domqlApp, redefinedOptions);
    return domqlApp;
};
const $22cae8e82746fd5e$export$fa0abf86dcc47d66 = (App, options = (0, $d5fc17b4ecb94b3e$export$2e2bcd8739ae039), optionsExternalFile)=>{
    const redefinedOptions = {
        ...(0, $d5fc17b4ecb94b3e$export$2e2bcd8739ae039),
        ...$22cae8e82746fd5e$var$mergeWithLocalFile(options, optionsExternalFile)
    };
    const domqlApp = (0, $a04f9f910a252074$export$b5b313bfdabf2fb4)(App, redefinedOptions);
    (0, $5b6a3972014f3e94$export$a0eecf521ca4df6c)(domqlApp, redefinedOptions);
    (0, $4747ce2ab72764ea$export$423945072aa2156)(domqlApp, redefinedOptions);
    if (redefinedOptions.on && redefinedOptions.on.create) redefinedOptions.on.create(domqlApp, redefinedOptions);
    const key = options.key || $22cae8e82746fd5e$var$SYMBOLS_KEY;
    (0, $5e586daec44b56de$export$beca342e15b450be)(domqlApp, key, {
        utils: $2a60ce89a661a6b2$exports,
        ...redefinedOptions
    });
    return domqlApp;
};
const $22cae8e82746fd5e$export$df2a74307fafca3b = async (App, options = (0, $d5fc17b4ecb94b3e$export$2e2bcd8739ae039), optionsExternalFile)=>{
    const redefinedOptions = {
        ...(0, $d5fc17b4ecb94b3e$export$2e2bcd8739ae039),
        ...$22cae8e82746fd5e$var$mergeWithLocalFile(options, optionsExternalFile)
    };
    const key = options.key || $22cae8e82746fd5e$var$SYMBOLS_KEY;
    await (0, $5e586daec44b56de$export$8946d631417d8ced)(key, redefinedOptions);
    const domqlApp = (0, $a04f9f910a252074$export$b5b313bfdabf2fb4)(App, redefinedOptions);
    if (redefinedOptions.on && redefinedOptions.on.create) redefinedOptions.on.create(domqlApp, redefinedOptions);
    return domqlApp;
};
var $22cae8e82746fd5e$export$2e2bcd8739ae039 = $22cae8e82746fd5e$export$185802fd694ee1f5;



"use strict";
 // export * from '@symbo.ls/socket/client' // TODO: Check with @nikoloza
 // export * from '@symbo.ls/socket-ui' // TODO: add it soon


var $04288ba364b453ff$exports = {};

$parcel$export($04288ba364b453ff$exports, "components", () => $6aaa67090b542dc0$exports);
$parcel$export($04288ba364b453ff$exports, "snippets", () => $1b6d556216bfb6d1$exports);
$parcel$export($04288ba364b453ff$exports, "pages", () => $2f93c2b81b587020$export$2e2bcd8739ae039);
$parcel$export($04288ba364b453ff$exports, "designSystem", () => $4f3a901bb5ebcc0c$export$2e2bcd8739ae039);
$parcel$export($04288ba364b453ff$exports, "state", () => $9223f18bf47aaa7d$export$2e2bcd8739ae039);
var $6aaa67090b542dc0$exports = {};
var $dc56a4adc2ac47fb$exports = {};

$parcel$export($dc56a4adc2ac47fb$exports, "LoadingLogo", () => $dc56a4adc2ac47fb$export$68d0e267715d85f2);
$parcel$export($dc56a4adc2ac47fb$exports, "Loading", () => $dc56a4adc2ac47fb$export$669f6ea7d267feaf);
let $dc56a4adc2ac47fb$var$logoLoad;
var $2f7c98c0215a07e8$exports = {};
$2f7c98c0215a07e8$exports = new URL("imgloading.bfcb82cf.svg", import.meta.url).toString();


const $dc56a4adc2ac47fb$export$68d0e267715d85f2 = {
    props: {
        flexAlign: "center center"
    },
    Flex: {
        props: {
            align: "center start",
            textAlign: "center",
            width: "100%",
            maxWidth: "G",
            height: "C1",
            transition: "G default, G default, E default",
            transitionProperty: "max-width, transform, opacity",
            overflow: "hidden",
            transform: "scale(1)",
            "!init": {
                opacity: "0",
                transform: "scale(.9)",
                maxWidth: "0"
            },
            ".render": {
                transform: "translate3d(-5%, 0, 0)",
                opacity: "0"
            }
        },
        Img: {
            height: "100%",
            src: new URL($2f7c98c0215a07e8$exports).pathname,
            onLoad: (ev, el, s)=>{
                el.parent.setProps({
                    init: true
                });
                if ($dc56a4adc2ac47fb$var$logoLoad) return;
                $dc56a4adc2ac47fb$var$logoLoad = true;
                setTimeout(()=>{
                    s.update({
                        init: true
                    });
                }, 750);
            }
        }
    }
};
let $dc56a4adc2ac47fb$var$loaded;
const $dc56a4adc2ac47fb$export$669f6ea7d267feaf = {
    extend: "Flex",
    props: {
        flow: "y",
        theme: "document",
        zIndex: 999,
        position: "fixed",
        inset: "0",
        transition: "D default",
        transitionProperty: "opacity, visibility",
        pointerEvents: "auto",
        opacity: 1,
        visibility: "visible",
        ".render": {
            pointerEvents: "none",
            opacity: 0,
            visibility: "hidden"
        },
        onUpdate: (el, s)=>{
            if (!s.init || window.location.pathname === "/" && !s.stripeLoaded || $dc56a4adc2ac47fb$var$loaded) return;
            $dc56a4adc2ac47fb$var$loaded = true;
            s.update({
                render: true
            });
        }
    },
    LoadingLogo: {
        flex: 1
    },
    LightFooter: {}
};


var $5de55eb3ffeabbdf$exports = {};

$parcel$export($5de55eb3ffeabbdf$exports, "Section", () => $5de55eb3ffeabbdf$export$6e2c8f0811a474ce);
$parcel$export($5de55eb3ffeabbdf$exports, "SectionTitle", () => $5de55eb3ffeabbdf$export$69bc41ee738923ec);
$parcel$export($5de55eb3ffeabbdf$exports, "SectionHgroup", () => $5de55eb3ffeabbdf$export$3dcc6f8ff8f0e21b);
const $5de55eb3ffeabbdf$export$6e2c8f0811a474ce = {};
const $5de55eb3ffeabbdf$export$69bc41ee738923ec = {
    tag: "h6",
    props: {
        margin: "Z2 0",
        textTransform: "uppercase",
        text: "NEW ARRIVALS",
        fontWeight: "300",
        fontSize: "Z1",
        opacity: ".5"
    }
};
const $5de55eb3ffeabbdf$export$3dcc6f8ff8f0e21b = {
    extend: "Hgroup",
    props: {
        padding: "B1 -",
        gap: "X2",
        "@tabletS": {
            padding: "B1"
        }
    },
    H4: {
        fontFamily: "Code",
        margin: "0",
        fontWeight: "300",
        text: "New arrivals"
    },
    Span: {
        fontFamily: "Code",
        opacity: "0.5",
        text: "Sprint 23/"
    }
};


var $5f89d3b90f2fb59e$exports = {};

$parcel$export($5f89d3b90f2fb59e$exports, "Polycam", () => $5f89d3b90f2fb59e$export$632c97af570207d4);
const $5f89d3b90f2fb59e$export$632c97af570207d4 = {
    props: {
        background: "#f6f4f3",
        position: "relative"
    },
    Iframe: {
        props: (el, state)=>({
                background: "white .05",
                src: state.view === "360" ? "https://poly.cam/capture/1FAA00D4-032D-4030-AA17-28B87C27A8BC" : state.view === "room" ? "https://poly.cam/capture/9E19E3FA-DB29-4F79-BE22-EC8CAA4FFA09" : "https://poly.cam/capture/0AF39C3B-E953-426F-8AF5-82284C113346",
                allowfullscreen: "",
                loading: "lazy",
                referrerpolicy: "no-referrer-when-downgrade",
                flex: "1",
                minWidth: "0",
                minHeight: "I",
                width: "100%",
                border: "0",
                "@mobileM": {
                    minHeight: "H"
                },
                onMouseenter: (ev, el)=>{
                    el.lookup("content").node.style.overflow = "hidden";
                },
                onMouseleave: (ev, el)=>{
                    el.lookup("content").node.style.overflow = "hidden auto";
                }
            })
    },
    Switcher: {
        props: {
            pointerEvents: "none",
            flexAlign: "center center",
            position: "absolute",
            width: "100%",
            padding: "B1",
            zIndex: 2,
            background: "#f6f4f3",
            bottom: "0"
        },
        childExtend: {
            extend: "Button",
            props: ({ state: state, key: key })=>({
                    active: state.view === key,
                    pointerEvents: "auto",
                    theme: "none",
                    ".active": {
                        theme: "secondary"
                    },
                    onClick: (ev, el, s)=>s.update({
                            view: el.key !== s.view ? el.key : null
                        })
                })
        },
        360: {
            text: "360\xb0"
        },
        "3d-mockup": {
            text: "3d mockup"
        },
        room: {
            text: "room"
        }
    }
};


var $cab2fd0b619d6ee2$exports = {};

$parcel$export($cab2fd0b619d6ee2$exports, "Footer", () => $cab2fd0b619d6ee2$export$a06f1c675e846f6f);
$parcel$export($cab2fd0b619d6ee2$exports, "LightFooter", () => $cab2fd0b619d6ee2$export$4ccc0a5b0bac5da6);
var $d464f8eb96f85b05$exports = {};
$d464f8eb96f85b05$exports = new URL("sprite-vertical.5ef87421.svg", import.meta.url).toString();


const $cab2fd0b619d6ee2$export$a06f1c675e846f6f = {
    props: {
        margin: "auto - -",
        padding: "D1 A A2 0",
        flexAlign: "end space-between",
        textAlign: "center",
        "@tabletS": {
            padding: "D1 A A2"
        }
    },
    Img: {
        height: "D",
        width: "A",
        src: new URL($d464f8eb96f85b05$exports).pathname
    },
    Nav: {
        props: {
            flexFlow: "row",
            gap: "B2",
            "@mobileS": {
                flexAlign: "end center",
                flexFlow: "column",
                gap: "A"
            },
            childProps: {
                fontWeight: "600"
            }
        },
        childExtend: "Link",
        $propsCollection: [
            {
                text: ({ state: state })=>state.lang === "ge" ? "\u10DB\u10D7\u10D0\u10D5\u10D0\u10E0\u10D8" : "Main",
                href: "/"
            },
            {
                text: ({ state: state })=>state.lang === "ge" ? "\u10EC\u10D4\u10E1\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10DE\u10D8\u10E0\u10DD\u10D1\u10D4\u10D1\u10D8" : "Terms and conditions",
                href: "/terms"
            },
            {
                text: ({ state: state })=>state.lang === "ge" ? "\u10D9\u10DD\u10DC\u10E4\u10D8\u10D3\u10D4\u10DC\u10EA\u10D8\u10D0\u10DA\u10E3\u10E0\u10DD\u10D1\u10D8\u10E1 \u10DE\u10D8\u10E0\u10DD\u10D1\u10D4\u10D1\u10D8" : "Privacy Policy",
                href: "/privacy"
            },
            {
                text: ({ state: state })=>state.lang === "ge" ? "\u10DB\u10D8\u10E2\u10D0\u10DC\u10D8\u10E1 \u10DE\u10D8\u10E0\u10DD\u10D1\u10D4\u10D1\u10D8" : "Delivery",
                href: "/delivery"
            },
            {
                text: ({ state: state })=>state.lang === "ge" ? "\u10D3\u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10D8\u10E1 \u10DE\u10D8\u10E0\u10DD\u10D1\u10D4\u10D1\u10D8" : "Return Policy",
                href: "/return"
            },
            {
                text: ({ state: state })=>state.lang === "ge" ? "\u10D9\u10DD\u10DC\u10E2\u10D0\u10E5\u10E2\u10D8" : "Contact",
                href: "/contact"
            }
        ]
    },
    Text: {
        flexAlign: "center end",
        "@tabletS": {
            display: "none"
        },
        text: ({ state: state })=>state.lang === "ge" ? "\u10D0\u10E0\u10E9\u10D8 \xa9 2016 \u10EC\u10DA\u10D8\u10D3\u10D0\u10DC" : "Archy \xa9 Since 2016"
    }
};
const $cab2fd0b619d6ee2$export$4ccc0a5b0bac5da6 = {
    props: {
        padding: "A",
        flexAlign: "center center",
        text: ({ state: state })=>state.lang === "ge" ? "2016 \u10EC\u10EC\u10DA\u10D8\u10D3\u10D0\u10DC" : "Since 2016"
    }
};


var $a2f985d5c5d7bbd6$exports = {};

$parcel$export($a2f985d5c5d7bbd6$exports, "Stripe", () => $a2f985d5c5d7bbd6$export$3c7919ca4c48cda4);
var $3a792863917a3227$exports = {};
$3a792863917a3227$exports = new URL("1.028df186.png", import.meta.url).toString();


var $01cd489002048365$exports = {};
$01cd489002048365$exports = new URL("2.3153368c.png", import.meta.url).toString();


var $ff9238edd9bd76b4$exports = {};
$ff9238edd9bd76b4$exports = new URL("3.35e991de.png", import.meta.url).toString();


var $27aa13de711cb2b6$exports = {};
$27aa13de711cb2b6$exports = new URL("4.85b8e336.png", import.meta.url).toString();


var $b093f00d474d53f7$exports = {};
$b093f00d474d53f7$exports = new URL("5.61ccb990.png", import.meta.url).toString();


var $f0e9bfb3e27d6b50$exports = {};
$f0e9bfb3e27d6b50$exports = new URL("6.5e49d722.png", import.meta.url).toString();


var $6d4d43a19b93e15a$exports = {};
$6d4d43a19b93e15a$exports = new URL("7.f1a0cd18.png", import.meta.url).toString();


var $e69d55df73e496df$export$2e2bcd8739ae039 = [
    (0, (/*@__PURE__*/$parcel$interopDefault($3a792863917a3227$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($01cd489002048365$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($ff9238edd9bd76b4$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($27aa13de711cb2b6$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b093f00d474d53f7$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($f0e9bfb3e27d6b50$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($6d4d43a19b93e15a$exports)))
];


var $c557a21ce36a65fc$exports = {};

/*!
 * imagesLoaded v5.0.0
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */ (function(window1, factory) {
    // universal module definition
    if (0, $c557a21ce36a65fc$exports) // CommonJS
    $c557a21ce36a65fc$exports = factory(window1, (parcelRequire("Vqjah")));
    else // browser global
    window1.imagesLoaded = factory(window1, window1.EvEmitter);
})(typeof window !== "undefined" ? window : $c557a21ce36a65fc$exports, function factory(window1, EvEmitter) {
    let $ = window1.jQuery;
    let console = window1.console;
    // -------------------------- helpers -------------------------- //
    // turn element or nodeList into an array
    function makeArray(obj) {
        // use object if already an array
        if (Array.isArray(obj)) return obj;
        let isArrayLike = typeof obj == "object" && typeof obj.length == "number";
        // convert nodeList to array
        if (isArrayLike) return [
            ...obj
        ];
        // array of single index
        return [
            obj
        ];
    }
    // -------------------------- imagesLoaded -------------------------- //
    /**
 * @param {[Array, Element, NodeList, String]} elem
 * @param {[Object, Function]} options - if function, use as callback
 * @param {Function} onAlways - callback function
 * @returns {ImagesLoaded}
 */ function ImagesLoaded(elem, options, onAlways) {
        // coerce ImagesLoaded() without new, to be new ImagesLoaded()
        if (!(this instanceof ImagesLoaded)) return new ImagesLoaded(elem, options, onAlways);
        // use elem as selector string
        let queryElem = elem;
        if (typeof elem == "string") queryElem = document.querySelectorAll(elem);
        // bail if bad element
        if (!queryElem) {
            console.error(`Bad element for imagesLoaded ${queryElem || elem}`);
            return;
        }
        this.elements = makeArray(queryElem);
        this.options = {};
        // shift arguments if no options set
        if (typeof options == "function") onAlways = options;
        else Object.assign(this.options, options);
        if (onAlways) this.on("always", onAlways);
        this.getImages();
        // add jQuery Deferred object
        if ($) this.jqDeferred = new $.Deferred();
        // HACK check async to allow time to bind listeners
        setTimeout(this.check.bind(this));
    }
    ImagesLoaded.prototype = Object.create(EvEmitter.prototype);
    ImagesLoaded.prototype.getImages = function() {
        this.images = [];
        // filter & find items if we have an item selector
        this.elements.forEach(this.addElementImages, this);
    };
    const elementNodeTypes = [
        1,
        9,
        11
    ];
    /**
 * @param {Node} elem
 */ ImagesLoaded.prototype.addElementImages = function(elem) {
        // filter siblings
        if (elem.nodeName === "IMG") this.addImage(elem);
        // get background image on element
        if (this.options.background === true) this.addElementBackgroundImages(elem);
        // find children
        // no non-element nodes, #143
        let { nodeType: nodeType } = elem;
        if (!nodeType || !elementNodeTypes.includes(nodeType)) return;
        let childImgs = elem.querySelectorAll("img");
        // concat childElems to filterFound array
        for (let img of childImgs)this.addImage(img);
        // get child background images
        if (typeof this.options.background == "string") {
            let children = elem.querySelectorAll(this.options.background);
            for (let child of children)this.addElementBackgroundImages(child);
        }
    };
    const reURL = /url\((['"])?(.*?)\1\)/gi;
    ImagesLoaded.prototype.addElementBackgroundImages = function(elem) {
        let style = getComputedStyle(elem);
        // Firefox returns null if in a hidden iframe https://bugzil.la/548397
        if (!style) return;
        // get url inside url("...")
        let matches = reURL.exec(style.backgroundImage);
        while(matches !== null){
            let url = matches && matches[2];
            if (url) this.addBackground(url, elem);
            matches = reURL.exec(style.backgroundImage);
        }
    };
    /**
 * @param {Image} img
 */ ImagesLoaded.prototype.addImage = function(img) {
        let loadingImage = new LoadingImage(img);
        this.images.push(loadingImage);
    };
    ImagesLoaded.prototype.addBackground = function(url, elem) {
        let background = new Background(url, elem);
        this.images.push(background);
    };
    ImagesLoaded.prototype.check = function() {
        this.progressedCount = 0;
        this.hasAnyBroken = false;
        // complete if no images
        if (!this.images.length) {
            this.complete();
            return;
        }
        /* eslint-disable-next-line func-style */ let onProgress = (image, elem, message)=>{
            // HACK - Chrome triggers event before object properties have changed. #83
            setTimeout(()=>{
                this.progress(image, elem, message);
            });
        };
        this.images.forEach(function(loadingImage) {
            loadingImage.once("progress", onProgress);
            loadingImage.check();
        });
    };
    ImagesLoaded.prototype.progress = function(image, elem, message) {
        this.progressedCount++;
        this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
        // progress event
        this.emitEvent("progress", [
            this,
            image,
            elem
        ]);
        if (this.jqDeferred && this.jqDeferred.notify) this.jqDeferred.notify(this, image);
        // check if completed
        if (this.progressedCount === this.images.length) this.complete();
        if (this.options.debug && console) console.log(`progress: ${message}`, image, elem);
    };
    ImagesLoaded.prototype.complete = function() {
        let eventName = this.hasAnyBroken ? "fail" : "done";
        this.isComplete = true;
        this.emitEvent(eventName, [
            this
        ]);
        this.emitEvent("always", [
            this
        ]);
        if (this.jqDeferred) {
            let jqMethod = this.hasAnyBroken ? "reject" : "resolve";
            this.jqDeferred[jqMethod](this);
        }
    };
    // --------------------------  -------------------------- //
    function LoadingImage(img) {
        this.img = img;
    }
    LoadingImage.prototype = Object.create(EvEmitter.prototype);
    LoadingImage.prototype.check = function() {
        // If complete is true and browser supports natural sizes,
        // try to check for image status manually.
        let isComplete = this.getIsImageComplete();
        if (isComplete) {
            // report based on naturalWidth
            this.confirm(this.img.naturalWidth !== 0, "naturalWidth");
            return;
        }
        // If none of the checks above matched, simulate loading on detached element.
        this.proxyImage = new Image();
        // add crossOrigin attribute. #204
        if (this.img.crossOrigin) this.proxyImage.crossOrigin = this.img.crossOrigin;
        this.proxyImage.addEventListener("load", this);
        this.proxyImage.addEventListener("error", this);
        // bind to image as well for Firefox. #191
        this.img.addEventListener("load", this);
        this.img.addEventListener("error", this);
        this.proxyImage.src = this.img.currentSrc || this.img.src;
    };
    LoadingImage.prototype.getIsImageComplete = function() {
        // check for non-zero, non-undefined naturalWidth
        // fixes Safari+InfiniteScroll+Masonry bug infinite-scroll#671
        return this.img.complete && this.img.naturalWidth;
    };
    LoadingImage.prototype.confirm = function(isLoaded, message) {
        this.isLoaded = isLoaded;
        let { parentNode: parentNode } = this.img;
        // emit progress with parent <picture> or self <img>
        let elem = parentNode.nodeName === "PICTURE" ? parentNode : this.img;
        this.emitEvent("progress", [
            this,
            elem,
            message
        ]);
    };
    // ----- events ----- //
    // trigger specified handler for event type
    LoadingImage.prototype.handleEvent = function(event) {
        let method = "on" + event.type;
        if (this[method]) this[method](event);
    };
    LoadingImage.prototype.onload = function() {
        this.confirm(true, "onload");
        this.unbindEvents();
    };
    LoadingImage.prototype.onerror = function() {
        this.confirm(false, "onerror");
        this.unbindEvents();
    };
    LoadingImage.prototype.unbindEvents = function() {
        this.proxyImage.removeEventListener("load", this);
        this.proxyImage.removeEventListener("error", this);
        this.img.removeEventListener("load", this);
        this.img.removeEventListener("error", this);
    };
    // -------------------------- Background -------------------------- //
    function Background(url, element) {
        this.url = url;
        this.element = element;
        this.img = new Image();
    }
    // inherit LoadingImage prototype
    Background.prototype = Object.create(LoadingImage.prototype);
    Background.prototype.check = function() {
        this.img.addEventListener("load", this);
        this.img.addEventListener("error", this);
        this.img.src = this.url;
        // check if image is already complete
        let isComplete = this.getIsImageComplete();
        if (isComplete) {
            this.confirm(this.img.naturalWidth !== 0, "naturalWidth");
            this.unbindEvents();
        }
    };
    Background.prototype.unbindEvents = function() {
        this.img.removeEventListener("load", this);
        this.img.removeEventListener("error", this);
    };
    Background.prototype.confirm = function(isLoaded, message) {
        this.isLoaded = isLoaded;
        this.emitEvent("progress", [
            this,
            this.element,
            message
        ]);
    };
    // -------------------------- jQuery -------------------------- //
    ImagesLoaded.makeJQueryPlugin = function(jQuery) {
        jQuery = jQuery || window1.jQuery;
        if (!jQuery) return;
        // set local variable
        $ = jQuery;
        // $().imagesLoaded()
        $.fn.imagesLoaded = function(options, onAlways) {
            let instance = new ImagesLoaded(this, options, onAlways);
            return instance.jqDeferred.promise($(this));
        };
    };
    // try making plugin
    ImagesLoaded.makeJQueryPlugin();
    // --------------------------  -------------------------- //
    return ImagesLoaded;
});


const $a2f985d5c5d7bbd6$var$RATIO_FULL = 1800;
let $a2f985d5c5d7bbd6$var$loaded;
const $a2f985d5c5d7bbd6$var$preloadImages = (selector = "img", el)=>{
    return new Promise((resolve)=>{
        // The imagesLoaded library is used to ensure all images (including backgrounds) are fully loaded.
        (0, (/*@__PURE__*/$parcel$interopDefault($c557a21ce36a65fc$exports)))(document.querySelectorAll(selector), {
            background: true
        }, resolve);
    });
};
const $a2f985d5c5d7bbd6$export$3c7919ca4c48cda4 = {
    props: {
        flexFlow: "row",
        flex: 1,
        position: "absolute",
        inset: "0",
        boxSize: "100%",
        userSelect: "none",
        "!imgsLoaded": {
            "& picture": {
                widthRange: "0"
            }
        },
        onRender: (el, s)=>{
            setTimeout(()=>{
                $a2f985d5c5d7bbd6$var$preloadImages(".sprite-img", el).then(()=>{
                    s.update({
                        stripeLoaded: true
                    });
                });
            }, 150);
        },
        onUpdate: (el, s)=>{
            if (!s.render || !s.stripeLoaded || $a2f985d5c5d7bbd6$var$loaded) return;
            $a2f985d5c5d7bbd6$var$loaded = true;
            el.setProps({
                imgsLoaded: true
            });
        }
    },
    on: {
        init: ()=>{
            $a2f985d5c5d7bbd6$var$loaded = false;
        }
    },
    childExtend: {
        extend: "Picture",
        props: ({ props: props, key: key })=>({
                transition: "G default min-width, G default max-width, E default filter 0s, E default opacity 0s",
                transitionDelay: parseInt(key) * 35 + 100 + "ms",
                height: "100%",
                overflow: "hidden",
                position: "absolute",
                top: 0,
                left: `${(props.offset || 0) / $a2f985d5c5d7bbd6$var$RATIO_FULL * 100}%`,
                widthRange: `${props.ratio / $a2f985d5c5d7bbd6$var$RATIO_FULL * 100}%`,
                ":not(:hover)": {
                    opacity: ".5",
                    mixBlendMode: "luminosity"
                }
            }),
        Img: ({ key: key })=>({
                class: "sprite-img",
                transformOrigin: "50% 50%",
                position: "absolute",
                height: "100%",
                pointerEvents: "none",
                src: (0, $e69d55df73e496df$export$2e2bcd8739ae039)[key],
                transition: "G transform default",
                transform: "translate3d(-50%, 0, 1px)"
            })
    },
    $propsCollection: [
        {
            ratio: 194,
            Img: {
                left: "50%"
            }
        },
        {
            ratio: 357,
            offset: 207,
            Img: {
                left: "50%"
            }
        },
        {
            ratio: 194,
            offset: 594,
            Img: {
                left: "50%"
            }
        },
        {
            ratio: 233,
            offset: 801,
            Img: {
                left: "50%"
            }
        },
        {
            ratio: 135,
            offset: 1129,
            Img: {
                left: "50%"
            }
        },
        {
            ratio: 195,
            offset: 1345,
            Img: {
                left: "50%"
            }
        },
        {
            ratio: 236,
            offset: 1562,
            Img: {
                left: "50%"
            }
        }
    ]
};


var $01a2414ae03e44e6$exports = {};

$parcel$export($01a2414ae03e44e6$exports, "Hero", () => $01a2414ae03e44e6$export$887967f05dc521ae);
const $01a2414ae03e44e6$export$887967f05dc521ae = {
    extend: "Flex",
    props: {
        flexAlign: "center start",
        background: "black",
        position: "relative",
        maxHeight: "100dvh",
        boxSize: "100%"
    },
    Stripe: {},
    Leading: {
        props: {
            color: "white",
            margin: "5% 10%",
            pointerEvents: "none",
            position: "relative",
            "@tabletS": {
                margin: "C1 B"
            }
        },
        H6: {
            margin: "- - Z Z",
            fontWeight: "200",
            opacity: ".65",
            fontFamily: "Code",
            text: ({ state: state })=>state.lang === "en" ? "Spring 23/" : "\u10D2\u10D0\u10D6\u10D0\u10E4\u10EE\u10E3\u10DA\u10D8 23/"
        },
        H1: {
            props: ({ state: state })=>({
                    margin: 0,
                    fontWeight: "700",
                    fontSize: "16vh",
                    lineHeight: "1.2",
                    maxWidth: "50%",
                    fontFamily: "UI",
                    GE: state.lang === "ge",
                    text: state.lang === "en" ? "Ninja Collection" : "\u10D9\u10DD\u10DA\u10D4\u10E5\u10EA\u10D8\u10D0 \u10DC\u10D8\u10DC\u10EB\u10D0",
                    ".GE": {
                        fontWeight: "400",
                        letterSpacing: ".15ch",
                        fontFamily: "GE"
                    },
                    "@tabletS": {
                        fontSize: "16vmin"
                    }
                })
        },
        Button: {
            margin: "10% - - A1",
            padding: "A B2",
            round: "0",
            text: ({ state: state })=>state.lang === "en" ? "Check it out" : "\u10D9\u10DD\u10DA\u10D4\u10E5\u10EA\u10D8\u10D8\u10E1 \u10DC\u10D0\u10EE\u10D5\u10D0",
            pointerEvents: "auto",
            transition: "C default",
            transitionProperty: "color, background, padding, margin, font-weight",
            ":hover": {
                // fontWeight: 700,
                theme: "secondary"
            },
            onClick: (ev, el)=>{
                el.__ref.__root.content.node.scrollTo({
                    top: window.innerHeight,
                    behavior: "smooth"
                });
            }
        }
    }
};


var $c4735fa6f7a09f88$exports = {};

$parcel$export($c4735fa6f7a09f88$exports, "Sidebar", () => $c4735fa6f7a09f88$export$1ba59dacbcbf90fe);
const $c4735fa6f7a09f88$export$1ba59dacbcbf90fe = {
    extend: "Flex",
    props: {
        position: "sticky",
        flow: "column",
        top: "0",
        background: "white",
        widthRange: "E",
        padding: "A2 B",
        height: "100%",
        align: "start space-between",
        zIndex: 10,
        "@tabletS": {
            align: "center space-between",
            widthRange: "100%",
            boxShadow: "0, 0, C3, black .35",
            height: "D",
            flow: "row"
        }
    },
    Link: {
        props: {
            top: "A2",
            left: "-A2",
            position: "absolute",
            transform: "rotateZ(-90deg)",
            transformOrigin: "50% 50%",
            href: "/",
            color: "black",
            "@tabletS": {
                top: "-A2+X",
                left: "A2",
                transform: "rotateZ(0)"
            }
        },
        Icon: {
            name: "logo",
            fontSize: "7.5em"
        }
    },
    Menu: {
        extend: "Flex",
        props: {
            margin: "B1 - - F",
            gap: "C",
            fontFamily: "Code",
            textTransform: "uppercase",
            transform: "scale(-1, -1)",
            writingMode: "tb",
            "@tabletS": {
                margin: "0 0 0 F_default",
                writingMode: "lr",
                transform: "scale(1)"
            },
            "@mobileM": {
                margin: "0 0 0 E3_default"
            }
        },
        childExtend: {
            extend: "Link",
            props: ({ props: props })=>({
                    active: props.href === window.location.pathname || props.href === "/" && window.location.pathname !== "/studio",
                    ".active": {
                        fontWeight: 700,
                        "@mobileM": {
                            display: "none"
                        }
                    },
                    "!active": {
                        fontWeight: 400
                    }
                })
        },
        Store: {
            // text: 'Store',
            text: ({ state: state })=>state.lang === "en" ? "Store" : "\u10DB\u10D0\u10E6\u10D0\u10D6\u10D8\u10D0",
            href: "/"
        },
        Studio: {
            text: ({ state: state })=>state.lang === "en" ? "Studio" : "\u10E1\u10E2\u10E3\u10D3\u10D8\u10D0",
            href: "/studio",
            order: -1
        }
    },
    Box: {
        props: {
            margin: "auto 0 0",
            fontFamily: "Code",
            flexFlow: "column",
            gap: "X",
            cursor: "pointer",
            "@tabletS": {
                margin: "0"
            },
            onClick: (ev, el, s)=>s.toggle("openCart")
        },
        Icon: {
            icon: "cart"
        }
    },
    Lang: {
        props: ({ state: state })=>({
                margin: "B 0 0",
                text: state.lang === "ge" ? "Eng" : "Geo",
                fontFamily: "Code",
                "@tabletS": {
                    margin: "0 0 0"
                },
                onClick: (ev, el, s)=>{
                    s.update({
                        lang: state.lang === "ge" ? "en" : "ge"
                    });
                }
            })
    },
    Aside: {
        extend: "Flex",
        props: {
            flow: "y",
            align: "center space-between",
            gap: "C",
            position: "absolute",
            width: "G",
            verticalInset: "0",
            left: "100%",
            background: "white",
            padding: "A2 C2 A2 -",
            overflow: "hidden",
            transition: "C default, D default",
            transitionProperty: "max-width, box-shadow, padding, opacity",
            zIndex: 2,
            "@tabletS": {
                position: "fixed",
                left: 0
            },
            ".openCart": {
                padding: "A2 C2 A2 -",
                maxWidth: "G",
                boxShadow: "D1, 0, D1, -A, black .35"
            },
            "!openCart": {
                padding: "A2 0 A2 -",
                maxWidth: "0"
            }
        },
        Cart: {
            extend: "Flex",
            props: {
                minWidth: "G-C2",
                overflow: "hidden auto",
                flow: "y",
                gap: "A2"
            },
            childExtend: "ProductItemSmall",
            $propsCollection: [
                {
                },
                {
                    Img: {
                        src: "https://p194.p3.n0.cdn.zight.com/items/9Zu4DBeX/5bf7e9dd-f978-412a-bb8d-79eac379d167.png?v=39749525be280da55259d24a856f0e99"
                    }
                }
            ]
        },
        "Link+Button": {
            margin: "auto 0 0",
            theme: "secondary",
            padding: "Z2 B2",
            fontWeight: "300",
            gap: "X",
            reverse: true,
            icon: "arrow right",
            href: "/checkout",
            text: ({ state: state })=>state.__root.lang === "en" ? "Order" : "\u10E8\u10D4\u10E3\u10D9\u10D5\u10D4\u10D7\u10D4"
        }
    },
    Fade: {
        zIndex: 1,
        flow: "y",
        align: "center space-between",
        gap: "C",
        position: "absolute",
        verticalInset: "0",
        left: "100%",
        background: "white .35",
        width: "100vw",
        transition: "D default",
        transitionProperty: "visibility, opacity",
        onClick: (ev, el, s)=>s.toggle("openCart"),
        ".openCart": {
            opacity: 1,
            visibility: "visible",
            pointerEvents: "auto"
        },
        "!openCart": {
            opacity: 0,
            visibility: "hidden",
            pointerEvents: "none"
        }
    }
};


var $8009b06449c96910$exports = {};

$parcel$export($8009b06449c96910$exports, "ProductItem", () => $8009b06449c96910$export$38dd9abaed3bfffb);
$parcel$export($8009b06449c96910$exports, "ProductItemSmall", () => $8009b06449c96910$export$abecb7133d971ee1);
$parcel$export($8009b06449c96910$exports, "ProductItemLarge", () => $8009b06449c96910$export$12ec31132b036650);
const $8009b06449c96910$export$38dd9abaed3bfffb = {
    extend: [
        "Flex"
    ],
    state: {},
    props: {
        href: "/item",
        flow: "column",
        position: "relative",
        align: "center center",
        gap: "Y",
        ":hover img": {
            transform: "scale(.95)"
        }
    },
    Img: {
        aspectRatio: "3 / 5",
        width: "100%",
        src: "https://p194.p3.n0.cdn.zight.com/items/E0uJon0N/11d817f1-ed88-411b-a5e7-5da4da83160f.png?v=66acc890569c52def3b99c5bc7b8d310",
        opacity: 0,
        transition: "C default",
        transitionProperty: "opacity, transform",
        onLoad: (ev, el, s)=>{
            el.node.style.opacity = 1;
        }
    },
    Link: {
        position: "absolute",
        inset: "0",
        href: "/item"
    },
    TakeIt: {
        zIndex: 2
    }
};
const $8009b06449c96910$export$abecb7133d971ee1 = {
    extend: [
        "ProductItem"
    ],
    state: {},
    props: {},
    Img: {
        maxWidth: "E1"
    },
    Link: {
        position: "absolute",
        inset: "0",
        href: "/item"
    },
    IncDecButton: {
        minWidth: "D3",
        zIndex: 2
    },
    TakeIt: null
};
const $8009b06449c96910$export$12ec31132b036650 = {
    extend: "ProductItem",
    props: {},
    Img: {
        aspectRatio: "5 / 3"
    },
    Link: {},
    Flex: {
        props: {
            width: "100%",
            align: "start space-between",
            padding: "B"
        },
        Hgroup: {
            props: {},
            H3: {
                margin: "0",
                text: "Pendant Lights simple"
            },
            P: {
                margin: "0",
                opacity: "0.5",
                fontWeight: "400",
                text: ({ state: state })=>(state.__root.lang === "en" ? "price: " : "\u10E4\u10D0\u10E1\u10D8: ") + "420,35" + (state.__root.lang === "en" ? " GEL" : " \u10DA\u10D0\u10E0\u10D8")
            }
        },
        TakeIt: {
            zIndex: 2,
            margin: "-Z -A - -"
        }
    },
    TakeIt: null
};


var $bbda98531ed22a49$exports = {};

$parcel$export($bbda98531ed22a49$exports, "ProductRowLarge", () => $bbda98531ed22a49$export$de86aa108e0f15ce);
$parcel$export($bbda98531ed22a49$exports, "ProductRowMid", () => $bbda98531ed22a49$export$38b5ffc0375f50ad);
$parcel$export($bbda98531ed22a49$exports, "ProductRow", () => $bbda98531ed22a49$export$3a2181fd16910101);
const $bbda98531ed22a49$export$de86aa108e0f15ce = {
    extend: "Grid",
    props: {
        columns: "repeat(2, 1fr)",
        padding: "B1 B1 B1 -",
        gap: "A",
        "@tabletS": {
            padding: "B1 B1 B1 B1",
            columns: "repeat(1, 1fr)"
        }
    },
    childExtend: "ProductItemLarge",
    $propsCollection: [
        {
        },
        {
            Img: {
                src: "https://p194.p3.n0.cdn.zight.com/items/9Zu4DBeX/5bf7e9dd-f978-412a-bb8d-79eac379d167.png?v=39749525be280da55259d24a856f0e99"
            }
        }
    ]
};
const $bbda98531ed22a49$export$38b5ffc0375f50ad = {
    props: {
        padding: "B1 B1 B1 -",
        "@tabletS": {
            padding: "B1 B1 B1 B1"
        }
    },
    SectionTitle: {
        text: "NEW ARRIVALS",
        fontWeight: "300"
    },
    Grid: {
        props: {
            gap: "A",
            columns: "repeat(6, 1fr)",
            "@tabletM": {
                columns: "repeat(4, 1fr)"
            },
            "@tabletS": {
                columns: "repeat(3, 1fr)"
            },
            "@mobileL": {
                columns: "repeat(2, 1fr)"
            }
        },
        childExtend: "ProductItem"
    }
};
const $bbda98531ed22a49$export$3a2181fd16910101 = {
    extend: "Flex",
    props: {
        flow: "column",
        gap: "B1"
    },
    ProductRowLarge: {},
    ProductRowMid: {
        props: {},
        SectionTitle: {},
        Grid: {
            $propsCollection: [
                {
                    Img: {
                        src: "https://p194.p3.n0.cdn.zight.com/items/12ub0rxv/17c3d116-caf5-49dd-a197-19da8b719711.png?v=7b927c17cd6c05a85e665b1c2ef1f96b"
                    }
                },
                {
                    Img: {
                        src: "https://p194.p3.n0.cdn.zight.com/items/Bluqd1jR/c996b919-3ee7-4382-b48e-0d1538818c9f.png?v=dbf6588e14144623488cafc49708bedf"
                    }
                },
                {
                    Img: {
                        src: "https://p194.p3.n0.cdn.zight.com/items/7Kunq8Br/73ecee1a-1433-4892-9d29-811a6e215f5e.png?v=e79203942e6fec2fa6d07de18a48727a"
                    }
                },
                {
                    Img: {
                        src: "https://p194.p3.n0.cdn.zight.com/items/KouKYwOv/f328f184-2351-4472-bf9a-d4aeaa15f226.png?v=3db1c2cc365cdbb361a4684d92dca005"
                    }
                },
                {
                    Img: {
                        src: "https://p194.p3.n0.cdn.zight.com/items/DOuJm9ee/1a994391-0dd1-4e7b-bba6-1da4b54d666f.png?v=bd80fb8261de67040ea62d43931e703a"
                    }
                },
                {
                    Img: {
                        src: "https://p194.p3.n0.cdn.zight.com/items/P8uw6yvp/11e3918b-d828-4709-8174-10953ed9e140.png?v=daa125996b73e76dec7172e6a47810cb"
                    }
                }
            ]
        }
    }
};


var $09857fae07e92be5$exports = {};

$parcel$export($09857fae07e92be5$exports, "ImageLogo", () => $09857fae07e92be5$export$7e8c7d21951cc1a8);
const $09857fae07e92be5$export$7e8c7d21951cc1a8 = {
    extend: "Flex",
    Svg: {
        props: {
            html: '<svg height="147" viewBox="0 0 109 147" width="109" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><pattern id="a" height="100%" width="108.354%" x="-8.354%"><image height="283" transform="scale(.53004)" width="242" xlink:href="data:image/png;base64,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"/></pattern><path id="b" d="m80.7718503 83.0798332-1.0324189-2.3341801c14.1845688-6.8289427 23.9843416-21.4149391 23.9843416-38.308813 0-23.437244-18.8595461-42.4368401-42.124775-42.4368401h-39.2431032v22.5346843h39.2431032c10.9112644 0 19.7554527 8.9106167 19.7554527 19.9021558 0 10.992291-8.8441883 19.9021557-19.7554527 19.9021557h-10.9105181-38.9238291v.0097698h-11.7646508v84.6512344h22.3558948v-62.1255681h36.1906051l27.6283915 62.0338841h-.5296363v.091684h21.8695239v-.091684h1.485221l-21.8695243-49.4506538z"/><mask id="c" fill="#fff"><use fill="#fff" fill-rule="evenodd" xlink:href="#b"/></mask></defs><g fill="none" fill-rule="evenodd"><use fill="#000" fill-rule="nonzero" xlink:href="#b"/><path d="m-.765-1.507h109.905v150h-109.905z" fill="url(#a)" mask="url(#c)"/></g></svg>'
        }
    }
};


var $f8d9046c79318a49$exports = {};

$parcel$export($f8d9046c79318a49$exports, "TakeIt", () => $f8d9046c79318a49$export$fbbacd572cb076e7);
const $f8d9046c79318a49$export$fbbacd572cb076e7 = {
    extend: "Button",
    props: {
        theme: null,
        position: "relative",
        background: "transparent",
        icon: "plus",
        gap: "X",
        padding: "Z2 A",
        text: ({ state: state })=>state.__root.lang === "en" ? "take it" : "\u10D3\u10D0\u10D0\u10DB\u10D0\u10E2\u10D4",
        onClick: (ev, el, s)=>s.__root.toggle("openCart")
    }
};


var $fef8c2d1d5ed66e5$exports = {};

$parcel$export($fef8c2d1d5ed66e5$exports, "IncDecButton", () => $fef8c2d1d5ed66e5$export$843842ec2f91b9a1);
const $fef8c2d1d5ed66e5$export$843842ec2f91b9a1 = {
    extend: [
        "Flex"
    ],
    props: {
        flex: "1",
        border: "1px, solid, border",
        borderRadius: "A",
        padding: "0 W",
        borderColor: "currentColor",
        align: "center space-between",
        color: "currentColor",
        maxWidth: "F",
        lineHeight: "1"
    },
    SquareButton_minu: {
        props: {
            icon: "minus",
            fontWeight: "700",
            background: "transparent",
            lineHeight: "1",
            padding: "X",
            border: "none",
            color: "currentColor",
            aspectRatio: "1/1",
            round: "A",
            boxSize: "A",
            ":hover": {
                background: "white .25"
            }
        },
        on: {
            click: (ev, el, s)=>s.__root.order.quantity > 1 && s.rootUpdate({
                    order: {
                        quantity: s.__root.order.quantity - 1
                    }
                })
        }
    },
    span2: {
        text: ({ state: state })=>state.__root.order.quantity,
        props: {
            lineHeight: "1.8"
        }
    },
    SquareButton_plus: {
        tag: "button",
        props: {
            icon: "plus",
            fontWeight: "700",
            background: "transparent",
            lineHeight: "1",
            padding: "X",
            border: "none",
            color: "currentColor",
            aspectRatio: "1/1",
            round: "A",
            boxSize: "A",
            ":hover": {
                background: "white .25"
            }
        },
        on: {
            click: (ev, el, s)=>s.__root.order.quantity < 30 && s.rootUpdate({
                    order: {
                        quantity: s.__root.order.quantity + 1
                    }
                })
        }
    }
};


$parcel$exportWildcard($6aaa67090b542dc0$exports, $dc56a4adc2ac47fb$exports);
$parcel$exportWildcard($6aaa67090b542dc0$exports, $5de55eb3ffeabbdf$exports);
$parcel$exportWildcard($6aaa67090b542dc0$exports, $5f89d3b90f2fb59e$exports);
$parcel$exportWildcard($6aaa67090b542dc0$exports, $cab2fd0b619d6ee2$exports);
$parcel$exportWildcard($6aaa67090b542dc0$exports, $a2f985d5c5d7bbd6$exports);
$parcel$exportWildcard($6aaa67090b542dc0$exports, $01a2414ae03e44e6$exports);
$parcel$exportWildcard($6aaa67090b542dc0$exports, $c4735fa6f7a09f88$exports);
$parcel$exportWildcard($6aaa67090b542dc0$exports, $8009b06449c96910$exports);
$parcel$exportWildcard($6aaa67090b542dc0$exports, $bbda98531ed22a49$exports);
$parcel$exportWildcard($6aaa67090b542dc0$exports, $09857fae07e92be5$exports);
$parcel$exportWildcard($6aaa67090b542dc0$exports, $f8d9046c79318a49$exports);
$parcel$exportWildcard($6aaa67090b542dc0$exports, $fef8c2d1d5ed66e5$exports);


var $1b6d556216bfb6d1$exports = {};


const $382aee6e54bfb983$export$f22da7240b7add18 = {
    Hero: {},
    Spacing: {
        boxSize: "D1"
    },
    ProductRow: {},
    Footer: {}
};


const $4ac81149468225c7$export$b79f4e85220631d7 = {
    props: {},
    SectionHgroup: {},
    ProductRow: {},
    Footer: {
        margin: "auto - -"
    }
};


const $67c35965dde2b630$export$414d047e665c7112 = {
    props: {
        flexFlow: "column"
    },
    Box: {
        props: {
            flexFlow: "column",
            width: "100%",
            margin: "0 auto",
            maxWidth: "J",
            gap: "B",
            padding: "B B -"
        },
        Box: {
            tag: "article",
            props: {},
            H1: {
                fontWeight: "400",
                text: "Contact"
            },
            P: {
                maxWidth: "48%",
                margin: "X - B1",
                text: "Welcome to Tbilisi's premier interior design company, where elegance meets comfort. Explore our curated collection of exquisite furniture goods, crafted to elevate any space. From sleek modern designs to timeless classics, find the perfect pieces to express your style. Welcome to a world of luxury and sophistication."
            }
        },
        Address: {
            extend: "Flex",
            props: {
                margin: "- - B2",
                gap: "C1",
                childProps: {
                    width: "F3"
                },
                "@mobileM": {
                    flow: "y"
                }
            },
            Flex: {
                props: {
                    flow: "y",
                    childProps: {
                        margin: "0"
                    }
                },
                H6: {
                    text: ({ state: state })=>state.lang === "en" ? "Phone" : "\u10E2\u10D4\u10DA\u10D4\u10E4\u10DD\u10DC\u10D8"
                },
                P: {
                    text: "+995 593 745 453"
                },
                P_2: {
                    text: "+995 571 811 000"
                }
            },
            Flex_phone: {
                props: {
                    flow: "y",
                    childProps: {
                        margin: "0"
                    }
                },
                H6: {
                    text: ({ state: state })=>state.lang === "en" ? "Address" : "\u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D8"
                },
                P: {
                    text: ({ state: state })=>state.lang === "en" ? "David Guramishvili av. 78, Block D" : "\u10D3\u10D0\u10D5\u10D8\u10D7 \u10D2\u10E3\u10E0\u10D0\u10DB\u10D8\u10E8\u10D5\u10D8\u10DA\u10D8 \u10D2\u10D0\u10DB\u10D6. 78, \u10D1\u10DA\u10DD\u10D9\u10D8 D."
                },
                P_2: {
                    text: ({ state: state })=>state.lang === "en" ? "Tbilisi, Georgia" : "\u10D7\u10D1\u10D8\u10DA\u10D8\u10E1\u10D8, \u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD"
                }
            }
        },
        Box_2: {
            tag: "article",
            props: {},
            H6: {
                margin: "0 0 X",
                text: ({ state: state })=>state.lang === "en" ? "Contact" : "\u10D9\u10DD\u10DC\u10E2\u10D0\u10E5\u10E2\u10D8"
            },
            Flex: {
                props: {
                    gap: "C1"
                },
                childExtend: "P",
                Form: {
                    props: {
                        flexFlow: "column",
                        flexAlign: "start start",
                        flex: 1,
                        gap: "A"
                    },
                    "Input.name": {
                        round: "X",
                        theme: "dialog",
                        placeholder: "Name"
                    },
                    "Input.email": {
                        round: "X",
                        theme: "dialog",
                        placeholder: "Email"
                    },
                    "Input.phone": {
                        round: "X",
                        theme: "dialog",
                        placeholder: "Phone"
                    },
                    "Textarea.contact": {
                        round: "X",
                        theme: "dialog",
                        placeholder: "Phone"
                    },
                    Button: {
                        round: "0",
                        theme: "secondary",
                        type: "submit",
                        text: "Submit"
                    }
                }
            }
        }
    },
    Footer: {
        margin: "auto - -"
    }
};



"use strict";
const $0137ee424137bfa9$var$Static = {
    extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
    props: {
        flow: "column",
        content: {
            flex: 1,
            margin: "C1 auto E",
            maxWidth: "J",
            "@tabletS": {
                padding: "B1"
            }
        },
        "& h5": {
            margin: "0 - Z"
        }
    },
    LogoHeader: {},
    Footer: {
        order: 3
    }
};
const $0137ee424137bfa9$export$8a21ba990ca4a7cb = {
    extend: $0137ee424137bfa9$var$Static,
    LogoHeader: {},
    content: {
        extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
        props: {
            flow: "column"
        },
        H2: {
            order: -1,
            text: "\u10EC\u10D4\u10E1\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10DE\u10D8\u10E0\u10DD\u10D1\u10D4\u10D1\u10D8"
        },
        ...[
            {
                childExtend: (0, $b448a4a1f1311a88$export$56c0d5a1e737357d),
                $propsCollection: [
                    '\u10EC\u10D8\u10DC\u10D0\u10DB\u10D3\u10D4\u10D1\u10D0\u10E0\u10D4 \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D8 \u10D0\u10E0\u10D8\u10E1 "Archy"-\u10E1 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D8\u10D7 \u10E1\u10D0\u10E0\u10D2\u10D4\u10D1\u10DA\u10DD\u10D1\u10D8\u10E1 \u10EC\u10D4\u10E1\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10DE\u10D8\u10E0\u10DD\u10D1\u10D4\u10D1\u10D8.',
                    '\u10EC\u10D8\u10DC\u10D0\u10DB\u10D3\u10D4\u10D1\u10D0\u10E0\u10D4 \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D8 \u10D0\u10E0\u10D8\u10E1 \u10DD\u10E0\u10DB\u10EE\u10E0\u10D8\u10D5\u10D0\u10D3 \u10DB\u10D0\u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10D4\u10D1\u10D4\u10DA\u10D8 \u10EE\u10D4\u10DA\u10E8\u10D4\u10D9\u10E0\u10E3\u10DA\u10D4\u10D1\u10D0, \u10E0\u10DD\u10DB\u10D4\u10DA\u10D8\u10EA \u10E4\u10DD\u10E0\u10DB\u10D3\u10D4\u10D1\u10D0 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10E1\u10D0 \u10D3\u10D0 \u10E8\u10DE\u10E1 \u10D0\u10E0\u10E9\u10D8\u10E1 \u10E8\u10DD\u10E0\u10D8\u10E1. \u10E8\u10DE\u10E1 \u10D0\u10E0\u10E9\u10D8 (\u10E1.\u10DC. 400232798) \u10E0\u10D4\u10D2\u10D8\u10E1\u10E2\u10E0\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8 \u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D8 - \u10D3\u10D0\u10D5\u10D8\u10D7 \u10D2\u10E3\u10E0\u10D0\u10DB\u10D8\u10E8\u10D5\u10D8\u10DA\u10D8 \u10D2\u10D0\u10DB\u10D6. 78, \u10D1\u10DA\u10DD\u10D9\u10D8 D.  \u1CA8\u10D4\u10DB\u10D3\u10D2\u10DD\u10DB\u10E8\u10D8 \u10DB\u10DD\u10EE\u10E1\u10D4\u10DC\u10D8\u10D4\u10D1\u10E3\u10DA\u10D8 \u10E0\u10DD\u10D2\u10DD\u10E0\u10EA "Archy" (\u10D0\u10E0\u10E9\u10D8)',
                    '"\u10E8\u10DE\u10E1 \u10D0\u10E0\u10E9\u10D8" \u10EC\u10D8\u10DC\u10D0\u10DB\u10D3\u10D4\u10D1\u10D0\u10E0\u10D4 \u10E1\u10D0\u10E0\u10D2\u10D4\u10D1\u10DA\u10DD\u10D1\u10D8\u10E1 \u10EC\u10D4\u10E1\u10D4\u10D1\u10E1\u10D0 \u10D3\u10D0 \u10DE\u10D8\u10E0\u10DD\u10D1\u10D4\u10D1\u10E8\u10D8, \u10D9\u10DD\u10DC\u10E4\u10D8\u10D3\u10D4\u10DC\u10EA\u10D8\u10D0\u10DA\u10E3\u10E0\u10DD\u10D1\u10D8\u10E1 \u10DE\u10DD\u10DA\u10D8\u10E2\u10D8\u10D9\u10D0\u10E8\u10D8 \u10D3\u10D0 \u10E7\u10D5\u10D4\u10DA\u10D0 \u10E1\u10EE\u10D5\u10D0 \u10E1\u10D0\u10EE\u10D4\u10DA\u10DB\u10EB\u10E6\u10D5\u10D0\u10DC\u10D4\u10DA\u10DD\u10E1\u10D0 \u10D3\u10D0 \u10D8\u10DC\u10E1\u10E2\u10E0\u10E3\u10E5\u10EA\u10D8\u10D0\u10E8\u10D8 \u10E8\u10D4\u10DB\u10D3\u10D2\u10DD\u10DB\u10E8\u10D8 \u10DB\u10DD\u10EE\u10E1\u10D4\u10DC\u10D8\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D8\u10E5\u10DC\u10D4\u10D1\u10D0 \u10E0\u10DD\u10D2\u10DD\u10E0\u10EA \u201EArchy\u201D (\u10D0\u10E0\u10E9\u10D8).',
                    '"Archy"-\u10E1 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D8\u10D7 \u10E1\u10D0\u10E0\u10D2\u10D4\u10D1\u10DA\u10DD\u10D1\u10D8\u10E1 \u10EC\u10D4\u10E1\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10DE\u10D8\u10E0\u10DD\u10D1\u10D4\u10D1\u10D8, \u10DB\u10D0\u10E1\u10E8\u10D8 \u10E8\u10D4\u10E2\u10D0\u10DC\u10D8\u10DA \u10EA\u10D5\u10DA\u10D8\u10DA\u10D4\u10D1\u10D4\u10D1\u10D7\u10D0\u10DC \u10D3\u10D0 "Archy"-\u10E1 \u10E1\u10EE\u10D5\u10D0 \u10E0\u10D4\u10D2\u10E3\u10DA\u10D0\u10EA\u10D8\u10D4\u10D1\u10D7\u10D0\u10DC \u10D4\u10E0\u10D7\u10D0\u10D3 \u10EC\u10D0\u10E0\u10DB\u10DD\u10D0\u10D3\u10D2\u10D4\u10DC\u10D4\u10DC \u10D4\u10E0\u10D7\u10D8\u10D0\u10DC \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10E1 \u10D3\u10D0 \u10D2\u10D0\u10DC\u10EE\u10D8\u10DA\u10E3\u10DA \u10E3\u10DC\u10D3\u10D0 \u10D8\u10E5\u10DC\u10D4\u10E1 \u10E0\u10DD\u10D2\u10DD\u10E0\u10EA \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D7\u10D0\u10DC \u10D2\u10D0\u10E4\u10DD\u10E0\u10DB\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D4\u10E0\u10D7\u10D8\u10D0\u10DC\u10D8 \u10EE\u10D4\u10DA\u10E8\u10D4\u10D9\u10E0\u10E3\u10DA\u10D4\u10D1\u10D0.',
                    "\u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4 \u10E0\u10D4\u10D2\u10D8\u10E1\u10E2\u10E0\u10D0\u10EA\u10D8\u10D8\u10E1 \u10D3\u10E0\u10DD\u10E1 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8 \u10D4\u10D7\u10D0\u10DC\u10EE\u10DB\u10D4\u10D1\u10D0 \u10D3\u10D0 \u10D0\u10E6\u10D8\u10D0\u10E0\u10D4\u10D1\u10E1 \u10EC\u10D8\u10DC\u10D0\u10DB\u10D3\u10D4\u10D1\u10D0\u10E0\u10D4 \u10EC\u10D4\u10E1\u10D4\u10D1\u10E1\u10D0 \u10D3\u10D0 \u10DE\u10D8\u10E0\u10DD\u10D1\u10D4\u10D1\u10E1, \u10D9\u10DD\u10DC\u10E4\u10D8\u10D3\u10D4\u10DC\u10EA\u10D8\u10D0\u10DA\u10E3\u10E0\u10DD\u10D1\u10D8\u10E1 \u10DE\u10DD\u10DA\u10D8\u10E2\u10D8\u10D9\u10D0\u10E1, \u10D3\u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10D8\u10E1\u10D0 \u10D3\u10D0 \u10D2\u10D0\u10EA\u10D5\u10DA\u10D8\u10E1 \u10EC\u10D4\u10E1\u10D4\u10D1\u10E1, \u10D0\u10E1\u10D4\u10D5\u10D4 \u10D0\u10EA\u10EE\u10D0\u10D3\u10D4\u10D1\u10E1 \u10D7\u10D0\u10DC\u10EE\u10DB\u10DD\u10D1\u10D0\u10E1, \u10D2\u10D0\u10D5\u10E0\u10EA\u10D4\u10DA\u10D3\u10D4\u10E1 \u10DB\u10D0\u10E1\u10D6\u10D4 \u10DB\u10D0\u10D7\u10D8 \u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10D4\u10D1\u10E0\u10D8\u10D5\u10D8 \u10EB\u10D0\u10DA\u10D0.",
                    '\u10D8\u10DB \u10E8\u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D0\u10E8\u10D8, \u10D7\u10E3 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8 \u10D0\u10E0 \u10D4\u10D7\u10D0\u10DC\u10EE\u10DB\u10D4\u10D1\u10D0 "Archy"-\u10E1 \u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10D4\u10D1\u10E0\u10D8\u10D5\u10D8 \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D8\u10DC\u10D0\u10D0\u10E0\u10E1\u10E1, \u10E8\u10D4\u10E3\u10EB\u10DA\u10D8\u10D0 \u10D0\u10E0 \u10D2\u10D0\u10DB\u10DD\u10D8\u10E7\u10D4\u10DC\u10DD\u10E1 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D8, \u10D7\u10E3\u10DB\u10EA\u10D0, \u10D0\u10DB\u10D0\u10E1\u10D7\u10D0\u10DC "Archy"-\u10E1  \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10E1 \u10DB\u10D8\u10DB\u10D0\u10E0\u10D7\u10D0\u10D5\u10E1 \u10D7\u10EE\u10DD\u10D5\u10DC\u10D8\u10D7, \u10E8\u10D4\u10DC\u10D8\u10E8\u10D5\u10DC\u10D4\u10D1\u10D8 \u10DB\u10D8\u10D0\u10EC\u10DD\u10D3\u10DD\u10E1 \u10D4\u10DA\u10D4\u10E5\u10E2\u10E0\u10DD\u10DC\u10E3\u10DA \u10E4\u10DD\u10E1\u10E2\u10D0\u10D6\u10D4.',
                    '\u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7\u10D8 \u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8\u10E1, \u10DE\u10E0\u10D4\u10E2\u10D4\u10DC\u10D6\u10D8\u10D8\u10E1, \u10D7\u10EE\u10DD\u10D5\u10DC\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D0\u10E8\u10D8, \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10E1 \u10E8\u10D4\u10E3\u10EB\u10DA\u10D8\u10D0 "Archy"-\u10E1 \u10D3\u10D0\u10E3\u10D9\u10D0\u10D5\u10E8\u10D8\u10E0\u10D3\u10D4\u10E1 \u10D4\u10DA\u10D4\u10E5\u10E2\u10E0\u10DD\u10DC\u10E3\u10DA\u10D8 \u10E4\u10DD\u10E1\u10E2\u10D8\u10E1 \u10DB\u10D4\u10E8\u10D5\u10D4\u10DD\u10D1\u10D8\u10D7. "Archy"-\u10E1 \u10D2\u10E3\u10DC\u10D3\u10D8 \u10DB\u10D6\u10D0\u10D3 \u10D0\u10E0\u10D8\u10E1 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10E1 \u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D6\u10D4 \u10D2\u10D0\u10E1\u10EA\u10D4\u10E1 \u10D3\u10D4\u10E2\u10D0\u10DA\u10E3\u10E0\u10D8 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8.'
                ].map((text)=>({
                        text: text
                    }))
            },
            {
                props: {
                    margin: "C 0 0"
                },
                H5: {
                    text: "\u10E2\u10D4\u10E0\u10DB\u10D8\u10DC\u10D7\u10D0 \u10D2\u10D0\u10DC\u10DB\u10D0\u10E0\u10E2\u10D4\u10D1\u10D0"
                },
                P: {
                    text: "\u10EC\u10D8\u10DC\u10D0\u10DB\u10D3\u10D4\u10D1\u10D0\u10E0\u10D4 \u10EC\u10D4\u10E1\u10D4\u10D1\u10E1\u10D0 \u10D3\u10D0 \u10DE\u10D8\u10E0\u10DD\u10D1\u10D4\u10D1\u10E8\u10D8 \u10D2\u10D0\u10DB\u10DD\u10E7\u10D4\u10DC\u10D4\u10D1\u10E3\u10DA \u10E2\u10D4\u10E0\u10DB\u10D8\u10DC\u10D4\u10D1\u10E1 \u10D2\u10D0\u10D0\u10E9\u10DC\u10D8\u10D0\u10D7 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8 \u10DB\u10DC\u10D8\u10E8\u10D5\u10DC\u10D4\u10DA\u10DD\u10D1\u10D0:"
                },
                Ul: {
                    props: {},
                    $propsCollection: [
                        '"Archy"-\u10E1 (\u10E8\u10D4\u10DB\u10D3\u10D2\u10DD\u10DB\u10E8\u10D8 \u201E\u10E9\u10D5\u10D4\u10DC\u201C, \u201E\u10E9\u10D5\u10D4\u10DC\u10D8\u201C, \u201E\u10D5\u10D4\u10D1-\u10D2\u10D5\u10D4\u10E0\u10D3\u10D8\u201C) - \u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD\u10E1 \u10D9\u10D0\u10DC\u10DD\u10DC\u10DB\u10D3\u10D4\u10D1\u10DA\u10DD\u10D1\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10D1\u10D0\u10DB\u10D8\u10E1\u10D0\u10D3 \u10D3\u10D0\u10E4\u10E3\u10EB\u10DC\u10D4\u10D1\u10E3\u10DA\u10D8 "Archy", \u10E1\u10D0\u10D8\u10D3\u10D4\u10DC\u10E2\u10D8\u10E4\u10D8\u10D9\u10D0\u10EA\u10D8\u10DD \u10D9\u10DD\u10D3\u10D8 400232798, \u10E0\u10D4\u10D2\u10D8\u10E1\u10E2\u10E0\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8: \u10D3\u10D0\u10D5\u10D8\u10D7 \u10D2\u10E3\u10E0\u10D0\u10DB\u10D8\u10E8\u10D5\u10D8\u10DA\u10D8 \u10D2\u10D0\u10DB\u10D6. 78, \u10D1\u10DA\u10DD\u10D9\u10D8 D.',
                        '\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8 - \u10D8\u10E3\u10E0\u10D8\u10D3\u10D8\u10E3\u10DA\u10D8 \u10D0\u10DC \u10E4\u10D8\u10D6\u10D8\u10D9\u10E3\u10E0\u10D8 \u10DE\u10D8\u10E0\u10D8, \u10E0\u10DD\u10DB\u10D4\u10DA\u10E1\u10D0\u10EA \u10E1\u10E3\u10E0\u10E1 \u10E8\u10D4\u10D8\u10EB\u10D8\u10DC\u10DD\u10E1 "Archy"-\u10E1 -\u10D6\u10D4 \u10D2\u10D0\u10DC\u10D7\u10D0\u10D5\u10E1\u10D4\u10D1\u10E3\u10DA\u10D8 \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10EA\u10D8\u10D0 \u10D3\u10D0 \u10E1\u10D4\u10E0\u10D5\u10D8\u10E1\u10D4\u10D1\u10D8.',
                        "\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10D7\u10D0\u10DC\u10EE\u10DB\u10DD\u10D1\u10D0 - \u10EC\u10D8\u10DC\u10D0\u10DB\u10D3\u10D4\u10D1\u10D0\u10E0\u10D4 \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D8\u10E1 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10D2\u10D0\u10EA\u10DC\u10DD\u10D1\u10D8\u10E1\u10D0 \u10D3\u10D0 \u10DB\u10D8\u10E1\u10D8 \u10DE\u10D4\u10E0\u10E1\u10DD\u10DC\u10D0\u10DA\u10E3\u10E0\u10D8 \u10EE\u10D0\u10E1\u10D8\u10D0\u10D7\u10D8\u10E1 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8\u10E1 \u10D3\u10D0\u10DB\u10E3\u10E8\u10D0\u10D5\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10EE\u10D4\u10D1 \u10D2\u10D0\u10DB\u10DD\u10EE\u10D0\u10E2\u10E3\u10DA\u10D8 \u10DC\u10D4\u10D1\u10D0.",
                        "\u10DB\u10D4\u10E1\u10D0\u10DB\u10D4 \u10DE\u10D8\u10E0\u10D8 - \u10DC\u10D4\u10D1\u10D8\u10E1\u10DB\u10D8\u10D4\u10E0\u10D8 \u10E4\u10D8\u10D6\u10D8\u10D9\u10E3\u10E0\u10D8 \u10D0\u10DC \u10D8\u10E3\u10E0\u10D8\u10D3\u10D8\u10E3\u10DA\u10D8 \u10DE\u10D8\u10E0\u10D8, \u10E1\u10D0\u10EF\u10D0\u10E0\u10DD \u10D3\u10D0\u10EC\u10D4\u10E1\u10D4\u10D1\u10E3\u10DA\u10D4\u10D1\u10D0.",
                        "\u10DE\u10D8\u10E0\u10D3\u10D0\u10DE\u10D8\u10E0\u10D8 \u10DB\u10D0\u10E0\u10D9\u10D4\u10E2\u10D8\u10DC\u10D2\u10D8 - \u10E4\u10DD\u10E1\u10E2\u10D8\u10E1, \u10E1\u10D0\u10E2\u10D4\u10DA\u10D4\u10E4\u10DD\u10DC\u10DD \u10D6\u10D0\u10E0\u10D4\u10D1\u10D8\u10E1, \u10D4\u10DA\u10D4\u10E5\u10E2\u10E0\u10DD\u10DC\u10E3\u10DA\u10D8 \u10E4\u10DD\u10E1\u10E2\u10D8\u10E1 \u10D0\u10DC \u10E1\u10EE\u10D5\u10D0 \u10DC\u10D4\u10D1\u10D8\u10E1\u10DB\u10D8\u10D4\u10E0\u10D8 \u10E1\u10D0\u10E2\u10D4\u10DA\u10D4\u10D9\u10DD\u10DB\u10E3\u10DC\u10D8\u10D9\u10D0\u10EA\u10D8\u10DD \u10E1\u10D0\u10E8\u10E3\u10D0\u10DA\u10D4\u10D1\u10D8\u10D7 \u10E1\u10D0\u10E5\u10DD\u10DC\u10DA\u10D8\u10E1, \u10DB\u10DD\u10DB\u10E1\u10D0\u10EE\u10E3\u10E0\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10D7\u10D0\u10D5\u10D0\u10D6\u10D4\u10D1\u10D0.",
                        "\u10E0\u10D4\u10D2\u10D8\u10E1\u10E2\u10E0\u10D0\u10EA\u10D8\u10D0 - \u10DE\u10D8\u10E0\u10D0\u10D3\u10D8 \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D8\u10E1 \u10E8\u10D4\u10E5\u10DB\u10DC\u10D0.",
                        '\u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D8 - \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 "Archy"-\u10E1 -\u10D6\u10D4 \u10E0\u10D4\u10D2\u10D8\u10E1\u10E2\u10E0\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8 \u10DE\u10D8\u10E0\u10D0\u10D3\u10D8 \u10D2\u10D5\u10D4\u10E0\u10D3\u10D8.'
                    ].map((text)=>({
                            text: text
                        }))
                },
                Paragraphs: {
                    props: {},
                    $propsCollection: [
                        '\u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4  \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10E1 \u10D4\u10EB\u10DA\u10D4\u10D5\u10D0 \u10E1\u10D0\u10E8\u10E3\u10D0\u10DA\u10D4\u10D1\u10D0, \u10E8\u10D4\u10D8\u10EB\u10D8\u10DC\u10DD\u10E1 "Archy"-\u10E1 -\u10D6\u10D4 \u10D2\u10D0\u10DC\u10D7\u10D0\u10D5\u10E1\u10D4\u10D1\u10E3\u10DA\u10D8 \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10EA\u10D8\u10D0.',
                        "\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10D2\u10D0\u10D9\u10D4\u10D7\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D7\u10D8\u10D7\u10DD\u10D4\u10E3\u10DA\u10D8 \u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D0 \u10EC\u10D0\u10E0\u10DB\u10DD\u10D0\u10D3\u10D2\u10D4\u10DC\u10E1 \u10EA\u10D0\u10DA\u10D9\u10D4\u10E3\u10DA \u10DC\u10D0\u10E1\u10E7\u10D8\u10D3\u10DD\u10D1\u10D8\u10E1 \u10EE\u10D4\u10DA\u10E8\u10D4\u10D9\u10E0\u10E3\u10DA\u10D4\u10D1\u10D0\u10E1, \u10E0\u10DD\u10DB\u10DA\u10D8\u10E1 \u10DB\u10EE\u10D0\u10E0\u10D4\u10D4\u10D1\u10D8 \u10D0\u10E0\u10D8\u10D0\u10DC \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D8\u10E1 \u10D0\u10D5\u10E2\u10DD\u10E0\u10D8\u10D6\u10D4\u10D1\u10E3\u10DA\u10D8 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8 \u10D3\u10D0 \u201EArchy\u201C. \u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D8\u10E1 \u10D2\u10D0\u10E4\u10DD\u10E0\u10DB\u10D4\u10D1\u10D8\u10E1\u10D0\u10E1 \u10D2\u10D4\u10DC\u10D4\u10E0\u10D8\u10E0\u10D3\u10D4\u10D1\u10D0 \u10DC\u10D0\u10E1\u10E7\u10D8\u10D3\u10DD\u10D1\u10D8\u10E1 \u10E1\u10D0\u10D2\u10D0\u10DC\u10D8, \u10DB\u10D8\u10E1\u10D8 \u10E6\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D4\u10D1\u10D0 \u10D3\u10D0 \u10DB\u10D8\u10EC\u10DD\u10D3\u10D4\u10D1\u10D8\u10E1 \u10D0\u10D3\u10D2\u10D8\u10DA\u10D8."
                    ].map((text)=>({
                            text: text
                        }))
                }
            },
            {
                props: {
                    margin: "C 0 0"
                },
                H5: {
                    text: "\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8 \u10D0\u10D3\u10D0\u10E1\u10E2\u10E3\u10E0\u10D4\u10D1\u10E1 \u10D3\u10D0 \u10D8\u10EB\u10DA\u10D4\u10D5\u10D0 \u10D2\u10D0\u10E0\u10D0\u10DC\u10E2\u10D8\u10D0\u10E1, \u10E0\u10DD\u10DB:"
                },
                Ul: {
                    props: {},
                    $propsCollection: [
                        "\u10DB\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10DB\u10D8\u10D7\u10D8\u10D7\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0 \u10D0\u10E0\u10D8\u10E1 \u10E1\u10E0\u10E3\u10DA\u10D8 \u10D3\u10D0 \u10E1\u10EC\u10DD\u10E0\u10D8;",
                        "\u10D0\u10E0 \u10D2\u10D0\u10DB\u10DD\u10D8\u10E7\u10D4\u10DC\u10D4\u10D1\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10E1, \u10E0\u10DD\u10DB\u10D4\u10DA\u10D8\u10EA \u10E8\u10D4\u10E1\u10D0\u10EB\u10DA\u10DD\u10D0 \u10D3\u10D0\u10DB\u10D0\u10DB\u10EA\u10D8\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8 \u10D3\u10D0 \u10E8\u10D4\u10E3\u10E0\u10D0\u10EA\u10EE\u10DB\u10E7\u10DD\u10E4\u10D4\u10DA\u10D8 \u10D0\u10E6\u10DB\u10DD\u10E9\u10DC\u10D3\u10D4\u10E1 \u10DC\u10D4\u10D1\u10D8\u10E1\u10DB\u10D8\u10D4\u10E0\u10D8 \u10E1\u10EE\u10D5\u10D0 \u10DE\u10D8\u10E0\u10D8\u10E1\u10D0\u10D7\u10D5\u10D8\u10E1;",
                        "\u10D0\u10E0 \u10D2\u10D0\u10DB\u10DD\u10D8\u10E7\u10D4\u10DC\u10D4\u10D1\u10E1 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10E1 \u10E7\u10D0\u10DA\u10D1\u10D8 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D8\u10E1 \u10D2\u10D0\u10D5\u10E0\u10EA\u10D4\u10DA\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D8\u10D6\u10DC\u10D8\u10D7;",
                        "\u10D0\u10E0 \u10D2\u10D0\u10DB\u10DD\u10D8\u10E7\u10D4\u10DC\u10D4\u10D1\u10E1 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10E1 \u10E1\u10EE\u10D5\u10D0 \u10D9\u10DD\u10DB\u10DE\u10D0\u10DC\u10D8\u10D8\u10E1, \u10D9\u10DD\u10DB\u10DE\u10D0\u10DC\u10D8\u10D8\u10E1 \u10D7\u10D0\u10DC\u10D0\u10DB\u10E8\u10E0\u10DD\u10DB\u10DA\u10D8\u10E1 \u10D0\u10DC \u10DC\u10D4\u10D1\u10D8\u10E1\u10DB\u10D8\u10D4\u10E0\u10D8 \u10E1\u10EE\u10D5\u10D0 \u10DE\u10D8\u10E0\u10D8\u10E1 \u10D2\u10D0\u10DC\u10E1\u10D0\u10EE\u10D8\u10D4\u10E0\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D8\u10D6\u10DC\u10D8\u10D7;",
                        "\u10D0\u10E0 \u10D3\u10D0\u10D0\u10E0\u10E6\u10D5\u10D4\u10D5\u10E1 \u10E1\u10EE\u10D5\u10D0 \u10DE\u10D8\u10E0\u10D8\u10E1 \u10E3\u10E4\u10DA\u10D4\u10D1\u10D4\u10D1\u10E1, \u10D9\u10D0\u10DC\u10DD\u10DC\u10E1\u10D0\u10EC\u10D8\u10DC\u10D0\u10D0\u10E6\u10DB\u10D3\u10D4\u10D2\u10DD \u10D3\u10D0 \u10D6\u10D8\u10D0\u10DC\u10D8\u10E1 \u10DB\u10D8\u10DB\u10E7\u10D4\u10DC\u10D4\u10D1\u10D4\u10DA\u10D8 \u10E5\u10DB\u10D4\u10D3\u10D4\u10D1\u10D8\u10D7;",
                        "\u10D0\u10E0 \u10D2\u10D0\u10DB\u10DD\u10D8\u10E7\u10D4\u10DC\u10D4\u10D1\u10E1 \u10DB\u10DD\u10EC\u10E7\u10DD\u10D1\u10D8\u10DA\u10DD\u10D1\u10D0\u10E1, \u10DE\u10E0\u10DD\u10D2\u10E0\u10D0\u10DB\u10D0\u10E1, \u10E0\u10DD\u10DB\u10DA\u10D8\u10E1 \u10DB\u10D8\u10D6\u10D0\u10DC\u10D8 \u10D0\u10E0\u10D8\u10E1 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D8\u10E1 \u10DB\u10DD\u10DE\u10DD\u10D5\u10D4\u10D1\u10D0 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D8\u10D3\u10D0\u10DC \u10D0\u10DC/\u10D3\u10D0 \u10DC\u10DD\u10E0\u10DB\u10D0\u10DA\u10E3\u10E0\u10D8 \u10E4\u10E3\u10DC\u10E5\u10EA\u10D8\u10DD\u10DC\u10D8\u10E0\u10D4\u10D1\u10D8\u10E1\u10D0\u10D7\u10D5\u10D8\u10E1 \u10EE\u10D4\u10DA\u10D8\u10E1 \u10E8\u10D4\u10E8\u10DA\u10D0;",
                        '\u10D3\u10D0\u10D8\u10EA\u10D0\u10D5\u10E1 \u10E1\u10D0\u10D0\u10D5\u10E2\u10DD\u10E0\u10DD \u10D3\u10D0 \u10DB\u10DD\u10DB\u10D8\u10EF\u10DC\u10D0\u10D5\u10D4 \u10E3\u10E4\u10DA\u10D4\u10D1\u10D4\u10D1\u10E1, \u10D0\u10E0 \u10D2\u10D0\u10DC\u10D0\u10EE\u10DD\u10E0\u10EA\u10D8\u10D4\u10DA\u10D4\u10D1\u10E1 "Archy" -\u10D6\u10D4 \u10D0\u10E0\u10E1\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D8\u10E1: \u10DA\u10DD\u10D2\u10DD, \u10DE\u10D8\u10E5\u10E2\u10DD\u10D2\u10E0\u10D0\u10DB\u10D0, \u10E1\u10E3\u10E0\u10D0\u10D7\u10D8, \u10D2\u10E0\u10D0\u10E4\u10D8\u10D9\u10D0, \u10D2\u10D0\u10DB\u10DD\u10E1\u10D0\u10EE\u10E3\u10DA\u10D4\u10D1\u10D0, \u10DE\u10D0\u10E2\u10D4\u10DC\u10E2\u10D8, \u10E1\u10D0\u10E1\u10D0\u10E5\u10DD\u10DC\u10DA\u10DD \u10DC\u10D8\u10E8\u10DC\u10D4\u10D1\u10D8, \u10D3\u10D8\u10D6\u10D0\u10D8\u10DC\u10D8\u10E1 \u10D3\u10D0 \u10E1\u10EE\u10D5\u10D0 \u10DC\u10D4\u10D1\u10D8\u10E1\u10DB\u10D8\u10D4\u10E0\u10D8 \u10E1\u10D0\u10EE\u10D8\u10E1 \u10D8\u10DC\u10E2\u10D4\u10DA\u10D4\u10E5\u10E2\u10E3\u10D0\u10DA\u10E3\u10E0\u10D8 \u10E1\u10D0\u10D9\u10E3\u10D7\u10E0\u10D4\u10D1\u10D8\u10E1 \u10E3\u10DC\u10D4\u10D1\u10D0\u10E0\u10D7\u10D5\u10DD \u10D2\u10D0\u10DB\u10DD\u10E7\u10D4\u10DC\u10D4\u10D1\u10D0\u10E1, \u10D3\u10D0\u10DB\u10E3\u10E8\u10D0\u10D5\u10D4\u10D1\u10D0\u10E1\u10D0 \u10D3\u10D0 \u10D2\u10D0\u10DB\u10DD\u10E5\u10D5\u10D4\u10E7\u10DC\u10D4\u10D1\u10D0\u10E1, "Archy"-\u10E1 \u10EC\u10D8\u10DC\u10D0\u10E1\u10EC\u10D0\u10E0\u10D8 \u10EC\u10D4\u10E0\u10D8\u10DA\u10DD\u10D1\u10D8\u10D7\u10D8 \u10D7\u10D0\u10DC\u10EE\u10DB\u10DD\u10D1\u10D8\u10E1 \u10D2\u10D0\u10E0\u10D4\u10E8\u10D4;',
                        '\u10D0\u10E0 \u10D2\u10D0\u10DC\u10D0\u10EE\u10DD\u10E0\u10EA\u10D8\u10D4\u10DA\u10D4\u10D1\u10E1 \u10D8\u10E1\u10D4\u10D7 \u10E5\u10DB\u10D4\u10D3\u10D4\u10D1\u10D0\u10E1, \u10E0\u10DD\u10DB\u10D4\u10DA\u10D8\u10EA \u10E1\u10D0\u10E4\u10E0\u10D7\u10EE\u10D4\u10E1 \u10E8\u10D4\u10E3\u10E5\u10DB\u10DC\u10D8\u10E1 "Archy"-\u10E1 -\u10D8\u10E1 \u10D2\u10D0\u10DB\u10D0\u10E0\u10D7\u10E3\u10DA \u10E4\u10E3\u10DC\u10E5\u10EA\u10D8\u10DD\u10DC\u10D8\u10E0\u10D4\u10D1\u10D0\u10E1;',
                        '\u10D0\u10E0 \u10D2\u10D0\u10DC\u10D0\u10EE\u10DD\u10E0\u10EA\u10D8\u10D4\u10DA\u10D4\u10D1\u10E1 \u10E5\u10DB\u10D4\u10D3\u10D4\u10D1\u10D0\u10E1, \u10E0\u10DD\u10DB\u10D4\u10DA\u10D8\u10EA \u10D8\u10D9\u10E0\u10EB\u10D0\u10DA\u10D4\u10D1\u10D0 \u10DB\u10DD\u10E5\u10DB\u10D4\u10D3\u10D8 \u10D9\u10D0\u10DC\u10DD\u10DC\u10DB\u10D3\u10D4\u10D1\u10DA\u10DD\u10D1\u10D8\u10D7, \u10EC\u10D8\u10DC\u10D0\u10DB\u10D3\u10D4\u10D1\u10D0\u10E0\u10D4 \u10EE\u10D4\u10DA\u10E8\u10D4\u10D9\u10E0\u10E3\u10DA\u10D4\u10D1\u10D8\u10D7\u10D0 \u10D3\u10D0 "Archy" -\u10E1 \u10D9\u10DD\u10DC\u10E4\u10D8\u10D3\u10D4\u10DC\u10EA\u10D8\u10D0\u10DA\u10E3\u10E0\u10DD\u10D1\u10D8\u10E1 \u10D3\u10D0\u10EA\u10D5\u10D8\u10E1 \u10DE\u10DD\u10DA\u10D8\u10E2\u10D8\u10D9\u10D8\u10D7.'
                    ].map((text)=>({
                            text: text
                        }))
                }
            },
            {
                H5: {
                    text: "\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D8\u10E1 \u10D2\u10D0\u10E4\u10DD\u10E0\u10DB\u10D4\u10D1\u10D0 \u10D3\u10D0 \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10EA\u10D8\u10D8\u10E1 \u10E8\u10D4\u10EB\u10D4\u10DC\u10D0"
                },
                props: {
                    margin: "C 0 0"
                },
                Paragraphs: {
                    childExtend: (0, $b448a4a1f1311a88$export$56c0d5a1e737357d),
                    $propsCollection: [
                        "\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D8\u10E1 \u10E8\u10D4\u10E0\u10E9\u10D4\u10D5\u10D8\u10E1 \u10D3\u10D0 \u10D5\u10D8\u10E0\u10E2\u10E3\u10D0\u10DA\u10E3\u10E0 \u10D9\u10D0\u10DA\u10D0\u10D7\u10D0\u10E8\u10D8 \u10DB\u10DD\u10D7\u10D0\u10D5\u10E1\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D2\u10DD\u10DB, \u10E1\u10D0\u10ED\u10D8\u10E0\u10DD \u10D8\u10E5\u10DC\u10D4\u10D1\u10D0 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D8\u10E1 \u10DB\u10D8\u10D7\u10D8\u10D7\u10D4\u10D1\u10D0: \u10D4\u10DA\u10D4\u10E5\u10E2\u10E0\u10DD\u10DC\u10E3\u10DA\u10D8 \u10E4\u10DD\u10E1\u10E2\u10D0, \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8, \u10DB\u10DD\u10D1\u10D8\u10DA\u10E3\u10E0\u10D8\u10E1 \u10DC\u10DD\u10DB\u10D4\u10E0\u10D8 \u10D3\u10D0 \u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D8 \u10E1\u10D0\u10D3\u10D0\u10EA \u10E1\u10E3\u10E0\u10E1 \u10E0\u10DD\u10DB \u10E8\u10D4\u10DC\u10D0\u10EB\u10D4\u10DC\u10D8 \u10DB\u10D8\u10D8\u10E6\u10DD\u10E1.",
                        '"Archy"-\u10E1 \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10EA\u10D8\u10D8\u10E1 \u10E1\u10D0\u10E4\u10D0\u10E1\u10E3\u10E0\u10D8\u10E1 \u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D8\u10E1 \u10DB\u10D8\u10D6\u10DC\u10D8\u10D7 \u10D2\u10D0\u10D3\u10D0\u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D3\u10D4\u10D1\u10D0 \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10E1\u10EC\u10DD\u10E0\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4. \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10E1\u10EC\u10DD\u10E0\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10DC\u10EE\u10DD\u10E0\u10EA\u10D8\u10D4\u10DA\u10D4\u10D1\u10D0\u10DB\u10D3\u10D4 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8 \u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0 \u10D2\u10D0\u10D3\u10D0\u10D0\u10DB\u10DD\u10EC\u10DB\u10DD\u10E1 \u10DB\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10DB\u10D8\u10D7\u10D8\u10D7\u10D4\u10D1\u10E3\u10DA\u10D8 \u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D8 \u10D3\u10D0 \u10E1\u10D0\u10D9\u10DD\u10DC\u10E2\u10D0\u10E5\u10E2\u10DD \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0, \u10E8\u10D4\u10EB\u10D4\u10DC\u10D8\u10DA\u10D8 \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10EA\u10D8\u10D8\u10E1 \u10DB\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1 \u10E8\u10D4\u10E3\u10E4\u10D4\u10E0\u10EE\u10D4\u10D1\u10DA\u10D0\u10D3 \u10DB\u10D8\u10EC\u10DD\u10D3\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10DC\u10EE\u10DD\u10E0\u10EA\u10D8\u10D4\u10DA\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D8\u10D6\u10DC\u10D8\u10D7. \u10D0\u10E0\u10D0\u10E1\u10EC\u10DD\u10E0\u10D8/\u10D0\u10E0\u10D0\u10E1\u10E0\u10E3\u10DA\u10D8 \u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D8\u10E1\u10D0 \u10D0\u10DC/\u10D3\u10D0 \u10E1\u10D0\u10D9\u10DD\u10DC\u10E2\u10D0\u10E5\u10E2\u10DD \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D8\u10E1 \u10DB\u10D8\u10D7\u10D8\u10D7\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D0\u10E8\u10D8 \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10EA\u10D8\u10D8\u10E1 \u10DB\u10D8\u10EC\u10DD\u10D3\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10E4\u10D4\u10E0\u10EE\u10D4\u10D1\u10D8\u10E1 \u10D7\u10D0\u10DD\u10D1\u10D0\u10D6\u10D4 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1\u10DB\u10D2\u10D4\u10D1\u10DA\u10DD\u10D1\u10D0 \u10D4\u10D9\u10D8\u10E1\u10E0\u10D4\u10D1\u10D0 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10E1.',
                        "\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8 \u10DB\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10E8\u10D4\u10EB\u10D4\u10DC\u10D8\u10DA\u10D8 \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10EE\u10D4\u10D1 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D8\u10E1 \u10D2\u10D0\u10D3\u10D0\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10D0\u10E1 \u10E8\u10D4\u10EB\u10DA\u10D4\u10D1\u10E1 \u10DB\u10D8\u10D7\u10D8\u10D7\u10D4\u10D1\u10E3\u10DA \u10D4\u10DA \u10E4\u10DD\u10E1\u10E2\u10D0\u10D6\u10D4 \u10DB\u10D8\u10E6\u10D4\u10D1\u10E3\u10DA \u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D8\u10E1 \u10D3\u10D0\u10DB\u10D0\u10D3\u10D0\u10E1\u10E2\u10E3\u10E0\u10D4\u10D1\u10D4\u10DA \u10EC\u10D4\u10E0\u10D8\u10DA\u10E8\u10D8..",
                        '"Archy"-\u10E1 \u10D8\u10E2\u10DD\u10D5\u10D4\u10D1\u10E1 \u10E3\u10E4\u10DA\u10D4\u10D1\u10D0\u10DB\u10DD\u10E1\u10D8\u10DA\u10D4\u10D1\u10D0\u10E1 \u10E3\u10D0\u10E0\u10D8 \u10D7\u10E5\u10D5\u10D0\u10E1 \u10D0\u10DC \u10D2\u10D0\u10D0\u10E3\u10E5\u10DB\u10DD\u10E1 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D0 \u10D7\u10D0\u10E6\u10DA\u10D8\u10D7\u10DD\u10D1\u10D8\u10E1, \u10E3\u10DC\u10D4\u10D1\u10D0\u10E0\u10D7\u10D5\u10DD \u10D0\u10DC \u10E3\u10D9\u10D0\u10DC\u10DD\u10DC\u10DD \u10E2\u10E0\u10D0\u10DC\u10D6\u10D0\u10E5\u10EA\u10D8\u10D0\u10D6\u10D4 \u10D4\u10ED\u10D5\u10D8\u10E1 \u10D0\u10E0\u10E1\u10D4\u10D1\u10DD\u10D1\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D0\u10E8\u10D8.',
                        "\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D8\u10E1 \u10E1\u10D0\u10E4\u10D0\u10E1\u10E3\u10E0\u10D8\u10E1 \u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D2\u10DD\u10DB \u10E8\u10D4\u10EB\u10D4\u10DC\u10D8\u10DA \u10DC\u10D8\u10D5\u10D7\u10D6\u10D4 \u10E1\u10D0\u10D9\u10E3\u10D7\u10E0\u10D4\u10D1\u10D8\u10E1 \u10E3\u10E4\u10DA\u10D4\u10D1\u10D0 \u10E1\u10E0\u10E3\u10DA\u10D0\u10D3 \u10D2\u10D0\u10D3\u10D0\u10D3\u10D8\u10E1 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D6\u10D4.",
                        "\u10E8\u10D4\u10EB\u10D4\u10DC\u10D8\u10DA\u10D8 \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10EA\u10D8\u10D8\u10E1 \u10D2\u10D0\u10EA\u10D5\u10DA\u10D8\u10E1\u10D0 \u10D3\u10D0 \u10D3\u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10D8\u10E1 \u10EC\u10D4\u10E1\u10D4\u10D1\u10D8 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10E1 \u10E8\u10D4\u10E3\u10EB\u10DA\u10D8\u10D0 \u10D8\u10EE\u10D8\u10DA\u10DD\u10E1 \u10D3\u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10D8\u10E1 \u10DE\u10D8\u10E0\u10DD\u10D1\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4 ."
                    ].map((text)=>({
                            text: text
                        }))
                }
            },
            {
                H5: {
                    text: "\u10E8\u10D4\u10EB\u10D4\u10DC\u10D8\u10DA\u10D8 \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10EA\u10D8\u10D8\u10E1 \u10DB\u10D8\u10EC\u10DD\u10D3\u10D4\u10D1\u10D8\u10E1 \u10EC\u10D4\u10E1\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10DE\u10D8\u10E0\u10DD\u10D1\u10D4\u10D1\u10D8"
                },
                props: {
                    margin: "C 0 0"
                },
                Paragraphs: {
                    childExtend: (0, $b448a4a1f1311a88$export$56c0d5a1e737357d),
                    $propsCollection: [
                        "\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8 \u10D0\u10EA\u10EE\u10D0\u10D3\u10D4\u10D1\u10E1 \u10D7\u10D0\u10DC\u10EE\u10DB\u10DD\u10D1\u10D0\u10E1, \u10E0\u10DD\u10DB \u10DB\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10E8\u10D4\u10EB\u10D4\u10DC\u10D8\u10DA\u10D8 \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10EA\u10D8\u10D8\u10E1 \u10DB\u10D8\u10EC\u10DD\u10D3\u10D4\u10D1\u10D0\u10E1 \u10D2\u10D0\u10DC\u10D0\u10EE\u10DD\u10E0\u10EA\u10D8\u10D4\u10DA\u10D4\u10D1\u10E1  \u201EArchy\u201C (\u10E1\u10D0\u10D8\u10D3\u10D4\u10DC\u10E2\u10D8\u10E4\u10D8\u10D9\u10D0\u10EA\u10D8\u10DD \u10D9\u10DD\u10D3\u10D8: 400232798, \u10E0\u10D4\u10D2\u10D8\u10E1\u10E2\u10E0\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8: \u10D3\u10D0\u10D5\u10D8\u10D7 \u10D2\u10E3\u10E0\u10D0\u10DB\u10D8\u10E8\u10D5\u10D8\u10DA\u10D8 \u10D2\u10D0\u10DB\u10D6. 78, \u10D1\u10DA\u10DD\u10D9\u10D8 D.",
                        "\u10DB\u10D8\u10EC\u10DD\u10D3\u10D4\u10D1\u10D8\u10E1 \u10EE\u10D4\u10DA\u10E8\u10D4\u10D9\u10E0\u10E3\u10DA\u10D4\u10D1\u10D8\u10E1 \u10DB\u10EE\u10D0\u10E0\u10D4\u10D4\u10D1\u10D8 \u10D0\u10E0\u10D8\u10D0\u10DC \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8 \u10D3\u10D0  \u201EArchy\u201C.",
                        "\u10D9\u10DD\u10DC\u10E4\u10D8\u10D3\u10D4\u10DC\u10EA\u10D8\u10D0\u10DA\u10E3\u10E0\u10D8 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D8\u10E1 \u10D3\u10D0\u10DB\u10E3\u10E8\u10D0\u10D5\u10D4\u10D1\u10D8\u10E1\u10D0 \u10D3\u10D0 \u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10EE\u10D4\u10D1 \u10DE\u10DD\u10DA\u10D8\u10E2\u10D8\u10D9\u10D0 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10E1 \u10E8\u10D4\u10E3\u10EB\u10DA\u10D8\u10D0 \u10D8\u10EE\u10D8\u10DA\u10DD\u10E1 \u10D9\u10DD\u10DC\u10E4\u10D8\u10D3\u10D4\u10DC\u10EA\u10D8\u10D0\u10DA\u10E3\u10E0\u10D8 \u10DE\u10DD\u10DA\u10D8\u10E2\u10D8\u10D9\u10D8\u10E1 \u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4."
                    ].map((text)=>({
                            text: text
                        }))
                }
            },
            {
                H5: {
                    text: "\u10DB\u10DD\u10DB\u10E1\u10D0\u10EE\u10E3\u10E0\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D8\u10E6\u10D4\u10D1\u10D0"
                },
                props: {
                    margin: "C 0 0"
                },
                Paragraphs: {
                    childExtend: (0, $b448a4a1f1311a88$export$56c0d5a1e737357d),
                    $propsCollection: [
                        "\u10E8\u10D4\u10EB\u10D4\u10DC\u10D8\u10DA\u10D8 \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10EA\u10D8\u10D8\u10E1 \u10DB\u10D8\u10E6\u10D4\u10D1\u10D0 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10E1 \u10E8\u10D4\u10E3\u10EB\u10DA\u10D8\u10D0 \u10E0\u10DD\u10D2\u10DD\u10E0\u10EA \u10E1\u10D0\u10DB\u10E3\u10E8\u10D0\u10DD, \u10D0\u10E1\u10D4\u10D5\u10D4 \u10D0\u10E0\u10D0\u10E1\u10D0\u10DB\u10E3\u10E8\u10D0\u10DD \u10D3\u10E6\u10D4\u10D4\u10D1\u10E8\u10D8.",
                        '\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 "Archy"-\u10E1 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D8\u10D3\u10D0\u10DC \u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1 18:00 \u10E1\u10D0\u10D0\u10D7\u10D0\u10DB\u10D3\u10D4 \u10E8\u10D4\u10EB\u10D4\u10DC\u10D8\u10DA\u10D8 \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10EA\u10D8\u10D8\u10E1 \u10DB\u10D8\u10EC\u10DD\u10D3\u10D4\u10D1\u10D0, \u10D7\u10D1\u10D8\u10DA\u10D8\u10E1\u10D8\u10E1 \u10E2\u10D4\u10E0\u10D8\u10E2\u10DD\u10E0\u10D8\u10D0\u10D6\u10D4, \u10D2\u10D0\u10DC\u10EE\u10DD\u10E0\u10EA\u10D8\u10D4\u10DA\u10D3\u10D4\u10D1\u10D0 \u10D8\u10DB\u10D0\u10D5\u10D4 \u10D3\u10E6\u10D4\u10E1, \u10EE\u10DD\u10DA\u10DD 18:00\u10E1\u10D0\u10D0\u10D7\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2 \u10E8\u10D4\u10EB\u10D4\u10DC\u10D8\u10DA\u10D8 \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10EA\u10D8\u10D8\u10E1 \u10DB\u10D8\u10EC\u10DD\u10D3\u10D4\u10D1\u10D0, - \u10DB\u10D4\u10DD\u10E0\u10D4 \u10D3\u10E6\u10D4\u10E1.',
                        "\u10D7\u10D1\u10D8\u10DA\u10D8\u10E1\u10D8\u10E1 \u10E4\u10D0\u10E0\u10D2\u10DA\u10D4\u10D1\u10E1 \u10D2\u10D0\u10E0\u10D4\u10D7 \u10DB\u10D8\u10EC\u10DD\u10D3\u10D4\u10D1\u10D0 \u10D2\u10D0\u10DC\u10EE\u10DD\u10E0\u10EA\u10D8\u10D4\u10DA\u10D3\u10D4\u10D1\u10D0 \u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD\u10E1 \u10E4\u10DD\u10E1\u10E2\u10D8\u10D7, \u10DB\u10D8\u10E1\u10D8\u10D5\u10D4 \u10D3\u10D0\u10D3\u10D2\u10D4\u10DC\u10D8\u10DA\u10D8 \u10E2\u10D0\u10E0\u10D8\u10E4\u10D8\u10D7\u10D0 \u10D3\u10D0 \u10D5\u10D0\u10D3\u10D4\u10D1\u10D8\u10D7.",
                        '"Archy"-\u10E1 , \u10E1\u10D0\u10D9\u10E3\u10E0\u10D8\u10D4\u10E0\u10DD \u10DB\u10DD\u10DB\u10E1\u10D0\u10EE\u10E3\u10E0\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10EC\u10D4\u10D5\u10D8\u10E1 \u10DB\u10D8\u10D6\u10DC\u10D8\u10D7, \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10EE\u10D4\u10D1 \u10DB\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1 \u10EA\u10DC\u10DD\u10D1\u10D8\u10DA, \u10DE\u10D4\u10E0\u10E1\u10DD\u10DC\u10D0\u10DA\u10E3\u10E0\u10D8 \u10EE\u10D0\u10E1\u10D8\u10D0\u10D7\u10D8\u10E1 \u10D9\u10DD\u10DC\u10E4\u10D8\u10D3\u10D4\u10DC\u10EA\u10D8\u10D0\u10DA\u10E3\u10E0 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0\u10E1, \u10D9\u10D4\u10E0\u10EB\u10DD\u10D3, \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10E1, \u10D2\u10D5\u10D0\u10E0\u10E1, \u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10E1\u10D0 \u10D3\u10D0 \u10E2\u10D4\u10DA\u10D4\u10E4\u10DD\u10DC\u10D8\u10E1 \u10DC\u10DD\u10DB\u10D4\u10E0\u10E1 \u10DB\u10D8\u10D0\u10EC\u10DD\u10D3\u10D4\u10D1\u10E1 \u201E\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD\u10E1 \u10E4\u10DD\u10E1\u10E2\u10D0\u10E1.',
                        '"Archy"-\u10E1  \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10E8\u10D4\u10EB\u10D4\u10DC\u10D8\u10DA \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10EA\u10D8\u10D0\u10E1 \u10D2\u10D0\u10D3\u10D0\u10E1\u10EA\u10D4\u10DB\u10E1 \u201D\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD\u10E1 \u10E4\u10DD\u10E1\u10E2\u10D0\u201D, \u10E0\u10DD\u10DB\u10D4\u10DA\u10D8\u10EA \u10D0\u10EE\u10DD\u10E0\u10EA\u10D8\u10D4\u10DA\u10D4\u10D1\u10E1 \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10EA\u10D8\u10D8\u10E1 \u10E2\u10E0\u10D0\u10DC\u10E1\u10DE\u10DD\u10E0\u10E2\u10D8\u10E0\u10D4\u10D1\u10D0\u10E1 \u10DB\u10D8\u10D7\u10D8\u10D7\u10D4\u10D1\u10E3\u10DA \u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D6\u10D4. \u201CArchy\u201C-\u10D8\u10E1 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1\u10DB\u10D2\u10D4\u10D1\u10DA\u10DD\u10D1\u10D0 \u10E1\u10E0\u10E3\u10DA\u10D3\u10D4\u10D1\u10D0 \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10EA\u10D8\u10D8\u10E1 \u10E1\u10D0\u10D9\u10E3\u10E0\u10D8\u10D4\u10E0\u10DD \u10D9\u10DD\u10DB\u10DE\u10D0\u10DC\u10D8\u10D8\u10E1\u10D0\u10D7\u10D5\u10D8\u10E1 \u10D2\u10D0\u10D3\u10D0\u10EA\u10D4\u10DB\u10D8\u10E1 \u10D3\u10E0\u10DD\u10E1. \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10EA\u10D8\u10D8\u10E1 \u10D3\u10D0\u10D9\u10D0\u10E0\u10D2\u10D5\u10D8\u10E1\u10D0 \u10D3\u10D0 \u10D3\u10D0\u10D6\u10D8\u10D0\u10DC\u10D4\u10D1\u10D8\u10E1 \u10E0\u10D8\u10E1\u10D9\u10D8 \u10E1\u10E0\u10E3\u10DA\u10D0\u10D3 \u10D2\u10D0\u10D3\u10D0\u10D3\u10D8\u10E1 \u10E1\u10D0\u10D9\u10E3\u10E0\u10D8\u10D4\u10E0\u10DD \u10DB\u10DD\u10DB\u10E1\u10D0\u10EE\u10E3\u10E0\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10DB\u10EC\u10D4\u10D5 \u10D9\u10DD\u10DB\u10DE\u10D0\u10DC\u10D8\u10D0\u10D6\u10D4.'
                    ].map((text)=>({
                            text: text
                        }))
                }
            },
            {
                H5: {
                    text: "\u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10E1\u10EC\u10DD\u10E0\u10D4\u10D1\u10D8\u10E1 \u10EC\u10D4\u10E1\u10D8"
                },
                props: {
                    margin: "C 0 0"
                },
                Paragraphs: {
                    childExtend: (0, $b448a4a1f1311a88$export$56c0d5a1e737357d),
                    $propsCollection: [
                        "\u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10E1\u10EC\u10DD\u10E0\u10D4\u10D1\u10D0 \u10EE\u10DD\u10E0\u10EA\u10D8\u10D4\u10DA\u10D3\u10D4\u10D1\u10D0 \u10DB\u10EE\u10DD\u10DA\u10DD\u10D3 \u10E3\u10DC\u10D0\u10E6\u10D3\u10DD \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10E1\u10EC\u10DD\u10E0\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D6\u10D8\u10D7.",
                        "\u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D8\u10E1 \u10D2\u10D0\u10E4\u10DD\u10E0\u10DB\u10D4\u10D1\u10D8\u10E1\u10D0\u10E1 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D8\u10D3\u10D0\u10DC \u10D2\u10D0\u10D3\u10D0\u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D3\u10D4\u10D1\u10D0 \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10E1\u10EC\u10DD\u10E0\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4, \u10E1\u10D0\u10D3\u10D0\u10EA \u10E3\u10D7\u10D8\u10D7\u10D4\u10D1\u10E1 \u10E1\u10D0\u10D9\u10E3\u10D7\u10D0\u10E0\u10D8 \u10D1\u10D0\u10E0\u10D0\u10D7\u10D8\u10E1 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10E1. \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10E1\u10EC\u10DD\u10E0\u10D4\u10D1\u10D8\u10E1 \u10DB\u10DD\u10D7\u10EE\u10DD\u10D5\u10DC\u10D0 \u10DB\u10E3\u10E8\u10D0\u10D5\u10D3\u10D4\u10D1\u10D0 \u10D3\u10D0 \u10D3\u10D0\u10E1\u10E2\u10E3\u10E0\u10D3\u10D4\u10D1\u10D0 \u10D1\u10D0\u10DC\u10D9\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0.",
                        '"Archy\u201C-\u10E1 \u10D0\u10E0 \u10D0\u10E5\u10D5\u10E1 \u10EC\u10D5\u10D3\u10DD\u10DB\u10D0 \u10E0\u10DD\u10D2\u10DD\u10E0\u10EA \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10E1\u10EC\u10DD\u10E0\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4, \u10D0\u10E1\u10D4\u10D5\u10D4 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10DB\u10D8\u10D7\u10D8\u10D7\u10D4\u10D1\u10E3\u10DA \u10E1\u10D0\u10D1\u10D0\u10DC\u10D9\u10DD \u10D1\u10D0\u10E0\u10D0\u10D7\u10D8\u10E1 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D6\u10D4.',
                        "\u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10E1\u10EC\u10DD\u10E0\u10D4\u10D1\u10D8\u10E1 \u10EC\u10D0\u10E0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7 \u10D3\u10D0\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D0\u10E8\u10D8, \u10D4\u10D9\u10E0\u10D0\u10DC\u10D6\u10D4 \u10D2\u10D0\u10DB\u10DD\u10D3\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10D1\u10D0\u10DB\u10D8\u10E1\u10D8 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D8\u10E1 \u10E8\u10D4\u10DB\u10EA\u10D5\u10D4\u10DA\u10D8 \u10E8\u10D4\u10E2\u10E7\u10DD\u10D1\u10D8\u10DC\u10D4\u10D1\u10D0.",
                        "\u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10E1\u10EC\u10DD\u10E0\u10D4\u10D1\u10D8\u10E1 \u10D3\u10D0\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D2\u10DD\u10DB \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8 \u10DB\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10DB\u10D8\u10D7\u10D8\u10D7\u10D4\u10D1\u10E3\u10DA \u10D4\u10DA\u10D4\u10E5\u10E2\u10E0\u10DD\u10DC\u10E3\u10DA \u10E4\u10DD\u10E1\u10E2\u10D0\u10D6\u10D4 \u10DB\u10D8\u10D8\u10E6\u10D4\u10D1\u10E1 \u10D3\u10D0\u10E1\u10E2\u10E3\u10E0\u10E1 \u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D8\u10E1 \u10EC\u10D0\u10E0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7 \u10D3\u10D0\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10EE\u10D4\u10D1."
                    ].map((text)=>({
                            text: text
                        }))
                }
            },
            {
                H5: {
                    text: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1\u10DB\u10D2\u10D4\u10D1\u10DA\u10DD\u10D1\u10D8\u10E1 \u10E8\u10D4\u10D6\u10E6\u10E3\u10D3\u10D5\u10D0"
                },
                props: {
                    margin: "C 0 0"
                },
                Paragraphs: {
                    childExtend: (0, $b448a4a1f1311a88$export$56c0d5a1e737357d),
                    $propsCollection: [
                        '"Archy"-\u10E1  \u10E8\u10D4\u10E1\u10D0\u10EB\u10DA\u10D4\u10D1\u10DA\u10DD\u10D1\u10D4\u10D1\u10D8\u10E1 \u10E4\u10D0\u10E0\u10D2\u10DA\u10D4\u10D1\u10E8\u10D8 \u10DB\u10D0\u10E5\u10E1\u10D8\u10DB\u10D0\u10DA\u10E3\u10E0\u10D0\u10D3 \u10E3\u10D6\u10E0\u10E3\u10DC\u10D5\u10D4\u10DA\u10E7\u10DD\u10E4\u10E1 \u10D7\u10D0\u10D5\u10D3\u10D0\u10EA\u10D5\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10D1\u10D0\u10DB\u10D8\u10E1\u10D8 \u10DB\u10D4\u10E5\u10D0\u10DC\u10D8\u10D6\u10DB\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10DB\u10E3\u10E8\u10D0\u10D5\u10D4\u10D1\u10D0\u10E1, \u10D7\u10E3\u10DB\u10EA\u10D0 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1\u10DB\u10D2\u10D4\u10D1\u10D4\u10DA\u10D8 \u10DE\u10DA\u10D0\u10E2\u10E4\u10DD\u10E0\u10DB\u10D0\u10D6\u10D4 \u10D3\u10D0\u10EA\u10E3\u10DA\u10D8 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8\u10E1 \u10D0\u10E0\u10D0\u10E1\u10D0\u10DC\u10E5\u10EA\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA \u10EC\u10D5\u10D3\u10DD\u10DB\u10D0\u10D6\u10D4, \u10DB\u10D4\u10E1\u10D0\u10DB\u10D4 \u10DE\u10D8\u10E0\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10DB\u10D8\u10E7\u10D4\u10DC\u10D4\u10D1\u10E3\u10DA \u10D6\u10D8\u10D0\u10DC\u10D6\u10D4, \u10DB\u10D0\u10D7 \u10DB\u10D8\u10D4\u10E0 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1\u10D0\u10D7\u10D5\u10D8\u10E1 \u10E8\u10D4\u10D7\u10D0\u10D5\u10D0\u10D6\u10D4\u10D1\u10E3\u10DA \u10DB\u10DD\u10DB\u10E1\u10D0\u10EE\u10E3\u10E0\u10D4\u10D1\u10D0\u10D6\u10D4.',
                        '"Archy\u201C  \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1\u10DB\u10D2\u10D4\u10D1\u10D4\u10DA\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1, \u10E0\u10DD\u10DB \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D8 \u10D0\u10DC \u10DB\u10DD\u10DB\u10E1\u10D0\u10EE\u10E3\u10E0\u10D4\u10D1\u10D0 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1\u10D0\u10D7\u10D5\u10D8\u10E1 \u10D8\u10E5\u10DC\u10D4\u10D1\u10D0 \u10DB\u10E3\u10D3\u10DB\u10D8\u10D5\u10D0\u10D3 \u10EE\u10D4\u10DA\u10DB\u10D8\u10E1\u10D0\u10EC\u10D5\u10D3\u10DD\u10DB\u10D8 \u10D3\u10D0 \u10D0\u10E0 \u10D8\u10EB\u10DA\u10D4\u10D5\u10D0 \u10D2\u10D0\u10E0\u10D0\u10DC\u10E2\u10D8\u10D0\u10E1, \u10E0\u10DD\u10DB \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10E1 \u10D0\u10E0 \u10D4\u10E5\u10DC\u10D4\u10D1\u10D0 \u10DE\u10E0\u10DD\u10D2\u10E0\u10D0\u10DB\u10E3\u10DA\u10D8 \u10EE\u10D0\u10E0\u10D5\u10D4\u10D6\u10D4\u10D1\u10D8, \u10D5\u10D8\u10E0\u10E3\u10E1\u10D4\u10D1\u10D8 \u10D0\u10DC/\u10D3\u10D0 \u10E1\u10EE\u10D5\u10D0 \u10DC\u10D4\u10D1\u10D8\u10E1\u10DB\u10D8\u10D4\u10E0\u10D8 \u10E8\u10D4\u10EA\u10D3\u10DD\u10DB\u10D0.',
                        '"Archy\u201C  \u10D8\u10EE\u10DC\u10D8\u10E1 \u10E1\u10E0\u10E3\u10DA \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1\u10DB\u10D2\u10D4\u10D1\u10DA\u10DD\u10D1\u10D0\u10E1 \u10D2\u10D0\u10E3\u10E4\u10E0\u10D7\u10EE\u10D8\u10DA\u10D4\u10D1\u10DA\u10DD\u10D1\u10D8\u10E1 \u10E8\u10D4\u10D3\u10D4\u10D2\u10D0\u10D3 \u10D3\u10D0\u10DB\u10D3\u10D2\u10D0\u10E0 \u10D6\u10D8\u10D0\u10DC\u10D6\u10D4, \u10D0\u10E1\u10D4\u10D5\u10D4 \u10D8\u10DB \u10E8\u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D4\u10D1\u10D6\u10D4, \u10E0\u10DD\u10D3\u10D4\u10E1\u10D0\u10EA \u10DB\u10D4\u10E1\u10D0\u10DB\u10D4 \u10DE\u10D8\u10E0\u10D8\u10E1\u10D0\u10D7\u10D5\u10D8\u10E1 \u10D2\u10D0\u10EE\u10D3\u10D0 \u10EA\u10DC\u10DD\u10D1\u10D8\u10DA\u10D8 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DB\u10DD\u10DB\u10E1\u10D0\u10EE\u10E3\u10E0\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D8\u10E6\u10D4\u10D1\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1 \u10D2\u10D0\u10D6\u10D8\u10D0\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8 \u10E1\u10D0\u10ED\u10D8\u10E0\u10DD \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0.',
                        '"Archy\u201C  \u10D2\u10D0\u10DB\u10DD\u10E0\u10D8\u10EA\u10EE\u10D0\u10D5\u10E1 \u10E0\u10DD\u10D2\u10DD\u10E0\u10EA \u10D7\u10D0\u10D5\u10D8\u10E1, \u10D0\u10E1\u10D4\u10D5\u10D4 \u10DB\u10D8\u10E1\u10D8 \u10E7\u10D5\u10D4\u10DA\u10D0 \u10D7\u10D0\u10DC\u10D0\u10DB\u10E8\u10E0\u10DD\u10DB\u10DA\u10D8\u10E1 \u10DC\u10D4\u10D1\u10D8\u10E1\u10DB\u10D8\u10D4\u10E0 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1\u10DB\u10D2\u10D4\u10D1\u10DA\u10DD\u10D1\u10D0\u10E1 \u10EC\u10D8\u10DC\u10D0\u10DB\u10D3\u10D4\u10D1\u10D0\u10E0\u10D4 \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D8\u10E1\u10D0 \u10D3\u10D0 \u10DB\u10DD\u10E5\u10DB\u10D4\u10D3\u10D8 \u10D9\u10D0\u10DC\u10DD\u10DC\u10DB\u10D3\u10D4\u10D1\u10DA\u10DD\u10D1\u10D8\u10E1 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10D1\u10E0\u10D0\u10DA\u10D4\u10E3\u10DA\u10D8 \u10D3\u10D0\u10E0\u10E6\u10D5\u10D4\u10D5\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D0\u10E8\u10D8.',
                        '"Archy\u201C  \u10E1\u10D0\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10DD\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10DB\u10D8\u10E1\u10D8 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1\u10DB\u10D2\u10D4\u10D1\u10DA\u10DD\u10D1\u10D8\u10E1 \u10D3\u10D0\u10D3\u10D2\u10D4\u10DC\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D0\u10E8\u10D8 \u10E8\u10D4\u10D6\u10E6\u10E3\u10D3\u10E3\u10DA\u10D8\u10D0 \u10E1\u10D0\u10D3\u10D0\u10D5\u10DD \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D8\u10E1 \u10E6\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D4\u10D1\u10D8\u10E1 \u10DD\u10D3\u10D4\u10DC\u10DD\u10D1\u10D8\u10D7.',
                        "\u10D9\u10DD\u10DB\u10DE\u10D0\u10DC\u10D8\u10D0 \u10D8\u10EE\u10E1\u10DC\u10D8\u10E1 \u10E1\u10E0\u10E3\u10DA \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1\u10DB\u10D2\u10D4\u10D1\u10DA\u10DD\u10D1\u10D0\u10E1 \u10DC\u10D4\u10D1\u10D8\u10E1\u10DB\u10D8\u10D4\u10E0\u10D8 \u10E1\u10D0\u10EE\u10D8\u10E1 \u10D6\u10D8\u10D0\u10DC\u10D8\u10E1\u10D0\u10D7\u10D5\u10D8\u10E1 \u10D0\u10DC/\u10D3\u10D0 \u10E8\u10D4\u10E4\u10D4\u10E0\u10EE\u10D4\u10D1\u10D8\u10E1\u10D0\u10D7\u10D5\u10D8\u10E1, \u10E0\u10DD\u10DB\u10D4\u10DA\u10D8\u10EA \u10E8\u10D4\u10E1\u10D0\u10EB\u10DA\u10D4\u10D1\u10D4\u10DA\u10D8\u10D0 \u10D2\u10D0\u10DB\u10DD\u10EC\u10D5\u10D4\u10E3\u10DA \u10D8\u10E5\u10DC\u10D0\u10E1 \u10DB\u10D4\u10E1\u10D0\u10DB\u10D4 \u10DE\u10D8\u10E0\u10D4\u10D1\u10D8\u10E1 \u10DB\u10DD\u10DC\u10D0\u10EC\u10D8\u10DA\u10D4\u10DD\u10D1\u10D8\u10D7 - \u10D8\u10DC\u10E2\u10D4\u10E0\u10DC\u10D4\u10E2 \u10DE\u10E0\u10DD\u10D5\u10D0\u10D8\u10D3\u10D4\u10E0\u10D4\u10D1\u10D8\u10E1, \u10DB\u10DD\u10D1\u10D8\u10DA\u10E3\u10E0\u10D8 \u10D9\u10DD\u10DB\u10DE\u10D0\u10DC\u10D8\u10D4\u10D1\u10D8\u10E1 \u10D3\u10D0 \u10E1\u10EE\u10D5\u10D0\u10D7\u10D0 \u10E8\u10D4\u10E4\u10D4\u10E0\u10EE\u10D4\u10D1\u10E3\u10DA\u10D8 \u10DB\u10E3\u10E8\u10D0\u10DD\u10D1\u10D8\u10D7."
                    ].map((text)=>({
                            text: text
                        }))
                }
            },
            {
                H5: {
                    text: "\u10E8\u10D4\u10D6\u10E6\u10E3\u10D3\u10D5\u10D4\u10D1\u10D8 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D8\u10E1 \u10D2\u10D0\u10DB\u10DD\u10E7\u10D4\u10DC\u10D4\u10D1\u10D8\u10E1\u10D0\u10E1"
                },
                props: {
                    margin: "C 0 0"
                },
                Paragraphs: {
                    childExtend: (0, $b448a4a1f1311a88$export$56c0d5a1e737357d),
                    $propsCollection: [
                        '\u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4 \u10D0\u10E0\u10E1\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0 \u10E8\u10D4\u10D8\u10EB\u10DA\u10D4\u10D1\u10D0 \u10E8\u10D4\u10D8\u10EA\u10D5\u10D0\u10DA\u10DD\u10E1 \u10D0\u10DC \u10DB\u10DD\u10D8\u10EE\u10E1\u10DC\u10D0\u10E1 \u10EC\u10D8\u10DC\u10D0\u10E1\u10EC\u10D0\u10E0\u10D8 \u10E8\u10D4\u10E2\u10E7\u10DD\u10D1\u10D8\u10DC\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10E0\u10D4\u10E8\u10D4. "Archy"  \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10E1 \u10D0\u10E0 \u10D2\u10D0\u10E3\u10EC\u10D4\u10D5\u10E1 \u10D8\u10DB \u10E1\u10D0\u10EE\u10D8\u10E1 \u10DB\u10DD\u10DB\u10E1\u10D0\u10EE\u10E3\u10E0\u10D4\u10D1\u10D0\u10E1, \u10E0\u10DD\u10DB\u10D4\u10DA\u10D8\u10EA \u10DB\u10D8\u10D0\u10E9\u10DC\u10D8\u10D0, \u10E0\u10DD\u10DB \u10D4\u10EC\u10D8\u10DC\u10D0\u10D0\u10E6\u10DB\u10D3\u10D4\u10D2\u10D4\u10D1\u10D0 \u10DB\u10DD\u10E5\u10DB\u10D4\u10D3 \u10D9\u10D0\u10DC\u10DD\u10DC\u10DB\u10D3\u10D4\u10D1\u10DA\u10DD\u10D1\u10D0\u10E1.',
                        '\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10E1 \u10D4\u10D9\u10E0\u10EB\u10D0\u10DA\u10D4\u10D1\u10D0 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D8\u10E1 \u10D0\u10E0\u10D0\u10D9\u10D0\u10DC\u10DD\u10DC\u10D8\u10D4\u10E0\u10D8 \u10DB\u10D8\u10D6\u10DC\u10D4\u10D1\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1 \u10D2\u10D0\u10DB\u10DD\u10E7\u10D4\u10DC\u10D4\u10D1\u10D0, \u10DB\u10D0\u10D7 \u10E8\u10DD\u10E0\u10D8\u10E1, "Archy"-\u10D8\u10E1 \u10E1\u10D8\u10E1\u10E2\u10D4\u10DB\u10D4\u10D1\u10E8\u10D8 \u10D0\u10E0\u10D0\u10E1\u10D0\u10DC\u10E5\u10EA\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8 \u10E8\u10D4\u10E6\u10EC\u10D4\u10D5\u10D0, \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4 \u10D0\u10E0\u10E1\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D8\u10E1 \u10EA\u10D5\u10DA\u10D8\u10DA\u10D4\u10D1\u10D0, \u10D0\u10E0\u10D0\u10E1\u10D0\u10D7\u10D0\u10DC\u10D0\u10D3\u10DD\u10D3 \u10D2\u10D0\u10DB\u10DD\u10E7\u10D4\u10DC\u10D4\u10D1\u10D0 \u10D0\u10DC \u10E1\u10EE\u10D5\u10D0\u10D2\u10D5\u10D0\u10E0\u10D8 \u10E5\u10DB\u10D4\u10D3\u10D4\u10D1\u10D0, \u10E0\u10DD\u10DB\u10D4\u10DA\u10DB\u10D0\u10EA \u10E8\u10D4\u10D8\u10EB\u10DA\u10D4\u10D1\u10D0 \u10DE\u10D8\u10E0\u10D3\u10D0\u10DE\u10D8\u10E0\u10D8 \u10D0\u10DC \u10D8\u10E0\u10D8\u10D1\u10D8 \u10D6\u10D8\u10D0\u10DC\u10D8 \u10DB\u10D8\u10D0\u10E7\u10D4\u10DC\u10DD\u10E1 "Archy"-\u10D8\u10E1 \u10D9\u10D0\u10DC\u10DD\u10DC\u10D8\u10D7 \u10D3\u10D0\u10EA\u10E3\u10DA \u10D8\u10DC\u10E2\u10D4\u10E0\u10D4\u10E1\u10D4\u10D1\u10E1.'
                    ].map((text)=>({
                            text: text
                        }))
                }
            },
            {
                H5: {
                    text: "\u10DB\u10D0\u10E0\u10D9\u10D4\u10E2\u10D8\u10DC\u10D2\u10D8"
                },
                props: {
                    margin: "C 0 0"
                },
                Paragraphs: {
                    childExtend: (0, $b448a4a1f1311a88$export$56c0d5a1e737357d),
                    $propsCollection: [
                        "\u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4 \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10EA\u10D8\u10D8\u10E1 \u10E8\u10D4\u10E1\u10E7\u10D8\u10D3\u10D5\u10D8\u10E1 \u10D3\u10E0\u10DD\u10E1 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8 \u10D4\u10D7\u10D0\u10DC\u10EE\u10DB\u10D4\u10D1\u10D0 \u10E1\u10D0\u10E0\u10D4\u10D9\u10DA\u10D0\u10DB\u10DD, \u10EC\u10D0\u10DB\u10D0\u10EE\u10D0\u10DA\u10D8\u10E1\u10D4\u10D1\u10D4\u10DA\u10D8 \u10DB\u10D0\u10E1\u10D0\u10DA\u10D4\u10D1\u10D8\u10E1, \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1\u10D0\u10D7\u10D5\u10D8\u10E1 \u10E1\u10D0\u10D8\u10DC\u10E2\u10D4\u10E0\u10D4\u10E1\u10DD \u10DB\u10DD\u10DB\u10E1\u10D0\u10EE\u10E3\u10E0\u10D4\u10D1\u10D8\u10E1, \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10EA\u10D8\u10D8\u10E1\u10D0 \u10D3\u10D0 \u10E1\u10D4\u10E0\u10D5\u10D8\u10E1\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10DB\u10DD\u10EC\u10D4\u10E0\u10D0\u10E1. \u10D7\u10D0\u10DC\u10EE\u10DB\u10DD\u10D1\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D0\u10E8\u10D8 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8 \u10D4\u10DA\u10D4\u10E5\u10E2\u10E0\u10DD\u10DC\u10E3\u10DA\u10D8 \u10E4\u10DD\u10E1\u10E2\u10D8\u10E1 \u10DB\u10D4\u10E8\u10D5\u10D4\u10DD\u10D1\u10D8\u10D7 \u10DB\u10D8\u10D8\u10E6\u10D4\u10D1\u10E1 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D8\u10E1 \u10E1\u10D8\u10D0\u10EE\u10DA\u10D4\u10D4\u10D1\u10E1, \u10E1\u10EE\u10D5\u10D0\u10D3\u10D0\u10E1\u10EE\u10D5\u10D0 \u10E8\u10D4\u10D7\u10D0\u10D5\u10D0\u10D6\u10D4\u10D1\u10D0\u10E1\u10D0 \u10D3\u10D0 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0\u10E1.",
                        '\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10E1 \u10E8\u10D4\u10E3\u10EB\u10DA\u10D8\u10D0 \u10DC\u10D4\u10D1\u10D8\u10E1\u10DB\u10D8\u10D4\u10E0 \u10D3\u10E0\u10DD\u10E1 "Archy"-\u10D8\u10E1 \u10D4\u10DA\u10D4\u10E5\u10E2\u10E0\u10DD\u10DC\u10E3\u10DA \u10E4\u10DD\u10E1\u10E2\u10D0\u10D6\u10D4 \u10D2\u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D8\u10DA\u10D8 \u10E8\u10D4\u10E2\u10E7\u10DD\u10D1\u10D8\u10DC\u10D4\u10D1\u10D8\u10D7 \u10D2\u10D0\u10DC\u10D0\u10EA\u10EE\u10D0\u10D3\u10DD\u10E1 \u10E3\u10D0\u10E0\u10D8 \u10DB\u10D0\u10E0\u10D9\u10D4\u10E2\u10D8\u10DC\u10D2\u10E3\u10DA\u10D8 \u10D0\u10E5\u10E2\u10D8\u10D5\u10DD\u10D1\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10EE\u10D4\u10D1 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D8\u10E1 \u10DB\u10D8\u10E6\u10D4\u10D1\u10D0\u10D6\u10D4.'
                    ].map((text)=>({
                            text: text
                        }))
                }
            },
            {
                H5: {
                    text: "\u10E1\u10D0\u10D0\u10D5\u10E2\u10DD\u10E0\u10DD \u10E3\u10E4\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8"
                },
                props: {
                    margin: "C 0 0"
                },
                Paragraphs: {
                    childExtend: (0, $b448a4a1f1311a88$export$56c0d5a1e737357d),
                    $propsCollection: [
                        '\u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4 \u10D2\u10D0\u10DC\u10D7\u10D0\u10D5\u10E1\u10D4\u10D1\u10E3\u10DA\u10D8 \u10DC\u10D4\u10D1\u10D8\u10E1\u10DB\u10D8\u10D4\u10E0\u10D8 \u10E2\u10D4\u10E5\u10E1\u10E2\u10D8, \u10D2\u10E0\u10D0\u10E4\u10D8\u10D9\u10E3\u10DA\u10D8 \u10D3\u10D0 \u10D0\u10DC\u10D8\u10DB\u10D0\u10EA\u10D8\u10E3\u10E0\u10D8 \u10D2\u10D0\u10DB\u10DD\u10E1\u10D0\u10EE\u10E3\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8 \u10D4\u10E5\u10E1\u10D9\u10DA\u10E3\u10D6\u10D8\u10E3\u10E0\u10D0\u10D3 \u10D4\u10D9\u10E3\u10D7\u10D5\u10DC\u10D8\u10E1 "Archy" -\u10E1.',
                        '"Archy\u201C-\u10E1 \u10E1\u10D0\u10E1\u10D0\u10E5\u10DD\u10DC\u10DA\u10DD \u10DC\u10D8\u10E8\u10D0\u10DC\u10D8 \u10E0\u10D4\u10D2\u10D8\u10E1\u10E2\u10E0\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0 \u10E1\u10D0\u10E5\u10DE\u10D0\u10E2\u10D4\u10DC\u10E2\u10E8\u10D8 \u10D3\u10D0 \u10EC\u10D0\u10E0\u10DB\u10DD\u10D0\u10D3\u10D2\u10D4\u10DC\u10E1  "Archy\u201C \u10E1\u10D0\u10D9\u10E3\u10D7\u10E0\u10D4\u10D1\u10D0\u10E1.',
                        '"Archy\u201C-\u10D8\u10E1 \u10E1\u10D0\u10E1\u10D0\u10E5\u10DD\u10DC\u10DA\u10DD \u10DC\u10D8\u10E8\u10DC\u10D8\u10E1 \u10DC\u10D4\u10D1\u10D8\u10E1\u10DB\u10D8\u10D4\u10E0\u10D8 \u10E1\u10D0\u10EE\u10D8\u10D7 \u10D2\u10D0\u10DB\u10DD\u10E7\u10D4\u10DC\u10D4\u10D1\u10D0, "Archy"-\u10E1 \u10EC\u10D4\u10E0\u10D8\u10DA\u10DD\u10D1\u10D8\u10D7\u10D8 \u10E4\u10DD\u10E0\u10DB\u10D8\u10D7 \u10D2\u10D0\u10DB\u10DD\u10EE\u10D0\u10E2\u10E3\u10DA\u10D8 \u10EC\u10D8\u10DC\u10D0\u10E1\u10EC\u10D0\u10E0\u10D8 \u10D7\u10D0\u10DC\u10EE\u10DB\u10DD\u10D1\u10D8\u10E1 \u10D2\u10D0\u10E0\u10D4\u10E8\u10D4, \u10DB\u10D9\u10D0\u10EA\u10E0\u10D0\u10D3 \u10D0\u10D9\u10E0\u10EB\u10D0\u10DA\u10E3\u10DA\u10D8\u10D0. \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10E1 \u10D0\u10E0 \u10D0\u10E5\u10D5\u10E1 \u10E3\u10E4\u10DA\u10D4\u10D1\u10D0, \u10D2\u10D0\u10DB\u10DD\u10D8\u10E7\u10D4\u10DC\u10DD\u10E1 "Archy"-\u10D8\u10E1 \u10E1\u10D0\u10E1\u10D0\u10E5\u10DD\u10DC\u10DA\u10DD \u10DC\u10D8\u10E8\u10D0\u10DC\u10D8, \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4 \u10D2\u10D0\u10DC\u10D7\u10D0\u10D5\u10E1\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D2\u10E0\u10D0\u10E4\u10D8\u10D9\u10E3\u10DA\u10D8 \u10D2\u10D0\u10DB\u10DD\u10E1\u10D0\u10EE\u10E3\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8 \u10DC\u10D4\u10D1\u10D8\u10E1\u10DB\u10D8\u10D4\u10E0 \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D7\u10D0\u10DC \u10D0\u10DC \u10DB\u10DD\u10DB\u10E1\u10D0\u10EE\u10E3\u10E0\u10D4\u10D1\u10D0\u10E1\u10D7\u10D0\u10DC \u10D3\u10D0\u10D9\u10D0\u10D5\u10E8\u10D8\u10E0\u10D4\u10D1\u10D8\u10D7, \u10E0\u10D0\u10DB\u10D0\u10EA \u10E8\u10D4\u10D8\u10EB\u10DA\u10D4\u10D1\u10D0 \u10D2\u10D0\u10DB\u10DD\u10D8\u10EC\u10D5\u10D8\u10DD\u10E1 \u10D0\u10E6\u10E0\u10D4\u10D5\u10D0. \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10E1 \u10D0\u10E0 \u10D0\u10E5\u10D5\u10E1 \u10E3\u10E4\u10DA\u10D4\u10D1\u10D0, \u10D2\u10D0\u10DB\u10DD\u10D8\u10E7\u10D4\u10DC\u10DD\u10E1 \u10D8\u10E1\u10D8\u10DC\u10D8 \u10D8\u10DB\u10D2\u10D5\u10D0\u10E0\u10D0\u10D3, \u10E0\u10DD\u10DB \u10D3\u10D0\u10D0\u10DB\u10EA\u10D8\u10E0\u10DD\u10E1 \u10D0\u10DC \u10E8\u10D4\u10E3\u10E0\u10D0\u10EA\u10EE\u10E7\u10DD\u10E4\u10D0 \u10DB\u10D8\u10D0\u10E7\u10D4\u10DC\u10DD\u10E1 "Archy" -\u10E1 \u10E0\u10D4\u10DE\u10E3\u10E2\u10D0\u10EA\u10D8\u10D0\u10E1. \u10D0\u10DB\u10D2\u10D5\u10D0\u10E0\u10D8 \u10D3\u10D0\u10E0\u10E6\u10D5\u10D4\u10D5\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D0\u10E8\u10D8, "Archy"  \u10E3\u10E4\u10DA\u10D4\u10D1\u10D0\u10E1 \u10D8\u10E2\u10DD\u10D5\u10D4\u10D1\u10E1, \u10DB\u10D8\u10DB\u10D0\u10E0\u10D7\u10DD\u10E1 \u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10D4\u10D1\u10E0\u10D8\u10D5\u10D8 \u10E3\u10E4\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8\u10E1 \u10D3\u10D0\u10EA\u10D5\u10D8\u10E1 \u10E1\u10D0\u10E8\u10E3\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10E1. \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1\u10DB\u10D2\u10D4\u10D1\u10D4\u10DA\u10D8 \u10D8\u10E5\u10DC\u10D4\u10D1\u10D0 "Archy" -\u10E1\u10D0\u10D7\u10D5\u10D8\u10E1 \u10DB\u10D8\u10E7\u10D4\u10DC\u10D4\u10D1\u10E3\u10DA \u10DB\u10D0\u10E2\u10D4\u10E0\u10D8\u10D0\u10DA\u10E3\u10E0 \u10D3\u10D0 \u10D0\u10E0\u10D0\u10DB\u10D0\u10E2\u10D4\u10E0\u10D8\u10D0\u10DA\u10E3\u10E0 \u10D6\u10D8\u10D0\u10DC\u10D6\u10D4, \u10D6\u10D8\u10D0\u10DC\u10D8 \u10E8\u10D4\u10E1\u10D0\u10EB\u10DA\u10DD\u10D0 \u10DB\u10DD\u10D8\u10EA\u10D0\u10D5\u10D3\u10D4\u10E1 "Archy"-\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10D0\u10DB \u10D6\u10D8\u10D0\u10DC\u10D8\u10E1 \u10D0\u10E6\u10DB\u10DD\u10E4\u10EE\u10D5\u10E0\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1 \u10D2\u10D0\u10EC\u10D4\u10E3\u10DA \u10EE\u10D0\u10E0\u10EF\u10D4\u10D1\u10E1, \u10DB\u10D0\u10D7 \u10E8\u10DD\u10E0\u10D8\u10E1, \u10E1\u10D0\u10D0\u10D3\u10D5\u10DD\u10D9\u10D0\u10E2\u10DD \u10DB\u10DD\u10DB\u10E1\u10D0\u10EE\u10E3\u10E0\u10D4\u10D1\u10D8\u10E1\u10D0 \u10D3\u10D0 \u10E1\u10D0\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10DD\u10E1 \u10EE\u10D0\u10E0\u10EF\u10D4\u10D1\u10E1.',
                        "\u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4 \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10EA\u10D8\u10D8\u10E1 \u10E7\u10D8\u10D3\u10D5\u10D8\u10D7 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D6\u10D4 \u10D0\u10E0 \u10D2\u10D0\u10D3\u10D0\u10D3\u10D8\u10E1 \u10D0\u10E0\u10D0\u10DC\u10D0\u10D8\u10E0\u10D8 \u10E1\u10D0\u10D0\u10D5\u10E2\u10DD\u10E0\u10DD \u10E3\u10E4\u10DA\u10D4\u10D1\u10D0.",
                        '"Archy\u201C  \u10DE\u10D0\u10E2\u10D8\u10D5\u10E1 \u10E1\u10EA\u10D4\u10DB\u10E1 \u10E1\u10EE\u10D5\u10D0 \u10DE\u10D8\u10E0\u10D4\u10D1\u10D8\u10E1 \u10E1\u10D0\u10D0\u10D5\u10E2\u10DD\u10E0\u10DD \u10E3\u10E4\u10DA\u10D4\u10D1\u10D4\u10D1\u10E1 \u10D3\u10D0 \u10DB\u10DD\u10E3\u10EC\u10DD\u10D3\u10D4\u10D1\u10E1 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10E1 \u10D3\u10D0\u10D8\u10EA\u10D5\u10D0\u10E1 "Archy"-\u10D8\u10E1 \u10E1\u10D0\u10D0\u10D5\u10E2\u10DD\u10E0\u10DD \u10E3\u10E4\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8.',
                        '\u10D8\u10DB \u10E8\u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D0\u10E8\u10D8, \u10D7\u10E3 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8 \u10E1\u10D0\u10D0\u10D5\u10E2\u10DD\u10E0\u10DD \u10E3\u10E4\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D4\u10E1\u10D0\u10D9\u10E3\u10D7\u10E0\u10D4\u10D0 \u10D3\u10D0 \u10D7\u10D5\u10DA\u10D8\u10E1, \u10E0\u10DD\u10DB \u10DB\u10D8\u10E1\u10D8 \u10E1\u10D0\u10D0\u10D5\u10E2\u10DD\u10E0\u10DD \u10E3\u10E4\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D3\u10D0\u10EA\u10D5\u10D8\u10E1 \u10DD\u10D1\u10D8\u10D4\u10E5\u10E2\u10D8 \u10E0\u10D0\u10D8\u10DB\u10D4 \u10E4\u10DD\u10E0\u10DB\u10D8\u10D7, \u10D9\u10D0\u10DC\u10DD\u10DC\u10DB\u10D3\u10D4\u10D1\u10DA\u10DD\u10D1\u10D8\u10E1 \u10D3\u10D0\u10E0\u10E6\u10D5\u10D4\u10D5\u10D8\u10D7 \u10D2\u10D0\u10DC\u10D7\u10D0\u10D5\u10E1\u10D3\u10D0 "Archy" -\u10D6\u10D4, \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8 \u10E3\u10DC\u10D3\u10D0 \u10D3\u10D0\u10E3\u10D9\u10D0\u10D5\u10E8\u10D8\u10E0\u10D3\u10D4\u10E1 "Archy" -\u10E1 \u10D4\u10DA\u10D4\u10E5\u10E2\u10E0\u10DD\u10DC\u10E3\u10DA \u10E4\u10DD\u10E1\u10E2\u10D0\u10D6\u10D4 \u10D3\u10D0 \u10DB\u10D8\u10E3\u10D7\u10D8\u10D7\u10DD\u10E1 \u10D3\u10D0\u10DC\u10D8\u10E8\u10DC\u10E3\u10DA\u10D4\u10D1\u10D0\u10E8\u10D8 \u10E1\u10D0\u10D0\u10D5\u10E2\u10DD\u10E0\u10DD \u10E3\u10E4\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D3\u10D0\u10E0\u10E6\u10D5\u10D4\u10D5\u10D0.'
                    ].map((text)=>({
                            text: text
                        }))
                }
            },
            {
                H5: {
                    text: "\u10DB\u10DD\u10E5\u10DB\u10D4\u10D3\u10D4\u10D1\u10D8\u10E1 \u10D5\u10D0\u10D3\u10D0 \u10D3\u10D0 \u10E8\u10D4\u10EC\u10E7\u10D5\u10D4\u10E2\u10D0"
                },
                props: {
                    margin: "C 0 0"
                },
                Paragraphs: {
                    childExtend: (0, $b448a4a1f1311a88$export$56c0d5a1e737357d),
                    $propsCollection: [
                        "\u10EC\u10D8\u10DC\u10D0\u10DB\u10D3\u10D4\u10D1\u10D0\u10E0\u10D4 \u10EC\u10D4\u10E1\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10DE\u10D8\u10E0\u10DD\u10D1\u10D4\u10D1\u10D8 \u10EB\u10D0\u10DA\u10D0\u10E8\u10D8 \u10E8\u10D4\u10D3\u10D8\u10E1 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10D7\u10D0\u10DC\u10EE\u10DB\u10DD\u10D1\u10D8\u10E1 \u10D2\u10D0\u10DB\u10DD\u10EA\u10EE\u10D0\u10D3\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2.",
                        '\u10EC\u10D8\u10DC\u10D0\u10DB\u10D3\u10D4\u10D1\u10D0\u10E0\u10D4 \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D8\u10E1 \u10DB\u10DD\u10E5\u10DB\u10D4\u10D3\u10D4\u10D1\u10D0 \u10E8\u10D4\u10E1\u10D0\u10EB\u10DA\u10D4\u10D1\u10D4\u10DA\u10D8\u10D0 \u10E8\u10D4\u10EC\u10E7\u10D3\u10D4\u10E1 \u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD\u10E1 \u10D9\u10D0\u10DC\u10DD\u10DC\u10DB\u10D3\u10D4\u10D1\u10DA\u10DD\u10D1\u10D8\u10D7 \u10D0\u10DC/\u10D3\u10D0 \u10EC\u10D8\u10DC\u10D0\u10DB\u10D3\u10D4\u10D1\u10D0\u10E0\u10D4 \u10EC\u10D4\u10E1\u10D8\u10D7 \u10D2\u10D0\u10D7\u10D5\u10D0\u10DA\u10D8\u10E1\u10EC\u10D8\u10DC\u10D4\u10D1\u10E3\u10DA \u10E8\u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D4\u10D1\u10E8\u10D8, \u10D0\u10D2\u10E0\u10D4\u10D7\u10D5\u10D4 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10D8\u10DC\u10D8\u10EA\u10D8\u10D0\u10E2\u10D8\u10D5\u10D8\u10D7 \u10DC\u10D4\u10D1\u10D8\u10E1\u10DB\u10D8\u10D4\u10E0 \u10D3\u10E0\u10DD\u10E1, \u10E8\u10D4\u10EC\u10E7\u10D5\u10D4\u10E2\u10D8\u10E1 \u10DB\u10DD\u10DB\u10D4\u10DC\u10E2\u10D8\u10E1\u10D0\u10D7\u10D5\u10D8\u10E1 "Archy"-\u10D8\u10E1 \u10EC\u10D8\u10DC\u10D0\u10E8\u10D4 \u10D0\u10E0\u10E1\u10D4\u10D1\u10E3\u10DA\u10D8 \u10DC\u10D4\u10D1\u10D8\u10E1\u10DB\u10D8\u10D4\u10E0\u10D8 \u10E1\u10D0\u10EE\u10D8\u10E1 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D8\u10D0\u10DC\u10D4\u10D1\u10D8\u10E1 (\u10D0\u10E1\u10D4\u10D7\u10D8\u10E1 \u10D0\u10E0\u10E1\u10D4\u10D1\u10DD\u10D1\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D0\u10E8\u10D8) \u10E1\u10E0\u10E3\u10DA\u10D0\u10D3 \u10D3\u10D0\u10E4\u10D0\u10E0\u10D5\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2.'
                    ].map((text)=>({
                            text: text
                        }))
                }
            },
            {
                H5: {
                    text: "\u10DB\u10D4\u10E1\u10D0\u10DB\u10D4 \u10DB\u10EE\u10D0\u10E0\u10D4"
                },
                props: {
                    margin: "C 0 0"
                },
                Paragraphs: {
                    childExtend: (0, $b448a4a1f1311a88$export$56c0d5a1e737357d),
                    $propsCollection: [
                        '"Archy\u201C  \u10D8\u10EE\u10E1\u10DC\u10D8\u10E1 \u10E7\u10DD\u10D5\u10D4\u10DA\u10D2\u10D5\u10D0\u10E0 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1\u10DB\u10D2\u10D4\u10D1\u10DA\u10DD\u10D1\u10D0\u10E1 \u10E1\u10EE\u10D5\u10D0 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D4\u10D1\u10D7\u10D0\u10DC \u10DB\u10D8\u10DB\u10D0\u10E0\u10D7\u10D4\u10D1\u10D8\u10D7, \u10E0\u10DD\u10DB\u10DA\u10D4\u10D1\u10D8\u10EA \u10E8\u10D4\u10E1\u10D0\u10EB\u10DA\u10D4\u10D1\u10D4\u10DA\u10D8\u10D0 \u10D2\u10D0\u10E0\u10D4 \u10D1\u10DB\u10E3\u10DA\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D8\u10D7 \u10D2\u10D0\u10DC\u10D7\u10D0\u10D5\u10E1\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D8\u10E7\u10DD\u10E1 "Archy"-\u10D8\u10E1 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4. \u10E1\u10EE\u10D5\u10D0 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D8\u10E1 \u10E8\u10D8\u10DC\u10D0\u10D0\u10E0\u10E1\u10D8, \u10EC\u10D4\u10E1\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10DE\u10D8\u10E0\u10DD\u10D1\u10D4\u10D1\u10D8, \u10D9\u10DD\u10DC\u10E4\u10D8\u10D3\u10D4\u10DC\u10EA\u10D8\u10D0\u10DA\u10E3\u10E0\u10DD\u10D1\u10D8\u10E1 \u10DE\u10DD\u10DA\u10D8\u10E2\u10D8\u10D9\u10D0 \u10E8\u10D4\u10E1\u10D0\u10EB\u10DA\u10DD\u10D0 \u10D2\u10D0\u10DC\u10E1\u10EE\u10D5\u10D0\u10D5\u10D3\u10D4\u10D1\u10DD\u10D3\u10D4\u10E1 \u10EC\u10D8\u10DC\u10D0\u10DB\u10D3\u10D4\u10D1\u10D0\u10E0\u10D4 \u10DE\u10DD\u10DA\u10D8\u10E2\u10D8\u10D9\u10D8\u10E1\u10D2\u10D0\u10DC. \u10E8\u10D4\u10E1\u10D0\u10D1\u10D0\u10DB\u10D8\u10E1\u10D0\u10D3, "Archy"  \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10E1 \u10DB\u10DD\u10E3\u10EC\u10DD\u10D3\u10D4\u10D1\u10E1 \u10D2\u10D0\u10D4\u10EA\u10DC\u10DD\u10E1 \u10D2\u10D0\u10E0\u10D4 \u10D1\u10DB\u10E3\u10DA\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D8\u10D7 \u10DB\u10D8\u10D7\u10D8\u10D7\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D8\u10E1 \u10D2\u10D0\u10DB\u10DD\u10E7\u10D4\u10DC\u10D4\u10D1\u10D8\u10E1 \u10DE\u10D8\u10E0\u10DD\u10D1\u10D4\u10D1\u10E1\u10D0 \u10D3\u10D0 \u10D9\u10DD\u10DC\u10E4\u10D8\u10D3\u10D4\u10DC\u10EA\u10D8\u10D0\u10DA\u10E3\u10E0\u10DD\u10D1\u10D8\u10E1 \u10DE\u10DD\u10DA\u10D8\u10E2\u10D8\u10D9\u10D0\u10E1.'
                    ].map((text)=>({
                            text: text
                        }))
                }
            },
            {
                H5: {
                    text: "\u10DB\u10D0\u10E0\u10D4\u10D2\u10E3\u10DA\u10D8\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8 \u10D9\u10D0\u10DC\u10DD\u10DC\u10DB\u10D3\u10D4\u10D1\u10DA\u10DD\u10D1\u10D0 \u10D3\u10D0 \u10D3\u10D0\u10D5\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10D3\u10D0\u10EC\u10E7\u10D5\u10D4\u10E2\u10D8\u10E1 \u10EC\u10D4\u10E1\u10D8"
                },
                props: {
                    margin: "C 0 0"
                },
                Paragraphs: {
                    childExtend: (0, $b448a4a1f1311a88$export$56c0d5a1e737357d),
                    $propsCollection: [
                        "\u10EC\u10D8\u10DC\u10D0\u10DB\u10D3\u10D4\u10D1\u10D0\u10E0\u10D4 \u10EC\u10D4\u10E1\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10DE\u10D8\u10E0\u10DD\u10D1\u10D4\u10D1\u10D8 \u10E0\u10D4\u10D2\u10E3\u10DA\u10D8\u10E0\u10D3\u10D4\u10D1\u10D0 \u10D3\u10D0 \u10D2\u10D0\u10DC\u10D8\u10DB\u10D0\u10E0\u10E2\u10D4\u10D1\u10D0 \u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD\u10E1 \u10DB\u10DD\u10E5\u10DB\u10D4\u10D3\u10D8 \u10D9\u10D0\u10DC\u10DD\u10DC\u10DB\u10D3\u10D4\u10D1\u10DA\u10DD\u10D1\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10D1\u10D0\u10DB\u10D8\u10E1\u10D0\u10D3.",
                        "\u10DB\u10EE\u10D0\u10E0\u10D4\u10D4\u10D1\u10D8 \u10D7\u10D0\u10DC\u10EE\u10DB\u10D3\u10D4\u10D1\u10D8\u10D0\u10DC \u10E0\u10DD\u10DB \u10D3\u10D0\u10D5\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D0\u10E8\u10D8, \u10E8\u10D4\u10D4\u10EA\u10D3\u10D4\u10D1\u10D8\u10D0\u10DC \u10DB\u10DD\u10DA\u10D0\u10DE\u10D0\u10E0\u10D0\u10D9\u10D4\u10D1\u10D8\u10D7 \u10D2\u10D0\u10D3\u10D0\u10EC\u10E7\u10D3\u10D4\u10E1 \u10EC\u10D0\u10E0\u10DB\u10DD\u10E8\u10DD\u10D1\u10D8\u10DA\u10D8 \u10E3\u10D7\u10D0\u10DC\u10EE\u10DB\u10DD\u10D4\u10D1\u10D0. \u10DB\u10DD\u10DA\u10D0\u10DE\u10D0\u10E0\u10D0\u10D9\u10D4\u10D1\u10D4\u10D1\u10D8\u10E1 \u10EC\u10D0\u10E0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7 \u10D3\u10D0\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10E3\u10EB\u10DA\u10D4\u10D1\u10DA\u10DD\u10D1\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D0\u10E8\u10D8, \u10DB\u10EE\u10D0\u10E0\u10D4\u10D4\u10D1\u10D8 \u10E3\u10E4\u10DA\u10D4\u10D1\u10D0\u10DB\u10DD\u10E1\u10D8\u10DA\u10DC\u10D8 \u10D0\u10E0\u10D8\u10D0\u10DC \u10DB\u10D8\u10DB\u10D0\u10E0\u10D7\u10DD\u10DC \u10D7\u10D1\u10D8\u10DA\u10D8\u10E1\u10D8\u10E1 \u10E1\u10D0\u10E5\u10D0\u10DA\u10D0\u10E5\u10DD \u10E1\u10D0\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10DD\u10E1.",
                        "\u10EC\u10D8\u10DC\u10D0\u10DB\u10D3\u10D4\u10D1\u10D0\u10E0\u10D4 \u10EC\u10D4\u10E1\u10D4\u10D1\u10D8\u10E1\u10D0 \u10D3\u10D0 \u10DE\u10D8\u10E0\u10DD\u10D1\u10D4\u10D1\u10D8\u10E1 \u10E0\u10DD\u10DB\u10D4\u10DA\u10D8\u10DB\u10D4 \u10DC\u10D0\u10EC\u10D8\u10DA\u10D8\u10E1 \u10D1\u10D0\u10D7\u10D8\u10DA\u10D0\u10D3 \u10EA\u10DC\u10DD\u10D1\u10D0 \u10D0\u10E0 \u10D2\u10D0\u10DB\u10DD\u10D8\u10EC\u10D5\u10D4\u10D5\u10E1 \u10E1\u10EE\u10D5\u10D0 \u10DC\u10D0\u10EC\u10D8\u10DA\u10D8\u10E1 \u10D1\u10D0\u10D7\u10D8\u10DA\u10D0\u10D3 \u10EA\u10DC\u10DD\u10D1\u10D0\u10E1."
                    ].map((text)=>({
                            text: text
                        }))
                }
            },
            {
                H5: {
                    text: "\u10EA\u10D5\u10DA\u10D8\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D4\u10D1\u10D8"
                },
                props: {
                    margin: "C 0 0"
                },
                Paragraphs: {
                    childExtend: (0, $b448a4a1f1311a88$export$56c0d5a1e737357d),
                    $propsCollection: [
                        '"Archy\u201C  \u10D8\u10E2\u10DD\u10D5\u10D4\u10D1\u10E1 \u10E3\u10E4\u10DA\u10D4\u10D1\u10D0\u10E1, \u10EC\u10D8\u10DC\u10D0\u10DB\u10D3\u10D4\u10D1\u10D0\u10E0\u10D4 \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10E8\u10D8 \u10DC\u10D4\u10D1\u10D8\u10E1\u10DB\u10D8\u10D4\u10E0 \u10D3\u10E0\u10DD\u10E1, \u10EA\u10D0\u10DA\u10DB\u10EE\u10E0\u10D8\u10D5\u10D0\u10D3, \u10D0\u10DB\u10D0\u10D5\u10D4 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4 \u10D2\u10D0\u10DB\u10DD\u10E5\u10D5\u10D4\u10E7\u10DC\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D6\u10D8\u10D7, \u10E8\u10D4\u10D8\u10E2\u10D0\u10DC\u10DD\u10E1 \u10EA\u10D5\u10DA\u10D8\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8 \u10D0\u10DC/\u10D3\u10D0 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D4\u10D1\u10D8 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D2\u10DD\u10DB\u10D8 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7\u10D8 \u10D7\u10D0\u10DC\u10EE\u10DB\u10DD\u10D1\u10D8\u10E1 \u10D2\u10D0\u10E0\u10D4\u10E8\u10D4. \u10EA\u10D5\u10DA\u10D8\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8\u10E1/\u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10DC\u10EE\u10DD\u10E0\u10EA\u10D8\u10D4\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2, "Archy"  \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D8\u10D7 \u10E1\u10D0\u10E0\u10D2\u10D4\u10D1\u10DA\u10DD\u10D1\u10D8\u10E1 \u10D2\u10D0\u10D2\u10E0\u10EB\u10D4\u10DA\u10D4\u10D1\u10D0\u10E1 \u10DB\u10D8\u10D8\u10E9\u10DC\u10D4\u10D5\u10E1 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10D7\u10D0\u10DC\u10EE\u10DB\u10DD\u10D1\u10D0\u10D3.'
                    ].map((text)=>({
                            text: text
                        }))
                }
            }
        ]
    }
};
const $0137ee424137bfa9$export$116a08ee153e3bde = {
    extend: $0137ee424137bfa9$var$Static,
    LogoHeader: {},
    content: {
        extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
        props: {
            flow: "column"
        },
        H2: {
            order: -1,
            text: "\u10D9\u10DD\u10DC\u10E4\u10D8\u10D3\u10D4\u10DC\u10EA\u10D8\u10D0\u10DA\u10E3\u10E0\u10DD\u10D1\u10D8\u10E1 \u10DE\u10D8\u10E0\u10DD\u10D1\u10D4\u10D1\u10D8"
        },
        ...[
            {
                H5: {
                    text: "\u10DB\u10D8\u10D6\u10D0\u10DC\u10D8"
                },
                props: {
                    margin: "C 0 0"
                },
                Paragraphs: {
                    childExtend: (0, $b448a4a1f1311a88$export$56c0d5a1e737357d),
                    $propsCollection: [
                        '\u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4 archy.ge-\u10D6\u10D4 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D8\u10E1 \u10D3\u10E0\u10DD\u10E1 \u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10D8 \u10EE\u10D0\u10E0\u10D7 \u10D2\u10D0\u10D4\u10EA\u10DC\u10DD\u10D7 \u10E9\u10D5\u10D4\u10DC\u10E1 \u10D9\u10DD\u10DC\u10E4\u10D8\u10D3\u10D4\u10DC\u10EA\u10D8\u10D0\u10DA\u10E3\u10E0\u10DD\u10D1\u10D8\u10E1 \u10DE\u10DD\u10DA\u10D8\u10E2\u10D8\u10D9\u10D0\u10E1. \u10E8\u10D4\u10E1\u10D0\u10EB\u10DA\u10D4\u10D1\u10D4\u10DA\u10D8\u10D0 \u10EC\u10D8\u10DC\u10D0\u10DB\u10D3\u10D4\u10D1\u10D0\u10E0\u10D4 \u10D9\u10DD\u10DC\u10E4\u10D8\u10D3\u10D4\u10DC\u10EA\u10D8\u10D0\u10DA\u10E3\u10E0\u10DD\u10D1\u10D8\u10E1 \u10DE\u10DD\u10DA\u10D8\u10E2\u10D8\u10D9\u10D0\u10E8\u10D8 \u10D2\u10D0\u10DC\u10EE\u10DD\u10E0\u10EA\u10D8\u10D4\u10DA\u10D3\u10D4\u10E1 \u10EA\u10D5\u10DA\u10D8\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D4\u10D1\u10D8, \u10E8\u10D4\u10E1\u10D0\u10D1\u10D0\u10DB\u10D8\u10E1\u10D0\u10D3 "Archy"  \u10DB\u10DD\u10D2\u10D8\u10EC\u10DD\u10D3\u10D4\u10D1\u10D7, \u10E0\u10DD\u10DB \u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10E3\u10DA\u10D0\u10D3 \u10D2\u10D0\u10D3\u10D0\u10D0\u10DB\u10DD\u10EC\u10DB\u10DD\u10D7 \u10D9\u10DD\u10DC\u10E4\u10D8\u10D3\u10D4\u10DC\u10EA\u10D8\u10D0\u10DA\u10E3\u10E0\u10DD\u10D1\u10D8\u10E1 \u10DE\u10DD\u10DA\u10D8\u10E2\u10D8\u10D9\u10D0.',
                        '\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8, \u10E0\u10DD\u10DB\u10D4\u10DA\u10D8\u10EA "Archy" -\u10E1 \u10E1\u10D0\u10D9\u10E3\u10D7\u10D0\u10E0\u10D8 \u10E1\u10E3\u10E0\u10D5\u10D8\u10DA\u10D8\u10D7 \u10DB\u10D8\u10D0\u10EC\u10DD\u10D3\u10D4\u10D1\u10E1 \u10DE\u10D4\u10E0\u10E1\u10DD\u10DC\u10D0\u10DA\u10E3\u10E0\u10D8 \u10EE\u10D0\u10E1\u10D8\u10D0\u10D7\u10D8\u10E1 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0\u10E1, \u10D8\u10E1 \u10D0\u10D5\u10E2\u10DD\u10DB\u10D0\u10E2\u10E3\u10E0\u10D0\u10D3 \u10D0\u10DC\u10D8\u10ED\u10D4\u10D1\u10E1 \u10E3\u10E4\u10DA\u10D4\u10D1\u10D0\u10DB\u10DD\u10E1\u10D8\u10DA\u10D4\u10D1\u10D0\u10E1 "Archy" -\u10E1 \u10D2\u10D0\u10DB\u10DD\u10D8\u10E7\u10D4\u10DC\u10DD\u10E1 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DE\u10D4\u10E0\u10E1\u10DD\u10DC\u10D0\u10DA\u10E3\u10E0\u10D8 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D8\u10E1\u10D0 \u10D3\u10D0 \u10D3\u10D0\u10DB\u10E3\u10E8\u10D0\u10D5\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D8\u10D6\u10DC\u10D8\u10D7.',
                        '\u10EC\u10D8\u10DC\u10D0\u10DB\u10D3\u10D4\u10D1\u10D0\u10E0\u10D4 \u10D9\u10DD\u10DC\u10E4\u10D8\u10D3\u10D4\u10DC\u10EA\u10D8\u10D0\u10DA\u10E3\u10E0\u10DD\u10D1\u10D8\u10E1 \u10DE\u10DD\u10DA\u10D8\u10E2\u10D8\u10D9\u10D0 \u10D2\u10D0\u10DC\u10E1\u10D0\u10D6\u10E6\u10D5\u10E0\u10D0\u10D5\u10E1 "Archy"-\u10D8\u10E1 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D7\u10D0 \u10DE\u10D4\u10E0\u10E1\u10DD\u10DC\u10D0\u10DA\u10E3\u10E0\u10D8 \u10EE\u10D0\u10E1\u10D8\u10D0\u10D7\u10D8\u10E1 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8\u10E1 \u10D3\u10D0\u10DB\u10E3\u10E8\u10D0\u10D5\u10D4\u10D1\u10D8\u10E1 \u10EC\u10D4\u10E1\u10E1, \u10DB\u10D8\u10D6\u10DC\u10D4\u10D1\u10E1, \u10D2\u10D0\u10DB\u10DD\u10E7\u10D4\u10DC\u10D4\u10D1\u10D8\u10E1\u10D0 \u10D3\u10D0 \u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D8\u10E1 \u10DE\u10D8\u10E0\u10DD\u10D1\u10D4\u10D1\u10E1. \u201E\u10DE\u10D4\u10E0\u10E1\u10DD\u10DC\u10D0\u10DA\u10E3\u10E0 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D7\u10D0 \u10D3\u10D0\u10EA\u10D5\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10EE\u10D4\u10D1\u201C \u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD\u10E1 \u10D9\u10D0\u10DC\u10DD\u10DC\u10D8\u10E1 \u10E1\u10D0\u10E4\u10E3\u10EB\u10D5\u10D4\u10DA\u10D6\u10D4, "Archy"-\u10D8\u10E1 \u10DB\u10D8\u10D6\u10D0\u10DC\u10D8\u10D0 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DE\u10D4\u10E0\u10E1\u10DD\u10DC\u10D0\u10DA\u10E3\u10E0\u10D8 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8\u10E1 \u10D3\u10D0\u10EA\u10D5\u10D0.',
                        '\u10EC\u10D8\u10DC\u10D0\u10DB\u10D3\u10D4\u10D1\u10D0\u10E0\u10D4 \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D8 (\u10D9\u10DD\u10DC\u10E4\u10D8\u10D3\u10D4\u10DC\u10EA\u10D8\u10D0\u10DA\u10E3\u10E0\u10DD\u10D1\u10D8\u10E1 \u10DE\u10DD\u10DA\u10D8\u10E2\u10D8\u10D9\u10D0) \u10EC\u10D0\u10E0\u10DB\u10DD\u10D0\u10D3\u10D2\u10D4\u10DC\u10E1 "Archy"-\u10D8\u10E1 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D8\u10D7 \u10E1\u10D0\u10E0\u10D2\u10D4\u10D1\u10DA\u10DD\u10D1\u10D8\u10E1 \u10EC\u10D4\u10E1\u10D4\u10D1\u10D8\u10E1\u10D0 \u10D3\u10D0 \u10DE\u10D8\u10E0\u10DD\u10D1\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10DC\u10E3\u10E7\u10DD\u10E4\u10D4\u10DA \u10DC\u10D0\u10EC\u10D8\u10DA\u10E1, \u10E0\u10DD\u10DB\u10D4\u10DA\u10D8\u10EA \u10D0\u10E0\u10D8\u10E1 \u10DD\u10E0\u10DB\u10EE\u10E0\u10D8\u10D5\u10D8 \u10DB\u10D0\u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10D4\u10D1\u10D4\u10DA\u10D8 \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D8.'
                    ].map((text)=>({
                            text: text
                        }))
                }
            },
            {
                props: {
                    margin: "C 0 0"
                },
                H5: {
                    text: "\u10E2\u10D4\u10E0\u10DB\u10D8\u10DC\u10D7\u10D0 \u10D2\u10D0\u10DC\u10DB\u10D0\u10E0\u10E2\u10D4\u10D1\u10D0"
                },
                P: {
                    text: "\u10EC\u10D8\u10DC\u10D0\u10DB\u10D3\u10D4\u10D1\u10D0\u10E0\u10D4 \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10E8\u10D8 \u10D2\u10D0\u10DB\u10DD\u10E7\u10D4\u10DC\u10D4\u10D1\u10E3\u10DA \u10E2\u10D4\u10E0\u10DB\u10D8\u10DC\u10D4\u10D1\u10E1 \u10D0\u10E5\u10D5\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8 \u10DB\u10DC\u10D8\u10E8\u10D5\u10DC\u10D4\u10DA\u10DD\u10D1\u10D0:"
                },
                Ul: {
                    props: {},
                    $propsCollection: [
                        '"Archy" (\u10E8\u10D4\u10DB\u10D3\u10D2\u10DD\u10DB\u10E8\u10D8 \u201E\u10E9\u10D5\u10D4\u10DC\u201C, \u201E\u10E9\u10D5\u10D4\u10DC\u10D8\u201C, \u201E\u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D8\u201C) - \u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD\u10E1 \u10D9\u10D0\u10DC\u10DD\u10DC\u10DB\u10D3\u10D4\u10D1\u10DA\u10DD\u10D1\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10D1\u10D0\u10DB\u10D8\u10E1\u10D0\u10D3 \u10D3\u10D0\u10E4\u10E3\u10EB\u10DC\u10D4\u10D1\u10E3\u10DA\u10D8 \u10E8\u10DE\u10E1 \u10D0\u10E0\u10E9\u10D8, \u10E1\u10D0\u10D8\u10D3\u10D4\u10DC\u10E2\u10D8\u10E4\u10D8\u10D9\u10D0\u10EA\u10D8\u10DD \u10D9\u10DD\u10D3\u10D8 400232798, \u10E0\u10D4\u10D2\u10D8\u10E1\u10E2\u10E0\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8:  \u10D3\u10D0\u10D5\u10D8\u10D7 \u10D2\u10E3\u10E0\u10D0\u10DB\u10D8\u10E8\u10D5\u10D8\u10DA\u10D8 \u10D2\u10D0\u10DB\u10D6. 78, \u10D1\u10DA\u10DD\u10D9\u10D8 D.',
                        "\u10DE\u10D4\u10E0\u10E1\u10DD\u10DC\u10D0\u10DA\u10E3\u10E0\u10D8 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D8 - \u10DC\u10D4\u10D1\u10D8\u10E1\u10DB\u10D8\u10D4\u10E0\u10D8 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0, \u10E0\u10DD\u10DB\u10D4\u10DA\u10D8\u10EA \u10E3\u10D9\u10D0\u10D5\u10E8\u10D8\u10E0\u10D3\u10D4\u10D1\u10D0 \u10D8\u10D3\u10D4\u10DC\u10E2\u10D8\u10E4\u10D8\u10EA\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA \u10D0\u10DC \u10D8\u10D3\u10D4\u10DC\u10E2\u10D8\u10E4\u10D8\u10EA\u10D8\u10E0\u10D4\u10D1\u10D0\u10D3 \u10E4\u10D8\u10D6\u10D8\u10D9\u10E3\u10E0 \u10DE\u10D8\u10E0\u10E1.",
                        "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D7\u10D0 \u10D3\u10D0\u10DB\u10E3\u10E8\u10D0\u10D5\u10D4\u10D1\u10D0 - \u10D0\u10D5\u10E2\u10DD\u10DB\u10D0\u10E2\u10E3\u10E0\u10D8, \u10DC\u10D0\u10EE\u10D4\u10D5\u10E0\u10D0\u10D3 \u10D0\u10D5\u10E2\u10DD\u10DB\u10D0\u10E2\u10E3\u10E0\u10D8 \u10D0\u10DC \u10D0\u10E0\u10D0\u10D0\u10D5\u10E2\u10DD\u10DB\u10D0\u10E2\u10E3\u10E0\u10D8 \u10E1\u10D0\u10E8\u10E3\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10DB\u10DD\u10E7\u10D4\u10DC\u10D4\u10D1\u10D8\u10D7 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D7\u10D0 \u10DB\u10D8\u10DB\u10D0\u10E0\u10D7 \u10E8\u10D4\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8 \u10DC\u10D4\u10D1\u10D8\u10E1\u10DB\u10D8\u10D4\u10E0\u10D8 \u10DB\u10DD\u10E5\u10DB\u10D4\u10D3\u10D4\u10D1\u10D0.",
                        "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D7\u10D0 \u10E1\u10E3\u10D1\u10D8\u10D4\u10E5\u10E2\u10D8 (\u10E8\u10D4\u10DB\u10D3\u10D2\u10DD\u10DB\u10E8\u10D8 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8) - \u10DC\u10D4\u10D1\u10D8\u10E1\u10DB\u10D8\u10D4\u10E0\u10D8 \u10E4\u10D8\u10D6\u10D8\u10D9\u10E3\u10E0\u10D8 \u10DE\u10D8\u10E0\u10D8, \u10E0\u10DD\u10DB\u10DA\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10EE\u10D4\u10D1\u10D0\u10EA \u10DB\u10E3\u10E8\u10D0\u10D5\u10D3\u10D4\u10D1\u10D0 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8.",
                        "\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10D7\u10D0\u10DC\u10EE\u10DB\u10DD\u10D1\u10D0 - \u10EC\u10D8\u10DC\u10D0\u10DB\u10D3\u10D4\u10D1\u10D0\u10E0\u10D4 \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D8\u10E1 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10D2\u10D0\u10EA\u10DC\u10DD\u10D1\u10D8\u10E1\u10D0 \u10D3\u10D0 \u10DB\u10D8\u10E1\u10D8 \u10DE\u10D4\u10E0\u10E1\u10DD\u10DC\u10D0\u10DA\u10E3\u10E0\u10D8 \u10EE\u10D0\u10E1\u10D8\u10D0\u10D7\u10D8\u10E1 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8\u10E1 \u10D3\u10D0\u10DB\u10E3\u10E8\u10D0\u10D5\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10EE\u10D4\u10D1 \u10D2\u10D0\u10DB\u10DD\u10EE\u10D0\u10E2\u10E3\u10DA\u10D8 \u10DC\u10D4\u10D1\u10D0.",
                        "\u10DB\u10D4\u10E1\u10D0\u10DB\u10D4 \u10DE\u10D8\u10E0\u10D8 - \u10DC\u10D4\u10D1\u10D8\u10E1\u10DB\u10D8\u10D4\u10E0\u10D8 \u10E4\u10D8\u10D6\u10D8\u10D9\u10E3\u10E0\u10D8 \u10D0\u10DC \u10D8\u10E3\u10E0\u10D8\u10D3\u10D8\u10E3\u10DA\u10D8 \u10DE\u10D8\u10E0\u10D8, \u10E1\u10D0\u10EF\u10D0\u10E0\u10DD \u10D3\u10D0\u10EC\u10D4\u10E1\u10D4\u10D1\u10E3\u10DA\u10D4\u10D1\u10D0.",
                        "\u10DE\u10D8\u10E0\u10D3\u10D0\u10DE\u10D8\u10E0\u10D8 \u10DB\u10D0\u10E0\u10D9\u10D4\u10E2\u10D8\u10DC\u10D2\u10D8 - \u10E4\u10DD\u10E1\u10E2\u10D8\u10E1, \u10E1\u10D0\u10E2\u10D4\u10DA\u10D4\u10E4\u10DD\u10DC\u10DD \u10D6\u10D0\u10E0\u10D4\u10D1\u10D8\u10E1, \u10D4\u10DA\u10D4\u10E5\u10E2\u10E0\u10DD\u10DC\u10E3\u10DA\u10D8 \u10E4\u10DD\u10E1\u10E2\u10D8\u10E1 \u10D0\u10DC \u10E1\u10EE\u10D5\u10D0 \u10DC\u10D4\u10D1\u10D8\u10E1\u10DB\u10D8\u10D4\u10E0\u10D8 \u10E1\u10D0\u10E2\u10D4\u10DA\u10D4\u10D9\u10DD\u10DB\u10E3\u10DC\u10D8\u10D9\u10D0\u10EA\u10D8\u10DD \u10E1\u10D0\u10E8\u10E3\u10D0\u10DA\u10D4\u10D1\u10D8\u10D7 \u10E1\u10D0\u10E5\u10DD\u10DC\u10DA\u10D8\u10E1, \u10DB\u10DD\u10DB\u10E1\u10D0\u10EE\u10E3\u10E0\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10D7\u10D0\u10D5\u10D0\u10D6\u10D4\u10D1\u10D0."
                    ].map((text)=>({
                            text: text
                        }))
                }
            },
            {
                H5: {
                    text: "\u10D7\u10D0\u10DC\u10EE\u10DB\u10DD\u10D1\u10D0"
                },
                props: {
                    margin: "C 0 0"
                },
                Paragraphs: {
                    childExtend: (0, $b448a4a1f1311a88$export$56c0d5a1e737357d),
                    $propsCollection: [
                        '"Archy"-\u10D8\u10E1 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D8\u10D7 \u10E1\u10D0\u10E0\u10D2\u10D4\u10D1\u10DA\u10DD\u10D1\u10D0 \u10DB\u10D8\u10D8\u10E9\u10DC\u10D4\u10D5\u10D0 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10D9\u10DD\u10DC\u10E4\u10D8\u10D3\u10D4\u10DC\u10EA\u10D8\u10D0\u10DA\u10E3\u10E0\u10DD\u10D1\u10D8\u10E1 \u10DE\u10DD\u10DA\u10D8\u10E2\u10D8\u10D9\u10D8\u10E1 \u10D7\u10D0\u10DD\u10D1\u10D0\u10D6\u10D4 \u10D7\u10D0\u10DC\u10EE\u10DB\u10DD\u10D1\u10D0\u10D3. \u10E8\u10D4\u10E1\u10D0\u10D1\u10D0\u10DB\u10D8\u10E1\u10D0\u10D3, "Archy" -\u10E1 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8 \u10D0\u10DC\u10D8\u10ED\u10D4\u10D1\u10E1 \u10E3\u10E4\u10DA\u10D4\u10D1\u10D0\u10E1 \u10D3\u10D0\u10D0\u10DB\u10E3\u10E8\u10D0\u10DD\u10E1, \u10E8\u10D4\u10D8\u10DC\u10D0\u10EE\u10DD\u10E1 \u10D3\u10D0 \u10D2\u10D0\u10DB\u10DD\u10D8\u10E7\u10D4\u10DC\u10DD\u10E1 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10DB\u10D8\u10EC\u10DD\u10D3\u10D4\u10D1\u10E3\u10DA\u10D8 \u10DE\u10D4\u10E0\u10E1\u10DD\u10DC\u10D0\u10DA\u10E3\u10E0\u10D8 \u10EE\u10D0\u10E1\u10D8\u10D0\u10D7\u10D8\u10E1 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0.',
                        '\u10D0\u10E6\u10DC\u10D8\u10E8\u10DC\u10E3\u10DA\u10D8 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0 "Archy"-\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10D2\u10D0\u10DB\u10DD\u10E7\u10D4\u10DC\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D8\u10E5\u10DC\u10D4\u10D1\u10D0 \u10DB\u10DD\u10DB\u10E1\u10D0\u10EE\u10E3\u10E0\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10EC\u10D4\u10D5\u10D8\u10E1 \u10DB\u10D8\u10D6\u10DC\u10D4\u10D1\u10D8\u10D3\u10D0\u10DC \u10D2\u10D0\u10DB\u10DD\u10DB\u10D3\u10D8\u10DC\u10D0\u10E0\u10D4 \u10DB\u10DD\u10E5\u10DB\u10D4\u10D3\u10D8 \u10D9\u10D0\u10DC\u10DD\u10DC\u10DB\u10D3\u10D4\u10D1\u10DA\u10DD\u10D1\u10D8\u10E1 \u10D2\u10D0\u10D7\u10D5\u10D0\u10DA\u10D8\u10E1\u10EC\u10D8\u10DC\u10D4\u10D1\u10D8\u10D7.'
                    ].map((text)=>({
                            text: text
                        }))
                }
            },
            {
                props: {
                    margin: "C 0 0"
                },
                H5: {
                    text: "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D7\u10D0 \u10D3\u10D0\u10DB\u10E3\u10E8\u10D0\u10D5\u10D4\u10D1\u10D8\u10E1 \u10E1\u10D0\u10E4\u10E3\u10EB\u10D5\u10DA\u10D4\u10D1\u10D8"
                },
                P: {
                    text: '"Archy"  \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DE\u10D4\u10E0\u10E1\u10DD\u10DC\u10D0\u10DA\u10E3\u10E0 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10E1 \u10D3\u10D0\u10D0\u10DB\u10E3\u10E8\u10D0\u10D5\u10D4\u10D1\u10E1, \u10D7\u10E3:'
                },
                Ul: {
                    props: {},
                    $propsCollection: [
                        "\u10D0\u10E0\u10E1\u10D4\u10D1\u10DD\u10D1\u10E1 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10D7\u10D0\u10DC\u10EE\u10DB\u10DD\u10D1\u10D0.",
                        '\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D7\u10D0 \u10D3\u10D0\u10DB\u10E3\u10E8\u10D0\u10D5\u10D4\u10D1\u10D0 \u10E1\u10D0\u10ED\u10D8\u10E0\u10DD\u10D0 "Archy"-\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0, \u10DB\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1 \u10D9\u10D0\u10DC\u10DD\u10DC\u10DB\u10D3\u10D4\u10D1\u10DA\u10DD\u10D1\u10D8\u10D7 \u10D3\u10D0\u10D9\u10D8\u10E1\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8 \u10DB\u10DD\u10D5\u10D0\u10DA\u10D4\u10DD\u10D1\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10DA\u10D0\u10D3.',
                        "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D7\u10D0 \u10D3\u10D0\u10DB\u10E3\u10E8\u10D0\u10D5\u10D4\u10D1\u10D0 \u10D0\u10E3\u10EA\u10D8\u10DA\u10D4\u10D1\u10D4\u10DA\u10D8\u10D0 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1\u10D0\u10D7\u10D5\u10D8\u10E1 \u10DB\u10DD\u10DB\u10E1\u10D0\u10EE\u10E3\u10E0\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10E1\u10D0\u10EC\u10D4\u10D5\u10D0\u10D3."
                    ].map((text)=>({
                            text: text
                        }))
                }
            },
            {
                props: {
                    margin: "C 0 0"
                },
                H5: {
                    text: "\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DE\u10D4\u10E0\u10E1\u10DD\u10DC\u10D0\u10DA\u10E3\u10E0\u10D8 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8\u10E1 \u10D3\u10D0\u10DB\u10E3\u10E8\u10D0\u10D5\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D8\u10D6\u10D0\u10DC\u10D8"
                },
                Ul: {
                    props: {},
                    $propsCollection: [
                        '"Archy"-\u10D8\u10E1 \u10DB\u10DD\u10DB\u10E1\u10D0\u10EE\u10E3\u10E0\u10D4\u10D1\u10D8\u10E1 \u10EE\u10D0\u10E0\u10D8\u10E1\u10EE\u10D8\u10E1 \u10D2\u10D0\u10E3\u10DB\u10EF\u10DD\u10D1\u10D4\u10E1\u10D4\u10D1\u10D0;',
                        '"Archy"-\u10D8\u10E1 \u10D9\u10D0\u10DC\u10DD\u10DC\u10D8\u10E1\u10DB\u10D8\u10D4\u10E0\u10D8 \u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8\u10E1 \u10EF\u10D4\u10E0\u10DD\u10D5\u10DC\u10D0\u10D3 \u10E8\u10D4\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10D0;',
                        "\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10EC\u10D0\u10E7\u10D4\u10DC\u10D4\u10D1\u10E3\u10DA\u10D8 \u10DE\u10E0\u10D4\u10E2\u10D4\u10DC\u10D6\u10D8\u10D4\u10D1\u10D8\u10E1 \u10D0\u10E6\u10DB\u10DD\u10E4\u10EE\u10D5\u10E0\u10D0;",
                        "\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4 \u10D2\u10D0\u10DB\u10DD\u10D5\u10DA\u10D4\u10DC\u10D8\u10DA\u10D8 \u10D0\u10E5\u10E2\u10D8\u10D5\u10DD\u10D1\u10D4\u10D1\u10D8\u10E1 \u10DB\u10DD\u10DC\u10D8\u10E2\u10DD\u10E0\u10D8\u10DC\u10D2\u10D8;",
                        '"Archy" -\u10D6\u10D4 \u10D2\u10D0\u10DC\u10D0\u10EE\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8\u10E1 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D4\u10D1\u10D8\u10E1\u10D0\u10D7\u10D5\u10D8\u10E1 \u10E8\u10D4\u10E2\u10E7\u10DD\u10D1\u10D8\u10DC\u10D4\u10D1\u10D0;',
                        "\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D7\u10D0\u10DC \u10D4\u10E4\u10D4\u10E5\u10E2\u10E3\u10E0\u10D8 \u10D9\u10DD\u10DB\u10E3\u10DC\u10D8\u10D9\u10D0\u10EA\u10D8\u10D0;",
                        "\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10E3\u10D9\u10E3\u10D9\u10D0\u10D5\u10E8\u10D8\u10E0\u10D8\u10E1 \u10D3\u10D0\u10DB\u10E7\u10D0\u10E0\u10D4\u10D1\u10D0;",
                        '"Archy"-\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10D3\u10D0\u10DC\u10D4\u10E0\u10D2\u10D8\u10DA\u10D8 \u10E1\u10D8\u10D0\u10EE\u10DA\u10D4\u10D4\u10D1\u10D8\u10E1 \u10D3\u10D0\u10E2\u10D4\u10E1\u10E2\u10D5\u10D0;',
                        "\u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4 \u10D0\u10EE\u10D0\u10DA\u10D8 \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D4\u10D1\u10D8\u10E1\u10D0 \u10D3\u10D0 \u10E1\u10D8\u10D0\u10EE\u10DA\u10D4\u10D4\u10D1\u10D8\u10E1 \u10D3\u10D0\u10DC\u10D4\u10E0\u10D2\u10D5\u10D0;",
                        "\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D8\u10DB \u10EF\u10D2\u10E3\u10E4\u10D7\u10D0 \u10D2\u10D0\u10DC\u10E1\u10D0\u10D6\u10E6\u10D5\u10E0\u10D0, \u10E0\u10DD\u10DB\u10D4\u10DA\u10D7\u10D0\u10D7\u10D5\u10D8\u10E1 \u10E3\u10DC\u10D3\u10D0 \u10D2\u10D0\u10DC\u10EE\u10DD\u10E0\u10EA\u10D8\u10D4\u10DA\u10D3\u10D4\u10E1 \u10E1\u10D8\u10D0\u10EE\u10DA\u10D4\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10D7\u10D0\u10D5\u10D0\u10D6\u10D4\u10D1\u10D0;",
                        "\u10DB\u10D0\u10E0\u10D9\u10D4\u10E2\u10D8\u10DC\u10D2\u10E3\u10DA\u10D8 \u10D3\u10D0 \u10E1\u10EE\u10D5\u10D0 \u10E1\u10D0\u10EE\u10D8\u10E1 \u10D0\u10E5\u10E2\u10D8\u10D5\u10DD\u10D1\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10DC\u10EE\u10DD\u10E0\u10EA\u10D8\u10D4\u10DA\u10D4\u10D1\u10D0;",
                        "\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10D2\u10D0\u10DC\u10EE\u10DD\u10E0\u10EA\u10D8\u10D4\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8 \u10E8\u10D4\u10E1\u10E7\u10D8\u10D3\u10D5\u10D4\u10D1\u10D8\u10E1 \u10D7\u10D0\u10DD\u10D1\u10D0\u10D6\u10D4 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D8\u10E1 \u10DB\u10D8\u10EC\u10DD\u10D3\u10D4\u10D1\u10D0;",
                        "\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10E4\u10E3\u10DA\u10D0\u10D3\u10D8 \u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D7\u10D0\u10DD\u10D1\u10D0\u10D6\u10D4 \u10E3\u10E4\u10DA\u10D4\u10D1\u10D0\u10DB\u10DD\u10E1\u10D8\u10DA\u10D8 \u10DB\u10D4\u10E1\u10D0\u10DB\u10D4 \u10DE\u10D8\u10E0\u10D8\u10E1\u10D2\u10D0\u10DC \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D8\u10E1 \u10DB\u10D8\u10E6\u10D4\u10D1\u10D0;",
                        '"Archy"-\u10D8\u10E1 \u10E1\u10D8\u10E1\u10E2\u10D4\u10DB\u10D8\u10E1 \u10D0\u10E0\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10D6\u10DD\u10DB\u10D8\u10D4\u10E0\u10D8 \u10D2\u10D0\u10DB\u10DD\u10E7\u10D4\u10DC\u10D4\u10D1\u10D8\u10E1 \u10DE\u10E0\u10D4\u10D5\u10D4\u10DC\u10EA\u10D8\u10D0;',
                        "\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD\u10E1 \u10E1\u10D8\u10E1\u10EE\u10DA\u10D8\u10E1 \u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10D8\u10E1 \u10D9\u10DD\u10D3\u10D4\u10E5\u10E1\u10D8\u10D7 \u10D2\u10D0\u10D7\u10D5\u10D0\u10DA\u10D8\u10E1\u10EC\u10D8\u10DC\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D3\u10D0\u10DC\u10D0\u10E8\u10D0\u10E3\u10DA\u10D8\u10E1 \u10DE\u10E0\u10D4\u10D5\u10D4\u10DC\u10EA\u10D8\u10D0;",
                        "\u10E1\u10D0\u10EE\u10D4\u10DA\u10DB\u10EC\u10D8\u10E4\u10DD \u10D9\u10DD\u10DB\u10DE\u10D4\u10E2\u10D4\u10DC\u10E2\u10E3\u10E0\u10D8 \u10DD\u10E0\u10D2\u10D0\u10DC\u10DD\u10D4\u10D1\u10D8\u10E1\u10D0\u10D7\u10D5\u10D8\u10E1 \u10DB\u10D8\u10EC\u10DD\u10D3\u10D4\u10D1\u10D0;",
                        "\u10D9\u10D0\u10DC\u10DD\u10DC\u10D8\u10D4\u10E0\u10D8 \u10D8\u10DC\u10E2\u10D4\u10E0\u10D4\u10E1\u10D4\u10D1\u10D8\u10E1 \u10D3\u10D0\u10EA\u10D5\u10D0;",
                        '"Archy"-\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1 \u10DE\u10D4\u10E0\u10E1\u10DD\u10DC\u10D0\u10DA\u10E3\u10E0 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D7\u10D0 \u10D3\u10D0\u10EA\u10D5\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10EE\u10D4\u10D1 \u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD\u10E1 \u10D9\u10D0\u10DC\u10DD\u10DC\u10D8\u10D7 \u10DB\u10D8\u10DC\u10D8\u10ED\u10D4\u10D1\u10E3\u10DA\u10D8 \u10E1\u10EE\u10D5\u10D0 \u10DA\u10D4\u10D2\u10D8\u10E2\u10D8\u10DB\u10E3\u10E0\u10D8 \u10DB\u10D8\u10D6\u10D0\u10DC\u10D8.'
                    ].map((text)=>({
                            text: text
                        }))
                }
            },
            {
                props: {
                    margin: "C 0 0"
                },
                H5: {
                    text: "\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10E3\u10E4\u10DA\u10D4\u10D1\u10D0\u10DB\u10DD\u10E1\u10D8\u10DA\u10D4\u10D1\u10D0"
                },
                P: {
                    text: '\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10E1 \u10E3\u10E4\u10DA\u10D4\u10D1\u10D0 \u10D0\u10E5\u10D5\u10E1 "Archy" -\u10E1 \u10DB\u10DD\u10E1\u10D7\u10EE\u10DD\u10D5\u10DD\u10E1 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D7\u10D0 \u10D3\u10D0\u10DB\u10E3\u10E8\u10D0\u10D5\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10EE\u10D4\u10D1 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0:'
                },
                Ul: {
                    props: {},
                    $propsCollection: [
                        '\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10EE\u10D4\u10D1 \u10E0\u10DD\u10DB\u10D4\u10DA\u10D8 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10DB\u10E3\u10E8\u10D0\u10D5\u10D3\u10D4\u10D1\u10D0 "Archy"-\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0;',
                        "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D7\u10D0 \u10D3\u10D0\u10DB\u10E3\u10E8\u10D0\u10D5\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D8\u10D6\u10D0\u10DC\u10D8;",
                        "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D7\u10D0 \u10D3\u10D0\u10DB\u10E3\u10E8\u10D0\u10D5\u10D4\u10D1\u10D8\u10E1 \u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10D4\u10D1\u10E0\u10D8\u10D5\u10D8 \u10E1\u10D0\u10E4\u10E3\u10EB\u10D5\u10D4\u10DA\u10D8;",
                        "\u10E0\u10D0 \u10D2\u10D6\u10D8\u10D7 \u10E8\u10D4\u10D2\u10E0\u10DD\u10D5\u10D3\u10D0 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8;",
                        "\u10D5\u10D8\u10E1\u10D6\u10D4 \u10D2\u10D0\u10D8\u10EA\u10D0 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10EE\u10D4\u10D1 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8, \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D7\u10D0 \u10D2\u10D0\u10EA\u10D4\u10DB\u10D8\u10E1 \u10E1\u10D0\u10E4\u10E3\u10EB\u10D5\u10D4\u10DA\u10D8 \u10D3\u10D0 \u10DB\u10D8\u10D6\u10D0\u10DC\u10D8;"
                    ].map((text)=>({
                            text: text
                        }))
                },
                Paragraphs: {
                    childExtend: (0, $b448a4a1f1311a88$export$56c0d5a1e737357d),
                    $propsCollection: [
                        '\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10DB\u10DD\u10D7\u10EE\u10DD\u10D5\u10DC\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D0\u10E8\u10D8 "Archy"  \u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0 \u10D2\u10D0\u10D0\u10E1\u10EC\u10DD\u10E0\u10DD\u10E1, \u10D2\u10D0\u10DC\u10D0\u10D0\u10EE\u10DA\u10DD\u10E1, \u10D3\u10D0\u10D0\u10DB\u10D0\u10E2\u10DD\u10E1, \u10D3\u10D0\u10D1\u10DA\u10DD\u10D9\u10DD\u10E1, \u10EC\u10D0\u10E8\u10D0\u10DA\u10DD\u10E1 \u10D0\u10DC \u10D2\u10D0\u10D0\u10DC\u10D0\u10D3\u10D2\u10E3\u10E0\u10DD\u10E1 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8, \u10D7\u10E3 \u10D8\u10E1\u10D8\u10DC\u10D8 \u10D0\u10E0\u10D0\u10E1\u10E0\u10E3\u10DA\u10D8\u10D0, \u10D0\u10E0\u10D0\u10D6\u10E3\u10E1\u10E2\u10D8\u10D0, \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1 \u10D2\u10D0\u10DC\u10D0\u10EE\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D0\u10DC \u10D7\u10E3 \u10DB\u10D0\u10D7\u10D8 \u10E8\u10D4\u10D2\u10E0\u10DD\u10D5\u10D4\u10D1\u10D0 \u10D3\u10D0 \u10D3\u10D0\u10DB\u10E3\u10E8\u10D0\u10D5\u10D4\u10D1\u10D0 \u10D2\u10D0\u10DC\u10EE\u10DD\u10E0\u10EA\u10D8\u10D4\u10DA\u10D3\u10D0 \u10D9\u10D0\u10DC\u10DD\u10DC\u10D8\u10E1 \u10DB\u10DD\u10D7\u10EE\u10DD\u10D5\u10DC\u10D0\u10D7\u10D0 \u10D3\u10D0\u10E0\u10E6\u10D5\u10D4\u10D5\u10D8\u10D7.',
                        "\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8 \u10E3\u10E4\u10DA\u10D4\u10D1\u10D0\u10DB\u10DD\u10E1\u10D8\u10DA\u10D8\u10D0 \u10DE\u10D4\u10E0\u10E1\u10DD\u10DC\u10D0\u10DA\u10E3\u10E0 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D7\u10D0 \u10D3\u10D0\u10EA\u10D5\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10EE\u10D4\u10D1 \u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD\u10E1 \u10D9\u10D0\u10DC\u10DD\u10DC\u10D8\u10D7 \u10D2\u10D0\u10D7\u10D5\u10D0\u10DA\u10D8\u10E1\u10EC\u10D8\u10DC\u10D4\u10D1\u10E3\u10DA\u10D8 \u10E3\u10E4\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8\u10E1 \u10D3\u10D0\u10E0\u10E6\u10D5\u10D4\u10D5\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D0\u10E8\u10D8 \u10DB\u10D8\u10DB\u10D0\u10E0\u10D7\u10DD\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10DB\u10EC\u10D8\u10E4\u10DD \u10D8\u10DC\u10E1\u10DE\u10D4\u10E5\u10E2\u10DD\u10E0\u10D8\u10E1 \u10E1\u10D0\u10DB\u10E1\u10D0\u10EE\u10E3\u10E0\u10E1 \u10D0\u10DC \u10E1\u10D0\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10DA\u10DD\u10E1.",
                        '\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10E1 \u10E3\u10E4\u10DA\u10D4\u10D1\u10D0 \u10D0\u10E5\u10D5\u10E1, \u10DC\u10D4\u10D1\u10D8\u10E1\u10DB\u10D8\u10D4\u10E0 \u10D3\u10E0\u10DD\u10E1 \u10D2\u10D0\u10DC\u10D0\u10EA\u10EE\u10D0\u10D3\u10DD\u10E1 \u10E3\u10D0\u10E0\u10D8 \u10DB\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 "Archy"-\u10D8\u10E1\u10D0\u10D7\u10D5\u10D8\u10E1 \u10DB\u10D8\u10EA\u10D4\u10DB\u10E3\u10DA \u10D7\u10D0\u10DC\u10EE\u10DB\u10DD\u10D1\u10D0\u10D6\u10D4 \u10D3\u10D0 \u10DB\u10DD\u10D8\u10D7\u10EE\u10DD\u10D5\u10DD\u10E1 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D7\u10D0 \u10D3\u10D0\u10DB\u10E3\u10E8\u10D0\u10D5\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10EC\u10E7\u10D5\u10D4\u10E2\u10D0 \u10D0\u10DC/\u10D3\u10D0 \u10D3\u10D0\u10DB\u10E3\u10E8\u10D0\u10D5\u10D4\u10D1\u10E3\u10DA\u10D8 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10DC\u10D0\u10D3\u10D2\u10E3\u10E0\u10D4\u10D1\u10D0.'
                    ].map((text)=>({
                            text: text
                        }))
                }
            },
            {
                H5: {
                    text: "\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10D4\u10D1\u10D0"
                },
                props: {
                    margin: "C 0 0"
                },
                Paragraphs: {
                    childExtend: (0, $b448a4a1f1311a88$export$56c0d5a1e737357d),
                    $propsCollection: [
                        '\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8 \u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0 "Archy" -\u10E1 \u10DB\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10EE\u10D4\u10D1 \u10DB\u10D8\u10D0\u10EC\u10DD\u10D3\u10DD\u10E1 \u10E1\u10E0\u10E3\u10DA\u10E7\u10DD\u10E4\u10D8\u10DA\u10D8 \u10D3\u10D0 \u10E1\u10EC\u10DD\u10E0\u10D8 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0 \u10E8\u10D4\u10DB\u10D3\u10D2\u10DD\u10DB\u10E8\u10D8 \u10DB\u10DD\u10DB\u10E1\u10D0\u10EE\u10E3\u10E0\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D8\u10E6\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D8\u10D6\u10DC\u10D8\u10D7. \u10D0\u10E6\u10DC\u10D8\u10E8\u10DC\u10E3\u10DA\u10D8 \u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10D4\u10D1\u10D0 \u10D0\u10E1\u10D4\u10D5\u10D4 \u10D5\u10E0\u10EA\u10D4\u10DA\u10D3\u10D4\u10D1\u10D0 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10DB\u10D8\u10EC\u10DD\u10D3\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D8\u10E1 \u10EA\u10D5\u10DA\u10D8\u10DA\u10D4\u10D1\u10D4\u10D1\u10D6\u10D4.'
                    ].map((text)=>({
                            text: text
                        }))
                }
            },
            {
                H5: {
                    text: '"Archy"-\u10D8\u10E1 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D8\u10E1 \u10D2\u10D0\u10DB\u10DD\u10E7\u10D4\u10DC\u10D4\u10D1\u10D8\u10E1 \u10DE\u10D8\u10E0\u10DD\u10D1\u10D4\u10D1\u10D8'
                },
                props: {
                    margin: "C 0 0"
                },
                Paragraphs: {
                    childExtend: (0, $b448a4a1f1311a88$export$56c0d5a1e737357d),
                    $propsCollection: [
                        '\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 "Archy"-\u10D8\u10E1 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D8\u10E1 \u10D2\u10D0\u10DB\u10DD\u10E7\u10D4\u10DC\u10D4\u10D1\u10D8\u10D7 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8 \u10D0\u10EA\u10EE\u10D0\u10D3\u10D4\u10D1\u10E1 \u10D7\u10D0\u10DC\u10EE\u10DB\u10DD\u10D1\u10D0\u10E1 "Archy"-\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10DB\u10D8\u10E1\u10D8 \u10DE\u10D4\u10E0\u10E1\u10DD\u10DC\u10D0\u10DA\u10E3\u10E0\u10D8 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8\u10E1\u10D0 \u10D3\u10D0 \u10DB\u10D6\u10D0 \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D4\u10D1\u10D8\u10E1 (Cookies) \u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D0\u10E1\u10D0 \u10D3\u10D0 \u10D3\u10D0\u10DB\u10E3\u10E8\u10D0\u10D5\u10D4\u10D1\u10D0\u10D6\u10D4.',
                        '\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8 \u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0 "Archy" -\u10E1 \u10DB\u10D8\u10D0\u10EC\u10DD\u10D3\u10DD\u10E1 \u10E1\u10E0\u10E3\u10DA\u10D8 \u10D3\u10D0 \u10E1\u10EC\u10DD\u10E0\u10D8 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0, \u10EA\u10D5\u10DA\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D0\u10E8\u10D8 \u10D2\u10D0\u10DC\u10D0\u10D0\u10EE\u10DA\u10DD\u10E1 \u10DB\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10DB\u10D8\u10EC\u10DD\u10D3\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0'
                    ].map((text)=>({
                            text: text
                        }))
                }
            },
            {
                H5: {
                    text: "\u10D5\u10D8\u10E1 \u10D5\u10E3\u10D6\u10D8\u10D0\u10E0\u10D4\u10D1\u10D7 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10E1"
                },
                props: {
                    margin: "C 0 0"
                },
                Paragraphs: {
                    childExtend: (0, $b448a4a1f1311a88$export$56c0d5a1e737357d),
                    $propsCollection: [
                        "\u10DE\u10D4\u10E0\u10E1\u10DD\u10DC\u10D0\u10DA\u10E3\u10E0\u10D8 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10D6\u10D8\u10D0\u10E0\u10D4\u10D1\u10D0 \u10EE\u10DD\u10E0\u10EA\u10D8\u10D4\u10DA\u10D3\u10D4\u10D1\u10D0 \u10DE\u10D0\u10E0\u10E2\u10DC\u10D8\u10DD\u10E0\u10D8 \u10E1\u10D0\u10D9\u10E3\u10E0\u10D8\u10D4\u10E0\u10DD \u10DB\u10DD\u10DB\u10E1\u10D0\u10EE\u10E3\u10E0\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10DB\u10EC\u10D4\u10D5\u10D8 \u10D9\u10DD\u10DB\u10DE\u10D0\u10DC\u10D8\u10D4\u10D1\u10D8\u10E1\u10D0\u10D7\u10D5\u10D8\u10E1, \u10E0\u10DD\u10DB\u10DA\u10D4\u10D1\u10D8\u10EA \u10E3\u10D6\u10E0\u10E3\u10DC\u10D5\u10D4\u10DA\u10E7\u10DD\u10E4\u10D4\u10DC \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1\u10D0\u10D7\u10D5\u10D8\u10E1 \u10E8\u10D4\u10EB\u10D4\u10DC\u10D8\u10DA\u10D8 \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10EA\u10D8\u10D8\u10E1 \u10DB\u10D8\u10EC\u10DD\u10D3\u10D4\u10D1\u10D0\u10E1 \u10DB\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10DB\u10D8\u10D7\u10D8\u10D7\u10D4\u10D1\u10E3\u10DA \u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D6\u10D4. \u10E1\u10D0\u10D9\u10E3\u10E0\u10D8\u10D4\u10E0\u10DD \u10DB\u10DD\u10DB\u10E1\u10D0\u10EE\u10E3\u10E0\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10DB\u10EC\u10D4\u10D5 \u10DE\u10D0\u10E0\u10E2\u10DC\u10D8\u10DD\u10E0 \u10D9\u10DD\u10DB\u10DE\u10D0\u10DC\u10D8\u10D4\u10D1\u10E1 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10EE\u10D4\u10D1 \u10D2\u10D0\u10D3\u10D0\u10D4\u10EA\u10D4\u10DB\u10D0 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8 \u10E1\u10D0\u10EE\u10D8\u10E1 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0: \u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D8\u10E1 \u10D3\u10D4\u10E2\u10D0\u10DA\u10D4\u10D1\u10D8, \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8, \u10D2\u10D5\u10D0\u10E0\u10D8, \u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D8 \u10D3\u10D0 \u10E1\u10D0\u10D9\u10DD\u10DC\u10E2\u10D0\u10E5\u10E2\u10DD \u10DC\u10DD\u10DB\u10D4\u10E0\u10D8. \u10DE\u10D0\u10E0\u10E2\u10DC\u10D8\u10DD\u10E0\u10D8 \u10E1\u10D0\u10D9\u10E3\u10E0\u10D8\u10D4\u10E0\u10DD \u10D9\u10DD\u10DB\u10DE\u10D0\u10DC\u10D8\u10D4\u10D1\u10D8\u10E1\u10D0\u10D7\u10D5\u10D8\u10E1 \u10DB\u10D8\u10EC\u10DD\u10D3\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0 \u10D2\u10D0\u10DB\u10DD\u10E7\u10D4\u10DC\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D8\u10E5\u10DC\u10D4\u10D1\u10D0 \u10DB\u10EE\u10DD\u10DA\u10DD\u10D3 \u10E8\u10D4\u10EB\u10D4\u10DC\u10D8\u10DA\u10D8 \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10EA\u10D8\u10D8\u10E1 \u10DB\u10D8\u10EC\u10DD\u10D3\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D8\u10D6\u10DC\u10D8\u10D7.",
                        "\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DE\u10D4\u10E0\u10E1\u10DD\u10DC\u10D0\u10DA\u10E3\u10E0\u10D8 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10D6\u10D8\u10D0\u10E0\u10D4\u10D1\u10D0 \u10E8\u10D4\u10E1\u10D0\u10EB\u10DA\u10D4\u10D1\u10D4\u10DA\u10D8\u10D0 \u10E1\u10D0\u10ED\u10D8\u10E0\u10DD \u10D2\u10D0\u10EE\u10D3\u10D4\u10E1 \u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD\u10E1 \u10DB\u10DD\u10E5\u10DB\u10D4\u10D3\u10D8 \u10D9\u10D0\u10DC\u10DD\u10DC\u10DB\u10D3\u10D4\u10D1\u10DA\u10DD\u10D1\u10D8\u10D7 \u10D2\u10D0\u10D7\u10D5\u10D0\u10DA\u10D8\u10E1\u10EC\u10D8\u10DC\u10D4\u10D1\u10E3\u10DA \u10E8\u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D4\u10D1\u10E8\u10D8, \u10D3\u10D0\u10DC\u10D0\u10E8\u10D0\u10E3\u10DA\u10D8\u10E1 \u10D3\u10D0\u10D3\u10D2\u10D4\u10DC\u10D8\u10E1, \u10D2\u10D0\u10DB\u10DD\u10EB\u10D8\u10D4\u10D1\u10D8\u10E1 \u10D0\u10DC \u10D3\u10D0\u10DC\u10D0\u10E8\u10D0\u10E3\u10DA\u10D8\u10E1 \u10D0\u10E6\u10D9\u10D5\u10D4\u10D7\u10D8\u10E1 \u10DB\u10D8\u10D6\u10DC\u10D8\u10D7.",
                        '\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10D8\u10DC\u10E2\u10D4\u10E0\u10D4\u10E1\u10D4\u10D1\u10D8\u10D3\u10D0\u10DC \u10D2\u10D0\u10DB\u10DD\u10DB\u10D3\u10D8\u10DC\u10D0\u10E0\u10D4, \u10DE\u10D8\u10E0\u10D3\u10D0\u10DE\u10D8\u10E0\u10D8 \u10DB\u10D0\u10E0\u10D9\u10D4\u10E2\u10D8\u10DC\u10D2\u10D8\u10E1 \u10D2\u10D6\u10D8\u10D7, \u10E1\u10D0\u10E0\u10D4\u10D9\u10DA\u10D0\u10DB\u10DD \u10DB\u10D0\u10E1\u10D0\u10DA\u10D4\u10D1\u10D8\u10E1 \u10DB\u10DD\u10EC\u10DD\u10D3\u10D4\u10D1\u10D8\u10E1, \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1\u10D0\u10D7\u10D5\u10D8\u10E1 \u10E1\u10D0\u10D8\u10DC\u10E2\u10D4\u10E0\u10D4\u10E1\u10DD \u10DB\u10DD\u10DB\u10E1\u10D0\u10EE\u10E3\u10E0\u10D4\u10D1\u10D8\u10E1, \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10EA\u10D8\u10D8\u10E1, \u10E1\u10D4\u10E0\u10D5\u10D8\u10E1\u10D4\u10D1\u10D8\u10E1\u10D0 \u10D3\u10D0 \u10DB\u10DD\u10DB\u10E1\u10D0\u10EE\u10E3\u10E0\u10D4\u10D1\u10D8\u10E1 \u10EE\u10D0\u10E0\u10D8\u10E1\u10EE\u10D8\u10E1 \u10D2\u10D0\u10E3\u10DB\u10EF\u10DD\u10D1\u10D4\u10E1\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D8\u10D6\u10DC\u10D8\u10D7 "Archy" -\u10E1 \u10E8\u10D4\u10E3\u10EB\u10DA\u10D8\u10D0 \u10D8\u10E1\u10D0\u10E0\u10D2\u10D4\u10D1\u10DA\u10DD\u10E1 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DE\u10D4\u10E0\u10E1\u10DD\u10DC\u10D0\u10DA\u10E3\u10E0\u10D8 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D8\u10D7, \u10D9\u10D4\u10E0\u10EB\u10DD\u10D3, \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8\u10D7 \u10D3\u10D0 \u10D4\u10DA. \u10E4\u10DD\u10E1\u10E2\u10D8\u10E1 \u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D8\u10D7/\u10E2\u10D4\u10DA\u10D4\u10E4\u10DD\u10DC\u10D8\u10E1 \u10DC\u10DD\u10DB\u10E0\u10D8\u10D7. \u10DE\u10D8\u10E0\u10D3\u10D0\u10DE\u10D8\u10E0\u10D8 \u10DB\u10D0\u10E0\u10D9\u10D4\u10E2\u10D8\u10DC\u10D2\u10D8\u10E1 \u10D2\u10D0\u10DC\u10E1\u10D0\u10EE\u10DD\u10E0\u10EA\u10D8\u10D4\u10DA\u10D4\u10D1\u10DA\u10D0\u10D3 "Archy"  \u10D8\u10E2\u10DD\u10D5\u10D4\u10D1\u10E1 \u10E3\u10E4\u10DA\u10D4\u10D1\u10D0\u10E1, \u10EE\u10E1\u10D4\u10DC\u10D4\u10D1\u10E3\u10DA\u10D8 \u10DE\u10D4\u10E0\u10E1\u10DD\u10DC\u10D0\u10DA\u10E3\u10E0\u10D8 \u10EE\u10D0\u10E1\u10D8\u10D0\u10D7\u10D8\u10E1 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0 \u10D2\u10D0\u10D3\u10D0\u10E1\u10EA\u10D4\u10E1 \u10DB\u10D4\u10E1\u10D0\u10DB\u10D4 \u10DE\u10D8\u10E0\u10D4\u10D1\u10E1, \u10E0\u10DD\u10DB\u10DA\u10D4\u10D1\u10D8\u10EA \u10E1\u10D0\u10EE\u10D4\u10DA\u10E8\u10D4\u10D9\u10E0\u10E3\u10DA\u10D4\u10D1\u10DD \u10E3\u10E0\u10D7\u10D8\u10D4\u10E0\u10D7\u10DD\u10D1\u10D8\u10D3\u10D0\u10DC \u10D2\u10D0\u10DB\u10DD\u10DB\u10D3\u10D8\u10DC\u10D0\u10E0\u10D4 \u10D2\u10D0\u10E3\u10EC\u10D4\u10D5\u10D4\u10DC "Archy" -\u10E1 \u10E1\u10D0\u10E0\u10D4\u10D9\u10DA\u10D0\u10DB\u10DD \u10DB\u10DD\u10DB\u10E1\u10D0\u10EE\u10E3\u10E0\u10D4\u10D1\u10D0\u10E1.',
                        '"Archy"  \u10E3\u10E4\u10DA\u10D4\u10D1\u10D0\u10DB\u10DD\u10E1\u10D8\u10DA\u10D8\u10D0 \u10DE\u10D4\u10E0\u10E1\u10DD\u10DC\u10D0\u10DA\u10E3\u10E0\u10D8 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0 \u10D2\u10D0\u10E3\u10D6\u10D8\u10D0\u10E0\u10DD\u10E1 \u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD\u10E1 \u10DB\u10DD\u10E5\u10DB\u10D4\u10D3\u10D8 \u10D9\u10D0\u10DC\u10DD\u10DC\u10DB\u10D3\u10D4\u10D1\u10DA\u10DD\u10D1\u10D8\u10D7 \u10D2\u10D0\u10D7\u10D5\u10D0\u10DA\u10D8\u10E1\u10EC\u10D8\u10DC\u10D4\u10D1\u10E3\u10DA \u10E8\u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D4\u10D1\u10E8\u10D8, \u10D2\u10D0\u10E0\u10D3\u10D0 \u10D6\u10D4\u10DB\u10DD\u10D0\u10E6\u10DC\u10D8\u10E8\u10DC\u10E3\u10DA\u10D8\u10E1\u10D0, \u10DC\u10D4\u10D1\u10D8\u10E1\u10DB\u10D8\u10D4\u10E0 \u10DB\u10D4\u10E1\u10D0\u10DB\u10D4 \u10DE\u10D8\u10E0\u10E1.'
                    ].map((text)=>({
                            text: text
                        }))
                }
            },
            {
                H5: {
                    text: "\u10DE\u10D8\u10E0\u10D3\u10D0\u10DE\u10D8\u10E0\u10D8 \u10DB\u10D0\u10E0\u10D9\u10D4\u10E2\u10D8\u10DC\u10D2\u10D8\u10E1 \u10E8\u10D4\u10EC\u10E7\u10D5\u10D4\u10E2\u10D8\u10E1 \u10DB\u10DD\u10D7\u10EE\u10DD\u10D5\u10DC\u10D0"
                },
                props: {
                    margin: "C 0 0"
                },
                Paragraphs: {
                    childExtend: (0, $b448a4a1f1311a88$export$56c0d5a1e737357d),
                    $propsCollection: [
                        '\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10E1 \u10DC\u10D4\u10D1\u10D8\u10E1\u10DB\u10D8\u10D4\u10E0 \u10D3\u10E0\u10DD\u10E1 \u10D0\u10E5\u10D5\u10E1 \u10E8\u10D4\u10E1\u10D0\u10EB\u10DA\u10D4\u10D1\u10DA\u10DD\u10D1\u10D0 "Archy" -\u10E1 \u10DB\u10DD\u10E1\u10D7\u10EE\u10DD\u10D5\u10DD\u10E1 \u10DE\u10D8\u10E0\u10D3\u10D0\u10DE\u10D8\u10E0\u10D8 \u10DB\u10D0\u10E0\u10D9\u10D4\u10E2\u10D8\u10DC\u10D2\u10D8\u10E1 \u10E8\u10D4\u10EC\u10E7\u10D5\u10D4\u10E2\u10D0. \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10DE\u10D8\u10E0\u10D3\u10D0\u10DE\u10D8\u10E0\u10D8 \u10DB\u10D0\u10E0\u10D9\u10D4\u10E2\u10D8\u10DC\u10D2\u10D8\u10E1 \u10E8\u10D4\u10EC\u10E7\u10D5\u10D4\u10E2\u10D8\u10E1 \u10D7\u10D0\u10DD\u10D1\u10D0\u10D6\u10D4 \u10DB\u10DD\u10D7\u10EE\u10DD\u10D5\u10DC\u10D0 \u10D0\u10E0 \u10D0\u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10D4\u10D1\u10E1 "Archy" -\u10E1 \u10E8\u10D4\u10EC\u10E7\u10D5\u10D8\u10E2\u10DD\u10E1 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D8\u10E1 \u10DB\u10D8\u10EC\u10DD\u10D3\u10D4\u10D1\u10D0 \u10D2\u10D0\u10DC\u10D0\u10EE\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8\u10E1\u10D0 \u10D3\u10D0 \u10EA\u10D5\u10DA\u10D8\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10EE\u10D4\u10D1.',
                        '\u10DE\u10D8\u10E0\u10D3\u10D0\u10DE\u10D8\u10E0\u10D8 \u10DB\u10D0\u10E0\u10D9\u10D4\u10E2\u10D8\u10DC\u10D2\u10D8\u10E1 \u10E8\u10D4\u10EC\u10E7\u10D5\u10D4\u10E2\u10D8\u10E1 \u10E1\u10E3\u10E0\u10D5\u10D8\u10DA\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D0\u10E8\u10D8 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10E1 \u10E8\u10D4\u10E3\u10EB\u10DA\u10D8\u10D0 \u10D4\u10DA.\u10E4\u10DD\u10E1\u10E2\u10D8\u10E1 \u10DB\u10D4\u10E8\u10D5\u10D4\u10DD\u10D1\u10D8\u10D7 \u10DB\u10D8\u10DB\u10D0\u10E0\u10D7\u10DD\u10E1 "Archy" -\u10E1. \u10D0\u10E6\u10DC\u10D8\u10E8\u10DC\u10E3\u10DA\u10E8\u10D8 \u10D0\u10E0 \u10DB\u10DD\u10D8\u10D0\u10D6\u10E0\u10D4\u10D1\u10D0 "Archy" -\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10E1\u10EE\u10D5\u10D0 \u10DB\u10DD\u10DB\u10E1\u10D0\u10EE\u10E3\u10E0\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D8\u10EC\u10DD\u10D3\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10EC\u10E7\u10D5\u10D4\u10E2\u10D0.'
                    ].map((text)=>({
                            text: text
                        }))
                }
            },
            {
                props: {
                    margin: "C 0 0"
                },
                H5: {
                    text: "\u10DA\u10DD\u10D2 \u10E4\u10D0\u10D8\u10DA\u10D4\u10D1\u10D8 \u10D3\u10D0 cookies"
                },
                P: {
                    text: '"Archy"  \u10E1\u10D0\u10E0\u10D2\u10D4\u10D1\u10DA\u10DD\u10D1\u10E1 \u10DA\u10DD\u10D2 \u10E4\u10D0\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E1\u10E2\u10D0\u10DC\u10D3\u10D0\u10E0\u10E2\u10E3\u10DA\u10D8 \u10DE\u10E0\u10DD\u10EA\u10D4\u10D3\u10E3\u10E0\u10D8\u10D7. \u10E1\u10EE\u10D5\u10D0 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D4\u10D1\u10D8\u10E1 \u10DB\u10E1\u10D2\u10D0\u10D5\u10E1\u10D0\u10D3, "Archy"  \u10D8\u10E7\u10D4\u10DC\u10D4\u10D1\u10E1 Cookies. \u10DA\u10DD\u10D2 \u10E4\u10D0\u10D8\u10DA\u10D4\u10D1\u10D8 \u10D3\u10D0 Cookies \u10D2\u10D0\u10DB\u10DD\u10D8\u10E7\u10D4\u10DC\u10D4\u10D1\u10D0 \u10D8\u10DB\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1 \u10E0\u10DD\u10DB \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10DB\u10D0 \u10E8\u10D4\u10D8\u10DC\u10D0\u10EE\u10DD\u10E1 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E5\u10EA\u10D4\u10D5\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10EE\u10D4\u10D1 \u10D3\u10D0 \u10D2\u10D0\u10D0\u10E3\u10DB\u10EF\u10DD\u10D1\u10D4\u10E1\u10DD\u10E1 \u10DB\u10DD\u10DB\u10E1\u10D0\u10EE\u10E3\u10E0\u10D4\u10D1\u10D8\u10E1 \u10EE\u10D0\u10E0\u10D8\u10E1\u10EE\u10D8. \u10DB\u10D0\u10D7\u10D8 \u10DB\u10D4\u10E8\u10D5\u10D4\u10DD\u10D1\u10D8\u10D7 \u10D2\u10D4\u10DC\u10D4\u10E0\u10D8\u10E0\u10D3\u10D4\u10D1\u10D0 \u10D3\u10D0 \u10D2\u10E0\u10DD\u10D5\u10D3\u10D4\u10D1\u10D0 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0:'
                },
                Ul: {
                    props: {},
                    $propsCollection: [
                        "IP \u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D8",
                        "\u10DB\u10DD\u10EC\u10E7\u10DD\u10D1\u10D8\u10DA\u10DD\u10D1\u10D8\u10E1 \u10E2\u10D8\u10DE\u10D8",
                        "\u10D1\u10E0\u10D0\u10E3\u10D6\u10D4\u10E0\u10D8",
                        "\u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D8\u10E1 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D8\u10E1 \u10D3\u10E0\u10DD, \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8 \u10D3\u10D0 \u10EE\u10D0\u10DC\u10D2\u10E0\u10EB\u10DA\u10D8\u10D5\u10DD\u10D1\u10D0",
                        '\u10E0\u10DD\u10DB\u10D4\u10DA\u10D8 \u10DE\u10DA\u10D0\u10E2\u10E4\u10DD\u10E0\u10DB\u10D8\u10D3\u10D0\u10DC \u10D2\u10D0\u10D3\u10DB\u10DD\u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D3\u10D0 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8 "Archy" -\u10D8\u10E1 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4',
                        '\u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0 "Archy" -\u10D8\u10E1 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4 \u10D2\u10D0\u10DC\u10EE\u10DD\u10E0\u10EA\u10D8\u10D4\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8 \u10E5\u10DB\u10D4\u10D3\u10D4\u10D1\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10EE\u10D4\u10D1 - \u10E0\u10D0 \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D4\u10D1\u10D8 \u10DB\u10DD\u10D8\u10DC\u10D0\u10EE\u10E3\u10DA\u10D0 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10DB\u10D0'
                    ].map((text)=>({
                            text: text
                        }))
                },
                Paragraphs: {
                    childExtend: (0, $b448a4a1f1311a88$export$56c0d5a1e737357d),
                    $propsCollection: [
                        "\u10D0\u10DB \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D8\u10D7 \u10D0\u10E0 \u10EE\u10D3\u10D4\u10D1\u10D0 \u10D9\u10DD\u10DC\u10D9\u10E0\u10D4\u10E2\u10E3\u10DA\u10D8 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10D8\u10D3\u10D4\u10DC\u10E2\u10D8\u10E4\u10D8\u10EA\u10D8\u10E0\u10D4\u10D1\u10D0 \u10D3\u10D0 \u10EC\u10D0\u10E0\u10DB\u10DD\u10D0\u10D3\u10D2\u10D4\u10DC\u10E1 \u10D0\u10DC\u10D0\u10DA\u10D8\u10E2\u10D8\u10D9\u10E3\u10E0 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10E1."
                    ].map((text)=>({
                            text: text
                        }))
                }
            },
            {
                props: {
                    margin: "C 0 0"
                },
                H5: {
                    text: "\u10D0\u10DB\u10D2\u10D5\u10D0\u10E0\u10D8 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D8\u10E1 \u10D3\u10D0\u10DB\u10E3\u10E8\u10D0\u10D5\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D8\u10D6\u10D0\u10DC\u10D8\u10D0:"
                },
                P: {
                    text: '"Archy"  \u10E1\u10D0\u10E0\u10D2\u10D4\u10D1\u10DA\u10DD\u10D1\u10E1 \u10DA\u10DD\u10D2 \u10E4\u10D0\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E1\u10E2\u10D0\u10DC\u10D3\u10D0\u10E0\u10E2\u10E3\u10DA\u10D8 \u10DE\u10E0\u10DD\u10EA\u10D4\u10D3\u10E3\u10E0\u10D8\u10D7. \u10E1\u10EE\u10D5\u10D0 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D4\u10D1\u10D8\u10E1 \u10DB\u10E1\u10D2\u10D0\u10D5\u10E1\u10D0\u10D3, "Archy"  \u10D8\u10E7\u10D4\u10DC\u10D4\u10D1\u10E1 Cookies. \u10DA\u10DD\u10D2 \u10E4\u10D0\u10D8\u10DA\u10D4\u10D1\u10D8 \u10D3\u10D0 Cookies \u10D2\u10D0\u10DB\u10DD\u10D8\u10E7\u10D4\u10DC\u10D4\u10D1\u10D0 \u10D8\u10DB\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1 \u10E0\u10DD\u10DB \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10DB\u10D0 \u10E8\u10D4\u10D8\u10DC\u10D0\u10EE\u10DD\u10E1 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E5\u10EA\u10D4\u10D5\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10EE\u10D4\u10D1 \u10D3\u10D0 \u10D2\u10D0\u10D0\u10E3\u10DB\u10EF\u10DD\u10D1\u10D4\u10E1\u10DD\u10E1 \u10DB\u10DD\u10DB\u10E1\u10D0\u10EE\u10E3\u10E0\u10D4\u10D1\u10D8\u10E1 \u10EE\u10D0\u10E0\u10D8\u10E1\u10EE\u10D8. \u10DB\u10D0\u10D7\u10D8 \u10DB\u10D4\u10E8\u10D5\u10D4\u10DD\u10D1\u10D8\u10D7 \u10D2\u10D4\u10DC\u10D4\u10E0\u10D8\u10E0\u10D3\u10D4\u10D1\u10D0 \u10D3\u10D0 \u10D2\u10E0\u10DD\u10D5\u10D3\u10D4\u10D1\u10D0 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0:'
                },
                Ul: {
                    props: {},
                    $propsCollection: [
                        "\u10D2\u10D0\u10D5\u10D0\u10D0\u10DC\u10D0\u10DA\u10D8\u10D6\u10DD\u10D7 \u10E2\u10E0\u10D4\u10DC\u10D3\u10D4\u10D1\u10D8",
                        '"Archy" -\u10DB\u10D0 \u10DB\u10D0\u10E0\u10D7\u10DD\u10E1 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D8',
                        "\u10D0\u10EC\u10D0\u10E0\u10DB\u10DD\u10DD\u10E1 \u10E1\u10E2\u10D0\u10E2\u10D8\u10E1\u10E2\u10D8\u10D9\u10D0",
                        "\u10D7\u10D5\u10D0\u10DA\u10D8 \u10D0\u10D3\u10D4\u10D5\u10DC\u10DD\u10E1 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E5\u10DB\u10D4\u10D3\u10D4\u10D1\u10D4\u10D1\u10E1 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4 \u10D2\u10D0\u10DB\u10DD\u10EA\u10D3\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10E5\u10DB\u10DC\u10D8\u10E1 \u10DB\u10D8\u10D6\u10DC\u10D8\u10D7",
                        "\u10D4\u10E4\u10D4\u10E5\u10E2\u10E3\u10E0\u10D8 \u10DB\u10D0\u10E0\u10D9\u10D4\u10E2\u10D8\u10DC\u10D2\u10E3\u10DA\u10D8 \u10D0\u10E5\u10E2\u10D8\u10D5\u10DD\u10D1\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10DB\u10E3\u10E8\u10D0\u10D5\u10D4\u10D1\u10DA\u10D0\u10D3 \u10D3\u10D0 \u10D2\u10D0\u10DC\u10E1\u10D0\u10EE\u10DD\u10E0\u10EA\u10D8\u10D4\u10DA\u10D4\u10D1\u10DA\u10D0\u10D3",
                        "\u10E0\u10E9\u10D4\u10D5\u10D4\u10D1\u10D8\u10E1\u10D0 \u10D3\u10D0 \u10E0\u10D4\u10D9\u10DD\u10DB\u10D4\u10DC\u10D3\u10D0\u10EA\u10D8\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D8\u10E1\u10D0\u10EA\u10D4\u10DB\u10D0\u10D3"
                    ].map((text)=>({
                            text: text
                        }))
                },
                Paragraphs: {
                    childExtend: (0, $b448a4a1f1311a88$export$56c0d5a1e737357d),
                    $propsCollection: [
                        "\u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D8\u10E1 \u10D2\u10D0\u10DB\u10DD\u10E7\u10D4\u10DC\u10D4\u10D1\u10D8\u10E1 \u10D3\u10D0\u10EC\u10E7\u10D4\u10D1\u10D8\u10E1\u10D0\u10E1 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10E1 \u10D0\u10E5\u10D5\u10E1 \u10E1\u10D0\u10E8\u10E3\u10D0\u10DA\u10D4\u10D1\u10D0 \u10D3\u10D0\u10D4\u10D7\u10D0\u10DC\u10EE\u10DB\u10DD\u10D7 cookies. \u10D7\u10E3 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8 \u10D0\u10E0 \u10D3\u10D0\u10D0\u10ED\u10D4\u10E0\u10E1 \u10E8\u10D4\u10E1\u10D0\u10D1\u10D0\u10DB\u10D8\u10E1 \u10E6\u10D8\u10DA\u10D0\u10D9\u10E1 \u10D3\u10D0 \u10E8\u10D4\u10E2\u10E7\u10DD\u10D1\u10D8\u10DC\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D8\u10E3\u10EE\u10D4\u10D3\u10D0\u10D5\u10D0\u10D3 \u10D2\u10D0\u10D0\u10D2\u10E0\u10EB\u10D4\u10DA\u10D4\u10D1\u10E1 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D8\u10D7 \u10E1\u10D0\u10E0\u10D2\u10D4\u10D1\u10DA\u10DD\u10D1\u10D0\u10E1, \u10D0\u10DB\u10D2\u10D5\u10D0\u10E0\u10D8 \u10E5\u10DB\u10D4\u10D3\u10D4\u10D1\u10D0 \u10E9\u10D0\u10D8\u10D7\u10D5\u10DA\u10D4\u10D1\u10D0 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10D7\u10D0\u10DC\u10EE\u10DB\u10DD\u10D1\u10D0\u10D3.",
                        "Cookie-\u10E1 \u10DE\u10D0\u10E0\u10D0\u10DB\u10D4\u10E2\u10E0\u10D4\u10D1\u10D8\u10E1 \u10EA\u10D5\u10DA\u10D8\u10DA\u10D4\u10D1\u10D0 \u10E8\u10D4\u10E1\u10D0\u10EB\u10DA\u10D4\u10D1\u10D4\u10DA\u10D8\u10D0 \u10D1\u10E0\u10D0\u10E3\u10D6\u10D4\u10E0\u10D8\u10E1 \u10DE\u10D0\u10E0\u10D0\u10DB\u10D4\u10E2\u10E0\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10EA\u10D5\u10DA\u10D8\u10D7."
                    ].map((text)=>({
                            text: text
                        }))
                }
            },
            {
                props: {
                    margin: "C 0 0"
                },
                H5: {
                    text: "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D8\u10E6\u10D4\u10D1\u10D0"
                },
                P: {
                    text: '"Archy"  \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0\u10E1 \u10D8\u10E6\u10D4\u10D1\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8 \u10EC\u10E7\u10D0\u10E0\u10DD\u10D4\u10D1\u10D8\u10D3\u10D0\u10DC:'
                },
                Ul: {
                    props: {},
                    $propsCollection: [
                        "\u10E0\u10DD\u10D3\u10D4\u10E1\u10D0\u10EA \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8 \u10D0\u10D5\u10E1\u10D4\u10D1\u10E1 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4 \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D8\u10E1 \u10E8\u10D4\u10EB\u10D4\u10DC\u10D8\u10E1 \u10E4\u10DD\u10E0\u10DB\u10D0\u10E1",
                        "\u10E0\u10DD\u10D3\u10D4\u10E1\u10D0\u10EA \u10D9\u10DD\u10DB\u10E3\u10DC\u10D8\u10D9\u10D0\u10EA\u10D8\u10D0 \u10EE\u10D3\u10D4\u10D1\u10D0 \u10E2\u10D4\u10DA\u10D4\u10E4\u10DD\u10DC\u10D8\u10E1 \u10D0\u10DC \u10D4\u10DA\u10D4\u10E5\u10E2\u10E0\u10DD\u10DC\u10E3\u10DA\u10D8 \u10E4\u10DD\u10E1\u10E2\u10D8\u10E1 \u10DB\u10D4\u10E8\u10D5\u10D4\u10DD\u10D1\u10D8\u10D7",
                        '\u10E0\u10DD\u10D3\u10D4\u10E1\u10D0\u10EA \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8 \u10D8\u10E7\u10D4\u10DC\u10D4\u10D1\u10E1 "Archy" -\u10D8\u10E1 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10E1'
                    ].map((text)=>({
                            text: text
                        }))
                }
            },
            {
                props: {
                    margin: "C 0 0"
                },
                H5: {
                    text: "\u10E0\u10D0 \u10E1\u10D0\u10EE\u10D8\u10E1 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10DB\u10E3\u10E8\u10D0\u10D5\u10D3\u10D4\u10D1\u10D0"
                },
                P: {
                    text: "\u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4 \u10E0\u10D4\u10D2\u10D8\u10E1\u10E2\u10E0\u10D0\u10EA\u10D8\u10D8\u10E1\u10D0\u10E1 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8 \u10E3\u10D7\u10D8\u10D7\u10D4\u10D1\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0\u10E1:"
                },
                Ul: {
                    props: {},
                    $propsCollection: [
                        "\u10DB\u10DD\u10D1\u10D8\u10DA\u10E3\u10E0\u10D8\u10E1 \u10DC\u10DD\u10DB\u10D4\u10E0\u10D8",
                        "\u10D4\u10DA\u10D4\u10E5\u10E2\u10E0\u10DD\u10DC\u10E3\u10DA\u10D8 \u10E4\u10DD\u10E1\u10E2\u10D0",
                        "\u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D8",
                        "\u10E1\u10D0\u10EE\u10D4\u10DA\u10D8 \u10D3\u10D0 \u10D2\u10D5\u10D0\u10E0\u10D8"
                    ].map((text)=>({
                            text: text
                        }))
                },
                Paragraphs: {
                    childExtend: (0, $b448a4a1f1311a88$export$56c0d5a1e737357d),
                    $propsCollection: [
                        "\u10E0\u10D4\u10D2\u10D8\u10E1\u10E2\u10E0\u10D0\u10EA\u10D8\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1 \u10D0\u10E3\u10EA\u10D8\u10DA\u10D4\u10D1\u10D4\u10DA\u10D8\u10D0 \u10D0\u10E6\u10DC\u10D8\u10E8\u10DC\u10E3\u10DA\u10D8 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D8\u10E1 \u10DB\u10D8\u10D7\u10D8\u10D7\u10D4\u10D1\u10D0, \u10E0\u10DD\u10DB\u10DA\u10D8\u10E1 \u10D2\u10D0\u10E0\u10D4\u10E8\u10D4 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8 \u10D5\u10D4\u10E0 \u10D2\u10D0\u10DC\u10D0\u10EE\u10DD\u10E0\u10EA\u10D8\u10D4\u10DA\u10D4\u10D1\u10E1 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4 \u10E0\u10D4\u10D2\u10D8\u10E1\u10E2\u10E0\u10D0\u10EA\u10D8\u10D0\u10E1.",
                        '\u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10EA\u10D8\u10D8\u10E1 \u10E8\u10D4\u10E0\u10E9\u10D4\u10D5\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D2\u10DD\u10DB \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8 \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10E1\u10EC\u10DD\u10E0\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D8\u10D6\u10DC\u10D8\u10D7 \u10D2\u10D0\u10D3\u10D0\u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D3\u10D4\u10D1\u10D0 \u10D1\u10D0\u10DC\u10D9\u10D8\u10E1 \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10E1\u10EC\u10DD\u10E0\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4, \u10E1\u10D0\u10D3\u10D0\u10EA \u10E3\u10D7\u10D8\u10D7\u10D4\u10D1\u10E1 \u10DB\u10D8\u10E1\u10D8 \u10D1\u10D0\u10E0\u10D0\u10D7\u10D8\u10E1 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10E1 \u10D3\u10D0 \u10D0\u10D3\u10D0\u10E1\u10E2\u10E3\u10E0\u10D4\u10D1\u10E1 \u10D2\u10D0\u10D3\u10D0\u10E0\u10D8\u10EA\u10EE\u10D5\u10D0\u10E1. "Archy" -\u10E1 \u10D0\u10E0 \u10D0\u10E5\u10D5\u10E1 \u10EC\u10D5\u10D3\u10DD\u10DB\u10D0 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10E1\u10D0\u10D1\u10D0\u10DC\u10D9\u10DD \u10D1\u10D0\u10E0\u10D0\u10D7\u10D8\u10E1 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D6\u10D4. "Archy"  \u10D8\u10E6\u10D4\u10D1\u10E1 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0\u10E1 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10E1\u10EC\u10DD\u10E0\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10EE\u10D4\u10D1.'
                    ].map((text)=>({
                            text: text
                        }))
                }
            },
            {
                H5: {
                    text: "\u10D9\u10DD\u10DC\u10E4\u10D8\u10D3\u10D4\u10DC\u10EA\u10D8\u10D0\u10DA\u10E3\u10E0\u10D8 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D8\u10E1 \u10D5\u10D0\u10D3\u10D0"
                },
                props: {
                    margin: "C 0 0"
                },
                Paragraphs: {
                    childExtend: (0, $b448a4a1f1311a88$export$56c0d5a1e737357d),
                    $propsCollection: [
                        '"Archy"  \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1\u10DB\u10D2\u10D4\u10D1\u10DA\u10DD\u10D1\u10D0\u10E1 \u10D8\u10E6\u10D4\u10D1\u10E1 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DE\u10D4\u10E0\u10E1\u10DD\u10DC\u10D0\u10DA\u10E3\u10E0\u10D8 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8\u10E1 \u10E1\u10D0\u10D8\u10D3\u10E3\u10DB\u10DA\u10DD\u10D4\u10D1\u10D0\u10E1\u10D0 \u10D3\u10D0 \u10E3\u10E1\u10D0\u10E4\u10E0\u10D7\u10EE\u10DD\u10D4\u10D1\u10D0\u10D6\u10D4.',
                        '\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10EE\u10D4\u10D1 \u10D9\u10DD\u10DC\u10E4\u10D8\u10D3\u10D4\u10DC\u10EA\u10D8\u10D0\u10DA\u10E3\u10E0 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0\u10E1 "Archy"  \u10D8\u10DC\u10D0\u10EE\u10D0\u10D5\u10E1 \u10D9\u10D0\u10DC\u10DD\u10DC\u10DB\u10D3\u10D4\u10D1\u10DA\u10DD\u10D1\u10D8\u10D7 \u10D3\u10D0 \u10EC\u10D8\u10DC\u10D0\u10DB\u10D3\u10D4\u10D1\u10D0\u10E0\u10D4 \u10DE\u10DD\u10DA\u10D8\u10E2\u10D8\u10D9\u10D8\u10D7 \u10D2\u10D0\u10D7\u10D5\u10D0\u10DA\u10D8\u10E1\u10EC\u10D8\u10DC\u10D4\u10D1\u10E3\u10DA\u10D8 \u10DB\u10D8\u10D6\u10DC\u10D8\u10E1 \u10DB\u10D8\u10E6\u10EC\u10D4\u10D5\u10D8\u10E1\u10D0\u10D7\u10D5\u10D8\u10E1 \u10E1\u10D0\u10ED\u10D8\u10E0\u10DD \u10D5\u10D0\u10D3\u10D8\u10D7.'
                    ].map((text)=>({
                            text: text
                        }))
                }
            },
            {
                H5: {
                    text: "\u10E3\u10E1\u10D0\u10E4\u10E0\u10D7\u10EE\u10DD\u10D4\u10D1\u10D0"
                },
                props: {
                    margin: "C 0 0"
                },
                Paragraphs: {
                    childExtend: (0, $b448a4a1f1311a88$export$56c0d5a1e737357d),
                    $propsCollection: [
                        '"Archy" -\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1 \u10DB\u10DC\u10D8\u10E8\u10D5\u10DC\u10D4\u10DA\u10DD\u10D5\u10D0\u10DC\u10D8\u10D0 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10DB\u10D8\u10EC\u10DD\u10D3\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D9\u10DD\u10DC\u10E4\u10D8\u10D3\u10D4\u10DC\u10EA\u10D8\u10D0\u10DA\u10E3\u10E0\u10D8 \u10EE\u10D0\u10E1\u10D8\u10D0\u10D7\u10D8\u10E1 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D8\u10E1 \u10D3\u10D0\u10EA\u10D5\u10D0. \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DE\u10D8\u10E0\u10D0\u10D3\u10D8 \u10DE\u10E0\u10DD\u10E4\u10D8\u10DA\u10D8 \u10EE\u10D4\u10DA\u10DB\u10D8\u10E1\u10D0\u10EC\u10D5\u10D3\u10DD\u10DB\u10D8\u10D0 \u10DB\u10EE\u10DD\u10DA\u10DD\u10D3 \u10DB\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10E8\u10D4\u10E0\u10E9\u10D4\u10E3\u10DA\u10D8 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8\u10E1\u10D0 \u10D3\u10D0 \u10E4\u10D0\u10E1\u10D5\u10DD\u10E0\u10D3\u10D8\u10E1 \u10E1\u10D0\u10E8\u10E3\u10D0\u10DA\u10D4\u10D1\u10D8\u10D7. "Archy"  \u10D2\u10D7\u10EE\u10DD\u10D5\u10D7, \u10D0\u10E6\u10DC\u10D8\u10E8\u10DC\u10E3\u10DA\u10D8 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0 \u10D0\u10E0 \u10D2\u10D0\u10D0\u10DC\u10D3\u10DD\u10D7 \u10DB\u10D4\u10E1\u10D0\u10DB\u10D4 \u10DE\u10D8\u10E0\u10D4\u10D1\u10E1. \u10EC\u10D8\u10DC\u10D0\u10D0\u10E6\u10DB\u10D3\u10D4\u10D2 \u10E8\u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D0\u10E8\u10D8 "Archy"  \u10D8\u10EE\u10E1\u10DC\u10D8\u10E1 \u10E1\u10E0\u10E3\u10DA \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1\u10DB\u10D2\u10D4\u10D1\u10DA\u10DD\u10D1\u10D0\u10E1.',
                        '"Archy"  \u10DB\u10D8\u10DB\u10D0\u10E0\u10D7\u10D0\u10D5\u10E1 \u10E7\u10D5\u10D4\u10DA\u10D0 \u10D6\u10DD\u10DB\u10D0\u10E1 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10D9\u10DD\u10DC\u10E4\u10D8\u10D3\u10D4\u10DC\u10EA\u10D8\u10D0\u10DA\u10E3\u10E0\u10D8 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D8\u10E1 \u10D3\u10D0\u10EA\u10D5\u10D8\u10E1 \u10DB\u10D8\u10D6\u10DC\u10D8\u10D7, \u10D7\u10E3\u10DB\u10EA\u10D0 \u10D0\u10E0 \u10D8\u10E6\u10D4\u10D1\u10E1 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1\u10DB\u10D2\u10D4\u10D1\u10DA\u10DD\u10D1\u10D0\u10E1 \u10D3\u10D0 \u10D0\u10E0 \u10D8\u10EB\u10DA\u10D4\u10D5\u10D0 \u10D2\u10D0\u10E0\u10D0\u10DC\u10E2\u10D8\u10D0\u10E1 \u10DB\u10D4\u10E1\u10D0\u10DB\u10D4 \u10DE\u10D8\u10E0\u10D4\u10D1\u10D8\u10E1 \u10E5\u10DB\u10D4\u10D3\u10D4\u10D1\u10D4\u10D1\u10D6\u10D4, \u10E0\u10DD\u10DB\u10DA\u10D4\u10D1\u10D8\u10EA \u10D0\u10EE\u10DD\u10E0\u10EA\u10D8\u10D4\u10DA\u10D4\u10D1\u10D4\u10DC \u10D9\u10D0\u10DC\u10DD\u10DC\u10E1\u10D0\u10EC\u10D8\u10DC\u10D0\u10D0\u10E6\u10DB\u10D3\u10D4\u10D2\u10DD \u10E8\u10D4\u10E6\u10EC\u10D4\u10D5\u10D0\u10E1 "Archy" -\u10D8\u10E1 \u10E1\u10D4\u10E0\u10D5\u10D4\u10E0\u10D4\u10D1\u10D6\u10D4.'
                    ].map((text)=>({
                            text: text
                        }))
                }
            },
            {
                H5: {
                    text: "\u10DB\u10D4\u10E1\u10D0\u10DB\u10D4 \u10DB\u10EE\u10D0\u10E0\u10D4"
                },
                props: {
                    margin: "C 0 0"
                },
                Paragraphs: {
                    childExtend: (0, $b448a4a1f1311a88$export$56c0d5a1e737357d),
                    $propsCollection: [
                        '"Archy"  \u10D8\u10EE\u10E1\u10DC\u10D8\u10E1 \u10E7\u10DD\u10D5\u10D4\u10DA\u10D2\u10D5\u10D0\u10E0 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1\u10DB\u10D2\u10D4\u10D1\u10DA\u10DD\u10D1\u10D0\u10E1 \u10E1\u10EE\u10D5\u10D0 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D4\u10D1\u10D7\u10D0\u10DC \u10DB\u10D8\u10DB\u10D0\u10E0\u10D7\u10D4\u10D1\u10D8\u10D7, \u10E0\u10DD\u10DB\u10DA\u10D4\u10D1\u10D8\u10EA \u10E8\u10D4\u10E1\u10D0\u10EB\u10DA\u10D4\u10D1\u10D4\u10DA\u10D8\u10D0 \u10D2\u10D0\u10E0\u10D4 \u10D1\u10DB\u10E3\u10DA\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D8\u10D7 \u10D2\u10D0\u10DC\u10D7\u10D0\u10D5\u10E1\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D8\u10E7\u10DD\u10E1 "Archy" -\u10D8\u10E1 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4. \u10E1\u10EE\u10D5\u10D0 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D8\u10E1 \u10D9\u10DD\u10DC\u10E4\u10D8\u10D3\u10D4\u10DC\u10EA\u10D8\u10D0\u10DA\u10E3\u10E0\u10DD\u10D1\u10D8\u10E1 \u10DE\u10DD\u10DA\u10D8\u10E2\u10D8\u10D9\u10D0 \u10E8\u10D4\u10E1\u10D0\u10EB\u10DA\u10DD\u10D0 \u10D2\u10D0\u10DC\u10E1\u10EE\u10D5\u10D0\u10D5\u10D3\u10D4\u10D1\u10DD\u10D3\u10D4\u10E1 \u10EC\u10D8\u10DC\u10D0\u10DB\u10D3\u10D4\u10D1\u10D0\u10E0\u10D4 \u10DE\u10DD\u10DA\u10D8\u10E2\u10D8\u10D9\u10D8\u10E1\u10D2\u10D0\u10DC. \u10E8\u10D4\u10E1\u10D0\u10D1\u10D0\u10DB\u10D8\u10E1\u10D0\u10D3, "Archy"  \u10DB\u10DD\u10D2\u10D8\u10EC\u10DD\u10D3\u10D4\u10D1\u10D7 \u10D2\u10D0\u10D4\u10EA\u10DC\u10DD\u10D7 \u10D2\u10D0\u10E0\u10D4 \u10D1\u10DB\u10E3\u10DA\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D8\u10D7 \u10DB\u10D8\u10D7\u10D8\u10D7\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D8\u10E1 \u10D2\u10D0\u10DB\u10DD\u10E7\u10D4\u10DC\u10D4\u10D1\u10D8\u10E1 \u10DE\u10D8\u10E0\u10DD\u10D1\u10D4\u10D1\u10E1\u10D0 \u10D3\u10D0 \u10D9\u10DD\u10DC\u10E4\u10D8\u10D3\u10D4\u10DC\u10EA\u10D8\u10D0\u10DA\u10E3\u10E0\u10DD\u10D1\u10D8\u10E1 \u10DE\u10DD\u10DA\u10D8\u10E2\u10D8\u10D9\u10D0\u10E1.'
                    ].map((text)=>({
                            text: text
                        }))
                }
            },
            {
                H5: {
                    text: "\u10EA\u10D5\u10DA\u10D8\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D4\u10D1\u10D8"
                },
                props: {
                    margin: "C 0 0"
                },
                Paragraphs: {
                    childExtend: (0, $b448a4a1f1311a88$export$56c0d5a1e737357d),
                    $propsCollection: [
                        "\u10E8\u10D4\u10E1\u10D0\u10EB\u10DA\u10D4\u10D1\u10D4\u10DA\u10D8\u10D0 \u10EC\u10D8\u10DC\u10D0\u10DB\u10D3\u10D4\u10D1\u10D0\u10E0\u10D4 \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10E8\u10D8 \u10D2\u10D0\u10DC\u10EE\u10DD\u10E0\u10EA\u10D8\u10D4\u10DA\u10D3\u10D4\u10E1 \u10EA\u10D5\u10DA\u10D8\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D4\u10D1\u10D8. \u10EA\u10D5\u10DA\u10D8\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8\u10E1 \u10D0\u10DC \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10E2\u10D0\u10DC\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D0\u10E8\u10D8 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8 \u10DB\u10D8\u10D8\u10E6\u10D4\u10D1\u10E1 \u10DE\u10D8\u10E0\u10D0\u10D3 \u10E8\u10D4\u10E2\u10E7\u10DD\u10D1\u10D8\u10DC\u10D4\u10D1\u10D0\u10E1 \u10D0\u10DC \u10D2\u10D0\u10DB\u10DD\u10E5\u10D5\u10D4\u10E7\u10DC\u10D3\u10D4\u10D1\u10D0 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4.",
                        '\u10EA\u10D5\u10DA\u10D8\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D4\u10D1\u10D8 \u10EB\u10D0\u10DA\u10D0\u10E8\u10D8 \u10E8\u10D4\u10D3\u10D8\u10E1 "Archy" -\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1\u10D0\u10D7\u10D5\u10D8\u10E1 \u10DE\u10D8\u10E0\u10D0\u10D3\u10D8 \u10E8\u10D4\u10E2\u10E7\u10DD\u10D1\u10D8\u10DC\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D8\u10E1 \u10D0\u10DC \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4 \u10D2\u10D0\u10DB\u10DD\u10E5\u10D5\u10D4\u10E7\u10DC\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2. \u10EA\u10D5\u10DA\u10D8\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8\u10E1\u10D0 \u10D3\u10D0 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D4\u10D1\u10D8\u10E1 \u10EB\u10D0\u10DA\u10D0\u10E8\u10D8 \u10E8\u10D4\u10E1\u10D5\u10DA\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D2\u10DD\u10DB, \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D8\u10D7 \u10E1\u10D0\u10E0\u10D2\u10D4\u10D1\u10DA\u10DD\u10D1\u10D0 \u10D2\u10D0\u10DC\u10EE\u10D8\u10DA\u10E3\u10DA\u10D8 \u10D8\u10E5\u10DC\u10D4\u10D1\u10D0 \u10E0\u10DD\u10D2\u10DD\u10E0\u10EA \u10E8\u10D4\u10EA\u10D5\u10DA\u10D8\u10DA \u10DE\u10D8\u10E0\u10DD\u10D1\u10D4\u10D1\u10D6\u10D4 \u10D7\u10D0\u10DC\u10EE\u10DB\u10DD\u10D1\u10D0.'
                    ].map((text)=>({
                            text: text
                        }))
                }
            },
            {
                H5: {
                    text: '"Archy"-\u10D7\u10D0\u10DC \u10D3\u10D0\u10D9\u10D0\u10D5\u10E8\u10D8\u10E0\u10D4\u10D1\u10D0'
                },
                props: {
                    margin: "C 0 0"
                },
                Paragraphs: {
                    childExtend: (0, $b448a4a1f1311a88$export$56c0d5a1e737357d),
                    $propsCollection: [
                        "\u10D9\u10DD\u10DC\u10E4\u10D8\u10D3\u10D4\u10DC\u10EA\u10D8\u10D0\u10DA\u10E3\u10E0\u10DD\u10D1\u10D8\u10E1 \u10DE\u10DD\u10DA\u10D8\u10E2\u10D8\u10D9\u10D0\u10E1\u10D7\u10D0\u10DC \u10D3\u10D0\u10D9\u10D0\u10D5\u10E8\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8\u10E1\u10D0 \u10D3\u10D0 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7\u10D8 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D8\u10E1 \u10DB\u10D8\u10E6\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D8\u10D6\u10DC\u10D8\u10D7 \u10D3\u10D0\u10D2\u10D5\u10D8\u10D9\u10D0\u10D5\u10E8\u10D8\u10E0\u10D3\u10D8\u10D7 info@archy.ge"
                    ].map((text)=>({
                            text: text
                        }))
                }
            }
        ]
    }
};
const $0137ee424137bfa9$export$af0183d50be14be2 = {
    extend: $0137ee424137bfa9$var$Static,
    LogoHeader: {},
    content: {
        extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
        props: {
            flow: "column"
        },
        H2: {
            order: -2,
            text: "\u10D3\u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10D8\u10E1 \u10DE\u10DD\u10DA\u10D8\u10E2\u10D8\u10D9\u10D0"
        },
        P: {
            order: -1,
            text: "\u10D3\u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10D8\u10E1 \u10DE\u10DD\u10DA\u10D8\u10E2\u10D8\u10D9\u10D0 / \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D8\u10E1 \u10E3\u10D9\u10D0\u10DC \u10D3\u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10D8\u10E1 \u10DE\u10DD\u10DA\u10D8\u10E2\u10D8\u10D9\u10D0"
        },
        P_2: {
            text: "\u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D8\u10E1 \u10E3\u10D9\u10D0\u10DC \u10D3\u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10D0 \u10E8\u10D4\u10E1\u10D0\u10EB\u10DA\u10D4\u10D1\u10D4\u10DA\u10D8\u10D0 \u10DB\u10D8\u10E1\u10D8 \u10DB\u10D8\u10E6\u10D4\u10D1\u10D8\u10D3\u10D0\u10DC 1 \u10D9\u10D5\u10D8\u10E0\u10D8\u10E1 \u10DB\u10D0\u10DC\u10EB\u10D8\u10DA\u10D6\u10D4, \u10DB\u10EE\u10DD\u10DA\u10DD\u10D3 \u10D8\u10DB \u10E8\u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D0\u10E8\u10D8 \u10D7\u10E3 \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D8 \u10D0\u10E0\u10D0\u10D0 \u10D2\u10D0\u10EE\u10E1\u10DC\u10D8\u10DA\u10D8, \u10D3\u10D0\u10D6\u10D8\u10D0\u10DC\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D0\u10DC \u10D2\u10D0\u10DB\u10DD\u10E7\u10D4\u10DC\u10D4\u10D1\u10E3\u10DA\u10D8."
        },
        div: {
            P: {
                text: "\u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D8\u10E1 \u10D3\u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10D8\u10E1 \u10DE\u10D8\u10E0\u10DD\u10D1\u10D4\u10D1\u10D8:"
            },
            Ul: {
                props: {},
                $propsCollection: [
                    "\u10DE\u10D8\u10E0\u10D5\u10D4\u10DA \u10E0\u10D8\u10D2\u10E8\u10D8 \u10E1\u10D0\u10ED\u10D8\u10E0\u10DD\u10D0, \u10D3\u10D0\u10D2\u10D5\u10D8\u10D9\u10D0\u10D5\u10E8\u10D8\u10E0\u10D3\u10D4\u10D7 \u10E9\u10D5\u10D4\u10DC\u10E1 \u10DC\u10DD\u10DB\u10D4\u10E0\u10D6\u10D4 \u10D3\u10D0 \u10D2\u10D0\u10DC\u10D0\u10EA\u10EE\u10D0\u10D3\u10DD\u10D7 \u10DB\u10D8\u10D6\u10D4\u10D6\u10D8 \u10E0\u10D8\u10E1 \u10E1\u10D0\u10E4\u10E3\u10EB\u10D5\u10D4\u10DA\u10D6\u10D4\u10EA \u10EE\u10D3\u10D4\u10D1\u10D0 \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D8\u10E1 \u10E3\u10D9\u10D0\u10DC \u10D3\u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10D0.",
                    "\u10D3\u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1 \u10E1\u10D0\u10ED\u10D8\u10E0\u10DD\u10D0 \u10EC\u10D0\u10E0\u10DB\u10DD\u10D0\u10D3\u10D2\u10D8\u10DC\u10DD\u10D7 \u10E9\u10D4\u10D9\u10D8 (\u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D8\u10E1 \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D8), \u10E0\u10DD\u10DB\u10D4\u10DA\u10D8\u10EA \u10DB\u10D8\u10E1\u10D8 \u10E8\u10D4\u10EB\u10D4\u10DC\u10D8\u10E1\u10D0\u10E1 \u10D2\u10D0\u10D3\u10DB\u10DD\u10D2\u10D4\u10EA\u10D0\u10D7.",
                    "\u10D8\u10DB \u10E8\u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D0\u10E8\u10D8 \u10D7\u10E3 \u10D7\u10D5\u10DA\u10D8\u10D7, \u10E0\u10DD\u10DB \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10E1 \u10D0\u10E5\u10D5\u10E1 \u10E5\u10D0\u10E0\u10EE\u10DC\u10E3\u10DA\u10D8 \u10DC\u10D0\u10D9\u10DA\u10D8, \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D8\u10E1 \u10DB\u10D8\u10E6\u10D4\u10D1\u10D8\u10D3\u10D0\u10DC 1 \u10D9\u10D5\u10D8\u10E0\u10D8\u10E1 \u10DB\u10D0\u10DC\u10EB\u10D8\u10DA\u10D6\u10D4, \u10E3\u10DC\u10D3\u10D0 \u10DB\u10DD\u10D2\u10D5\u10DB\u10D0\u10E0\u10DD\u10D7 \u10D6\u10D0\u10E0\u10D8\u10D7. \u10E9\u10D5\u10D4\u10DC\u10D8 \u10D9\u10DD\u10DB\u10DE\u10D0\u10DC\u10D8\u10D0 \u10E8\u10D4\u10D0\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10E1 \u10DB\u10D0\u10E1 \u10D3\u10D0 3-5 \u10E1\u10D0\u10DB\u10E3\u10E8\u10D0\u10DD \u10D3\u10E6\u10D8\u10E1 \u10DB\u10D0\u10DC\u10EB\u10D8\u10DA\u10D6\u10D4 \u10E8\u10D4\u10D2\u10D0\u10E2\u10E7\u10DD\u10D1\u10D8\u10DC\u10D4\u10D1\u10D7 \u10DE\u10D0\u10E1\u10E3\u10EE\u10E1 \u10D0\u10E6\u10DC\u10D8\u10E8\u10DC\u10E3\u10DA \u10E1\u10D0\u10D9\u10D8\u10D7\u10EE\u10D6\u10D4.",
                    "\u10D8\u10DB \u10E8\u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D0\u10E8\u10D8 \u10D7\u10E3 \u10D6\u10D4\u10D3\u10D0 \u10D9\u10E0\u10D8\u10E2\u10D4\u10E0\u10D8\u10E3\u10DB\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10DC\u10EE\u10D8\u10DA\u10D5\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2 \u10D9\u10DD\u10DB\u10DE\u10D0\u10DC\u10D8\u10D0 \u10DB\u10D8\u10D8\u10E6\u10D4\u10D1\u10E1 \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D8\u10E1 \u10E3\u10D9\u10D0\u10DC \u10D3\u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10D3\u10D0\u10EC\u10E7\u10D5\u10D4\u10E2\u10D8\u10DA\u10D4\u10D1\u10D0\u10E1,\u10D7\u10E5\u10D5\u10D4\u10DC \u10D2\u10D0\u10E5\u10D5\u10D7 \u10E3\u10E4\u10DA\u10D4\u10D1\u10D0, \u10E0\u10DD\u10D2\u10DD\u10E0\u10EA \u10D2\u10D0\u10D3\u10D0\u10EA\u10D5\u10D0\u10DA\u10DD\u10D7 \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D8, \u10D0\u10E1\u10D4\u10D5\u10D4 \u10D3\u10D0\u10D8\u10D1\u10E0\u10E3\u10DC\u10DD\u10D7 \u10E3\u10D9\u10D0\u10DC \u10D7\u10D0\u10DC\u10EE\u10D0.",
                    "\u10D7\u10D0\u10DC\u10EE\u10D8\u10E1 \u10E3\u10D9\u10D0\u10DC \u10D3\u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10D0 \u10DB\u10DD\u10EE\u10D3\u10D4\u10D1\u10D0 \u10E1\u10D0\u10D1\u10D0\u10DC\u10D9\u10DD \u10D2\u10D0\u10D3\u10D0\u10E0\u10D8\u10EA\u10EE\u10D5\u10D8\u10D7 2-3 \u10E1\u10D0\u10DB\u10E3\u10E8\u10D0\u10DD \u10D3\u10E6\u10D8\u10E1 \u10E8\u10E3\u10D0\u10DA\u10D4\u10D3\u10E8\u10D8 \u10E8\u10D4\u10DB\u10D9\u10D5\u10D4\u10D7\u10D8\u10E1 \u10D9\u10E3\u10D7\u10D5\u10DC\u10D8\u10DA \u10E1\u10D0\u10D1\u10D0\u10DC\u10D9\u10DD \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D6\u10D4."
                ].map((text)=>({
                        text: text
                    }))
            }
        }
    }
};
const $0137ee424137bfa9$export$127af628b6a19b6b = {
    extend: $0137ee424137bfa9$var$Static,
    LogoHeader: {},
    content: {
        extend: (0, $8184389c03ed1792$export$f51f4c4ede09e011),
        props: {
            flow: "column",
            gap: "B1"
        },
        H2: {
            order: -2,
            text: "\u10DB\u10D8\u10E2\u10D0\u10DC\u10D8\u10E1 \u10E1\u10D4\u10E0\u10D5\u10D8\u10E1\u10D8"
        },
        ...[
            {
                H5: {
                    text: "\u10DB\u10D8\u10EC\u10DD\u10D3\u10D4\u10D1\u10D0 \u10D7\u10D1\u10D8\u10DA\u10D8\u10E1\u10D8\u10E1 \u10DB\u10D0\u10E8\u10E2\u10D0\u10D1\u10D8\u10D7:"
                },
                Ul: {
                    props: {},
                    $propsCollection: [
                        "\u10DB\u10D8\u10E2\u10D0\u10DC\u10D8\u10E1 \u10E1\u10D4\u10E0\u10D5\u10D8\u10E1\u10D8\u10E1 \u10E6\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D4\u10D1\u10D0 \u10D7\u10D1\u10D8\u10DA\u10D8\u10E1\u10D8\u10E1 \u10DB\u10D0\u10E8\u10E2\u10D0\u10D1\u10D8\u10D7 \u10E8\u10D4\u10D0\u10D3\u10D2\u10D4\u10DC\u10E1 5 \u10DA\u10D0\u10E0\u10E1.",
                        "\u10DB\u10D8\u10E2\u10D0\u10DC\u10D8\u10E1 \u10E1\u10D4\u10E0\u10D5\u10D8\u10E1\u10D8 \u10DB\u10E3\u10E8\u10D0\u10DD\u10D1\u10E1 \u10DD\u10E0\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8\u10D3\u10D0\u10DC \u10DE\u10D0\u10E0\u10D0\u10E1\u10D9\u10D4\u10D5\u10D8\u10E1 \u10E9\u10D0\u10D7\u10D5\u10DA\u10D8\u10D7 11:00 \u2013 18:00",
                        "\u10DB\u10D8\u10EC\u10DD\u10D3\u10D4\u10D1\u10D0 \u10EE\u10D3\u10D4\u10D1\u10D0 \u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D8\u10E1 \u10D2\u10D0\u10E4\u10DD\u10E0\u10DB\u10D4\u10D1\u10D8\u10D3\u10D0\u10DC 2 \u10E1\u10D0\u10DB\u10E3\u10E8\u10D0\u10DD \u10D3\u10E6\u10D8\u10E1 \u10DB\u10D0\u10DC\u10EB\u10D8\u10DA\u10D6\u10D4.",
                        "\u10E8\u10D4\u10D2\u10D8\u10EB\u10DA\u10D8\u10D0\u10D7 \u10D8\u10E1\u10D0\u10E0\u10D2\u10D4\u10D1\u10DA\u10DD\u10D7 \u10D4\u10E5\u10E1\u10DE\u10E0\u10D4\u10E1 \u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D8\u10D7, \u10E0\u10DD\u10DB\u10D4\u10DA\u10D8\u10EA \u10D2\u10E3\u10DA\u10D8\u10E1\u10EE\u10DB\u10DD\u10D1\u10E1 18:00 \u10E1\u10D0\u10D0\u10D7\u10D0\u10DB\u10D3\u10D4 \u10D3\u10D0\u10E4\u10D8\u10E5\u10E1\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8 \u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D8\u10E1 \u10D8\u10DB\u10D0\u10D5\u10D4 \u10E1\u10D0\u10DB\u10E3\u10E8\u10D0\u10DD \u10D3\u10E6\u10D4\u10E1 \u10DB\u10D8\u10E6\u10D4\u10D1\u10D0\u10E1, \u10E0\u10DD\u10DB\u10DA\u10D8\u10E1 \u10E6\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D4\u10D1\u10D0\u10D0 10 \u10DA\u10D0\u10E0\u10D8.",
                        "\u10D7\u10E3 \u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D8\u10E1 \u10EF\u10D0\u10DB\u10E3\u10E0\u10D8 \u10E6\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D4\u10D1\u10D0 \u10E8\u10D4\u10D0\u10D3\u10D2\u10D4\u10DC\u10E1 100 \u10DA\u10D0\u10E0\u10E1 \u10D0\u10DC \u10DB\u10D4\u10E2\u10E1 \u10DB\u10D8\u10E2\u10D0\u10DC\u10D8\u10E1 \u10E1\u10D4\u10E0\u10D5\u10D8\u10E1\u10D8 \u10E3\u10E4\u10D0\u10E1\u10DD\u10D0.",
                        "\u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D8\u10E1 \u10E6\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D0 \u10E8\u10D4\u10D2\u10D8\u10EB\u10DA\u10D8\u10D0\u10D7, \u10E0\u10DD\u10D2\u10DD\u10E0\u10EA \u10E9\u10D5\u10D4\u10DC\u10D8 \u10D5\u10D4\u10D1\u10D2\u10D5\u10D4\u10E0\u10D3\u10D8\u10D3\u10D0\u10DC \u10E1\u10D0\u10D1\u10D0\u10DC\u10D9\u10DD \u10D1\u10D0\u10E0\u10D0\u10D7\u10D8\u10E1 \u10D2\u10D0\u10DB\u10DD\u10E7\u10D4\u10DC\u10D4\u10D1\u10D8\u10D7, \u10D0\u10E1\u10D4\u10D5\u10D4 \u10D9\u10DD\u10DB\u10DE\u10D0\u10DC\u10D8\u10D8\u10E1 \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D6\u10D4 \u10D7\u10D0\u10DC\u10EE\u10D8\u10E1 \u10D2\u10D0\u10D3\u10DB\u10DD\u10E0\u10D8\u10EA\u10EE\u10D5\u10D8\u10D7."
                    ].map((text)=>({
                            text: text
                        }))
                }
            },
            {
                H5: {
                    text: "\u10DB\u10D8\u10EC\u10DD\u10D3\u10D4\u10D1\u10D0 \u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10DA\u10DD\u10E1 \u10DB\u10D0\u10E8\u10E2\u10D0\u10D1\u10D8\u10D7:"
                },
                P: {
                    text: "\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD\u10E1 \u10DB\u10D0\u10E8\u10E2\u10D0\u10D1\u10D8\u10D7 \u10DB\u10D8\u10EC\u10DD\u10D3\u10D4\u10D1\u10D8\u10E1 \u10E1\u10D0\u10E0\u10D2\u10D4\u10D1\u10DA\u10DD\u10D1\u10D8\u10E1\u10D0\u10E1 \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D8\u10E1 \u10E6\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D4\u10D1\u10D8 \u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D0 \u10EE\u10D3\u10D4\u10D1\u10D0 \u10DB\u10EE\u10DD\u10DA\u10DD\u10D3 \u10DD\u10DC\u10DA\u10D0\u10D8\u10DC \u10E1\u10D0\u10D1\u10D0\u10DC\u10D9\u10DD \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D8\u10E1 \u10E1\u10D0\u10E8\u10E3\u10D0\u10DA\u10D4\u10D1\u10D8\u10D7 \u10D0\u10DC \u10D9\u10DD\u10DB\u10DE\u10D0\u10DC\u10D8\u10D8\u10E1 \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D6\u10D4 \u10D7\u10D0\u10DC\u10EE\u10D8\u10E1 \u10EC\u10D8\u10DC\u10D0\u10E1\u10EC\u10D0\u10E0\u10D8 \u10D2\u10D0\u10D3\u10DB\u10DD\u10E0\u10D8\u10EA\u10EE\u10D5\u10D8\u10D7."
                }
            },
            {
                H5: {
                    text: "\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD\u10E1 \u10E4\u10DD\u10E1\u10E2\u10D0:"
                },
                P: {
                    text: "\u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D8\u10E1 \u10E8\u10D4\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10D8\u10D3\u10D0\u10DC \u10DB\u10D4\u10DD\u10E0\u10D4 \u10E1\u10D0\u10DB\u10E3\u10E8\u10DD \u10D3\u10E6\u10D4\u10E1 \u10EE\u10D3\u10D4\u10D1\u10D0 \u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D8\u10E1 \u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD\u10E1 \u10E4\u10DD\u10E1\u10E2\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1 \u10D2\u10D0\u10D3\u10D0\u10EA\u10D4\u10DB\u10D0, \u10E0\u10DD\u10DB\u10DA\u10D8\u10E1 \u10E2\u10E0\u10D0\u10DC\u10E1\u10DE\u10DD\u10E0\u10E2\u10D8\u10E0\u10D4\u10D1\u10D8\u10E1 \u10E1\u10D0\u10E8\u10E3\u10D0\u10DA\u10DD \u10D3\u10E0\u10DD \u10D2\u10D0\u10EE\u10DA\u10D0\u10D5\u10D7 2-3 \u10E1\u10D0\u10DB\u10E3\u10E8\u10D0\u10DD \u10D3\u10E6\u10D4. \u10D2\u10D6\u10D0\u10D5\u10DC\u10D8\u10DA\u10D8\u10E1 \u10D0\u10E1\u10D0\u10E6\u10D4\u10D1\u10D0\u10D3 \u10E3\u10DC\u10D3\u10D0 \u10DB\u10D8\u10D1\u10E0\u10EB\u10D0\u10DC\u10D3\u10D4\u10D7 \u10E8\u10D4\u10E1\u10D0\u10D1\u10D0\u10DB\u10D8\u10E1 \u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD\u10E1 \u10E4\u10DD\u10E1\u10E2\u10D8\u10E1 \u10E4\u10D8\u10DA\u10D8\u10D0\u10DA\u10E8\u10D8. \u10E2\u10E0\u10D0\u10DC\u10E1\u10DE\u10DD\u10E0\u10E2\u10D8\u10D4\u10D1\u10D8\u10E1 \u10E6\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D4\u10D1\u10D0\u10E1 \u10D8\u10EE\u10D3\u10D8\u10D7 \u10D0\u10DB\u10D0\u10DC\u10D0\u10D7\u10D8\u10E1 \u10D0\u10E6\u10D4\u10D1\u10D8\u10E1\u10D0\u10E1 \u10D2\u10D6\u10D0\u10D5\u10DC\u10D8\u10DA\u10D8\u10E1 \u10EC\u10DD\u10DC\u10D8\u10E1 \u10DB\u10D8\u10EE\u10D4\u10D3\u10D5\u10D8\u10D7."
                }
            }
        ]
    }
};


const $fe89aa31cd825ac2$export$7061c75fc5af8b7e = {
    extend: "Flex",
    props: {
        flow: "y",
        gap: "C1",
        padding: "A2 A2 - -"
    },
    Flex: {
        props: {
            gap: "C1",
            "@tabletS": {
                flow: "y"
            }
        },
        Pics: {
            extend: "Flex",
            props: {
                flex: 1,
                flow: "y",
                gap: "B2"
            },
            Figure: {
                props: {
                    background: "#e8e8e8",
                    aspectRatio: "5 / 3",
                    position: "relative",
                    margin: "0"
                },
                Img: {
                    maxWidth: "100%",
                    maxHeight: "100%",
                    position: "absolute",
                    left: "50%",
                    top: "50%",
                    transform: "translate3d(-50%, -50%, 1px)",
                    src: "https://p194.p3.n0.cdn.zight.com/items/5zuvnwmO/68cd430c-4e30-413a-b7cd-898ce85959c1.png?v=95fef7ff646f0127f509ab686acd36fe",
                    opacity: 0,
                    transition: "C default",
                    transitionProperty: "opacity, transform",
                    onLoad: (ev, el, s)=>{
                        el.node.style.opacity = 1;
                    }
                }
            },
            Flex: {
                props: {
                    gap: "B"
                },
                childExtend: {
                    props: {
                        background: "#e8e8e8",
                        position: "relative",
                        aspectRatio: "3 / 5",
                        flex: 1
                    },
                    Img: {
                        maxWidth: "100%",
                        maxHeight: "100%",
                        position: "absolute",
                        left: "50%",
                        top: "50%",
                        transform: "translate3d(-50%, -50%, 1px)",
                        opacity: 0,
                        transition: "C default",
                        transitionProperty: "opacity, transform",
                        onLoad: (ev, el, s)=>{
                            el.node.style.opacity = 1;
                        }
                    }
                },
                $collection: [
                    {
                        Img: {
                            src: "https://p194.p3.n0.cdn.zight.com/items/12ub0r5x/1f4a0481-0597-451d-ad23-20f874bc11f6.png?v=02e9ff2ba5f1032fb926454729c8223e"
                        }
                    },
                    {
                        Img: {
                            src: "https://p194.p3.n0.cdn.zight.com/items/Bluqd1Jp/d8ff6e50-00fe-4048-8213-690dcf6fb7b4.png?v=e36fc8173087ad9a2feab42c3e5f60e6"
                        }
                    },
                    {
                        Img: {
                            src: "https://p194.p3.n0.cdn.zight.com/items/6quXEPkx/f7f8c73d-b9ad-4933-a7b3-f0b1b68cee4a.png?v=9785e010de19ff52661dcbc524c169ef"
                        }
                    }
                ]
            }
        },
        Info: {
            extend: "Flex",
            props: {
                flow: "y",
                gap: "C3",
                padding: "Z A2",
                flex: 1
            },
            Hgroup: {
                props: {},
                H1: {
                    margin: "0",
                    text: "Pendant Lights simple"
                },
                P: {
                    margin: "0",
                    fontWeight: "400",
                    text: ({ state: state })=>(state.__root.lang === "en" ? "price: " : "\u10E4\u10D0\u10E1\u10D8: ") + "420,35" + (state.__root.lang === "en" ? " GEL" : " \u10DA\u10D0\u10E0\u10D8")
                }
            },
            Hgroup_color: {
                props: {},
                P: {
                    textTransform: "uppercase",
                    opacity: ".5",
                    margin: "0",
                    fontWeight: "400",
                    text: ({ state: state })=>state.lang === "en" ? "COLOR" : "\u10E4\u10D4\u10E0\u10D8"
                },
                H6: {
                    fontWeight: "400",
                    margin: "0",
                    text: "pendant Lights simple"
                }
            },
            Hgroup_material: {
                props: {},
                P: {
                    textTransform: "uppercase",
                    opacity: ".5",
                    margin: "0",
                    fontWeight: "400",
                    text: ({ state: state })=>state.lang === "en" ? "MATERIAL" : "\u10DB\u10D0\u10E2\u10D4\u10E0\u10D8\u10D0"
                },
                H6: {
                    fontWeight: "400",
                    margin: "0",
                    text: "venge, wood"
                }
            },
            Hgroup_size: {
                props: {},
                P: {
                    textTransform: "uppercase",
                    opacity: ".5",
                    margin: "0",
                    fontWeight: "400",
                    text: ({ state: state })=>state.lang === "en" ? "SIZE" : "\u10D6\u10DD\u10DB\u10D0"
                },
                H6: {
                    fontWeight: "400",
                    margin: "0",
                    text: "10cm x 30cm"
                }
            },
            Clicks: {
                props: {},
                Button: {
                    theme: "secondary",
                    padding: "Z2 B2",
                    fontWeight: "300",
                    gap: "X",
                    icon: "plus",
                    text: ({ state: state })=>state.__root.lang === "en" ? "Take" : "\u10D3\u10D0\u10D0\u10DB\u10D0\u10E2\u10D4",
                    onClick: (ev, el, s)=>s.toggle("openCart")
                },
                Available: {
                    extend: "Flex",
                    props: {
                        margin: "C1 0"
                    },
                    Icon: {
                        margin: "W X2 - -",
                        fontSize: "C",
                        color: "green",
                        name: "check"
                    },
                    Hgroup: {
                        props: {
                            gap: "W"
                        },
                        H6: {
                            margin: "0",
                            fontWeight: "400",
                            text: ({ state: state })=>state.__root.lang === "en" ? "In Stock at Archy showroom" : "\u10D0\u10D3\u10D2\u10D8\u10DA\u10D6\u10D4\u10D0 \u10D0\u10E0\u10E9\u10D8\u10E1 \u10E8\u10DD\u10E3\u10E0\u10E3\u10DB\u10E8\u10D8"
                        },
                        Span: {
                            opacity: ".5",
                            text: ({ state: state })=>state.__root.lang === "en" ? "Pickup is available upon notice" : "\u10D0\u10E6\u10D4\u10D1\u10D0 \u10E8\u10D4\u10E1\u10D0\u10EB\u10DA\u10D4\u10D1\u10D4\u10DA\u10D8\u10D0 \u10E8\u10D4\u10D7\u10D0\u10DC\u10EE\u10DB\u10D4\u10D1\u10D8\u10E1\u10D0\u10DB\u10D4\u10D1\u10E0"
                        }
                    }
                }
            }
        }
    },
    Polycam: {},
    ProductRowMid: {
        props: {
            margin: "C1 - -"
        },
        SectionTitle: {
            text: "Related"
        },
        Grid: {
            props: {
                columns: "repeat(9, 1fr)"
            },
            $propsCollection: [
                {
                    Img: {
                        src: "https://p194.p3.n0.cdn.zight.com/items/12ub0rxv/17c3d116-caf5-49dd-a197-19da8b719711.png?v=7b927c17cd6c05a85e665b1c2ef1f96b"
                    }
                },
                {
                    Img: {
                        src: "https://p194.p3.n0.cdn.zight.com/items/Bluqd1jR/c996b919-3ee7-4382-b48e-0d1538818c9f.png?v=dbf6588e14144623488cafc49708bedf"
                    }
                },
                {
                    Img: {
                        src: "https://p194.p3.n0.cdn.zight.com/items/7Kunq8Br/73ecee1a-1433-4892-9d29-811a6e215f5e.png?v=e79203942e6fec2fa6d07de18a48727a"
                    }
                }
            ]
        }
    },
    Footer: {}
};


var $2f93c2b81b587020$export$2e2bcd8739ae039 = {
    "/": (0, $382aee6e54bfb983$export$f22da7240b7add18),
    "/studio": (0, $4ac81149468225c7$export$b79f4e85220631d7),
    // '/about': about,
    "/contact": (0, $67c35965dde2b630$export$414d047e665c7112),
    "/terms": (0, $0137ee424137bfa9$export$8a21ba990ca4a7cb),
    "/privacy": (0, $0137ee424137bfa9$export$116a08ee153e3bde),
    "/delivery": (0, $0137ee424137bfa9$export$127af628b6a19b6b),
    "/return": (0, $0137ee424137bfa9$export$af0183d50be14be2),
    "/item": (0, $fe89aa31cd825ac2$export$7061c75fc5af8b7e)
};



var $4f3a901bb5ebcc0c$export$2e2bcd8739ae039 = {
    version: "0.0.1",
    globalTheme: "light",
    useDefaultConfig: true,
    COLOR: {
        transparent: "rgba(0, 0, 0, 0)",
        black: "black",
        blue: "#0e80fd",
        indigo: "#50E1FF",
        green: "#59AC56",
        red: "#FE5B47",
        yellow: "#EDCB38",
        orange: "#E2862F",
        brown: "#7D6755",
        pink: "#FD8ABF",
        purple: "#7345AF",
        white: "white",
        gray: "#141416"
    },
    GRADIENT: {
        "gradient-dark": `linear-gradient(0deg,
    rgba(0,0,0,0.06) 0%,
    rgba(0,0,0,0.07) 100%
  )`,
        "gradient-dark-active": `linear-gradient(0deg,
    rgba(0,0,0,0.09) 0%,
    rgba(0,0,0,0.1) 100%
  )`,
        "gradient-light": `linear-gradient(
    0deg,
    rgba(255,255,255,0.05) 0%,
    rgba(255,255,255,0.06) 100%
  )`,
        "gradient-light-active": `linear-gradient(
    0deg,
    rgba(255,255,255,0.09) 0%,
    rgba(255,255,255,0.10) 100%
  )`,
        "gradient-colorful": `linear-gradient(60deg,
    #00A2E7 0%,
    #185DF3 31%,
    #1E54F0 36%,
    #8B4CCA 69%,
    #C66894 100%
  )`
    },
    THEME: {
        document: {
            "@light": {
                color: "black",
                background: "white"
            },
            "@dark": {
                color: "white",
                background: "black"
            }
        },
        primary: {
            "@light": {
                color: "black",
                background: "white"
            },
            "@dark": {
                color: "white",
                background: "black"
            }
        },
        secondary: {
            "@light": {
                color: "white",
                background: "black"
            },
            "@dark": {
                color: "black",
                background: "white"
            }
        },
        dialog: {
            "@light": {
                color: "black",
                background: "#e8e8e8"
            }
        },
        alert: {
            "@dark": {
                color: "white",
                background: "red"
            }
        },
        warning: {
            "@dark": {
                color: "black",
                background: "yellow"
            }
        },
        none: {
            color: "none",
            background: "none"
        },
        transparent: {
            color: "transparent",
            background: "transparent"
        }
    },
    TYPOGRAPHY: {
        base: 16,
        ratio: 1.125,
        subSequence: true,
        templates: {
            h1: {
                fontSize: "var(--font-size-G)"
            },
            h2: {
                fontSize: "var(--font-size-F)"
            },
            h3: {
                fontSize: "var(--font-size-E)"
            },
            h4: {
                fontSize: "var(--font-size-D)"
            },
            h5: {
                fontSize: "var(--font-size-C)"
            },
            h6: {
                fontSize: "var(--font-size-B)"
            },
            body: {}
        },
        "@tabletS": {
            base: 16,
            ratio: 1.1
        }
    },
    SPACING: {
        base: 16,
        ratio: 1.618,
        subSequence: true,
        "@tabletS": {
            base: 16,
            ratio: 1.2
        }
    },
    FONT: {},
    FONT_FAMILY: {
        UI: {
            isDefault: true,
            value: [
                '"Avenir Next"'
            ],
            type: "sans-serif"
        },
        GE: {
            value: [
                '"AR Archy"'
            ],
            type: "sans-serif"
        },
        Code: {
            value: [
                '"Basier Square Mono"'
            ],
            type: "sans-serif"
        },
        system: {
            value: [
                '"Helvetica Neue"',
                "Helvetica",
                "Arial"
            ],
            type: "sans-serif"
        }
    },
    TIMING: {
        default: "cubic-bezier(.29, .67, .51, .97)"
    },
    ICONS: {
        ...(0, $812d27f1e77a76ab$export$2e2bcd8739ae039).ICONS,
        logo: '<svg xmlns="http://www.w3.org/2000/svg" width="132" height="132" viewBox="0 0 132 132"><path fill-rule="evenodd" d="M93.2617733,63.7086828 L93.2617733,53 L89.3378787,53 L89.3378787,64.0078621 L89.3378787,67.9919586 L89.3378787,79 L93.2617733,79 L93.2617733,67.9919586 L104.545892,67.9919586 L104.545892,79 L108.469875,79 L108.469875,67.9919586 L108.469875,64.0078621 L93.2617733,64.0078621 L93.2617733,63.7086828 Z M12.3366336,53 L1,79 L4.89936974,79 L4.93589051,79 L4.98334085,79 L9.85108858,68.0014621 L16.2360922,68.0014621 L16.2360922,64.0149448 L11.585603,64.0149448 L16.352852,53 L12.3366336,53 Z M43.2040862,67.7018857 L43.0225308,67.2898653 C45.5169498,66.0844469 47.2402831,63.5097837 47.2402831,60.5277429 C47.2402831,56.3906918 43.9237487,53.0369571 39.8324555,53.0369571 L32.9313827,53.0369571 L32.9313827,57.0146918 L39.8324555,57.0146918 C41.7512495,57.0146918 43.306539,58.5875592 43.306539,60.5277429 C43.306539,62.4680592 41.7512495,64.0407938 39.8324555,64.0407938 L37.9137928,64.0407938 L31.0688657,64.0407938 L31.0688657,64.0425184 L29,64.0425184 L29,78.9848245 L32.9313827,78.9848245 L32.9313827,68.0186612 L39.2956603,68.0186612 L44.1542348,78.9686408 L44.0610959,78.9686408 L44.0610959,78.9848245 L47.9069482,78.9848245 L47.9069482,78.9686408 L48.1681308,78.9686408 L44.3222785,70.239804 L43.2040862,67.7018857 Z M72.9386698,74.8866602 C67.9582187,74.8866602 63.9207631,70.7348882 63.9207631,65.6134212 C63.9207631,61.4757366 66.5568934,57.9721148 70.1958705,56.7785283 L68.5709661,53 C63.5298656,54.8459766 59.9206813,59.7959348 59.9206813,65.6134212 C59.9206813,73.006628 65.7490298,79 72.9386698,79 C75.1571689,79 77.2458567,78.4287142 79.0738574,77.422365 L77.4482881,73.642469 C76.1214446,74.4323123 74.5820616,74.8866602 72.9386698,74.8866602 Z M130.185783,65.9837724 L124.529417,53 L124.180382,53 L120.515865,53 L126.14655,66 L120.515865,79 L124.180382,79 L124.529417,79 L130.2,66.0163172 L130.185783,65.9837724 Z"/></svg>',
        cart: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="15" height="15" viewBox="0 0 15 15"><defs><rect id="a" width="15" height="15" x="0" y="0"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path fill="#000" fill-rule="nonzero" d="M-8,-2 L-8,-0.779499404 L-5.55899881,-0.779499404 C-5.29678158,-0.779499404 -5.07270499,-0.607866508 -4.98688915,-0.359952324 L-3.84743712,9.80929648 C-3.74255096,10.7294392 -2.951132,11.4350411 -2.026222,11.4350411 L5.42550656,11.4350411 L5.42550656,10.2145405 L-2.026222,10.2145405 C-2.3408817,10.2145405 -2.59833165,9.98569665 -2.6317038,9.67580422 L-2.70798509,8.99403991 L5.03456557,8.99403991 C5.9022646,8.99403991 6.6603102,8.37425507 6.83194309,7.52562513 L8,1.67103634 L-3.53277742,1.67103634 L-3.79499343,-0.655542923 L-3.81406375,-0.712753888 C-4.04767611,-1.47556676 -4.75804529,-1.99523272 -5.55899881,-2 L-8,-2 Z M4.20500596,11.4350411 C3.53277742,11.4350411 2.98450536,11.9833132 2.98450536,12.6555417 C2.98450536,13.3277702 3.53277742,13.8760423 4.20500596,13.8760423 C4.8772345,13.8760423 5.42550656,13.3277702 5.42550656,12.6555417 C5.42550656,11.9833132 4.8772345,11.4350411 4.20500596,11.4350411 Z M-1.89749702,11.4350411 C-2.56972556,11.4350411 -3.11799762,11.9833132 -3.11799762,12.6555417 C-3.11799762,13.3277702 -2.56972556,13.8760423 -1.89749702,13.8760423 C-1.22526848,13.8760423 -0.676996424,13.3277702 -0.676996424,12.6555417 C-0.676996424,11.9833132 -1.22526848,11.4350411 -1.89749702,11.4350411 Z M-3.39451667,2.89153693 L6.5125149,2.89153693 L5.6352801,7.28247823 C5.57330185,7.57330155 5.33015495,7.77353932 5.03456557,7.77353932 L-2.84624584,7.77353932 L-3.39451667,2.89153693 Z" mask="url(#b)"/></g></svg>'
    },
    MEDIA: {
        tv: "(min-width: 2780px)",
        screenL: "(max-width: 1920px)",
        screenM: "(max-width: 1680px)",
        screenS: "(max-width: 1440px)",
        tabletL: "(max-width: 1366px)",
        tabletM: "(max-width: 1280px)",
        tabletS: "(max-width: 1024px)",
        mobileL: "(max-width: 768px)",
        mobileM: "(max-width: 560px)",
        mobileS: "(max-width: 480px)",
        mobileXS: "(max-width: 375px)",
        light: "(prefers-color-scheme: light)",
        dark: "(prefers-color-scheme: dark)",
        print: "print"
    },
    DEVICES: {},
    CASES: {},
    SVG: {},
    RESET: {
        "body, html": {
            overflow: "hidden"
        }
    }
};


var $9223f18bf47aaa7d$export$2e2bcd8739ae039 = {
    lang: "en",
    view: "360",
    order: {
        quantity: 1
    }
};




var $834caef3af99f6ee$exports = {};
(function() {
    "use strict";
    /**
	 * @preserve FastClick: polyfill to remove click delays on browsers with touch UIs.
	 *
	 * @codingstandard ftlabs-jsv2
	 * @copyright The Financial Times Limited [All Rights Reserved]
	 * @license MIT License (see LICENSE.txt)
	 */ /*jslint browser:true, node:true*/ /*global define, Event, Node*/ /**
	 * Instantiate fast-clicking listeners on the specified layer.
	 *
	 * @constructor
	 * @param {Element} layer The layer to listen on
	 * @param {Object} [options={}] The options to override the defaults
	 */ function FastClick(layer, options) {
        var oldOnClick;
        options = options || {};
        /**
		 * Whether a click is currently being tracked.
		 *
		 * @type boolean
		 */ this.trackingClick = false;
        /**
		 * Timestamp for when click tracking started.
		 *
		 * @type number
		 */ this.trackingClickStart = 0;
        /**
		 * The element being tracked for a click.
		 *
		 * @type EventTarget
		 */ this.targetElement = null;
        /**
		 * X-coordinate of touch start event.
		 *
		 * @type number
		 */ this.touchStartX = 0;
        /**
		 * Y-coordinate of touch start event.
		 *
		 * @type number
		 */ this.touchStartY = 0;
        /**
		 * ID of the last touch, retrieved from Touch.identifier.
		 *
		 * @type number
		 */ this.lastTouchIdentifier = 0;
        /**
		 * Touchmove boundary, beyond which a click will be cancelled.
		 *
		 * @type number
		 */ this.touchBoundary = options.touchBoundary || 10;
        /**
		 * The FastClick layer.
		 *
		 * @type Element
		 */ this.layer = layer;
        /**
		 * The minimum time between tap(touchstart and touchend) events
		 *
		 * @type number
		 */ this.tapDelay = options.tapDelay || 200;
        /**
		 * The maximum time for a tap
		 *
		 * @type number
		 */ this.tapTimeout = options.tapTimeout || 700;
        if (FastClick.notNeeded(layer)) return;
        // Some old versions of Android don't have Function.prototype.bind
        function bind(method, context) {
            return function() {
                return method.apply(context, arguments);
            };
        }
        var methods = [
            "onMouse",
            "onClick",
            "onTouchStart",
            "onTouchMove",
            "onTouchEnd",
            "onTouchCancel"
        ];
        var context = this;
        for(var i = 0, l = methods.length; i < l; i++)context[methods[i]] = bind(context[methods[i]], context);
        // Set up event handlers as required
        if (deviceIsAndroid) {
            layer.addEventListener("mouseover", this.onMouse, true);
            layer.addEventListener("mousedown", this.onMouse, true);
            layer.addEventListener("mouseup", this.onMouse, true);
        }
        layer.addEventListener("click", this.onClick, true);
        layer.addEventListener("touchstart", this.onTouchStart, false);
        layer.addEventListener("touchmove", this.onTouchMove, false);
        layer.addEventListener("touchend", this.onTouchEnd, false);
        layer.addEventListener("touchcancel", this.onTouchCancel, false);
        // Hack is required for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
        // which is how FastClick normally stops click events bubbling to callbacks registered on the FastClick
        // layer when they are cancelled.
        if (!Event.prototype.stopImmediatePropagation) {
            layer.removeEventListener = function(type, callback, capture) {
                var rmv = Node.prototype.removeEventListener;
                if (type === "click") rmv.call(layer, type, callback.hijacked || callback, capture);
                else rmv.call(layer, type, callback, capture);
            };
            layer.addEventListener = function(type, callback, capture) {
                var adv = Node.prototype.addEventListener;
                if (type === "click") adv.call(layer, type, callback.hijacked || (callback.hijacked = function(event) {
                    if (!event.propagationStopped) callback(event);
                }), capture);
                else adv.call(layer, type, callback, capture);
            };
        }
        // If a handler is already declared in the element's onclick attribute, it will be fired before
        // FastClick's onClick handler. Fix this by pulling out the user-defined handler function and
        // adding it as listener.
        if (typeof layer.onclick === "function") {
            // Android browser on at least 3.2 requires a new reference to the function in layer.onclick
            // - the old one won't work if passed to addEventListener directly.
            oldOnClick = layer.onclick;
            layer.addEventListener("click", function(event) {
                oldOnClick(event);
            }, false);
            layer.onclick = null;
        }
    }
    /**
	* Windows Phone 8.1 fakes user agent string to look like Android and iPhone.
	*
	* @type boolean
	*/ var deviceIsWindowsPhone = navigator.userAgent.indexOf("Windows Phone") >= 0;
    /**
	 * Android requires exceptions.
	 *
	 * @type boolean
	 */ var deviceIsAndroid = navigator.userAgent.indexOf("Android") > 0 && !deviceIsWindowsPhone;
    /**
	 * iOS requires exceptions.
	 *
	 * @type boolean
	 */ var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;
    /**
	 * iOS 4 requires an exception for select elements.
	 *
	 * @type boolean
	 */ var deviceIsIOS4 = deviceIsIOS && /OS 4_\d(_\d)?/.test(navigator.userAgent);
    /**
	 * iOS 6.0-7.* requires the target element to be manually derived
	 *
	 * @type boolean
	 */ var deviceIsIOSWithBadTarget = deviceIsIOS && /OS [6-7]_\d/.test(navigator.userAgent);
    /**
	 * BlackBerry requires exceptions.
	 *
	 * @type boolean
	 */ var deviceIsBlackBerry10 = navigator.userAgent.indexOf("BB10") > 0;
    /**
	 * Determine whether a given element requires a native click.
	 *
	 * @param {EventTarget|Element} target Target DOM element
	 * @returns {boolean} Returns true if the element needs a native click
	 */ FastClick.prototype.needsClick = function(target) {
        switch(target.nodeName.toLowerCase()){
            // Don't send a synthetic click to disabled inputs (issue #62)
            case "button":
            case "select":
            case "textarea":
                if (target.disabled) return true;
                break;
            case "input":
                // File inputs need real clicks on iOS 6 due to a browser bug (issue #68)
                if (deviceIsIOS && target.type === "file" || target.disabled) return true;
                break;
            case "label":
            case "iframe":
            case "video":
                return true;
        }
        return /\bneedsclick\b/.test(target.className);
    };
    /**
	 * Determine whether a given element requires a call to focus to simulate click into element.
	 *
	 * @param {EventTarget|Element} target Target DOM element
	 * @returns {boolean} Returns true if the element requires a call to focus to simulate native click.
	 */ FastClick.prototype.needsFocus = function(target) {
        switch(target.nodeName.toLowerCase()){
            case "textarea":
                return true;
            case "select":
                return !deviceIsAndroid;
            case "input":
                switch(target.type){
                    case "button":
                    case "checkbox":
                    case "file":
                    case "image":
                    case "radio":
                    case "submit":
                        return false;
                }
                // No point in attempting to focus disabled inputs
                return !target.disabled && !target.readOnly;
            default:
                return /\bneedsfocus\b/.test(target.className);
        }
    };
    /**
	 * Send a click event to the specified element.
	 *
	 * @param {EventTarget|Element} targetElement
	 * @param {Event} event
	 */ FastClick.prototype.sendClick = function(targetElement, event) {
        var clickEvent, touch;
        // On some Android devices activeElement needs to be blurred otherwise the synthetic click will have no effect (#24)
        if (document.activeElement && document.activeElement !== targetElement) document.activeElement.blur();
        touch = event.changedTouches[0];
        // Synthesise a click event, with an extra attribute so it can be tracked
        clickEvent = document.createEvent("MouseEvents");
        clickEvent.initMouseEvent(this.determineEventType(targetElement), true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
        clickEvent.forwardedTouchEvent = true;
        targetElement.dispatchEvent(clickEvent);
    };
    FastClick.prototype.determineEventType = function(targetElement) {
        //Issue #159: Android Chrome Select Box does not open with a synthetic click event
        if (deviceIsAndroid && targetElement.tagName.toLowerCase() === "select") return "mousedown";
        return "click";
    };
    /**
	 * @param {EventTarget|Element} targetElement
	 */ FastClick.prototype.focus = function(targetElement) {
        var length;
        // Issue #160: on iOS 7, some input elements (e.g. date datetime month) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
        if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf("date") !== 0 && targetElement.type !== "time" && targetElement.type !== "month") {
            length = targetElement.value.length;
            targetElement.setSelectionRange(length, length);
        } else targetElement.focus();
    };
    /**
	 * Check whether the given target element is a child of a scrollable layer and if so, set a flag on it.
	 *
	 * @param {EventTarget|Element} targetElement
	 */ FastClick.prototype.updateScrollParent = function(targetElement) {
        var scrollParent, parentElement;
        scrollParent = targetElement.fastClickScrollParent;
        // Attempt to discover whether the target element is contained within a scrollable layer. Re-check if the
        // target element was moved to another parent.
        if (!scrollParent || !scrollParent.contains(targetElement)) {
            parentElement = targetElement;
            do {
                if (parentElement.scrollHeight > parentElement.offsetHeight) {
                    scrollParent = parentElement;
                    targetElement.fastClickScrollParent = parentElement;
                    break;
                }
                parentElement = parentElement.parentElement;
            }while (parentElement);
        }
        // Always update the scroll top tracker if possible.
        if (scrollParent) scrollParent.fastClickLastScrollTop = scrollParent.scrollTop;
    };
    /**
	 * @param {EventTarget} targetElement
	 * @returns {Element|EventTarget}
	 */ FastClick.prototype.getTargetElementFromEventTarget = function(eventTarget) {
        // On some older browsers (notably Safari on iOS 4.1 - see issue #56) the event target may be a text node.
        if (eventTarget.nodeType === Node.TEXT_NODE) return eventTarget.parentNode;
        return eventTarget;
    };
    /**
	 * On touch start, record the position and scroll offset.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */ FastClick.prototype.onTouchStart = function(event) {
        var targetElement, touch, selection;
        // Ignore multiple touches, otherwise pinch-to-zoom is prevented if both fingers are on the FastClick element (issue #111).
        if (event.targetTouches.length > 1) return true;
        targetElement = this.getTargetElementFromEventTarget(event.target);
        touch = event.targetTouches[0];
        if (deviceIsIOS) {
            // Only trusted events will deselect text on iOS (issue #49)
            selection = window.getSelection();
            if (selection.rangeCount && !selection.isCollapsed) return true;
            if (!deviceIsIOS4) {
                // Weird things happen on iOS when an alert or confirm dialog is opened from a click event callback (issue #23):
                // when the user next taps anywhere else on the page, new touchstart and touchend events are dispatched
                // with the same identifier as the touch event that previously triggered the click that triggered the alert.
                // Sadly, there is an issue on iOS 4 that causes some normal touch events to have the same identifier as an
                // immediately preceeding touch event (issue #52), so this fix is unavailable on that platform.
                // Issue 120: touch.identifier is 0 when Chrome dev tools 'Emulate touch events' is set with an iOS device UA string,
                // which causes all touch events to be ignored. As this block only applies to iOS, and iOS identifiers are always long,
                // random integers, it's safe to to continue if the identifier is 0 here.
                if (touch.identifier && touch.identifier === this.lastTouchIdentifier) {
                    event.preventDefault();
                    return false;
                }
                this.lastTouchIdentifier = touch.identifier;
                // If the target element is a child of a scrollable layer (using -webkit-overflow-scrolling: touch) and:
                // 1) the user does a fling scroll on the scrollable layer
                // 2) the user stops the fling scroll with another tap
                // then the event.target of the last 'touchend' event will be the element that was under the user's finger
                // when the fling scroll was started, causing FastClick to send a click event to that layer - unless a check
                // is made to ensure that a parent layer was not scrolled before sending a synthetic click (issue #42).
                this.updateScrollParent(targetElement);
            }
        }
        this.trackingClick = true;
        this.trackingClickStart = event.timeStamp;
        this.targetElement = targetElement;
        this.touchStartX = touch.pageX;
        this.touchStartY = touch.pageY;
        // Prevent phantom clicks on fast double-tap (issue #36)
        if (event.timeStamp - this.lastClickTime < this.tapDelay) event.preventDefault();
        return true;
    };
    /**
	 * Based on a touchmove event object, check whether the touch has moved past a boundary since it started.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */ FastClick.prototype.touchHasMoved = function(event) {
        var touch = event.changedTouches[0], boundary = this.touchBoundary;
        if (Math.abs(touch.pageX - this.touchStartX) > boundary || Math.abs(touch.pageY - this.touchStartY) > boundary) return true;
        return false;
    };
    /**
	 * Update the last position.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */ FastClick.prototype.onTouchMove = function(event) {
        if (!this.trackingClick) return true;
        // If the touch has moved, cancel the click tracking
        if (this.targetElement !== this.getTargetElementFromEventTarget(event.target) || this.touchHasMoved(event)) {
            this.trackingClick = false;
            this.targetElement = null;
        }
        return true;
    };
    /**
	 * Attempt to find the labelled control for the given label element.
	 *
	 * @param {EventTarget|HTMLLabelElement} labelElement
	 * @returns {Element|null}
	 */ FastClick.prototype.findControl = function(labelElement) {
        // Fast path for newer browsers supporting the HTML5 control attribute
        if (labelElement.control !== undefined) return labelElement.control;
        // All browsers under test that support touch events also support the HTML5 htmlFor attribute
        if (labelElement.htmlFor) return document.getElementById(labelElement.htmlFor);
        // If no for attribute exists, attempt to retrieve the first labellable descendant element
        // the list of which is defined here: http://www.w3.org/TR/html5/forms.html#category-label
        return labelElement.querySelector("button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea");
    };
    /**
	 * On touch end, determine whether to send a click event at once.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */ FastClick.prototype.onTouchEnd = function(event) {
        var forElement, trackingClickStart, targetTagName, scrollParent, touch, targetElement = this.targetElement;
        if (!this.trackingClick) return true;
        // Prevent phantom clicks on fast double-tap (issue #36)
        if (event.timeStamp - this.lastClickTime < this.tapDelay) {
            this.cancelNextClick = true;
            return true;
        }
        if (event.timeStamp - this.trackingClickStart > this.tapTimeout) return true;
        // Reset to prevent wrong click cancel on input (issue #156).
        this.cancelNextClick = false;
        this.lastClickTime = event.timeStamp;
        trackingClickStart = this.trackingClickStart;
        this.trackingClick = false;
        this.trackingClickStart = 0;
        // On some iOS devices, the targetElement supplied with the event is invalid if the layer
        // is performing a transition or scroll, and has to be re-detected manually. Note that
        // for this to function correctly, it must be called *after* the event target is checked!
        // See issue #57; also filed as rdar://13048589 .
        if (deviceIsIOSWithBadTarget) {
            touch = event.changedTouches[0];
            // In certain cases arguments of elementFromPoint can be negative, so prevent setting targetElement to null
            targetElement = document.elementFromPoint(touch.pageX - window.pageXOffset, touch.pageY - window.pageYOffset) || targetElement;
            targetElement.fastClickScrollParent = this.targetElement.fastClickScrollParent;
        }
        targetTagName = targetElement.tagName.toLowerCase();
        if (targetTagName === "label") {
            forElement = this.findControl(targetElement);
            if (forElement) {
                this.focus(targetElement);
                if (deviceIsAndroid) return false;
                targetElement = forElement;
            }
        } else if (this.needsFocus(targetElement)) {
            // Case 1: If the touch started a while ago (best guess is 100ms based on tests for issue #36) then focus will be triggered anyway. Return early and unset the target element reference so that the subsequent click will be allowed through.
            // Case 2: Without this exception for input elements tapped when the document is contained in an iframe, then any inputted text won't be visible even though the value attribute is updated as the user types (issue #37).
            if (event.timeStamp - trackingClickStart > 100 || deviceIsIOS && window.top !== window && targetTagName === "input") {
                this.targetElement = null;
                return false;
            }
            this.focus(targetElement);
            this.sendClick(targetElement, event);
            // Select elements need the event to go through on iOS 4, otherwise the selector menu won't open.
            // Also this breaks opening selects when VoiceOver is active on iOS6, iOS7 (and possibly others)
            if (!deviceIsIOS || targetTagName !== "select") {
                this.targetElement = null;
                event.preventDefault();
            }
            return false;
        }
        if (deviceIsIOS && !deviceIsIOS4) {
            // Don't send a synthetic click event if the target element is contained within a parent layer that was scrolled
            // and this tap is being used to stop the scrolling (usually initiated by a fling - issue #42).
            scrollParent = targetElement.fastClickScrollParent;
            if (scrollParent && scrollParent.fastClickLastScrollTop !== scrollParent.scrollTop) return true;
        }
        // Prevent the actual click from going though - unless the target node is marked as requiring
        // real clicks or if it is in the whitelist in which case only non-programmatic clicks are permitted.
        if (!this.needsClick(targetElement)) {
            event.preventDefault();
            this.sendClick(targetElement, event);
        }
        return false;
    };
    /**
	 * On touch cancel, stop tracking the click.
	 *
	 * @returns {void}
	 */ FastClick.prototype.onTouchCancel = function() {
        this.trackingClick = false;
        this.targetElement = null;
    };
    /**
	 * Determine mouse events which should be permitted.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */ FastClick.prototype.onMouse = function(event) {
        // If a target element was never set (because a touch event was never fired) allow the event
        if (!this.targetElement) return true;
        if (event.forwardedTouchEvent) return true;
        // Programmatically generated events targeting a specific element should be permitted
        if (!event.cancelable) return true;
        // Derive and check the target element to see whether the mouse event needs to be permitted;
        // unless explicitly enabled, prevent non-touch click events from triggering actions,
        // to prevent ghost/doubleclicks.
        if (!this.needsClick(this.targetElement) || this.cancelNextClick) {
            // Prevent any user-added listeners declared on FastClick element from being fired.
            if (event.stopImmediatePropagation) event.stopImmediatePropagation();
            else // Part of the hack for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
            event.propagationStopped = true;
            // Cancel the event
            event.stopPropagation();
            event.preventDefault();
            return false;
        }
        // If the mouse event is permitted, return true for the action to go through.
        return true;
    };
    /**
	 * On actual clicks, determine whether this is a touch-generated click, a click action occurring
	 * naturally after a delay after a touch (which needs to be cancelled to avoid duplication), or
	 * an actual click which should be permitted.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */ FastClick.prototype.onClick = function(event) {
        var permitted;
        // It's possible for another FastClick-like library delivered with third-party code to fire a click event before FastClick does (issue #44). In that case, set the click-tracking flag back to false and return early. This will cause onTouchEnd to return early.
        if (this.trackingClick) {
            this.targetElement = null;
            this.trackingClick = false;
            return true;
        }
        // Very odd behaviour on iOS (issue #18): if a submit element is present inside a form and the user hits enter in the iOS simulator or clicks the Go button on the pop-up OS keyboard the a kind of 'fake' click event will be triggered with the submit-type input element as the target.
        if (event.target.type === "submit" && event.detail === 0) return true;
        permitted = this.onMouse(event);
        // Only unset targetElement if the click is not permitted. This will ensure that the check for !targetElement in onMouse fails and the browser's click doesn't go through.
        if (!permitted) this.targetElement = null;
        // If clicks are permitted, return true for the action to go through.
        return permitted;
    };
    /**
	 * Remove all FastClick's event listeners.
	 *
	 * @returns {void}
	 */ FastClick.prototype.destroy = function() {
        var layer = this.layer;
        if (deviceIsAndroid) {
            layer.removeEventListener("mouseover", this.onMouse, true);
            layer.removeEventListener("mousedown", this.onMouse, true);
            layer.removeEventListener("mouseup", this.onMouse, true);
        }
        layer.removeEventListener("click", this.onClick, true);
        layer.removeEventListener("touchstart", this.onTouchStart, false);
        layer.removeEventListener("touchmove", this.onTouchMove, false);
        layer.removeEventListener("touchend", this.onTouchEnd, false);
        layer.removeEventListener("touchcancel", this.onTouchCancel, false);
    };
    /**
	 * Check whether FastClick is needed.
	 *
	 * @param {Element} layer The layer to listen on
	 */ FastClick.notNeeded = function(layer) {
        var metaViewport;
        var chromeVersion;
        var blackberryVersion;
        var firefoxVersion;
        // Devices that don't support touch don't need FastClick
        if (typeof window.ontouchstart === "undefined") return true;
        // Chrome version - zero for other browsers
        chromeVersion = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [
            ,
            0
        ])[1];
        if (chromeVersion) {
            if (deviceIsAndroid) {
                metaViewport = document.querySelector("meta[name=viewport]");
                if (metaViewport) {
                    // Chrome on Android with user-scalable="no" doesn't need FastClick (issue #89)
                    if (metaViewport.content.indexOf("user-scalable=no") !== -1) return true;
                    // Chrome 32 and above with width=device-width or less don't need FastClick
                    if (chromeVersion > 31 && document.documentElement.scrollWidth <= window.outerWidth) return true;
                }
            // Chrome desktop doesn't need FastClick (issue #15)
            } else return true;
        }
        if (deviceIsBlackBerry10) {
            blackberryVersion = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/);
            // BlackBerry 10.3+ does not require Fastclick library.
            // https://github.com/ftlabs/fastclick/issues/251
            if (blackberryVersion[1] >= 10 && blackberryVersion[2] >= 3) {
                metaViewport = document.querySelector("meta[name=viewport]");
                if (metaViewport) {
                    // user-scalable=no eliminates click delay.
                    if (metaViewport.content.indexOf("user-scalable=no") !== -1) return true;
                    // width=device-width (or less than device-width) eliminates click delay.
                    if (document.documentElement.scrollWidth <= window.outerWidth) return true;
                }
            }
        }
        // IE10 with -ms-touch-action: none or manipulation, which disables double-tap-to-zoom (issue #97)
        if (layer.style.msTouchAction === "none" || layer.style.touchAction === "manipulation") return true;
        // Firefox version - zero for other browsers
        firefoxVersion = +(/Firefox\/([0-9]+)/.exec(navigator.userAgent) || [
            ,
            0
        ])[1];
        if (firefoxVersion >= 27) {
            // Firefox 27+ does not have tap delay if the content is not zoomable - https://bugzilla.mozilla.org/show_bug.cgi?id=922896
            metaViewport = document.querySelector("meta[name=viewport]");
            if (metaViewport && (metaViewport.content.indexOf("user-scalable=no") !== -1 || document.documentElement.scrollWidth <= window.outerWidth)) return true;
        }
        // IE11: prefixed -ms-touch-action is no longer supported and it's recomended to use non-prefixed version
        // http://msdn.microsoft.com/en-us/library/windows/apps/Hh767313.aspx
        if (layer.style.touchAction === "none" || layer.style.touchAction === "manipulation") return true;
        return false;
    };
    /**
	 * Factory method for creating a FastClick object
	 *
	 * @param {Element} layer The layer to listen on
	 * @param {Object} [options={}] The options to override the defaults
	 */ FastClick.attach = function(layer, options) {
        return new FastClick(layer, options);
    };
    if (typeof define === "function" && typeof define.amd === "object" && define.amd) // AMD. Register as an anonymous module.
    define(function() {
        return FastClick;
    });
    else if (0, $834caef3af99f6ee$exports) {
        $834caef3af99f6ee$exports = FastClick.attach;
        $834caef3af99f6ee$exports.FastClick = FastClick;
    } else window.FastClick = FastClick;
})();


var $8e9859f69be36d9b$exports = {};
$8e9859f69be36d9b$exports = JSON.parse('{"key":"archy.symbo.ls","distDir":"smbls"}');


"use strict";
(0, $22cae8e82746fd5e$export$185802fd694ee1f5)({
    props: {
        theme: "document",
        position: "relative",
        flexFlow: "row",
        flexAlign: "stretch center",
        width: "100%",
        minHeight: "100%",
        "@tabletS": {
            flexFlow: "column"
        },
        Sidebar: {
            minHeight: "100dvh",
            "@tabletS": {
                position: "sticky",
                bottom: "0",
                minHeight: "auto",
                order: 2
            }
        },
        content: {
            flex: 1,
            boxSize: "100dvh auto",
            maxHeight: "100dvh",
            overflow: "hidden auto",
            position: "relative",
            "@tabletS": {
                maxHeight: "calc(100dvh - var(--spacing-D_default))"
            }
        }
    },
    Loading: {},
    Sidebar: {},
    content: {},
    on: {
        initStateUpdate: (_, el, s)=>{
            if (_.order?.quantity) return;
            if (s.openCart) s.openCart = false;
        }
    }
}, {
    key: (0, (/*@__PURE__*/$parcel$interopDefault($8e9859f69be36d9b$exports))).key
}, $04288ba364b453ff$exports);
(0, $834caef3af99f6ee$exports.FastClick).attach(document.body);


//# sourceMappingURL=index.dedf6f64.js.map
